(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 44642:
/***/ (function(module, exports, __webpack_require__) {

// Save global object in a variable
var __global__ =
(typeof globalThis !== 'undefined' && globalThis) ||
(typeof self !== 'undefined' && self) ||
(typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g);
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = (function () {
function F() {
this.fetch = false;
this.DOMException = __global__.DOMException
}
F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
return new F();
})();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis) {

var irrelevant = (function (exports) {

  /* eslint-disable no-prototype-builtins */
  var g =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    // eslint-disable-next-line no-undef
    (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g) ||
    {};

  var support = {
    searchParams: 'URLSearchParams' in g,
    iterable: 'Symbol' in g && 'iterator' in Symbol,
    blob:
      'FileReader' in g &&
      'Blob' in g &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in g,
    arrayBuffer: 'ArrayBuffer' in g
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        if (header.length != 2) {
          throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
        }
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body._noBody) return
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      // eslint-disable-next-line no-self-assign
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._noBody = true;
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this);
        if (isConsumed) {
          return isConsumed
        } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(
            this._bodyArrayBuffer.buffer.slice(
              this._bodyArrayBuffer.byteOffset,
              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
            )
          )
        } else {
          return Promise.resolve(this._bodyArrayBuffer)
        }
      } else if (support.blob) {
        return this.blob().then(readBlobAsArrayBuffer)
      } else {
        throw new Error('could not read as ArrayBuffer')
      }
    };

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || (function () {
      if ('AbortController' in g) {
        var ctrl = new AbortController();
        return ctrl.signal;
      }
    }());
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          try {
            headers.append(key, value);
          } catch (error) {
            console.warn('Response ' + error.message);
          }
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) {
      throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
    }
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 200, statusText: ''});
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = g.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        // This check if specifically for when a user fetches a file locally from the file system
        // Only if the status is out of a normal range
        if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) {
          options.status = 200;
        } else {
          options.status = xhr.status;
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request timed out'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && g.location.href ? g.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
        var names = [];
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          names.push(normalizeName(name));
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
        request.headers.forEach(function(value, name) {
          if (names.indexOf(name) === -1) {
            xhr.setRequestHeader(name, value);
          }
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!g.fetch) {
    g.fetch = fetch;
    g.Headers = Headers;
    g.Request = Request;
    g.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 77236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xC": function() { return /* binding */ configureStore; },
  "hg": function() { return /* binding */ createAsyncThunk; },
  "oM": function() { return /* binding */ createSlice; }
});

// UNUSED EXPORTS: MiddlewareArray, TaskAbortError, __DO_NOT_USE__ActionTypes, addListener, applyMiddleware, bindActionCreators, clearAllListeners, combineReducers, compose, createAction, createDraftSafeSelector, createEntityAdapter, createImmutableStateInvariantMiddleware, createListenerMiddleware, createNextState, createReducer, createSelector, createSerializableStateInvariantMiddleware, createStore, current, findNonSerializableValue, freeze, getDefaultMiddleware, getType, isAllOf, isAnyOf, isAsyncThunkAction, isDraft, isFulfilled, isImmutableDefault, isPending, isPlain, isPlainObject, isRejected, isRejectedWithValue, legacy_createStore, miniSerializeError, nanoid, original, removeListener, unwrapResult

;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s,v){if( false&&0,r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.g&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=i[s];"string"!=typeof p&&"number"!=typeof p&&(p=""+p),0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},N:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.R,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.R,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.R=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=N(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.g&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,R:void 0,t:n,k:this,C:!1,g:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.R.set(n,!0),t.o.set(n,r),t.R.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.R.set(n,!1):r.R.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.R=new Map,i(n.t,(function(r){n.R.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=N(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{F:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){F(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?g(c):O(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ var immer_esm = (fn);
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var es = (thunk);
;// CONCATENATED MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) { return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value; };
var __spreadValues = function (a, b) {
    for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
        for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
            var prop = _c[_i];
            if (__propIsEnum.call(b, prop))
                __defNormalProp(a, prop, b[prop]);
        }
    return a;
};
var __spreadProps = function (a, b) { return __defProps(a, __getOwnPropDescs(b)); };
var __async = function (__this, __arguments, generator) {
    return new Promise(function (resolve, reject) {
        var fulfilled = function (value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var rejected = function (value) {
            try {
                step(generator.throw(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var step = function (x) { return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected); };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelector = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var selector = createSelector.apply(void 0, args);
    var wrappedSelector = function (value) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return selector.apply(void 0, __spreadArray([isDraft(value) ? current(value) : value], rest));
    };
    return wrappedSelector;
};
// src/configureStore.ts

// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0)
        return void 0;
    if (typeof arguments[0] === "object")
        return redux/* compose */.qC;
    return redux/* compose.apply */.qC.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
    return function (noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function isPlainObject(value) {
    if (typeof value !== "object" || value === null)
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    var baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
// src/getDefaultMiddleware.ts

// src/utils.ts
function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function (fn) {
            var started = Date.now();
            try {
                return fn();
            }
            finally {
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function () {
            if (elapsed > maxDelay) {
                console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
            }
        }
    };
}
var MiddlewareArray = /** @class */ (function (_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function () {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array));
// src/immutableStateInvariantMiddleware.ts
var isProduction = (/* unused pure expression or super */ null && ("production" === "production"));
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler)
        decycler = function (_, value) {
            if (stack[0] === value)
                return "[Circular ~]";
            return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
        };
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value))
                value = decycler.call(this, key, value);
        }
        else
            stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value === null || typeof value === "undefined" || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (path === void 0) { path = ""; }
    var tracked = { value: obj };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for (var key in obj) {
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
                continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignorePaths, trackedProperty, obj, sameParentRef, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (sameParentRef === void 0) { sameParentRef = false; }
    if (path === void 0) { path = ""; }
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
        return { wasMutated: true, path: path };
    }
    if (isImmutable(prevObj) || isImmutable(obj)) {
        return { wasMutated: false };
    }
    var keysToDetect = {};
    for (var key in trackedProperty.children) {
        keysToDetect[key] = true;
    }
    for (var key in obj) {
        keysToDetect[key] = true;
    }
    for (var key in keysToDetect) {
        var childPath = path ? path + "." + key : key;
        if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
            continue;
        }
        var result = detectMutations(isImmutable, ignorePaths, trackedProperty.children[key], obj[key], sameRef, childPath);
        if (result.wasMutated) {
            return result;
        }
    }
    return { wasMutated: false };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isImmutable, isImmutable = _c === void 0 ? isImmutableDefault : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function (_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function (next) { return function (action) {
            var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            var dispatchedAction = next(action);
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            measureUtils.warnIfExceeded();
            return dispatchedAction;
        }; };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return type === "undefined" || val === null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths) {
    if (path === void 0) { path = ""; }
    if (isSerializable === void 0) { isSerializable = isPlain; }
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    var foundNestedSerializable;
    if (!isSerializable(value)) {
        return {
            keyPath: path || "<root>",
            value: value
        };
    }
    if (typeof value !== "object" || value === null) {
        return false;
    }
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths && ignoredPaths.indexOf(nestedPath) >= 0) {
            continue;
        }
        if (!isSerializable(nestedValue)) {
            return {
                keyPath: nestedPath,
                value: nestedValue
            };
        }
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths);
            if (foundNestedSerializable) {
                return foundNestedSerializable;
            }
        }
    }
    return false;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isSerializable, isSerializable = _c === void 0 ? isPlain : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j;
    return function (storeAPI) { return function (next) { return function (action) {
        var result = next(action);
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
            measureUtils.measureTime(function () {
                var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths);
                if (foundActionNonSerializableValue) {
                    var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                    console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
                }
            });
        }
        if (!ignoreState) {
            measureUtils.measureTime(function () {
                var state = storeAPI.getState();
                var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths);
                if (foundStateNonSerializableValue) {
                    var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                    console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                }
            });
            measureUtils.warnIfExceeded();
        }
        return result;
    }; }; };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) {
            middlewareArray.push(es);
        }
        else {
            middlewareArray.push(es.withExtraArgument(thunk.extraArgument));
        }
    }
    if (false) { var serializableOptions, immutableOptions; }
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = "production" === "production";
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") {
        rootReducer = reducer;
    }
    else if (isPlainObject(reducer)) {
        rootReducer = (0,redux/* combineReducers */.UY)(reducer);
    }
    else {
        throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    }
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
            throw new Error("when using a middleware builder function, an array of middleware must be returned");
        }
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function (item) { return typeof item !== "function"; })) {
        throw new Error("each middleware provided to configureStore must be a function");
    }
    var middlewareEnhancer = redux/* applyMiddleware.apply */.md.apply(void 0, finalMiddleware);
    var finalCompose = redux/* compose */.qC;
    if (devTools) {
        finalCompose = composeWithDevTools(__spreadValues({
            trace: !IS_PRODUCTION
        }, typeof devTools === "object" && devTools));
    }
    var storeEnhancers = [middlewareEnhancer];
    if (Array.isArray(enhancers)) {
        storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
    }
    else if (typeof enhancers === "function") {
        storeEnhancers = enhancers(storeEnhancers);
    }
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0,redux/* createStore */.MT)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) {
                throw new Error("prepareAction did not return an object");
            }
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && { meta: prepared.meta }), "error" in prepared && { error: prepared.error });
        }
        return { type: type, payload: args[0] };
    }
    actionCreator.toString = function () { return "" + type; };
    actionCreator.type = type;
    actionCreator.match = function (action) { return action.type === type; };
    return actionCreator;
}
function isFSA(action) {
    return isPlainObject(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/createReducer.ts

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function (typeOrActionCreator, reducer) {
            if (false) {}
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) {
                throw new Error("addCase cannot be called with two reducers for the same action type");
            }
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function (matcher, reducer) {
            if (false) {}
            actionMatchers.push({ matcher: matcher, reducer: reducer });
            return builder;
        },
        addDefaultCase: function (reducer) {
            if (false) {}
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) { actionMatchers = []; }
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) {
        getInitialState = function () { return immer_esm(initialState(), function () {
        }); };
    }
    else {
        var frozenInitialState_1 = immer_esm(initialState, function () {
        });
        getInitialState = function () { return frozenInitialState_1; };
    }
    function reducer(state, action) {
        if (state === void 0) { state = getInitialState(); }
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function (_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function (_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function (cr) { return !!cr; }).length === 0) {
            caseReducers = [finalDefaultCaseReducer];
        }
        return caseReducers.reduce(function (previousState, caseReducer) {
            if (caseReducer) {
                if (r(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (typeof result === "undefined") {
                        return previousState;
                    }
                    return result;
                }
                else if (!t(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (typeof result === "undefined") {
                        if (previousState === null) {
                            return previousState;
                        }
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                }
                else {
                    return immer_esm(previousState, function (draft) {
                        return caseReducer(draft, action);
                    });
                }
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) {
        throw new Error("`name` is a required option for createSlice");
    }
    var initialState = typeof options.initialState == "function" ? options.initialState : immer_esm(options.initialState, function () {
    });
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function (reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        }
        else {
            caseReducer = maybeReducerWithPrepare;
        }
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, finalCaseReducers, actionMatchers, defaultCaseReducer);
    }
    var _reducer;
    return {
        name: name,
        reducer: function (state, action) {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function () {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) { additionalState = {}; }
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return { getInitialState: getInitialState };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function (state) { return state.ids; };
        var selectEntities = function (state) { return state.entities; };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function (ids, entities) { return ids.map(function (id) { return entities[id]; }); });
        var selectId = function (_, id) { return id; };
        var selectById = function (entities, id) { return entities[id]; };
        var selectTotal = createDraftSafeSelector(selectIds, function (ids) { return ids.length; });
        if (!selectState) {
            return {
                selectIds: selectIds,
                selectEntities: selectEntities,
                selectAll: selectAll,
                selectTotal: selectTotal,
                selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
            };
        }
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return { getSelectors: getSelectors };
}
// src/entities/state_adapter.ts

function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function (_, state) { return mutator(state); });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function (draft) {
            if (isPayloadActionArgument(arg)) {
                mutator(arg.payload, draft);
            }
            else {
                mutator(arg, draft);
            }
        };
        if (isDraft3(state)) {
            runMutator(state);
            return state;
        }
        else {
            return createNextState2(state, runMutator);
        }
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    if (false) {}
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) {
        entities = Object.values(entities);
    }
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for (var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++) {
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) {
            updated.push({ id: id, changes: entity });
        }
        else {
            added.push(entity);
        }
    }
    return [added, updated];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) {
            return;
        }
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++) {
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) {
            state.ids.push(key);
        }
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++) {
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([key], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function (key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) {
            state.ids = state.ids.filter(function (id) { return id in state.entities; });
        }
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function (update) {
            if (update.id in state.entities) {
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function (update) { return takeNewKey(newKeys, update, state); }).length > 0;
            if (didMutateIds) {
                state.ids = state.ids.map(function (id) { return newKeys[id] || id; });
            }
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([entity], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function (model) { return !(selectIdValue(model, selectId) in state.entities); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function setOneMutably(entity, state) {
        return setManyMutably([entity], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            merge(newEntities, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function takeUpdatedModel(models, update, state) {
        if (!(update.id in state.entities)) {
            return false;
        }
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        delete state.entities[update.id];
        models.push(updated);
        return newKey !== update.id;
    }
    function updateManyMutably(updates, state) {
        var models = [];
        updates.forEach(function (update) { return takeUpdatedModel(models, update, state); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length && i < b.length; i++) {
            if (a[i] === b[i]) {
                continue;
            }
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function (model) {
            state.entities[selectId(model)] = model;
        });
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) {
            state.ids = newSortedIds;
        }
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) { options = {}; }
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function (instance) { return instance.id; }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
    if (size === void 0) { size = 21; }
    var id = "";
    var i = size;
    while (i--) {
        id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ (function () {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}());
var FulfillWithMeta = /** @class */ (function () {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}());
var miniSerializeError = function (value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") {
                simpleError[property] = value[property];
            }
        }
        return simpleError;
    }
    return { message: String(value) };
};
function createAsyncThunk(typePrefix, payloadCreator, options) {
    var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) { return ({
        payload: payload,
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            requestStatus: "fulfilled"
        })
    }); });
    var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) { return ({
        payload: void 0,
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            requestStatus: "pending"
        })
    }); });
    var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) { return ({
        payload: payload,
        error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            rejectedWithValue: !!payload,
            requestStatus: "rejected",
            aborted: (error == null ? void 0 : error.name) === "AbortError",
            condition: (error == null ? void 0 : error.name) === "ConditionError"
        })
    }); });
    var displayedWarning = false;
    var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ (function () {
        function class_1() {
            this.signal = {
                aborted: false,
                addEventListener: function () {
                },
                dispatchEvent: function () {
                    return false;
                },
                onabort: function () {
                },
                removeEventListener: function () {
                }
            };
        }
        class_1.prototype.abort = function () {
            if (false) {}
        };
        return class_1;
    }());
    function actionCreator(arg) {
        return function (dispatch, getState, extra) {
            var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
            var abortController = new AC();
            var abortReason;
            var abortedPromise = new Promise(function (_, reject) { return abortController.signal.addEventListener("abort", function () { return reject({ name: "AbortError", message: abortReason || "Aborted" }); }); });
            var started = false;
            function abort(reason) {
                if (started) {
                    abortReason = reason;
                    abortController.abort();
                }
            }
            var promise = function () {
                return __async(this, null, function () {
                    var _a, _b, finalAction, conditionResult, err_1, skipDispatch;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _c.trys.push([0, 4, , 5]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, { getState: getState, extra: extra });
                                if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                                return [4 /*yield*/, conditionResult];
                            case 1:
                                conditionResult = _c.sent();
                                _c.label = 2;
                            case 2:
                                if (conditionResult === false) {
                                    throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                }
                                started = true;
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, { requestId: requestId, arg: arg }, { getState: getState, extra: extra })));
                                return [4 /*yield*/, Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            rejectWithValue: function (value, meta) {
                                                return new RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function (value, meta) {
                                                return new FulfillWithMeta(value, meta);
                                            }
                                        })).then(function (result) {
                                            if (result instanceof RejectWithValue) {
                                                throw result;
                                            }
                                            if (result instanceof FulfillWithMeta) {
                                                return fulfilled(result.payload, requestId, arg, result.meta);
                                            }
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])];
                            case 3:
                                finalAction = _c.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                err_1 = _c.sent();
                                finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                return [3 /*break*/, 5];
                            case 5:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) {
                                    dispatch(finalAction);
                                }
                                return [2 /*return*/, finalAction];
                        }
                    });
                });
            }();
            return Object.assign(promise, {
                abort: abort,
                requestId: requestId,
                arg: arg,
                unwrap: function () {
                    return promise.then(unwrapResult);
                }
            });
        };
    }
    return Object.assign(actionCreator, {
        pending: pending,
        rejected: rejected,
        fulfilled: fulfilled,
        typePrefix: typePrefix
    });
}
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) {
        throw action.payload;
    }
    if (action.error) {
        throw action.error;
    }
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var hasMatchFunction = function (v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var matches = function (matcher, action) {
    if (hasMatchFunction(matcher)) {
        return matcher.match(action);
    }
    else {
        return matcher(action);
    }
};
function isAnyOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.some(function (matcher) { return matches(matcher, action); });
    };
}
function isAllOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.every(function (matcher) { return matches(matcher, action); });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta)
        return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isPending()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.pending; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejected()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.rejected; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    var hasFlag = function (action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) {
        return function (action) {
            var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
            return combinedMatcher(action);
        };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejectedWithValue()(asyncThunks[0]);
    }
    return function (action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["fulfilled"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isFulfilled()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.fulfilled; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isAsyncThunkAction()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = [];
        for (var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++) {
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function (func, expected) {
    if (typeof func !== "function") {
        throw new TypeError(expected + " is not a function");
    }
};
var noop = function () {
};
var catchRejection = function (promise, onError) {
    if (onError === void 0) { onError = noop; }
    promise.catch(onError);
    return promise;
};
var addAbortSignalListener = function (abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, { once: true });
};
var abortControllerWithReason = function (abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) {
        return;
    }
    if (!("reason" in signal)) {
        Object.defineProperty(signal, "reason", {
            enumerable: true,
            value: reason,
            configurable: true,
            writable: true
        });
    }
    ;
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */ (function () {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = task + " " + cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}());
// src/listenerMiddleware/task.ts
var validateActive = function (signal) {
    if (signal.aborted) {
        throw new TaskAbortError(signal.reason);
    }
};
var promisifyAbortSignal = function (signal) {
    return catchRejection(new Promise(function (_, reject) {
        var notifyRejection = function () { return reject(new TaskAbortError(signal.reason)); };
        if (signal.aborted) {
            notifyRejection();
        }
        else {
            addAbortSignalListener(signal, notifyRejection);
        }
    }));
};
var runTask = function (task2, cleanUp) { return __async(void 0, null, function () {
    var value, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, 4, 5]);
                return [4 /*yield*/, Promise.resolve()];
            case 1:
                _c.sent();
                return [4 /*yield*/, task2()];
            case 2:
                value = _c.sent();
                return [2 /*return*/, {
                        status: "ok",
                        value: value
                    }];
            case 3:
                error_1 = _c.sent();
                return [2 /*return*/, {
                        status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
                        error: error_1
                    }];
            case 4:
                cleanUp == null ? void 0 : cleanUp();
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
var createPause = function (signal) {
    return function (promise) {
        return catchRejection(Promise.race([promisifyAbortSignal(signal), promise]).then(function (output) {
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = function (signal) {
    var pause = createPause(signal);
    return function (timeoutMs) {
        return pause(new Promise(function (resolve) { return setTimeout(resolve, timeoutMs); }));
    };
};
// src/listenerMiddleware/index.ts
var redux_toolkit_esm_assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function (parentAbortSignal) {
    var linkControllers = function (controller) { return addAbortSignalListener(parentAbortSignal, function () { return abortControllerWithReason(controller, parentAbortSignal.reason); }); };
    return function (taskExecutor) {
        assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = runTask(function () { return __async(void 0, null, function () {
            var result2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        validateActive(parentAbortSignal);
                        validateActive(childAbortController.signal);
                        return [4 /*yield*/, taskExecutor({
                                pause: createPause(childAbortController.signal),
                                delay: createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })];
                    case 1:
                        result2 = _c.sent();
                        validateActive(childAbortController.signal);
                        return [2 /*return*/, result2];
                }
            });
        }); }, function () { return abortControllerWithReason(childAbortController, taskCompleted); });
        return {
            result: createPause(parentAbortSignal)(result),
            cancel: function () {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = function (startListening, signal) {
    var take = function (predicate, timeout) { return __async(void 0, null, function () {
        var unsubscribe, tuplePromise, promises, output;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    validateActive(signal);
                    unsubscribe = function () {
                    };
                    tuplePromise = new Promise(function (resolve) {
                        unsubscribe = startListening({
                            predicate: predicate,
                            effect: function (action, listenerApi) {
                                listenerApi.unsubscribe();
                                resolve([
                                    action,
                                    listenerApi.getState(),
                                    listenerApi.getOriginalState()
                                ]);
                            }
                        });
                    });
                    promises = [
                        promisifyAbortSignal(signal),
                        tuplePromise
                    ];
                    if (timeout != null) {
                        promises.push(new Promise(function (resolve) { return setTimeout(resolve, timeout, null); }));
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, Promise.race(promises)];
                case 2:
                    output = _c.sent();
                    validateActive(signal);
                    return [2 /*return*/, output];
                case 3:
                    unsubscribe();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return function (predicate, timeout) { return catchRejection(take(predicate, timeout)); };
};
var getListenerEntryPropsFrom = function (options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) {
        predicate = createAction(type).match;
    }
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    }
    else if (matcher) {
        predicate = matcher;
    }
    else if (predicate) {
    }
    else {
        throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    }
    assertFunction(effect, "options.listener");
    return { predicate: predicate, type: type, effect: effect };
};
var createListenerEntry = function (options) {
    var _c = getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = nanoid();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function () {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var createClearListenerMiddleware = function (listenerMap) {
    return function () {
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = function (errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    }
    catch (errorHandlerError) {
        setTimeout(function () {
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.error.apply(console, __spreadArray([alm + "/error"], args));
};
var cancelActiveListeners = function (entry) {
    entry.pending.forEach(function (controller) {
        abortControllerWithReason(controller, listenerCancelled);
    });
};
function createListenerMiddleware(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) { middlewareOptions = {}; }
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? defaultErrorHandler : _c;
    assertFunction(onError, "onError");
    var insertEntry = function (entry) {
        entry.unsubscribe = function () { return listenerMap.delete(entry.id); };
        listenerMap.set(entry.id, entry);
        return function (cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) {
                cancelActiveListeners(entry);
            }
        };
    };
    var findListenerEntry = function (comparator) {
        for (var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++) {
            var entry = _c[_i];
            if (comparator(entry)) {
                return entry;
            }
        }
        return void 0;
    };
    var startListening = function (options) {
        var entry = findListenerEntry(function (existingEntry) { return existingEntry.effect === options.effect; });
        if (!entry) {
            entry = createListenerEntry(options);
        }
        return insertEntry(entry);
    };
    var stopListening = function (options) {
        var _c = getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function (entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) {
                cancelActiveListeners(entry);
            }
        }
        return !!entry;
    };
    var notifyListener = function (entry, action, api, getOriginalState) { return __async(_this, null, function () {
        var internalTaskController, take, listenerError_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    internalTaskController = new AbortController();
                    take = createTakePattern(startListening, internalTaskController.signal);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    entry.pending.add(internalTaskController);
                    return [4 /*yield*/, Promise.resolve(entry.effect(action, redux_toolkit_esm_assign({}, api, {
                            getOriginalState: getOriginalState,
                            condition: function (predicate, timeout) { return take(predicate, timeout).then(Boolean); },
                            take: take,
                            delay: createDelay(internalTaskController.signal),
                            pause: createPause(internalTaskController.signal),
                            extra: extra,
                            signal: internalTaskController.signal,
                            fork: createFork(internalTaskController.signal),
                            unsubscribe: entry.unsubscribe,
                            subscribe: function () {
                                listenerMap.set(entry.id, entry);
                            },
                            cancelActiveListeners: function () {
                                entry.pending.forEach(function (controller, _, set) {
                                    if (controller !== internalTaskController) {
                                        abortControllerWithReason(controller, listenerCancelled);
                                        set.delete(controller);
                                    }
                                });
                            }
                        })))];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    listenerError_1 = _c.sent();
                    if (!(listenerError_1 instanceof TaskAbortError)) {
                        safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                    }
                    return [3 /*break*/, 5];
                case 4:
                    abortControllerWithReason(internalTaskController, listenerCompleted);
                    entry.pending.delete(internalTaskController);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    var middleware = function (api) { return function (next) { return function (action) {
        if (addListener.match(action)) {
            return startListening(action.payload);
        }
        if (clearAllListeners.match(action)) {
            clearListenerMiddleware();
            return;
        }
        if (removeListener.match(action)) {
            return stopListening(action.payload);
        }
        var originalState = api.getState();
        var getOriginalState = function () {
            if (originalState === INTERNAL_NIL_TOKEN) {
                throw new Error(alm + ": getOriginalState can only be called synchronously");
            }
            return originalState;
        };
        var result;
        try {
            result = next(action);
            if (listenerMap.size > 0) {
                var currentState = api.getState();
                var listenerEntries = Array.from(listenerMap.values());
                for (var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++) {
                    var entry = listenerEntries_1[_i];
                    var runListener = false;
                    try {
                        runListener = entry.predicate(action, currentState, originalState);
                    }
                    catch (predicateError) {
                        runListener = false;
                        safelyNotifyError(onError, predicateError, {
                            raisedBy: "predicate"
                        });
                    }
                    if (!runListener) {
                        continue;
                    }
                    notifyListener(entry, action, api, getOriginalState);
                }
            }
        }
        finally {
            originalState = INTERNAL_NIL_TOKEN;
        }
        return result;
    }; }; };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/index.ts
F();

//# sourceMappingURL=redux-toolkit.esm.js.map

/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var transitionalDefaults = __webpack_require__(77874);
var AxiosError = __webpack_require__(82648);
var CanceledError = __webpack_require__(60644);
var parseProtocol = __webpack_require__(90205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(60644);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);
axios.VERSION = (__webpack_require__(97288).version);
axios.toFormData = __webpack_require__(47675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(82648);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(60644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 60644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);
var utils = __webpack_require__(64867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var buildFullPath = __webpack_require__(94097);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 82648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45546);
var CanceledError = __webpack_require__(60644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var AxiosError = __webpack_require__(82648);
var transitionalDefaults = __webpack_require__(77874);
var toFormData = __webpack_require__(47675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(91623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 77874:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 97288:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 91623:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 90205:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 47675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];


var utils = __webpack_require__(64867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(97288).version);
var AxiosError = __webpack_require__(82648);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 25730:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);
var $reflectApply = __webpack_require__(59770);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),

/***/ 1768:
/***/ (function(module) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),

/***/ 68928:
/***/ (function(module) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),

/***/ 40319:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);
var $TypeError = __webpack_require__(14453);

var $call = __webpack_require__(68928);
var $actualApply = __webpack_require__(25730);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),

/***/ 59770:
/***/ (function(module) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),

/***/ 17379:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBindBasic = __webpack_require__(40319);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),

/***/ 2350:
/***/ (function() {



/***/ }),

/***/ 67389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/*!
 * content-disposition
 * Copyright(c) 2014-2017 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

module.exports = contentDisposition
module.exports.parse = parse

/**
 * Module dependencies.
 * @private
 */

var basename = (__webpack_require__(1864).basename)
var Buffer = (__webpack_require__(89509).Buffer)

/**
 * RegExp to match non attr-char, *after* encodeURIComponent (i.e. not including "%")
 * @private
 */

var ENCODE_URL_ATTR_CHAR_REGEXP = /[\x00-\x20"'()*,/:;<=>?@[\\\]{}\x7f]/g // eslint-disable-line no-control-regex

/**
 * RegExp to match percent encoding escape.
 * @private
 */

var HEX_ESCAPE_REGEXP = /%[0-9A-Fa-f]{2}/
var HEX_ESCAPE_REPLACE_REGEXP = /%([0-9A-Fa-f]{2})/g

/**
 * RegExp to match non-latin1 characters.
 * @private
 */

var NON_LATIN1_REGEXP = /[^\x20-\x7e\xa0-\xff]/g

/**
 * RegExp to match quoted-pair in RFC 2616
 *
 * quoted-pair = "\" CHAR
 * CHAR        = <any US-ASCII character (octets 0 - 127)>
 * @private
 */

var QESC_REGEXP = /\\([\u0000-\u007f])/g // eslint-disable-line no-control-regex

/**
 * RegExp to match chars that must be quoted-pair in RFC 2616
 * @private
 */

var QUOTE_REGEXP = /([\\"])/g

/**
 * RegExp for various RFC 2616 grammar
 *
 * parameter     = token "=" ( token | quoted-string )
 * token         = 1*<any CHAR except CTLs or separators>
 * separators    = "(" | ")" | "<" | ">" | "@"
 *               | "," | ";" | ":" | "\" | <">
 *               | "/" | "[" | "]" | "?" | "="
 *               | "{" | "}" | SP | HT
 * quoted-string = ( <"> *(qdtext | quoted-pair ) <"> )
 * qdtext        = <any TEXT except <">>
 * quoted-pair   = "\" CHAR
 * CHAR          = <any US-ASCII character (octets 0 - 127)>
 * TEXT          = <any OCTET except CTLs, but including LWS>
 * LWS           = [CRLF] 1*( SP | HT )
 * CRLF          = CR LF
 * CR            = <US-ASCII CR, carriage return (13)>
 * LF            = <US-ASCII LF, linefeed (10)>
 * SP            = <US-ASCII SP, space (32)>
 * HT            = <US-ASCII HT, horizontal-tab (9)>
 * CTL           = <any US-ASCII control character (octets 0 - 31) and DEL (127)>
 * OCTET         = <any 8-bit sequence of data>
 * @private
 */

var PARAM_REGEXP = /;[\x09\x20]*([!#$%&'*+.0-9A-Z^_`a-z|~-]+)[\x09\x20]*=[\x09\x20]*("(?:[\x20!\x23-\x5b\x5d-\x7e\x80-\xff]|\\[\x20-\x7e])*"|[!#$%&'*+.0-9A-Z^_`a-z|~-]+)[\x09\x20]*/g // eslint-disable-line no-control-regex
var TEXT_REGEXP = /^[\x20-\x7e\x80-\xff]+$/
var TOKEN_REGEXP = /^[!#$%&'*+.0-9A-Z^_`a-z|~-]+$/

/**
 * RegExp for various RFC 5987 grammar
 *
 * ext-value     = charset  "'" [ language ] "'" value-chars
 * charset       = "UTF-8" / "ISO-8859-1" / mime-charset
 * mime-charset  = 1*mime-charsetc
 * mime-charsetc = ALPHA / DIGIT
 *               / "!" / "#" / "$" / "%" / "&"
 *               / "+" / "-" / "^" / "_" / "`"
 *               / "{" / "}" / "~"
 * language      = ( 2*3ALPHA [ extlang ] )
 *               / 4ALPHA
 *               / 5*8ALPHA
 * extlang       = *3( "-" 3ALPHA )
 * value-chars   = *( pct-encoded / attr-char )
 * pct-encoded   = "%" HEXDIG HEXDIG
 * attr-char     = ALPHA / DIGIT
 *               / "!" / "#" / "$" / "&" / "+" / "-" / "."
 *               / "^" / "_" / "`" / "|" / "~"
 * @private
 */

var EXT_VALUE_REGEXP = /^([A-Za-z0-9!#$%&+\-^_`{}~]+)'(?:[A-Za-z]{2,3}(?:-[A-Za-z]{3}){0,3}|[A-Za-z]{4,8}|)'((?:%[0-9A-Fa-f]{2}|[A-Za-z0-9!#$&+.^_`|~-])+)$/

/**
 * RegExp for various RFC 6266 grammar
 *
 * disposition-type = "inline" | "attachment" | disp-ext-type
 * disp-ext-type    = token
 * disposition-parm = filename-parm | disp-ext-parm
 * filename-parm    = "filename" "=" value
 *                  | "filename*" "=" ext-value
 * disp-ext-parm    = token "=" value
 *                  | ext-token "=" ext-value
 * ext-token        = <the characters in token, followed by "*">
 * @private
 */

var DISPOSITION_TYPE_REGEXP = /^([!#$%&'*+.0-9A-Z^_`a-z|~-]+)[\x09\x20]*(?:$|;)/ // eslint-disable-line no-control-regex

/**
 * Create an attachment Content-Disposition header.
 *
 * @param {string} [filename]
 * @param {object} [options]
 * @param {string} [options.type=attachment]
 * @param {string|boolean} [options.fallback=true]
 * @return {string}
 * @public
 */

function contentDisposition (filename, options) {
  var opts = options || {}

  // get type
  var type = opts.type || 'attachment'

  // get parameters
  var params = createparams(filename, opts.fallback)

  // format into string
  return format(new ContentDisposition(type, params))
}

/**
 * Create parameters object from filename and fallback.
 *
 * @param {string} [filename]
 * @param {string|boolean} [fallback=true]
 * @return {object}
 * @private
 */

function createparams (filename, fallback) {
  if (filename === undefined) {
    return
  }

  var params = {}

  if (typeof filename !== 'string') {
    throw new TypeError('filename must be a string')
  }

  // fallback defaults to true
  if (fallback === undefined) {
    fallback = true
  }

  if (typeof fallback !== 'string' && typeof fallback !== 'boolean') {
    throw new TypeError('fallback must be a string or boolean')
  }

  if (typeof fallback === 'string' && NON_LATIN1_REGEXP.test(fallback)) {
    throw new TypeError('fallback must be ISO-8859-1 string')
  }

  // restrict to file base name
  var name = basename(filename)

  // determine if name is suitable for quoted string
  var isQuotedString = TEXT_REGEXP.test(name)

  // generate fallback name
  var fallbackName = typeof fallback !== 'string'
    ? fallback && getlatin1(name)
    : basename(fallback)
  var hasFallback = typeof fallbackName === 'string' && fallbackName !== name

  // set extended filename parameter
  if (hasFallback || !isQuotedString || HEX_ESCAPE_REGEXP.test(name)) {
    params['filename*'] = name
  }

  // set filename parameter
  if (isQuotedString || hasFallback) {
    params.filename = hasFallback
      ? fallbackName
      : name
  }

  return params
}

/**
 * Format object to Content-Disposition header.
 *
 * @param {object} obj
 * @param {string} obj.type
 * @param {object} [obj.parameters]
 * @return {string}
 * @private
 */

function format (obj) {
  var parameters = obj.parameters
  var type = obj.type

  if (!type || typeof type !== 'string' || !TOKEN_REGEXP.test(type)) {
    throw new TypeError('invalid type')
  }

  // start with normalized type
  var string = String(type).toLowerCase()

  // append parameters
  if (parameters && typeof parameters === 'object') {
    var param
    var params = Object.keys(parameters).sort()

    for (var i = 0; i < params.length; i++) {
      param = params[i]

      var val = param.substr(-1) === '*'
        ? ustring(parameters[param])
        : qstring(parameters[param])

      string += '; ' + param + '=' + val
    }
  }

  return string
}

/**
 * Decode a RFC 5987 field value (gracefully).
 *
 * @param {string} str
 * @return {string}
 * @private
 */

function decodefield (str) {
  var match = EXT_VALUE_REGEXP.exec(str)

  if (!match) {
    throw new TypeError('invalid extended field value')
  }

  var charset = match[1].toLowerCase()
  var encoded = match[2]
  var value

  // to binary string
  var binary = encoded.replace(HEX_ESCAPE_REPLACE_REGEXP, pdecode)

  switch (charset) {
    case 'iso-8859-1':
      value = getlatin1(binary)
      break
    case 'utf-8':
      value = Buffer.from(binary, 'binary').toString('utf8')
      break
    default:
      throw new TypeError('unsupported charset in extended field')
  }

  return value
}

/**
 * Get ISO-8859-1 version of string.
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function getlatin1 (val) {
  // simple Unicode -> ISO-8859-1 transformation
  return String(val).replace(NON_LATIN1_REGEXP, '?')
}

/**
 * Parse Content-Disposition header string.
 *
 * @param {string} string
 * @return {object}
 * @public
 */

function parse (string) {
  if (!string || typeof string !== 'string') {
    throw new TypeError('argument string is required')
  }

  var match = DISPOSITION_TYPE_REGEXP.exec(string)

  if (!match) {
    throw new TypeError('invalid type format')
  }

  // normalize type
  var index = match[0].length
  var type = match[1].toLowerCase()

  var key
  var names = []
  var params = {}
  var value

  // calculate index to start at
  index = PARAM_REGEXP.lastIndex = match[0].substr(-1) === ';'
    ? index - 1
    : index

  // match parameters
  while ((match = PARAM_REGEXP.exec(string))) {
    if (match.index !== index) {
      throw new TypeError('invalid parameter format')
    }

    index += match[0].length
    key = match[1].toLowerCase()
    value = match[2]

    if (names.indexOf(key) !== -1) {
      throw new TypeError('invalid duplicate parameter')
    }

    names.push(key)

    if (key.indexOf('*') + 1 === key.length) {
      // decode extended value
      key = key.slice(0, -1)
      value = decodefield(value)

      // overwrite existing value
      params[key] = value
      continue
    }

    if (typeof params[key] === 'string') {
      continue
    }

    if (value[0] === '"') {
      // remove quotes and escapes
      value = value
        .substr(1, value.length - 2)
        .replace(QESC_REGEXP, '$1')
    }

    params[key] = value
  }

  if (index !== -1 && index !== string.length) {
    throw new TypeError('invalid parameter format')
  }

  return new ContentDisposition(type, params)
}

/**
 * Percent decode a single character.
 *
 * @param {string} str
 * @param {string} hex
 * @return {string}
 * @private
 */

function pdecode (str, hex) {
  return String.fromCharCode(parseInt(hex, 16))
}

/**
 * Percent encode a single character.
 *
 * @param {string} char
 * @return {string}
 * @private
 */

function pencode (char) {
  return '%' + String(char)
    .charCodeAt(0)
    .toString(16)
    .toUpperCase()
}

/**
 * Quote a string for HTTP.
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function qstring (val) {
  var str = String(val)

  return '"' + str.replace(QUOTE_REGEXP, '\\$1') + '"'
}

/**
 * Encode a Unicode string for HTTP (RFC 5987).
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function ustring (val) {
  var str = String(val)

  // percent encode as UTF-8
  var encoded = encodeURIComponent(str)
    .replace(ENCODE_URL_ATTR_CHAR_REGEXP, pencode)

  return 'UTF-8\'\'' + encoded
}

/**
 * Class for parsed Content-Disposition header for v8 optimization
 *
 * @public
 * @param {string} type
 * @param {object} parameters
 * @constructor
 */

function ContentDisposition (type, parameters) {
  this.type = type
  this.parameters = parameters
}


/***/ }),

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
exports.q = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 54098:
/***/ (function(module, exports, __webpack_require__) {

// Save global object in a variable
var __global__ =
(typeof globalThis !== 'undefined' && globalThis) ||
(typeof self !== 'undefined' && self) ||
(typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g);
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = (function () {
function F() {
this.fetch = false;
this.DOMException = __global__.DOMException
}
F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
return new F();
})();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis) {

var irrelevant = (function (exports) {

  var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    (typeof global !== 'undefined' && global);

  var support = {
    searchParams: 'URLSearchParams' in global,
    iterable: 'Symbol' in global && 'iterator' in Symbol,
    blob:
      'FileReader' in global &&
      'Blob' in global &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in global,
    arrayBuffer: 'ArrayBuffer' in global
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          var isConsumed = consumed(this);
          if (isConsumed) {
            return isConsumed
          }
          if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
            return Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            )
          } else {
            return Promise.resolve(this._bodyArrayBuffer)
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          headers.append(key, value);
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = global.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && global.location.href ? global.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer &&
          request.headers.get('Content-Type') &&
          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!global.fetch) {
    global.fetch = fetch;
    global.Headers = Headers;
    global.Request = Request;
    global.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  return exports;

})({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 99960:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;


/***/ }),

/***/ 47915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DomHandler = void 0;
var domelementtype_1 = __webpack_require__(99960);
var node_js_1 = __webpack_require__(97790);
__exportStar(__webpack_require__(97790), exports);
// Default options
var defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler = /** @class */ (function () {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */
        this.dom = [];
        /** The root element for the DOM */
        this.root = new node_js_1.Document(this.dom);
        /** Indicated whether parsing has been completed. */
        this.done = false;
        /** Stack of open tags. */
        this.tagStack = [this.root];
        /** A data node that is still being written to. */
        this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_js_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_js_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            var node = new node_js_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_js_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_js_1.Text("");
        var node = new node_js_1.CDATA([text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_js_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports["default"] = DomHandler;


/***/ }),

/***/ 97790:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.CDATA = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
var domelementtype_1 = __webpack_require__(99960);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node = /** @class */ (function () {
    function Node() {
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode(this, recursive);
    };
    return Node;
}());
exports.Node = Node;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */ (function (_super) {
    __extends(DataNode, _super);
    /**
     * @param data The content of the data node
     */
    function DataNode(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node));
exports.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Text;
        return _this;
    }
    Object.defineProperty(Text.prototype, "nodeType", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    return Text;
}(DataNode));
exports.Text = Text;
/**
 * Comments within the document.
 */
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Comment;
        return _this;
    }
    Object.defineProperty(Comment.prototype, "nodeType", {
        get: function () {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    return Comment;
}(DataNode));
exports.Comment = Comment;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = domelementtype_1.ElementType.Directive;
        return _this;
    }
    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ProcessingInstruction;
}(DataNode));
exports.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */ (function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node));
exports.NodeWithChildren = NodeWithChildren;
var CDATA = /** @class */ (function (_super) {
    __extends(CDATA, _super);
    function CDATA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.CDATA;
        return _this;
    }
    Object.defineProperty(CDATA.prototype, "nodeType", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return CDATA;
}(NodeWithChildren));
exports.CDATA = CDATA;
/**
 * The root node of the document.
 */
var Document = /** @class */ (function (_super) {
    __extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Root;
        return _this;
    }
    Object.defineProperty(Document.prototype, "nodeType", {
        get: function () {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    return Document;
}(NodeWithChildren));
exports.Document = Document;
/**
 * An element within the DOM.
 */
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1.ElementType.Script
            : name === "style"
                ? domelementtype_1.ElementType.Style
                : domelementtype_1.ElementType.Tag; }
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Element.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
exports.Element = Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
    return (0, domelementtype_1.isTag)(node);
}
exports.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
    return node.type === domelementtype_1.ElementType.CDATA;
}
exports.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
    return node.type === domelementtype_1.ElementType.Text;
}
exports.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
    return node.type === domelementtype_1.ElementType.Comment;
}
exports.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === domelementtype_1.ElementType.Directive;
}
exports.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === domelementtype_1.ElementType.Root;
}
exports.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
exports.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text(node.data);
    }
    else if (isComment(node)) {
        result = new Comment(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new CDATA(children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
exports.cloneNode = cloneNode;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


/***/ }),

/***/ 27856:
/***/ (function(module) {

/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
    setPrototypeOf = Object.setPrototypeOf,
    isFrozen = Object.isFrozen,
    getPrototypeOf = Object.getPrototypeOf,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
    seal = Object.seal,
    create = Object.create; // eslint-disable-line import/no-mutable-exports
  var _ref = typeof Reflect !== 'undefined' && Reflect,
    apply = _ref.apply,
    construct = _ref.construct;
  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }
  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }
  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }
  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }
  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return construct(func, args);
    };
  }

  /* Add properties to a lookup table */
  function addToSet(set, array, transformCaseFunc) {
    var _transformCaseFunc;
    transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }
    var l = array.length;
    while (l--) {
      var element = array[l];
      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }
          element = lcElement;
        }
      }
      set[element] = true;
    }
    return set;
  }

  /* Shallow clone an object */
  function clone(object) {
    var newObject = create(null);
    var property;
    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }
    return newObject;
  }

  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */
  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }
        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }
      object = getPrototypeOf(object);
    }
    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }
    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);
  var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';
    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }
    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };
  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '2.5.8';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];
    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }
    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
      HTMLTemplateElement = window.HTMLTemplateElement,
      Node = window.Node,
      Element = window.Element,
      NodeFilter = window.NodeFilter,
      _window$NamedNodeMap = window.NamedNodeMap,
      NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
      HTMLFormElement = window.HTMLFormElement,
      DOMParser = window.DOMParser,
      trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode');

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }
    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
      implementation = _document.implementation,
      createNodeIterator = _document.createNodeIterator,
      createDocumentFragment = _document.createDocumentFragment,
      getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};
    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}
    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
      ERB_EXPR$1 = ERB_EXPR,
      TMPLIT_EXPR$1 = TMPLIT_EXPR,
      DATA_ATTR$1 = DATA_ATTR,
      ARIA_ATTR$1 = ARIA_ATTR,
      IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE$1 = ATTR_WHITESPACE,
      CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */
    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));

    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */
    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */
    var ALLOW_SELF_CLOSE_IN_ATTR = true;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */
    var SAFE_FOR_XML = true;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    var RETURN_DOM_FRAGMENT = false;

    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    var RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */
    var SANITIZE_DOM = true;

    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */
    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    var IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    var USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;

    /* Allowed XHTML+XML namespaces */
    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);

    /* Parsing of strict XHTML documents */
    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');
    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }

      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);
      PARSER_MEDIA_TYPE =
      // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;

      // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;

      /* Set configuration parameters */
      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES),
      // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS),
      // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }
      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }
      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }
        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }
        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }
      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }
        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }
      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }
      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }
        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }
      CONFIG = cfg;
    };
    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']);

    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);

    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element);

      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }
      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);
      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }
      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }

        // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }

        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }
      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }

        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }

        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }
      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      }

      // For XHTML and XML documents that support custom namespaces
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      }

      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.
      return false;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }
      node.removeAttribute(name);

      // We void attribute values for unremovable "is"" attributes
      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;
      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }
      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }
      var body = doc.body || doc.documentElement;
      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }
      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };

    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */
    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root,
      // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };

    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }
      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Check if tagname contains Unicode */
      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      var tagName = transformCaseFunc(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Detect mXSS attempts abusing namespace confusion */
      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Mitigate a problem with templates inside select */
      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any ocurrence of processing instructions */
      if (currentNode.nodeType === 7) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any kind of possibly harmful comments */
      if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }

        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
          if (childNodes && parentNode) {
            var childCount = childNodes.length;
            for (var i = childCount - 1; i >= 0; --i) {
              var childClone = cloneNode(childNodes[i], true);
              childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
              parentNode.insertBefore(childClone, getNextSibling(currentNode));
            }
          }
        }
        _forceRemove(currentNode);
        return true;
      }

      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Make sure that older browsers don't get fallback-tag mXSS */
      if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);
      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
        // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (value) {
        return false;
      } else ;
      return true;
    };

    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */
    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);
      var attributes = currentNode.attributes;

      /* Check if we have attributes; if not we might have a text node */
      if (!attributes || _isClobbered(currentNode)) {
        return;
      }
      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        attr = attributes[l];
        var _attr = attr,
          name = _attr.name,
          namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;

        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        _removeAttribute(name, currentNode);

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }

        /* Is `value` valid for this attribute? */
        var lcTag = transformCaseFunc(currentNode.nodeName);
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */
        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode);

          // Prefix the value and later re-create the attribute with the sanitized value
          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }

        /* Work around a security issue with comments inside attributes */
        if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Handle attributes that require Trusted Types */
        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                {
                  value = trustedTypesPolicy.createHTML(value);
                  break;
                }
              case 'TrustedScriptURL':
                {
                  value = trustedTypesPolicy.createScriptURL(value);
                  break;
                }
            }
          }
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }
          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
          } else {
            arrayPop(DOMPurify.removed);
          }
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;
      var shadowIterator = _createIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);
      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */
        _sanitizeElements(shadowNode);

        /* Check attributes next */
        _sanitizeAttributes(shadowNode);

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        if (typeof dirty.toString === 'function') {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        } else {
          throw typeErrorCreate('toString is not a function');
        }
      }

      /* Check we can run. Otherwise fall back or ignore */
      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }
          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }
        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }
      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);
          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }

        /* Sanitize tags and elements */
        _sanitizeElements(currentNode);

        /* Check attributes next */
        _sanitizeAttributes(currentNode);

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        oldNode = currentNode;
      }
      oldNode = null;

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);
          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }
        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }
        return returnNode;
      }
      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Serialize doctype if allowed */
      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }
      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }
      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }
      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };
    return DOMPurify;
  }
  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ 96504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(40319);
var gOPD = __webpack_require__(27296);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),

/***/ 24429:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 53981:
/***/ (function(module) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 81648:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 24726:
/***/ (function(module) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 26712:
/***/ (function(module) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 33464:
/***/ (function(module) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 14453:
/***/ (function(module) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 43915:
/***/ (function(module) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 68892:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ 17648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(68892);

var $Error = __webpack_require__(81648);
var $EvalError = __webpack_require__(53981);
var $RangeError = __webpack_require__(24726);
var $ReferenceError = __webpack_require__(26712);
var $SyntaxError = __webpack_require__(33464);
var $TypeError = __webpack_require__(14453);
var $URIError = __webpack_require__(43915);

var abs = __webpack_require__(59738);
var floor = __webpack_require__(76329);
var max = __webpack_require__(52264);
var min = __webpack_require__(55730);
var pow = __webpack_require__(20707);
var round = __webpack_require__(63862);
var sign = __webpack_require__(29550);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(27296);
var $defineProperty = __webpack_require__(24429);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(41405)();

var getProto = __webpack_require__(81618);
var $ObjectGPO = __webpack_require__(68899);
var $ReflectGPO = __webpack_require__(10443);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(48824);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 68899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(68892);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),

/***/ 10443:
/***/ (function(module) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),

/***/ 81618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(10443);
var originalGetProto = __webpack_require__(68899);

var getDunderProto = __webpack_require__(96504);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),

/***/ 40690:
/***/ (function(module) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 27296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(40690);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 41405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(55419);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 55419:
/***/ (function(module) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 48824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(58612);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 60885:
/***/ (function(__unused_webpack_module, exports) {

/**
 * SVG elements are case-sensitive.
 *
 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z}
 */
exports.CASE_SENSITIVE_TAG_NAMES = [
  'animateMotion',
  'animateTransform',
  'clipPath',
  'feBlend',
  'feColorMatrix',
  'feComponentTransfer',
  'feComposite',
  'feConvolveMatrix',
  'feDiffuseLighting',
  'feDisplacementMap',
  'feDropShadow',
  'feFlood',
  'feFuncA',
  'feFuncB',
  'feFuncG',
  'feFuncR',
  'feGaussianBlur',
  'feImage',
  'feMerge',
  'feMergeNode',
  'feMorphology',
  'feOffset',
  'fePointLight',
  'feSpecularLighting',
  'feSpotLight',
  'feTile',
  'feTurbulence',
  'foreignObject',
  'linearGradient',
  'radialGradient',
  'textPath'
];


/***/ }),

/***/ 38276:
/***/ (function(module) {

// constants
var HTML = 'html';
var HEAD = 'head';
var BODY = 'body';
var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
// match-all-characters in case of newlines (DOTALL)
var HEAD_TAG_REGEX = /<head[^]*>/i;
var BODY_TAG_REGEX = /<body[^]*>/i;

// falls back to `parseFromString` if `createHTMLDocument` cannot be used
var parseFromDocument = function () {
  throw new Error(
    'This browser does not support `document.implementation.createHTMLDocument`'
  );
};

var parseFromString = function () {
  throw new Error(
    'This browser does not support `DOMParser.prototype.parseFromString`'
  );
};

var DOMParser = typeof window === 'object' && window.DOMParser;

/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */
if (typeof DOMParser === 'function') {
  var domParser = new DOMParser();
  var mimeType = 'text/html';

  /**
   * Creates an HTML document using `DOMParser.parseFromString`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */
  parseFromString = function (html, tagName) {
    if (tagName) {
      html = '<' + tagName + '>' + html + '</' + tagName + '>';
    }

    return domParser.parseFromString(html, mimeType);
  };

  parseFromDocument = parseFromString;
}

/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */
if (typeof document === 'object' && document.implementation) {
  var doc = document.implementation.createHTMLDocument();

  /**
   * Use HTML document created by `document.implementation.createHTMLDocument`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */
  parseFromDocument = function (html, tagName) {
    if (tagName) {
      var element = doc.documentElement.querySelector(tagName);
      element.innerHTML = html;
      return doc;
    }

    doc.documentElement.innerHTML = html;
    return doc;
  };
}

/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */
var template =
  typeof document === 'object' ? document.createElement('template') : {};

var parseFromTemplate;

if (template.content) {
  /**
   * Uses a template element (content fragment) to parse HTML.
   *
   * @param  {string} html - The HTML string.
   * @return {NodeList}
   */
  parseFromTemplate = function (html) {
    template.innerHTML = html;
    return template.content.childNodes;
  };
}

/**
 * Parses HTML string to DOM nodes.
 *
 * @param  {string}   html - HTML markup.
 * @return {NodeList}
 */
function domparser(html) {
  var firstTagName;
  var match = html.match(FIRST_TAG_REGEX);

  if (match && match[1]) {
    firstTagName = match[1].toLowerCase();
  }

  var doc;
  var element;
  var elements;

  switch (firstTagName) {
    case HTML:
      doc = parseFromString(html);

      // the created document may come with filler head/body elements,
      // so make sure to remove them if they don't actually exist
      if (!HEAD_TAG_REGEX.test(html)) {
        element = doc.querySelector(HEAD);
        if (element) {
          element.parentNode.removeChild(element);
        }
      }

      if (!BODY_TAG_REGEX.test(html)) {
        element = doc.querySelector(BODY);
        if (element) {
          element.parentNode.removeChild(element);
        }
      }

      return doc.querySelectorAll(HTML);

    case HEAD:
    case BODY:
      doc = parseFromDocument(html);
      elements = doc.querySelectorAll(firstTagName);

      // if there's a sibling element, then return both elements
      if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
        return elements[0].parentNode.childNodes;
      }
      return elements;

    // low-level tag or text
    default:
      if (parseFromTemplate) {
        return parseFromTemplate(html);
      }
      element = parseFromDocument(html, BODY).querySelector(BODY);
      return element.childNodes;
  }
}

module.exports = domparser;


/***/ }),

/***/ 14152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var domparser = __webpack_require__(38276);
var utilities = __webpack_require__(1507);

var formatDOM = utilities.formatDOM;

var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>

/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param  {string} html  - HTML markup.
 * @return {DomElement[]} - DOM elements.
 */
function HTMLDOMParser(html) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (html === '') {
    return [];
  }

  // match directive
  var match = html.match(DIRECTIVE_REGEX);
  var directive;

  if (match && match[1]) {
    directive = match[1];
  }

  return formatDOM(domparser(html), null, directive);
}

module.exports = HTMLDOMParser;


/***/ }),

/***/ 1507:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var domhandler = __webpack_require__(47915);
var constants = __webpack_require__(60885);

var CASE_SENSITIVE_TAG_NAMES = constants.CASE_SENSITIVE_TAG_NAMES;

var Comment = domhandler.Comment;
var Element = domhandler.Element;
var ProcessingInstruction = domhandler.ProcessingInstruction;
var Text = domhandler.Text;

var caseSensitiveTagNamesMap = {};
var tagName;

for (var i = 0, len = CASE_SENSITIVE_TAG_NAMES.length; i < len; i++) {
  tagName = CASE_SENSITIVE_TAG_NAMES[i];
  caseSensitiveTagNamesMap[tagName.toLowerCase()] = tagName;
}

/**
 * Gets case-sensitive tag name.
 *
 * @param {string} tagName - Tag name in lowercase.
 * @returns {string|undefined} - Case-sensitive tag name.
 */
function getCaseSensitiveTagName(tagName) {
  return caseSensitiveTagNamesMap[tagName];
}

/**
 * Formats DOM attributes to a hash map.
 *
 * @param {NamedNodeMap} attributes - List of attributes.
 * @returns {object} - Map of attribute name to value.
 */
function formatAttributes(attributes) {
  var result = {};
  var attribute;
  // `NamedNodeMap` is array-like
  for (var i = 0, len = attributes.length; i < len; i++) {
    attribute = attributes[i];
    result[attribute.name] = attribute.value;
  }
  return result;
}

/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param {string} tagName - Lowercase tag name.
 * @returns {string} - Formatted tag name.
 */
function formatTagName(tagName) {
  tagName = tagName.toLowerCase();
  var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
  if (caseSensitiveTagName) {
    return caseSensitiveTagName;
  }
  return tagName;
}

/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param {NodeList} nodes - DOM nodes.
 * @param {Element|null} [parent=null] - Parent node.
 * @param {string} [directive] - Directive.
 * @returns {Array<Comment|Element|ProcessingInstruction|Text>}
 */
function formatDOM(nodes, parent, directive) {
  parent = parent || null;
  var result = [];
  var tagName;

  for (var index = 0, len = nodes.length; index < len; index++) {
    var node = nodes[index];
    var current;

    // set the node data given the type
    switch (node.nodeType) {
      case 1:
        tagName = formatTagName(node.nodeName);
        // script, style, or tag
        current = new Element(tagName, formatAttributes(node.attributes));
        current.children = formatDOM(
          // template children are on content
          tagName === 'template' ? node.content.childNodes : node.childNodes,
          current
        );
        break;

      case 3:
        current = new Text(node.nodeValue);
        break;

      case 8:
        current = new Comment(node.nodeValue);
        break;

      default:
        continue;
    }

    // set previous node next
    var prev = result[index - 1] || null;
    if (prev) {
      prev.next = current;
    }

    // set properties for current node
    current.parent = parent;
    current.prev = prev;
    current.next = null;

    result.push(current);
  }

  if (directive) {
    current = new ProcessingInstruction(
      directive.substring(0, directive.indexOf(' ')).toLowerCase(),
      directive
    );
    current.next = result[0] || null;
    current.parent = parent;
    result.unshift(current);

    if (result[1]) {
      result[1].prev = result[0];
    }
  }

  return result;
}

exports.formatAttributes = formatAttributes;
exports.formatDOM = formatDOM;


/***/ }),

/***/ 81613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var void_elements__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71739);
/* harmony import */ var void_elements__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(void_elements__WEBPACK_IMPORTED_MODULE_0__);
var t=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],((void_elements__WEBPACK_IMPORTED_MODULE_0___default())[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(t),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var o=c[1].trim(),l=[o,""];o.indexOf("=")>-1&&(l=o.split("=")),r.attrs[l[0]]=l[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}var c={parse:function(e,t){t||(t={}),t.components||(t.components=s);var a,c=[],o=[],l=-1,m=!1;if(0!==e.indexOf("<")){var u=e.indexOf("<");c.push({type:"text",content:-1===u?e:e.substring(0,u)})}return e.replace(r,function(r,s){if(m){if(r!=="</"+a.name+">")return;m=!1}var u,f="/"!==r.charAt(1),h=r.startsWith("\x3c!--"),p=s+r.length,d=e.charAt(p);if(h){var v=n(r);return l<0?(c.push(v),c):((u=o[l]).children.push(v),c)}if(f&&(l++,"tag"===(a=n(r)).type&&t.components[a.name]&&(a.type="component",m=!0),a.voidElement||m||!d||"<"===d||a.children.push({type:"text",content:e.slice(p,e.indexOf("<",p))}),0===l&&c.push(a),(u=o[l-1])&&u.children.push(a),o[l]=a),(!f||a.voidElement)&&(l>-1&&(a.voidElement||a.name===r.slice(2,-1))&&(l--,a=-1===l?c:o[l]),!m&&"<"!==d&&d)){u=-1===l?c:o[l].children;var x=e.indexOf("<",p),g=e.slice(p,-1===x?void 0:x);i.test(g)&&(g=" "),(x>-1&&l+u.length>=0||" "!==g)&&u.push({type:"text",content:g})}}),c},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};/* harmony default export */ __webpack_exports__["Z"] = (c);
//# sourceMappingURL=html-parse-stringify.module.js.map


/***/ }),

/***/ 30488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var domhandler = __webpack_require__(47915);
var htmlToDOM = __webpack_require__(14152);

var attributesToProps = __webpack_require__(50484);
var domToReact = __webpack_require__(53670);

// support backwards compatibility for ES Module
htmlToDOM =
  /* istanbul ignore next */
  typeof htmlToDOM.default === 'function' ? htmlToDOM.default : htmlToDOM;

var domParserOptions = { lowerCaseAttributeNames: false };

/**
 * Converts HTML string to React elements.
 *
 * @param {string} html - HTML string.
 * @param {object} [options] - Parser options.
 * @param {object} [options.htmlparser2] - htmlparser2 options.
 * @param {object} [options.library] - Library for React, Preact, etc.
 * @param {Function} [options.replace] - Replace method.
 * @returns {JSX.Element|JSX.Element[]|string} - React element(s), empty array, or string.
 */
function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (html === '') {
    return [];
  }
  options = options || {};
  return domToReact(
    htmlToDOM(html, options.htmlparser2 || domParserOptions),
    options
  );
}

HTMLReactParser.domToReact = domToReact;
HTMLReactParser.htmlToDOM = htmlToDOM;
HTMLReactParser.attributesToProps = attributesToProps;

// domhandler
HTMLReactParser.Comment = domhandler.Comment;
HTMLReactParser.Element = domhandler.Element;
HTMLReactParser.ProcessingInstruction = domhandler.ProcessingInstruction;
HTMLReactParser.Text = domhandler.Text;

// support CommonJS and ES Modules
module.exports = HTMLReactParser;
HTMLReactParser.default = HTMLReactParser;


/***/ }),

/***/ 50484:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var reactProperty = __webpack_require__(83);
var utilities = __webpack_require__(74606);

// https://reactjs.org/docs/uncontrolled-components.html
// https://developer.mozilla.org/docs/Web/HTML/Attributes
var UNCONTROLLED_COMPONENT_ATTRIBUTES = ['checked', 'value'];
var UNCONTROLLED_COMPONENT_NAMES = ['input', 'select', 'textarea'];

var VALUE_ONLY_INPUTS = {
  reset: true,
  submit: true
};

/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param {object} [attributes={}] - HTML/SVG DOM attributes.
 * @param {string} [nodeName] - DOM node name.
 * @returns - React props.
 */
module.exports = function attributesToProps(attributes, nodeName) {
  attributes = attributes || {};

  var attributeName;
  var attributeNameLowerCased;
  var attributeValue;
  var propName;
  var propertyInfo;
  var props = {};
  var inputIsValueOnly = attributes.type && VALUE_ONLY_INPUTS[attributes.type];

  for (attributeName in attributes) {
    attributeValue = attributes[attributeName];

    // ARIA (aria-*) or custom data (data-*) attribute
    if (reactProperty.isCustomAttribute(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    }

    // convert HTML/SVG attribute to React prop
    attributeNameLowerCased = attributeName.toLowerCase();
    propName = getPropName(attributeNameLowerCased);

    if (propName) {
      propertyInfo = reactProperty.getPropertyInfo(propName);

      // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
      if (
        UNCONTROLLED_COMPONENT_ATTRIBUTES.indexOf(propName) !== -1 &&
        UNCONTROLLED_COMPONENT_NAMES.indexOf(nodeName) !== -1 &&
        !inputIsValueOnly
      ) {
        propName = getPropName('default' + attributeNameLowerCased);
      }

      props[propName] = attributeValue;

      switch (propertyInfo && propertyInfo.type) {
        case reactProperty.BOOLEAN:
          props[propName] = true;
          break;
        case reactProperty.OVERLOADED_BOOLEAN:
          if (attributeValue === '') {
            props[propName] = true;
          }
          break;
      }
      continue;
    }

    // preserve custom attribute if React >=16
    if (utilities.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  }

  // transform inline style to object
  utilities.setStyleProp(attributes.style, props);

  return props;
};

/**
 * Gets prop name from lowercased attribute name.
 *
 * @param {string} attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */
function getPropName(attributeName) {
  return reactProperty.possibleStandardNames[attributeName];
}


/***/ }),

/***/ 53670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(67294);
var attributesToProps = __webpack_require__(50484);
var utilities = __webpack_require__(74606);

var setStyleProp = utilities.setStyleProp;
var canTextBeChildOfNode = utilities.canTextBeChildOfNode;

/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param {DomElement[]} nodes - DOM nodes.
 * @param {object} [options={}] - Options.
 * @param {Function} [options.replace] - Replacer.
 * @param {object} [options.library] - Library (React, Preact, etc.).
 * @returns - String or JSX element(s).
 */
function domToReact(nodes, options) {
  options = options || {};

  var library = options.library || React;
  var cloneElement = library.cloneElement;
  var createElement = library.createElement;
  var isValidElement = library.isValidElement;

  var result = [];
  var node;
  var isWhitespace;
  var hasReplace = typeof options.replace === 'function';
  var replaceElement;
  var props;
  var children;
  var trim = options.trim;

  for (var i = 0, len = nodes.length; i < len; i++) {
    node = nodes[i];

    // replace with custom React element (if present)
    if (hasReplace) {
      replaceElement = options.replace(node);

      if (isValidElement(replaceElement)) {
        // set "key" prop for sibling elements
        // https://fb.me/react-warning-keys
        if (len > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || i
          });
        }
        result.push(replaceElement);
        continue;
      }
    }

    if (node.type === 'text') {
      isWhitespace = !node.data.trim().length;

      if (isWhitespace && node.parent && !canTextBeChildOfNode(node.parent)) {
        // We have a whitespace node that can't be nested in its parent
        // so skip it
        continue;
      }

      if (trim && isWhitespace) {
        // Trim is enabled and we have a whitespace node
        // so skip it
        continue;
      }

      // We have a text node that's not whitespace and it can be nested
      // in its parent so add it to the results
      result.push(node.data);
      continue;
    }

    props = node.attribs;
    if (skipAttributesToProps(node)) {
      setStyleProp(props.style, props);
    } else if (props) {
      props = attributesToProps(props, node.name);
    }

    children = null;

    switch (node.type) {
      case 'script':
      case 'style':
        // prevent text in <script> or <style> from being escaped
        // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
        if (node.children[0]) {
          props.dangerouslySetInnerHTML = {
            __html: node.children[0].data
          };
        }
        break;

      case 'tag':
        // setting textarea value in children is an antipattern in React
        // https://reactjs.org/docs/forms.html#the-textarea-tag
        if (node.name === 'textarea' && node.children[0]) {
          props.defaultValue = node.children[0].data;
        } else if (node.children && node.children.length) {
          // continue recursion of creating React elements (if applicable)
          children = domToReact(node.children, options);
        }
        break;

      // skip all other cases (e.g., comment)
      default:
        continue;
    }

    // set "key" prop for sibling elements
    // https://fb.me/react-warning-keys
    if (len > 1) {
      props.key = i;
    }

    result.push(createElement(node.name, props, children));
  }

  return result.length === 1 ? result[0] : result;
}

/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param {DomElement} node
 * @returns - Whether node attributes should be converted to props.
 */
function skipAttributesToProps(node) {
  return (
    utilities.PRESERVE_CUSTOM_ATTRIBUTES &&
    node.type === 'tag' &&
    utilities.isCustomComponent(node.name, node.attribs)
  );
}

module.exports = domToReact;


/***/ }),

/***/ 74606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(67294);
var styleToJS = (__webpack_require__(41476)["default"]);

/**
 * Swap key with value in an object.
 *
 * @param {object} obj - The object.
 * @param {Function} [override] - The override method.
 * @returns - The inverted object.
 */
function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }

  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};

  for (key in obj) {
    value = obj[key];

    if (isOverridePresent) {
      overrides = override(key, value);
      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }

    if (typeof value === 'string') {
      result[value] = key;
    }
  }

  return result;
}

/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {object} props - The props being passed to the element.
 * @returns - Whether tag is custom component.
 */
function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return props && typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;
    default:
      return true;
  }
}

var styleToJSOptions = { reactCompat: true };

/**
 * Sets style prop.
 *
 * @param {null|undefined|string} style
 * @param {object} props
 */
function setStyleProp(style, props) {
  if (style === null || style === undefined) {
    return;
  }
  try {
    props.style = styleToJS(style, styleToJSOptions);
  } catch (err) {
    props.style = {};
  }
}

/**
 * @constant {boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */
var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;

// Taken from
// https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
var elementsWithNoTextChildren = new Set([
  'tr',
  'tbody',
  'thead',
  'tfoot',
  'colgroup',
  'table',
  'head',
  'html',
  'frameset'
]);

/**
 * Checks if the given node can contain text nodes
 *
 * @param {DomElement} node - Node.
 * @returns - Whether node can contain text nodes.
 */
function canTextBeChildOfNode(node) {
  return !elementsWithNoTextChildren.has(node.name);
}

module.exports = {
  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
  invertObject: invertObject,
  isCustomComponent: isCustomComponent,
  setStyleProp: setStyleProp,
  canTextBeChildOfNode: canTextBeChildOfNode,
  elementsWithNoTextChildren: elementsWithNoTextChildren
};


/***/ }),

/***/ 81580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Backend; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43144);



var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function createClassOnDemand(ClassOrObject) {
  if (!ClassOrObject) return null;
  if (typeof ClassOrObject === 'function') return new ClassOrObject();
  return ClassOrObject;
}

function getDefaults() {
  return {
    handleEmptyResourcesAsFailed: true,
    cacheHitMode: 'none'
    // reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000
    // refreshExpirationTime: 60 * 60 * 1000
  };
}

function handleCorrectReadFunction(backend, language, namespace, resolver) {
  var fc = backend.read.bind(backend);
  if (fc.length === 2) {
    // no callback
    try {
      var r = fc(language, namespace);
      if (r && typeof r.then === 'function') {
        // promise
        r.then(function (data) {
          return resolver(null, data);
        })["catch"](resolver);
      } else {
        // sync
        resolver(null, r);
      }
    } catch (err) {
      resolver(err);
    }
    return;
  }

  // normal with callback
  fc(language, namespace, resolver);
}
var Backend = /*#__PURE__*/function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nextOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Backend);
    this.backends = [];
    this.type = 'backend';
    this.allOptions = i18nextOptions;
    this.init(services, options);
  }
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nextOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = defaults(options, this.options || {}, getDefaults());
      this.allOptions = i18nextOptions;
      this.options.backends && this.options.backends.forEach(function (b, i) {
        _this.backends[i] = _this.backends[i] || createClassOnDemand(b);
        _this.backends[i].init(services, _this.options.backendOptions && _this.options.backendOptions[i] || {}, i18nextOptions);
      });
      if (this.services && this.options.reloadInterval) {
        setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
      }
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      var _this2 = this;
      var bLen = this.backends.length;
      var loadPosition = function loadPosition(pos) {
        if (pos >= bLen) return callback(new Error('non of the backend loaded data', true)); // failed pass retry flag
        var isLastBackend = pos === bLen - 1;
        var lengthCheckAmount = _this2.options.handleEmptyResourcesAsFailed && !isLastBackend ? 0 : -1;
        var backend = _this2.backends[pos];
        if (backend.read) {
          handleCorrectReadFunction(backend, language, namespace, function (err, data, savedAt) {
            if (!err && data && Object.keys(data).length > lengthCheckAmount) {
              callback(null, data, pos);
              savePosition(pos - 1, data); // save one in front
              if (backend.save && _this2.options.cacheHitMode && ['refresh', 'refreshAndUpdateStore'].indexOf(_this2.options.cacheHitMode) > -1) {
                if (savedAt && _this2.options.refreshExpirationTime && savedAt + _this2.options.refreshExpirationTime > Date.now()) return;
                var nextBackend = _this2.backends[pos + 1];
                if (nextBackend && nextBackend.read) {
                  handleCorrectReadFunction(nextBackend, language, namespace, function (err, data) {
                    if (err) return;
                    if (!data) return;
                    if (Object.keys(data).length <= lengthCheckAmount) return;
                    savePosition(pos, data);
                    if (_this2.options.cacheHitMode !== 'refreshAndUpdateStore') return;
                    if (_this2.services && _this2.services.resourceStore) {
                      _this2.services.resourceStore.addResourceBundle(language, namespace, data);
                    }
                  });
                }
              }
            } else {
              loadPosition(pos + 1); // try load from next
            }
          });
        } else {
          loadPosition(pos + 1); // try load from next
        }
      };

      var savePosition = function savePosition(pos, data) {
        if (pos < 0) return;
        var backend = _this2.backends[pos];
        if (backend.save) {
          backend.save(language, namespace, data);
          savePosition(pos - 1, data);
        } else {
          savePosition(pos - 1, data);
        }
      };
      loadPosition(0);
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue) {
      var clb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
      var opts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      this.backends.forEach(function (b) {
        if (!b.create) return;
        var fc = b.create.bind(b);
        if (fc.length < 6) {
          // no callback
          try {
            var r;
            if (fc.length === 5) {
              // future callback-less api for i18next-locize-backend
              r = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r = fc(languages, namespace, key, fallbackValue);
            }
            if (r && typeof r.then === 'function') {
              // promise
              r.then(function (data) {
                return clb(null, data);
              })["catch"](clb);
            } else {
              // sync
              clb(null, r);
            }
          } catch (err) {
            clb(err);
          }
          return;
        }

        // normal with callback
        fc(languages, namespace, key, fallbackValue, clb /* unused callback */, opts);
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this3 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return; // avoid loading resources for cimode

      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this3.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
  return Backend;
}();
Backend.type = 'backend';




/***/ }),

/***/ 70660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Cache; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43144);




function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-classes-per-file */
var Storage = /*#__PURE__*/function () {
  function Storage(options) {
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Storage);
    this.store = options.store;
  }
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Storage, [{
    key: "setItem",
    value: function setItem(key, value) {
      if (this.store) {
        try {
          this.store.setItem(key, value);
        } catch (e) {
          // f.log('failed to set value for key "' + key + '" to localStorage.');
        }
      }
    }
  }, {
    key: "getItem",
    value: function getItem(key, value) {
      if (this.store) {
        try {
          return this.store.getItem(key, value);
        } catch (e) {
          // f.log('failed to get value for key "' + key + '" from localStorage.');
        }
      }
      return undefined;
    }
  }]);
  return Storage;
}();
function getDefaults() {
  var store = null;
  try {
    store = window.localStorage;
  } catch (e) {
    if (typeof window !== 'undefined') {
      console.log('Failed to load local storage.', e);
    }
  }
  return {
    prefix: 'i18next_res_',
    expirationTime: 7 * 24 * 60 * 60 * 1000,
    defaultVersion: undefined,
    versions: {},
    store: store
  };
}
var Cache = /*#__PURE__*/function () {
  function Cache(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Cache);
    this.init(services, options);
    this.type = 'backend';
  }
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Cache, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.services = services;
      this.options = _objectSpread(_objectSpread(_objectSpread({}, getDefaults()), this.options), options);
      this.storage = new Storage(this.options);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      var nowMS = Date.now();
      if (!this.storage.store) {
        return callback(null, null);
      }
      var local = this.storage.getItem("".concat(this.options.prefix).concat(language, "-").concat(namespace));
      if (local) {
        local = JSON.parse(local);
        var version = this.getVersion(language);
        if (
        // expiration field is mandatory, and should not be expired
        local.i18nStamp && local.i18nStamp + this.options.expirationTime > nowMS &&
        // there should be no language version set, or if it is, it should match the one in translation
        version === local.i18nVersion) {
          var i18nStamp = local.i18nStamp;
          delete local.i18nVersion;
          delete local.i18nStamp;
          return callback(null, local, i18nStamp);
        }
      }
      return callback(null, null);
    }
  }, {
    key: "save",
    value: function save(language, namespace, data) {
      if (this.storage.store) {
        data.i18nStamp = Date.now();

        // language version (if set)
        var version = this.getVersion(language);
        if (version) {
          data.i18nVersion = version;
        }

        // save
        this.storage.setItem("".concat(this.options.prefix).concat(language, "-").concat(namespace), JSON.stringify(data));
      }
    }
  }, {
    key: "getVersion",
    value: function getVersion(language) {
      return this.options.versions[language] || this.options.defaultVersion;
    }
  }]);
  return Cache;
}();
Cache.type = 'backend';




/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 18139:
/***/ (function(module) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),

/***/ 29238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = window.DOMPurify || (window.DOMPurify = (__webpack_require__(27856)["default"]) || __webpack_require__(27856));

/***/ }),

/***/ 35823:
/***/ (function(module) {

module.exports = function(data, filename, mime, bom) {
    var blobData = (typeof bom !== 'undefined') ? [bom, data] : [data]
    var blob = new Blob(blobData, {type: mime || 'application/octet-stream'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }

        document.body.appendChild(tempLink);
        tempLink.click();

        // Fixes "webkit blob resource error 1"
        setTimeout(function() {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200)
    }
}


/***/ }),

/***/ 83465:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;


/***/ }),

/***/ 60790:
/***/ (function(module) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : baseFor(object, typeof iteratee == 'function' ? iteratee : identity, keysIn);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = forIn;


/***/ }),

/***/ 29208:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 99245:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' ||
        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;


/***/ }),

/***/ 16040:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Creates an array of the own and inherited enumerable symbol properties
 * of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  return object == null ? {} : basePickBy(object, getAllKeysIn(object), baseIteratee(predicate));
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = pickBy;


/***/ }),

/***/ 31468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ 96633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);
  object = parent(object, path);

  var key = toKey(last(path));
  return !(object != null && hasOwnProperty.call(object, key)) || delete object[key];
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

module.exports = unset;


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 41609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(280),
    getTag = __webpack_require__(64160),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLike = __webpack_require__(98612),
    isBuffer = __webpack_require__(44144),
    isPrototype = __webpack_require__(25726),
    isTypedArray = __webpack_require__(36719);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 59738:
/***/ (function(module) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),

/***/ 76329:
/***/ (function(module) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),

/***/ 43678:
/***/ (function(module) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),

/***/ 52264:
/***/ (function(module) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),

/***/ 55730:
/***/ (function(module) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),

/***/ 20707:
/***/ (function(module) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),

/***/ 63862:
/***/ (function(module) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),

/***/ 29550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(43678);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),

/***/ 30381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                Object(function webpackMissingModule() { var e = new Error("Cannot find module 'undefined'"); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ 52786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cC": function() { return /* reexport */ Trans/* Trans */.c; },
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "ag": function() { return /* reexport */ globalI18n; },
  "$G": function() { return /* reexport */ useTranslation/* useTranslation */.$; }
});

// UNUSED EXPORTS: I18nContext, Translation, withTranslation

// EXTERNAL MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/Trans.js
var Trans = __webpack_require__(96220);
// EXTERNAL MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(14661);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/I18nextProvider.js
var I18nextProvider = __webpack_require__(10313);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(59199);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function toConsumableArray_toConsumableArray(r) {
  return _arrayWithoutHoles(r) || (0,iterableToArray/* default */.Z)(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },

  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },

  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: []
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/utils.js


var getFallbackForLng = function getFallbackForLng(lng, fallbackLng) {
  if (typeof fallbackLng === 'string') {
    return [fallbackLng];
  }

  if (Array.isArray(fallbackLng)) {
    return fallbackLng;
  }

  if (_typeof(fallbackLng) === 'object') {
    var fallbackList = fallbackLng[lng];
    var fallbackDefault = fallbackLng["default"];
    return [].concat(_toConsumableArray(fallbackList !== null && fallbackList !== void 0 ? fallbackList : []), _toConsumableArray(fallbackDefault !== null && fallbackDefault !== void 0 ? fallbackDefault : []));
  }

  if (typeof fallbackLng === 'function') {
    return getFallbackForLng(lng, fallbackLng(lng));
  }

  return [];
};
var unique = function unique(list) {
  return Array.from(new Set(list));
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/createConfig.js





var _excluded = ["i18n"],
    _excluded2 = ["i18n"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$use;

  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  } //
  // Initial merge of default and user-provided config
  //


  var userI18n = userConfig.i18n,
      userConfigStripped = (0,objectWithoutProperties/* default */.Z)(userConfig, _excluded);

  var defaultI18n = defaultConfig.i18n,
      defaultConfigStripped = (0,objectWithoutProperties/* default */.Z)(defaultConfig, _excluded2);

  var combinedConfig = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);

  var defaultNS = combinedConfig.defaultNS,
      lng = combinedConfig.lng,
      localeExtension = combinedConfig.localeExtension,
      localePath = combinedConfig.localePath,
      localeStructure = combinedConfig.localeStructure,
      nonExplicitSupportedLngs = combinedConfig.nonExplicitSupportedLngs;
  var locales = combinedConfig.locales.filter(function (l) {
    return l !== 'default';
  });
  /**
   * Skips translation file resolution while in cimode
   * https://github.com/i18next/next-i18next/pull/851#discussion_r503113620
  */

  if (lng === 'cimode') {
    return combinedConfig;
  }

  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;

    if (combinedConfig.fallbackLng === 'default') {
      var _locales = (0,slicedToArray/* default */.Z)(locales, 1);

      combinedConfig.fallbackLng = _locales[0];
    }
  }

  var fallbackLng = combinedConfig.fallbackLng;

  if (nonExplicitSupportedLngs) {
    var createFallbackObject = function createFallbackObject(acc, l) {
      var _l$split = l.split('-'),
          _l$split2 = (0,slicedToArray/* default */.Z)(_l$split, 1),
          locale = _l$split2[0];

      acc[l] = [locale];
      return acc;
    };

    if (typeof fallbackLng === 'string') {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": [fallbackLng]
      });
    } else if (Array.isArray(fallbackLng)) {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": fallbackLng
      });
    } else if ((0,esm_typeof/* default */.Z)(fallbackLng) === 'object') {
      combinedConfig.fallbackLng = Object.entries(combinedConfig.fallbackLng).reduce(function (acc, _ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
            l = _ref2[0],
            f = _ref2[1];

        acc[l] = l.includes('-') ? unique([l.split('-')[0]].concat(toConsumableArray_toConsumableArray(f))) : f;
        return acc;
      }, fallbackLng);
    } else if (typeof fallbackLng === 'function') {
      throw new Error('If nonExplicitSupportedLngs is true, no functions are allowed for fallbackLng');
    }
  }

  var hasCustomBackend = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });

  if (false) { var getNamespaces, _defaultFallbackNSExists, _fallback, _defaultNSExists, _defaultNSPath, defaultFallbackNSExists, fallback, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, suffix, prefix, _userConfig$interpola, _userConfig$interpola2, _userConfig$interpola3, _userConfig$interpola4, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }

    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  } //
  // Deep merge with overwrite - goes last
  //


  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = _objectSpread(_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(32531);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(84506);
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/i18next/dist/esm/i18next.js










function i18next_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function i18next_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { i18next_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { i18next_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Logger);

    this.init(concreteLogger, options);
  }

  (0,createClass/* default */.Z)(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, i18next_objectSpread(i18next_objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    (0,classCallCheck/* default */.Z)(this, EventEmitter);

    this.observers = {};
  }

  (0,createClass/* default */.Z)(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (mix === null) return null;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  (0,inherits/* default */.Z)(ResourceStore, _EventEmitter);

  var _super = _createSuper(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    (0,classCallCheck/* default */.Z)(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  (0,createClass/* default */.Z)(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Translator, _EventEmitter);

  var _super = _createSuper$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, (0,assertThisInitialized/* default */.Z)(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  (0,createClass/* default */.Z)(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if ((0,esm_typeof/* default */.Z)(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;

          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }

          return "".concat(namespace).concat(nsSeparator).concat(key);
        }

        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");

          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }

          return r;
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    (0,classCallCheck/* default */.Z)(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  (0,createClass/* default */.Z)(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  (0,createClass/* default */.Z)(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  (0,createClass/* default */.Z)(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);

        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = (0,toArray/* default */.Z)(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];

    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }

    return formatter(val);
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, options);
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val, options.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }

  (0,createClass/* default */.Z)(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}

var Connector = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    (0,classCallCheck/* default */.Z)(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });

      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);

        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];

            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});

      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }

      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        _this3.readingCalls--;

        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();

          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }

        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if ((0,esm_typeof/* default */.Z)(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if ((0,esm_typeof/* default */.Z)(args[2]) === 'object' || (0,esm_typeof/* default */.Z)(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n = function (_EventEmitter) {
  (0,inherits/* default */.Z)(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    (0,classCallCheck/* default */.Z)(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions((0,assertThisInitialized/* default */.Z)(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return (0,possibleConstructorReturn/* default */.Z)(_this, (0,assertThisInitialized/* default */.Z)(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if ((0,esm_typeof/* default */.Z)(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);

      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }

      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

(0,defineProperty/* default */.Z)(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});

var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

/* harmony default export */ var i18next = (instance);


;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  if (config.ns === undefined) config.ns = [];
  var instance = i18next.createInstance(config);
  var initPromise;

  if (!instance.isInitialized) {
    var _config$use;

    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });

    if (typeof config.onPreInitI18next === 'function') {
      config.onPreInitI18next(instance);
    }

    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next.t);
  }

  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;

function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? appWithTranslation_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;

    var _ref = props.pageProps,
        _nextI18Next = _ref._nextI18Next;
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 ? void 0 : (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale;
    var ns = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.ns; // Memoize the instance and only re-initialize when either:
    // 1. The route changes (non-shallowly)
    // 2. Router locale changes
    // 3. UserConfig override changes

    var i18n = (0,react.useMemo)(function () {
      var _userConfig, _userConfig2, _userConfig2$i18n;

      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;

      if (!userConfig && configOverride === null) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }

      if (configOverride !== null) {
        userConfig = configOverride;
      }

      if (!((_userConfig = userConfig) !== null && _userConfig !== void 0 && _userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }

      if (!((_userConfig2 = userConfig) !== null && _userConfig2 !== void 0 && (_userConfig2$i18n = _userConfig2.i18n) !== null && _userConfig2$i18n !== void 0 && _userConfig2$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }

      var _ref2 = _nextI18Next || {},
          initialI18nStore = _ref2.initialI18nStore;

      var resources = configOverride !== null && configOverride !== void 0 && configOverride.resources ? configOverride.resources : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: locale
      }))), {}, {
        lng: locale,
        ns: ns,
        resources: resources
      })).i18n;
      globalI18n = instance;
      return instance;
    }, [_nextI18Next, locale, configOverride, ns]);
    return i18n !== null ? __jsx(I18nextProvider/* I18nextProvider */.a, {
      i18n: i18n
    }, __jsx(WrappedComponent, props)) : __jsx(WrappedComponent, _extends({
      key: locale
    }, props));
  };

  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 10313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ I18nextProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84917);


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_context__WEBPACK_IMPORTED_MODULE_1__/* .I18nContext.Provider */ .OO.Provider, {
    value: value
  }, children);
}

/***/ }),

/***/ 96220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ Trans; }
/* harmony export */ });
/* unused harmony export nodesToString */
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71002);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var html_parse_stringify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81613);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84917);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19983);



var _excluded = ["format"],
    _excluded2 = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function hasChildren(node, checkLength) {
  if (!node) return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}

function getChildren(node) {
  if (!node) return [];
  return node.props ? node.props.children : node.children;
}

function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child);
  });
}

function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}

function mergeProps(source, target) {
  var newTarget = _objectSpread({}, target);

  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}

function nodesToString(children, i18nOptions) {
  if (!children) return '';
  var stringNode = '';
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach(function (child, childIndex) {
    if (typeof child === 'string') {
      stringNode += "".concat(child);
    } else if ((0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;

      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warn */ .ZK)("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(child) === 'object') {
      var format = child.format,
          clone = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(child, _excluded);

      var keys = Object.keys(clone);

      if (keys.length === 1) {
        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warn */ .ZK)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warn */ .ZK)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}

function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  var data = {};

  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(child) === 'object' && !(0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child)) Object.assign(data, child);
    });
  }

  getData(children);
  var ast = html_parse_stringify__WEBPACK_IMPORTED_MODULE_2__/* ["default"].parse */ .Z.parse("<0>".concat(targetString, "</0>"));

  var opts = _objectSpread(_objectSpread({}, data), combinedTOpts);

  function renderInner(child, node, rootReactNode) {
    var childs = getChildren(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }

  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push((0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
      key: i
    }), isVoid ? undefined : inner));
  }

  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);

      if (node.type === 'tag') {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child);
        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(child) === 'object' && child.dummy && !isElement;
        var isKnownComponent = (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);

        if (typeof child === 'string') {
          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
            var inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i);
          } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);

          mem.push((0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);

            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push((0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);

              mem.push((0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);

            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push((0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
            key: i
          }), translationContent));
        } else {
          mem.push((0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;

        var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);

        if (wrapTextNodes) {
          mem.push((0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i)
          }, _content));
        } else {
          mem.push(_content);
        }
      }

      return mem;
    }, []);
  }

  var result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}

function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded2);

  var _ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_6__/* .I18nContext */ .OO) || {},
      i18nFromContext = _ref2.i18n,
      defaultNSFromContext = _ref2.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || (0,_context__WEBPACK_IMPORTED_MODULE_6__/* .getI18n */ .nI)();

  if (!i18n) {
    (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warnOnce */ .O4)('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }

  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };

  if (context) tOptions.context = context;

  var reactI18nextOptions = _objectSpread(_objectSpread({}, (0,_context__WEBPACK_IMPORTED_MODULE_6__/* .getDefaults */ .JP)()), i18n.options && i18n.options.react);

  var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: _objectSpread(_objectSpread({}, tOptions.interpolation), {}, {
      prefix: '#$?',
      suffix: '?$#'
    })
  };

  var combinedTOpts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, tOptions), {}, {
    count: count
  }, values), interpolationOverride), {}, {
    defaultValue: defaultValue,
    ns: namespaces
  });

  var translation = key ? t(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(useAsParent, additionalProps, content) : content;
}

/***/ }),

/***/ 84917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OO": function() { return /* binding */ I18nContext; },
  "zv": function() { return /* binding */ ReportNamespaces; },
  "qi": function() { return /* binding */ composeInitialProps; },
  "JP": function() { return /* binding */ getDefaults; },
  "nI": function() { return /* binding */ getI18n; },
  "kK": function() { return /* binding */ getInitialProps; },
  "Db": function() { return /* binding */ initReactI18next; },
  "j_": function() { return /* binding */ setDefaults; },
  "I6": function() { return /* binding */ setI18n; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/context.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
var i18nInstance;
var I18nContext = (0,react.createContext)();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,classCallCheck/* default */.Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,createClass/* default */.Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}

/***/ }),

/***/ 14661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useTranslation; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97685);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84917);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19983);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .I18nContext */ .OO) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .getI18n */ .nI)();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new _context__WEBPACK_IMPORTED_MODULE_2__/* .ReportNamespaces */ .zv();

  if (!i18n) {
    (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warnOnce */ .O4)('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warnOnce */ .O4)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .getDefaults */ .JP)()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .hasLoadedNamespace */ .F0)(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(getT),
      _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .loadNamespaces */ .DC)(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .loadNamespaces */ .DC)(i18n, namespaces, function () {
      resolve();
    });
  });
}

/***/ }),

/***/ 19983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DC": function() { return /* binding */ loadNamespaces; },
/* harmony export */   "F0": function() { return /* binding */ hasLoadedNamespace; },
/* harmony export */   "Gf": function() { return /* binding */ getDisplayName; },
/* harmony export */   "O4": function() { return /* binding */ warnOnce; },
/* harmony export */   "ZK": function() { return /* binding */ warn; }
/* harmony export */ });
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

/***/ }),

/***/ 28858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ createWrapper; },
/* harmony export */   "ju": function() { return /* binding */ HYDRATE; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


/**
 * Quick note on Next.js return types:
 *
 * Page.getInitialProps https://nextjs.org/docs/api-reference/data-fetching/getInitialProps
 * as-is
 *
 * App.getInitialProps: AppInitialProps https://nextjs.org/docs/advanced-features/custom-app
 * {pageProps: any}
 *
 * getStaticProps https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 * {props: any}
 *
 * getServerSideProps https://nextjs.org/docs/basic-features/data-fetching#getserversideprops-server-side-rendering
 * {props: any}
 */
var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserializedState = function (initialState, _a) {
    var _b = _a === void 0 ? {} : _a, deserializeState = _b.deserializeState;
    return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
    var _b = _a === void 0 ? {} : _a, serializeState = _b.serializeState;
    return serializeState ? serializeState(state) : state;
};
var store;
var initStore = function (_a) {
    var makeStore = _a.makeStore, context = _a.context;
    var createStore = function () { return makeStore(context); };
    if (getIsServer()) {
        var c = context;
        var req = void 0;
        if (c.req)
            req = c.req;
        if (c.ctx && c.ctx.req)
            req = c.ctx.req;
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req.__nextReduxWrapperStore)
                req.__nextReduxWrapperStore = createStore();
            return req.__nextReduxWrapperStore;
        }
        return createStore();
    }
    // Memoize store if client
    if (!store) {
        store = createStore();
    }
    return store;
};
var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context;
        return __awaiter(void 0, void 0, void 0, function () {
            var store, nextCallback, initialProps, _b, state;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        store = initStore({ context: context, makeStore: makeStore });
                        if (config.debug)
                            console.log("1. getProps created store with state", store.getState());
                        nextCallback = callback && callback(store);
                        _b = nextCallback;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextCallback(context)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        initialProps = (_b) || {};
                        if (config.debug)
                            console.log("3. getProps after dispatches has store state", store.getState());
                        state = store.getState();
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                initialState: getIsServer() ? getSerializedState(state, config) : state,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ('getState' in context) {
                return [2 /*return*/, callback && callback(context)];
            }
            return [2 /*return*/, makeProps({ callback: callback, context: context })];
        });
    }); }; };
    var getInitialAppProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { initialState: initialState })];
            }
        });
    }); }; };
    var getStaticProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { props: __assign(__assign({}, initialProps.props), { initialState: initialState }) })];
            }
        });
    }); }; };
    var getServerSideProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getStaticProps(callback)(context)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }; }; // just not to repeat myself
    var withRedux = function (Component) {
        var _a;
        var displayName = "withRedux(" + (Component.displayName || Component.name || 'Component') + ")";
        var hasInitialProps = 'getInitialProps' in Component;
        //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
        return _a = /** @class */ (function (_super) {
                __extends(Wrapper, _super);
                function Wrapper(props, context) {
                    var _this = _super.call(this, props, context) || this;
                    _this.store = null;
                    _this.hydrate(props, context);
                    return _this;
                }
                Wrapper.prototype.hydrate = function (_a, context) {
                    var _b;
                    var initialState = _a.initialState, initialProps = _a.initialProps, props = __rest(_a, ["initialState", "initialProps"]);
                    // this happens when App has page with getServerSideProps/getStaticProps, initialState will be dumped twice:
                    // one incomplete and one complete
                    var initialStateFromGSPorGSSR = (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState;
                    if (!this.store) {
                        this.store = initStore({ makeStore: makeStore, context: context });
                        if (config.debug)
                            console.log('4. WrappedApp created new store with', displayName, {
                                initialState: initialState,
                                initialStateFromGSPorGSSR: initialStateFromGSPorGSSR,
                            });
                    }
                    if (initialState)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialState, config),
                        });
                    // ATTENTION! This code assumes that Page's getServerSideProps is executed after App.getInitialProps
                    // so we dispatch in this order
                    if (initialStateFromGSPorGSSR)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialStateFromGSPorGSSR, config),
                        });
                };
                Wrapper.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
                    var _a, _b, _c, _d;
                    if (((_a = nextProps === null || nextProps === void 0 ? void 0 : nextProps.pageProps) === null || _a === void 0 ? void 0 : _a.initialState) !== ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.pageProps) === null || _c === void 0 ? void 0 : _c.initialState) ||
                        (nextProps === null || nextProps === void 0 ? void 0 : nextProps.initialState) !== ((_d = this.props) === null || _d === void 0 ? void 0 : _d.initialState)) {
                        this.hydrate(nextProps, nextContext);
                    }
                    return true;
                };
                Wrapper.prototype.render = function () {
                    var _a, _b;
                    var _c = this.props, initialState = _c.initialState, initialProps = _c.initialProps, props = __rest(_c, ["initialState", "initialProps"]);
                    var resultProps = props;
                    // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
                    // @see https://github.com/zeit/next.js/issues/11648
                    if (initialProps && initialProps.pageProps)
                        resultProps.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
                    var initialStateFromGSPorGSSR = (_a = props === null || props === void 0 ? void 0 : props.pageProps) === null || _a === void 0 ? void 0 : _a.initialState;
                    // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
                    if (initialStateFromGSPorGSSR) {
                        resultProps = __assign(__assign({}, props), { pageProps: __assign({}, props.pageProps) });
                        delete resultProps.pageProps.initialState;
                    }
                    // unwrap getInitialPageProps
                    if ((_b = resultProps === null || resultProps === void 0 ? void 0 : resultProps.pageProps) === null || _b === void 0 ? void 0 : _b.initialProps) {
                        resultProps.pageProps = __assign(__assign({}, resultProps.pageProps), resultProps.pageProps.initialProps);
                        delete resultProps.pageProps.initialProps;
                    }
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_redux__WEBPACK_IMPORTED_MODULE_1__/* .Provider */ .zt, { store: this.store },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, __assign({}, initialProps, resultProps))));
                };
                return Wrapper;
            }(react__WEBPACK_IMPORTED_MODULE_0__.Component)),
            _a.displayName = displayName,
            _a.getInitialProps = hasInitialProps ? Component.getInitialProps : undefined,
            _a;
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        getInitialAppProps: getInitialAppProps,
        getInitialPageProps: getInitialPageProps,
        withRedux: withRedux,
    };
};
// Legacy
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (function (makeStore, config) {
    if (config === void 0) { config = {}; }
    console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.withRedux().');
    return createWrapper(makeStore, config).withRedux;
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 23837:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(37344);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 653:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close.8c2dae8d.svg","height":17,"width":17});

/***/ }),

/***/ 36513:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/image-missing.e5ede0fc.png","height":1200,"width":1310,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAABlBMVEX////19fVC0XEuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAEUlEQVQImWNgwAYYGXEyUAEAAPwAB/jM1CkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 3155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pc": function() { return /* binding */ offerClickEventAnalytics; },
/* harmony export */   "Sg": function() { return /* binding */ getBreadcrumbEventInfo; },
/* harmony export */   "f8": function() { return /* binding */ addBuyBtnAnalytics; },
/* harmony export */   "fE": function() { return /* binding */ dataLayerAddToCart; },
/* harmony export */   "i3": function() { return /* binding */ addDataLayerForConfigurationExapandState; },
/* harmony export */   "nr": function() { return /* binding */ addAnalyticsForSelectionDropdown; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; }
/* harmony export */ });
/* unused harmony exports getWidgetEventInfo, getOfferEventInfo */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34326);

const getEventInfo = function(type) {
    let needsJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, toolTipText = arguments.length > 2 ? arguments[2] : void 0, accordianState = arguments.length > 3 ? arguments[3] : void 0;
    let eventAction;
    let eventName;
    let internalLinkType;
    let internalLinkName;
    if (type === "list info mouseover") {
        internalLinkType = "pdp:mouseover";
        internalLinkName = "list";
    } else if (type === "print") {
        internalLinkType = "pdp:print";
    } else if (type === "color selection") {
        internalLinkType = "pdp:color selection";
        internalLinkName = type;
    } else if (type === "select configurations") {
        internalLinkName = accordianState;
    } else if (type.includes("mouseover") && toolTipText) {
        internalLinkName = toolTipText === null || toolTipText === void 0 ? void 0 : toolTipText.toLowerCase();
        const title = type.replace("mouseover", "");
        internalLinkType = "pdp:mouseover:".concat(title);
    } else if (type === "remove") {
        internalLinkType = "pdp:".concat(type);
    } else if (type === "read more") {
        internalLinkType = "pdp:".concat(type);
    } else if (type === "tooltip") {
        internalLinkName = "info tooltip";
        internalLinkType = eventName = eventAction = "pdp:info tooltip";
    } else if (type === "items required for install test" || "edit items required for install") {
        internalLinkType = eventName = eventAction = "pdp:".concat(type);
    }
    const eventInfo = {
        eventAction: eventAction || "pdp:product details:" + type + (accordianState ? ":".concat(accordianState) : ""),
        eventName: eventName || "pdp:product details:" + type + (accordianState ? ":".concat(accordianState) : ""),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName || type,
        internalLinkPosition: "pdp",
        internalLinkType: internalLinkType || "pdp:navigation",
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const dataLayerAddToCart = (param, serviceName)=>{
    let { res , productInfo  } = param;
    var ref;
    const { status , message ="n/a"  } = res;
    const isStatus = status === 200;
    const eventInfo = {
        eventAction: "pdp:cross-sell:kohler professional services:add to cart",
        eventName: "pdp:cross-sell:kohler professional services:add to cart",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: "add to cart",
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(serviceName === null || serviceName === void 0 ? void 0 : serviceName.toLowerCase()),
        internalLinkZoneName: "pdp:cross-sell:kohler professional services",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    page.cart = {
        cartID: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.id
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const addAnalyticsForSelectionDropdown = (value, dropdownName, productInfo)=>{
    const eventInfo = getEventInfo((dropdownName === null || dropdownName === void 0 ? void 0 : dropdownName.toLowerCase()) + ":dropdown", true);
    eventInfo.internalLinkName = "".concat(value === null || value === void 0 ? void 0 : value.toLowerCase(), ":applied");
    eventInfo.internalLinkType = "pdp:dropdown:".concat(dropdownName === null || dropdownName === void 0 ? void 0 : dropdownName.toLowerCase());
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const addDataLayerForConfigurationExapandState = (title, accordianState, productInfo)=>{
    const eventInfo = getEventInfo("select configurations", true, null, accordianState);
    eventInfo.internalLinkType = "pdp:".concat(title);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const getBreadcrumbEventInfo = function() {
    let internalLinkName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", link = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref;
    return {
        eventAction: "pdp:breadcrumb",
        eventName: "pdp:breadcrumb",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeTextForAnalytics)(internalLinkName),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:breadcrumb",
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: link ? (((ref = String(link)) === null || ref === void 0 ? void 0 : ref.indexOf("http")) === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
};
const getWidgetEventInfo = (retailer)=>({
        clickInternalLinks: "true",
        eventAction: "pdp:product details:buy now",
        eventMsg: "n/a",
        eventName: "pdp:product details:buy now",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(retailer, "-buy now"),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:buy now",
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:product details"
    });
const addBuyBtnAnalytics = (e, retailer)=>{
    e.preventDefault();
    e.stopPropagation();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = getWidgetEventInfo(retailer);
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const getOfferEventInfo = (href)=>({
        clickInternalLinks: "true",
        internalLinkPosition: "pdp link",
        internalLinkZoneName: "pdp",
        internalLinkURL: "<<".concat(href, ">>"),
        internalLinkName: "Get Extra 15% off & No Cost EMI for 3/6 months",
        eventName: "discount offer",
        internalLinkType: "pdp:offer",
        eventType: "click",
        eventAction: "offer click"
    });
const offerClickEventAnalytics = (e)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const href = window.location.href;
    const eventInfo = getOfferEventInfo(href);
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};


/***/ }),

/***/ 44753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ getProfileData; },
/* harmony export */   "B8": function() { return /* binding */ removeCartItem; },
/* harmony export */   "ES": function() { return /* binding */ setCustomerEmail; },
/* harmony export */   "HZ": function() { return /* binding */ scrollToError; },
/* harmony export */   "Hy": function() { return /* binding */ removeLineItems; },
/* harmony export */   "OA": function() { return /* binding */ getProductsById; },
/* harmony export */   "Qi": function() { return /* binding */ getShippingDetails; },
/* harmony export */   "V7": function() { return /* binding */ breakBundleItem; },
/* harmony export */   "WN": function() { return /* binding */ removeInstallItems; },
/* harmony export */   "_S": function() { return /* binding */ calculateInventoryStatus; },
/* harmony export */   "_o": function() { return /* binding */ getInventoryErrorMessage; },
/* harmony export */   "aJ": function() { return /* binding */ clearCartFromStore; },
/* harmony export */   "ag": function() { return /* binding */ getInventoryStatus; },
/* harmony export */   "c5": function() { return /* binding */ getETA; },
/* harmony export */   "dM": function() { return /* binding */ getTotalInclusiveTax; },
/* harmony export */   "jE": function() { return /* binding */ getPromoCodeList; },
/* harmony export */   "nc": function() { return /* binding */ setShippingAddress; },
/* harmony export */   "pf": function() { return /* binding */ getPincode; },
/* harmony export */   "q1": function() { return /* binding */ checkInventory; },
/* harmony export */   "vC": function() { return /* binding */ getMessageStatus; },
/* harmony export */   "wC": function() { return /* binding */ setBillingAddress; }
/* harmony export */ });
/* unused harmony exports deleteFromCart, updateProductDetailToStore */
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45094);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46201);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60475);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73350);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34326);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11310);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_removeCart__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3783);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33273);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88751);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55111);
/* harmony import */ var _utils_prerender__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61150);













const setShippingAddress = async (data, errorCb)=>{
    if (data.postalCode && data.postalCode.trim() !== "") {
        var ref, ref1, ref2;
        const address = {
            postalCode: (ref = data.postalCode) === null || ref === void 0 ? void 0 : ref.trim(),
            region: (ref1 = data.state) === null || ref1 === void 0 ? void 0 : ref1.trim(),
            country: (ref2 = data.country) === null || ref2 === void 0 ? void 0 : ref2.trim()
        };
        const { firstName , lastName , streetName , streetNumber , city , email , phone  } = data;
        if (firstName) address.firstName = firstName.trim();
        if (lastName) address.lastName = lastName.trim();
        if (streetName) address.streetName = streetName.trim();
        if (streetNumber) address.streetNumber = streetNumber.trim();
        if (city) address.city = city === null || city === void 0 ? void 0 : city.trim();
        if (email) address.email = email.trim().toLowerCase();
        if (phone) address.phone = phone.trim();
        const actions = [
            {
                action: "setShippingAddress",
                address: address
            }
        ];
        const payload = {
            actions: actions
        };
        return actions;
    }
};
const setBillingAddress = async function(data, cb, needAnalytics, errorCb) {
    let extraActions = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [];
    var ref, ref1;
    const { user ={}  } = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : ref.auth;
    const isIscUser = (user === null || user === void 0 ? void 0 : (ref1 = user.persona) === null || ref1 === void 0 ? void 0 : ref1.includes("IN_Kohler_ISC")) || false;
    if (data.postalCode && data.postalCode.trim() !== "") {
        var ref2, ref3, ref4, ref5, ref6;
        const address = {
            postalCode: (ref2 = data.postalCode) === null || ref2 === void 0 ? void 0 : ref2.trim(),
            region: (ref3 = data.state) === null || ref3 === void 0 ? void 0 : ref3.trim(),
            country: (ref4 = data.country) === null || ref4 === void 0 ? void 0 : ref4.trim()
        };
        const cart = (ref5 = _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.cart) === null || ref6 === void 0 ? void 0 : ref6.cart;
        const { firstName , lastName , streetName , streetNumber , city , email , phone  } = data;
        if (firstName) address.firstName = firstName.trim();
        if (lastName) address.lastName = lastName.trim();
        if (streetName) address.streetName = streetName.trim();
        if (streetNumber) address.streetNumber = streetNumber.trim();
        if (city) address.city = city === null || city === void 0 ? void 0 : city.trim();
        if (email) address.email = email.trim().toLowerCase();
        if (phone) address.phone = phone.trim();
        const actions = [
            {
                action: "setBillingAddress",
                address: address
            },
            {
                action: "calculateTax"
            }
        ];
        if (user === null || user === void 0 ? void 0 : user.koc) {
            actions.push({
                action: "setCustomType",
                type: {
                    key: "order",
                    typeId: "type"
                },
                fields: {
                    CSRAssociateId: user === null || user === void 0 ? void 0 : user.koc,
                    orderType: "ISC"
                }
            });
        }
        if (isIscUser && (!cart.customerEmail || (cart === null || cart === void 0 ? void 0 : cart.customerEmail) === "")) {
            actions.push({
                action: "setCustomerEmail",
                email: address.email
            });
        }
        if (extraActions.length) {
            actions.push(...extraActions);
        }
        const payload = {
            actions: actions
        };
        await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .shipmentUpdate */ .NM)(payload)).unwrap().then(async (res)=>{
            if ((res === null || res === void 0 ? void 0 : res.type) === "Cart" && res.lineItems.length > 0) {
                await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
                const lineItems = res.lineItems || [];
                const customLineItems = res.customLineItems || [];
                const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_7__/* .getQuantityCount */ .PW)([
                    ...lineItems,
                    ...customLineItems
                ]);
                _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(payload));
                // getShippingMethods()
                cb && cb(address.postalCode, "success");
                needAnalytics && needAnalytics("success");
            } else {
                if (!phone) {
                    cb && cb(address.postalCode, "failure", "no items to ship in cart");
                }
            }
        }).catch((error)=>{
            errorCb && errorCb(error);
            if (!phone) {
                cb && cb(address.postalCode, "failure", "failed to set shipping address.");
            }
        });
    }
};
const getProfileData = async function() {
    let errorMsg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    let profile = {};
    try {
        const res = await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_2__/* .getProfile */ .Ai)());
        if (res && res.data) {
            var ref, ref1, ref2, ref3;
            localStorage.setItem("profile-version", (ref = res.data) === null || ref === void 0 ? void 0 : ref.version);
            profile = res.data;
            profile.postalCode = (ref1 = profile === null || profile === void 0 ? void 0 : profile.addresses[0]) === null || ref1 === void 0 ? void 0 : ref1.postalCode;
            const profileAddr = profile === null || profile === void 0 ? void 0 : (ref2 = profile.addresses) === null || ref2 === void 0 ? void 0 : ref2.find((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) === "Profile";
            });
            profile.profileAddrId = profileAddr === null || profileAddr === void 0 ? void 0 : profileAddr.id;
            profile.addresses = profile === null || profile === void 0 ? void 0 : (ref3 = profile.addresses) === null || ref3 === void 0 ? void 0 : ref3.filter((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
            });
            let addresses = profile === null || profile === void 0 ? void 0 : profile.addresses;
            if (profile === null || profile === void 0 ? void 0 : profile.defaultShippingAddressId) {
                const index = addresses.findIndex((item)=>item.id === profile.defaultShippingAddressId);
                addresses = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.arrayMove)(profile === null || profile === void 0 ? void 0 : profile.addresses, index, 0);
            }
            profile.addresses = addresses;
        }
    } catch (err) {
        errorMsg && _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__/* .showToast */ .CF)({
            message: errorMsg,
            isVisible: true
        }));
    }
    return profile;
};
const removeCartItem = async function(data) {
    let cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, isBundleParent = arguments.length > 2 ? arguments[2] : void 0, setLoading = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{}, setLoadingText = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : ()=>{};
    var ref, ref1;
    setLoadingText("Loading...");
    setLoading(true);
    let payload = [];
    const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const buildRemoveAction = (data)=>{
        var ref;
        const { isInstallService , installServiceName , isInstallItem  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.getProductDetails)(cart, data === null || data === void 0 ? void 0 : data.sku, data === null || data === void 0 ? void 0 : data.isBundleParent);
        const installServiceData = cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.find((item)=>{
            var ref, ref1;
            return item.variant.sku === installServiceName && (item === null || item === void 0 ? void 0 : (ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.associatedProduct) === data.sku;
        });
        const tempData = isInstallService && installServiceData ? [
            data,
            installServiceData
        ] : data;
        const { shippingAddress: { postalCode: postalCode1 = ""  } = {}  } = cart;
        if (!Array.isArray(tempData)) {
            payload.push(...(0,_utils_removeCart__WEBPACK_IMPORTED_MODULE_10__/* .removeFromCart */ .h2)(tempData));
            if (isInstallItem) {
                if (data === null || data === void 0 ? void 0 : data.productData) {
                    var ref1;
                    const { installServiceName: installServiceName1 , lineItemId: productLineItemId , warehouses , installServiceQty  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.getProductDetails)(cart, data === null || data === void 0 ? void 0 : (ref1 = data.productData) === null || ref1 === void 0 ? void 0 : ref1.sku);
                    const currentInstallationQty = installServiceQty - (data === null || data === void 0 ? void 0 : data.quantity);
                    if (currentInstallationQty > 0) {
                        payload.push({
                            action: "setLineItemCustomType",
                            lineItemId: productLineItemId,
                            type: {
                                key: "cartLineItemAdditionalInfo",
                                typeId: "type"
                            },
                            fields: {
                                associatedService: installServiceName1,
                                associatedServiceQty: installServiceQty - (data === null || data === void 0 ? void 0 : data.quantity),
                                warehouses
                            }
                        });
                    } else {
                        payload.push({
                            action: "setLineItemCustomType",
                            lineItemId: productLineItemId,
                            type: {
                                key: "cartLineItemAdditionalInfo",
                                typeId: "type"
                            },
                            fields: {
                                warehouses
                            }
                        });
                    }
                }
            }
        } else {
            payload.push(...(0,_utils_removeCart__WEBPACK_IMPORTED_MODULE_10__/* .setRemoveCartPayload */ .$D)(tempData));
        }
    };
    if (Array.isArray(data)) {
        data.forEach((item)=>buildRemoveAction(item));
    } else {
        buildRemoveAction(data);
    }
    payload.push({
        action: "calculateTax"
    });
    const body = {
        actions: payload
    };
    await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .removeFromCartLineItem */ .Z5)(body)).unwrap().then((res)=>{
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
        const lineItems = res.lineItems || [];
        const customLineItems = res.customLineItems || [];
        const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_7__/* .getQuantityCount */ .PW)([
            ...lineItems,
            ...customLineItems
        ]);
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(payload));
        if (res.lineItems.length > 0) {
            if (postalCode) {
                // getShippingMethods()
                _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setRemoveItemId */ .Cf)(data === null || data === void 0 ? void 0 : data.id));
            }
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setRemoveItemId */ .Cf)(data === null || data === void 0 ? void 0 : data.id));
        } else {
            deleteFromCart(cb);
        }
    }).catch((ex)=>{
        console.log(ex);
    }).finally(()=>{
        (0,_utils_prerender__WEBPACK_IMPORTED_MODULE_11__/* .cartPrerender */ .L)();
        setLoading(false);
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCardStatus */ .YZ)(false));
        setLoadingText(null);
    });
};
const breakBundleItem = async (id)=>{
    await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .breakBundle */ .bs)(id)).unwrap().then((res)=>{
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCardStatus */ .YZ)(false));
    }).catch((err)=>console.log(err));
};
const removeLineItems = async function(lineItems) {
    let productData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref, ref1;
    const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const { id ="" , version =0 , lineItems: cartItems  } = cart;
    const actions = [];
    lineItems.forEach((item)=>{
        var ref, ref1;
        const isInstallItem = ((ref1 = Object === null || Object === void 0 ? void 0 : Object.entries(item === null || item === void 0 ? void 0 : (ref = item.custom) === null || ref === void 0 ? void 0 : ref.fields)) === null || ref1 === void 0 ? void 0 : ref1.length) === 0;
        if (isInstallItem) {
            if (productData) {
                var ref2, ref3, ref4, ref5, ref6;
                const cartItem = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((item)=>{
                    return item.variant.sku === (productData === null || productData === void 0 ? void 0 : productData.sku);
                });
                const productLineItemId = cartItem === null || cartItem === void 0 ? void 0 : cartItem.id;
                const isInstallService = cartItem === null || cartItem === void 0 ? void 0 : (ref2 = cartItem.custom) === null || ref2 === void 0 ? void 0 : ref2.fields.hasOwnProperty("associatedService");
                const installServiceName = isInstallService && (cartItem === null || cartItem === void 0 ? void 0 : (ref3 = cartItem.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.associatedService);
                const warehouses = isInstallService && (cartItem === null || cartItem === void 0 ? void 0 : (ref5 = cartItem.custom) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : ref6.warehouses);
                actions.push({
                    action: "setLineItemCustomType",
                    lineItemId: productLineItemId,
                    type: {
                        key: "cartLineItemAdditionalInfo",
                        typeId: "type"
                    },
                    fields: {
                        associatedService: installServiceName,
                        associatedServiceQty: 0,
                        warehouses
                    }
                });
            }
        }
        actions.push({
            action: item.isComboSku ? "removebundle" : "removeLineItem",
            lineItemId: item.id,
            quantity: item.quantity
        });
    });
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.post */ .TH.post("/cart/items?cartId=".concat(id, "&expand=calculation"), {
        version: version,
        actions: actions
    });
    if (res.status === 200) {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res.data));
        const lineItems1 = res.data.lineItems || [];
        const customLineItems = res.data.customLineItems || [];
        const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_7__/* .getQuantityCount */ .PW)([
            ...lineItems1,
            ...customLineItems
        ]);
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(payload));
        if (![
            ...lineItems1,
            ...customLineItems
        ].length) {
            deleteFromCart();
        }
    }
};
const removeInstallItems = async function() {
    let installItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ref, ref1;
    const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const { id ="" , version =0 , lineItems: cartItems  } = cart;
    const actions = [];
    installItems.forEach((installItem)=>{
        if (installItem.associatedProductSku) {
            var ref, ref1, ref2, ref3, ref4;
            const productCartItem = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((item)=>item.variant.sku === installItem.associatedProductSku);
            const productLineItemId = productCartItem === null || productCartItem === void 0 ? void 0 : productCartItem.id;
            const isInstallService = productCartItem === null || productCartItem === void 0 ? void 0 : (ref = productCartItem.custom) === null || ref === void 0 ? void 0 : ref.fields.hasOwnProperty("associatedService");
            const installServiceName = isInstallService && (productCartItem === null || productCartItem === void 0 ? void 0 : (ref1 = productCartItem.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.associatedService);
            const warehouses = isInstallService && (productCartItem === null || productCartItem === void 0 ? void 0 : (ref3 = productCartItem.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.warehouses);
            actions.push({
                action: "setLineItemCustomType",
                lineItemId: productLineItemId,
                type: {
                    key: "cartLineItemAdditionalInfo",
                    typeId: "type"
                },
                fields: {
                    associatedService: installServiceName,
                    associatedServiceQty: 0,
                    warehouses
                }
            });
        }
        actions.push({
            action: installItem.isComboSku ? "removebundle" : "removeLineItem",
            lineItemId: installItem.id,
            quantity: installItem.quantity
        });
    });
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.post */ .TH.post("/cart/items?cartId=".concat(id, "&expand=calculation"), {
        version: version,
        actions: actions
    });
    if (res.status === 200) {
        await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res.data));
        const lineItems = res.data.lineItems || [];
        const customLineItems = res.data.customLineItems || [];
        const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_7__/* .getQuantityCount */ .PW)([
            ...lineItems,
            ...customLineItems
        ]);
        await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(payload));
    }
};
const clearCartFromStore = function() {
    let email = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref, ref1;
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)({
        lineItems: []
    }));
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setNoshipping */ .qT)([]));
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(0));
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setShipping */ .YO)([]));
    const cartPayload = {
        currency: "INR"
    };
    const { user ={}  } = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : ref.auth;
    const isIscUser = (user === null || user === void 0 ? void 0 : (ref1 = user.persona) === null || ref1 === void 0 ? void 0 : ref1.includes("IN_Kohler_ISC")) || false;
    if (!isIscUser) {
        cartPayload.customerEmail = email;
    }
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .createCart */ .Bk)(cartPayload));
};
const scrollToError = function() {
    let fromLink = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const section = Array.from(document.querySelectorAll('[id^="scroll-error"]'));
    if (fromLink) {
        const sectionTop = section[0].offsetTop - 500;
        window.scrollTo({
            top: sectionTop,
            behavior: "smooth"
        });
        return;
    }
    if (section.length > 0) {
        const selectedSection = section.filter((sel)=>{
            return !sel.id.includes(id);
        });
        if (selectedSection.length > 0) {
            const sectionTop1 = selectedSection[0].offsetTop - 500;
            window.scrollTo({
                top: sectionTop1,
                behavior: "smooth"
            });
            return;
        }
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setRemoveItemId */ .Cf)(""));
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        return;
    }
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};
const deleteFromCart = async (cb)=>{
    await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .deleteCart */ .al)()).unwrap().then((res)=>{
        if (res) {
            cb && cb("success", null, res ? res : {});
            clearCartFromStore();
            const cartPayload = {
                currency: "INR"
            };
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .createCart */ .Bk)(cartPayload));
        }
    }).catch(()=>{
        cb && cb("failure", "failed to empty your cart.");
    });
};
const getProductsById = async (ids)=>{
    let query = "";
    ids.forEach((id, i)=>{
        query += '"'.concat(id, '"');
        if (i + 1 !== ids.length) query += ", ";
    });
    try {
        const response = await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .recentlyViewed */ .er)(query)).unwrap().then((res)=>{
            if (res === null || res === void 0 ? void 0 : res.results) {
                return res.results;
            }
        });
        if (response) return response;
    } catch (err) {
        console.error("Failed to fetch product details", err);
    }
    return [];
};
const getShippingDetails = async ()=>{
    return new Promise(async (resolve, reject)=>{
        var ref, ref1;
        const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
        const shippingDetails = {
            "shipping-details": {
                results: []
            },
            shippingCost: true
        };
        const customLineItems = (cart === null || cart === void 0 ? void 0 : cart.customLineItems) || [];
        const lineItems = (cart === null || cart === void 0 ? void 0 : cart.lineItems) || [];
        const items = [
            ...customLineItems,
            ...lineItems
        ];
        const results = items.filter((item)=>{
            var ref, ref1, ref2, ref3, ref4;
            const productCategory = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.attributes.find((attr)=>attr.name === "ProductLocalCategory"), "value", "");
            return ((ref1 = item.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.isBundleChildItem) && productCategory === _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .INSTALL_SERVICES */ ._F || !((ref3 = item.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.isBundleChildItem);
        }).map((param)=>{
            let { variant , id  } = param;
            return {
                type: "Parcel",
                tiers: [
                    {
                        name: "Standard",
                        key: "Regular",
                        currencyCode: "IN"
                    }
                ],
                sku: variant === null || variant === void 0 ? void 0 : variant.sku,
                lineItemId: id
            };
        });
        shippingDetails["shipping-details"]["results"] = results;
        if (results) {
            resolve(shippingDetails);
        } else {
            reject(new Error("Cannot ship to your location"));
        }
    });
};
const updateProductDetailToStore = (response)=>{
    var ref, ref1, ref2, ref3;
    let validProducts = [];
    let inValidProducts = [];
    validProducts = (ref = response["shipping-details"]) === null || ref === void 0 ? void 0 : (ref1 = ref.results) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>!item.warningMessage);
    inValidProducts = (ref2 = response["shipping-details"]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.results) === null || ref3 === void 0 ? void 0 : ref3.filter((item)=>item.warningMessage);
    store.dispatch(setShipping(validProducts));
    store.dispatch(setNoshipping(inValidProducts));
};
const getMessageStatus = (info)=>{
    const { data , email , hideAlerts , i18n , checkoutMode , isMobile , alert ={}  } = info;
    if (data.cancelled || email || !hideAlerts) {
        if (isMobile) {
            if (alert.show) {
                return true;
            } else if (!alert.show && data.outOfStock) {
                return true;
            } else if (!alert.show && !data.outOfStock && data.noShipping) {
                return true;
            } else if (data.category !== "Install Services" && data.category !== "Design Services") {
                if (data.backOrder && data.leadTime && data.quantity > data.availableQty) {
                    return true;
                } else if (!alert.show) {
                    if (data.outOfStock || data.noShipping) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            } else return false;
        } else {
            return true;
        }
    } else if (!data.cancelled && hideAlerts && data.backOrder && data.leadTime && data.quantity > data.availableQty && i18n.backOrderMssg) {
        return true;
    } else if (!checkoutMode && !isMobile) {
        return true;
    } else {
        return false;
    }
};
const getPincode = async ()=>{
    try {
        const getCookieValue = (name)=>{
            var ref;
            return ((ref = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
        };
        return getCookieValue("pincode");
    } catch (e) {
        console.log(e);
    }
};
const checkInventory = async function(isCheckout, pin) {
    let updateCartVersion = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    try {
        var ref, ref1;
        let inventoryData = {};
        const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
        const pincode = pin !== null && pin !== void 0 ? pin : await getPincode();
        const body = {
            version: cart === null || cart === void 0 ? void 0 : cart.version,
            actions: [
                {
                    action: "checkInventory"
                }
            ]
        };
        if (pincode) {
            var ref2, ref3;
            const { data , data: { newLineItems =[] , version , lineItems =[]  }  } = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.post */ .TH.post("/cart/items?cartId=".concat(cart === null || cart === void 0 ? void 0 : cart.id, "&expand=calculation&pincode=").concat(pincode), body);
            const itemId = (ref2 = _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.cart) === null || ref3 === void 0 ? void 0 : ref3.itemId;
            if (itemId && itemId !== "") scrollToError(false, itemId);
            if (updateCartVersion && version) {
                await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setVersion */ .xO)(version));
            // await store.dispatch(setCart(data))
            }
            if (isCheckout) {
                return {
                    inventoryItems: newLineItems,
                    lineItems
                };
            } else {
                newLineItems === null || newLineItems === void 0 ? void 0 : newLineItems.map((param)=>{
                    let { error , latestInventory , sku , isParentQtyFullfilled  } = param;
                    if (error && (latestInventory === null || latestInventory === void 0 ? void 0 : latestInventory.length) === 0) {
                        inventoryData[sku] = 0;
                    } else {
                        if (!isParentQtyFullfilled) {
                            const availableQty = latestInventory === null || latestInventory === void 0 ? void 0 : latestInventory.reduce((acc, curr)=>acc + curr.availableQuantity, 0);
                            inventoryData[sku] = availableQty;
                        }
                    }
                });
                return {
                    inventoryData,
                    newLineItems
                };
            }
        }
    } catch (e) {
        console.log(e);
    }
};
async function getETA(sku, mastervariantkey, quantity, postalCode1) {
    let isReturnResponse = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, isBundle = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, handleError = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : ()=>{};
    try {
        var ref;
        const pincode = postalCode1 || await getPincode();
        const payload = {
            pincode,
            qty: quantity
        };
        if (isBundle) {
            payload.masterKey = sku;
            payload.parentSKU = sku;
        } else {
            payload.mastervariantkey = mastervariantkey;
            payload.sku = sku;
        }
        const data = await (0,_utils_cart__WEBPACK_IMPORTED_MODULE_7__/* .getETACached */ .X3)(isBundle, payload);
        if (isReturnResponse) {
            var ref1;
            return (ref1 = data.result) === null || ref1 === void 0 ? void 0 : ref1.data;
        }
        if (isBundle) {
            var ref2;
            if (data.status === "fail") {
                handleError();
                return;
            }
            return [
                JSON.stringify((ref2 = data.result) === null || ref2 === void 0 ? void 0 : ref2.data)
            ];
        }
        const { result: { data: { eta ={} , warehouse =[]  } = {}  } = {}  } = data;
        let wareHouse;
        if (((ref = Object.keys(eta)) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            if (warehouse === null || warehouse === void 0 ? void 0 : warehouse.length) {
                wareHouse = [
                    JSON.stringify(warehouse)
                ];
            }
        }
        return wareHouse;
    } catch (e) {
        console.log(e);
        throw new Error("Failed fetching ETA");
    }
}
const getTotalInclusiveTax = ()=>{
    var ref, ref1;
    const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    let totalTax = 0;
    let isError = false;
    try {
        cart === null || cart === void 0 ? void 0 : cart.lineItems.forEach((items)=>{
            var ref;
            const currentLineItemCustomFields = items === null || items === void 0 ? void 0 : (ref = items.custom) === null || ref === void 0 ? void 0 : ref.fields;
            if (currentLineItemCustomFields && "taxAmount" in currentLineItemCustomFields) {
                totalTax += Number(currentLineItemCustomFields.taxAmount);
            } else if (Object.keys(currentLineItemCustomFields).length !== 0) {
                isError = true;
            }
        });
    } catch (error) {
        isError = true;
    }
    return isError ? null : totalTax;
};
const calculateInventoryStatus = (newLineItems)=>{
    let installationError = false;
    let stockData = [];
    let nonDeliverableData = [];
    let outOfStockData = [];
    let installationServiceData = [];
    stockData = newLineItems.map((param)=>{
        let { isParentQtyFullfilled , sku , error , installationService , lineItemId , isOutOfStock , isNonDeliverable  } = param;
        if (error) {
            let associatedServiceSku = "", associatedServiceId = "";
            if (installationService && Object.keys(installationService).length) {
                if (!installationService.isInstallation) {
                    associatedServiceSku = installationService === null || installationService === void 0 ? void 0 : installationService.name;
                    associatedServiceId = installationService === null || installationService === void 0 ? void 0 : installationService.associatedInstallServiceLineItemId;
                }
            }
            if (isNonDeliverable) {
                nonDeliverableData.push({
                    sku,
                    id: lineItemId
                });
                if (associatedServiceSku) {
                    nonDeliverableData.push({
                        sku: associatedServiceSku,
                        id: associatedServiceId
                    });
                }
            } else if (isOutOfStock) {
                outOfStockData.push({
                    sku,
                    id: lineItemId
                });
                if (associatedServiceSku) {
                    outOfStockData.push({
                        sku: associatedServiceSku,
                        id: associatedServiceId
                    });
                }
            }
            return false;
        } else {
            if (isParentQtyFullfilled) {
                var ref, ref1, ref2, ref3;
                const cart = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState().cart.cart;
                const cartItem = (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.find((item)=>item.id === lineItemId);
                const hasInstallationAdded = (cartItem === null || cartItem === void 0 ? void 0 : (ref1 = cartItem.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.associatedService) && ((ref3 = cartItem.custom) === null || ref3 === void 0 ? void 0 : ref3.fields.associatedServiceQty);
                if (hasInstallationAdded && installationService && Object.keys(installationService).length) {
                    var ref4;
                    const associatedServiceQty = (ref4 = cartItem.custom) === null || ref4 === void 0 ? void 0 : ref4.fields.associatedServiceQty;
                    const isInstallationAvailable = installationService === null || installationService === void 0 ? void 0 : installationService.isInstallation;
                    installationError = installationError || !isInstallationAvailable;
                    if (!isInstallationAvailable) {
                        installationServiceData.push({
                            id: installationService === null || installationService === void 0 ? void 0 : installationService.associatedInstallServiceLineItemId,
                            sku: installationService.name,
                            userQuantity: associatedServiceQty,
                            associatedProductSku: sku,
                            associatedProductId: cartItem.id
                        });
                    }
                    return isInstallationAvailable;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }
    });
    return {
        stockData,
        nonDeliverableData,
        outOfStockData,
        installationError,
        installationServiceData
    };
};
const getInventoryStatus = function(data, inventoryData) {
    let isInstallService = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const { nonDeliverableData =[] , outOfStockData =[] , installationServiceData =[]  } = inventoryData;
    if (nonDeliverableData.length && nonDeliverableData.some((item)=>item.id === data.id)) {
        return _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .inventoryStatus.NON_DELIVERABLE */ .BB.NON_DELIVERABLE;
    } else if (outOfStockData.length && outOfStockData.some((item)=>item.id === data.id)) {
        return _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .inventoryStatus.OUT_OF_STOCK */ .BB.OUT_OF_STOCK;
    } else if (installationServiceData.some((item)=>isInstallService ? item.id === data.id : item.associatedProductId === data.id)) {
        return _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .inventoryStatus.INSTALLATION_NOT_AVAILABLE */ .BB.INSTALLATION_NOT_AVAILABLE;
    }
    return "";
};
const getInventoryErrorMessage = function(status, i18n) {
    let isInstallService = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    switch(status){
        case _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .inventoryStatus.NON_DELIVERABLE */ .BB.NON_DELIVERABLE:
            return "".concat(i18n.nonDeliverableMsg, " ").concat(i18n.removeFromCart);
        case _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .inventoryStatus.OUT_OF_STOCK */ .BB.OUT_OF_STOCK:
            return i18n.outOfStock;
        case _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .inventoryStatus.INSTALLATION_NOT_AVAILABLE */ .BB.INSTALLATION_NOT_AVAILABLE:
            if (isInstallService) {
                return "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.installServiceNotAvailable, " ").concat(i18n.removeFromCart);
            }
            return i18n.installServiceNotAvailable;
        default:
            return "";
    }
};
const getPromoCodeList = async (cartId)=>{
    try {
        const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_9__.getCartEndPoint, "&cartId=").concat(cartId, "&discountCodeList=true"));
        return data;
    } catch (e) {
        console.log(e);
    }
};
const setCustomerEmail = (email, cid, koc, cb)=>{
    const payload = {
        actions: [
            {
                action: "setCustomerEmail",
                email: email
            },
            {
                action: "setCustomerId",
                customerId: cid
            }
        ]
    };
    if (koc) {
        payload.actions.push({
            action: "setCustomType",
            type: {
                key: "order",
                typeId: "type"
            },
            fields: {
                CSRAssociateId: koc,
                orderType: "ISC"
            }
        });
    }
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .shipmentUpdate */ .NM)(payload)).unwrap().then((res)=>{
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
        if (cb) {
            cb();
        }
    }).catch((error)=>console.log(error));
};



/***/ }),

/***/ 65875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ getChildItemsCount; },
/* harmony export */   "IC": function() { return /* binding */ formatMobileNumber; },
/* harmony export */   "KY": function() { return /* binding */ formatName; },
/* harmony export */   "Tg": function() { return /* binding */ formatAddress; },
/* harmony export */   "c0": function() { return /* binding */ getCartCount; },
/* harmony export */   "u1": function() { return /* binding */ isBundleWithInstallation; }
/* harmony export */ });
/* unused harmony export handleZipChange */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_location__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97433);
/* harmony import */ var _components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44753);




const handleZipChange = async (zip)=>{
    const res = await getLocationUsingZipcode(zip);
    const addr = _get(res === null || res === void 0 ? void 0 : res.data, "resourceSets[0].resources[0].address", {});
    var _adminDistrict, _countryRegionIso2;
    const payload = {
        postalCode: zip,
        state: (_adminDistrict = addr.adminDistrict) !== null && _adminDistrict !== void 0 ? _adminDistrict : "",
        country: (_countryRegionIso2 = addr.countryRegionIso2) !== null && _countryRegionIso2 !== void 0 ? _countryRegionIso2 : ""
    };
    await setShippingAddress(payload);
    localStorage.setItem("shippingZip", zip);
};
const formatMobileNumber = function() {
    let inputNumber = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    let resultantNumberArray = [];
    let error = null;
    try {
        const reversedArray = inputNumber.split("").reverse().filter((digit)=>digit.trim());
        reversedArray.forEach((digit, index)=>{
            resultantNumberArray.push(digit);
            if (index !== 0 && index % 3 === 0 && index !== reversedArray.length - 1) {
                resultantNumberArray.push(" ");
            }
        });
    } catch (err) {
        error = err;
        console.error(err);
    } finally{
        return !error ? resultantNumberArray.reverse().join("") : inputNumber;
    }
};
const formatName = (address)=>{
    const { firstName ="" , lastName =""  } = address;
    let name = "";
    if (firstName) {
        name = name.concat(firstName);
    }
    if (lastName) {
        name = name.concat(" ", lastName);
    }
    return name;
};
const formatAddress = (address)=>{
    let formattedAddress = null;
    const { streetName ="" , postalCode ="" , city ="" , region ="" , country ="IN"  } = address;
    const name = formatName(address);
    formattedAddress = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            name ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    name,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                ]
            }) : null,
            streetName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: streetName + ", "
            }) : null,
            region ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    region,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                ]
            }) : null,
            city ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: city + ", "
            }) : null,
            country ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: country + " "
            }) : null,
            postalCode ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    postalCode,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                ]
            }) : null
        ]
    });
    return formattedAddress;
};
const isBundleWithInstallation = (bundleSku, lineItems)=>{
    return Boolean(lineItems.find((item)=>{
        var ref;
        if (((ref = item.custom) === null || ref === void 0 ? void 0 : ref.fields.parentBundleSku) === bundleSku) {
            var ref1, ref2;
            const category = (ref1 = item.variant) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.find((attr)=>attr.name === "ProductLocalCategory");
            return (category === null || category === void 0 ? void 0 : category.value) === "Install Services";
        }
    }));
};
const getChildItemsCount = (lineItems)=>{
    const items = lineItems.filter((item)=>item.category !== "Install Services");
    return items.length;
};
const getCartCount = (cartItems)=>{
    let count = 0;
    cartItems === null || cartItems === void 0 ? void 0 : cartItems.map((item)=>{
        if (!item.isBundleChildItem || item.category === "Install Services") count += item.quantity;
    });
    return count;
};


/***/ }),

/***/ 41600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageLoader_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./public/icons/page-loader.svg
/* harmony default export */ var page_loader = ({"src":"/_next/static/media/page-loader.46514bdc.svg","height":40,"width":40});
// EXTERNAL MODULE: ./components/core/PageLoader/index.module.scss
var index_module = __webpack_require__(20889);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/core/PageLoader/PageLoader.jsx






const PageLoader = (param)=>{
    let { loading =false , initialLoader =false , showLoadingText =true , cartLoading =false , ctnDeliverLoading =false , isCartMergeLoading =false , isOrderDetails =false , text =null , loadingMessage =null  } = param;
    const RECALCULATING_TEXT = "Recalculating delivery timelines...";
    let loadingStates = showLoadingText ? [
        "".concat(ctnDeliverLoading ? RECALCULATING_TEXT : isOrderDetails ? "Fetching your order details..." : "Loading...")
    ] : [
        ""
    ];
    (0,react.useEffect)(()=>{
        const htmlElem = document.getElementsByTagName("html")[0];
        if (loading) {
            document.body.style["touch-action"] = "none";
            htmlElem.style["touch-action"] = "none";
        } else {
            document.body.style.removeProperty("touch-action");
            htmlElem.style.removeProperty("touch-action");
        }
        return ()=>{
            document.body.style.removeProperty("touch-action");
            htmlElem.style.removeProperty("touch-action");
        };
    }, [
        loading
    ]);
    const EMPTY_PIXEL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const [src, setSrc] = (0,react.useState)(EMPTY_PIXEL);
    const [currentLoadingState, setCurrentLoadingState] = (0,react.useState)(loadingStates[0]);
    (0,react.useEffect)(()=>{
        document.addEventListener("set-loader-text", (e)=>{
            console.log("set-loader-text", e.detail);
            setCurrentLoadingState(e.detail);
        });
        return document.removeEventListener("set-loader-text", (e)=>{
            setCurrentLoadingState(e.detail);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (showLoadingText && lib/* isMobile */.tq) {
            setSrc(EMPTY_PIXEL);
        } else {
            setSrc(page_loader.src);
        }
    }, [
        lib/* isMobile */.tq
    ]);
    const shuffle = (0,react.useCallback)(()=>{
        const index = Math.floor(Math.random() * loadingStates.length);
        setCurrentLoadingState(loadingStates[index]);
    }, []);
    if (ctnDeliverLoading) {
        loadingStates = [
            RECALCULATING_TEXT
        ];
    }
    (0,react.useEffect)(()=>{
        if (ctnDeliverLoading) {
            loadingStates = [
                RECALCULATING_TEXT
            ];
            setCurrentLoadingState(RECALCULATING_TEXT);
        }
    }, [
        ctnDeliverLoading
    ]);
    // useEffect(() => {
    //   const intervalID = setInterval(shuffle, 5000)
    //   return () => clearInterval(intervalID)
    // }, [shuffle])
    return loading || initialLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).pageLoaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "page-loader",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "page-loader__spinner",
                    src: src,
                    alt: "",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "page-loader__message",
                    children: cartLoading ? text !== null && text !== void 0 ? text : "Checking item availability..." : isCartMergeLoading ? "Preparing your cart..." : loadingMessage !== null && loadingMessage !== void 0 ? loadingMessage : currentLoadingState
                })
            ]
        })
    }) : null;
};
PageLoader.propTypes = {
    loading: (prop_types_default()).bool
};
/* harmony default export */ var PageLoader_PageLoader = (PageLoader);


/***/ }),

/***/ 4364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J9": function() { return /* binding */ shareaddToCart; },
/* harmony export */   "gO": function() { return /* binding */ getSharedCart; },
/* harmony export */   "uX": function() { return /* binding */ getProductsBySku; },
/* harmony export */   "ze": function() { return /* binding */ getProductDetailsBySku; }
/* harmony export */ });
/* unused harmony export generateCartData */
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45094);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46201);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19514);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33273);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88751);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34326);







const { productBySkuEndPoint , shareCartEndPoint , searchPlpEndPoint  } = __webpack_require__(55111);
const getProductsBySku = async (skus)=>{
    let query = "";
    skus.forEach((sku, i)=>{
        query += '"'.concat(sku, '"');
        if (i + 1 !== skus.length) query += ", ";
    });
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(productBySkuEndPoint, "?limit=50&where=masterVariant(sku in (").concat(query, ")) or variants(sku in (").concat(query, "))"));
    if (res && res.data && res.data.results) return res.data.results;
    return [];
};
const getProductDetailsBySku = async (skus, category)=>{
    var ref, ref1;
    let query = "";
    skus.forEach((sku, i)=>{
        query += '"'.concat(sku, '"');
        if (i + 1 !== skus.length) query += ", ";
    });
    let brandName = "kohler-india";
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(searchPlpEndPoint, "?fl=*&q=*:*&rows=10&collections=kohler-india&fq=sku_s:(").concat(query, ")&profilename=profile_").concat(brandName.toLowerCase(), "_PLP_").concat(category));
    if (res && res.data) return res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.docs;
    return [];
};
const getSharedCart = async (id)=>{
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(shareCartEndPoint, "/").concat(id));
    if (res && res.data) return res.data;
    return;
};
const showToastHandler = (msg)=>_store_index__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__/* .showToast */ .CF)({
        message: msg,
        isVisible: true
    }));
const shareaddToCart = async (items, message, callback, cartItems)=>{
    const payload = [];
    items.forEach((product)=>{
        var ref;
        let customObj = {
            type: {
                key: "cartLineItemAdditionalInfo",
                typeId: "type"
            }
        };
        const hasInstallService = product === null || product === void 0 ? void 0 : (ref = product.custom) === null || ref === void 0 ? void 0 : ref.fields.hasOwnProperty("associatedService");
        if (product.backorder) customObj.isBackOrderable = true;
        const isInCart = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((item)=>{
            var ref;
            return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) === (product === null || product === void 0 ? void 0 : product.sku);
        });
        const isInstallServiceInCart = items === null || items === void 0 ? void 0 : items.find((item)=>{
            var ref;
            return (item === null || item === void 0 ? void 0 : item.sku) === (product === null || product === void 0 ? void 0 : (ref = product.custom) === null || ref === void 0 ? void 0 : ref.fields.associatedService);
        });
        const lineItemId = isInCart ? isInCart.id : product.sku;
        if (hasInstallService && isInstallServiceInCart) {
            var ref1, ref2, ref3;
            const installService = items === null || items === void 0 ? void 0 : items.find((item)=>{
                var ref, ref1;
                return (item === null || item === void 0 ? void 0 : item.sku) === (product === null || product === void 0 ? void 0 : (ref = product.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.associatedService);
            });
            const warehouse = product === null || product === void 0 ? void 0 : (ref1 = product.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.warehouses;
            customObj = {
                ...customObj,
                fields: {
                    warehouses: warehouse,
                    associatedService: installService === null || installService === void 0 ? void 0 : installService.sku,
                    associatedServiceQty: (ref3 = product.custom.fields) === null || ref3 === void 0 ? void 0 : ref3.associatedServiceQty
                }
            };
        }
        if (isInCart) {
            var ref4, ref5, ref6;
            const hasCartInstallService = isInCart === null || isInCart === void 0 ? void 0 : (ref4 = isInCart.custom) === null || ref4 === void 0 ? void 0 : ref4.fields.hasOwnProperty("associatedService");
            const isInstallCart = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((item)=>{
                var ref, ref1;
                return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) === (product === null || product === void 0 ? void 0 : (ref1 = product.custom) === null || ref1 === void 0 ? void 0 : ref1.fields.associatedService);
            });
            const warehouse1 = (isInCart === null || isInCart === void 0 ? void 0 : (ref5 = isInCart.custom) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : ref6.warehouses) || JSON.stringify({});
            if (hasCartInstallService && isInstallCart) {
                var ref7;
                payload.push({
                    action: "setLineItemCustomType",
                    lineItemId: lineItemId,
                    type: {
                        key: "cartLineItemAdditionalInfo",
                        typeId: "type"
                    },
                    fields: {
                        warehouses: warehouse1,
                        associatedService: isInstallCart === null || isInstallCart === void 0 ? void 0 : (ref7 = isInstallCart.variant) === null || ref7 === void 0 ? void 0 : ref7.sku,
                        associatedServiceQty: isInCart.quantity + isInstallCart.quantity
                    }
                });
                payload.push({
                    action: "changeLineItemQuantity",
                    lineItemId,
                    quantity: product.quantity + isInCart.quantity
                });
            } else {
                if (hasInstallService) {
                    var ref8, ref9, ref10;
                    const installService1 = items === null || items === void 0 ? void 0 : items.find((item)=>{
                        var ref, ref1;
                        return (item === null || item === void 0 ? void 0 : item.sku) === (product === null || product === void 0 ? void 0 : (ref = product.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.associatedService);
                    });
                    const warehouse2 = (installService1 === null || installService1 === void 0 ? void 0 : (ref8 = installService1.custom) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : ref9.warehouses) || JSON.stringify({});
                    customObj = {
                        ...customObj,
                        fields: {
                            warehouses: warehouse2,
                            associatedService: installService1 === null || installService1 === void 0 ? void 0 : installService1.sku,
                            associatedServiceQty: (ref10 = product.custom.fields) === null || ref10 === void 0 ? void 0 : ref10.associatedServiceQty
                        }
                    };
                    payload.push({
                        action: product.isBundle ? "addBundleItem" : "addLineItem",
                        sku: product.sku,
                        quantity: product.quantity,
                        custom: customObj
                    });
                } else {
                    payload.push({
                        action: product.isBundle ? "addBundleItem" : "addLineItem",
                        sku: product.sku,
                        quantity: product.quantity,
                        custom: customObj
                    });
                }
            }
        } else {
            payload.push({
                action: product.isBundle ? "addBundleItem" : "addLineItem",
                sku: product.sku,
                quantity: product.quantity,
                custom: customObj
            });
        }
    });
    const body = {
        actions: payload
    };
    await _store_index__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
        if (res) {
            _store_index__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCart */ .RV)(res));
            console.log("res", res);
            const lineItems = res.lineItems || [];
            const customLineItems = res.customLineItems || [];
            const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)([
                ...lineItems,
                ...customLineItems
            ]);
            _store_index__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCartCount */ .oJ)(payload));
            if (message) {
                showToastHandler(message);
            }
            if (callback) {
                callback({
                    res
                });
            }
        }
    });
};
const generateCartData = async (arg)=>{
    const currency = await getCurrency();
    const body = {
        currency: "INR"
    };
    let cartData = {};
    const { payload: rsp  } = await store.dispatch(getCart({
        isNotFromCart: arg
    }));
    if ((rsp === null || rsp === void 0 ? void 0 : rsp.error) && (rsp === null || rsp === void 0 ? void 0 : rsp.cartExists) === "false") {
        const { payload  } = await store.dispatch(createCart(body));
        cartData = payload;
    } else {
        var ref, ref1;
        cartData = arg === true ? rsp : rsp === null || rsp === void 0 ? void 0 : (ref = rsp.data) === null || ref === void 0 ? void 0 : (ref1 = ref.me) === null || ref1 === void 0 ? void 0 : ref1.activeCart;
    }
    return cartData;
};


/***/ }),

/***/ 73350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gb": function() { return /* binding */ aemAxiosInstance; },
/* harmony export */   "IT": function() { return /* binding */ aemPreviewAxiosInstance; },
/* harmony export */   "TH": function() { return /* binding */ apim; },
/* harmony export */   "ab": function() { return /* binding */ getAnonymousToken; },
/* harmony export */   "v0": function() { return /* binding */ aemApimAxiosInstance; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65885);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45094);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46201);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34326);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19514);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);









const token = "".concat(___WEBPACK_IMPORTED_MODULE_1__.authorPreviewUserName, ":").concat(___WEBPACK_IMPORTED_MODULE_1__.authorPreviewPassword);
const encodedToken = Buffer.from(token).toString("base64");
const aemAxiosInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: ___WEBPACK_IMPORTED_MODULE_1__.authorBaseUrl,
    timeout: 10000,
    headers: {
        "Content-type": "application/json",
        KohlerTarget: "AzureApp"
    }
});
const aemApimAxiosInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://www.kohler.co.in/apirequest",
    timeout: 10000,
    headers: {
        "Content-type": "application/json",
        KohlerTarget: "AzureApp",
        "Ocp-Apim-Subscription-Key": process.env.APIM_SUBSCRIPTION_KEY
    }
});
const aemPreviewAxiosInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: ___WEBPACK_IMPORTED_MODULE_1__.authorPreviewBaseUrl,
    timeout: 10000,
    headers: {
        "Content-type": "application/json",
        KohlerTarget: "AzureApp",
        Authorization: "Basic " + encodedToken
    }
});
const apim = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    timeout: 60000,
    headers: {
        "Content-type": "application/json",
        KohlerTarget: "AzureApp"
    }
});
const apimCache = new Map();
//Retry 409
apim.interceptors.response.use((response)=>{
    const cacheKey = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getCacheKey)(response.config);
    apimCache.set(cacheKey, response);
    return response;
}, (error)=>{
    var ref;
    const originalRequest = error.config;
    if (error.response && error.response.status === 409 && !originalRequest._retry && ((ref = originalRequest.url) === null || ref === void 0 ? void 0 : ref.startsWith("/cart/items"))) {
        var ref1, ref2;
        originalRequest._retry = true;
        const latestVersion = (ref1 = _store__WEBPACK_IMPORTED_MODULE_2__/* .store.getState */ .h.getState().cart) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cart) === null || ref2 === void 0 ? void 0 : ref2.version;
        const prevPayload = JSON.parse(originalRequest.data);
        prevPayload.version = latestVersion;
        originalRequest.data = JSON.stringify(prevPayload);
        return axios__WEBPACK_IMPORTED_MODULE_0___default()(originalRequest);
    }
    return Promise.reject(error);
});
//Cache LW Requests
apim.interceptors.request.use((config)=>{
    if (config.url.startsWith("/search/plp") && config.method === "get") {
        const cacheKey = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getCacheKey)(config);
        const cachedResponse = apimCache.get(cacheKey);
        if (cachedResponse) {
            config.adapter = ()=>Promise.resolve({
                    data: cachedResponse.data,
                    status: cachedResponse.status,
                    statusText: cachedResponse.statusText,
                    headers: cachedResponse.headers,
                    config: config
                });
        }
    }
    return config;
});
let validateTokenRequest;
let getAnonymousTokenRequest;
const validateToken = (accessToken, apimHost)=>{
    if (!validateTokenRequest) {
        validateTokenRequest = axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(apimHost).concat(___WEBPACK_IMPORTED_MODULE_1__.validateTokenEndPoint), {}, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(accessToken)
            }
        });
        validateTokenRequest.then(resetValidateTokenRequest, resetValidateTokenRequest);
    }
    return validateTokenRequest;
};
const getAnonymousToken = (apimHost)=>{
    let gId;
    const token = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getAccessToken)();
    gId = token.gId;
    const cookie = new universal_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z();
    cookie.get("commerce_gid") && (gId = cookie.get("commerce_gid"));
    if (!getAnonymousTokenRequest) {
        getAnonymousTokenRequest = axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(apimHost).concat(___WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=guest&channel=india"), null, {
            params: {
                gId: gId
            }
        });
        getAnonymousTokenRequest.then(resetGetAnonymousTokenRequest, resetGetAnonymousTokenRequest);
    }
    return getAnonymousTokenRequest;
};
const resetValidateTokenRequest = ()=>{
    validateTokenRequest = null;
    getAnonymousTokenRequest = null;
};
const resetGetAnonymousTokenRequest = ()=>{
    getAnonymousTokenRequest = null;
    validateTokenRequest = null;
};
apim.interceptors.request.use(async (config)=>{
    var ref, ref1;
    let apimHost = process.env.NEXT_PUBLIC_APIMBASEURL;
    if (apimHost) {
        config.baseURL = apimHost;
    } else {
        var ref2;
        // set apim baseurl from global config
        const configVal = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        apimHost = configVal === null || configVal === void 0 ? void 0 : (ref2 = configVal.general) === null || ref2 === void 0 ? void 0 : ref2.apimHost;
        config.baseURL = apimHost;
    }
    const { token: accessToken = ""  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getAccessToken)();
    const anonymousId = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getAnonymousId)();
    if (accessToken) {
        config.headers.Authorization = "Bearer ".concat(accessToken);
    } else if (window && window.authAccessToken) {
        config.headers.Authorization = "Bearer ".concat(window.authAccessToken);
        window.authAccessToken = "";
    }
    const getNewToken = ()=>{
        return getAnonymousToken(apimHost).then((res)=>{
            const { data: { access_token: accessToken = ""  } = {}  } = res;
            const payload = {
                accessToken
            };
            _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setAuthData */ .A3)(payload));
            config.headers.Authorization = "Bearer ".concat(accessToken);
            return config;
        }).catch((_error)=>{
            return Promise.reject(_error);
        });
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.addPageLoadAnalyticsEvent)();
    const revalidateIn = ((ref = _store__WEBPACK_IMPORTED_MODULE_2__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.revalidate_in) || "";
    const isAfter = moment__WEBPACK_IMPORTED_MODULE_3___default()().isAfter(revalidateIn);
    if (!accessToken) {
        return getNewToken();
    } else if (anonymousId && isAfter) {
        return validateToken(accessToken, apimHost).then((res)=>{
            var ref;
            if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.valid) {
                _store__WEBPACK_IMPORTED_MODULE_2__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_2__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setRevalidateTime */ .iU)());
                return config;
            } else {
                return getNewToken();
            }
        }).catch(()=>{
            return getAnonymousToken(apimHost).then((res)=>{
                const { data: { access_token: accessToken = ""  } = {}  } = res;
                const payload = {
                    accessToken
                };
                _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setAuthData */ .A3)(payload));
                config.headers.Authorization = "Bearer ".concat(accessToken);
                return config;
            }).catch((_error)=>{
                return Promise.reject(_error);
            });
        });
    } else {
        return config;
    }
}, (error)=>{
    return Promise.reject(error);
});
apim.interceptors.response.use(async (res)=>{
    return res;
}, async (error)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    const originalConfig = error.config;
    if (!((ref = _store__WEBPACK_IMPORTED_MODULE_2__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.isAuth) && (error === null || error === void 0 ? void 0 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 401 && !originalConfig._retry && (error.response.data.message === "JWT not present." || error.response.data.message === "Invalid JWT.")) {
        originalConfig._retry = true;
        const { general: { apimHost  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        return getAnonymousToken(apimHost).then((res)=>{
            const { data: { access_token: accessToken = ""  } = {}  } = res;
            const payload = {
                accessToken
            };
            _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setAuthData */ .A3)(payload));
        }).catch((_error)=>{
            return Promise.reject(_error);
        });
    } else if (((error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.url) === null || ref5 === void 0 ? void 0 : ref5.includes(___WEBPACK_IMPORTED_MODULE_1__.shipmentFromCartEndPoint)) || (error === null || error === void 0 ? void 0 : (ref6 = error.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.config) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.url) === null || ref8 === void 0 ? void 0 : ref8.includes(___WEBPACK_IMPORTED_MODULE_1__.shippingCostEndPoint))) && (error === null || error === void 0 ? void 0 : (ref9 = error.response) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.error) === null || ref11 === void 0 ? void 0 : ref11.message) && (error === null || error === void 0 ? void 0 : (ref12 = error.response) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.error) === null || ref14 === void 0 ? void 0 : ref14.sku)) {
        var ref15, ref16, ref17, ref18;
        const productsArray = [];
        error === null || error === void 0 ? void 0 : (ref15 = error.response) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.data) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.error) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.sku) === null || ref18 === void 0 ? void 0 : ref18.forEach((data)=>{
            productsArray.push({
                sku: data
            });
        });
        await _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__/* .setNoshipping */ .qT)(productsArray));
    }
    return Promise.reject(error);
});



/***/ }),

/***/ 19514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ getConfig; },
/* harmony export */   "p": function() { return /* binding */ initConfig; }
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55111);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);


/**
 *
 * @return {{initConfig, getConfig}}
 */ function configuration() {
    let _configurationObj = {};
    const initConfig = async ()=>{
        const urlPath = window.location.pathname;
        const path = "".concat(___WEBPACK_IMPORTED_MODULE_0__.GLOBAL_CONFIGURATION_ENDPOINT, "?path=").concat(___WEBPACK_IMPORTED_MODULE_0__.baseUrl).concat(urlPath, "&caConfig=true");
        var ref;
        _configurationObj = (ref = JSON.parse(localStorage && localStorage.getItem("caConfig"))) !== null && ref !== void 0 ? ref : {
            expireTime: 0
        };
        const currentTime = new Date().getTime();
        if (path && currentTime > _configurationObj.expireTime) {
            var ref1;
            await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance.get */ .Gb.get(path).then((response)=>{
                if (response && response.data) {
                    var ref, ref1, ref2, ref3, ref4;
                    const _backendConfig = response.data;
                    if (_backendConfig === null || _backendConfig === void 0 ? void 0 : (ref = _backendConfig.general) === null || ref === void 0 ? void 0 : ref.isPublish) {
                        const getShortenedUrl = (uUrl)=>{
                            var _shortendPagePath;
                            const shortUrl = (_shortendPagePath = _backendConfig.general.shortendPagePath) !== null && _shortendPagePath !== void 0 ? _shortendPagePath : "";
                            const shortUrlRegEx = new RegExp(shortUrl, "g");
                            const htmlRegExp = new RegExp(".html", "g");
                            return uUrl.replace(shortUrlRegEx, "").replace(htmlRegExp, "");
                        };
                        const pattern = "^(?!.*json)".concat(_backendConfig.general.shortendPagePath, ".*");
                        for(const link in _backendConfig.general){
                            if (({}).hasOwnProperty.call(_backendConfig.general, link)) {
                                const url = "".concat(_backendConfig.general[link]);
                                if (url.match(pattern)) {
                                    if (link !== "shortendPagePath") _backendConfig.general[link] = getShortenedUrl(_backendConfig.general[link]);
                                }
                            }
                        }
                    }
                    _configurationObj = Object.assign(_configurationObj, _backendConfig);
                    _configurationObj.annsacksPDPConfig = (ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.annsacksPDPConfig) === null || ref2 === void 0 ? void 0 : ref2.map;
                    var ref5;
                    _configurationObj.apiEndpoints = (ref5 = (ref3 = response.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.apiEndPointData) === null || ref4 === void 0 ? void 0 : ref4.map) !== null && ref5 !== void 0 ? ref5 : {};
                } else {
                    console.error("Error occurred while fetching Backend Configuration");
                }
            });
            await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance.get */ .Gb.get(___WEBPACK_IMPORTED_MODULE_0__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + ((ref1 = _configurationObj.general) === null || ref1 === void 0 ? void 0 : ref1.plpServletPath)).then((res)=>{
                var ref;
                _configurationObj.plpServletPath = (ref = res.data) === null || ref === void 0 ? void 0 : ref.pdpURLMapping;
                _configurationObj.expireTime = new Date().getTime() + ___WEBPACK_IMPORTED_MODULE_0__.ADD_10_MINUTES;
                if (localStorage) localStorage.setItem("caConfig", JSON.stringify(_configurationObj));
            }).catch((err)=>console.error("Error occurred while fetching PLP Servlet path", err));
        } else {
            console.log("Configuration URL for found");
        }
    };
    const getConfig = async ()=>{
        let configTimer;
        const config = new Promise((resolve)=>{
            if ((_configurationObj === null || _configurationObj === void 0 ? void 0 : _configurationObj.expireTime) === 0) {
                configTimer = setTimeout(()=>resolve(getConfig()), 500);
            } else {
                configTimer && clearTimeout(configTimer);
                resolve(_configurationObj);
            }
        });
        return config;
    };
    return {
        initConfig,
        getConfig
    };
}
const { initConfig , getConfig  } = configuration();


/***/ }),

/***/ 55111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ADDRESS_SUGGESTION_DEFAULT_COUNTRY": function() { return /* reexport */ ADDRESS_SUGGESTION_DEFAULT_COUNTRY; },
  "ADD_10_MINUTES": function() { return /* reexport */ ADD_10_MINUTES; },
  "AFFIRM_SHOP_URL": function() { return /* reexport */ AFFIRM_SHOP_URL; },
  "API_FAILURE_STATUS": function() { return /* reexport */ API_FAILURE_STATUS; },
  "API_SUCCESS_STATUS": function() { return /* reexport */ API_SUCCESS_STATUS; },
  "ARTICLE_CONTENT_END_POINT": function() { return /* reexport */ ARTICLE_CONTENT_END_POINT; },
  "ARTICLE_IMG_END_POINT": function() { return /* reexport */ ARTICLE_IMG_END_POINT; },
  "BAZAAR_VOICE": function() { return /* reexport */ BAZAAR_VOICE; },
  "BROWSE_ALL_STORES": function() { return /* reexport */ BROWSE_ALL_STORES; },
  "BROWSE_ALL_STORES_URL": function() { return /* reexport */ BROWSE_ALL_STORES_URL; },
  "BUYING_GUIDE_ASPATH": function() { return /* reexport */ BUYING_GUIDE_ASPATH; },
  "CART_URL": function() { return /* reexport */ CART_URL; },
  "CHANGE_ACCOUNT_PASSWORD_ENDPOINT": function() { return /* reexport */ CHANGE_ACCOUNT_PASSWORD_ENDPOINT; },
  "CHECKOUT_URL": function() { return /* reexport */ CHECKOUT_URL; },
  "COMPONENT_TYPES": function() { return /* binding */ compTypeUpdates; },
  "CONSTANTS": function() { return /* binding */ constUpdates; },
  "CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT": function() { return /* reexport */ CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT; },
  "CORE_GLOBAL_CONFIG_URL": function() { return /* reexport */ CORE_GLOBAL_CONFIG_URL; },
  "COUNTRY": function() { return /* reexport */ COUNTRY; },
  "CREDIT_NOTE_URL": function() { return /* binding */ CREDIT_NOTE_URL; },
  "DECRYPT_PAYMENT_RESP": function() { return /* binding */ DECRYPT_PAYMENT_RESP; },
  "DEFAULT_CARD_DETAILS_API_PATH": function() { return /* binding */ constants_DEFAULT_CARD_DETAILS_API_PATH; },
  "DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME": function() { return /* reexport */ DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME; },
  "DEFAULT_PRODUCT_COUNT_PLP": function() { return /* reexport */ DEFAULT_PRODUCT_COUNT_PLP; },
  "DEFAULT_SCROLL": function() { return /* reexport */ DEFAULT_SCROLL; },
  "DEFAULT_STORE_DETAILS_API_PATH": function() { return /* reexport */ DEFAULT_STORE_DETAILS_API_PATH; },
  "DEFAULT_TECHNICAL_SPECT_COUNT": function() { return /* reexport */ DEFAULT_TECHNICAL_SPECT_COUNT; },
  "DELETE_ACCOUNT_ENDPOINT": function() { return /* reexport */ DELETE_ACCOUNT_ENDPOINT; },
  "DESKTOP_WIDTH": function() { return /* reexport */ DESKTOP_WIDTH; },
  "DISABLE_SROLL_PATH": function() { return /* reexport */ DISABLE_SROLL_PATH; },
  "DOMAIN": function() { return /* reexport */ DOMAIN; },
  "DOWNLOAD_SPINNER": function() { return /* reexport */ DOWNLOAD_SPINNER; },
  "EDIT_PROFILE_ENDPOINT": function() { return /* reexport */ EDIT_PROFILE_ENDPOINT; },
  "EMBED_TYPE_HTML": function() { return /* reexport */ EMBED_TYPE_HTML; },
  "EMBED_TYPE_SCRIPT": function() { return /* reexport */ EMBED_TYPE_SCRIPT; },
  "EMPTY_FAVORITE_BASE64": function() { return /* reexport */ EMPTY_FAVORITE_BASE64; },
  "EMPTY_PIXEL": function() { return /* reexport */ EMPTY_PIXEL; },
  "ESTIMATED_TOTAL_FOR_NO_COST_EMI": function() { return /* binding */ ESTIMATED_TOTAL_FOR_NO_COST_EMI; },
  "ESTIMATED_TOTAL_FOR_PAN_CONSENT": function() { return /* binding */ ESTIMATED_TOTAL_FOR_PAN_CONSENT; },
  "EXCLUDE_PAGES": function() { return /* reexport */ EXCLUDE_PAGES; },
  "FAQ_PAGE_DATA_URL": function() { return /* reexport */ FAQ_PAGE_DATA_URL; },
  "FEATURE_FLAGS_CHECKOUT_PAYLOAD": function() { return /* reexport */ FEATURE_FLAGS_CHECKOUT_PAYLOAD; },
  "FETCH_PRODUCT_REG_ENDPOINT": function() { return /* reexport */ FETCH_PRODUCT_REG_ENDPOINT; },
  "FINDLOCATIONKEYCODE": function() { return /* reexport */ FINDLOCATIONKEYCODE; },
  "FIND_A_PRO_HASH": function() { return /* reexport */ FIND_A_PRO_HASH; },
  "FIND_A_PRO_PATH": function() { return /* reexport */ FIND_A_PRO_PATH; },
  "FIND_MY_ORDERS_ENDPOINT": function() { return /* binding */ constants_FIND_MY_ORDERS_ENDPOINT; },
  "FIND_MY_ORDERS_ENDPOINT2": function() { return /* binding */ FIND_MY_ORDERS_ENDPOINT2; },
  "FIND_MY_ORDERS_V1_ENDPOINT": function() { return /* reexport */ FIND_MY_ORDERS_V1_ENDPOINT; },
  "FIND_STORE_URL": function() { return /* reexport */ FIND_STORE_URL; },
  "FRAGMENT_TYPES": function() { return /* reexport */ FRAGMENT_TYPES; },
  "FRAUD_CHLLENGE_STATUS": function() { return /* reexport */ FRAUD_CHLLENGE_STATUS; },
  "FREIGHT_SHIPPING_TYPES": function() { return /* reexport */ FREIGHT_SHIPPING_TYPES; },
  "FRIENDS_AND_FAMILY_API_URL_ENDPOINT": function() { return /* reexport */ FRIENDS_AND_FAMILY_API_URL_ENDPOINT; },
  "FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL": function() { return /* reexport */ FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL; },
  "FULL_FAVORITE_BASE64": function() { return /* reexport */ FULL_FAVORITE_BASE64; },
  "GATED_HASHES": function() { return /* reexport */ GATED_HASHES; },
  "GET_GUEST_TOKEN_ENDPOINT": function() { return /* reexport */ GET_GUEST_TOKEN_ENDPOINT; },
  "GET_ORDER_DETAILS_ENDPOINT": function() { return /* reexport */ GET_ORDER_DETAILS_ENDPOINT; },
  "GET_ORDER_ENDPOINT": function() { return /* binding */ GET_ORDER_ENDPOINT; },
  "GET_PROFILE_ENDPOINT": function() { return /* reexport */ GET_PROFILE_ENDPOINT; },
  "GLOBAL_CONFIGURATION_ENDPOINT": function() { return /* reexport */ GLOBAL_CONFIGURATION_ENDPOINT; },
  "GLOBAL_CONFIGURATION_PATH": function() { return /* binding */ constants_GLOBAL_CONFIGURATION_PATH; },
  "HELP_AND_FAQ": function() { return /* reexport */ HELP_AND_FAQ; },
  "HELP_FAQ_END_POINT": function() { return /* reexport */ HELP_FAQ_END_POINT; },
  "HOMEPAGEURL": function() { return /* binding */ HOMEPAGEURL; },
  "INSTALLATION_SERVICES_ASPATH": function() { return /* reexport */ INSTALLATION_SERVICES_ASPATH; },
  "INSTALLATION_SERVICES_HASH": function() { return /* reexport */ INSTALLATION_SERVICES_HASH; },
  "INSTALLATION_SERVICES_PATH": function() { return /* reexport */ INSTALLATION_SERVICES_PATH; },
  "IS": function() { return /* reexport */ IS; },
  "KEYCODE": function() { return /* reexport */ KEYCODE; },
  "KEY_SPECIFIER_API_URL_ENDPOINT": function() { return /* reexport */ KEY_SPECIFIER_API_URL_ENDPOINT; },
  "KEY_SPECIFIER_QUERRY_SELECTOR_URL": function() { return /* reexport */ KEY_SPECIFIER_QUERRY_SELECTOR_URL; },
  "LITERATURE_DATA_URL": function() { return /* reexport */ LITERATURE_DATA_URL; },
  "LOCATIONSCONST": function() { return /* reexport */ LOCATIONSCONST; },
  "LOCATIONS_ASPATH": function() { return /* reexport */ LOCATIONS_ASPATH; },
  "LOCATIONS_PATH": function() { return /* reexport */ LOCATIONS_PATH; },
  "LOCATION_API_TRIGGER_INTERVAL": function() { return /* reexport */ LOCATION_API_TRIGGER_INTERVAL; },
  "MATTERPORT_ARIA_LABEL": function() { return /* reexport */ MATTERPORT_ARIA_LABEL; },
  "MEMBERSHIP_API_URL_ENDPOINT": function() { return /* reexport */ MEMBERSHIP_API_URL_ENDPOINT; },
  "MEMBERSHIP_QUERRY_SELECTOR_URL": function() { return /* reexport */ MEMBERSHIP_QUERRY_SELECTOR_URL; },
  "MILLISECONDSADAY": function() { return /* reexport */ MILLISECONDSADAY; },
  "MIN_DELAY": function() { return /* reexport */ MIN_DELAY; },
  "MODEL_JSON_EXTENSION": function() { return /* reexport */ MODEL_JSON_EXTENSION; },
  "MORE_OPTIONS": function() { return /* reexport */ MORE_OPTIONS; },
  "MY_ACCOUNT_PATH": function() { return /* reexport */ MY_ACCOUNT_PATH; },
  "MY_FAVORITES_ENDPOINT": function() { return /* reexport */ MY_FAVORITES_ENDPOINT; },
  "MY_PRODUCTS_ENDPOINT": function() { return /* reexport */ MY_PRODUCTS_ENDPOINT; },
  "MY_PRODUCT_PRODUCT_REGISTRATION": function() { return /* reexport */ MY_PRODUCT_PRODUCT_REGISTRATION; },
  "MY_PRODUCT_SEARCH_CATALOG": function() { return /* reexport */ MY_PRODUCT_SEARCH_CATALOG; },
  "MY_SERVICES_ENDPOINT": function() { return /* reexport */ MY_SERVICES_ENDPOINT; },
  "MyFavoritesPageDataUrl": function() { return /* reexport */ MyFavoritesPageDataUrl; },
  "MyProductsPageDataUrl": function() { return /* reexport */ MyProductsPageDataUrl; },
  "MyServicePageDataUrl": function() { return /* reexport */ MyServicePageDataUrl; },
  "NODE_NAMES": function() { return /* reexport */ NODE_NAMES; },
  "NS": function() { return /* reexport */ NS; },
  "NUMERIC_REGX": function() { return /* reexport */ NUMERIC_REGX; },
  "ONETRUST_IDENTIFIER": function() { return /* reexport */ ONETRUST_IDENTIFIER; },
  "ORDER_INVOICE_URL": function() { return /* binding */ ORDER_INVOICE_URL; },
  "PAGE_TYPES": function() { return /* reexport */ PAGE_TYPES; },
  "PARTS": function() { return /* reexport */ PARTS; },
  "PAYMENT_URL": function() { return /* binding */ PAYMENT_URL; },
  "PAYPAL_TYPES": function() { return /* reexport */ PAYPAL_TYPES; },
  "PAY_BY_LINK_URL": function() { return /* binding */ PAY_BY_LINK_URL; },
  "PDP_DEFAULT_IMAGE": function() { return /* reexport */ PDP_DEFAULT_IMAGE; },
  "PDP_END_POINT_SUBSCRIPTION_KEY": function() { return /* binding */ constants_PDP_END_POINT_SUBSCRIPTION_KEY; },
  "PDP_SLIDER_SIZES": function() { return /* binding */ PDP_SLIDER_SIZES; },
  "PDP_TEASER_DETAILS": function() { return /* reexport */ PDP_TEASER_DETAILS; },
  "PHONE_REGEX": function() { return /* binding */ PHONE_REGEX; },
  "PLP_END_POINT": function() { return /* reexport */ PLP_END_POINT; },
  "PLP_END_POINT_CLIENT": function() { return /* binding */ constants_PLP_END_POINT_CLIENT; },
  "PLP_END_POINT_SUBSCRIPTION_KEY": function() { return /* reexport */ PLP_END_POINT_SUBSCRIPTION_KEY; },
  "PLUMBING_SERVICE_PARTS": function() { return /* reexport */ PLUMBING_SERVICE_PARTS; },
  "PRESS_LANDING_URL": function() { return /* reexport */ PRESS_LANDING_URL; },
  "PRESS_ROOM_PATH": function() { return /* reexport */ PRESS_ROOM_PATH; },
  "PRIVACY_ASPATH": function() { return /* reexport */ PRIVACY_ASPATH; },
  "PRIVACY_COOKIE_CLICKED": function() { return /* reexport */ PRIVACY_COOKIE_CLICKED; },
  "PRODUCTS_PER_PAGE": function() { return /* reexport */ PRODUCTS_PER_PAGE; },
  "PRODUCT_DATA_URL": function() { return /* binding */ constants_PRODUCT_DATA_URL; },
  "PROFILE_END_POINT_CLIENT": function() { return /* reexport */ PROFILE_END_POINT_CLIENT; },
  "REGISTER_OFFLINE_PRODUCTS_DATA_URL": function() { return /* binding */ constants_REGISTER_OFFLINE_PRODUCTS_DATA_URL; },
  "REGISTER_ONLINE_PRODUCTS_DATA_URL": function() { return /* binding */ constants_REGISTER_ONLINE_PRODUCTS_DATA_URL; },
  "ROW_COLUMN_MIN_WIDTH": function() { return /* reexport */ ROW_COLUMN_MIN_WIDTH; },
  "SEARCH_PDP_FL": function() { return /* binding */ constants_SEARCH_PDP_FL; },
  "SEARCH_PLP_ENDPOINT": function() { return /* reexport */ SEARCH_PLP_ENDPOINT; },
  "SEAT_TYPES": function() { return /* reexport */ SEAT_TYPES; },
  "SHOP_THE_ROOM_CLASSES": function() { return /* reexport */ SHOP_THE_ROOM_CLASSES; },
  "SPLIT_ORDER": function() { return /* reexport */ SPLIT_ORDER; },
  "STORE_APPOINTMENT_ANCHOR_VALUE": function() { return /* reexport */ STORE_APPOINTMENT_ANCHOR_VALUE; },
  "STORE_DETAILS_API_ENDPOINT": function() { return /* reexport */ STORE_DETAILS_API_ENDPOINT; },
  "STORE_MAX_DISTANCE": function() { return /* reexport */ STORE_MAX_DISTANCE; },
  "STORE_MIN_DISTANCE": function() { return /* reexport */ STORE_MIN_DISTANCE; },
  "SUCCESS": function() { return /* reexport */ SUCCESS; },
  "SUPPORT_CENTER_PATH": function() { return /* reexport */ SUPPORT_CENTER_PATH; },
  "SWATCH_NA": function() { return /* reexport */ SWATCH_NA; },
  "TABS_NOT_REQUIRED_GRIDICON": function() { return /* reexport */ TABS_NOT_REQUIRED_GRIDICON; },
  "TAB_WIDTH": function() { return /* reexport */ TAB_WIDTH; },
  "TEASER_CAPTION_CLASSES": function() { return /* reexport */ TEASER_CAPTION_CLASSES; },
  "TEASER_CAPTION_CLASSES_LIST": function() { return /* reexport */ TEASER_CAPTION_CLASSES_LIST; },
  "TEASER_CLASSES": function() { return /* reexport */ TEASER_CLASSES; },
  "TECHNICAL_SPECIFICATION_DATA_URL": function() { return /* reexport */ TECHNICAL_SPECIFICATION_DATA_URL; },
  "TECHNICAL_SPECIFICATION_PATH": function() { return /* reexport */ TECHNICAL_SPECIFICATION_PATH; },
  "TECHNICAL_SPECT_SEARCH_COUNT": function() { return /* reexport */ TECHNICAL_SPECT_SEARCH_COUNT; },
  "TIMEOUT_1500": function() { return /* reexport */ TIMEOUT_1500; },
  "TOAST_MESSAGE_DEFAULT_DURATION": function() { return /* reexport */ TOAST_MESSAGE_DEFAULT_DURATION; },
  "TotalSecsForaDay": function() { return /* reexport */ TotalSecsForaDay; },
  "UTILITY_CONSTANTS": function() { return /* reexport */ UTILITY_CONSTANTS; },
  "VANITY_REDIRECT_TYPE": function() { return /* reexport */ VANITY_REDIRECT_TYPE; },
  "VIDEO_EVENTS": function() { return /* reexport */ VIDEO_EVENTS; },
  "VISUALICON_ARIA_LABEL": function() { return /* reexport */ VISUALICON_ARIA_LABEL; },
  "ZIP_FILE_DOWNLOAD_ENDPOINT": function() { return /* reexport */ ZIP_FILE_DOWNLOAD_ENDPOINT; },
  "accountSettingsPageDataUrl": function() { return /* reexport */ accountSettingsPageDataUrl; },
  "addAddressEndPoint": function() { return /* reexport */ addAddressEndPoint; },
  "addFavoritesEndPoint": function() { return /* binding */ constants_addFavoritesEndPoint; },
  "addressEndPoint": function() { return /* binding */ addressEndPoint; },
  "addressSuggestionEndPoint": function() { return /* reexport */ addressSuggestionEndPoint; },
  "apiBaseUrl": function() { return /* reexport */ apiBaseUrl; },
  "apimAemURL": function() { return /* binding */ apimAemURL; },
  "apimSubscriptionKey": function() { return /* reexport */ apimSubscriptionKey; },
  "authorBaseUrl": function() { return /* reexport */ authorBaseUrl; },
  "authorPreviewBaseUrl": function() { return /* reexport */ authorPreviewBaseUrl; },
  "authorPreviewPassword": function() { return /* reexport */ authorPreviewPassword; },
  "authorPreviewUserName": function() { return /* reexport */ authorPreviewUserName; },
  "baseUrl": function() { return /* reexport */ baseUrl; },
  "blogUrl": function() { return /* binding */ blogUrl; },
  "brandTransactSwitcher": function() { return /* binding */ brandTransactSwitcher; },
  "browseAllStoresURL": function() { return /* reexport */ browseAllStoresURL; },
  "cancellationReason": function() { return /* binding */ cancellationReason; },
  "cartDataUrl": function() { return /* binding */ constants_cartDataUrl; },
  "cartItemsEndPoint": function() { return /* binding */ constants_cartItemsEndPoint; },
  "cartPage": function() { return /* binding */ constants_cartPage; },
  "checkDuplicacyUrl": function() { return /* binding */ checkDuplicacyUrl; },
  "checkDuplicacyUrlForUpdateNumber": function() { return /* binding */ checkDuplicacyUrlForUpdateNumber; },
  "checkSplitOrderEndPoint": function() { return /* reexport */ checkSplitOrderEndPoint; },
  "checkoutDataUrl": function() { return /* binding */ constants_checkoutDataUrl; },
  "contactUsUrl": function() { return /* binding */ contactUsUrl; },
  "createCartEndPoint": function() { return /* reexport */ createCartEndPoint; },
  "createFavoritesEndPoint": function() { return /* reexport */ createFavoritesEndPoint; },
  "customActivityEvents": function() { return /* reexport */ customActivityEvents; },
  "dataUrl": function() { return /* binding */ constants_dataUrl; },
  "dealerEnquiryCitiesURL": function() { return /* binding */ dealerEnquiryCitiesURL; },
  "dealerEnquiryURL": function() { return /* binding */ dealerEnquiryURL; },
  "debounceThresholdCheckUserExists": function() { return /* reexport */ debounceThresholdCheckUserExists; },
  "default": function() { return /* binding */ constants_0; },
  "deleteCartEndPoint": function() { return /* reexport */ deleteCartEndPoint; },
  "discountEndPoint": function() { return /* reexport */ discountEndPoint; },
  "diwaliSaleUrl": function() { return /* binding */ diwaliSaleUrl; },
  "downloadFileURL": function() { return /* binding */ downloadFileURL; },
  "dynamicSearch": function() { return /* reexport */ dynamicSearch; },
  "editAddressEndPoint": function() { return /* reexport */ editAddressEndPoint; },
  "emailSubscribeEndPoint": function() { return /* binding */ constants_emailSubscribeEndPoint; },
  "enrollFactorUrl": function() { return /* binding */ enrollFactorUrl; },
  "favoritesEndPoint": function() { return /* binding */ constants_favoritesEndPoint; },
  "findAStoreUrl": function() { return /* binding */ findAStoreUrl; },
  "footerUrl": function() { return /* binding */ constants_footerUrl; },
  "getCartEndPoint": function() { return /* reexport */ getCartEndPoint; },
  "getPdpTooltipEndPoint": function() { return /* reexport */ getPdpTooltipEndPoint; },
  "getStockEndPoint": function() { return /* reexport */ getStockEndPoint; },
  "groupedComponents": function() { return /* reexport */ groupedComponents; },
  "headerUrl": function() { return /* binding */ constants_headerUrl; },
  "imgPlaceholderData": function() { return /* reexport */ imgPlaceholderData; },
  "inPageSearchEndPoint": function() { return /* reexport */ inPageSearchEndPoint; },
  "isANYPersona": function() { return /* reexport */ isANYPersona; },
  "keyCodes": function() { return /* reexport */ keyCodes; },
  "locationIpEndPoint": function() { return /* reexport */ locationIpEndPoint; },
  "locationZipEndPoint": function() { return /* reexport */ locationZipEndPoint; },
  "loveYourLookDataUrl": function() { return /* reexport */ loveYourLookDataUrl; },
  "maxAppReached": function() { return /* reexport */ maxAppReached; },
  "mergeCartEndPoint": function() { return /* reexport */ mergeCartEndPoint; },
  "oktaTokenEndpoint": function() { return /* reexport */ oktaTokenEndpoint; },
  "orderConfirmationDataUrl": function() { return /* binding */ constants_orderConfirmationDataUrl; },
  "orderConstants": function() { return /* reexport */ orderConstants; },
  "orderDetailsPageDataUrl": function() { return /* binding */ constants_orderDetailsPageDataUrl; },
  "orderHistoryPageDataUrl": function() { return /* binding */ constants_orderHistoryPageDataUrl; },
  "orderStatusPageDataUrl": function() { return /* binding */ constants_orderStatusPageDataUrl; },
  "orderSubmitEndPoint": function() { return /* binding */ constants_orderSubmitEndPoint; },
  "pageNotFoundDataUrl": function() { return /* reexport */ pageNotFoundDataUrl; },
  "pageUrl": function() { return /* reexport */ pageUrl; },
  "panConsentEndPoint": function() { return /* binding */ panConsentEndPoint; },
  "payPalPaymentEndPoint": function() { return /* reexport */ payPalPaymentEndPoint; },
  "paymentEndPoint": function() { return /* reexport */ paymentEndPoint; },
  "paymentSubscriptionKey": function() { return /* binding */ paymentSubscriptionKey; },
  "pdpCatalogProjectionEndPoint": function() { return /* reexport */ pdpCatalogProjectionEndPoint; },
  "pdpResourceFacetLabels": function() { return /* binding */ pdpResourceFacetLabels; },
  "postOrderNoOfDays": function() { return /* reexport */ postOrderNoOfDays; },
  "pressroomUrl": function() { return /* binding */ pressroomUrl; },
  "previewContentPrefix": function() { return /* reexport */ previewContentPrefix; },
  "productBySkuEndPoint": function() { return /* reexport */ productBySkuEndPoint; },
  "productEnquiryUrl": function() { return /* binding */ productEnquiryUrl; },
  "publicWebsiteUrl": function() { return /* reexport */ publicWebsiteUrl; },
  "publisherBaseUrl": function() { return /* reexport */ publisherBaseUrl; },
  "queryParamsToPersist": function() { return /* reexport */ queryParamsToPersist; },
  "recentlyViewedEndPoint": function() { return /* reexport */ recentlyViewedEndPoint; },
  "removeFavoritesEndPoint": function() { return /* reexport */ removeFavoritesEndPoint; },
  "resetFactorUrl": function() { return /* binding */ resetFactorUrl; },
  "resourceFacetLabels": function() { return /* binding */ constants_resourceFacetLabels; },
  "returnConfirmationUrl": function() { return /* binding */ returnConfirmationUrl; },
  "returnRequestUrl": function() { return /* binding */ returnRequestUrl; },
  "returnsUrl": function() { return /* binding */ returnsUrl; },
  "searchDataUrl": function() { return /* reexport */ searchDataUrl; },
  "searchPdpEndPoint": function() { return /* reexport */ searchPdpEndPoint; },
  "searchPlpEndPoint": function() { return /* reexport */ searchPlpEndPoint; },
  "searchProfilePlpEndPoint": function() { return /* reexport */ searchProfilePlpEndPoint; },
  "selectors": function() { return /* reexport */ selectors; },
  "sendTriggerURL": function() { return /* binding */ sendTriggerURL; },
  "shareCartEndPoint": function() { return /* reexport */ shareCartEndPoint; },
  "sharedCartItemsEndPoint": function() { return /* reexport */ sharedCartItemsEndPoint; },
  "sharedCartUrl": function() { return /* reexport */ sharedCartUrl; },
  "shipmentFromCartEndPoint": function() { return /* reexport */ shipmentFromCartEndPoint; },
  "shippingCostEndPoint": function() { return /* reexport */ shippingCostEndPoint; },
  "signupEndPoint": function() { return /* reexport */ signupEndPoint; },
  "staticClasses": function() { return /* binding */ constants_staticClasses; },
  "stopedByPreviousDiscount": function() { return /* reexport */ stopedByPreviousDiscount; },
  "storeLandingURL": function() { return /* binding */ storeLandingURL; },
  "taxEndPoint": function() { return /* reexport */ taxEndPoint; },
  "updateNumberUrl": function() { return /* binding */ updateNumberUrl; },
  "validateTokenEndPoint": function() { return /* reexport */ validateTokenEndPoint; }
});

;// CONCATENATED MODULE: ./src/constants/index.js
/* provided dependency */ var process = __webpack_require__(83454);
const authorBaseUrl = "https://www.kohler.co.in";
const authorPreviewBaseUrl = process.env.NEXT_PUBLIC_PREVIEW_AUTHORBASEURL;
const authorPreviewUserName = process.env.NEXT_PUBLIC_PREVIEW_USERNAME;
const authorPreviewPassword = process.env.NEXT_PUBLIC_PREVIEW_PASSWORD;
const previewContentPrefix = "/content/kohler-india/in";
const publisherBaseUrl = process.env.NEXT_PUBLIC_PUBLISHERBASEURL;
const baseUrl = "/en";
const publicWebsiteUrl = "https://www.kohler.co.in";
const isANYPersona = process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true" ? true : false;
const dataUrl = "/en.model.json";
const searchDataUrl = "/search.model.json";
const cartDataUrl = "/en/cart.model.json";
const headerUrl = "/content/experience-fragments/kohler/us/en/navigation/header/global-header-experience-fragment/master";
const footerUrl = "/content/experience-fragments/kohler/us/en/navigation/footer/Global-footer-experience-fragment/master";
const pageUrl = "/en/";
const cartPage = pageUrl + "cart";
const checkoutDataUrl = "/en/checkout.model.json";
const sharedCartUrl = "/en/cart/shared-cart.model.json";
const orderConfirmationDataUrl = "/en/orders/order-confirmation.model.json";
const orderDetailsPageDataUrl = "/en/orders/order-details.model.json";
const orderHistoryPageDataUrl = "/en/orders/order-history.model.json";
const orderStatusPageDataUrl = "/en/orders/order-status.model.json";
const PRODUCT_DATA_URL = "/products/product-details.model.json";
const MyProductsPageDataUrl = "/my-account/my-products.model.json";
const loveYourLookDataUrl = "/en/love-your-look.model.json";
const pageNotFoundDataUrl = "/en/error-handler-pages/404.model.json";
const apiBaseUrl = "https://www.kohler.co.in/apirequest";
const oktaTokenEndpoint = "/oauth/token";
const getCartEndPoint = "/cart/active?expand=calculation";
const createCartEndPoint = "/cart/create";
const getStockEndPoint = "/catalog/inventory";
const cartItemsEndPoint = "/cart/v2/items";
const sharedCartItemsEndPoint = "/cart/items";
const shippingCostEndPoint = "/checkout/shipping-cost";
const discountEndPoint = "cart/v2/discount?expand=calculation";
const taxEndPoint = "/cart/v2/items?expand=calculation";
const shareCartEndPoint = "/cart/sharedcart";
const mergeCartEndPoint = "/cart/merge?expand=calculation";
const signupEndPoint = "/customer/signup";
const deleteCartEndPoint = "/cart/v2/deleteActiveCart";
const shipmentFromCartEndPoint = "/checkout/v2/assign/shipmentfromcart";
const addAddressEndPoint = "/customer/address";
const addressSuggestionEndPoint = "/maps/address/validate";
const validateTokenEndPoint = "/oauth/token/validate";
const orderSubmitEndPoint = "/checkout/v2/order/submit";
const paymentEndPoint = "/checkout/payment";
const payPalPaymentEndPoint = "/payment/paypal/getToken";
const recentlyViewedEndPoint = "/catalog/product/projection";
const searchPlpEndPoint = "/search/plp";
const inPageSearchEndPoint = "/search/plp";
const searchProfilePlpEndPoint = "/search/profile";
const checkSplitOrderEndPoint = "/checkout/order-split-check";
const searchPdpEndPoint = "/search/pdp";
const pdpCatalogProjectionEndPoint = "/catalog/product/projection";
const getPdpTooltipEndPoint = "/search/tooltip";
const accountSettingsPageDataUrl = "/my-account/account-settings.model.json";
const MY_PRODUCTS_ENDPOINT = "/shopping-list/MyProducts";
const FETCH_PRODUCT_REG_ENDPOINT = "/crm/fetchproductregistration";
const staticClasses = {
    CONTAINER: "container responsivegrid",
    ONETRUST_ANALYTICS: "optanon-category-C0002"
};
const productBySkuEndPoint = "/catalog/product/projection";
const MyServicePageDataUrl = "/my-account/my-services.model.json";
const MyFavoritesPageDataUrl = "/my-account/my-favorites.model.json";
const REGISTER_OFFLINE_PRODUCTS_DATA_URL = "/my-account/product-registration/register-offline-product.model.json";
const REGISTER_ONLINE_PRODUCTS_DATA_URL = "/en/my-account/product-registration/register-online-product.model.json";
const FAQ_PAGE_DATA_URL = "/support/help-and-faq";
const browseAllStoresURL = "/en/locations/browse-all-stores.model.json";
const LITERATURE_DATA_URL = "/en/for-professionals/literature.model.json";
const TECHNICAL_SPECIFICATION_DATA_URL = "/en/for-professionals/technical-specifications.model.json";
const PRESS_LANDING_URL = "/en/press-room.model.json";
const FIND_STORE_URL = "en/locations.model.json";
const ARTICLE_CONTENT_END_POINT = "/jcr:content.json";
const ARTICLE_IMG_END_POINT = "/jcr:content/image.json";
const MODEL_JSON_EXTENSION = ".model.json";
const dynamicSearch = "dynamic search";
const CONSTANTS = {
    DEFAULT_IDLE_TIMEOUT: 172800,
    DEFAULT_VERSION: "v1",
    ERROR_CODES: {
        BAD_REQUEST_ERROR: 400,
        INTERNAL_SERVER_ERROR: 500,
        AUTHENTICATION_ERROR: [
            401,
            403
        ]
    },
    USER_STATE: {
        LOGGED_USER: "logged",
        ANONYMOUS_USER: "anonymous"
    },
    PARENT_COMPONENTS_LIST: {
        ORDER_DETAILS: "OrderDetails"
    },
    PAYMENT: {
        SUCCESS_CODE: "870",
        NUM_YEARS: 16
    },
    ORDER_STATUS_SHIPPED: "Shipped",
    DELETE_INACTIVE_MYFOLDER_AFTER: 30,
    ERROR_MESSAGE: {
        GENERAL: "Something went wrong. Please try again...",
        SESSION_TIMEOUT_MSG: "Your session is expired.. Please login again...",
        SESSION_TIMEOUT_SECURE_PAGE_MSG: "Redirecting to Home Page due to inactivity"
    },
    COLOR_FILE_URL: "https://kohler.scene7.com/is/image/PAWEB/",
    CT_API_URL: "https://api.us-central1.gcp.commercetools.com",
    CT_PROJECT_KEY: "kohler-na-qa-1",
    CT_SALES_CHANNEL: "KOUS",
    REGEX_TEXT: /^[a-z\d\-,'"\s]+$/,
    REGEX_ALPHANUMERIC_SAFE_CHARS: /^[a-z\d\-,'"\s]+$/i,
    REGEX_PASSWORD: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{11,})"),
    REGEX_EMAIL: /^((?!\.)(?!\-)(?!\_)[a-z0-9]*([\.\-\_]?[a-z0-9\-]*)?[^\-`_.#()+/=!@$%^&*:'"<>])(@(?!\.)(?!\-)(?!\_)[\w-]+)(\.\w+(\.\w+)?[^.\W])$/i,
    KEYCODE: {
        ENTER: 13,
        ESC: 27,
        SPACE: 32,
        UP: 38,
        DOWN: 40,
        TAB: 9
    },
    KEY: {
        ENTER: "Enter",
        ESC: "Escape"
    },
    FF_PERSONA: "US_Kcom_FriendsNFamily:FF",
    KEMP_PERSONA: "US_Kcom_KohlerCoAssociate:KEMP",
    KF_FORCE_RENEW_TOKEN: "kf-okta-force-renew-token",
    KF_UPDATE_MEMBERSHIP: "kf-update-membership",
    CREATE_ACCOUNT_TYPE: {
        HOME_OWNER: "homeowner",
        PROFESSIONAL: "professional"
    },
    UNDEFINED: "undefined",
    COMPONENT: {
        PAIRS_WELL_WITH: "pairsWellWith"
    },
    SLICK: {
        DEFAULT_DELAY: 5000,
        COUNT_OFFSET: 22,
        ARROW_OFFSET: 52
    },
    CURRENCY_SIGN: "$",
    STATUS: {
        OK: 200,
        PAGE_NOT_FOUND: 404,
        INTERNAL_SERVER_ERROR: 500
    }
};
const favoritesEndPoint = "/shopping-list/Favorites";
const createFavoritesEndPoint = "/shopping-list/create";
const addFavoritesEndPoint = (id, type)=>{
    return "/shopping-list/add/".concat(id, "?type=").concat(type);
};
const removeFavoritesEndPoint = (id)=>{
    return "/shopping-list/remove/items/".concat(id);
};
const SWATCH_NA = "swatch_NA";
const ADD_10_MINUTES = 600000;
const PRIVACY_COOKIE_CLICKED = "is_privacy_cookie_clicked";
const GLOBAL_CONFIGURATION_PATH = "/bin/kohler/services/globalconfig.kohler.json";
const DOMAIN = "https://www.kohler.co.in";
const GLOBAL_CONFIGURATION_ENDPOINT = DOMAIN + "/api/globalconfig";
const locationIpEndPoint = "/maps/location/ip/";
const locationZipEndPoint = "/maps/location/zipcode/";
const STORE_MIN_DISTANCE = 64;
const STORE_MAX_DISTANCE = 1000;
const TIMEOUT_1500 = 1500;
const LOCATION_API_TRIGGER_INTERVAL = 1800000 // 30mins
;
const STORE_DETAILS_API_ENDPOINT = DOMAIN + "/api/storedetails";
const DEFAULT_STORE_DETAILS_API_PATH = "/bin/kohler/services/storedetails?path=";
const GET_PROFILE_ENDPOINT = "/customer/me";
const ZIP_FILE_DOWNLOAD_ENDPOINT = "/catalog/zip-file-download";
const SEARCH_PLP_ENDPOINT = "search/plp";
const MY_ACCOUNT_PATH = "/my-account";
// cart Dicount
const stopedByPreviousDiscount = "ApplicationStoppedByPreviousDiscount";
const maxAppReached = "MaxApplicationReached";
const emailSubscribeEndPoint = "/crm/newsletter/subscription";
const TOAST_MESSAGE_DEFAULT_DURATION = 5000 // 5seconds
;
const editAddressEndPoint = "customer/address";
const FIND_MY_ORDERS_V1_ENDPOINT = "/checkout/orders/v1/query";
const FIND_MY_ORDERS_ENDPOINT = "/checkout/orders/query";
const SPLIT_ORDER = "checkout/ordersplit";
const GET_GUEST_TOKEN_ENDPOINT = DOMAIN + "/api/token";
// Membership
const KEY_SPECIFIER_QUERRY_SELECTOR_URL = 'a[href="#KeySpecifier"]';
const KEY_SPECIFIER_API_URL_ENDPOINT = "/membership/assign/persona";
const MEMBERSHIP_API_URL_ENDPOINT = "/membership/kohler-associate/entry";
const MEMBERSHIP_QUERRY_SELECTOR_URL = 'a[href="#AssociateMembership"]';
const FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL = 'a[href="#FriendsAndFamily"]';
const FRIENDS_AND_FAMILY_API_URL_ENDPOINT = "/membership/assign/persona";
// Store Appointment
const STORE_APPOINTMENT_ANCHOR_VALUE = "#StoreAppointment";
const MORE_OPTIONS = {
    LEARN_MORE: "Learn More",
    EXPLORE_MORE: "Explore More",
    FREE_QUOTE: "Get a FREE Quote",
    FIND_PRO: "Find a Pro",
    INSTALLATION_SERVICES: "Buy Now"
};
const DISABLE_SROLL_PATH = [
    "home-energy/home-generators",
    "buying-guides/bath-tub-buying-guide",
    "services/installation-services"
];
const DEFAULT_SCROLL = {
    scroll: 60,
    backToTop: 20,
    freeQuote: 120,
    findAPro: 120,
    installationServices: 120
};
// order confirmation
const orderConstants = {
    COMPLETED: "Completed",
    CANCELLED: "Cancelled",
    CREDIT_CARD: "CREDIT_CARD",
    PAYPAL: "PP",
    ACI_PAYPAL: "Paypal",
    SHIPPED: "Shipped"
};
const PAYPAL_TYPES = [
    "PP",
    "Paypal",
    "PAYPAL",
    "PayPal"
];
const GET_ORDER_DETAILS_ENDPOINT = "checkout/orders";
const DEFAULT_CARD_DETAILS_API_PATH = "/bin/kohler/services/list?path=/content/kohler";
const MY_SERVICES_ENDPOINT = "/shopping-list/MyServices?lang=" + "en-IN";
const MY_FAVORITES_ENDPOINT = "/shopping-list/Favorites";
const COMPONENT_TYPES = {
    AEMFORM: "aemform",
    PRODUCTCARD: "productcard",
    ROOT_CONTAINER: "root",
    CONTAINER: "container",
    VIDEO: "video",
    AUTH_MODAL: "authmodal",
    NEWSLETTER: "newsletter",
    TEASER: "teaser",
    CAROUSEL: "carousel",
    SLICK: "carousel-slick",
    SPACER: "spacer",
    TEXT: "text",
    TAB: "tab",
    BREADCRUMB: "breadcrumb",
    PRODUCTLIST: "productlist",
    SEARCH: "search/v1/search",
    EMBED: "embed",
    BRAND_SWITCHER: "brand-switcher",
    UTILITY_NAV_HEADER: "utilitynavheader",
    UTILITY_WIDGET: "utilitywidget",
    TABS: "tabs",
    IMAGE: "image",
    SITEWIDE_WARNING: "sitewide-warning",
    IMAGEV3: "image/v3/image",
    CAROUSELSLICK: "carousel-slick",
    TOASTER: "toaster/v1/toaster",
    COMPARE_PRODUCTS: "compareproducts",
    MAIN_FOOTER: "mainfooter",
    ADDITIONAL_FOOTER: "additionalfooter",
    NEWSLETTER_SIGNIN: "newslettersignin",
    NEWSLETTER_SIGNUP: "newslettersignup",
    CART_LANDING: "cart-landing",
    CHECKOUT: "checkout",
    ORDER_CONFIRMATION: "orderconfirmation",
    ORDER_STATUS: "orderstatus",
    ORDER_HISTORY: "orderhistory",
    ORDER_DETAILS: "orderdetails",
    SHARED_CART: "sharedcart",
    PAIRS_WELL_WITH: "pairs-well-with",
    HELPSUPPORT: "help-support",
    GLOBAL_NAVIGATION: "globalnavigation",
    PROMOBANNER: "plp-promo-banner",
    ACCOUNT_SETTINGS: "accountsettings",
    MY_SERVICES: "myservices",
    MY_FAVORITES: "myfavorites",
    CHANGE_PASSWORD: "changepassword",
    MY_PRODUCTS: "myproducts",
    PRODUCT_DETAILS: "pdp/v1/pdp",
    PRODUCT_DETAILS_ACCORDION: "accordion",
    PRODUCT_DETAILS_EXFPDP: "exfpdp/v1/exfpdp",
    PRODUCT_DETAILS_REVIEW: "components/review",
    REGISTER_OFFLINE_PRODUCTS: "register-offline-products",
    REGISTER_ONLINE_PRODUCTS: "register-online-products",
    KNOWLEDGE_ARTICLE: "knowledge-article/v1/knowledge-article",
    BROWSE_ALL_STORES: "browseallstores",
    STORE_FILTER: "storefilter",
    LITERATURE: "literature",
    CONTACT_US: "contactus",
    FINDING_MODEL_NUMBER: "finding-model-number",
    TECHNICAL_SPECIFICATION: "technicalspecs",
    PRESS_LANDING: "press-release-landing",
    UPSELL_CONTAINER: "container-up-sell",
    FIND_STORE: "findstore",
    INPAGE_SEARCH: "in-page-search",
    TITLE: "title",
    KEY_SPECIFIER: "key-specifier",
    DYNAMIC_SEARCH: "dynamicsearch",
    ASSOCIATE_MEMBERSHIP: "associate-membership",
    INSPIRE_VIDEO: "inspire-video",
    IMAGE_CLUSTER: "imagecluster",
    SHOP_THE_ROOM_CARD: "shoptheroomcard",
    INSTALL_DESIGN_SERVICES: "v1/installdesignservices",
    PROFESSIONAL_DETAILS: "professional-detail",
    FRIENDS_AND_FAMILY: "friends-family",
    FIND_A_PRO_BY_ZIP: "find-pro-by-zip",
    STORE_APPOINTMENT: "store-appointment",
    PRODUCTCARD_V3: "productcard-v3",
    SHOP_THE_ROOM_DETAIL: "shoptheroomdetail",
    ROOM_DETAIL: "roomdetail",
    GATED_CONTENT: "gated-content-paths",
    PRODUCT_CARD_V4: "productcard-v4"
};
const FRAGMENT_TYPES = {
    HEADER: "header",
    MAIN: "main",
    FOOTER: "footer"
};
const VIDEO_EVENTS = {
    PLAY: "play",
    PAUSE: "pause",
    ENDED: "ended"
};
const TAB_WIDTH = 768;
const DESKTOP_WIDTH = 1280;
const ROW_COLUMN_MIN_WIDTH = 1025;
// PLP
// sort constants
const KEYCODE = {
    ENTER: 13,
    ESC: 27,
    SPACE: 32,
    UP: 38,
    DOWN: 40,
    TAB: 9
};
// Find a store
const FINDLOCATIONKEYCODE = {
    LEFTARROW: 37,
    RIGHTARROW: 39
};
const LOCATIONSCONST = {
    LocationType: "KOHLER Store",
    paramSpatialFilter: 161,
    status: 200
};
const MILLISECONDSADAY = 86400000;
// press room
const PRESS_ROOM_PATH = "/en/press-room";
// Filter
const queryParamsToPersist = [
    "sort",
    "keyword",
    "tab"
];
const DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME = 9;
const PLP_END_POINT = "/apirequest/search/v1/plp";
const PLP_END_POINT_SUBSCRIPTION_KEY = "/apirequest/lw/plp";
const PDP_END_POINT_SUBSCRIPTION_KEY = "/apirequest/lw/v1/pdp/product";
const apimSubscriptionKey = process.env.APIM_SUBSCRIPTION_KEY;
const PLP_END_POINT_CLIENT = "/search/v1/plp";
const HELP_FAQ_END_POINT = "/search/plp";
const DEFAULT_PRODUCT_COUNT_PLP = 30;
const DEFAULT_TECHNICAL_SPECT_COUNT = 30;
const TECHNICAL_SPECT_SEARCH_COUNT = 5;
const PROFILE_END_POINT_CLIENT = "/search/v1/profile";
const debounceThresholdCheckUserExists = 500;
const customActivityEvents = [
    "click",
    "keydown"
];
const PAGE_TYPES = {
    CATEGORY_LANDING_PAGE: "category landing page"
};
const PRODUCTS_PER_PAGE = [
    30,
    60,
    90
];
const imgPlaceholderData = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
// Account Settings constants
const EDIT_PROFILE_ENDPOINT = "/customer/profile";
const DELETE_ACCOUNT_ENDPOINT = "/customer/account";
const CHANGE_ACCOUNT_PASSWORD_ENDPOINT = "/customer/change_password";
const EMPTY_PIXEL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
const FULL_FAVORITE_BASE64 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjNweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjMgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+RmF2b3JpdGVzIEJsYWNrIGZpbGxlZCBJY29uPC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJGYXZvcml0ZXMtQmxhY2stZmlsbGVkLUljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNDk5OTcyLCAwLjUwMDAwMCkiIGZpbGw9IiM0OTQ5NDkiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjY5NDYxMTg5LDEuNjk1NTU5NDQgQy0wLjUwMTg5NzgzLDMuODk3MDQ5NDMgLTAuNTcwMjc5NjkxLDcuNDU1ODUwMTEgMS41MzEyODgxMyw5LjcwOTk2MzkgTDEuNjg4MjMwMDEsOS44NzMxOTUyIEwxMS4wMDE3MDE4LDE5LjIwNzkwMTYgTDIwLjI4Mzc4NTQsOS45MDUxNTEyIEwyMC40NDExNTc3LDkuNzQyNTQ2OCBDMjIuNTY5NTIwNiw3LjQ2MDMwODEzIDIyLjUwOTU1NjcsMy45MDEzNjA3OSAyMC4zMDg3NDU0LDEuNjk1NTU5NDQgTDIwLjEyMjgzOTUsMS41MTcyMDk4NyBDMTcuODU2NDMxMywtMC41NjM1MzUwOTUgMTQuMzM0NTc5MiwtMC41MDQwODUyMzkgMTIuMTM5OTEwNiwxLjY5NTU1OTQ0IEwxMS4wMDEwMjgsMi44MzYgTDkuODYzNDQ2NjMsMS42OTU1NTk0NCBDNy42Njg3NzgwNCwtMC41MDQwODUyMzkgNC4xNDY5MjYwMiwtMC41NjM1MzUwOTUgMS44ODA1MTc3NywxLjUxNzIwOTg3IEwxLjY5NDYxMTg5LDEuNjk1NTU5NDQgWiIgaWQ9IkZhdm9yaXRlcy1JY29uIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
const EMPTY_FAVORITE_BASE64 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjNweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjMgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+RmF2b3JpdGVzIEljb24gTW9iaWxlPC90aXRsZT4KICAgIDxnIGlkPSJQRFAtU3VwZXItU0tVLUxheW91dCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjM3NV9Lb2hsZXJfUERQLS0tU3VwZXItU0tVLTEuMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI5NC4wMDAwMDAsIC02My4wMDAwMDApIiBmaWxsPSIjMjEyMTIxIj4KICAgICAgICAgICAgPGcgaWQ9Ik1haW4tTmF2aWdhdGlvbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDQwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikljb25zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNjEuMDAwMDAwLCAxOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iMDUtSWNvbm9ncmFwaHkvTmF2aWdhdGlvbi9GYXZvcml0ZXMvRW1wdHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzLjQ5OTk3MiwgNS41MDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTEuNjk0NjExOSwxLjY5NTU1OTQ0IEMtMC41MDE4OTc4MywzLjg5NzA0OTQzIC0wLjU3MDI3OTY5MSw3LjQ1NTg1MDExIDEuNTMxMjg4MTMsOS43MDk5NjM5IEwxLjY4ODIzMDAyLDkuODczMTk1MTggTDExLjAwMTcwMTgsMTkuMjA3OTAxNiBMMjAuMjgzNzg1NSw5LjkwNTE1MTIyIEwyMC40NDExNTc3LDkuNzQyNTQ2ODIgQzIyLjU2OTUyMDYsNy40NjAzMDgxMyAyMi41MDk1NTY4LDMuOTAxMzYwNzkgMjAuMzA4NzQ1NCwxLjY5NTU1OTQ0IEwyMC4xMjI4Mzk1LDEuNTE3MjA5ODcgQzE3Ljg1NjQzMTMsLTAuNTYzNTM1MDk2IDE0LjMzNDU3OTMsLTAuNTA0MDg1MjQgMTIuMTM5OTEwNywxLjY5NTU1OTQ0IEwxMS4wMDEwMjgsMi44MzYgTDkuODYzNDQ2NjQsMS42OTU1NTk0NCBDNy42Njg3NzgwNCwtMC41MDQwODUyNCA0LjE0NjkyNjAzLC0wLjU2MzUzNTA5NiAxLjg4MDUxNzc4LDEuNTE3MjA5ODcgTDEuNjk0NjExOSwxLjY5NTU1OTQ0IFogTTkuMTU1NTM5NiwyLjQwMTg2NTA1IEwxMS4wMDE2Nzg3LDQuMjUyMTg5OTYgTDEyLjg0NzgxNzcsMi40MDE4NjUwNSBDMTQuNzEyNzQyNywwLjUzMjcxMTY1IDE3LjczNTkxMzQsMC41MzI3MTE2NSAxOS42MDA4Mzg0LDIuNDAxODY1MDUgQzIxLjQyMTQ1ODYsNC4yMjY2MTMyOCAyMS40NzEwODQsNy4xNzE5NTMxNCAxOS43MTYxMDQxLDkuMDUzOTE1MDQgTDE5LjU3MDQ2MDMsOS4yMDQzNjA4OSBMMTEuMDAxMDI4LDE3Ljc5MSBMMi40MDI1MTg5NSw5LjE3MzQwMzY3IEwyLjI1NzMzNDk3LDkuMDIyMzYzMDkgQzAuNTI4ODU3OTg0LDcuMTY4MzMxOTUgMC41ODU0NTExMTQsNC4yMjMwNTI4MSAyLjQwMjUxODk1LDIuNDAxODY1MDUgQzQuMjY3NDQzOTEsMC41MzI3MTE2NSA3LjI5MDYxNDYzLDAuNTMyNzExNjUgOS4xNTU1Mzk2LDIuNDAxODY1MDUgWiIgaWQ9IkZhdm9yaXRlcy1JY29uIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
const TABS_NOT_REQUIRED_GRIDICON = [
    "inspiration",
    "technical",
    "resources",
    "help"
];
// myProducts endPoints
const MY_PRODUCT_SEARCH_CATALOG = "/search/full-catalog";
const MY_PRODUCT_PRODUCT_REGISTRATION = "/crm/product/registration";
const PDP_TEASER_DETAILS = DOMAIN + "/api/pdpTeaserDetails";
const PLUMBING_SERVICE_PARTS = "PlumbingServiceParts";
const PARTS = "parts";
// contact us endpoints
const CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT = "/crm/webtocase";
const API_SUCCESS_STATUS = "succeeded";
const API_FAILURE_STATUS = "failed";
const PDP_DEFAULT_IMAGE = process.env.PDP_DEFAULT_IMAGE;
const EMBED_TYPE_SCRIPT = "SCRIPT";
const EMBED_TYPE_HTML = "HTML";
const VISUALICON_ARIA_LABEL = "View at 360 degree mode";
const MATTERPORT_ARIA_LABEL = "virtual tour popup";
// tab component constants
const NS = "cmp";
const IS = "tabs";
const keyCodes = {
    END: 35,
    HOME: 36,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40
};
const selectors = {
    self: "[data-" + NS + '-is="' + IS + '"]',
    active: {
        tab: "cmp-tabs__tab--active",
        tabpanel: "cmp-tabs__tabpanel--active"
    }
};
// privacy-policy constants
const PRIVACY_ASPATH = "privacy-policy";
// press room constants
const DOWNLOAD_SPINNER = "download-spinner";
const postOrderNoOfDays = 45;
const TotalSecsForaDay = 86400000;
// teasercaption-repositioning constants
const TEASER_CAPTION_CLASSES = ".teaser.img-right-caption-left, .history-module-vertical-image.image-right, .history-module-with-SQR-img.image-left, .img-caption-style-left.img-right-with-number__intend, .img-caption-style-left.img-right-with-number";
// Add conditional wrapper in AEMGRID component for the provided grouped elements.
const groupedComponents = [
    COMPONENT_TYPES === null || COMPONENT_TYPES === void 0 ? void 0 : COMPONENT_TYPES.BREADCRUMB,
    COMPONENT_TYPES === null || COMPONENT_TYPES === void 0 ? void 0 : COMPONENT_TYPES.CAROUSEL
];
const SUCCESS = "success";
// Product support center constants
const SUPPORT_CENTER_PATH = "/en/support/product-support-center";
// help-and-faq constants
const HELP_AND_FAQ = "help-and-faq";
const resourceFacetLabels = [
    "ResourceNvznId_s",
    "ResourceVntanaProductId_s",
    "ResourceVntanaProductIdList_ss",
    "ResourceNvznIdList_ss",
    "ProductIsExclusive_s"
];
// find a pro constants
const FIND_A_PRO_PATH = "/en/services/find-a-pro";
const FIND_A_PRO_HASH = "#findapro";
// Installation services constants
const INSTALLATION_SERVICES_HASH = "#InstallService";
const INSTALLATION_SERVICES_PATH = "/en/services/installation-services";
const INSTALLATION_SERVICES_ASPATH = "installation-services";
const BUYING_GUIDE_ASPATH = "buying-guides";
// cart and checkout constants
const CART_URL = "/en/cart";
const CHECKOUT_URL = "/en/checkout";
const COUNTRY = {
    US: "US"
};
// Technical Specifications constants
const TECHNICAL_SPECIFICATION_PATH = "/en/for-professionals/technical-specifications";
// Browse all stores constants
const BROWSE_ALL_STORES = "browse-all-stores";
const BROWSE_ALL_STORES_URL = "/locations/browse-all-stores";
// Locations constants
const LOCATIONS_PATH = "/en/locations";
const LOCATIONS_ASPATH = "/locations";
// bazaar voice constants
const BAZAAR_VOICE = "bazaarvoice";
// Redirect constants
const VANITY_REDIRECT_TYPE = "Vanity";
// teasercaption-repositioning constants
const TEASER_CAPTION_CLASSES_LIST = [
    "img-right-caption-left",
    "img-right-caption-left mobile-cta-double",
    "mobile-cta-double img-right-caption-left",
    "img-right-caption-left mobile-cta-single",
    "history-module-vertical-image image-right",
    "history-module-with-SQR-img image-left",
    "img-caption-style-left img-right-with-number__intend",
    "img-caption-style-left img-right-with-number"
];
const GATED_HASHES = [
    "#login",
    "#signup",
    "#createaccount"
];
const FRAUD_CHLLENGE_STATUS = [
    "CHALLENGE",
    "ERROR",
    "DENY"
];
const NODE_NAMES = {
    BUTTON: "BUTTON",
    IMG: "IMG"
};
const ONETRUST_IDENTIFIER = "cookielaw";

const SEAT_TYPES = [
    "Toilet Seats",
    "Bidet Seats"
];
const EXCLUDE_PAGES = [
    "/checkout"
];
const UTILITY_CONSTANTS = {
    FAVOURITES: "favourite",
    SHARE: "share",
    PRINT: "print",
    DOWNLOAD: "download"
};
const TEASER_CLASSES = [
    "hero-banner-full-bleed-image",
    "hero-video-3-4"
];
const SHOP_THE_ROOM_CLASSES = [
    "shop-the-room"
];
const MIN_DELAY = 100;
/* harmony default export */ var constants = (CONSTANTS);
const ADDRESS_SUGGESTION_DEFAULT_COUNTRY = "USA";
const AFFIRM_SHOP_URL = "https://www.affirm.com/shop/kohler-web";
const FREIGHT_SHIPPING_TYPES = [
    "Freight",
    "Freight Shipping"
];
const SEARCH_PDP_FL = [
    "id",
    "ctId_s",
    "CustomerFacingSKU_s",
    "ProductProductRecommendedAccessories_ss",
    "ProductProductRecommendedAccessories_s",
    "ProductBrandNameDisplay_t",
    "Product_Category",
    "ProductLocalCategory_s",
    "ProductServices_ss",
    "ProductPriceSpiderIncluded_s",
    "SKUIsProjectPack_s",
    "ProductBrandNameDisplay_s",
    "Super_Sku",
    "Collapse_Field_s",
    "SKU.Details_ss",
    "Color.SKU.Details_ss",
    "Color.SKU.Details_s",
    "productName_s",
    "RegionBrandName_s",
    "variantList.sku_s",
    "variantList.sku_ss",
    "ProductRequiredAccessoryGroup_s",
    "ProductRequiredAccessoryGroup_ss",
    "ProductYoutubeID_s",
    "productImages.labelWithUrl_s",
    "productImages.labelWithUrl_ss",
    "CustomerFacingBrand",
    "ProductDescriptionProductShort_s",
    "productRegionAllVariantDiscontinued_b",
    "ProductBrandName_s",
    "RegionOnBackOrder_s",
    "ProductOverallLengthInches_s",
    "ProductOverallWidthInches_s",
    "ProductOverallHeightInches_s",
    "ProductWebFeatures_ss",
    "ProductFreightPolicyType_s",
    "category1_s",
    "RegionReleaseforShipment_dt",
    "ProductIsExclusive_s",
    "priceList.*.finalPrice_d",
    "priceList.*.saleOffer_s",
    "ProductBadgeInfo_s",
    "ProductBadgeInfo_ss",
    "ProductWebFeatures_s",
    "ProductWebTechnology_ss",
    "ProductWebTechnology_s",
    "ProductNarrativeDescription_s",
    "ProductWebMaterial_ss",
    "ProductWebMaterial_s",
    "ProductWebInstallation_ss",
    "ProductWebInstallation_s",
    "ProductCaliforniaProp65WarningDisclaimer_ss",
    "ProductCaliforniaProp65WarningDisclaimer_s",
    "ProductWebHydrotherapy_s",
    "ProductWebHydrotherapy_ss",
    "ProductWebRebates_ss",
    "ProductWebRebates_s",
    "ProductResource.DXFPlanView.resourceFullWebURL_ss",
    "ProductResource.DWGPlanView.resourceFullWebURL_ss",
    "ProductResource.DXFFrontView.resourceFullWebURL_ss",
    "ProductResource.DWGFrontView.resourceFullWebURL_ss",
    "ProductResource.DXFSideView.resourceFullWebURL_ss",
    "ProductResource.DWGSideView.resourceFullWebURL_ss",
    "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
    "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
    "ProductResource.3DRevit.resourceFullWebURL_ss",
    "ProductResource.3D3DS.resourceFullWebURL_ss",
    "ProductResource.3DSketchup.resourceFullWebURL_ss",
    "ProductResource.3DOBJ.resourceFullWebURL_ss",
    "ProductResource.CutOutDXF.resourceFullWebURL_ss",
    "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
    "ProductResource.SpecPDFFileName.resourceTitle_ss",
    "ProductResource.EnvironProdDecl.resourceFullWebURL_ss",
    "ProductResource.EnvironProdDecl.resourceTitle_ss",
    "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
    "ProductResource.HomeownersGuide.resourceTitle_ss",
    "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
    "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
    "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
    "SKUDiscontinuedDate_dt",
    "ProductResource.YouTubeInstallVideo.resourceName_ss",
    "ProductResource.YouTubeInstallVideo.resourceTitle_ss",
    "ProductResource.InteractiveSVG.resourceName_ss",
    "ProductResource.InteractiveSVG.resourceTitle_ss",
    "ProductProductNo_s",
    "ctProductType_s",
    "CustomerFacingBrand_s",
    "isCollapsedPDP_b",
    resourceFacetLabels.join(",")
];
const FEATURE_FLAGS_CHECKOUT_PAYLOAD = [
    "MYSQLCONNSTR_ACI_PAYMENT_FLAG",
    "MYSQLCONNSTR_ACI_GLOBAL_PAYMENT_FLAG"
];
const CORE_GLOBAL_CONFIG_URL = "/api/globalconfig";
const NUMERIC_REGX = /^[0-9]+$/;

;// CONCATENATED MODULE: ./constants/index.js

const constants_dataUrl = "/content/kohler-india/in/en.model.json";
const contactUsUrl = "/support/contact.model.json";
const findAStoreUrl = "/locations/find-a-store.model.json";
const diwaliSaleUrl = "/p/promotions/diwali-sale.model.json";
const blogUrl = "/blog.model.json";
const downloadFileURL = "/crm/asset/download";
const productEnquiryUrl = "/place-an-enquiry.model.json";
const dealerEnquiryURL = "/dealership-enquiry.model.json";
const storeLandingURL = "/locations/find-a-store/kohler-experience-centres.model.json";
const returnsUrl = "/returns.model.json";
const constants_orderDetailsPageDataUrl = "/orders/order-details.model.json";
const constants_orderConfirmationDataUrl = "/orders/order-confirmation.model.json";
const constants_orderHistoryPageDataUrl = "/orders/order-history.model.json";
const constants_orderStatusPageDataUrl = "/orders/order-status.model.json";
const constants_REGISTER_OFFLINE_PRODUCTS_DATA_URL = "/my-account/product-registration/register-offline-product.model.json";
const constants_REGISTER_ONLINE_PRODUCTS_DATA_URL = "/my-account/product-registration/register-online-product.model.json";
const pressroomUrl = "/press-room.model.json";
const returnConfirmationUrl = "/return-confirmation.model.json";
const returnRequestUrl = "/return-request.model.json";
const dealerEnquiryCitiesURL = "/etc/acs-commons/lists/Kohler/in/en/dealership/cities/jcr:content.list.json";
const constants_headerUrl = "/content/experience-fragments/kohler-india/india/en/navigation/header/header_qa_testing/global-header-experience-fragment/master";
const constants_footerUrl = "/content/experience-fragments/kohler-india/india/en/navigation/footer/Global-footer-experience-fragment/master1";
const constants_cartItemsEndPoint = "/cart/items";
const constants_addFavoritesEndPoint = (id)=>{
    return "/shopping-list/add/".concat(id, "?type=product");
};
const constants_favoritesEndPoint = "/shopping-list/Favorites?lang=" + "en-IN";
const addressEndPoint = "/cart/address";
const constants_GLOBAL_CONFIGURATION_PATH = "/bin/kohler/services/globalconfig.kohler-india.json";
const constants_emailSubscribeEndPoint = "/clevertap/newsletter/subscription";
const constants_FIND_MY_ORDERS_ENDPOINT = "/checkout/orders/v1/query";
const FIND_MY_ORDERS_ENDPOINT2 = "/checkout/orders/query";
const constants_DEFAULT_CARD_DETAILS_API_PATH = "/bin/kohler/services/list?path=/content/kohler-india";
const constants_PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/pdp/product";
const constants_PRODUCT_DATA_URL = "/p/product-detail-page.model.json";
const PHONE_REGEX = /^[6-9]{1}[0-9]{9}$/;
const constants_cartDataUrl = "/cart.model.json";
const constants_cartPage = "/cart";
const HOMEPAGEURL = "/content/kohler-india/in/en.html";
const constants_checkoutDataUrl = "/checkout.model.json";
const panConsentEndPoint = (id)=>"/cart/items?cartId=".concat(id, "&expand=calculation");
const constants_orderSubmitEndPoint = "/checkout/order/submit";
const PAYMENT_URL = "/payment/ccavenue/iframe";
const DECRYPT_PAYMENT_RESP = "/payment/ccavenue/decrypt";
const PAY_BY_LINK_URL = "/ccavenue/paybylink?channel=india";
const checkDuplicacyUrl = "/customer/signup?stage=initial";
const checkDuplicacyUrlForUpdateNumber = "/customer/users";
const resetFactorUrl = "/customer/factor/reset";
const enrollFactorUrl = "/customer/factor/enroll";
const updateNumberUrl = "customer/profile";
const sendTriggerURL = "clevertap/events";
const GET_ORDER_ENDPOINT = (orderId)=>"/checkout/".concat(orderId);
const constants_PLP_END_POINT_CLIENT = "/search/plp";
const apimAemURL = "/aem/resource?resourcepath=";
const ORDER_INVOICE_URL = (invoiceNo, orderNo)=>"/checkout/order/invoice?filename=invoice_".concat(invoiceNo, ".pdf&orderNumber=").concat(orderNo);
const CREDIT_NOTE_URL = (creditNo, orderNo)=>"/checkout/order/invoice?filename=creditNote_".concat(creditNo, ".pdf&orderNumber=").concat(orderNo);
const brandTransactSwitcher = "PREVIEW.KOHLER.CO.IN";
const constants_resourceFacetLabels = function() {
    let persona = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GST";
    return [
        "masterSKU_s",
        "sourceId_s",
        "preferenceSku_s",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "ProductBrandName_s",
        "metaTitle_s",
        "productName_s",
        "id",
        "productImages.url_ss",
        "slug_s",
        "Product_Category",
        "displayPriceStartingAt_s",
        "priceList.".concat(persona, ".price_d"),
        "priceList.".concat(persona, ".finalPrice_d"),
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "priceStartingAt.".concat(persona, "_d"),
        "discountedPriceStartingAt.".concat(persona, "_d"),
        "variantList.sku_ss",
        "SKUColorFinishName_ss",
        "Color.SKU.Details_ss",
        "Color.".concat(persona, ".Details_ss"),
        "ProductExclusive_s",
        "RegionReleaseforShipment_dt",
        "productImages.labelWithUrl_ss",
        "productImageVariantImages.labelWithUrl_ss",
        "ProductBrandNameDisplay_s",
        "ctId_s",
        "ProductProductNo_s",
        "ProductServices_s",
        "InstallationAvailable_s",
        "priceList.ANY.price_d",
        "RegionSupplyChain_ss",
        "BundleList_ss",
        "bundleNameSlugDetails_ss"
    ];
};
const constUpdates = Object.assign(constants, {
    REGEX_NUMBER: /^[0-9]*$/,
    REGEX_PHONE_NUMBER: /^[6-9]{1}[0-9]{9}$/,
    REGEX_USER_TEXT: /^[a-zA-Z-,'\s]+$/,
    INVALID_OTP: "Invalid code. Try again.",
    SESSION_EXPIRED: "Your session has expired. Please try to sign in again.",
    TOO_MANY_ATTEMPTS: "Too many attempts. Try again later.",
    CURRENCY_SIGN: "₹",
    KEMP_PERSONA: "IN_Kohler_Registered_Consumer:KEMP"
});
const compTypeUpdates = Object.assign(COMPONENT_TYPES, {
    FIND_A_STORE: "find-a-store-detail",
    CUSTOMER_SUPPORT: "kohler-india/components/customersupport",
    DEALER_ENQUIRY: "Dealership Enquiry",
    PRODUCT_ENQUIRY: "Product Enquiry",
    RETURNS: "Returns",
    RETURN_CONFIRMATION: "Return Confirmation",
    RETURN_REQUEST: "Return Request",
    FIND_BY_PINCODE: "/maps/get-city-state-with-pincode?pincode=",
    PRESS_LANDING: "press-release-landing",
    LIST: "/list/v1/list",
    BLOG_PAGE: "blogtab",
    LEAD_GENERATION: "leadgenerationform",
    QUIZ: "identifymymirrorflow"
});
const ESTIMATED_TOTAL_FOR_PAN_CONSENT = 200000;
const ESTIMATED_TOTAL_FOR_NO_COST_EMI = 10000;
const cancellationReason = "Cancel reason is not specified by the customer.";
const pdpResourceFacetLabels = [
    "ProductIsExclusive_s"
];
const constants_SEARCH_PDP_FL = [
    "CustomerFacingSKU_s",
    "ProductServices_ss",
    "ProductPriceSpiderIncluded_s",
    "SKUIsProjectPack_s",
    "Color.SKU.Details_ss",
    "ProductYoutubeID_s",
    "productRegionAllVariantDiscontinued_b",
    "ProductOverallLengthInches_s",
    "ProductOverallWidthInches_s",
    "ProductOverallHeightInches_s",
    "ProductWebFeatures_ss",
    "ProductFreightPolicyType_s",
    "priceList.*.finalPrice_d",
    "priceList.*.saleOffer_s",
    "ProductWebTechnology_ss",
    "ProductNarrativeDescription_s",
    "ProductWebMaterial_ss",
    "ProductWebInstallation_ss",
    "ProductWebHydrotherapy_ss",
    "ProductWebRebates_ss",
    "SKUDiscontinuedDate_dt",
    "ProductResource.YouTubeInstallVideo.resourceName_ss",
    "ProductResource.YouTubeInstallVideo.resourceTitle_ss",
    "ctProductType_s",
    "isCollapsedPDP_b",
    "productInRiverId_s",
    "sku_s",
    "SKUCountryofOrigin_s",
    "ProductOverallLengthCm_d",
    "ProductOverallWidthCm_d",
    "ProductOverallHeightCm_d",
    "ProductPackageContents_s",
    "InstallationCost_s",
    "RequiredAccessoryGroupName_ss",
    "RequiredAccessoryGroupProduct_ss",
    "Recommended_Accessories_ss",
    "RegionSoldOnline_b",
    "productDiscontinued_b",
    pdpResourceFacetLabels.join(","),
    constants_resourceFacetLabels().join(","),
    "title_s",
    "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
    "ProductResource.SpecPDFFileName.resourceTitle_ss",
    "ProductResource.EnvironProdDecl.resourceFullWebURL_ss",
    "ProductResource.EnvironProdDecl.resourceTitle_ss",
    "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
    "ProductResource.HomeownersGuide.resourceTitle_ss",
    "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
    "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
    "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
    "ProductResource.DXFPlanView.resourceFullWebURL_ss",
    "ProductResource.DWGPlanView.resourceFullWebURL_ss",
    "ProductResource.DXFFrontView.resourceFullWebURL_ss",
    "ProductResource.DWGFrontView.resourceFullWebURL_ss",
    "ProductResource.DXFSideView.resourceFullWebURL_ss",
    "ProductResource.DWGSideView.resourceFullWebURL_ss",
    "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
    "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
    "ProductResource.3DRevit.resourceFullWebURL_ss",
    "ProductResource.3D3DS.resourceFullWebURL_ss",
    "ProductResource.3DSketchup.resourceFullWebURL_ss",
    "ProductResource.CutOutDXF.resourceFullWebURL_ss",
    "ProductResource.3DOBJ.resourceFullWebURL_ss",
    "productVideos.labelWithUrl_ss"
];
const constants_staticClasses = {
    CONTAINER: "container responsivegrid",
    ONETRUST_ANALYTICS: ""
};
const paymentSubscriptionKey = "bfc9ec279e354edd9a933c507fa0d8dd";
const PDP_SLIDER_SIZES = {
    largeIpadSize: 1024,
    mobileSize: 767,
    desktopSliderImages: 15,
    smallesIpadSliderImages: 12,
    imageReelTitle: "image reel"
};


/* harmony default export */ var constants_0 = (constants);


/***/ }),

/***/ 64757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ABANDONED_CARTS_URL; }
/* harmony export */ });
const ABANDONED_CARTS_URL = "/cart/abandone/data";


/***/ }),

/***/ 83699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kD": function() { return /* reexport */ getAttributeValue; },
  "PW": function() { return /* reexport */ getQuantityCount; },
  "qs": function() { return /* binding */ helperV2_getStateName; },
  "oO": function() { return /* reexport */ sanitizeText; },
  "oH": function() { return /* reexport */ validateEmail; },
  "a$": function() { return /* reexport */ validatePhone; }
});

// UNUSED EXPORTS: checkStock, convertToPhoneNumber, getCountryCode, getCountryName, getStateCode, sanitizeDOMString

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(27856);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
;// CONCATENATED MODULE: ./src/js/helperV2.js



const sanitizeText = (text)=>text.replace(/<\/?[^>]+(>|$)/g, "");
const checkStock = (backOrder, category)=>{
    if (!category) return false;
    if (backOrder === true || backOrder === "Yes") return false;
    if (category === "Install Services") return false;
    if (category === "Design Services") return false;
    return true;
};
const getQuantityCount = (data)=>{
    var ref;
    const totalCount = (ref = data === null || data === void 0 ? void 0 : data.filter((item)=>{
        var ref, ref1;
        return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
    })) === null || ref === void 0 ? void 0 : ref.reduce(function(accumulator, item) {
        return accumulator + item.quantity;
    }, 0);
    return totalCount;
};
const sanitizeDOMString = (property)=>typeof property === "string" ? DOMPurify.sanitize(property) : property;
const getStateCode = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.code === countryVal)) {
        country = data.find((obj)=>obj.code === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.name === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.code === stateVal)) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.name === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _code;
    return (_code = state.code) !== null && _code !== void 0 ? _code : "";
};
const getCountryCode = (countryVal, data)=>{
    if (data.find((obj)=>obj.code === countryVal)) return countryVal;
    var ref;
    const country = (ref = data.find((obj)=>obj.name === countryVal)) !== null && ref !== void 0 ? ref : {};
    var _code;
    return (_code = country.code) !== null && _code !== void 0 ? _code : "";
};
const getStateName = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.name === countryVal)) {
        country = data.find((obj)=>obj.name === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.code === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.name === stateVal)) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.code === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _name;
    return (_name = state.name) !== null && _name !== void 0 ? _name : "";
};
const getCountryName = (countryVal, data)=>{
    if (data.find((obj)=>obj.name === countryVal)) return countryVal;
    var ref;
    const country = (ref = data.find((obj)=>obj.code === countryVal)) !== null && ref !== void 0 ? ref : {};
    var _name;
    return (_name = country.name) !== null && _name !== void 0 ? _name : "";
};
const convertToPhoneNumber = (text)=>{
    try {
        if (text) {
            const value = text;
            const x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            return !x[2] ? "(" + x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
        } else {
            return;
        }
    } catch (error) {
        console.error(error);
    }
};
const validateEmail = (email)=>{
    if (constants["default"].REGEX_EMAIL.test(email)) return true;
    return false;
};
const validatePhone = (phone)=>{
    phone = phone.replace("(", "");
    phone = phone.replace(")", "");
    phone = phone.replace(" ", "");
    phone = phone.replace("-", "");
    if (/^\d+$/.test(phone) && phone.length > 9) return true;
    return false;
};
const getAttributeValue = (attributes, name)=>get_default()(attributes.find((attr)=>attr.name === name), "value", "");


;// CONCATENATED MODULE: ./js/helperV2.js
const helperV2_convertToPhoneNumber = (text)=>{
    try {
        if (text) {
            const value = text;
            const x = value.replace(/\D/g, "");
            return x;
        } else {
            return;
        }
    } catch (error) {
        console.error(error);
    }
};
const helperV2_getStateName = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.name === countryVal)) {
        country = data.find((obj)=>obj.name === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.code === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.name.toLowerCase() === stateVal.toLowerCase())) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.code === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _name;
    return (_name = state.name) !== null && _name !== void 0 ? _name : "";
};



/***/ }),

/***/ 37645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _loadableContext = __webpack_require__(33644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 82470:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(83454);
__webpack_require__(2350);
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && "production" === "production";
var isString = function(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node =  true && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    }
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if ( true && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) {
                    console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                }
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function(rule, index) {
                if (typeof index === "number") {
                    _this._serverSheet.cssRules[index] = {
                        cssText: rule
                    };
                } else {
                    _this._serverSheet.cssRules.push({
                        cssText: rule
                    });
                }
                return index;
            },
            deleteRule: function(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) {
            return tag.sheet;
        }
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) {
                return document.styleSheets[i];
            }
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (false) {}
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") {
                index = sheet.cssRules.length;
            }
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || "object" === "undefined") {
            var sheet =  true ? this.getSheet() : 0;
            if (!rule.trim()) {
                rule = this._deletedRulePlaceholder;
            }
            if (!sheet.cssRules[index]) {
                // @TBD Should we throw an error?
                return index;
            }
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (false) {}
        if (this._optimizeForSpeed) {
            this.replaceRule(index, "");
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (true) {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else {}
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (false) {}
        return this._tags.reduce(function(rules, tag) {
            if (tag) {
                rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                    return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
                }));
            } else {
                rules.push(null);
            }
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) {
            invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        }
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) {
            tag.appendChild(document.createTextNode(cssString));
        }
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) {
            head.insertBefore(tag, relativeToTag);
        } else {
            head.appendChild(tag);
        }
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) {
        throw new Error("StyleSheet: " + message + ".");
    }
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i){
        _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) {
        return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
        cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (false) {}
    var idcss = id + css;
    if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    }
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if ( true && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) {
        throw new Error("StyleSheetRegistry: " + message + ".");
    }
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
        return null;
    }
    if (false) {}
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
__webpack_unused_export__ = StyleRegistry;
__webpack_unused_export__ = createStyleRegistry;
exports.style = JSXStyle;
__webpack_unused_export__ = useStyleRegistry;


/***/ }),

/***/ 51857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(82470).style;


/***/ }),

/***/ 77932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ authClient; },
/* harmony export */   "Z": function() { return /* binding */ initAuth; }
/* harmony export */ });
/* harmony import */ var _okta_okta_auth_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30156);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34326);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45094);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55111);





let authClient;
const initAuth = async (config)=>{
    const { general: { homepageUrl ="" , registerNonKohlerProductPath ="" , isPublish  } = {} , commerce: { sessionAuth: { securePagePathList =[]  } = {}  } = {} , apiEndpoints: { oktaClientId ="" , oktaIssuerUrl ="" , oktaLogoutUri =""  } = {}  } = config || {};
    authClient = new _okta_okta_auth_js__WEBPACK_IMPORTED_MODULE_0__/* .OktaAuth */ .snk({
        issuer: oktaIssuerUrl,
        clientId: oktaClientId,
        redirectUri: "https://www.kohler.co.in",
        postLogoutRedirectUri: oktaLogoutUri,
        scopes: [
            "openid",
            "offline_access",
            "kin-session"
        ],
        pkce: true,
        useInteractionCodeFlow: true
    });
    authClient.start();
    let prevAuthState = null;
    authClient.authStateManager.subscribe((authState)=>{
        if (authState.isAuthenticated) {
            const payload = {
                accessToken: authState.accessToken.accessToken,
                refreshToken: authState.refreshToken.refreshToken,
                user: authState.accessToken.claims || {},
                isAuth: authState.isAuthenticated
            };
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .postLogin */ .SV)(payload));
        }
        if (prevAuthState && prevAuthState.isAuthenticated !== authState.isAuthenticated) {
            if (document.hidden) window.location.reload();
        }
        prevAuthState = authState;
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.addPageLoadAnalyticsEvent)();
    });
    authClient.tokenManager.on("error", async function(err) {
        console.error(err);
        await authClient.signOut({
            clearTokensBeforeRedirect: true
        });
        await authClient.session.close();
    });
    const isLoggedInRedirect = await authClient.isLoginRedirect();
    if (isLoggedInRedirect) {
        const { tokens  } = await authClient.token.parseFromUrl();
        authClient.tokenManager.setTokens(tokens);
        const { accessToken  } = tokens;
        _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .postLogin */ .SV)(accessToken.claims));
    } else {
        authClient.authStateManager.updateAuthState();
        try {
            const accessToken1 = await authClient.tokenManager.get("accessToken");
            const isSessionExists = await authClient.session.exists();
            if (accessToken1 && !authClient.tokenManager.hasExpired(accessToken1) && isSessionExists) {
                // check  if force renewal requested in previous session
                const userInfo = sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_4__["default"].KF_UPDATE_MEMBERSHIP);
                console.log("userInfo", userInfo);
                if (localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_4__["default"].KF_FORCE_RENEW_TOKEN)) {
                    if (userInfo) {
                        const user = JSON.parse(userInfo);
                        if (user.uid === accessToken1.claims.uid) {
                            const payload = {
                                user: accessToken1.claims
                            };
                            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .postLogin */ .SV)(payload));
                            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .setPersona */ .nf)(user.persona));
                        }
                    } else {
                        const renwedToken = await authClient.tokenManager.renew("accessToken");
                        const payload1 = {
                            user: renwedToken.claims
                        };
                        _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .postLogin */ .SV)(payload1));
                        localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_4__["default"].KF_FORCE_RENEW_TOKEN);
                    }
                } else {
                    const payload2 = {
                        user: accessToken1.claims
                    };
                    _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .postLogin */ .SV)(payload2));
                }
            } else if (isSessionExists) {
                authClient.token.getWithRedirect({
                    responseType: [
                        "id_token",
                        "access_token",
                        "code"
                    ],
                    state: location.href
                }).catch((err)=>{
                    console.error("error in getting token", err);
                });
            } else if (!accessToken1) {
                const isProtected = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.isProtectedUrl)();
                if (isProtected && isPublish) {
                    const redirectAction = {
                        isLoginAction: true,
                        loginCallbackURL: window.location.href
                    };
                    localStorage.setItem("SecurePageRedirect", JSON.stringify(redirectAction));
                    if (!(window.location.href.includes("status") && window.location.href.includes("/order-details"))) {
                        window.location.replace(await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.getShortenedUrl)(homepageUrl));
                    }
                } else if (localStorage.getItem("SecurePageRedirect")) {
                    const redirectAction1 = JSON.parse(localStorage.getItem("SecurePageRedirect"));
                    if (redirectAction1.isLoginAction) {
                        window.loginCallback = redirectAction1.loginCallbackURL;
                        localStorage.removeItem("SecurePageRedirect");
                        _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .setAuthModalVisibility */ .LY)({
                            show: false
                        }));
                    }
                }
            // store?.dispatch(getOktaToken("guest"))
            } else {
                _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .logout */ .kS)());
            }
        } catch (err) {
            console.error("Okta error while getting access token from token manager", err);
        }
        triggerLoginFlow();
    }
    securePagePathList.forEach((path)=>{
        document.querySelectorAll('a[href="'.concat(path, '"]')).forEach((tag)=>{
            tag.onclick = function(e) {
                e.preventDefault();
                if (registerNonKohlerProductPath === this.href) {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.setWindowProps)("signUpConfirmationCTA", "Register Products");
                }
                (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.isAuthenticated)(this.href);
            };
        });
    });
    document.querySelectorAll('a[href^="#isAuth"]').forEach((link)=>{
        link.addEventListener("click", (e)=>{
            e.preventDefault();
            const url = e.target.href.split("::")[1];
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.isAuthenticated)(url);
        });
    });
    document.querySelectorAll('a[href*="#KPN"]').forEach((link)=>{
        link.addEventListener("click", (e)=>{
            e.preventDefault();
            const link = e.target.href.split("::");
            const id = link[0];
            const url = link[1];
            if (link) {
                _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .setHideCustomerSignupCTA */ .n$)(true));
                if (id.includes("signIn")) {
                    window.KPNSignIn = true;
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.isAuthenticated)(url, 0, true);
                } else if (id.includes("createAccount")) {
                    window.KPNSignIn = false;
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.isAuthenticated)(url, 1, true);
                } else {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.isAuthenticated)(url);
                }
            }
        });
    });
};
const triggerLoginFlow = ()=>{
    var ref;
    const hash = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hash;
    if (hash === null || hash === void 0 ? void 0 : hash.includes("#isAuth")) {
        const url = hash.split("::")[1];
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.isAuthenticated)(url);
    }
};



/***/ }),

/***/ 50023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H3": function() { return /* binding */ getInitialSku; },
/* harmony export */   "O1": function() { return /* binding */ getZipCodeJsonFile; },
/* harmony export */   "i8": function() { return /* binding */ initPriceSpider; },
/* harmony export */   "lX": function() { return /* binding */ getTeaserFragments; },
/* harmony export */   "lk": function() { return /* binding */ getShippingLocations; },
/* harmony export */   "tz": function() { return /* binding */ checkProductCategory; },
/* harmony export */   "yS": function() { return /* binding */ getRequireItems; }
/* harmony export */ });
/* unused harmony export getTeaserDetails */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55111);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20558);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45094);
/* harmony import */ var _store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44561);
/* harmony import */ var _components_ProductDetail_v3_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3155);








const getInitialSku = (productData, setSkuVariantCb)=>{
    var ref;
    let colors = [];
    if (productData["Color.SKU.Details_ss"]) {
        colors = productData["Color.SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                sku: d[2],
                discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now())
            };
        });
    } else if (productData["Color.SKU.Details_s"]) {
        const d = productData["Color.SKU.Details_s"].split("|");
        colors = [
            {
                sku: d[2],
                discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now())
            }
        ];
    } else if (productData["SKU.Details_ss"]) {
        colors = productData["SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                sku: d[0],
                discontinued: !(d[2] === "false" || Date.parse(d[2]) > Date.now())
            };
        });
    }
    const availableSkus = colors.filter((color)=>!color.discontinued);
    const discontinuedAvailableSkus = colors.filter((color)=>color.discontinued);
    let initSku = "";
    if ((ref = availableSkus[0]) === null || ref === void 0 ? void 0 : ref.sku) {
        var ref1;
        var ref2;
        initSku = (ref2 = (ref1 = availableSkus[0]) === null || ref1 === void 0 ? void 0 : ref1.sku) !== null && ref2 !== void 0 ? ref2 : productData["masterSKU_s"];
    } else {
        var ref3;
        var ref4;
        initSku = ((ref4 = (ref3 = discontinuedAvailableSkus[0]) === null || ref3 === void 0 ? void 0 : ref3.sku) !== null && ref4 !== void 0 ? ref4 : productData["variantList.sku_ss"]) ? productData["variantList.sku_ss"][0] : productData["variantList.sku_s"];
    }
    setSkuVariantCb && setSkuVariantCb(initSku);
    return initSku;
};
const checkProductCategory = (productCategory, category)=>{
    if (productCategory === category || productCategory === "") {
        return true;
    }
    return false;
};
const getZipCodeJsonFile = (jsonFileUrl, getZipCodeJsonFileCb)=>{
    try {
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(jsonFileUrl)) {
            (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
                url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: jsonFileUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    getZipCodeJsonFileCb && getZipCodeJsonFileCb(response.data);
                } else {
                    console.error("API endpoint Url: Error occured while fetching data from Get URL Property");
                }
            });
        } else {
            console.warn("API endpoint Url: Get URL Property not found");
        }
    } catch (error) {
        console.error(error);
    }
};
const getShippingLocations = (statesData, states)=>{
    let resultTxt = "";
    if (statesData && (states === null || states === void 0 ? void 0 : states.length) > 0) {
        states.map((state, i)=>{
            const stateObj = statesData.find((st)=>{
                var ref;
                return state === ((ref = st.value) === null || ref === void 0 ? void 0 : ref.replace(/:US/g, ""));
            });
            if (stateObj === null || stateObj === void 0 ? void 0 : stateObj.text) {
                resultTxt = resultTxt + stateObj.text;
                if (i === states.length - 2) resultTxt += " and ";
                else if (i !== states.length - 1) resultTxt += ", ";
            }
        });
    }
    return resultTxt;
};
const getRequireItems = (items, discountedPrice, price, setInstallReqCb, setSubTotalCb, setPriceListCb, addItemsToCartCb)=>{
    setInstallReqCb(items);
    const cartItemProduct = [];
    const priceListItems = [];
    let requiredItemsPrice = 0;
    let priceLists = 0;
    let baseTotal = 0;
    let subTotalItem = 0;
    if (items.length > 0) {
        items && items.map((list)=>{
            const product = {};
            product.sku = list.skuid;
            product.brand = list.brandName;
            if (list.backorder) {
                product.quantity = 1;
                product.backorder = true;
                cartItemProduct.push(product);
            } else {
                const checkQuantity = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.colorsData.find((requiredItem)=>requiredItem.id === list.skuid), "isOutOfStock", false);
                product.quantity = !checkQuantity ? 1 : 0;
                if (!checkQuantity) {
                    cartItemProduct.push(product);
                }
            }
            if (list === null || list === void 0 ? void 0 : list.priceData) {
                priceLists = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.priceData.find((requiredList)=>requiredList.id === list.skuid), "discountedPrice", 0) > 0 ? lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.priceData.find((requiredList)=>requiredList.id === list.skuid), "discountedPrice", 0) : lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.priceData.find((requiredList)=>requiredList.id === list.skuid), "price", 0);
                priceListItems.push(priceLists);
                if (priceListItems.length >= 0) {
                    requiredItemsPrice = priceListItems.reduce((acc, item)=>{
                        return parseFloat(acc) + parseFloat(item);
                    }, 0);
                } else {
                    requiredItemsPrice = priceListItems[0];
                }
                baseTotal = discountedPrice > 0 ? discountedPrice : price;
                subTotalItem = baseTotal + requiredItemsPrice;
                setSubTotalCb(subTotalItem);
                setPriceListCb(requiredItemsPrice);
            }
        });
        addItemsToCartCb(cartItemProduct, false);
    } else {
        addItemsToCartCb([], false);
    }
};
const getTeaserFragments = (pageData, pdpData)=>{
    const teaserFragmentOrder = getFragmentsOrder(pageData);
    var ref;
    const customerFacingSKU = (ref = pdpData["masterSKU_s"]) !== null && ref !== void 0 ? ref : "";
    var ref1;
    const category = (ref1 = pdpData["ProductLocalCategory_s"]) !== null && ref1 !== void 0 ? ref1 : "";
    const pdpXFPaths = getFragmentPaths(pageData);
    if (teaserFragmentOrder && teaserFragmentOrder.length) {
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setIsTeaserLoaded */ .ZR)(true));
        const params = {
            skuId: customerFacingSKU,
            category: category
        };
        if (pdpXFPaths) params.xfPaths = pdpXFPaths;
        (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
            url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.PDP_TEASER_DETAILS,
            params
        }).then((response)=>{
            const { data  } = response;
            if (data && teaserFragmentOrder.length) getTeaserDetails(data, teaserFragmentOrder);
            else console.error("PDP Teaser Fragments Order Not Found..!");
        }).catch((error)=>{
            console.error("PDP Teaser Fragments Fetching Error..!");
        });
    }
};
const getFragmentsOrder = (pageData)=>{
    const itemOrder = [];
    const teaserFragments = (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .recursiveDataFunction */ .Qe)(pageData, _constants_index__WEBPACK_IMPORTED_MODULE_3__.COMPONENT_TYPES.PRODUCT_DETAILS_EXFPDP);
    if (teaserFragments && teaserFragments.length) {
        const list = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(teaserFragments[0], "configuredXfPathModels", "");
        list.map((item)=>{
            const itemArray = item && (item === null || item === void 0 ? void 0 : item.path) && item.path.split("/");
            itemOrder.push(itemArray[itemArray.length - 1]);
        });
        return itemOrder;
    }
};
const getFragmentPaths = (pageData)=>{
    const teaserFragments = (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .recursiveDataFunction */ .Qe)(pageData, _constants_index__WEBPACK_IMPORTED_MODULE_3__.COMPONENT_TYPES.PRODUCT_DETAILS_EXFPDP);
    if (teaserFragments && teaserFragments.length) {
        const fragmentPaths = teaserFragments.reduce((paths, fragment)=>{
            const list = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(fragment, "configuredXfPathModels", "");
            list.forEach((item)=>{
                paths.push(item === null || item === void 0 ? void 0 : item.path);
            });
            return paths;
        }, []);
        return fragmentPaths.join(",");
    }
    return "";
};
const getTeaserDetails = (data, teaserFragmentOrder)=>{
    const teaserDataPromises = [];
    teaserFragmentOrder.forEach((item)=>{
        if (data[item]) {
            teaserDataPromises.push(new Promise((resolve, reject)=>{
                (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
                    url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(data[item], ".model.json")
                    }
                }).then((res)=>{
                    resolve(res.data);
                }).catch((error)=>{
                    reject(error);
                });
            }));
        }
    });
    Promise.all(teaserDataPromises).then((response)=>{
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setTeaserContent */ .ub)(response));
    }).catch((error)=>{
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setTeaserContent */ .ub)([]));
        console.error("PDP Teaser Fragments Data Fetching Error..!");
    });
};
const initPriceSpider = ()=>{
    const waitTimeForPsWidgetElementsToLoad = 500;
    let psWidgetNode = document.getElementsByClassName("ps-widget")[0];
    // Here reason to use mutation observer instead of react ref is bcoz
    // this ps widget elements are getting fluctuated
    const psWidgetObserver = new MutationObserver(()=>{
        // fired when a mutation occurs
        psWidgetNode.querySelectorAll("div[data-retailer]").forEach((retailerDiv)=>{
            var ref;
            const btn = retailerDiv.querySelector(".ps-online-buy-button");
            const retailer = (ref = retailerDiv.getAttribute("data-retailer")) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            if (btn.getAttribute("attachedEvent") !== "true") {
                btn.addEventListener("click", (e)=>{
                    (0,_components_ProductDetail_v3_analytics__WEBPACK_IMPORTED_MODULE_7__/* .addBuyBtnAnalytics */ .f8)(e, retailer);
                }, false);
                btn.setAttribute("attachedEvent", "true");
            }
        });
    });
    let psWidgetObserverTimeout;
    const addObserverIfDesiredNodeAvailable = ()=>{
        psWidgetNode = document.getElementsByClassName("ps-widget")[0];
        if (!psWidgetNode) {
            psWidgetObserverTimeout = setTimeout(addObserverIfDesiredNodeAvailable, waitTimeForPsWidgetElementsToLoad);
            return;
        }
        if (psWidgetObserverTimeout) {
            clearTimeout(psWidgetObserverTimeout);
            psWidgetObserverTimeout = undefined;
        }
        const config = {
            subtree: true,
            childList: true
        };
        psWidgetObserver.observe(psWidgetNode, config);
    };
    addObserverIfDesiredNodeAvailable();
};


/***/ }),

/***/ 71990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ PURE_TEXT_REGEX; },
/* harmony export */   "FU": function() { return /* binding */ SPECIAL_CHAR_REGEX; },
/* harmony export */   "If": function() { return /* binding */ SANITIZE_TEXT_REGEX; },
/* harmony export */   "Vb": function() { return /* binding */ MEMBERSHIP_CODE_ERROR_REGEX; },
/* harmony export */   "dd": function() { return /* binding */ MEMBERSHIP_VALID_MAIL_ERROR_REGEX; },
/* harmony export */   "si": function() { return /* binding */ ALPHABET_WITH_SPACE_REGEX; },
/* harmony export */   "ub": function() { return /* binding */ PDP_REGEX; }
/* harmony export */ });
/* unused harmony export FULL_NAME_REGEX */
const SANITIZE_TEXT_REGEX = /[^a-zA-Z<>&@.-\d\s:]/g;
const PDP_REGEX = /^([\/]).*.([\-]).([0-9]{2,}).*$/gm;
const MEMBERSHIP_VALID_MAIL_ERROR_REGEX = /\S+@\S+\.\S+/;
const MEMBERSHIP_CODE_ERROR_REGEX = /@kohler.com\s*$/;
const FULL_NAME_REGEX = /^[a-zA-Z]+ [a-zA-Z]+$/;
const PURE_TEXT_REGEX = /<[^>]*>/g;
const SPECIAL_CHAR_REGEX = /[^a-zA-Zd0-9 ]/g;
const ALPHABET_WITH_SPACE_REGEX = /^[a-zA-Z ]+$/;


/***/ }),

/***/ 7154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useIsSsr = ()=>{
    // we always start off in "SSR mode", to ensure our initial browser render
    // matches the SSR render
    const [isSsr, setIsSsr] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        // `useEffect` never runs on the server, so we must be on the client if
        // we hit this block
        setIsSsr(false);
    }, []);
    return isSsr;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsSsr);


/***/ }),

/***/ 34201:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

const HttpBackend = __webpack_require__(78122);
const ChainedBackend = (__webpack_require__(81580)/* ["default"] */ .Z);
const LocalStorageBackend = (__webpack_require__(70660)/* ["default"] */ .Z);
module.exports = {
    backend: {
        backendOptions: [
            {
                expirationTime: 60 * 60 * 1000
            },
            {
                // need to revisit this block to load dictionaryPath from global config -  currently not possible due to incompatability with cjs modules. need to redefine imports and exports in future
                loadPath: async function(lng, ns) {
                    const dictionaryPath = "/content/kohler.i18nDictionary.json";
                    return "/api/locales/".concat(lng, "/").concat(ns, ".json?path=").concat(dictionaryPath);
                }
            }
        ],
        backends:  true ? [
            LocalStorageBackend,
            HttpBackend
        ] : 0
    },
    i18n: {
        locales: [
            "en",
            "fr"
        ],
        defaultLocale: "en"
    },
    ns: [
        "common"
    ],
    serializeConfig: false,
    use:  true ? [
        ChainedBackend
    ] : 0
};


/***/ }),

/***/ 37344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "reportWebVitals": function() { return /* binding */ reportWebVitals; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(51857);
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/styles/index.scss
var styles = __webpack_require__(44366);
// EXTERNAL MODULE: ./src/styles/index_main.scss
var index_main = __webpack_require__(6689);
// EXTERNAL MODULE: ./src/styles/clientlib-site.min.css
var clientlib_site_min = __webpack_require__(20127);
// EXTERNAL MODULE: ./styles/clientlib-base.min.css
var clientlib_base_min = __webpack_require__(28380);
// EXTERNAL MODULE: ./styles/overrides.scss
var overrides = __webpack_require__(81076);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(95828);
// EXTERNAL MODULE: ./components/core/PageLoader/PageLoader.jsx + 1 modules
var PageLoader = __webpack_require__(41600);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Shared/ErrorBoundary/index.jsx


/**
 * Class declaration for handling frontend errors
 */ class ErrorBoundary extends react.Component {
    /**
   *
   * @param {*} error
   * @return {boolean}
   */ static getDerivedStateFromError(error) {
        return {
            hasError: true
        };
    }
    /**
   *
   * @param {*} error
   * @param {*} errorInfo
   */ componentDidCatch(error, errorInfo) {
        // You can use your own error logging service here
        console.log({
            error,
            errorInfo
        });
    }
    /**
   *
   * @return {JSX.Element}
   */ render() {
        if (this.state.hasError) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Oops, there is an error!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        "aria-label": "Oops, there is an error!, try again?",
                        onClick: ()=>this.setState({
                                hasError: false
                            }),
                        children: "Try again?"
                    })
                ]
            });
        }
        return this.props.children;
    }
    /**
   *
   * @param {*} props
   */ constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
/* harmony default export */ var Shared_ErrorBoundary = (ErrorBoundary);

;// CONCATENATED MODULE: ./src/components/Shared/Layout.jsx

const Layout = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                props.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-backdrop fade show"
                }),
                children
            ]
        })
    });
};
/* harmony default export */ var Shared_Layout = (Layout);

// EXTERNAL MODULE: ./store/index.js + 1 modules
var store = __webpack_require__(45094);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/integration/react.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 // eslint-disable-line import/no-unresolved

var PersistGate =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      bootstrapped: false
    });

    _defineProperty(_assertThisInitialized(_this), "_unsubscribe", void 0);

    _defineProperty(_assertThisInitialized(_this), "handlePersistorState", function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).finally(function () {
            return _this.setState({
              bootstrapped: true
            });
          });
        } else {
          _this.setState({
            bootstrapped: true
          });
        }

        _this._unsubscribe && _this._unsubscribe();
      }
    });

    return _this;
  }

  _createClass(PersistGate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: "render",
    value: function render() {
      if (false) {}

      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }

      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(react.PureComponent);

_defineProperty(PersistGate, "defaultProps", {
  children: null,
  loading: null
});
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./services/auth.service.js
var auth_service = __webpack_require__(77932);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/store/features/locationSlice.js
var locationSlice = __webpack_require__(13644);
// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./src/next-i18next.config.js
var next_i18next_config = __webpack_require__(34201);
var next_i18next_config_default = /*#__PURE__*/__webpack_require__.n(next_i18next_config);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./src/constants/regex.js
var regex = __webpack_require__(71990);
;// CONCATENATED MODULE: ./src/pages/_app.jsx
/* provided dependency */ var process = __webpack_require__(83454);
/* eslint-disable new-cap */ 























const Toaster = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2182).then(__webpack_require__.bind(__webpack_require__, 2182)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2182)
            ]
    },
    ssr: false
});







const AuthModal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4432), __webpack_require__.e(1433), __webpack_require__.e(7636)]).then(__webpack_require__.bind(__webpack_require__, 20172)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(20172)
            ]
    },
    ssr: false
});
const CartActionModal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4432), __webpack_require__.e(582)]).then(__webpack_require__.bind(__webpack_require__, 90582)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90582)
            ]
    },
    ssr: false
});
const NewsLetterSignUpOverlay = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4432), __webpack_require__.e(627)]).then(__webpack_require__.bind(__webpack_require__, 90627)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90627)
            ]
    },
    ssr: false
});
const CompareProducts = dynamic_default()(()=>process.env.NEXT_PUBLIC_COMPARE_PRODUCTS_VERSION === "compare_products_v1" ? Promise.all(/* import() */[__webpack_require__.e(4432), __webpack_require__.e(7333), __webpack_require__.e(8153), __webpack_require__.e(6075)]).then(__webpack_require__.bind(__webpack_require__, 26075)) : Promise.all(/* import() */[__webpack_require__.e(4432), __webpack_require__.e(7333), __webpack_require__.e(8153), __webpack_require__.e(347)]).then(__webpack_require__.bind(__webpack_require__, 60347)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(60347)
            ]
    },
    ssr: false
});
const PromoModal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3411).then(__webpack_require__.bind(__webpack_require__, 73411)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(73411)
            ]
    },
    ssr: false
});






const PreviewCart = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4432), __webpack_require__.e(7333), __webpack_require__.e(2989), __webpack_require__.e(8221)]).then(__webpack_require__.bind(__webpack_require__, 33902)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33902)
            ]
    },
    ssr: false
});
if (false) {}
const MyApp = store/* wrapper.withRedux */.YS.withRedux((param)=>{
    let { Component , pageProps  } = param;
    const store = (0,es/* useStore */.oR)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { globalScripts , globalStyles , dataLayerObj , pageIsInteractive , toaster: { isVisible  } , menu: { isOpen  } , previewCart: { showPreview  } , newslettersignup , eventPageType , compareproducts , promoBannerModal , isProductInfo , gatedContentData  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { utilityLocation =""  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const { compare  } = router.query;
    const { comparedProducts  } = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const [showCompare, setShowCompare] = (0,react.useState)(false);
    const [previewMode, setPreviewMode] = (0,react.useState)(false);
    const { authModal: { show  } = {} , showCartAction =false  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { cart: cartObj  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [scriptsLoaded, setScriptsLoaded] = (0,react.useState)(0);
    const [showCampaign, setShowCampaign] = (0,react.useState)(false);
    const isRestricted = constants.EXCLUDE_PAGES.indexOf(router.pathname) >= 0;
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        (0,utils/* affirmRefresh */.Bq)();
        (0,constants_config/* initConfig */.p)().then(async ()=>{
            const config = await (0,constants_config/* getConfig */.i)();
            await (0,auth_service/* initAuth */.Z)(config);
        });
        var ref4;
        const authModalData = (ref4 = pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.footertmp) === null || ref === void 0 ? void 0 : (ref1 = ref[":items"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.root) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[":items"]) === null || ref3 === void 0 ? void 0 : ref3.authmodal) !== null && ref4 !== void 0 ? ref4 : {};
        dispatch((0,authSlice/* setAuthModalFormData */.id)(authModalData));
        window.adobeDataLayer = window.adobeDataLayer || [];
        document.body.addEventListener("keypress", helper.handleEnter);
        (0,helper.createPersonaCookie)();
        if ((0,helper.getAEMPreviewModeCookie)()) {
            setPreviewMode(true);
        } else {
            setPreviewMode(false);
        }
        if (!utilityLocation) checkForLocation();
        return ()=>document.body.removeEventListener("keypress", helper.handleEnter);
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(gatedContentData)) checkForGatedContentPaths();
    }, [
        gatedContentData
    ]);
    const checkForGatedContentPaths = ()=>{
        if (window) {
            var ref;
            const path = (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname;
            const { gatedContentPathsParameters =[]  } = gatedContentData;
            if (gatedContentPathsParameters.length) {
                var ref1;
                const matchedGatedContent = (ref1 = gatedContentPathsParameters.find((item)=>{
                    const { gatedURL =""  } = item;
                    const securedPath = gatedURL.substring(gatedURL.indexOf(constants.pageUrl), gatedURL.length);
                    return securedPath === path;
                })) !== null && ref1 !== void 0 ? ref1 : {};
                const { gatedURL ="" , landingPageURL =""  } = matchedGatedContent;
                const oktaTokenBrowStorage = localStorage.getItem("okta-token-storage");
                const oktaTokenStorage = oktaTokenBrowStorage ? JSON.parse(oktaTokenBrowStorage) : {};
                const isAnonymous = isEmpty_default()(oktaTokenStorage);
                if (gatedURL && landingPageURL && isAnonymous) {
                    var ref2;
                    const redirectBackUrl = (ref2 = landingPageURL.substring(landingPageURL.indexOf("/en"), landingPageURL.length)) !== null && ref2 !== void 0 ? ref2 : "/en";
                    dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                        show: true,
                        onCloseHandlation: ()=>handleCloseOfModal(redirectBackUrl)
                    }));
                }
            }
        }
    };
    const handleCloseOfModal = function() {
        let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        window.location.replace(url);
    };
    const checkForLocation = ()=>{
        if (localStorage.getItem("currentZipCode")) {
            dispatch((0,locationSlice/* setUtilityLocation */.NL)({
                utilityLocation: localStorage.getItem("currentZipCode")
            }));
            return;
        }
        (0,helper.getMyLocation)().then((getLocation)=>{
            var _zipcode, _city;
            const details = {
                utilityLocation: (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "",
                userCity: (_city = getLocation.city) !== null && _city !== void 0 ? _city : ""
            };
            dispatch((0,locationSlice/* setCityLocation */.OX)(details));
            var _zipcode1;
            localStorage.setItem("currentZipCode", (_zipcode1 = getLocation.zipcode) !== null && _zipcode1 !== void 0 ? _zipcode1 : "");
        }).catch((err)=>{
            (0,helper.getMyLocationByUserIP)().then((getLocation)=>{
                var _zipcode, _city;
                const details = {
                    utilityLocation: (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "",
                    userCity: (_city = getLocation.city) !== null && _city !== void 0 ? _city : ""
                };
                dispatch((0,locationSlice/* setCityLocation */.OX)(details));
                var _zipcode1;
                localStorage.setItem("currentZipCode", (_zipcode1 = getLocation.zipcode) !== null && _zipcode1 !== void 0 ? _zipcode1 : "");
            }).catch((error)=>{
                // eslint-disable-next-line no-console
                console.log(error);
            });
        });
    };
    (0,react.useEffect)(()=>{
        let queueDelay;
        if (cartObj === null || cartObj === void 0 ? void 0 : cartObj.id) {
            (0,helper.calculateCartData)({
                cart: cartObj
            }).then((res)=>{
                // added timeout for queueing to the callback stack
                // fix for cart not updating to dataLayer sometimes
                queueDelay = setTimeout(()=>{
                    window.adobeDataLayer.forEach(function(part, index, dataLayer) {
                        if (dataLayer[index].event) {
                            var ref;
                            var ref1;
                            const cartItems = (ref1 = res === null || res === void 0 ? void 0 : (ref = res.cart) === null || ref === void 0 ? void 0 : ref.item) !== null && ref1 !== void 0 ? ref1 : [];
                            var ref2;
                            const cartItemStr = cartItems.map((item)=>{
                                var ref;
                                return (ref2 = (ref = item.productInfo) === null || ref === void 0 ? void 0 : ref.productID) !== null && ref2 !== void 0 ? ref2 : "";
                            }).join();
                            dataLayer[index].page.cartInfo = {
                                cartItems: cartItemStr
                            };
                            dataLayer[index].page.cart = res === null || res === void 0 ? void 0 : res.cart;
                            const pageObj = dataLayer[index].page || window.pageObj;
                            const { category: { pageType =""  } = {}  } = pageObj;
                            const pageObjEvent = window.adobeDataLayer.filter((data)=>{
                                return data.event === "cmp:show";
                            });
                            if (pageObjEvent && pageObjEvent.length > 0) {
                                const pageObjEventTmp = {
                                    ...pageObjEvent
                                };
                                pageObjEventTmp.page = pageObj;
                                pageObjEventTmp.event = "cmp:tmpShow";
                                if ((window === null || window === void 0 ? void 0 : window.productInfo) && pageType === "pdp") {
                                    pageObjEventTmp.productInfo = JSON.parse(window === null || window === void 0 ? void 0 : window.productInfo);
                                    pageObjEventTmp.pageInfo = pageObj.pageInfo;
                                }
                                window.adobeDataLayer.push(pageObjEventTmp);
                                window.adobeDataLayer.pop();
                            }
                        }
                    });
                }, 500);
            });
        }
        return ()=>clearTimeout(queueDelay);
    }, [
        cartObj,
        router
    ]);
    (0,react.useEffect)(()=>{
        const onRouterChangeStart = (url)=>{
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(false));
            window.referrer = window.location.href;
            concernBanner("remove");
            clearAdobeTargetVideoTimeout();
        };
        const onRouterChangeComplete = ()=>{
            if (window && window.adobeDataLayer) {
                window.adobeDataLayer.length = 0;
            }
            alterBodyClass();
            const isPdp = (window === null || window === void 0 ? void 0 : window.eventPageType) === "pdp";
            if (!isPdp) {
                window.initDataLayerTop();
            }
            window.isShowAnalyticsEvent = true;
            (0,helper.addPageLoadAnalyticsEvent)();
            delete window.referrer;
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(true));
            concernBanner("add");
            if (pageIsInteractive) appendAdobeTargetVideoScript();
            window.datalayerTopLoaded = false;
        };
        const popStateListener = (e)=>{
            const queryString = window.location.search;
            const path = window.location.pathname;
            const urlParams = new URLSearchParams(queryString);
            const hashedUrl = window.location.hash;
            const eventState = e === null || e === void 0 ? void 0 : e.state;
            if (hashedUrl) {
                var ref;
                const hashUrl = (ref = hashedUrl.split("::")[0]) !== null && ref !== void 0 ? ref : "";
                var ref1;
                const redirectionPath = (ref1 = hashedUrl.split("::")[1]) !== null && ref1 !== void 0 ? ref1 : "";
                if (constants.GATED_HASHES.includes(hashUrl.toLowerCase())) {
                    if ((0,helper.getAnonymousId)()) {
                        let active = 0;
                        if (hashUrl.includes("#signup")) active = 1;
                        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                            show: true,
                            active
                        }));
                        window.gatedPathRedirection = redirectionPath;
                    } else {
                        window.location.href = redirectionPath;
                    }
                }
                if (hashedUrl === "#newsletter") {
                    setShowCampaign(true);
                }
            }
            if (urlParams.has("back") || urlParams.has("keyword") || path == "/en/support/help-and-faq" || path == constants.SUPPORT_CENTER_PATH || path == constants.FIND_A_PRO_PATH || path == constants.INSTALLATION_SERVICES_PATH && (eventState !== null && isEmpty_default()(eventState) || (eventState === null || eventState === void 0 ? void 0 : eventState.previousUrl) === constants.CART_URL || (eventState === null || eventState === void 0 ? void 0 : eventState.previousUrl) === constants.CHECKOUT_URL) || path.includes(constants.TECHNICAL_SPECIFICATION_PATH) || path.includes(constants.LOCATIONS_PATH) || urlParams.has("compare") || regex/* PDP_REGEX.test */.ub.test(path)) {
                router.reload();
            }
        };
        window.addEventListener("popstate", popStateListener);
        router.events.on("routeChangeStart", onRouterChangeStart);
        router.events.on("routeChangeComplete", onRouterChangeComplete);
        return ()=>{
            // concernBanner("remove")
            router.events.off("routeChangeStart", onRouterChangeStart);
            router.events.off("routeChangeComplete", onRouterChangeComplete);
            window.removeEventListener("popstate", popStateListener);
        };
    }, [
        router
    ]);
    const alterBodyClass = ()=>{
        var ref;
        if (pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.tmpData) === null || ref === void 0 ? void 0 : ref.cssClassNames) {
            var ref1;
            document.body.className = pageProps === null || pageProps === void 0 ? void 0 : (ref1 = pageProps.tmpData) === null || ref1 === void 0 ? void 0 : ref1.cssClassNames;
        }
    };
    (0,react.useEffect)(()=>{
        if (dataLayerObj !== "") {
            const pageObj = JSON.parse(dataLayerObj);
            const { pageInfo: { pageUrl =""  } = {}  } = pageObj;
            if (pageUrl.includes(".json")) {
                pageObj.pageInfo.pageUrl = window.location.href;
            }
            window.pageObj = pageObj;
            window.eventPageType = eventPageType;
            window.isShowAnalyticsEvent = true;
            const isPdpLoaded = (window === null || window === void 0 ? void 0 : window.eventPageType) === "pdp" && isProductInfo || (window === null || window === void 0 ? void 0 : window.eventPageType) !== "pdp";
            if (window.pageObj && !window.datalayerTopLoaded && isPdpLoaded) {
                const dataLayerEvent = new Event("datalayerTopFired");
                window.dispatchEvent(dataLayerEvent);
                window.datalayerTopLoaded = true;
            }
        }
    }, [
        dataLayerObj,
        isProductInfo
    ]);
    (0,react.useEffect)(()=>{
        const loadScripts = ()=>{
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(true));
        };
        const loadScriptsTimer = setTimeout(loadScripts, 5000);
        const userInteractionEvents = [
            "mouseover",
            "keydown",
            "touchmove",
            "touchstart",
            "scroll",
            "click"
        ];
        const triggerScriptLoader = ()=>{
            loadScripts();
            clearTimeout(loadScriptsTimer);
            userInteractionEvents.forEach(function(event) {
                window.removeEventListener(event, triggerScriptLoader, {
                    passive: true
                });
            });
        };
        userInteractionEvents.forEach(function(event) {
            window.addEventListener(event, triggerScriptLoader, {
                passive: true
            });
        });
        concernBanner("add");
        // setTimeout(ontrustCookie(), 1000)
        return ()=>{
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(false));
            concernBanner("remove");
        };
    }, []);
    const concernBanner = (action)=>{
        const oneTrustVal = window.OneTrust || window.OneTrustStub;
        if (oneTrustVal && oneTrustVal.ToggleInfoDisplay) {
            var ref;
            if (action === "add") {
                oneTrustVal.initializeCookiePolicyHtml();
                oneTrustVal.LoadBanner();
            }
            (ref = document.querySelectorAll("#ot-sdk-link")[0]) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", function() {
                oneTrustVal.ToggleInfoDisplay();
            });
            if (action === "add") {
                var ref1;
                (ref1 = document.querySelectorAll("#ot-sdk-link")[0]) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", function() {
                    oneTrustVal.ToggleInfoDisplay();
                });
            }
        }
    };
    (0,react.useEffect)(()=>{
        // To remove hide the chat window on openinig menu
        if (lib/* isMobile */.tq) {
            const chatElement = document.getElementsByClassName("embeddedServiceHelpButton");
            if (isOpen && chatElement.length) {
                chatElement.item(0).style.display = "none";
            } else if (chatElement.length) {
                chatElement.item(0).style.display = "block";
            }
        }
    }, [
        isOpen
    ]);
    (0,react.useEffect)(()=>{
        if (compare) {
            setShowCompare(true);
        } else if (comparedProducts && comparedProducts.length > 0) {
            setShowCompare(true);
        } else {
            document.body.classList.remove("compare-open", "scroll-lock", "modal-open");
            setShowCompare(false);
        }
    }, [
        comparedProducts
    ]);
    let adobeTargetVideoTimer;
    let adobeTargetElValidateCount = 0;
    const appendAdobeTargetVideoScript = ()=>{
        adobeTargetElValidateCount += 1;
        const adobeTargetVideoContainer = document.getElementsByClassName("at-element-marker");
        const videoEl = document.getElementsByTagName("video");
        if (adobeTargetVideoTimer) {
            clearTimeout(adobeTargetVideoTimer);
            adobeTargetVideoTimer = undefined;
        }
        if (adobeTargetVideoContainer.length > 0 && videoEl.length > 0) {
            const scriptPath = "/js/video.js";
            let script = document.querySelector('script[src="'.concat(scriptPath, '"]'));
            if (!script) {
                script = document.createElement("script");
                script.src = scriptPath;
                script.defer = true;
                document.body.appendChild(script);
            }
        } else if (adobeTargetElValidateCount <= 10) {
            adobeTargetVideoTimer = setTimeout(()=>{
                appendAdobeTargetVideoScript();
            }, 1000);
        }
    };
    const clearAdobeTargetVideoTimeout = ()=>{
        if (adobeTargetVideoTimer) {
            clearTimeout(adobeTargetVideoTimer);
            adobeTargetVideoTimer = undefined;
            adobeTargetElValidateCount = 0;
        }
    };
    (0,react.useEffect)(()=>{
        if (pageIsInteractive) appendAdobeTargetVideoScript();
        return ()=>{
            clearAdobeTargetVideoTimeout();
        };
    }, [
        pageIsInteractive
    ]);
    const handleModalClose = ()=>{
        if (showCampaign) setShowCampaign(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    globalStyles.map((style, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: (0,jsx_runtime.jsx)((style_default()), {
                                id: style.__hash,
                                children: style
                            })
                        }, "style-".concat(i, "-").concat((0,helper.getRandom)()));
                    }),
                    previewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Provider */.zt, {
                store: store,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: !isSsr,
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PersistGate, {
                            persistor: store.__persistor,
                            loading: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                                initialLoader: true
                            }),
                            children: children
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Layout, {
                        show: promoBannerModal === null || promoBannerModal === void 0 ? void 0 : promoBannerModal.show,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shared_ErrorBoundary, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "root ".concat(previewMode ? "previewmode" : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                                        ...pageProps
                                    })
                                }),
                                show && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal, {}),
                                showCartAction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartActionModal, {}) : null,
                                isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toaster, {
                                    message: ""
                                }),
                                newslettersignup && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsLetterSignUpOverlay, {
                                    data: newslettersignup,
                                    showCampaign: showCampaign,
                                    handleModalClose: handleModalClose
                                }),
                                (promoBannerModal === null || promoBannerModal === void 0 ? void 0 : promoBannerModal.show) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoModal, {
                                    ...promoBannerModal.modalContent
                                }),
                                !isRestricted && showCompare && (compareproducts === null || compareproducts === void 0 ? void 0 : compareproducts.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareProducts, {
                                    compareproducts: compareproducts === null || compareproducts === void 0 ? void 0 : compareproducts.content
                                }),
                                showPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewCart, {})
                            ]
                        })
                    })
                })
            }),
            pageIsInteractive && globalScripts.map((script, i)=>{
                if (!script.innerHTML && scriptsLoaded === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    onReady: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    onError: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    src: script.src,
                    id: "script-".concat(i)
                }, "script-".concat(i));
                if (script.innerHTML && scriptsLoaded === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    onReady: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    onError: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    id: "innerscript-".concat(i),
                    children: "".concat(script.innerHTML)
                }, "innerscript-".concat(i));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "/js/datalayer.js",
                onReady: ()=>{
                    const dataLayerEvent = new Event("datalayerFired");
                    window.dispatchEvent(dataLayerEvent);
                }
            }),
            previewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "topcorner",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "Decoupled preview mode",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "ml-10 mr-5",
                            onClick: ()=>(0,helper.closePreview)(),
                            src: icons_close/* default.src */.Z.src,
                            alt: "close-icon"
                        })
                    ]
                })
            })
        ]
    });
});
/**
 * function to log webvitals
 * @param {*} metric
 */ function reportWebVitals(metric) {
    console.log("Web Vitals", metric);
}
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(MyApp, (next_i18next_config_default())));


/***/ }),

/***/ 13644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NL": function() { return /* binding */ setUtilityLocation; },
/* harmony export */   "OX": function() { return /* binding */ setCityLocation; },
/* harmony export */   "_n": function() { return /* binding */ locationState; },
/* harmony export */   "h9": function() { return /* binding */ setMyStore; },
/* harmony export */   "tD": function() { return /* binding */ setFindAStoreSearchEvent; },
/* harmony export */   "vM": function() { return /* binding */ locationSlice; },
/* harmony export */   "wf": function() { return /* binding */ setStoreAddress; }
/* harmony export */ });
/* unused harmony exports setAPIRecallTime, setUtilityStoreDetails, setStoreFilter, setFindAStoreActive, setFindAStoreShow */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77236);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);


const initialState = {
    userCity: "",
    utilityLocation: "",
    utilityData: {},
    utilityStoreDetails: {},
    myStoreId: 0,
    utilityStoreDetailsUrl: "",
    isLoading: false,
    reCallIn: "",
    browseLocationsStoreFilterData: [],
    findAStoreShow: false,
    findAStoreActive: false,
    findAStoreSearchEvent: false
};
const locationSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "location",
    initialState,
    reducers: {
        setAPIRecallTime (state, action) {
            state.reCallIn = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(1, "m").unix();
        },
        setStoreAddress: (state, action)=>{
            state.utilityData = action.payload;
            state.reCallIn = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(1, "m").unix();
            state.isLoading = false;
        },
        setUtilityStoreDetails: (state, action)=>{
            state.utilityStoreDetails = action.payload;
            state.reCallIn = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(1, "m").unix();
            state.isLoading = false;
        },
        setCityLocation: (state, action)=>{
            state.userCity = action.payload.userCity;
            state.utilityLocation = action.payload.utilityLocation;
            state.reCallIn = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(1, "m").unix();
            state.isLoading = false;
        },
        setUtilityLocation: (state, action)=>{
            const { payload: { utilityLocation  } = {}  } = action;
            state.utilityLocation = utilityLocation;
        },
        setMyStore: (state, action)=>{
            state.myStoreId = action.payload;
        },
        setStoreFilter: (state, action)=>{
            state.browseLocationsStoreFilterData = action.payload;
        },
        setFindAStoreShow: (state, action)=>{
            state.findAStoreShow = action.payload;
        },
        setFindAStoreActive: (state, action)=>{
            state.findAStoreActive = action.payload;
        },
        setFindAStoreSearchEvent: (state, action)=>{
            state.findAStoreSearchEvent = action.payload;
        }
    }
});
const { setStoreAddress , setAPIRecallTime , setUtilityStoreDetails , setCityLocation , setMyStore , setUtilityLocation , setStoreFilter , setFindAStoreActive , setFindAStoreShow , setFindAStoreSearchEvent  } = locationSlice.actions;
const locationState = (state)=>state.location;


/***/ }),

/***/ 2570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ih": function() { return /* binding */ selectMyAccountState; },
/* harmony export */   "JC": function() { return /* binding */ setOnlineSubmitStatus; },
/* harmony export */   "Ku": function() { return /* binding */ clearSuccess; },
/* harmony export */   "M_": function() { return /* binding */ setInvalidModelNumber; },
/* harmony export */   "N0": function() { return /* binding */ onlineProductSubmitRegistration; },
/* harmony export */   "TN": function() { return /* binding */ setSubmitStatus; },
/* harmony export */   "dM": function() { return /* binding */ clearSuggestion; },
/* harmony export */   "dj": function() { return /* binding */ myProductSlice; },
/* harmony export */   "q5": function() { return /* binding */ getProductsForRegistration; },
/* harmony export */   "u8": function() { return /* binding */ getModelNumberSuggest; }
/* harmony export */ });
/* unused harmony export offlineProductSubmitRegistration */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28858);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77236);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55111);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34326);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51666);









const initialState = {
    status: "",
    offlineRegistration: {
        suggestions: [],
        invalidModelNumber: false,
        submitError: false,
        isSuccess: false,
        isDisabled: false
    },
    onlineRegistration: {
        submitError: false,
        isSuccess: false,
        isDisabled: false
    }
};
const getModelNumberSuggest = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/getSuggestion", async (payload)=>{
    const { q , rows , fq , fl , start , skuSearch  } = payload;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCT_SEARCH_CATALOG, {
        params: {
            q,
            rows,
            fq,
            fl,
            start,
            skuSearch,
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_7__/* .getSessionIdObjWithEpoc */ .o)()
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_8___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    const skuData = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.handleModelNumberSuggestion)(response.data);
    return skuData;
});
const getProductsForRegistration = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/fetchProducts", async (body)=>{
    var ref;
    const productsData = [];
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    var ref1;
    const locale = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.locale) !== null && ref1 !== void 0 ? ref1 : "en-US";
    await Promise.all([
        _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCTS_ENDPOINT, "?lang=").concat(locale)),
        _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_3__.FETCH_PRODUCT_REG_ENDPOINT))
    ]).then(async (res)=>{
        var ref, ref1, ref2, ref3;
        if ((ref = res[0]) === null || ref === void 0 ? void 0 : ref.data) productsData[0] = (ref1 = res[0]) === null || ref1 === void 0 ? void 0 : ref1.data;
        if ((ref2 = res[1]) === null || ref2 === void 0 ? void 0 : ref2.data) productsData[1] = (ref3 = res[1]) === null || ref3 === void 0 ? void 0 : ref3.data;
    }).catch((err)=>{
        console.error("Error occured while fetching registered product data", err);
    });
    return productsData;
});
const offlineProductSubmitRegistration = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/offlineRegistration", async (body)=>{
    let message = false;
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCT_PRODUCT_REGISTRATION, body);
    if (data) {
        message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(data, "success", "") === "true" ? true : false;
    }
    return message;
});
const onlineProductSubmitRegistration = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/onlineRegistration", async (body)=>{
    let message = false;
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCT_PRODUCT_REGISTRATION, body);
    if (data) {
        message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(data, "success", "") === "true" ? true : false;
    }
    return message;
});
const myProductSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "myProduct",
    initialState,
    reducers: {
        clearSuggestion: (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                suggestions: []
            };
        },
        setInvalidModelNumber: (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                invalidModelNumber: action.payload
            };
        },
        setSubmitStatus: (state, action)=>{
            const { submitError ="" , isDisabled =false  } = action.payload;
            state.offlineRegistration = {
                ...state.offlineRegistration,
                submitError: submitError,
                isDisabled: isDisabled
            };
        },
        clearSuccess: (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                isSuccess: false
            };
        },
        setOnlineSubmitStatus: (state, action)=>{
            const { submitError ="" , isDisabled =false  } = action.payload;
            state.onlineRegistration = {
                ...state.onlineRegistration,
                submitError: submitError,
                isDisabled: isDisabled
            };
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_1__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }).addCase(getModelNumberSuggest.pending, (state, action)=>{
        // state.status = "loading"
        }).addCase(getModelNumberSuggest.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.offlineRegistration = {
                ...state.offlineRegistration,
                ...action.payload
            };
        }).addCase(getModelNumberSuggest.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(offlineProductSubmitRegistration.pending, (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                submitError: false,
                isDisabled: true
            };
            state.status = "loading";
        }).addCase(offlineProductSubmitRegistration.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const isSuccess = action.payload;
            if (isSuccess) {
                state.offlineRegistration = {
                    ...state.offlineRegistration,
                    isSuccess: true,
                    isDisabled: false
                };
            }
        }).addCase(offlineProductSubmitRegistration.rejected, (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                submitError: action.error.message,
                isDisabled: false
            };
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getProductsForRegistration.pending, (state)=>{
            state.status = "loading";
        }).addCase(getProductsForRegistration.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(getProductsForRegistration.rejected, (state, action)=>{
            state.status = "failed";
        }).addCase(onlineProductSubmitRegistration.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(onlineProductSubmitRegistration.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(onlineProductSubmitRegistration.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { clearSuggestion , setInvalidModelNumber , setSubmitStatus , clearSuccess , setOnlineSubmitStatus  } = myProductSlice.actions;
const selectMyAccountState = (state)=>state.myProduct;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (myProductSlice.reducer);


/***/ }),

/***/ 54127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ec": function() { return /* binding */ setSearchKeyword; },
/* harmony export */   "Qf": function() { return /* binding */ setSearchFilter; },
/* harmony export */   "iv": function() { return /* binding */ searchSlice; },
/* harmony export */   "kj": function() { return /* binding */ setSearchCount; },
/* harmony export */   "uv": function() { return /* binding */ searchState; },
/* harmony export */   "w$": function() { return /* binding */ fetchSearchAllResults; }
/* harmony export */ });
/* unused harmony exports fetchSearchInspirationResults, getSearchProducts, fetchSearchServicePartsResults, getProducts */
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29843);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28858);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51666);







const fetchSearchInspirationResults = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/fetchSearchResults", async (general)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, {
        params: {
            fl: "id",
            fq: [
                'language_s:("'.concat(language, '")')
            ],
            q: "*:*",
            rows: 5,
            profilename: "profile_".concat(general.toLowerCase(), "_Search"),
            collections: general.toLowerCase(),
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_6__/* .getSessionIdObjWithEpoc */ .o)()
        }
    });
    return response.data;
});
const getSearchProducts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/getProducts", async (payload)=>{
    var ref;
    const { profilename , collections , q , fq , rows , start , fl  } = payload;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, "?q=").concat(q, "&fl=").concat(fl).concat(fq ? "&fq=".concat(fq.join("&fq=")) : "").concat(rows ? "&rows=" : "").concat(rows ? rows : "").concat(start >= 0 ? "&start=" : "").concat(start >= 0 ? start : "", "&profilename=").concat(profilename, "&collections=").concat(collections, '&fq=language_s:("').concat(language, '")&sessionId=').concat((0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_6__/* .getSessionIdObjWithEpoc */ .o)());
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    return {
        response
    };
});
const initialState = {
    searchDetails: {},
    search: {
        status: "loading",
        error: ""
    },
    servicePartsSearch: {
        status: "loading",
        error: ""
    },
    searchResponse: {
        data: ""
    },
    servicePartsSearchResponse: {
        data: ""
    }
};
const fetchSearchAllResults = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/fetchSearchAllResults", async (params)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    if (!params.fq) {
        params.fq = 'language_s:("'.concat(language, '")');
    } else {
        if (typeof params.fq === "string" && params.fq.length > 0) {
            params.fq = [
                params.fq,
                'language_s:("'.concat(language, '")')
            ];
        } else if (Array.isArray(params.fq)) {
            params.fq = [
                ...params.fq,
                'language_s:("'.concat(language, '")')
            ];
        }
    }
    const searchParams = new URLSearchParams(params);
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, "?").concat(searchParams.toString());
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    return response.data;
});
const fetchSearchServicePartsResults = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/fetchSearchServicePartsResults", async (params)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    if (!params.fq) {
        params.fq = 'language_s:("'.concat(language, '")');
    } else {
        if (typeof params.fq === "string" && params.fq.length > 0) {
            params.fq = [
                params.fq,
                'language_s:("'.concat(language, '")')
            ];
        } else if (Array.isArray(params.fq)) {
            params.fq = [
                ...params.fq,
                'language_s:("'.concat(language, '")')
            ];
        }
    }
    const searchParams = new URLSearchParams({
        ...params,
        sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_6__/* .getSessionIdObjWithEpoc */ .o)()
    });
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, "?").concat(searchParams.toString());
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    return response.data;
});
const getProducts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("plp/getProducts", async (payload)=>{
    const { q , profileName , update , query , collections , displaytype , type  } = payload;
    const { internationalization: { language ="en"  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    const { fq , rows , start , sort  } = query;
    const url = "".concat(type === "parts" ? _constants_index__WEBPACK_IMPORTED_MODULE_1__.PROFILE_END_POINT_CLIENT : _constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, "?profilename=").concat(profileName).concat(fq ? "&fq=".concat(fq.join("&fq=")) : "").concat(sort ? "&sort=".concat(sort) : "").concat(q ? "&q=".concat(q) : "").concat(collections ? "&collections=".concat(collections) : "").concat(displaytype ? "&displaytype=".concat(displaytype) : "").concat(rows ? "&rows=" : "").concat(rows ? rows : "").concat(start >= 0 ? "&start=" : "").concat(start >= 0 ? start : "").concat('&fq=language_s:("'.concat(language, '")&sessionId=').concat((0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_6__/* .getSessionIdObjWithEpoc */ .o)()), " ");
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    const data = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_3__/* .formatListingData */ .nx)(response.data);
    return {
        data,
        update
    };
});
const searchSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
    name: "search",
    initialState,
    reducers: {
        setSearchCount: (state, action)=>{
            state.searchDetails = action.payload;
        },
        setSearchFilter: (state, param)=>{
            let { payload: { key ="" , queries =[]  }  } = param;
            const searchDetails = {
                ...state.searchDetails
            };
            if (key) searchDetails[key] = {
                ...searchDetails[key],
                filters: queries
            };
            state.searchDetails = {
                ...state.searchDetails
            };
            state.searchDetails = searchDetails;
        },
        setSearchKeyword: (state, action)=>{
            state.searchDetails = {
                ...state.searchDetails,
                keyword: action.payload
            };
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_4__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }).addCase(fetchSearchAllResults.pending, (state, action)=>{
            state.search.status = "loading";
        }).addCase(fetchSearchAllResults.fulfilled, (state, action)=>{
            state.search.status = "succeeded";
            state.search.error = "";
            state.searchResponse.data = action.payload;
        }).addCase(fetchSearchAllResults.rejected, (state, action)=>{
            state.search.status = "failed";
            state.search.error = action.error.message;
        }).addCase(fetchSearchServicePartsResults.pending, (state, action)=>{
            state.servicePartsSearch.status = "loading";
        }).addCase(fetchSearchServicePartsResults.fulfilled, (state, action)=>{
            state.servicePartsSearch.status = "succeeded";
            state.servicePartsSearch.error = "";
            state.servicePartsSearchResponse.data = action.payload;
        }).addCase(fetchSearchServicePartsResults.rejected, (state, action)=>{
            state.servicePartsSearch.status = "failed";
            state.servicePartsSearch.error = action.error.message;
        }).addCase(getSearchProducts.pending, (state, action)=>{
            state.searchDetails.status = "loading";
        }).addCase(getSearchProducts.fulfilled, (state, action)=>{
            state.searchDetails = action.payload;
            state.searchDetails.status = "succeeded";
        }).addCase(getSearchProducts.rejected, (state, action)=>{
            state.searchDetails.status = "failed";
            state.searchDetails.error = action.error.message;
        });
    }
});
const { setSearchCount , setSearchFilter , setSearchKeyword  } = searchSlice.actions;
const searchState = (state)=>state.search;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (searchSlice.reducer);


/***/ }),

/***/ 33185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ac": function() { return /* binding */ onImageError; },
/* harmony export */   "Ar": function() { return /* binding */ isCheckoutLanding; },
/* harmony export */   "Be": function() { return /* binding */ isCompareProducts; },
/* harmony export */   "Bq": function() { return /* binding */ affirmRefresh; },
/* harmony export */   "C2": function() { return /* binding */ isCarousel; },
/* harmony export */   "C_": function() { return /* binding */ isNewsLetter; },
/* harmony export */   "DN": function() { return /* binding */ isProductcardV3; },
/* harmony export */   "Dx": function() { return /* binding */ isMyproducts; },
/* harmony export */   "EE": function() { return /* binding */ isImageV3; },
/* harmony export */   "F0": function() { return /* binding */ isAssociateMembership; },
/* harmony export */   "Gs": function() { return /* binding */ isText; },
/* harmony export */   "Hx": function() { return /* binding */ isProductList; },
/* harmony export */   "K0": function() { return /* binding */ isOrderStatus; },
/* harmony export */   "L": function() { return /* binding */ isRegisterOnline; },
/* harmony export */   "L8": function() { return /* binding */ isInPageSearch; },
/* harmony export */   "M0": function() { return /* binding */ accordionUniqueId; },
/* harmony export */   "M2": function() { return /* binding */ ConditionalWrapper; },
/* harmony export */   "MW": function() { return /* binding */ isSpacer; },
/* harmony export */   "Mc": function() { return /* binding */ isKnowledgeArticle; },
/* harmony export */   "N": function() { return /* binding */ isSearch; },
/* harmony export */   "Nm": function() { return /* binding */ isContainer; },
/* harmony export */   "Om": function() { return /* binding */ getPdpRedirectUrl; },
/* harmony export */   "P2": function() { return /* binding */ isEmbed; },
/* harmony export */   "Qe": function() { return /* binding */ recursiveDataFunction; },
/* harmony export */   "S": function() { return /* binding */ isAuthModal; },
/* harmony export */   "U4": function() { return /* binding */ isMyservice; },
/* harmony export */   "Uq": function() { return /* binding */ isOrderConfirmation; },
/* harmony export */   "V6": function() { return /* binding */ isProductExfPdp; },
/* harmony export */   "Wv": function() { return /* binding */ isVideo; },
/* harmony export */   "Z3": function() { return /* binding */ isBreadcrumb; },
/* harmony export */   "ZS": function() { return /* binding */ isHeaderNav; },
/* harmony export */   "_$": function() { return /* binding */ isOrderHistory; },
/* harmony export */   "_4": function() { return /* binding */ isUpSellContainer; },
/* harmony export */   "bU": function() { return /* binding */ alterClass; },
/* harmony export */   "bd": function() { return /* binding */ isSlick; },
/* harmony export */   "bu": function() { return /* binding */ isToaster; },
/* harmony export */   "cD": function() { return /* binding */ isBrandHeader; },
/* harmony export */   "ck": function() { return /* binding */ isShopTheRoomCard; },
/* harmony export */   "e7": function() { return /* binding */ isPromoBanner; },
/* harmony export */   "ek": function() { return /* binding */ isLiterature; },
/* harmony export */   "eq": function() { return /* binding */ isProductAccordion; },
/* harmony export */   "f5": function() { return /* binding */ isNewsLetterSignUp; },
/* harmony export */   "fN": function() { return /* binding */ getExtention; },
/* harmony export */   "hn": function() { return /* binding */ isRegisterOffline; },
/* harmony export */   "iL": function() { return /* binding */ isFindingModelNumber; },
/* harmony export */   "j$": function() { return /* binding */ isTeaser; },
/* harmony export */   "jS": function() { return /* binding */ isProductDetails; },
/* harmony export */   "mg": function() { return /* binding */ isAccountSettings; },
/* harmony export */   "n": function() { return /* binding */ getRowCols; },
/* harmony export */   "np": function() { return /* binding */ isAemForm; },
/* harmony export */   "oC": function() { return /* binding */ isPairsWellWth; },
/* harmony export */   "oq": function() { return /* binding */ closest; },
/* harmony export */   "po": function() { return /* binding */ isProductcard; },
/* harmony export */   "pv": function() { return /* binding */ isOrderDetails; },
/* harmony export */   "s3": function() { return /* binding */ isProductReview; },
/* harmony export */   "sL": function() { return /* binding */ isSharedCart; },
/* harmony export */   "wR": function() { return /* binding */ isTab; },
/* harmony export */   "we": function() { return /* binding */ isMyFavorites; },
/* harmony export */   "xW": function() { return /* binding */ isTeaserContainer; },
/* harmony export */   "yd": function() { return /* binding */ isSiteWideWarning; },
/* harmony export */   "zK": function() { return /* binding */ isHelpSupport; }
/* harmony export */ });
/* unused harmony exports isChangePassword, isGatedContent, isProductCardV4, removeExtraSpaces, getBillingAsShippingAddress, getIsSameAddress, getShippingAllTotal, getShippingData, getOrderDetailsUrl, isObjectEmpty, getPayPalPaymentIdFromParams, getBrandSwitcher, handleViewSterlingResults, getPresetUrl, isImage, isCartLanding, isFooter, getPresetThumbnailUrl, isBrowseAllStores, isContactUs, isTechnicalSpec, isPressLanding, isFindStore, isStoreFilter, isTitle, isKeySpecifier, isDynamicSearch, isInspireVideo, isImageCluster, isRoomDetail, isShopTheRoomDetail, isInstallDesignServices, isProfessionalDetail, isFriendsAndFamily, isFindAProByZip, isStoreAppointment */
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36513);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45094);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);





const isContainer = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CONTAINER);
};
const isProductcard = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCTCARD);
};
const isProductcardV3 = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCTCARD_V3);
};
const isAuthModal = (item)=>{
    var ref;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.AUTH_MODAL)) && (item === null || item === void 0 ? void 0 : item.hi);
};
const isSiteWideWarning = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SITEWIDE_WARNING);
};
const isNewsLetter = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.NEWSLETTER);
};
const isNewsLetterSignUp = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.NEWSLETTER_SIGNUP);
};
const isCompareProducts = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.COMPARE_PRODUCTS);
};
const isVideo = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.VIDEO);
};
const isSpacer = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SPACER);
};
const isImage = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.IMAGE);
};
const isImageV3 = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGEV3);
};
const isUpSellContainer = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.UPSELL_CONTAINER);
};
const isCartLanding = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.CART_LANDING);
};
const isCheckoutLanding = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CHECKOUT);
};
const isSharedCart = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SHARED_CART);
};
const isOrderConfirmation = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_CONFIRMATION);
};
const isOrderDetails = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_DETAILS);
};
const isOrderHistory = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_HISTORY);
};
const isOrderStatus = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_STATUS);
};
const isPairsWellWth = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PAIRS_WELL_WITH);
};
const isCarousel = (item)=>{
    var ref, ref1;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CAROUSEL)) && !((ref1 = item[":type"]) === null || ref1 === void 0 ? void 0 : ref1.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CAROUSELSLICK));
};
const isSlick = (item)=>{
    var ref, ref1, ref2;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SLICK)) && !(item === null || item === void 0 ? void 0 : (ref1 = item.carouselComponentProperties) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.appliedCssClassNames) === null || ref2 === void 0 ? void 0 : ref2.includes("carousel-promo-banner"));
};
const isPromoBanner = (item)=>{
    var ref, ref1, ref2;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SLICK)) && (item === null || item === void 0 ? void 0 : (ref1 = item.carouselComponentProperties) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.appliedCssClassNames) === null || ref2 === void 0 ? void 0 : ref2.includes("carousel-promo-banner"));
};
const isAemForm = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.AEMFORM);
};
const isTeaser = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TEASER);
};
const isTeaserContainer = (data)=>{
    const types = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (type) {
            types.push(type);
        }
    });
    return types.every((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TEASER));
};
const isText = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TEXT);
};
const isTab = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TAB);
};
const isBrandHeader = (data)=>{
    const types = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.BRAND_SWITCHER)) || types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.UTILITY_NAV_HEADER));
};
const isHeaderNav = (data)=>{
    const types = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.UTILITY_WIDGET)) && types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TABS)) && types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGE));
};
const isFooter = (data)=>{
    const types = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(COMPONENT_TYPES.MAIN_FOOTER)) || types.find((a)=>a.includes(COMPONENT_TYPES.ADDITIONAL_FOOTER)) || types.find((a)=>a.includes(COMPONENT_TYPES.NEWSLETTER_SIGNIN));
};
const isEmbed = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.EMBED);
};
const isBreadcrumb = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.BREADCRUMB);
};
const isProductList = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCTLIST);
};
const isSearch = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SEARCH);
};
const isToaster = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TOASTER);
};
const isHelpSupport = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.HELPSUPPORT);
};
const isProductDetails = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS);
};
const isAccountSettings = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ACCOUNT_SETTINGS);
};
const isMyservice = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.MY_SERVICES);
};
const isMyFavorites = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.MY_FAVORITES);
};
const isChangePassword = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.CHANGE_PASSWORD);
};
const isMyproducts = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.MY_PRODUCTS);
};
const isProductAccordion = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS_ACCORDION);
};
const isProductReview = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS_REVIEW);
};
const isRegisterOffline = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.REGISTER_OFFLINE_PRODUCTS);
};
const isRegisterOnline = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.REGISTER_ONLINE_PRODUCTS);
};
const isBrowseAllStores = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.BROWSE_ALL_STORES);
};
const isStoreFilter = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.STORE_FILTER);
};
const isProductExfPdp = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS_EXFPDP);
};
const isKnowledgeArticle = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.KNOWLEDGE_ARTICLE);
};
const isLiterature = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.LITERATURE);
};
const isContactUs = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES === null || COMPONENT_TYPES === void 0 ? void 0 : COMPONENT_TYPES.CONTACT_US);
};
const isFindingModelNumber = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === null || _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.FINDING_MODEL_NUMBER);
};
const isTechnicalSpec = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.TECHNICAL_SPECIFICATION);
};
const isPressLanding = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.PRESS_LANDING);
};
const isFindStore = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.FIND_STORE);
};
const isInPageSearch = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.INPAGE_SEARCH);
};
const isTitle = function() {
    let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.TITLE);
};
const isKeySpecifier = function() {
    let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.KEY_SPECIFIER);
};
const isDynamicSearch = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.DYNAMIC_SEARCH);
};
const isAssociateMembership = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ASSOCIATE_MEMBERSHIP);
};
const isInspireVideo = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.INSPIRE_VIDEO);
};
const isImageCluster = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.IMAGE_CLUSTER);
};
const isProfessionalDetail = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.PROFESSIONAL_DETAILS);
};
const isRoomDetail = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.ROOM_DETAIL);
};
const isShopTheRoomDetail = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.SHOP_THE_ROOM_DETAIL);
};
const isShopTheRoomCard = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SHOP_THE_ROOM_CARD);
};
const isFriendsAndFamily = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.FRIENDS_AND_FAMILY);
};
const isInstallDesignServices = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.INSTALL_DESIGN_SERVICES);
};
const isFindAProByZip = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.FIND_A_PRO_BY_ZIP);
};
const isStoreAppointment = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.STORE_APPOINTMENT);
};
const isGatedContent = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.GATED_CONTENT);
};
const isProductCardV4 = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.PRODUCT_CARD_V4);
};
/**
 *
 * @param {Element} e
 * @param {String} url
 */ const onImageError = (e, url)=>{
    const imgsrc = e.target.src;
    if (imgsrc.includes("&fmt=webp")) {
        e.target.src = imgsrc.replace("&fmt=webp", "");
        return;
    }
    const attr = document.createAttribute("errorsrc");
    attr.value = url;
    e.target.setAttributeNode(attr);
    e.target.src = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_0__/* ["default"].src */ .Z.src;
};
/**
 *
 * @param {Number} width
 * @param {Number} rowCols
 * @param {String} swatchUrl
 * @param {String} assetId
 * @param {Object} presetConfigs
 * @param {Boolean} isForInstallationService
 * @return {String} preset url
 */ const getPresetUrl = function() {
    let width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, rowCols = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, swatchUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", assetId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", presetConfigs = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, isForInstallationService = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    const { Desktop , MobilePortrait , MobilePortrait1 , MobilePortrait2 , MobileLandscape , MobileLandscape1 , MobileLandscape2 , PotraitCategory  } = presetConfigs;
    let preset = "";
    const mobileBasedCheckPoint = isForInstallationService ? 1023 : 768;
    if (width <= mobileBasedCheckPoint) {
        if (width <= 425) {
            if (rowCols) {
                preset = MobilePortrait2 || MobilePortrait;
                if (rowCols === 1) preset = MobilePortrait1 || MobilePortrait;
            } else if (MobilePortrait) {
                preset = MobilePortrait;
            } else preset = MobilePortrait2;
        } else {
            if (rowCols) {
                if (rowCols === 1) preset = MobileLandscape1 || MobileLandscape;
                else preset = MobileLandscape2 || MobileLandscape;
            } else if (MobileLandscape) {
                preset = MobileLandscape;
            } else preset = MobileLandscape1;
        }
    } else preset = Desktop;
    if (isForInstallationService) {
        return "".concat(swatchUrl).concat(assetId, "?").concat(preset);
    }
    return "".concat(swatchUrl).concat(PotraitCategory, "?$product_src=is{PAWEB/").concat(assetId, "}&").concat(preset);
};
const alterClass = function() {
    let elementClass = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", toAdd = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, toRemove = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    const element = document.getElementsByClassName(elementClass).item(0);
    if (toAdd && element) {
        element.classList.add(toAdd);
    }
    if (toRemove && element) {
        element.classList.remove(toRemove);
    }
};
//  * @param {String} fileName imagename.jpg / imagename
//  * @returns .jpg,.svg / false
const getExtention = (fileName)=>{
    const i = fileName.lastIndexOf(".");
    if (i === -1) return false;
    return fileName.slice(i);
};
/**
 *
 * @param {String} str
 * @param {Number} max
 * @param {Number} min
 * @return {Number}
 */ const accordionUniqueId = (str, max, min)=>{
    const crypto = window.crypto || window.msCrypto;
    const array = new Uint32Array(1);
    const randVal = crypto.getRandomValues(array)[0];
    return "".concat(str, "-").concat(Math.floor(randVal * (max - min + 1)) + min);
};
const ConditionalWrapper = (param)=>{
    let { condition , wrapper , children  } = param;
    return condition ? wrapper(children) : children;
};
const closest = (el, fn)=>el && (fn(el) ? el : closest(el.parentNode, fn));
const removeExtraSpaces = function() {
    let string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return string.replace(/\s+/g, " ").trim();
};
/**
 *
 * @param {String} swatchUrl
 * @param {String} assetId
 * @param {Object} presetConfigs
 * @param {String} assetAccountName
 * @return {String}
 */ const getPresetThumbnailUrl = (swatchUrl, assetId, presetConfigs, assetAccountName)=>{
    const { Thumbnail , LandscapeCategory  } = presetConfigs;
    return "".concat(swatchUrl).concat(LandscapeCategory, "?$product_src=is{").concat(assetAccountName, "/").concat(assetId, "}&").concat(Thumbnail);
};
const recursiveDataFunction = (data, type)=>{
    const results = [];
    if (data && data[":itemsOrder"]) {
        data[":itemsOrder"].map((key)=>{
            var ref;
            const item = data[":items"][key];
            if ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(type)) {
                results.push(item);
                return item;
            } else {
                const nestedResults = recursiveDataFunction(item, type);
                results.push(...nestedResults);
            }
        });
    }
    return results;
};
const getRowCols = (width, isMobile, isTablet)=>{
    let rowCols = width < 1024 ? 1 : 3;
    switch(true){
        case width > 1024:
            rowCols = 3;
            break;
        case width < 990 && (isMobile || isTablet) || width < 480:
            rowCols = 2;
            break;
        default:
            rowCols = 2;
    }
    return rowCols;
};
const getBillingAsShippingAddress = (shipping, billing)=>{
    const { billingStreetName ="" , billingAptNo ="" , billingCity ="" , billingStateCode ="" , billingZipcode =""  } = billing;
    const { shippingStreetName ="" , shippingAptNo ="" , shippingCity ="" , shippingStateCode ="" , shippingZipcode =""  } = shipping;
    return billingStreetName.toLowerCase() === shippingStreetName.toLowerCase() && billingAptNo.toLowerCase() === shippingAptNo.toLowerCase() && billingCity.toLowerCase() === shippingCity.toLowerCase() && billingStateCode.toLowerCase() === shippingStateCode.toLowerCase() && billingZipcode.toLowerCase() === shippingZipcode.toLowerCase();
};
const getIsSameAddress = (add1, add2)=>{
    const { streetName: streetName1 = "" , streetNumber: streetNumber1 = "" , city: city1 = "" , state: state1 = "" , postalCode: postalCode1 = ""  } = add1;
    const { streetName: streetName2 = "" , streetNumber: streetNumber2 = "" , city: city2 = "" , state: state2 = "" , postalCode: postalCode2 = ""  } = add2;
    return streetName1.toLowerCase() === streetName2.toLowerCase() && streetNumber1.toLowerCase() === streetNumber2.toLowerCase() && city1.toLowerCase() === city2.toLowerCase() && state1.toLowerCase() === state2.toLowerCase() && postalCode1.toLowerCase() === postalCode2.toLowerCase();
};
const getShippingAllTotal = (customLineItems, locale)=>{
    const shippings = [];
    customLineItems.forEach((item)=>{
        var ref;
        const itemName = item.name[locale];
        var ref1;
        const amount = (ref1 = (item === null || item === void 0 ? void 0 : (ref = item.totalPrice) === null || ref === void 0 ? void 0 : ref.centAmount) / 100) !== null && ref1 !== void 0 ? ref1 : 0;
        if (!shippings.find((el)=>el.name === itemName)) {
            shippings.push({
                total: amount,
                name: itemName
            });
        } else {
            const index = shippings.findIndex((code)=>code.name === itemName);
            shippings[index].total += amount;
        }
    });
    return shippings.filter((e)=>e.name !== "Service");
};
const getShippingData = async (currencySign, freeShipping)=>{
    const { cart: { cart: { customLineItems  } = {}  } = {}  } = store.getState();
    const { internationalization: { locale  } = {}  } = await getConfig();
    const shippingAllTotal = getShippingAllTotal(customLineItems, locale);
    var ref;
    const freightShippingData = (ref = shippingAllTotal.find((el)=>{
        return FREIGHT_SHIPPING_TYPES.includes(el === null || el === void 0 ? void 0 : el.name);
    })) !== null && ref !== void 0 ? ref : {};
    var ref1;
    const parcelShippingData = (ref1 = shippingAllTotal.find((el)=>{
        return !FREIGHT_SHIPPING_TYPES.includes(el === null || el === void 0 ? void 0 : el.name);
    })) !== null && ref1 !== void 0 ? ref1 : {};
    const { total: freightAmount = ""  } = freightShippingData;
    const { total: parcelAmount = ""  } = parcelShippingData;
    const freightShippingCost = freightAmount > 0 ? "".concat(currencySign).concat(freightAmount, ".00") : freeShipping;
    const parcelShippingCost = parcelAmount > 0 ? "".concat(currencySign).concat(parcelAmount, ".00") : freeShipping;
    return {
        freightShippingCost,
        parcelShippingCost
    };
};
const getOrderDetailsUrl = async (email, orderNumber)=>{
    const config = await getConfig();
    const { general: { orderDetailsPath =""  } = {}  } = config;
    return "".concat(orderDetailsPath, "?orderNumber=").concat(orderNumber, "&q=").concat(Buffer.from(email).toString("base64"));
};
const getPdpRedirectUrl = (pdpUrl, param)=>{
    const isHasQueryParams = pdpUrl.includes("?");
    return "".concat(pdpUrl).concat(isHasQueryParams ? "&" : "?").concat(param);
};
const isObjectEmpty = (object)=>{
    return Object.keys(object).length === 0;
};
const affirmRefresh = ()=>{
    const affirmConfig = {
        public_api_key: process.env.NEXT_PUBLIC_AFFIRM_API_KEY,
        script: "https://cdn1.affirm.com/js/v2/affirm.js",
        session_id: "sID"
    };
    (function(l, g, m, e, a, f, b) {
        let d;
        const c = l[m] || {};
        const h = document.createElement(f);
        const n = document.getElementsByTagName(f)[0];
        const k = function(a, b, c) {
            return function() {
                // eslint-disable-next-line prefer-rest-params
                a[b]._.push([
                    c,
                    arguments
                ]);
            };
        };
        c[e] = k(c, e, "set");
        // eslint-disable-next-line prefer-const
        d = c[e];
        c[a] = {};
        c[a]._ = [];
        d._ = [];
        c[a][b] = k(c, a, b);
        a = 0;
        for(b = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < b.length; a++)d[b[a]] = k(c, e, b[a]);
        a = 0;
        for(b = [
            "get",
            "token",
            "url",
            "items"
        ]; a < b.length; a++)d[b[a]] = function() {};
        h.async = !0;
        h.src = g[f];
        n.parentNode.insertBefore(h, n);
        delete g[f];
        d(g);
        l[m] = c;
    })(window, affirmConfig, "affirm", "checkout", "ui", "script", "ready");
};
const getPayPalPaymentIdFromParams = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("id");
};
const getBrandSwitcher = function() {
    let headerData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const headPropsItems = headerData[":items"];
    const headerPropsRoot = headPropsItems === null || headPropsItems === void 0 ? void 0 : headPropsItems.root;
    const headerRootItems = headerPropsRoot[":items"];
    const hedaerPropsContainer = headerRootItems === null || headerRootItems === void 0 ? void 0 : headerRootItems.container_copy_copy;
    const headerContainerItems = hedaerPropsContainer[":items"];
    const headerUtilityWidgets = headerContainerItems === null || headerContainerItems === void 0 ? void 0 : headerContainerItems.brand_switcher;
    var ref;
    return (ref = headerUtilityWidgets === null || headerUtilityWidgets === void 0 ? void 0 : headerUtilityWidgets.items) !== null && ref !== void 0 ? ref : "";
};
const handleViewSterlingResults = (brandSwitcher, brandName, sku)=>{
    const { link  } = brandSwitcher === null || brandSwitcher === void 0 ? void 0 : brandSwitcher.find((item)=>item.brandName.toLowerCase().replaceAll(" ", "") === brandName.toLowerCase());
    window.open("".concat(link, "/en/search?keyword=").concat(sku), "_blank");
};



/***/ }),

/***/ 24899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ setAnonymousId; },
/* harmony export */   "A3": function() { return /* binding */ setAuthData; },
/* harmony export */   "Cz": function() { return /* binding */ getAnonymousGuestToken; },
/* harmony export */   "Gb": function() { return /* binding */ authSlice; },
/* harmony export */   "IL": function() { return /* binding */ getOTP; },
/* harmony export */   "LY": function() { return /* binding */ setAuthModalVisibility; },
/* harmony export */   "M": function() { return /* binding */ setUserData; },
/* harmony export */   "Mi": function() { return /* binding */ setShowCustomerSignup; },
/* harmony export */   "Pk": function() { return /* binding */ clearPreviousToken; },
/* harmony export */   "SV": function() { return /* binding */ postLogin; },
/* harmony export */   "Up": function() { return /* binding */ setFavoritesLogin; },
/* harmony export */   "_9": function() { return /* binding */ selectAuthState; },
/* harmony export */   "b4": function() { return /* binding */ setUserName; },
/* harmony export */   "cs": function() { return /* binding */ getOktaToken; },
/* harmony export */   "gl": function() { return /* binding */ validateOTP; },
/* harmony export */   "hS": function() { return /* binding */ setAuthModalActiveTab; },
/* harmony export */   "iU": function() { return /* binding */ setRevalidateTime; },
/* harmony export */   "id": function() { return /* binding */ setAuthModalFormData; },
/* harmony export */   "kS": function() { return /* binding */ logout; },
/* harmony export */   "n$": function() { return /* binding */ setHideCustomerSignupCTA; },
/* harmony export */   "nf": function() { return /* binding */ setPersona; },
/* harmony export */   "vu": function() { return /* binding */ setAuthModalStaticText; },
/* harmony export */   "x4": function() { return /* binding */ login; },
/* harmony export */   "zj": function() { return /* binding */ closeAuthShow; }
/* harmony export */ });
/* unused harmony exports getEmailOTPForLogin, userLogin, signup, forgotPassword, clearAuthState, setShowProSignup, setShowForgotPassword */
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28858);
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77932);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33273);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34326);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46201);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19514);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _genericSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88751);
/* provided dependency */ var process = __webpack_require__(83454);












const initialState = {
    isAuth: false,
    anonymousId: "",
    access_token: "",
    refresh_token: "",
    expires_in: "",
    revalidate_in: "",
    scopes: [],
    token_type: "",
    status: "",
    error: "",
    authModal: {
        show: false,
        staticText: {},
        active: 0
    },
    hashedEmail: "",
    customerProspect: "",
    showForgotPassword: false,
    showCustomerSignup: false,
    showProSignup: false,
    hideCustomerSignupCTA: false,
    user: {},
    name: {},
    loggedInUser: {},
    closeAuth: false
};
const getOktaToken = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("auth/getOktaToken", async (type)=>{
    const { gId  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getAccessToken)();
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=").concat(type, "&channel=india"));
    return response.data;
});
const getAnonymousGuestToken = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("auth/getOktaToken", async ()=>{
    var ref;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=guest&channel=india"));
    console.log(response, "response");
    const { access_token: accessToken = ""  } = (response === null || response === void 0 ? void 0 : response.data) || (response === null || response === void 0 ? void 0 : (ref = response.payload) === null || ref === void 0 ? void 0 : ref.data);
    console.log(accessToken, "accessToken");
    localStorage.setItem("okta-anonymous-access-token", accessToken);
    return response;
});
const getOTP = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("get/otp/", async (payload, thunkAPI)=>{
    const { mobileNumber , getOTPWithEmail  } = payload;
    try {
        const resp = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.idx.authenticate */ .U.idx.authenticate({
            username: mobileNumber,
            authenticators: getOTPWithEmail ? [
                "okta_email"
            ] : [
                "phone_number"
            ]
        });
        const { status  } = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.idx.proceed */ .U.idx.proceed({
            methodType: getOTPWithEmail ? "email" : "sms"
        });
        if (status === "PENDING") {
            return thunkAPI.fulfillWithValue({
                status: "success"
            });
        } else {
            return thunkAPI.fulfillWithValue({
                invalidNumber: true
            });
        }
    } catch (err) {
        return thunkAPI.fulfillWithValue({
            error: true
        });
    }
});
const getEmailOTPForLogin = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("get/otp/", async (payload, thunkAPI)=>{
    const { mobileNumber  } = payload;
    try {
        const resp = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.idx.authenticate */ .U.idx.authenticate({
            username: mobileNumber,
            authenticators: [
                "okta_email"
            ]
        });
        const { status  } = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.idx.proceed */ .U.idx.proceed({
            methodType: "email"
        });
        if (status === "PENDING") {
            return thunkAPI.fulfillWithValue({
                status: "success"
            });
        } else {
            return thunkAPI.fulfillWithValue({
                invalidNumber: true
            });
        }
    } catch (err) {
        return thunkAPI.fulfillWithValue({
            error: true
        });
    }
});
const clearPreviousToken = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("get/otp/", async ()=>{
    await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.session.close */ .U.session.close();
    await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.tokenManager.clear */ .U.tokenManager.clear();
});
const validateOTP = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("auth/login", async (payload, thunkAPI)=>{
    const { otpEnteredByUser , isFirstLogin =false , isReplace =false , isMobile =false , isCheckoutStep =false  } = payload;
    const state = thunkAPI.getState();
    const { cart  } = state === null || state === void 0 ? void 0 : state.cart;
    try {
        var ref, ref1, ref2, ref3, ref4, ref5;
        const res = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.idx.proceed */ .U.idx.proceed({
            verificationCode: otpEnteredByUser
        });
        if (res.status === "SUCCESS") {
            _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.tokenManager.setTokens */ .U.tokenManager.setTokens(res.tokens);
            localStorage.setItem("userLoggedIn", true);
            return _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.token.getWithoutPrompt */ .U.token.getWithoutPrompt({
                responseType: [
                    "id_token",
                    "access_token",
                    "refresh_token"
                ],
                sessionToken: res.sessionToken
            }).then(async function(param) {
                let { tokens  } = param;
                var ref, ref1;
                await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.tokenManager.setTokens */ .U.tokenManager.setTokens(tokens);
                const payload = {
                    accessToken: tokens === null || tokens === void 0 ? void 0 : (ref = tokens.accessToken) === null || ref === void 0 ? void 0 : ref.accessToken,
                    refreshToken: tokens.refreshToken.refreshToken,
                    user: (tokens === null || tokens === void 0 ? void 0 : (ref1 = tokens.accessToken) === null || ref1 === void 0 ? void 0 : ref1.claims) || {},
                    isAuth: true
                };
                await thunkAPI.dispatch(postLogin(payload));
                await thunkAPI.dispatch(setAuthData(payload));
                const state = thunkAPI.getState();
                const mergeCartPayload = {
                    anonymousId: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getAnonymousId)()
                };
                if (isReplace) {
                    mergeCartPayload.action = "replace";
                }
                if (!isFirstLogin && mergeCartPayload.anonymousId) {
                    var ref2;
                    let itemsBeforeMerge = cart === null || cart === void 0 ? void 0 : (ref2 = cart.lineItems) === null || ref2 === void 0 ? void 0 : ref2.length;
                    if (isCheckoutStep) {
                        await thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setCardStatus */ .YZ)(true));
                    }
                    await thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .mergeCart */ .Ii)(mergeCartPayload)).then(async ()=>{
                        var ref;
                        const updatedState = thunkAPI.getState();
                        const { cart: updatedCart  } = updatedState === null || updatedState === void 0 ? void 0 : updatedState.cart;
                        if ((updatedCart === null || updatedCart === void 0 ? void 0 : (ref = updatedCart.lineItems) === null || ref === void 0 ? void 0 : ref.length) - itemsBeforeMerge) {
                            if (!isCheckoutStep) {
                                await thunkAPI.dispatch((0,_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .showToast */ .CF)({
                                    message: "Your cart may have been updated. Please review the cart.",
                                    isVisible: true
                                }));
                            } else {
                                await thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .showMergeModal */ .Ot)());
                                await thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setCardStatus */ .YZ)(false));
                            }
                            const onClick = async ()=>{
                                await thunkAPI.dispatch((0,_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .showCartExpandedView */ .Lf)(true));
                                window.scrollTo(0, 1000, {
                                    behavior: "smooth"
                                });
                            };
                            if (isMobile && !isCheckoutStep) {
                                await thunkAPI.dispatch((0,_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .showToast */ .CF)({
                                    message: 'Your cart is updated. <a href=\'#\' class="underline" onclick="'.concat(onClick(), '">Click here</a> to view the items.'),
                                    isVisible: true
                                }));
                            }
                        }
                    }).finally(async ()=>{
                        await thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setCardStatus */ .YZ)(false));
                    });
                } else {
                    thunkAPI.dispatch(setAnonymousId(""));
                }
                // ------------ functionality review start ----------------
                const loginCallback = window.loginCallback;
                const { hideCustomerSignupCTA  } = state === null || state === void 0 ? void 0 : state.auth;
                if (loginCallback) {
                    if (hideCustomerSignupCTA) {
                        const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getUserPersona)();
                        const { general: { homepageUrl =""  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
                        window.KPNSignIn ? window.location.replace(loginCallback) : null;
                    } else {
                        if (typeof loginCallback === "function") {
                            loginCallback();
                        } else {
                            window.location.replace(loginCallback);
                        // await authClient.session.setCookieAndRedirect(res.sessionToken)
                        }
                        window.loginCallback = null;
                    }
                }
                // ------------ functionality review end ----------------
                // await authClient.session.setCookieAndRedirect(res.sessionToken)
                return thunkAPI.fulfillWithValue("success");
            }).catch(function(err) {
                return thunkAPI.fulfillWithValue((err === null || err === void 0 ? void 0 : err.errorSummary) || "error");
            });
        } else if ((res === null || res === void 0 ? void 0 : (ref = res.messages) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.message) === _constants_index__WEBPACK_IMPORTED_MODULE_1__["default"].INVALID_OTP || (res === null || res === void 0 ? void 0 : (ref2 = res.messages) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.message) === _constants_index__WEBPACK_IMPORTED_MODULE_1__["default"].SESSION_EXPIRED) {
            return thunkAPI.fulfillWithValue({
                invalidOTP: true,
                data: res.data
            });
        } else if ((res === null || res === void 0 ? void 0 : (ref4 = res.messages) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.message) === _constants_index__WEBPACK_IMPORTED_MODULE_1__["default"].TOO_MANY_ATTEMPTS) {
            {
                return thunkAPI.fulfillWithValue({
                    tooManyAttempts: true,
                    data: res.data
                });
            }
        }
    } catch (err) {
        return thunkAPI.fulfillWithValue((err === null || err === void 0 ? void 0 : err.errorSummary) || "error");
    }
});
const userLogin = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("auth/login", async (payload, thunkAPI)=>{
    const { username , password , isFirstLogin =false , isReplace =false  } = payload;
    try {
        const res = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.signInWithCredentials */ .U.signInWithCredentials({
            username,
            password
        });
        if (res.status === "SUCCESS") {
            return _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.token.getWithoutPrompt */ .U.token.getWithoutPrompt({
                responseType: [
                    "id_token",
                    "access_token"
                ],
                sessionToken: res.sessionToken
            }).then(async function(param) {
                let { tokens  } = param;
                var ref;
                (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.clearAnonymousToken)();
                _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.tokenManager.setTokens */ .U.tokenManager.setTokens(tokens);
                const payload = {
                    accessToken: tokens.accessToken.accessToken,
                    refreshToken: tokens.refreshToken.refreshToken,
                    user: ((ref = tokens.accessToken) === null || ref === void 0 ? void 0 : ref.claims) || {},
                    isAuth: true
                };
                await thunkAPI.dispatch(postLogin(payload));
                const state = thunkAPI.getState();
                const mergeCartPayload = {
                    anonymousId: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getAnonymousId)()
                };
                if (isReplace) {
                    mergeCartPayload.action = "replace";
                }
                if (!isFirstLogin && mergeCartPayload.anonymousId) {
                    await thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .mergeCart */ .Ii)(mergeCartPayload));
                    dispatch((0,_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .showToast */ .CF)({
                        message: "Your cart may have been updated. Please review the cart.",
                        isVisible: true
                    }));
                } else {
                    thunkAPI.dispatch(setAnonymousId(""));
                }
                // ------------ functionality review start ----------------
                const loginCallback = window.loginCallback;
                const { hideCustomerSignupCTA  } = state === null || state === void 0 ? void 0 : state.auth;
                if (loginCallback) {
                    if (hideCustomerSignupCTA) {
                        const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getUserPersona)();
                        const { general: { homepageUrl =""  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
                        if (persona !== "TVS") {
                            window.location.replace(await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getShortenedUrl)(homepageUrl !== null && homepageUrl !== void 0 ? homepageUrl : "/"));
                        } else window.KPNSignIn ? window.location.replace(loginCallback) : null;
                    } else {
                        if (typeof loginCallback === "function") {
                            loginCallback();
                        } else {
                            window.location.replace(loginCallback);
                        // await authClient.session.setCookieAndRedirect(res.sessionToken)
                        }
                        window.loginCallback = null;
                    }
                }
                // ------------ functionality review end ----------------
                // await authClient.session.setCookieAndRedirect(res.sessionToken)
                return thunkAPI.fulfillWithValue("success");
            }).catch(function(err) {
                return thunkAPI.fulfillWithValue((err === null || err === void 0 ? void 0 : err.errorSummary) || "error");
            });
        } else if (res.status === "LOCKED_OUT") {
            return thunkAPI.fulfillWithValue({
                lockedOut: true
            });
        } else if (res.status === "PASSWORD_EXPIRED") {
            return thunkAPI.fulfillWithValue({
                passwordExpired: true,
                data: res.data
            });
        }
    } catch (err) {
        return thunkAPI.fulfillWithValue((err === null || err === void 0 ? void 0 : err.errorSummary) || "error");
    }
});
const login = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("auth/login", async (payload, thunkAPI)=>{
    const { username , password , isFirstLogin =false , isReplace =false  } = payload;
    try {
        const res = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.signInWithCredentials */ .U.signInWithCredentials({
            username,
            password
        });
        if (res.status === "SUCCESS") {
            return _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.token.getWithoutPrompt */ .U.token.getWithoutPrompt({
                responseType: [
                    "id_token",
                    "access_token",
                    "refresh_token"
                ],
                sessionToken: res.sessionToken
            }).then(async function(param) {
                let { tokens  } = param;
                var ref;
                await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.tokenManager.setTokens */ .U.tokenManager.setTokens(tokens);
                const payload = {
                    accessToken: tokens.accessToken.accessToken,
                    refreshToken: tokens.refreshToken.refreshToken,
                    user: ((ref = tokens.accessToken) === null || ref === void 0 ? void 0 : ref.claims) || {},
                    isAuth: true
                };
                await thunkAPI.dispatch(postLogin(payload));
                const state = thunkAPI.getState();
                const mergeCartPayload = {
                    anonymousId: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getAnonymousId)()
                };
                if (isReplace) {
                    mergeCartPayload.action = "replace";
                }
                if (!isFirstLogin && mergeCartPayload.anonymousId) {
                    await thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .mergeCart */ .Ii)(mergeCartPayload));
                    dispatch((0,_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .showToast */ .CF)({
                        message: "Your cart may have been updated. Please review the cart.",
                        isVisible: true
                    }));
                } else {
                    thunkAPI.dispatch(setAnonymousId(""));
                }
                // ------------ functionality review start ----------------
                const loginCallback = window.loginCallback;
                const { hideCustomerSignupCTA  } = state === null || state === void 0 ? void 0 : state.auth;
                if (loginCallback) {
                    if (hideCustomerSignupCTA) {
                        const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getUserPersona)();
                        const { general: { homepageUrl =""  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
                        if (persona !== "TVS") {
                            window.location.replace(await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getShortenedUrl)(homepageUrl !== null && homepageUrl !== void 0 ? homepageUrl : "/"));
                        } else window.KPNSignIn ? window.location.replace(loginCallback) : null;
                    } else {
                        if (typeof loginCallback === "function") {
                            loginCallback();
                        } else {
                            window.location.replace(loginCallback);
                        // await authClient.session.setCookieAndRedirect(res.sessionToken)
                        }
                        window.loginCallback = null;
                    }
                }
                // ------------ functionality review end ----------------
                // await authClient.session.setCookieAndRedirect(res.sessionToken)
                return thunkAPI.fulfillWithValue("success");
            }).catch(function(err) {
                return thunkAPI.fulfillWithValue((err === null || err === void 0 ? void 0 : err.errorSummary) || "error");
            });
        } else if (res.status === "LOCKED_OUT") {
            return thunkAPI.fulfillWithValue({
                lockedOut: true
            });
        } else if (res.status === "PASSWORD_EXPIRED") {
            return thunkAPI.fulfillWithValue({
                passwordExpired: true,
                data: res.data
            });
        }
    } catch (err) {
        return thunkAPI.fulfillWithValue((err === null || err === void 0 ? void 0 : err.errorSummary) || "error");
    }
});
const signup = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("auth/signup", async (payload, thunkAPI)=>{
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.signupEndPoint), payload);
        return response.data;
    } catch (err) {
        var ref;
        return thunkAPI.rejectWithValue(err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.data);
    }
});
const forgotPassword = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("auth/forgotPassword", async (payload, thunkAPI)=>{
    const { username  } = payload;
    try {
        const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        const { oktaChangePasswordUri  } = CONFIG === null || CONFIG === void 0 ? void 0 : CONFIG.apiEndpoints;
        const response = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.forgotPassword */ .U.forgotPassword({
            username,
            factorType: "EMAIL",
            relayState: oktaChangePasswordUri
        });
        return response.data;
    } catch (err) {
        return thunkAPI.rejectWithValue(err);
    }
});
const deleteAllCookies = ()=>{
    const cookies = document.cookie.split(";");
    for(let i = 0; i < cookies.length; i++){
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
};
const logout = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("auth/logout", async (payload, thunkAPI)=>{
    try {
        let apimHost = process.env.NEXT_PUBLIC_APIMBASEURL;
        const oktaTokenStorage = JSON.parse(localStorage.getItem("okta-token-storage")) || {};
        const caConfig = JSON.parse(localStorage.getItem("caConfig"));
        const idToken = oktaTokenStorage === null || oktaTokenStorage === void 0 ? void 0 : oktaTokenStorage["idToken"];
        const accessToken = oktaTokenStorage === null || oktaTokenStorage === void 0 ? void 0 : oktaTokenStorage["accessToken"];
        await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.signOut */ .U.signOut({
            revokeAccessToken: true,
            idToken,
            accessToken,
            clearTokensBeforeRedirect: true
        });
        localStorage.clear();
        localStorage.setItem("caConfig", JSON.stringify(caConfig));
        localStorage.setItem("userLoggedIn", false);
        deleteAllCookies();
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.createPersonaCookie)();
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .removeCustomerCartId */ .w$)();
        await thunkAPI.dispatch(clearPreviousToken());
        await thunkAPI.dispatch(clearAuthState());
        await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.session.close */ .U.session.close();
    } catch (err) {
        var ref;
        return thunkAPI.rejectWithValue(err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.data);
    }
});
const postLogin = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)("auth/postLogin", async (payload)=>{
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.clearAnonymousToken)();
    const { user ={}  } = payload;
    if (user === null || user === void 0 ? void 0 : user.sub) {
        // this is email id hashing
        const res = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.shaEncrypt)(user === null || user === void 0 ? void 0 : user.sub);
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.createPersonaCookie)();
        return {
            ...payload,
            encryptedEmail: res
        };
    }
});
const authSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createSlice */ .oM)({
    name: "auth",
    initialState,
    reducers: {
        clearAuthState (state, action) {
            state.isAuth = false;
            state.anonymousId = "";
            state.access_token = "";
            state.refresh_token = "";
            state.revalidate_in = "";
            state.user = {};
            state.hashedEmail = "";
            state.customerProspect = "";
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.clearAuthToken)();
            if (window) {
                window.authAccessToken = "";
            }
        },
        closeAuthShow (state, action) {
            state.closeAuth = action.payload;
        },
        setAuthData (state, action) {
            const { accessToken ="" , refreshToken ="" , isAuth =false , user ={} , name ={}  } = action.payload;
            if (accessToken) {
                state.access_token = accessToken;
                if (window) {
                    window.authAccessToken = accessToken;
                }
                if (!isAuth) {
                    localStorage.setItem("okta-anonymous-access-token", accessToken);
                }
            }
            if (refreshToken) {
                state.refresh_token = refreshToken;
                localStorage.setItem("okta-anonymous-refresh-token", refreshToken);
            }
            if (isAuth) state.isAuth = isAuth;
            if (user) state.user = user;
            if (name) state.name = name;
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.revalidateTime)();
        },
        setUserData (state, action) {
            state.loggedInUser = action.payload;
        },
        setRevalidateTime (state, action) {
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.revalidateTime)();
        },
        setAuthModalVisibility (state, action) {
            const { show , active =0  } = action.payload;
            state.authModal = {
                ...state.authModal,
                show: show,
                active: show ? active : 0
            };
            state.showCustomerSignup = false;
            state.showProSignup = false;
            state.showForgotPassword = false;
            if (!show && (window === null || window === void 0 ? void 0 : window.initSignUpFlow)) {
                window.initSignUpFlow = null;
            }
            if (!show) {
                state.favoritesLogin = false;
            }
        },
        setFavoritesLogin (state) {
            state.favoritesLogin = true;
        },
        setAuthModalActiveTab (state, action) {
            state.authModal = {
                ...state.authModal,
                active: action.payload
            };
        },
        setAuthModalStaticText (state, action) {
            state.authModal = {
                ...state.authModal,
                staticText: action.payload
            };
        },
        setAnonymousId (state, action) {
            const anonymousId = action.payload;
            state.anonymousId = anonymousId;
            localStorage.setItem("anonymousId", anonymousId);
        },
        setShowCustomerSignup (state, action) {
            state.showCustomerSignup = action.payload;
            state.showProSignup = false;
            state.showForgotPassword = false;
            state.authModal = {
                ...state.authModal,
                show: action.payload
            };
        },
        setShowProSignup (state, action) {
            state.showProSignup = action.payload;
            state.showCustomerSignup = false;
            state.showForgotPassword = false;
            state.authModal = {
                ...state.authModal,
                show: action.payload
            };
        },
        setShowForgotPassword (state, action) {
            state.showForgotPassword = action.payload;
            state.showCustomerSignup = false;
            state.showProSignup = false;
            state.authModal = {
                ...state.authModal,
                show: action.payload
            };
        },
        setHideCustomerSignupCTA (state, action) {
            state.hideCustomerSignupCTA = action.payload;
        },
        setPersona (state, action) {
            const { isAuth , user: { uid  }  } = state;
            const { user  } = state;
            if (isAuth) {
                sessionStorage.setItem(_constants_index__WEBPACK_IMPORTED_MODULE_1__["default"].KF_UPDATE_MEMBERSHIP, JSON.stringify({
                    uid
                }));
                localStorage.setItem(_constants_index__WEBPACK_IMPORTED_MODULE_1__["default"].KF_FORCE_RENEW_TOKEN, true);
                state.user = {
                    ...user,
                    persona: [
                        action.payload
                    ]
                };
            }
        },
        setUserName (state, action) {
            const { isAuth , user  } = state;
            var ref;
            const [firstName = "", lastName = ""] = (ref = action === null || action === void 0 ? void 0 : action.payload) !== null && ref !== void 0 ? ref : [];
            if (isAuth) {
                state.user = {
                    ...user,
                    firstName,
                    lastName
                };
            }
        },
        setAuthModalFormData (state, action) {
            state.authModal.formData = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_2__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.auth
            };
        }).addCase(getOktaToken.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getOktaToken.fulfilled, (state, action)=>{
            const { access_token: accessToken = "" , refresh_token: refreshToken = "" , expires_in: expiresIn = "" , scopes =[] , token_type: tokenType = ""  } = action.payload;
            if (accessToken) {
                state.access_token = accessToken;
                if (window) {
                    window.authAccessToken = accessToken;
                }
                localStorage.setItem("okta-anonymous-access-token", accessToken);
            }
            if (refreshToken) {
                state.refresh_token = refreshToken;
                localStorage.setItem("okta-anonymous-refresh-token", refreshToken);
            }
            if (expiresIn) state.expires_in = expiresIn;
            if (scopes) state.scopes = scopes;
            if (tokenType) state.token_type = tokenType;
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.revalidateTime)();
            state.status = "succeeded";
            state.error = "";
        }).addCase(getOktaToken.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(login.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(login.rejected, (state, action)=>{
            console.log("LOGIN", action.payload);
        }).addCase(login.fulfilled, (state, action)=>{
            console.log("LOGIN", action.payload);
        }).addCase(signup.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(signup.rejected, (state, action)=>{
            console.log("SIGNUP rejected", action.error);
        }).addCase(signup.fulfilled, (state, action)=>{
            console.log("SIGNUP fulfilled", action.payload);
        }).addCase(postLogin.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(postLogin.fulfilled, (state, action)=>{
            const { encryptedEmail ="" , accessToken ="" , refreshToken ="" , user ={} , isAuth =""  } = action.payload;
            const oldHashedEmail = state.hashedEmail;
            const oldCustomerProspect = state.customerProspect;
            if (accessToken) {
                state.access_token = accessToken;
                if (window) {
                    window.authAccessToken = accessToken;
                }
            }
            if (refreshToken) state.refresh_token = refreshToken;
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default()(user)) {
                state.user = user;
            }
            if (isAuth !== "") state.isAuth = isAuth;
            if (encryptedEmail) state.hashedEmail = encryptedEmail;
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.revalidateTime)();
            let needsUpdate = false;
            if (oldCustomerProspect && oldHashedEmail === encryptedEmail) {
                // here check if existing customerProspects are outdated
                try {
                    const decryptedCaesar = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.caesarDecrypt)(encryptedEmail, oldCustomerProspect);
                    const decryptedJSON = JSON.parse(decryptedCaesar);
                    const currDate = new Date().toString();
                    if (decryptedJSON.updatedAt && (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.hourDifference)(decryptedJSON.updatedAt, currDate) >= 1) {
                        needsUpdate = true;
                    }
                } catch (e) {
                    needsUpdate = true;
                }
            } else {
                needsUpdate = true;
            }
            if (needsUpdate) {
            /**
           * checking 3 conditions here
           *  1. if hashed emails are different
           *  2. if hashed emails are same then check if sync is done 1 hour ago or before that
           *  3. if old customer prospect object is missing from localstorage
           */ // await getPastOrders(true)
            }
        }).addCase(postLogin.rejected, (state, action)=>{
            console.log(action.error);
        });
    }
});
const { clearAuthState , setAuthData , setUserData , setRevalidateTime , setAuthModalVisibility , setFavoritesLogin , setAuthModalActiveTab , setAuthModalStaticText , setAnonymousId , setShowCustomerSignup , setShowProSignup , setShowForgotPassword , setHideCustomerSignupCTA , setPersona , setUserName , setAuthModalFormData , closeAuthShow  } = authSlice.actions;
const selectAuthState = (state)=>state.auth;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (authSlice.reducer);


/***/ }),

/***/ 46201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Al": function() { return /* binding */ discount; },
/* harmony export */   "Ao": function() { return /* binding */ cartSlice; },
/* harmony export */   "BR": function() { return /* binding */ setPaymetId; },
/* harmony export */   "Bk": function() { return /* binding */ createCart; },
/* harmony export */   "Cf": function() { return /* binding */ setRemoveItemId; },
/* harmony export */   "Ii": function() { return /* binding */ mergeCart; },
/* harmony export */   "NM": function() { return /* binding */ shipmentUpdate; },
/* harmony export */   "Ot": function() { return /* binding */ showMergeModal; },
/* harmony export */   "QL": function() { return /* binding */ taxCalculation; },
/* harmony export */   "RV": function() { return /* binding */ setCart; },
/* harmony export */   "Vp": function() { return /* binding */ shareCart; },
/* harmony export */   "Xq": function() { return /* binding */ addToCart; },
/* harmony export */   "YO": function() { return /* binding */ setShipping; },
/* harmony export */   "YZ": function() { return /* binding */ setCardStatus; },
/* harmony export */   "Z5": function() { return /* binding */ removeFromCartLineItem; },
/* harmony export */   "aN": function() { return /* binding */ orderSubmit; },
/* harmony export */   "al": function() { return /* binding */ deleteCart; },
/* harmony export */   "bs": function() { return /* binding */ breakBundle; },
/* harmony export */   "du": function() { return /* binding */ sendPaybyLink; },
/* harmony export */   "dv": function() { return /* binding */ getCart; },
/* harmony export */   "er": function() { return /* binding */ recentlyViewed; },
/* harmony export */   "i5": function() { return /* binding */ createCartISCUser; },
/* harmony export */   "lS": function() { return /* binding */ getAbandonedCarts; },
/* harmony export */   "mG": function() { return /* binding */ payment; },
/* harmony export */   "oJ": function() { return /* binding */ setCartCount; },
/* harmony export */   "pX": function() { return /* binding */ hideMergeModal; },
/* harmony export */   "pw": function() { return /* binding */ shipmentCart; },
/* harmony export */   "qT": function() { return /* binding */ setNoshipping; },
/* harmony export */   "sf": function() { return /* binding */ panConsentUpdate; },
/* harmony export */   "th": function() { return /* binding */ addresssSuggest; },
/* harmony export */   "w9": function() { return /* binding */ setShowShippingDetails; },
/* harmony export */   "xA": function() { return /* binding */ setCartUrl; },
/* harmony export */   "xO": function() { return /* binding */ setVersion; },
/* harmony export */   "xw": function() { return /* binding */ selectCartState; }
/* harmony export */ });
/* unused harmony exports shippingCost, addAddress, checkSplitOrder, payPalPayment, increment, decrement, setNameOnCard, setPanNumber */
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55111);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28858);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33273);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45094);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24899);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64757);









const initialState = {
    cart: {
        id: ""
    },
    quantity: 0,
    shipping: {},
    shipment: {},
    cartCount: 0,
    // shpping Items to checkout when product stock available
    shippingItemstoCheckout: [],
    // no items to ship from checkout when product is out of stock
    noShippingItemsInCheckout: [],
    cartUrl: "",
    showShippingDetailsForReview: {
        Parcel: false,
        LTL: false,
        Services: false
    },
    paymentId: "",
    nameOnCard: "",
    status: "",
    isCartMergeLoading: false,
    isCheckoutMergeModal: false
};
const getCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("getCart", async function() {
    let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isNotFromCart ="" , klId ="" , email ="" , isCheckout =false  } = payload;
    const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    if (email !== "") {
        var ref, ref1;
        const url = "/cart/filter"// it's for loading customer cart data using Email
        ;
        const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, payload);
        return (data === null || data === void 0 ? void 0 : data.results.length) ? (ref1 = (ref = data.results) === null || ref === void 0 ? void 0 : ref.filter((c)=>c.cartState === "Active")) === null || ref1 === void 0 ? void 0 : ref1[0] : {};
    }
    let url1 = klId ? "/cart/".concat(klId) // it's for loading customer cart data using KL id
     : "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.getCartEndPoint).concat(isNotFromCart ? "&gfqprofile=refershCartProfile" : "").concat(cartId);
    const buyNowInit = window === null || window === void 0 ? void 0 : window.localStorage.getItem("buy-now-init");
    const activeCartId = window === null || window === void 0 ? void 0 : window.localStorage.getItem("active-cart");
    const buyNowCart = window === null || window === void 0 ? void 0 : window.localStorage.getItem("buy-now-cart");
    if (buyNowInit === "false" && activeCartId && buyNowCart && !isCheckout) {
        url1 = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.getCartEndPoint, "&cartId=").concat(activeCartId);
    } else if (buyNowInit === "completed" && activeCartId && !buyNowCart) {
        url1 = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.getCartEndPoint, "&cartId=").concat(activeCartId);
        window === null || window === void 0 ? void 0 : window.localStorage.setItem("buy-now-init", false);
        window === null || window === void 0 ? void 0 : window.localStorage.removeItem("active-cart");
    }
    const { data: data1 = {}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url1);
    const { anonymousId =""  } = data1;
    _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(anonymousId));
    if (buyNowInit === "false" && activeCartId && buyNowCart && !isCheckout) {
        try {
            await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("/cart/items?cartId=".concat(data1 === null || data1 === void 0 ? void 0 : data1.id, "&expand=calculation"), {
                actions: [
                    {
                        action: "calculateTax"
                    }
                ],
                version: data1 === null || data1 === void 0 ? void 0 : data1.version
            });
            const { data: mergedCart  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("cart/merge", {
                cartKey: buyNowCart
            });
            window === null || window === void 0 ? void 0 : window.localStorage.removeItem("active-cart");
            window === null || window === void 0 ? void 0 : window.localStorage.removeItem("buy-now-cart");
            return mergedCart;
        } catch (ex) {
            console.log("Merging buy now product failed", ex);
        }
    }
    return data1;
});
const getAbandonedCarts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("getAbandonedCarts", async ()=>{
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(_constants_routes__WEBPACK_IMPORTED_MODULE_8__/* .ABANDONED_CARTS_URL */ .R);
    return data;
});
const createCartISCUser = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("createCartISCUser", async (body, thunkAPI)=>{
    var ref;
    const response = await axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.apiBaseUrl).concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.createCartEndPoint), body.cartPayload, {
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer ".concat(body.guestToken)
        }
    });
    if (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.anonymousId) {
        const { anonymousId  } = response === null || response === void 0 ? void 0 : response.data;
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(anonymousId));
    } else {
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(""));
    }
    let cart = response === null || response === void 0 ? void 0 : response.data;
    const { id ="" , type ="" , version =0  } = response === null || response === void 0 ? void 0 : response.data;
    if (type === "Cart") {
        const resp = await axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.apiBaseUrl, "/cart/items?cartId=").concat(id), {
            version: version,
            actions: [
                {
                    action: "setCustomerGroup",
                    customerGroup: {
                        key: "GST"
                    }
                }
            ]
        }, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(body.guestToken)
            }
        });
        var ref1;
        cart = (ref1 = resp === null || resp === void 0 ? void 0 : resp.data) !== null && ref1 !== void 0 ? ref1 : {};
    }
    return cart;
});
const createCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("createCart", async (body, thunkAPI)=>{
    var ref, ref1, ref2;
    const state = thunkAPI.getState();
    const { isAuth , user  } = state === null || state === void 0 ? void 0 : state.auth;
    const isIscUser = user === null || user === void 0 ? void 0 : (ref = user.persona) === null || ref === void 0 ? void 0 : ref.includes("IN_Kohler_ISC");
    body.currency = "INR" //Specific for INDIA PROJECT
    ;
    var ref3;
    if (user && !isIscUser) body.customerEmail = (ref3 = (ref1 = user.sub) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) !== null && ref3 !== void 0 ? ref3 : "";
    if (user.koc) body.custom = {
        type: {
            key: "order",
            typeId: "type"
        },
        fields: {
            CSRAssociateId: user.koc,
            orderType: "ISC"
        }
    };
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.createCartEndPoint), body);
    if (response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.anonymousId) {
        const { anonymousId  } = response === null || response === void 0 ? void 0 : response.data;
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(anonymousId));
    } else {
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(""));
    }
    let cart = response === null || response === void 0 ? void 0 : response.data;
    const { id ="" , type ="" , version =0  } = response === null || response === void 0 ? void 0 : response.data;
    if (type === "Cart") {
        if (!isAuth) {
            const resp = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("/cart/items?cartId=".concat(id), {
                version: version,
                actions: [
                    {
                        action: "setCustomerGroup",
                        customerGroup: {
                            key: "GST"
                        }
                    }
                ]
            });
            var ref4;
            cart = (ref4 = resp === null || resp === void 0 ? void 0 : resp.data) !== null && ref4 !== void 0 ? ref4 : {};
        }
    }
    return cart;
});
const shippingCost = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("shippingCost", async (id)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.shippingCostEndPoint, "?cartId=").concat(id));
    return response.data;
});
const discount = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("discount", async (body)=>{
    try {
        let cartID = body.cartID;
        delete body.cartID;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.discountEndPoint, "&cartId=").concat(cartID), body);
        return response.data;
    } catch (e) {
        return e.response.data;
    }
});
const taxCalculation = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("tax", async (body, thunkAPI)=>{
    const actionBody = {
        actions: [
            {
                action: "calculateTax"
            }
        ]
    };
    const state = thunkAPI.getState();
    const { cart: { id , version  }  } = state === null || state === void 0 ? void 0 : state.cart;
    actionBody.version = version;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.cartItemsEndPoint, "?cartId=").concat(id, "&expand=calculation"), actionBody);
    return response.data;
});
const shipmentUpdate = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("shipmentUpdate", async (body, thunkAPI)=>{
    try {
        const state = thunkAPI.getState();
        const { cart: { id , version  }  } = state === null || state === void 0 ? void 0 : state.cart;
        body.version = version;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.addressEndPoint, "?cartId=").concat(id, "&expand=calculation"), body);
        return response.data;
    } catch (error) {
        const { response: { data: { isNonDeliverableAddress =false  } = {}  } = {}  } = error;
        return thunkAPI.rejectWithValue({
            isNonDeliverableAddress
        });
    }
});
const panConsentUpdate = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("panConsentUpdate", async (body, thunkAPI)=>{
    try {
        const state = thunkAPI.getState();
        const { cart: { id , version  }  } = state === null || state === void 0 ? void 0 : state.cart;
        body.version = version;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post((0,_constants_index__WEBPACK_IMPORTED_MODULE_2__.panConsentEndPoint)(id), body);
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue({
            error
        });
    }
});
const shareCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("sharecart", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.shareCartEndPoint), body);
    return response.data;
});
const mergeCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("cart/merge", async (payload)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_2__.mergeCartEndPoint, payload);
    if (response && response.data && response.data.type === "Cart") {
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(""));
    }
    return response.data;
});
const addToCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("addToCart", async (body, thunkAPI)=>{
    var ref;
    const state = thunkAPI.getState();
    const { user  } = state === null || state === void 0 ? void 0 : state.auth;
    const { cart: { id , version  }  } = state === null || state === void 0 ? void 0 : state.cart;
    let userType = "GST";
    if (user && (user === null || user === void 0 ? void 0 : user.persona)) {
        var ref1;
        userType = (ref1 = user === null || user === void 0 ? void 0 : user.persona[0]) === null || ref1 === void 0 ? void 0 : ref1.split(":");
    }
    // if (!customerGroup) {
    //   const customerGroupData = {}
    //   customerGroupData["action"] = "setCustomerGroup"
    //   customerGroupData["customerGroup"] = { key: userType }
    //   if (body.actions) {
    //     body.actions.push(customerGroupData)
    //   }
    // }
    body.version = version;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.cartItemsEndPoint, "?cartId=").concat(id, "&expand=calculation"), body);
    if (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.anonymousId) {
        const { anonymousId  } = response === null || response === void 0 ? void 0 : response.data;
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(anonymousId));
    } else {
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(""));
    }
    return response.data;
});
const removeFromCartLineItem = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("removeFromCartLineItem", async (body, thunkAPI)=>{
    const state = thunkAPI.getState();
    const { cart: { id , version  }  } = state === null || state === void 0 ? void 0 : state.cart;
    body.version = version;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.cartItemsEndPoint, "?cartId=").concat(id, "&expand=calculation"), body);
    return response.data;
});
const breakBundle = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("breakBundle", async (lineItemId, thunkAPI)=>{
    const state = thunkAPI.getState();
    const { cart: { id , version  }  } = state === null || state === void 0 ? void 0 : state.cart;
    const payload = {
        version,
        actions: [
            {
                action: "breakBundleItem",
                lineItemId
            }
        ]
    };
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.cartItemsEndPoint, "?cartId=").concat(id, "&expand=calculation"), payload);
    return response.data;
});
const deleteCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("deleteCart", async ()=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim["delete"] */ .TH["delete"]("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.deleteCartEndPoint));
    return response.data;
});
const sendPaybyLink = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("send/paybylink", async (param)=>{
    let { emailId , phoneNumber , event  } = param;
    const payload = {
        emailId,
        phoneNumber
    };
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.sendTriggerURL, "?evtName=").concat(event);
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, payload);
        return res;
    } catch (error) {
        return error;
    }
});
const shipmentCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("shipmentcart", async (body)=>{
    let response;
    try {
        if (body && (body === null || body === void 0 ? void 0 : body.assign) && (body === null || body === void 0 ? void 0 : body.payload)) {
            response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.shipmentFromCartEndPoint).concat(body.assign ? "?assignshipping=true" : ""), body.payload);
        } else {
            response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.shipmentFromCartEndPoint));
        }
        return response.data;
    } catch (error) {
        var ref, ref1, ref2;
        const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_5__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_5__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_5__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
        const shippingDetails = {
            "shipping-details": {
                results: []
            },
            shippingCost: true
        };
        response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.shippingCostEndPoint, "?cartId=").concat(cart === null || cart === void 0 ? void 0 : cart.id));
        shippingDetails["shipping-details"]["results"] = response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.results;
        return shippingDetails;
    }
});
const addresssSuggest = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("addresssSuggest", async (addr)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.addressSuggestionEndPoint, "?query=").concat(addr, "&country=USA"));
    return response.data;
});
const addAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("addAddress", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.addAddressEndPoint), body);
    return response.data;
});
const checkSplitOrder = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("checkSplitOrder", async (cartId)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.checkSplitOrderEndPoint, "?cartId=").concat(cartId));
    return response.data;
});
const payment = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("payment", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.paymentEndPoint), body);
    return response.data;
});
const payPalPayment = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("payPalPayment", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.payPalPaymentEndPoint), body);
    return response.data;
});
const orderSubmit = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("orderSubmit", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.orderSubmitEndPoint), body);
    return response.data;
});
const recentlyViewed = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("recentlyViewed", async (query)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.recentlyViewedEndPoint, "?where=id in (").concat(query, ")"));
    return response.data;
});
const cartSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "cart",
    initialState,
    reducers: {
        setCart (state, action) {
            state.cart = action.payload;
        },
        setCartCount (state, action) {
            state.cartCount = action.payload;
        },
        setShipping (state, action) {
            state.shippingItemstoCheckout = action.payload;
        },
        setNoshipping (state, action) {
            var ref;
            const skuIds = action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : ref.map((item)=>item.sku);
            state.noShippingItemsInCheckout = skuIds || [];
        },
        setShowShippingDetails (state, action) {
            state.showShippingDetailsForReview = action.payload;
        },
        setCartUrl (state, action) {
            state.cartUrl = action.payload;
        },
        setPaymetId (state, action) {
            state.paymentId = action.payload;
        },
        showMergeModal (state, action) {
            state.isCheckoutMergeModal = true;
        },
        hideMergeModal (state, action) {
            state.isCheckoutMergeModal = false;
        },
        increment (state, action) {
            state.quantity = state.quantity + 1;
        },
        decrement (state, action) {
            state.quantity = state.quantity - 1;
        },
        setNameOnCard (state, action) {
            state.nameOnCard = action.payload;
        },
        setCardStatus (state, action) {
            state.isCartLoading = action.payload;
        },
        setVersion (state, action) {
            state.cart.version = action.payload;
        },
        setRemoveItemId (state, action) {
            state.itemId = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_3__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.cart
            };
        }).addCase(getCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getCart.fulfilled, (state, action)=>{
            var ref, ref1;
            state.cart = action.payload;
            const lineItems = ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems) || [];
            const customLineItems = ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.customLineItems) || [];
            var ref2;
            state.cartCount = (ref2 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)([
                ...lineItems,
                ...customLineItems
            ])) !== null && ref2 !== void 0 ? ref2 : 0;
            state.status = "succeeded";
        }).addCase(getCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getAbandonedCarts.pending, (state)=>{
            state.status = "loading";
        }).addCase(getAbandonedCarts.fulfilled, (state, action)=>{
            state.abandonedCarts = action.payload;
            state.status = "succeeded";
        }).addCase(getAbandonedCarts.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(createCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(createCart.fulfilled, (state, action)=>{
            state.cart = action.payload;
            state.status = "succeeded";
        }).addCase(createCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(createCartISCUser.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(createCartISCUser.fulfilled, (state, action)=>{
            state.cart = action.payload;
            state.status = "succeeded";
        }).addCase(createCartISCUser.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shippingCost.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(shippingCost.fulfilled, (state, action)=>{
            state.shipping = action.payload;
            state.status = "succeeded";
        }).addCase(shippingCost.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(discount.pending, (state)=>{
            state.status = "loading";
        }).addCase(discount.fulfilled, (state, action)=>{
            state.status = "succeeded";
            // after discount this will set cart with updated data
            if (!action.payload.error) {
                state.cart = action.payload;
            }
        }).addCase(discount.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(taxCalculation.pending, (state)=>{
            state.status = "loading";
        }).addCase(taxCalculation.fulfilled, (state, action)=>{
            state.status = "succeeded";
            // after tax this will set cart with updated data
            state.cart = action.payload;
        }).addCase(taxCalculation.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shipmentUpdate.pending, (state)=>{
            state.status = "loading";
        }).addCase(shipmentUpdate.fulfilled, (state, action)=>{
            var ref, ref1;
            state.status = "succeeded";
            // temp
            const activeCart = ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.type) === "Cart" && ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.lineItems.length) > 0;
            state.cart = activeCart ? action.payload : state.cart;
        }).addCase(shipmentUpdate.rejected, (state, action)=>{
            var ref;
            state.status = "failed";
            state.error = action.error.message;
            state.isNonDeliverableAddress = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.isNonDeliverableAddress;
        }).addCase(shareCart.pending, (state)=>{
        // state.status = "loading"
        }).addCase(shareCart.fulfilled, (state, action)=>{
        // state.status = "succeeded"
        }).addCase(shareCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addToCart.pending, (state, action)=>{
            // state.status = "loading"
            state.status = "loading";
        }).addCase(addToCart.fulfilled, (state, action)=>{
            var ref, ref1;
            state.cart = action.payload;
            const lineItems = ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems) || [];
            const customLineItems = ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.customLineItems) || [];
            var ref2;
            state.cartCount = (ref2 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)([
                ...lineItems,
                ...customLineItems
            ])) !== null && ref2 !== void 0 ? ref2 : 0;
            state.status = "succeeded";
        }).addCase(addToCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(deleteCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(deleteCart.fulfilled, (state, action)=>{
            // state.cart = { id: action.payload.id, lineItems: [] }
            state.cartCount = 0;
            state.status = "succeeded";
        }).addCase(deleteCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shipmentCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(shipmentCart.fulfilled, (state, action)=>{
            var ref;
            if (!((ref = action.payload) === null || ref === void 0 ? void 0 : ref.shippingCost)) {
                state.cart = {
                    ...state.cart,
                    ...action.payload
                };
            }
            state.status = "succeeded";
        }).addCase(shipmentCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addresssSuggest.pending, (state, action)=>{
        // state.status = "loading"
        }).addCase(addresssSuggest.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(addresssSuggest.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addAddress.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(addAddress.fulfilled, (state, action)=>{
            // state.cart = action.payload
            state.status = "succeeded";
        }).addCase(addAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(checkSplitOrder.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(checkSplitOrder.fulfilled, (state, action)=>{
            state.cart = {
                ...state.cart,
                ...action.payload
            };
            state.status = "succeeded";
        }).addCase(checkSplitOrder.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(mergeCart.pending, (state, action)=>{
            state.status = "loading";
            state.isCartMergeLoading = true;
        }).addCase(mergeCart.fulfilled, (state, action)=>{
            var ref, ref1;
            state.cart = action.payload;
            const lineItems = ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems) || [];
            const customLineItems = ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.customLineItems) || [];
            var ref2;
            state.cartCount = (ref2 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)([
                ...lineItems,
                ...customLineItems
            ])) !== null && ref2 !== void 0 ? ref2 : 0;
            state.status = "succeeded";
            state.isCartMergeLoading = false;
        }).addCase(mergeCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
            state.isCartMergeLoading = false;
        }).addCase(payment.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(payment.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(payment.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(payPalPayment.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(payPalPayment.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(payPalPayment.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(orderSubmit.pending, (state, action)=>{
            state.status = "loading" || 0;
        }).addCase(orderSubmit.fulfilled, (state, action)=>{
            // state.cart = action.payload
            state.status = "succeeded" || 0;
        }).addCase(orderSubmit.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message || "";
        }).addCase(removeFromCartLineItem.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(removeFromCartLineItem.fulfilled, (state, action)=>{
            var ref, ref1;
            state.cart = action.payload;
            const lineItems = ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems) || [];
            const customLineItems = ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.customLineItems) || [];
            var ref2;
            state.cartCount = (ref2 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)([
                ...lineItems,
                ...customLineItems
            ])) !== null && ref2 !== void 0 ? ref2 : 0;
            state.status = "succeeded";
        }).addCase(removeFromCartLineItem.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(breakBundle.pending, (state)=>{
            state.status = "loading";
        }).addCase(breakBundle.fulfilled, (state, action)=>{
            var ref, ref1;
            state.cart = action.payload;
            const lineItems = ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems) || [];
            const customLineItems = ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.customLineItems) || [];
            var ref2;
            state.cartCount = (ref2 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)([
                ...lineItems,
                ...customLineItems
            ])) !== null && ref2 !== void 0 ? ref2 : 0;
            state.status = "suceeded";
        }).addCase(breakBundle.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(recentlyViewed.pending, (state)=>{
            state.status = "loading";
        }).addCase(recentlyViewed.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(recentlyViewed.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setCart , increment , decrement , setCartCount , setCartUrl , setShipping , setNoshipping , setShowShippingDetails , setPaymetId , setNameOnCard , setCardStatus , setRemoveItemId , setPanNumber , setVersion , showMergeModal , hideMergeModal  } = cartSlice.actions;
const selectCartState = (state)=>state.cart;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (cartSlice.reducer);


/***/ }),

/***/ 60475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ getProfile; },
/* harmony export */   "BZ": function() { return /* binding */ setCheckoutAction; },
/* harmony export */   "TG": function() { return /* binding */ checkoutState; },
/* harmony export */   "Yb": function() { return /* binding */ editAddress; },
/* harmony export */   "_K": function() { return /* binding */ setDefaultAddress; },
/* harmony export */   "hK": function() { return /* binding */ setIsPaymentInfoAction; },
/* harmony export */   "vu": function() { return /* binding */ checkoutSlice; },
/* harmony export */   "y$": function() { return /* binding */ addAddress; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77236);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34326);




const initialState = {
    status: "",
    error: "",
    addresses: [],
    profileInfo: null,
    profileVersion: null,
    nextDefaultAddressId: null,
    profileLoading: true
};
const editAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/address/edit", async (payload, thunkAPI)=>{
    let addresses = [];
    const body = {
        actions: [
            {
                action: "changeAddress",
                addressId: payload.id,
                address: payload.address
            }
        ],
        version: payload.version
    };
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.editAddressEndPoint), body);
        if (res && res.data) {
            if (res.data.addresses.length > 0) {
                var ref;
                var ref1;
                addresses = (ref1 = (ref = res.data.addresses) === null || ref === void 0 ? void 0 : ref.filter((addr)=>{
                    var ref, ref1;
                    return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref1 !== void 0 ? ref1 : [];
                if (payload.address.setPrimary) {
                    res.data.setPrimary = true;
                    res.data.nextDefaultAddressId = payload.id;
                }
            }
        }
        res.data.addresses = addresses;
        return res.data;
    } catch (error) {
        const { response: { data: { isNonDeliverableAddress =false  } = {}  } = {}  } = error;
        return thunkAPI.rejectWithValue({
            isNonDeliverableAddress
        });
    }
});
const addAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/address/add", async (payload, thunkAPI)=>{
    let addresses = [];
    const body = Array.isArray(payload.address) ? {
        version: payload.version,
        actions: payload.data
    } : {
        version: payload.version,
        actions: [
            {
                action: "addAddress",
                address: payload.address
            }
        ]
    };
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.editAddressEndPoint), body);
        if (res && res.data) {
            if (res.data.addresses.length > 0) {
                var ref;
                var ref1;
                addresses = (ref1 = (ref = res.data.addresses) === null || ref === void 0 ? void 0 : ref.filter((addr)=>{
                    var ref, ref1;
                    return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref1 !== void 0 ? ref1 : [];
                if (payload.address.setPrimary) {
                    var ref2;
                    const index = addresses.length - 1;
                    res.data.setPrimary = true;
                    res.data.nextDefaultAddressId = (ref2 = addresses[index]) === null || ref2 === void 0 ? void 0 : ref2.id;
                }
            }
        }
        res.data.addresses = addresses;
        return res.data;
    } catch (error) {
        const { response: { data: { isNonDeliverableAddress =false  } = {}  } = {}  } = error;
        return thunkAPI.rejectWithValue({
            isNonDeliverableAddress
        });
    }
});
const setDefaultAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/default/address", async (payload)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    const body = {
        version: payload.profileVersion,
        actions: [
            {
                action: "setDefaultShippingAddress",
                addressId: payload.id
            }
        ]
    };
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.editAddressEndPoint), body);
    if (res && res.data) {
        resPayload.version = res.data.version;
        if (res.data.addresses.length > 0) {
            var ref;
            var ref1;
            resPayload.addresses = (ref1 = (ref = res.data.addresses) === null || ref === void 0 ? void 0 : ref.filter((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
            })) !== null && ref1 !== void 0 ? ref1 : [];
            resPayload.defaultShippingAddressId = res.data.defaultShippingAddressId;
        }
    }
    return resPayload;
});
const getProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/me", async ()=>{
    var ref, ref1;
    let profile = {};
    let index = 0;
    let addresses = {};
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.GET_PROFILE_ENDPOINT));
    profile = response.data;
    const profileAddr = profile === null || profile === void 0 ? void 0 : (ref = profile.addresses) === null || ref === void 0 ? void 0 : ref.find((addr)=>{
        var ref, ref1;
        return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) === "Profile";
    });
    profile["profileAddrId"] = profileAddr === null || profileAddr === void 0 ? void 0 : profileAddr.id;
    profile["addresses"] = profile === null || profile === void 0 ? void 0 : (ref1 = profile.addresses) === null || ref1 === void 0 ? void 0 : ref1.filter((addr)=>{
        var ref, ref1;
        return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
    });
    addresses = profile === null || profile === void 0 ? void 0 : profile.addresses;
    if (profile === null || profile === void 0 ? void 0 : profile.defaultShippingAddressId) {
        index = addresses.findIndex((item)=>{
            return item.id === (profile === null || profile === void 0 ? void 0 : profile.defaultShippingAddressId);
        });
    }
    if (index !== 0) {
        addresses = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.arrayMove)(profile === null || profile === void 0 ? void 0 : profile.addresses, index, 0);
    }
    profile["addresses"] = addresses;
    response["data"] = profile;
    return response.data;
});
const checkoutSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "checkout",
    initialState,
    reducers: {
        setIsPaymentInfoAction (state, action) {
            state.isPaymentInfo = action.payload;
        },
        setCheckoutAction (state, action) {
            state.checkoutStep = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase(editAddress.pending, (state)=>{
            state.status = "loading";
        }).addCase(editAddress.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const { addresses , version , nextDefaultAddressId , setPrimary  } = action.payload;
            state.addresses = addresses;
            state.profileVersion = version;
            if (setPrimary) {
                state.nextDefaultAddressId = nextDefaultAddressId;
            }
        }).addCase(editAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(setDefaultAddress.pending, (state)=>{
            state.status = "loading";
        }).addCase(setDefaultAddress.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const { addresses , version  } = action.payload;
            state.addresses = addresses;
            state.profileVersion = version;
        }).addCase(setDefaultAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getProfile.pending, (state)=>{
            state.status = "loading";
            state.profileLoading = true;
        }).addCase(getProfile.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.profileInfo = action.payload;
            state.profileVersion = action.payload.version;
            state.profileLoading = false;
        }).addCase(getProfile.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
            state.profileLoading = false;
        }).addCase(addAddress.pending, (state)=>{
            state.status = "loading";
        }).addCase(addAddress.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const { addresses , version , nextDefaultAddressId , setPrimary , defaultShippingAddressId  } = action.payload;
            state.addresses = addresses;
            state.profileVersion = version;
            state.defaultAddressId = defaultShippingAddressId;
            if (setPrimary) {
                state.nextDefaultAddressId = nextDefaultAddressId;
            }
        }).addCase(addAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setIsPaymentInfoAction , setCheckoutAction  } = checkoutSlice.actions;
const checkoutState = (state)=>state.checkout;


/***/ }),

/***/ 39915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Er": function() { return /* binding */ updateCompareStatus; },
/* harmony export */   "JY": function() { return /* binding */ clearProduct; },
/* harmony export */   "NP": function() { return /* binding */ compareState; },
/* harmony export */   "Oe": function() { return /* binding */ clearAllCompareProducts; },
/* harmony export */   "Sw": function() { return /* binding */ setCompareExpiry; },
/* harmony export */   "qD": function() { return /* binding */ compareSlice; },
/* harmony export */   "rI": function() { return /* binding */ addCompareProducts; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77236);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);


const initialState = {
    category: "",
    comparedProducts: [],
    expiresIn: 60,
    isEnable: false
};
const compareSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "compare",
    initialState,
    reducers: {
        clearProduct (state, action) {
            state.comparedProducts.forEach((obj)=>{});
            const products = state.comparedProducts.filter((product)=>product.compareSku !== action.payload);
            const query = products.map((item)=>item.compareSku).join(",");
            const path = "".concat(products.length > 0 ? "?compare=" : "").concat(query.toString());
            if (!query) {
                window.history.replaceState(null, "", window.location.pathname);
            } else {
                window.history.replaceState(window.location.pathname, document.title, path);
            }
            state.category = products.length === 0 ? "" : state.category;
            state.comparedProducts = products;
        },
        setCompareExpiry (state, action) {
            state.expiresIn = action.payload;
        },
        clearAllCompareProducts (state, action) {
            state.category = "";
            state.comparedProducts = [];
        },
        addCompareProducts (state, action) {
            try {
                const { expiresIn  } = state;
                const { sku ={} , backorder ="No" , compareSku ="" , imgUrl =""  } = action.payload;
                const product = sku;
                if (product && product != {}) {
                    var ref;
                    product.compareSku = compareSku || ((ref = sku.masterVariant) === null || ref === void 0 ? void 0 : ref.sku);
                    product.expiry = Date.now() + expiresIn * 24 * 3600 * 1000;
                    if (backorder === "Yes") product.backorder = true;
                    product.imgUrl = imgUrl;
                    const productsTemp = state.comparedProducts;
                    const prodMain = productsTemp.filter((obj)=>{
                        return obj.compareSku !== sku.masterSKU_s;
                    });
                    prodMain.push(product);
                    state.comparedProducts = prodMain;
                    state.category = product === null || product === void 0 ? void 0 : product.ProductCategory_s;
                }
                state.isEnable = false;
            } catch (error) {
                state.isEnable = false;
            }
        },
        updateCompareStatus (state, action) {
            state.isEnable = action.payload;
        }
    }
});
const { setCompareExpiry , clearAllCompareProducts , addCompareProducts , clearProduct , updateCompareStatus  } = compareSlice.actions;
const compareState = (state)=>state.compare;


/***/ }),

/***/ 5702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rA": function() { return /* binding */ addMedia; },
  "gK": function() { return /* binding */ addProduct; },
  "MY": function() { return /* binding */ favoritesSlice; },
  "_l": function() { return /* binding */ getFavorites; },
  "w": function() { return /* binding */ getMyAccountFavorites; },
  "tC": function() { return /* binding */ myAccountRemoveItems; },
  "Er": function() { return /* binding */ removeItems; },
  "Qx": function() { return /* binding */ selectFavoritesState; },
  "x9": function() { return /* binding */ setLoginFavouriteCallback; }
});

// UNUSED EXPORTS: createFavorite, default, setFavorites

// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(77236);
// EXTERNAL MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(28858);
// EXTERNAL MODULE: ./store/index.js + 1 modules
var store = __webpack_require__(45094);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./src/constants/regex.js
var regex = __webpack_require__(71990);
;// CONCATENATED MODULE: ./src/utils/favouritesHelper.js


const addDataLayerFav = function() {
    let msg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isSuccess = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", internalLinkType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", zone = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", videoName = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", videoId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "";
    var ref;
    const sharedZoneName = (ref = zone === null || zone === void 0 ? void 0 : zone.replace(regex/* SPECIAL_CHAR_REGEX */.FU, " ")) !== null && ref !== void 0 ? ref : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const sharedInternalLinkType = internalLinkType ? (0,helper.sanitizeTextForAnalytics)(internalLinkType) : "teaser";
    const cleanSharedInternalLinkType = (0,helper.cleanText)(sharedInternalLinkType);
    const sharedInternalLinkZoneName = sharedZoneName ? (0,helper.sanitizeTextForAnalytics)(sharedZoneName) : "teaser";
    const eventPageType = window.eventPageType;
    const pageType = "".concat(eventPageType, ":").concat(sharedInternalLinkZoneName);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":favorite ").concat(type),
        eventName: "".concat(pageType, ":favorite ").concat(type),
        eventMsg: msg || "n/a",
        eventStatus: isSuccess ? "success" : "failure",
        eventType: "navigation",
        internalLinkName: "favorite ".concat(type),
        internalLinkPosition: eventPageType,
        internalLinkType: "".concat(eventPageType, ":").concat(cleanSharedInternalLinkType),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventPageType, ":").concat(sharedInternalLinkZoneName)
    };
    if (videoName) eventInfo.videoName = videoName;
    if (videoId) eventInfo.videoId = videoId;
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
    delete window.zoneName;
    delete window.internalLinkType;
};

;// CONCATENATED MODULE: ./store/features/favoritesSlice.js







const initialState = {
    favorites: {},
    status: "",
    fullFavoriteData: {},
    isLoginFavouriteCallback: {
        isCallBack: false,
        callBackAssetID: ""
    }
};
const shoppingListName = "Favorites";
const getFavorites = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getFavorites", async ()=>{
    const response = await api/* apim.get */.TH.get("".concat(constants.favoritesEndPoint));
    var ref;
    const { results  } = (ref = response === null || response === void 0 ? void 0 : response.data) !== null && ref !== void 0 ? ref : {
        results: []
    };
    if (results.length > 0) {
        const getVersion = Math.max(...results.map((i)=>i.version));
        const favoritesData = results.filter((item)=>item.version === getVersion);
        const { textLineItems =[]  } = favoritesData[0];
        if (textLineItems.length > 0) (0,helper.checkIsFavorite)(textLineItems);
        if (favoritesData.length) {
            return favoritesData[0];
        }
    }
    await store/* store.dispatch */.h.dispatch(createFavorite());
    return {};
});
const getMyAccountFavorites = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getMyAccountFavorites", async (query)=>{
    const response = await api/* apim.get */.TH.get("".concat(constants.favoritesEndPoint));
    const { results  } = response.data;
    if ((results === null || results === void 0 ? void 0 : results.length) > 0) {
        const getVersion = Math.max(...results.map((i)=>i.version));
        const d = results.filter((i)=>i.version === getVersion)[0];
        if (d) {
            var ref, ref1;
            const { lineItems =[] , textLineItems =[]  } = d;
            const productIds = lineItems.map((item)=>item.productId);
            const persona = (0,helper.getUserPersona)();
            const fl = [
                "masterSKU_s",
                "SKUColorSwatchFilename_ss",
                "SKUColorSwatchFilename_s",
                "ProductDescriptionProductShort_s",
                "ProductBrandName_s",
                "metaTitle_s",
                "productName_s",
                "id",
                "productImages.url_s",
                "productImages.url_ss",
                "slug_s",
                "Product_Category",
                "displayPriceStartingAt_s",
                "Tile_Title",
                "ProductIsExclusive_s",
                "RegionReleaseforShipment_dt",
                "SKU.Details_ss",
                "Color.SKU.Details_ss",
                "Color.SKU.Details_s",
                "productImages.labelWithUrl_ss",
                "productImages.labelWithUrl_s",
                "variantList.sku_ss",
                "variantList.sku_s",
                "RegionBrandName_s",
                "priceList.".concat(persona, ".discountedPrice_d"),
                "priceList.".concat(persona, ".saleOffer_s"),
                "priceList.".concat(persona, ".finalPrice_d"),
                "priceList.".concat(persona, ".price_d"),
                "Color.".concat(persona, ".Details_ss"),
                "ctId_s",
                "Brand_ss",
                "Country_ss"
            ];
            const res = await api/* apim.get */.TH.get("/search/plp", {
                params: {
                    q: "*:*",
                    fq: 'ctId_s:("'.concat(productIds.join('","'), '")'),
                    fl: fl.join(","),
                    collections: "kohler-india",
                    profilename: "profile_kohler-india_General",
                    start: 0,
                    rows: 50
                }
            });
            var ref2;
            const productData = (ref2 = (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.docs) !== null && ref2 !== void 0 ? ref2 : [];
            if (productData.length > 0) {
                productData.forEach((product)=>{
                    const d = lineItems.find((item)=>item.productId === product["ctId_s"]);
                    d.productData = product;
                });
            }
            let sortLineItems = [];
            if (lineItems.length > 0) {
                sortLineItems = lineItems.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            let sortTextLineItems = [];
            if (textLineItems.length > 0) {
                sortTextLineItems = textLineItems.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            return {
                sortProducts: sortLineItems !== null && sortLineItems !== void 0 ? sortLineItems : [],
                sortMedia: sortTextLineItems !== null && sortTextLineItems !== void 0 ? sortTextLineItems : [],
                d
            };
        } else {
            await store/* store.dispatch */.h.dispatch(createFavorite());
        }
    }
    await store/* store.dispatch */.h.dispatch(createFavorite());
    return null;
});
const createFavorite = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("createFavorite", async ()=>{
    const response = await api/* apim.post */.TH.post("".concat(constants.createFavoritesEndPoint), {
        name: {
            "en-IN": shoppingListName
        }
    });
    var _data;
    return (_data = response.data) !== null && _data !== void 0 ? _data : {};
});
const addProduct = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("addProduct", async (sku, thunkAPI)=>{
    const state = thunkAPI.getState();
    let id;
    let version;
    let favorites;
    if ((state === null || state === void 0 ? void 0 : state.favorites.favorites) !== undefined && Object.keys(state === null || state === void 0 ? void 0 : state.favorites.favorites).length > 0) {
        var ref;
        favorites = state === null || state === void 0 ? void 0 : (ref = state.favorites) === null || ref === void 0 ? void 0 : ref.favorites;
        id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
        version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
    } else {
        const favoritesMain = await store/* store.dispatch */.h.dispatch(createFavorite());
        favorites = favoritesMain === null || favoritesMain === void 0 ? void 0 : favoritesMain.payload;
        id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
        version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
    }
    const body = {
        version,
        actions: [
            {
                action: "addLineItem",
                sku,
                custom: {
                    type: {
                        key: "lineItemShoppingList",
                        typeId: "type"
                    }
                }
            }
        ]
    };
    const response = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(id, "product")), body);
    return response.data;
});
const removeItems = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("removeItems", async (ids, thunkAPI)=>{
    try {
        var ref;
        const state = thunkAPI.getState();
        const { id , version , lineItems  } = state === null || state === void 0 ? void 0 : (ref = state.favorites) === null || ref === void 0 ? void 0 : ref.favorites;
        if (id) {
            const actions = ids.map((pid)=>{
                if (lineItems.find((el)=>el.id === pid)) {
                    return {
                        action: "removeLineItem",
                        lineItemId: pid
                    };
                } else {
                    return {
                        action: "removeTextLineItem",
                        textLineItemId: pid
                    };
                }
            });
            const response = await api/* apim.post */.TH.post("".concat((0,constants.removeFavoritesEndPoint)(id)), {
                version,
                actions
            });
            return response.data;
        }
        return {};
    } catch (error) {
        console.error("Failed to remove from favorites", error);
    }
});
const myAccountRemoveItems = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("myAccountRemoveItems", async (ids, thunkAPI)=>{
    var ref, ref1;
    const state = thunkAPI.getState();
    const { id , version , lineItems  } = state === null || state === void 0 ? void 0 : (ref = state.favorites) === null || ref === void 0 ? void 0 : (ref1 = ref.fullFavoriteData) === null || ref1 === void 0 ? void 0 : ref1.d;
    if (id) {
        const actions = ids.map((pid)=>{
            if (lineItems.find((el)=>el.id === pid)) {
                return {
                    action: "removeLineItem",
                    lineItemId: pid
                };
            } else {
                return {
                    action: "removeTextLineItem",
                    textLineItemId: pid
                };
            }
        });
        const response = await api/* apim.post */.TH.post("".concat((0,constants.removeFavoritesEndPoint)(id)), {
            version,
            actions
        });
        if (response === null || response === void 0 ? void 0 : response.data) {
            var ref2, ref3;
            const { lineItems: lineItems1 = [] , textLineItems =[]  } = response === null || response === void 0 ? void 0 : response.data;
            const productIds = lineItems1.map((item)=>item.productId);
            const persona = (0,helper.getUserPersona)();
            const fl = [
                "masterSKU_s",
                "SKUColorSwatchFilename_ss",
                "SKUColorSwatchFilename_s",
                "ProductDescriptionProductShort_s",
                "ProductBrandName_s",
                "metaTitle_s",
                "productName_s",
                "id",
                "productImages.url_s",
                "productImages.url_ss",
                "slug_s",
                "Product_Category",
                "displayPriceStartingAt_s",
                "Tile_Title",
                "ProductIsExclusive_s",
                "RegionReleaseforShipment_dt",
                "SKU.Details_ss",
                "Color.SKU.Details_ss",
                "Color.SKU.Details_s",
                "productImages.labelWithUrl_ss",
                "productImages.labelWithUrl_s",
                "variantList.sku_ss",
                "variantList.sku_s",
                "RegionBrandName_s",
                "priceList.".concat(persona, ".discountedPrice_d"),
                "priceList.".concat(persona, ".saleOffer_s"),
                "priceList.".concat(persona, ".finalPrice_d"),
                "priceList.".concat(persona, ".price_d"),
                "Color.".concat(persona, ".Details_ss"),
                "ctId_s",
                "Brand_ss",
                "Country_ss"
            ];
            const res = await api/* apim.get */.TH.get("/search/plp", {
                params: {
                    q: "*:*",
                    fq: 'ctId_s:("'.concat(productIds.join('","'), '")'),
                    fl: fl.join(","),
                    collections: "kohler-india",
                    profilename: "profile_kohler-india_General",
                    start: 0,
                    rows: 50
                }
            });
            var ref4;
            const productData = (ref4 = (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.response) === null || ref3 === void 0 ? void 0 : ref3.docs) !== null && ref4 !== void 0 ? ref4 : [];
            if (productData.length > 0) {
                productData.forEach((product)=>{
                    const d = lineItems1.find((item)=>item.productId === product["ctId_s"]);
                    d.productData = product;
                });
            }
            let sortLineItems = [];
            if (lineItems1.length > 0) {
                sortLineItems = lineItems1.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            let sortTextLineItems = [];
            if (textLineItems.length > 0) {
                sortTextLineItems = textLineItems.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            var ref5;
            return {
                sortProducts: sortLineItems !== null && sortLineItems !== void 0 ? sortLineItems : [],
                sortMedia: sortTextLineItems !== null && sortTextLineItems !== void 0 ? sortTextLineItems : [],
                d: (ref5 = response === null || response === void 0 ? void 0 : response.data) !== null && ref5 !== void 0 ? ref5 : {}
            };
        }
    }
    return {};
});
const addMedia = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("addMedia", async (params, thunkAPI)=>{
    const { type ="" , name ="" , url ="" , description ="" , articleType ="" , thumbnail ="" , needDataLayerToAdd =true , caption ="" , section ="" , videoName ="" , videoId ="" , errorMessage ="" , successMsg ="" , successCallback =()=>{} , errorCallback =()=>{}  } = params;
    try {
        var ref;
        const state = thunkAPI.getState();
        let id;
        let version;
        let favorites;
        if (state === null || state === void 0 ? void 0 : (ref = state.favorites) === null || ref === void 0 ? void 0 : ref.favorites) {
            var ref1;
            favorites = state === null || state === void 0 ? void 0 : (ref1 = state.favorites) === null || ref1 === void 0 ? void 0 : ref1.favorites;
            id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
            version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
        } else {
            const favoritesMain = await store/* store.dispatch */.h.dispatch(createFavorite());
            favorites = favoritesMain === null || favoritesMain === void 0 ? void 0 : favoritesMain.payload;
            id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
            version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
        }
        const body = {
            version: version,
            actions: [
                {
                    action: "addTextLineItem",
                    name: {
                        "en-IN": name
                    },
                    description: {
                        "en-IN": description
                    },
                    custom: {
                        type: {
                            key: "textLineItemShoppingList",
                            typeId: "type"
                        },
                        fields: {
                            itemType: type,
                            link: url,
                            thumbnail,
                            articleType
                        }
                    }
                }
            ]
        };
        const response = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(id, type)), body);
        const { textLineItems =[]  } = response.data;
        if (textLineItems.length > 0) {
            (0,helper.checkIsFavorite)(textLineItems);
            successCallback();
        }
        if (needDataLayerToAdd) addDataLayerFav(successMsg, true, "add", caption, section, videoName, videoId);
        return response.data;
    } catch (error) {
        if (needDataLayerToAdd) addDataLayerFav(errorMessage, false, "add", caption, section, videoName, videoId);
        errorCallback();
    }
});
const favoritesSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "favorites",
    initialState,
    reducers: {
        setFavorites (state, action) {
            state.favorites = action.payload;
        },
        setLoginFavouriteCallback (state, action) {
            state.isLoginFavouriteCallback = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            es6/* HYDRATE */.ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.favorites
            };
        }).addCase(getFavorites.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getFavorites.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(getFavorites.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getMyAccountFavorites.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getMyAccountFavorites.fulfilled, (state, action)=>{
            state.fullFavoriteData = action.payload;
            state.status = "succeeded";
        }).addCase(getMyAccountFavorites.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(myAccountRemoveItems.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(myAccountRemoveItems.fulfilled, (state, action)=>{
            state.fullFavoriteData = action.payload;
            state.status = "succeeded";
        }).addCase(myAccountRemoveItems.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addProduct.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(addProduct.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(addProduct.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(createFavorite.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(createFavorite.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(createFavorite.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addMedia.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(addMedia.fulfilled, (state, action)=>{
            state.favorites = {
                ...state.favorites,
                ...action.payload
            };
            state.status = "succeeded";
        }).addCase(addMedia.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(removeItems.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(removeItems.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(removeItems.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setFavorites , setLoginFavouriteCallback  } = favoritesSlice.actions;
const selectFavoritesState = (state)=>state.favorites;
/* harmony default export */ var features_favoritesSlice = (favoritesSlice.reducer);


/***/ }),

/***/ 88751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AT": function() { return /* binding */ setAuthNav; },
/* harmony export */   "C1": function() { return /* binding */ getCardType; },
/* harmony export */   "CF": function() { return /* binding */ showToast; },
/* harmony export */   "DE": function() { return /* binding */ setAnalyticsScript; },
/* harmony export */   "Dl": function() { return /* binding */ resetFactor; },
/* harmony export */   "Dz": function() { return /* binding */ getBusinessList; },
/* harmony export */   "FE": function() { return /* binding */ setPageObject; },
/* harmony export */   "FU": function() { return /* binding */ subscribeApi; },
/* harmony export */   "FV": function() { return /* binding */ setSitewideWarningContent; },
/* harmony export */   "GL": function() { return /* binding */ getplaceOfPurchaseList; },
/* harmony export */   "Ix": function() { return /* binding */ uploadImage; },
/* harmony export */   "JN": function() { return /* binding */ genericSlice; },
/* harmony export */   "Ji": function() { return /* binding */ setToastContent; },
/* harmony export */   "Jp": function() { return /* binding */ getCountryList; },
/* harmony export */   "Lf": function() { return /* binding */ showCartExpandedView; },
/* harmony export */   "Ln": function() { return /* binding */ getGenericListPath; },
/* harmony export */   "MA": function() { return /* binding */ unsetDefaultAddress; },
/* harmony export */   "N1": function() { return /* binding */ getplanTimingList; },
/* harmony export */   "Np": function() { return /* binding */ getDealerDetails; },
/* harmony export */   "PE": function() { return /* binding */ hideToast; },
/* harmony export */   "Px": function() { return /* binding */ selectGenericState; },
/* harmony export */   "QO": function() { return /* binding */ checkIsUserExist; },
/* harmony export */   "RS": function() { return /* binding */ showFindingModelPopup; },
/* harmony export */   "Ro": function() { return /* binding */ removeAddress; },
/* harmony export */   "T": function() { return /* binding */ closeCompareProductView; },
/* harmony export */   "T8": function() { return /* binding */ getAuthMenuFragment; },
/* harmony export */   "UD": function() { return /* binding */ mapStateToCountry; },
/* harmony export */   "Wj": function() { return /* binding */ closeMenu; },
/* harmony export */   "Wv": function() { return /* binding */ showPromoModal; },
/* harmony export */   "X7": function() { return /* binding */ setActiveMainCategory; },
/* harmony export */   "XY": function() { return /* binding */ setBrandLogoImg; },
/* harmony export */   "Yb": function() { return /* binding */ editAddress; },
/* harmony export */   "Ys": function() { return /* binding */ setPageIsIntercative; },
/* harmony export */   "_4": function() { return /* binding */ setShowHalfCompare; },
/* harmony export */   "_K": function() { return /* binding */ setDefaultAddress; },
/* harmony export */   "_W": function() { return /* binding */ hideFindingModelPopup; },
/* harmony export */   "_r": function() { return /* binding */ setSitewideNewsLetterContent; },
/* harmony export */   "a5": function() { return /* binding */ getStoreCountriesList; },
/* harmony export */   "bM": function() { return /* binding */ checkSubscription; },
/* harmony export */   "bh": function() { return /* binding */ getplanTypeList; },
/* harmony export */   "cw": function() { return /* binding */ setGlobalStyles; },
/* harmony export */   "d2": function() { return /* binding */ sendTrigger; },
/* harmony export */   "dN": function() { return /* binding */ setDatalayerPageName; },
/* harmony export */   "d_": function() { return /* binding */ enrollFactor; },
/* harmony export */   "et": function() { return /* binding */ getUserProfile; },
/* harmony export */   "go": function() { return /* binding */ getLegalPageLinks; },
/* harmony export */   "jy": function() { return /* binding */ toggleSiteWideWarning; },
/* harmony export */   "ks": function() { return /* binding */ setGbhDataLayerCustom; },
/* harmony export */   "kv": function() { return /* binding */ updateNumber; },
/* harmony export */   "lK": function() { return /* binding */ getstateList; },
/* harmony export */   "m8": function() { return /* binding */ getCommonList; },
/* harmony export */   "ml": function() { return /* binding */ setSubscribeModalContent; },
/* harmony export */   "n8": function() { return /* binding */ setGlobalScripts; },
/* harmony export */   "oS": function() { return /* binding */ hideCartExpandedView; },
/* harmony export */   "p1": function() { return /* binding */ setShowFullCompare; },
/* harmony export */   "ph": function() { return /* binding */ getReasonList; },
/* harmony export */   "qX": function() { return /* binding */ setRegionNav; },
/* harmony export */   "qn": function() { return /* binding */ openMenu; },
/* harmony export */   "rA": function() { return /* binding */ setCompareproductsStaticText; },
/* harmony export */   "s2": function() { return /* binding */ editProfile; },
/* harmony export */   "sZ": function() { return /* binding */ setDataLayerObj; },
/* harmony export */   "t8": function() { return /* binding */ zipDownload; },
/* harmony export */   "tH": function() { return /* binding */ checkDuplicacy; },
/* harmony export */   "tK": function() { return /* binding */ searchPlp; },
/* harmony export */   "tm": function() { return /* binding */ deleteAccount; },
/* harmony export */   "x": function() { return /* binding */ hidePreviewCart; },
/* harmony export */   "y$": function() { return /* binding */ addAddress; },
/* harmony export */   "z0": function() { return /* binding */ showPreviewCart; }
/* harmony export */ });
/* unused harmony exports getTrackingList, getAccountBusinessList, getProfile, resetPassword, setSitewideWarningRendered, setAnalyticsScripts, setCompareExpiry, clearAllCompareProducts, setConsolidatedZipCodes, setUpsellInstallationServiceData, showAppointmentModal, hideAppointmentModal */
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28858);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19514);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77236);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55111);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34326);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46201);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45094);










const initialState = {
    datalayerPageName: "",
    eventPageType: "",
    accountTypeListPath: "",
    businessListPath: "",
    countryListPath: "",
    commonListPath: "",
    trackingListPath: "",
    stateListPath: "",
    cardTypesPath: "",
    dealerDetailsPath: "",
    storeCountryListPath: "",
    placeOfPurchaseListPath: "",
    accountTypeList: [],
    businessList: [],
    legalPageLinks: {},
    countryList: [],
    stateList: [],
    stateToCountryList: [],
    placeOfPurchaseList: [],
    cardType: "",
    dealerDetails: [],
    userMenuFragment: "",
    guestMenuFragment: "",
    status: "",
    error: "",
    subscribeModal: {
        show: false,
        modalContent: {},
        active: 0
    },
    siteWideWarning: {
        isRendered: false
    },
    newslettersignup: {},
    compareproducts: {},
    profile: "",
    brandLogoImg: "",
    globalScripts: [],
    dataLayerObj: "",
    analyticsScript: "",
    globalStyles: [],
    toaster: {
        message: "",
        isVisible: false,
        content: {}
    },
    showCartExpandedView: false,
    menu: {
        isOpen: false,
        mainCategoryActive: "",
        isRegionOpen: false,
        isAuthNavOpen: false
    },
    pageIsInteractive: false,
    previewCart: {
        showPreview: false
    },
    promoBannerModal: {
        show: false,
        modalContent: {
            banner: {},
            item: {},
            count: 0
        }
    },
    enableSiteWideWarning: false,
    FindingModelModal: {
        show: false,
        modalContent: {}
    },
    associateMembershipModal: {
        show: false,
        isRetired: false,
        modalContent: {}
    },
    showHalfCompare: false,
    showFullCompare: false,
    isProductInfo: false,
    consolidatedZipCodes: [],
    upsellInstallationServiceAuthData: {},
    isShowAppointmentModal: false,
    bpNumber: null,
    reasonListPath: "",
    reasonList: [],
    planTimingList: [],
    planTimingListPath: "",
    planTypeList: [],
    planTypeListPath: ""
};
const getGenericListPath = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getGenericListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    const state = thunkAPI.getState();
    var ref13;
    const accountTypeListPath = (ref13 = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.accountTypeListPath) !== null && ref13 !== void 0 ? ref13 : "";
    var ref14;
    const businessListPath = (ref14 = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.businessListPath) !== null && ref14 !== void 0 ? ref14 : "";
    var ref15;
    const countryListPath = (ref15 = state === null || state === void 0 ? void 0 : (ref2 = state.generic) === null || ref2 === void 0 ? void 0 : ref2.countryListPath) !== null && ref15 !== void 0 ? ref15 : "";
    var ref16;
    const commonListPath = (ref16 = state === null || state === void 0 ? void 0 : (ref3 = state.generic) === null || ref3 === void 0 ? void 0 : ref3.commonListPath) !== null && ref16 !== void 0 ? ref16 : "";
    var ref17;
    const trackingListPath = (ref17 = state === null || state === void 0 ? void 0 : (ref4 = state.generic) === null || ref4 === void 0 ? void 0 : ref4.trackingListPath) !== null && ref17 !== void 0 ? ref17 : "";
    var ref18;
    const stateListPath = (ref18 = state === null || state === void 0 ? void 0 : (ref5 = state.generic) === null || ref5 === void 0 ? void 0 : ref5.stateListPath) !== null && ref18 !== void 0 ? ref18 : "";
    var ref19;
    const cardTypesPath = (ref19 = state === null || state === void 0 ? void 0 : (ref6 = state.generic) === null || ref6 === void 0 ? void 0 : ref6.cardTypesPath) !== null && ref19 !== void 0 ? ref19 : "";
    var ref20;
    const dealerDetailsPath = (ref20 = state === null || state === void 0 ? void 0 : (ref7 = state.generic) === null || ref7 === void 0 ? void 0 : ref7.dealerDetailsPath) !== null && ref20 !== void 0 ? ref20 : "";
    var ref21;
    const planTimingListPath = (ref21 = state === null || state === void 0 ? void 0 : (ref8 = state.generic) === null || ref8 === void 0 ? void 0 : ref8.planTimingListPath) !== null && ref21 !== void 0 ? ref21 : "";
    var ref22;
    const planTypeListPath = (ref22 = state === null || state === void 0 ? void 0 : (ref9 = state.general) === null || ref9 === void 0 ? void 0 : ref9.planTypeListPath) !== null && ref22 !== void 0 ? ref22 : "";
    var ref23;
    const placeOfPurchaseListPath = (ref23 = state === null || state === void 0 ? void 0 : (ref10 = state.generic) === null || ref10 === void 0 ? void 0 : ref10.placeOfPurchaseListPath) !== null && ref23 !== void 0 ? ref23 : "";
    var ref24;
    const storeCountryListPath = (ref24 = state === null || state === void 0 ? void 0 : (ref11 = state.generic) === null || ref11 === void 0 ? void 0 : ref11.placeOfPurchaseListPath) !== null && ref24 !== void 0 ? ref24 : "";
    var ref25;
    const reasonListPath = (ref25 = state === null || state === void 0 ? void 0 : (ref12 = state.generic) === null || ref12 === void 0 ? void 0 : ref12.reasonListPath) !== null && ref25 !== void 0 ? ref25 : "";
    let data = {};
    if (accountTypeListPath || businessListPath || countryListPath || commonListPath || trackingListPath || stateListPath || cardTypesPath || placeOfPurchaseListPath || reasonListPath || dealerDetailsPath || planTimingListPath || planTypeListPath || storeCountryListPath && !reload) {
        data = {
            accountTypeList: accountTypeListPath,
            businessList: businessListPath,
            countryList: countryListPath,
            commonList: commonListPath,
            trackingList: trackingListPath,
            stateList: stateListPath,
            cardTypes: cardTypesPath,
            placeOfPurchaseList: placeOfPurchaseListPath,
            storeCountryListPath: storeCountryListPath,
            reasonList: reasonListPath,
            dealerDetails: dealerDetailsPath,
            planTimingList: planTimingListPath,
            planTypeList: planTypeListPath
        };
        return data;
    }
    const { general  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .i)();
    if (general === null || general === void 0 ? void 0 : general.genericListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + (general === null || general === void 0 ? void 0 : general.genericListPath));
        return response.data;
    }
    return data;
});
const getCardType = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/cardTypesPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const cardTypesPath = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.cardTypesPath;
    if (cardTypesPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + cardTypesPath);
        return response.data;
    }
    return {};
});
const getDealerDetails = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/dealerDetailsPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const dealerDetailsPath = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.dealerDetailsPath;
    if (dealerDetailsPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + dealerDetailsPath);
        return response.data;
    }
    return [];
});
const getTrackingList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/trackingListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const trackingListPath = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.trackingListPath;
    if (trackingListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + trackingListPath);
        return response.data;
    }
    return {};
});
const getBusinessList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getBusinessList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const businessList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.businessList;
    if ((businessList === null || businessList === void 0 ? void 0 : businessList.length) > 0 && !reload) return businessList;
    const businessListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.businessListPath;
    if (businessListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + businessListPath);
        return response.data;
    }
    return [];
});
const getAccountBusinessList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getAccountBusinessList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const accountTypeList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.accountTypeList;
    if ((accountTypeList === null || accountTypeList === void 0 ? void 0 : accountTypeList.length) > 0 && !reload) return accountTypeList;
    const accountTypeListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.accountTypeListPath;
    if (accountTypeListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + accountTypeListPath);
        return response.data;
    }
    return [];
});
const getLegalPageLinks = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getLegalPageLinks", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const legalPageLinks = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.legalPageLinks;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(legalPageLinks) > 0 && !reload) return legalPageLinks;
    const { general  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .i)();
    if (general === null || general === void 0 ? void 0 : general.legalPageListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(general === null || general === void 0 ? void 0 : general.legalPageListPath);
        return response.data;
    }
    return {};
});
const getAuthMenuFragment = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getAuthMenuFragment", async function() {
    let { reload =false , path , fragmentName  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    const state = thunkAPI.getState();
    var _fragmentName;
    const fragment = (_fragmentName = state === null || state === void 0 ? void 0 : state.generic[fragmentName]) !== null && _fragmentName !== void 0 ? _fragmentName : "";
    const payload = {};
    if (fragment && !reload) {
        payload[fragmentName] = fragment;
        return payload;
    }
    if (path) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + path);
        payload[fragmentName] = response.data.commonTopics ? await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getShortenedUrl)(response.data.commonTopics) : "";
        return payload;
    }
    return {};
});
const getProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("getprofile", async ()=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GET_PROFILE_ENDPOINT));
    return response.data;
});
const getCountryList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/countryListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const countryList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.countryList;
    if ((countryList === null || countryList === void 0 ? void 0 : countryList.length) > 0 && !reload) return countryList;
    const countryListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.countryListPath;
    if (countryListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + countryListPath);
        return response.data;
    }
    return {};
});
const getstateList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/stateListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const stateList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.stateList;
    if ((stateList === null || stateList === void 0 ? void 0 : stateList.length) > 0 && !reload) return stateList;
    const stateListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.stateListPath;
    if (stateListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + stateListPath);
        return response.data;
    }
    return {};
});
const getStoreCountriesList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/storeCountryListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const storeCountryList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.storeCountryList;
    if ((storeCountryList === null || storeCountryList === void 0 ? void 0 : storeCountryList.length) > 0 && !reload) return storeCountryList;
    const storeCountryListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.storeCountryListPath;
    if (storeCountryListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + storeCountryListPath);
        return response.data;
    }
    return {};
});
const getplaceOfPurchaseList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/placeOfPurchaseList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const placeOfPurchaseList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.placeOfPurchaseList;
    if ((placeOfPurchaseList === null || placeOfPurchaseList === void 0 ? void 0 : placeOfPurchaseList.length) > 0 && !reload) return placeOfPurchaseList;
    const placeOfPurchaseListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.placeOfPurchaseListPath;
    if (placeOfPurchaseListPath) {
        var ref2;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + placeOfPurchaseListPath);
        return (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.map((purchase)=>purchase.value);
    }
    return {};
});
const getplanTimingList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/planTimingList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const planTimingList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.planTimingList;
    if ((planTimingList === null || planTimingList === void 0 ? void 0 : planTimingList.length) > 0 && !reload) return planTimingList;
    const planTimingListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.planTimingListPath;
    if (planTimingListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + planTimingListPath);
        return response.data;
    }
    return [];
});
const getplanTypeList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/planTypeList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const planTypeList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.planTypeList;
    if ((planTypeList === null || planTypeList === void 0 ? void 0 : planTypeList.length) > 0 && !reload) return planTypeList;
    const planTypeListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.planTypeListPath;
    if (planTypeListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + planTypeListPath);
        return response.data;
    }
    return [];
});
const zipDownload = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("zipDownload", async (payload)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_4__.ZIP_FILE_DOWNLOAD_ENDPOINT, payload, {
        responseType: "blob"
    });
    return response;
});
const searchPlp = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("search-plp", async (data)=>{
    try {
        var ref, ref1, ref2;
        const actions = data.actions;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.SEARCH_PLP_ENDPOINT, {
            params: {
                q: "*:*",
                fl: "CustomerFacingBrand_s, RegionOnBackOrder_s",
                fq: "sku_s:(".concat((ref = actions[0]) === null || ref === void 0 ? void 0 : ref.sku, ")"),
                collections: "service_parts",
                profilename: "profile_service_parts_Search"
            }
        });
        if (response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.response) === null || ref2 === void 0 ? void 0 : ref2.docs[0]) {
            const newActions = [];
            const newData = {};
            actions.forEach((action)=>{
                action["backorder"] = response.data.response.docs[0]["RegionOnBackOrder_s"] === "Yes";
                action["brand"] = response.data.response.docs[0]["CustomerFacingBrand_s"];
                newActions.push(action);
            });
            newData["actions"] = newActions;
            return _store__WEBPACK_IMPORTED_MODULE_7__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .addToCart */ .Xq)(newData));
        }
    } catch (e) {
        return _store__WEBPACK_IMPORTED_MODULE_7__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .addToCart */ .Xq)(data));
    }
});
const getUserProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("getuserprofile", async ()=>{
    let profile = {};
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GET_PROFILE_ENDPOINT));
        if (res && res.data) {
            var ref, ref1, ref2;
            localStorage.setItem("profile-version", res.data.version);
            profile = res.data;
            profile.postalCode = (ref = profile.addresses[0]) === null || ref === void 0 ? void 0 : ref.postalCode;
            var ref3;
            const profileAddr = (ref3 = (ref1 = profile.addresses) === null || ref1 === void 0 ? void 0 : ref1.find((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) === "Profile";
            })) !== null && ref3 !== void 0 ? ref3 : {};
            profile.profileAddrId = profileAddr.id;
            profile.addresses = (ref2 = profile.addresses) === null || ref2 === void 0 ? void 0 : ref2.filter((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
            });
            let addresses = profile.addresses;
            if (profile.defaultShippingAddressId) {
                const index = addresses.findIndex((item)=>item.id === profile.defaultShippingAddressId);
                addresses = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.arrayMove)(profile.addresses, index, 0);
            }
            profile.addresses = addresses;
        }
    } catch (err) {
        console.log("Failed to get user profile", err);
    }
    return profile;
});
const editProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("editProfile", async (data, thunkAPI)=>{
    let profile = [];
    let actions = [];
    const oktaTokenStorage = JSON.parse(localStorage.getItem("okta-token-storage"));
    const userType = oktaTokenStorage.accessToken.claims.persona[0].split(":")[1];
    if (userType === "TVS") {
        actions = [
            {
                action: "setFirstName",
                firstName: data.firstName
            },
            {
                action: "setLastName",
                lastName: data.lastName
            },
            {
                action: "setCompanyName",
                companyName: data.businessName
            },
            {
                action: "setCustomField",
                name: "businessType",
                value: data.businessType
            },
            {
                action: "setCustomField",
                name: "businessSubType",
                value: data.businessSubType
            },
            {
                action: "changeAddress",
                addressId: data.addressId,
                address: {
                    postalCode: data.businessZipCode,
                    country: "US",
                    custom: {
                        type: {
                            key: "custom-address"
                        },
                        fields: {
                            label: "Profile"
                        }
                    }
                }
            }
        ];
    } else {
        actions = [
            {
                action: "setFirstName",
                firstName: data.firstName
            },
            {
                action: "setLastName",
                lastName: data.lastName
            }
        ];
    }
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.EDIT_PROFILE_ENDPOINT), {
            version: version,
            actions: actions
        });
        if (res) {
            profile = await thunkAPI.dispatch(getUserProfile());
            localStorage.setItem(_constants_index__WEBPACK_IMPORTED_MODULE_4__["default"] === null || _constants_index__WEBPACK_IMPORTED_MODULE_4__["default"] === void 0 ? void 0 : _constants_index__WEBPACK_IMPORTED_MODULE_4__["default"].KF_FORCE_RENEW_TOKEN, true);
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("Failed to edit profile", err);
    }
    const { payload: response  } = profile;
    return response;
});
const checkSubscription = async (user)=>{
    let response = {};
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("clevertap/communication/preference?email=".concat(user === null || user === void 0 ? void 0 : user.sub));
        response = res.data;
    } catch (e) {
        console.log(e, "error");
    }
    return response;
};
const subscribeApi = async (user, isSubscribed)=>{
    let res = {};
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("clevertap/communication/preference", {
            email: user === null || user === void 0 ? void 0 : user.sub,
            userId: user === null || user === void 0 ? void 0 : user.uid,
            isSubscribed: isSubscribed
        });
        res = response === null || response === void 0 ? void 0 : response.data;
    } catch (e) {
        console.log(e, "error");
    }
    return res;
};
const addAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("addAddress", async (data)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const payload = Array.isArray(data) ? {
            version: version,
            actions: data
        } : {
            version: version,
            actions: [
                {
                    action: "addAddress",
                    address: data
                }
            ]
        };
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), payload);
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2, ref3;
            localStorage.setItem("profile-version", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.version);
            if ((res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.addresses) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
                var ref4, ref5, ref6;
                var ref7;
                resPayload.addresses = (ref7 = res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.addresses) === null || ref5 === void 0 ? void 0 : ref5.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref7 !== void 0 ? ref7 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref6 = res.data) === null || ref6 === void 0 ? void 0 : ref6.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to add address", err);
        const { response: { data: { error =""  }  } = {}  } = err;
        return {
            error
        };
    }
    return resPayload;
});
const editAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("editAddress", async (payload)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), {
            version: version,
            actions: [
                {
                    action: "changeAddress",
                    addressId: payload === null || payload === void 0 ? void 0 : payload.id,
                    address: payload === null || payload === void 0 ? void 0 : payload.addr
                }
            ]
        });
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2;
            localStorage.setItem("profile-version", res.data.version);
            if ((res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.addresses) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
                var ref3, ref4, ref5;
                var ref6;
                resPayload.addresses = (ref6 = res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.addresses) === null || ref4 === void 0 ? void 0 : ref4.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref6 !== void 0 ? ref6 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : ref5.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to edit address", err);
    }
    return resPayload;
});
const setDefaultAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("setDefaultAddress", async (addressId)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), {
            version: version,
            actions: [
                {
                    action: "setDefaultShippingAddress",
                    addressId: addressId
                }
            ]
        });
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2, ref3;
            localStorage.setItem("profile-version", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.version);
            if ((res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.addresses) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
                var ref4, ref5, ref6;
                var ref7;
                resPayload.addresses = (ref7 = res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.addresses) === null || ref5 === void 0 ? void 0 : ref5.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref7 !== void 0 ? ref7 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref6 = res.data) === null || ref6 === void 0 ? void 0 : ref6.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to set default", err);
    }
    return resPayload;
});
const removeAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("removeAddress", async (addressId)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), {
            version: version,
            actions: [
                {
                    action: "removeAddress",
                    addressId: addressId
                }
            ]
        });
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2;
            console.log(res, "res");
            console.log("enter remove address");
            localStorage.setItem("profile-version", (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.version);
            if (((ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.addresses.length) > 0) {
                var ref3, ref4, ref5;
                var ref6;
                resPayload.addresses = (ref6 = (ref3 = res.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.addresses) === null || ref4 === void 0 ? void 0 : ref4.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref6 !== void 0 ? ref6 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : ref5.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to remove address", err);
    }
    return resPayload;
});
const deleteAccount = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("deleteAccount", async ()=>{
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim["delete"] */ .TH["delete"]("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.DELETE_ACCOUNT_ENDPOINT));
        if (res && res.data) return true;
    } catch (err) {
        console.log("Failed to delete account", err);
    }
});
const resetPassword = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("resetPassword", async (data)=>{
    try {
        return await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.CHANGE_ACCOUNT_PASSWORD_ENDPOINT), data);
    } catch (err) {
        console.log("Failed to reset password", err);
        return err.response;
    }
});
const uploadImage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("", async (file)=>{
    var ref, ref1, ref2, ref3;
    const fileName = (ref2 = file === null || file === void 0 ? void 0 : (ref = file.uplaodData) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === null || ref2 === void 0 ? void 0 : ref2.replace(/ /g, "-");
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.put */ .TH.put("/crm/asset/upload?fileName=".concat(fileName).concat((file === null || file === void 0 ? void 0 : file.isReturn) ? "&formAsset=formupload&brand=KIN" : ""), file === null || file === void 0 ? void 0 : file.uplaodData, {
        headers: {
            "Content-Type": file === null || file === void 0 ? void 0 : (ref3 = file.uplaodData) === null || ref3 === void 0 ? void 0 : ref3.type
        }
    });
    if (res && res.data) return res.data;
});
const getCommonList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getCommonList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const commonList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.commonList;
    if ((commonList === null || commonList === void 0 ? void 0 : commonList.length) > 0 && !reload) return commonList;
    const commonListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.commonListPath;
    if (commonListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + commonListPath);
        return response.data;
    }
    return [];
});
const getReasonList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/reasonListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const reasonListPath = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.reasonListPath;
    if (reasonListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + reasonListPath);
        return response.data;
    }
    return [];
});
const closeCompareProductView = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    _store__WEBPACK_IMPORTED_MODULE_7__/* .store.dispatch */ .h.dispatch(setShowHalfCompare(false));
    _store__WEBPACK_IMPORTED_MODULE_7__/* .store.dispatch */ .h.dispatch(setShowFullCompare(true));
    const query = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getPdpUrlParams)();
    if ((window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) === _constants_index__WEBPACK_IMPORTED_MODULE_4__.INSTALLATION_SERVICES_PATH) {
        const newUrl = window.location.hash ? "".concat(window.location.pathname).concat(window.location.hash) : window.location.pathname;
        window.history.replaceState({
            previousUrl: url
        }, document.title, newUrl);
    } else if (query) {
        window.history.replaceState(window.location.pathname, document.title, query);
    } else {
        window.history.replaceState({}, document.title, window.location.pathname);
    }
    document.body.classList.remove("compare-open", "scroll-lock", "modal-open");
};
const checkDuplicacy = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("customers/users", async (mobileNumber)=>{
    try {
        const payload = {
            login: mobileNumber
        };
        const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.checkDuplicacyUrl), payload);
        return content;
    } catch (error) {
        var ref;
        return error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.data;
    }
});
const checkIsUserExist = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("customers/users", async (mobileNumber)=>{
    try {
        const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.checkDuplicacyUrlForUpdateNumber, "/").concat(mobileNumber));
        return content;
    } catch (error) {
        var ref;
        return error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.data;
    }
});
const resetFactor = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("customer/reset/factor", async (userid)=>{
    const payload = {
        userId: userid
    };
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.resetFactorUrl), payload);
    return response;
});
const enrollFactor = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("customer/reset/factor", async (param)=>{
    let { userid , data  } = param;
    const payload = {
        userId: userid,
        data
    };
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.enrollFactorUrl), payload);
        return response;
    } catch (error) {
        return error;
    }
});
const updateNumber = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("update/number", async (param)=>{
    let { actions  } = param;
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    const payload = {
        version,
        actions
    };
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.updateNumberUrl), payload);
    return response;
});
const sendTrigger = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("send/trigger", async (param)=>{
    let { firstName , lastName , emailId , phoneNumber  } = param;
    const payload = {
        firstName,
        lastName,
        emailId,
        phoneNumber,
        geolocation: "India"
    };
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.sendTriggerURL, "?evtName=logged-in");
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post(url, payload);
        return res;
    } catch (error) {
        return error;
    }
});
const unsetDefaultAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("customer/default/address", async (payload)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    const body = {
        version: payload.profileVersion,
        actions: [
            {
                action: "removeShippingAddressId",
                addressId: payload.id
            }
        ]
    };
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.editAddressEndPoint), body);
    if (res && res.data) {
        resPayload.version = res.data.version;
        if (res.data.addresses.length > 0) {
            var ref;
            var ref1;
            resPayload.addresses = (ref1 = (ref = res.data.addresses) === null || ref === void 0 ? void 0 : ref.filter((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
            })) !== null && ref1 !== void 0 ? ref1 : [];
            resPayload.defaultShippingAddressId = res.data.defaultShippingAddressId;
        }
    }
    return resPayload;
});
const genericSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSlice */ .oM)({
    name: "generic",
    initialState,
    reducers: {
        setSubscribeModalContent (state, action) {
            state.subscribeModal = {
                ...state.subscribeModal,
                modalContent: action.payload
            };
        },
        setCompareproductsStaticText (state, action) {
            state.compareproducts = {
                ...state.compareproducts,
                content: action.payload
            };
        },
        setSitewideWarningContent (state, action) {
            state.siteWideWarning = {
                ...state.subscribeModal,
                content: action.payload
            };
        },
        setSitewideNewsLetterContent (state, action) {
            state.newslettersignup = {
                ...state.newslettersignup,
                content: action.payload
            };
        },
        setSitewideWarningRendered (state, action) {
            state.siteWideWarning = {
                ...state.subscribeModal,
                isRendered: action.payload
            };
        },
        setBrandLogoImg (state, action) {
            state.brandLogoImg = action.payload;
        },
        setGlobalScripts (state, action) {
            state.globalScripts = state.globalScripts.concat(action.payload);
        },
        setDataLayerObj (state, action) {
            state.dataLayerObj = action.payload;
        },
        setGlobalStyles (state, action) {
            state.globalStyles = state.globalStyles.concat(action.payload);
        },
        setAnalyticsScript (state, action) {
            state.analyticsScript = action.payload;
        },
        showCartExpandedView (state, action) {
            state.showCartExpandedView = true;
        },
        hideCartExpandedView (state, action) {
            state.showCartExpandedView = false;
        },
        showToast (state, action) {
            state.toaster = {
                ...state.toaster,
                ...action.payload
            };
        },
        hideToast (state, action) {
            state.toaster = {
                ...state.toaster,
                message: "",
                isVisible: false
            };
        },
        setToastContent (state, action) {
            state.toaster = {
                ...state.toaster,
                content: action.payload
            };
        },
        openMenu (state, action) {
            state.menu = {
                ...state.menu,
                isOpen: true
            };
        },
        closeMenu (state, action) {
            state.menu = {
                ...state.menu,
                isOpen: false
            };
        },
        setActiveMainCategory (state, action) {
            state.menu = {
                ...state.menu,
                mainCategoryActive: action.payload.item
            };
        },
        setRegionNav (state, action) {
            state.menu = {
                ...state.menu,
                isRegionOpen: action.payload
            };
        },
        setAuthNav (state, action) {
            state.menu = {
                ...state.menu,
                isAuthNavOpen: action.payload
            };
        },
        setPageIsIntercative (state, action) {
            state.pageIsInteractive = action.payload;
        },
        setPageIsIntercative (state, action) {
            state.pageIsInteractive = action.payload;
        },
        showPreviewCart (state, action) {
            window.previewCartKeySource = false;
            state.previewCart = {
                ...state.previewCart,
                showPreview: true
            };
        },
        hidePreviewCart (state, action) {
            window.previewCartKeySource = true;
            state.previewCart = {
                ...state.previewCart,
                showPreview: false
            };
        },
        setDatalayerPageName (state, action) {
            let trimmed = action.payload;
            // will remove .model.json from the incoming string
            trimmed = trimmed ? trimmed.replace(".model.json", "") : trimmed;
            state.datalayerPageName = trimmed;
        },
        setGbhDataLayerCustom (state, action) {
            const { datalayerPageName , eventPageType , pageType  } = action.payload;
            if (datalayerPageName) {
                state.datalayerPageName = datalayerPageName;
            } else {
                state.datalayerPageName = "";
            }
            if (eventPageType) {
                state.eventPageType = window.eventPageType = eventPageType;
            } else {
                state.eventPageType = "";
            }
            if (pageType) {
                state.pageType = window.pageType = pageType;
            } else {
                state.pageType = "";
            }
        },
        showPromoModal (state, action) {
            state.promoBannerModal = {
                ...action.payload
            };
        },
        mapStateToCountry: (state, action)=>{
            const { countryList , stateList  } = action.payload;
            const stateToCountryList = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.mapStateToCountryHandler)(countryList, stateList);
            state.stateToCountryList = stateToCountryList;
        },
        toggleSiteWideWarning: (state, action)=>{
            state.enableSiteWideWarning = !state.enableSiteWideWarning;
        },
        showFindingModelPopup (state, action) {
            state.FindingModelModal = {
                show: true,
                modalContent: {}
            };
        },
        hideFindingModelPopup (state, action) {
            state.FindingModelModal = {
                show: false,
                modalContent: {}
            };
        },
        setShowHalfCompare (state, action) {
            state.showHalfCompare = action.payload;
        },
        setShowFullCompare (state, action) {
            state.showFullCompare = action.payload;
        },
        setPageObject (state, action) {
            state.isProductInfo = action.payload;
        },
        setConsolidatedZipCodes (state, action) {
            state.consolidatedZipCodes = action.payload;
        },
        setUpsellInstallationServiceData (state, action) {
            state.upsellInstallationServiceAuthData = action.payload;
        },
        showAppointmentModal: (state, action)=>{
            state.isShowAppointmentModal = true;
            state.bpNumber = action.payload;
        },
        hideAppointmentModal: (state)=>{
            state.isShowAppointmentModal = false;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.generic
            };
        }).addCase(getGenericListPath.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getGenericListPath.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const data = action.payload;
            for (const key of Object.keys(data)){
                state[key + "Path"] = data[key];
            }
        }).addCase(getGenericListPath.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getBusinessList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getBusinessList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.businessList = action.payload;
        }).addCase(getBusinessList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getAccountBusinessList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getAccountBusinessList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.accountTypeList = action.payload;
        }).addCase(getAccountBusinessList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getLegalPageLinks.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getLegalPageLinks.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.legalPageLinks = action.payload;
        }).addCase(getLegalPageLinks.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getAuthMenuFragment.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getAuthMenuFragment.fulfilled, (state, action)=>{
            state.status = "succeeded";
            for(const key in action.payload){
                if (({}).hasOwnProperty.call(action.payload, key)) {
                    state[key] = action.payload[key];
                }
            }
        }).addCase(getAuthMenuFragment.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getCountryList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getCountryList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.countryList = action.payload;
        }).addCase(getCountryList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getstateList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getstateList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.stateList = action.payload;
        }).addCase(getStoreCountriesList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getStoreCountriesList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getStoreCountriesList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.stateList = action.payload;
        }).addCase(getstateList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getplaceOfPurchaseList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getplaceOfPurchaseList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.placeOfPurchaseList = action.payload;
        }).addCase(getplaceOfPurchaseList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getCardType.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getCardType.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.cardType = action.payload;
        }).addCase(getCardType.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getDealerDetails.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getDealerDetails.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.dealerDetails = action.payload;
        }).addCase(getDealerDetails.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getReasonList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getReasonList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.reasonList = action.payload;
        }).addCase(getReasonList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getplanTimingList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getplanTimingList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.planTimingList = action.payload;
        }).addCase(getplanTimingList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getplanTypeList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getplanTypeList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.planTypeList = action.payload;
        }).addCase(getplanTypeList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setCompareproductsStaticText , setSubscribeModalContent , setSitewideWarningContent , setSitewideWarningRendered , setBrandLogoImg , setGlobalScripts , setGlobalStyles , setDataLayerObj , setAnalyticsScripts , setCompareExpiry , showToast , clearAllCompareProducts , showPreviewCart , hidePreviewCart , showCartExpandedView , hideCartExpandedView , hideToast , openMenu , closeMenu , setActiveMainCategory , setRegionNav , setAuthNav , setAnalyticsScript , setPageIsIntercative , setDatalayerPageName , setGbhDataLayerCustom , setSitewideNewsLetterContent , setToastContent , showPromoModal , mapStateToCountry , toggleSiteWideWarning , showFindingModelPopup , hideFindingModelPopup , setShowHalfCompare , setShowFullCompare , setPageObject , setConsolidatedZipCodes , setUpsellInstallationServiceData , showAppointmentModal , hideAppointmentModal  } = genericSlice.actions;
const selectGenericState = (state)=>state.generic;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (genericSlice.reducer);


/***/ }),

/***/ 9862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ applyAction; },
/* harmony export */   "k": function() { return /* binding */ memberSlice; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77236);

const initialState = {
    applyClicked: false
};
const memberSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "member",
    initialState,
    reducers: {
        applyAction (state, action) {
            state.applyClicked = true;
        }
    }
});
const { applyAction  } = memberSlice.actions;


/***/ }),

/***/ 76977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jv": function() { return /* binding */ findOrderByEmail; },
/* harmony export */   "_w": function() { return /* binding */ ordersState; },
/* harmony export */   "co": function() { return /* binding */ getOrder; },
/* harmony export */   "rx": function() { return /* binding */ getPastOrders; },
/* harmony export */   "se": function() { return /* binding */ findOrderByOrderID; },
/* harmony export */   "x0": function() { return /* binding */ getOpenOrders; },
/* harmony export */   "zM": function() { return /* binding */ orderSlice; }
/* harmony export */ });
/* unused harmony export getSplitOrder */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77236);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29843);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11310);





const initialState = {
    loading: true,
    error: "",
    orders: []
};
const getOrder = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("getOrder", async (orderId)=>{
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get((0,_constants__WEBPACK_IMPORTED_MODULE_1__.GET_ORDER_ENDPOINT)(orderId));
        return res.data;
    } catch (err) {
        console.error("Failed to fetch order detail for orderId: ".concat(orderId), err);
        return err;
    }
});
const getOpenOrders = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("orders/list/open", async function() {
    let offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let data = {};
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.GET_ORDER_DETAILS_ENDPOINT, "?offset=").concat(offset, "&state=open"));
        if (res && res.data && res.data.results) {
            data.total = res.data.total;
            data.results = res.data.results;
        }
    } catch (err) {
        console.error("Failed to fetch open orders", err);
    }
    return data;
});
const getPastOrders = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("orders/list/past", async (offset)=>{
    let data = {};
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.GET_ORDER_DETAILS_ENDPOINT, "?offset=").concat(offset, "&state=past"));
        if (res && res.data && res.data.results) {
            data.total = res.data.total;
            data.results = res.data.results;
        }
    } catch (err) {
        console.error("Failed to fetch past orders", err);
    }
    return data;
});
const findOrderByEmail = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("orders/email", async (payload)=>{
    var ref, ref1;
    const body = {
        email: (ref = payload.email) === null || ref === void 0 ? void 0 : ref.trim().toLowerCase(),
        orderId: (ref1 = payload.orderNo) === null || ref1 === void 0 ? void 0 : ref1.trim().toUpperCase()
    };
    try {
        const { status , data  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.FIND_MY_ORDERS_ENDPOINT, "?").concat(payload.source ? "orderSource=" + payload.source : ""), body);
        if (status === 200) {
            var ref2;
            let { order_detail: { shipments =[] , cancellations =[] , returns: { order: returnsOrder = []  }  } = {}  } = data;
            const installations = [];
            const returnsData = [];
            if (shipments.length) {
                const lineItems = [];
                shipments.forEach((order)=>{
                    const { shipDetail =[]  } = order;
                    shipDetail.forEach((delivery)=>{
                        if (delivery.item.length) {
                            delivery.item.forEach((item)=>{
                                lineItems.push({
                                    sku: item.sku
                                });
                            });
                        }
                    });
                });
                if (lineItems.length) {
                    const productData = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_2__/* .getLineItemAttrs */ .lP)(lineItems);
                    shipments.forEach((order)=>{
                        const { shipDetail =[]  } = order;
                        shipDetail.forEach((delivery)=>{
                            if (delivery.item.length) {
                                delivery.item.forEach((item, index)=>{
                                    const { lwData  } = productData.find((prod)=>prod.sku === item.sku);
                                    item.lwData = lwData;
                                    if (lwData.Product_Category === _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .INSTALL_SERVICES */ ._F) {
                                        var ref;
                                        var ref1, ref2;
                                        installations.push({
                                            ...item,
                                            trackingNumber: (ref1 = (ref = shipDetail[0]) === null || ref === void 0 ? void 0 : ref.trackingNumber) !== null && ref1 !== void 0 ? ref1 : "",
                                            invoiceNumber: (ref2 = order === null || order === void 0 ? void 0 : order.udf13) !== null && ref2 !== void 0 ? ref2 : ""
                                        });
                                        delete delivery.item[index];
                                    }
                                });
                            }
                        });
                    });
                }
            }
            if (cancellations && (cancellations === null || cancellations === void 0 ? void 0 : (ref2 = cancellations.order) === null || ref2 === void 0 ? void 0 : ref2.length)) {
                var ref3;
                const items = cancellations === null || cancellations === void 0 ? void 0 : (ref3 = cancellations.order) === null || ref3 === void 0 ? void 0 : ref3.reduce((itemsObj, orderObj)=>[
                        ...itemsObj,
                        ...orderObj.items
                    ], []);
                const productData1 = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_2__/* .getLineItemAttrs */ .lP)(items);
                items.forEach((item, index)=>{
                    const { lwData  } = productData1.find((prod)=>prod.sku === item.sku);
                    item.lwData = lwData;
                    if (lwData.Product_Category === _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .INSTALL_SERVICES */ ._F) {
                        items.splice(index, 1);
                    }
                });
            }
            if ((returnsOrder === null || returnsOrder === void 0 ? void 0 : returnsOrder.length) > 0) {
                const items1 = returnsOrder === null || returnsOrder === void 0 ? void 0 : returnsOrder.reduce((itemsObj, orderObj)=>[
                        ...itemsObj,
                        ...orderObj.items
                    ], []);
                const productData2 = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_2__/* .getLineItemAttrs */ .lP)(items1);
                returnsOrder.map((list, index)=>{
                    var ref;
                    if (list === null || list === void 0 ? void 0 : (ref = list.items) === null || ref === void 0 ? void 0 : ref.length) {
                        var ref1;
                        list === null || list === void 0 ? void 0 : (ref1 = list.items) === null || ref1 === void 0 ? void 0 : ref1.map((item)=>{
                            const { lwData  } = productData2.find((prod)=>prod.sku === item.sku);
                            item.lwData = lwData;
                            var ref;
                            item.return_date = (ref = list === null || list === void 0 ? void 0 : list.return_date) !== null && ref !== void 0 ? ref : "";
                            var ref1;
                            item.remarks = (ref1 = list === null || list === void 0 ? void 0 : list.remarks) !== null && ref1 !== void 0 ? ref1 : "";
                            var ref2;
                            item.return_amount = (ref2 = list === null || list === void 0 ? void 0 : list.return_amount) !== null && ref2 !== void 0 ? ref2 : "";
                            var _udf8;
                            item.itemName = (_udf8 = item.udf8) !== null && _udf8 !== void 0 ? _udf8 : "";
                            var ref3;
                            item.viniculumStatus = (ref3 = item === null || item === void 0 ? void 0 : item.status) !== null && ref3 !== void 0 ? ref3 : "";
                            var ref4;
                            item.status = (ref4 = list === null || list === void 0 ? void 0 : list.status) !== null && ref4 !== void 0 ? ref4 : "";
                        });
                    }
                });
            }
            shipments = shipments.filter((o)=>!o.extOrderNo.includes("SRV"));
            data.order_detail.shipments = shipments;
            data.order_detail.installations = installations;
            data.order_detail.returns = returnsOrder;
            return data;
        }
    } catch (err) {
        console.error("Failed to fetch order details", err);
        return {};
    }
});
const findOrderByOrderID = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("orders/email", async (payload)=>{
    var ref;
    const body = {
        orderId: (ref = payload.orderNo) === null || ref === void 0 ? void 0 : ref.trim().toUpperCase()
    };
    try {
        const { status , data  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.FIND_MY_ORDERS_ENDPOINT, "?").concat(payload.source ? "orderSource=" + payload.source : ""), body);
        if (status === 200) {
            var ref1;
            let { order_detail: { shipments =[] , cancellations =[] , returns: { order: returnsOrder = []  }  } = {}  } = data;
            const installations = [];
            const returnsData = [];
            if (shipments.length) {
                const lineItems = [];
                shipments.forEach((order)=>{
                    const { shipDetail =[]  } = order;
                    shipDetail.forEach((delivery)=>{
                        if (delivery.item.length) {
                            delivery.item.forEach((item)=>{
                                lineItems.push({
                                    sku: item.sku
                                });
                            });
                        }
                    });
                });
                if (lineItems.length) {
                    const productData = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_2__/* .getLineItemAttrs */ .lP)(lineItems);
                    shipments.forEach((order)=>{
                        const { shipDetail =[]  } = order;
                        shipDetail.forEach((delivery)=>{
                            if (delivery.item.length) {
                                delivery.item.forEach((item, index)=>{
                                    const { lwData  } = productData.find((prod)=>prod.sku === item.sku);
                                    item.lwData = lwData;
                                // if (lwData.Product_Category === INSTALL_SERVICES) {
                                //   installations.push({
                                //     ...item,
                                //     trackingNumber: shipDetail[0]?.trackingNumber ?? "",
                                //     invoiceNumber: order?.udf13 ?? "",
                                //   })
                                //   delete delivery.item[index]
                                // }
                                });
                            }
                        });
                    });
                }
            }
            if (cancellations && (cancellations === null || cancellations === void 0 ? void 0 : (ref1 = cancellations.order) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                var ref2;
                const items = cancellations === null || cancellations === void 0 ? void 0 : (ref2 = cancellations.order) === null || ref2 === void 0 ? void 0 : ref2.reduce((itemsObj, orderObj)=>[
                        ...itemsObj,
                        ...orderObj.items
                    ], []);
                const productData1 = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_2__/* .getLineItemAttrs */ .lP)(items);
                items.forEach((item, index)=>{
                    const { lwData  } = productData1.find((prod)=>prod.sku === item.sku);
                    item.lwData = lwData;
                    if (lwData.Product_Category === _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .INSTALL_SERVICES */ ._F) {
                        items.splice(index, 1);
                    }
                });
            }
            if ((returnsOrder === null || returnsOrder === void 0 ? void 0 : returnsOrder.length) > 0) {
                const items1 = returnsOrder === null || returnsOrder === void 0 ? void 0 : returnsOrder.reduce((itemsObj, orderObj)=>[
                        ...itemsObj,
                        ...orderObj.items
                    ], []);
                const productData2 = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_2__/* .getLineItemAttrs */ .lP)(items1);
                returnsOrder.map((list, index)=>{
                    var ref;
                    if (list === null || list === void 0 ? void 0 : (ref = list.items) === null || ref === void 0 ? void 0 : ref.length) {
                        var ref1;
                        list === null || list === void 0 ? void 0 : (ref1 = list.items) === null || ref1 === void 0 ? void 0 : ref1.map((item)=>{
                            const { lwData  } = productData2.find((prod)=>prod.sku === item.sku);
                            item.lwData = lwData;
                            var ref;
                            item.return_date = (ref = list === null || list === void 0 ? void 0 : list.return_date) !== null && ref !== void 0 ? ref : "";
                            var ref1;
                            item.remarks = (ref1 = list === null || list === void 0 ? void 0 : list.remarks) !== null && ref1 !== void 0 ? ref1 : "";
                            var ref2;
                            item.return_amount = (ref2 = list === null || list === void 0 ? void 0 : list.return_amount) !== null && ref2 !== void 0 ? ref2 : "";
                            var _udf8;
                            item.itemName = (_udf8 = item.udf8) !== null && _udf8 !== void 0 ? _udf8 : "";
                            var ref3;
                            item.viniculumStatus = (ref3 = item === null || item === void 0 ? void 0 : item.status) !== null && ref3 !== void 0 ? ref3 : "";
                            var ref4;
                            item.status = (ref4 = list === null || list === void 0 ? void 0 : list.status) !== null && ref4 !== void 0 ? ref4 : "";
                        });
                    }
                });
            }
            data.order_detail.shipments = shipments;
            data.order_detail.installations = installations;
            data.order_detail.returns = returnsOrder;
            return data;
        }
    } catch (err) {
        console.error("Failed to fetch order details", err);
        return {};
    }
});
const orderSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "orders",
    initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase(getOrder.pending, (state)=>{
            state.loading = true;
        }).addCase(getOrder.fulfilled, (state, action)=>{
            ;
            state.loading = false, state.orders = [
                ...state.orders,
                action.payload
            ];
        }).addCase(getOrder.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const getSplitOrder = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("orderSplit", async (payload)=>{
    const { email ="" , orderNo =""  } = payload;
    const emailId = email === null || email === void 0 ? void 0 : email.trim().toLowerCase();
    const encodeEmail = encodeURIComponent(emailId);
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.SPLIT_ORDER, "?parentOrderNumber=").concat(orderNo === null || orderNo === void 0 ? void 0 : orderNo.trim().toUpperCase(), "&email=").concat(encodeEmail));
    return response.data;
});
const {} = orderSlice.actions;
const ordersState = (state)=>state.orders;


/***/ }),

/***/ 44561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B$": function() { return /* binding */ getDiscontinuedProductValue; },
/* harmony export */   "BY": function() { return /* binding */ selectPdpState; },
/* harmony export */   "CC": function() { return /* binding */ setProductInfo; },
/* harmony export */   "Co": function() { return /* binding */ getProductBySlug; },
/* harmony export */   "ZR": function() { return /* binding */ setIsTeaserLoaded; },
/* harmony export */   "Zp": function() { return /* binding */ fetchPdpRequiredItems; },
/* harmony export */   "bF": function() { return /* binding */ getProductBySlugAndSku; },
/* harmony export */   "gP": function() { return /* binding */ getReqItemLwData; },
/* harmony export */   "n_": function() { return /* binding */ getPdpTooltip; },
/* harmony export */   "ou": function() { return /* binding */ pdpSlice; },
/* harmony export */   "qK": function() { return /* binding */ setPDP; },
/* harmony export */   "ub": function() { return /* binding */ setTeaserContent; },
/* harmony export */   "zF": function() { return /* binding */ searchPdp; }
/* harmony export */ });
/* unused harmony export getVariantFields */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55111);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28858);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34326);
/* harmony import */ var _components_ProductDetail_v3_productDetailsHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50023);








const initialState = {
    pdp: {},
    isDiscontinued: false,
    productInfo: {},
    teaserContent: [],
    isTeaserLoaded: false
};
const searchPdp = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("pdp/searchPdp", async (payload, thunkAPI)=>{
    try {
        const { slug , isParts , brandName , selectedSku , setSkuVariantCb  } = payload;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPdpEndPoint, "/").concat(slug), {
            q: "*:*",
            fl: _constants_index__WEBPACK_IMPORTED_MODULE_2__.SEARCH_PDP_FL.join(","),
            collections: isParts ? "service_parts" : brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase(),
            profilename: isParts ? "profile_service_parts_PDP" : "profile_".concat(brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase(), "_PDP"),
            search_type: "product_detail"
        });
        let productData = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(response.data, "response.docs[0]", {});
        let sku = "";
        let customerFacingSKU = "";
        let fusionQueryId = "";
        let recommendedAccessories = [];
        let colors = [];
        if (!productData["BundleList_ss"]) {
            sku = selectedSku === "" || !productData["variantList.sku_ss"].some((v)=>v === selectedSku) ? (0,_components_ProductDetail_v3_productDetailsHelper__WEBPACK_IMPORTED_MODULE_5__/* .getInitialSku */ .H3)(productData, setSkuVariantCb) : selectedSku;
            customerFacingSKU = productData["CustomerFacingSKU_s"];
            fusionQueryId = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(response.data, "fusion.fusionQueryId");
            if (productData["ProductProductRecommendedAccessories_ss"]) {
                recommendedAccessories = productData["ProductProductRecommendedAccessories_ss"];
            } else if (productData["ProductProductRecommendedAccessories_s"]) {
                recommendedAccessories.push(productData["ProductProductRecommendedAccessories_s"]);
            }
            if (productData["Color.SKU.Details_ss"]) {
                colors = productData["Color.SKU.Details_ss"].map((color)=>{
                    const d = color.split("|");
                    return {
                        sku: d[2],
                        discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now())
                    };
                });
            } else if (productData["SKU.Details_ss"]) {
                colors = productData["SKU.Details_ss"].map((color)=>{
                    const d = color.split("|");
                    return {
                        sku: d[0],
                        discontinued: !(d[2] === "false" || Date.parse(d[2]) > Date.now())
                    };
                });
            }
        } else {
            const response1 = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPdpEndPoint, "/").concat(slug, "?bundle=true&slug=").concat(slug), {
                q: "*:*",
                fl: _constants_index__WEBPACK_IMPORTED_MODULE_2__.SEARCH_PDP_FL.join(","),
                collections: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase(),
                profilename: "profile_".concat(brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase(), "_PDP"),
                search_type: "product_detail"
            });
            productData = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(response1.data, "response.docs[0]", {});
            productData.bundleItems = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(response1.data, "fusion.bundle-product-results", []);
            sku = selectedSku === "" || !productData["variantList.sku_ss"].some((v)=>v === selectedSku) ? (0,_components_ProductDetail_v3_productDetailsHelper__WEBPACK_IMPORTED_MODULE_5__/* .getInitialSku */ .H3)(productData, setSkuVariantCb) : selectedSku;
            customerFacingSKU = productData["CustomerFacingSKU_s"];
        }
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.addToRecentlyViewed)(productData["ctId_s"]);
        return {
            productData,
            sku,
            recommendedAccessories,
            colors,
            fusionQueryId,
            customerFacingSKU,
            slug
        };
    } catch (err) {
        return err;
    }
});
const getVariantFields = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("pdp/getVariantFields", async (payload)=>{
    try {
        const { skuList =[] , slug , isParts , brandName  } = payload;
        let skus = "";
        skuList.forEach((s)=>skus += '"'.concat(s, '" '));
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPdpEndPoint, "/").concat(slug), {
            q: "*:*",
            fq: "sku_s:(".concat(skus.trim(), ")"),
            fl: "sku_s,RegionStatesExcluded_ss,RegionSpecialOrder_s",
            collections: isParts ? "service_parts" : brandName.toLowerCase(),
            profilename: isParts ? "profile_service_parts_PDP" : "profile_".concat(brandName.toLowerCase(), "_PDP"),
            search_type: "product_detail"
        });
        return response.data;
    } catch (err) {
        return err;
    }
});
const getProductBySlug = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("pdp/getProductBySlug", async (payload)=>{
    let product = {};
    try {
        const { slug  } = payload;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.pdpCatalogProjectionEndPoint, '?where=slug(en-IN%3D"').concat(slug, '")'));
        if (response && response.data && response.data.results) {
            var ref;
            product = (ref = response.data.results[0]) !== null && ref !== void 0 ? ref : {};
        }
    } catch (err) {
        return err;
    }
    return product;
});
const getProductBySlugAndSku = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("pdp/getProductBySlugAndSku", async (payload)=>{
    const { slug , skus  } = payload;
    let query = "";
    let masterQuery = "";
    if (slug) masterQuery += 'slug(en-IN%3D"'.concat(slug, '") or ');
    if (skus.length > 0) {
        skus.forEach((sku, i)=>{
            query += '"'.concat(sku, '"');
            if (i + 1 !== skus.length) query += ", ";
        });
        masterQuery += "masterVariant(sku in (".concat(query, ")) or variants(sku in (").concat(query, "))");
    }
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.pdpCatalogProjectionEndPoint, "?where=").concat(masterQuery));
        if (res && res.data && res.data.results) return res.data.results;
    } catch (err) {
        console.error("Failed to fetch product details", err);
    }
    return [];
});
const getReqItemLwData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("pdp/getReqItemLwData", async (payload)=>{
    var ref, ref1;
    const { query , brandName  } = payload;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPlpEndPoint, {
        params: {
            q: "*:*",
            fl: "ctId_s,Color.SKU.Details_ss,Color.ANY.Details_ss,productName_s,ProductBrandNameDisplay_s,productImage.labelWithUrl_ss,RegionOnBackOrder_s,productInRiverId_s",
            fq: "productInRiverId_s:(".concat(query, ")"),
            collections: brandName.toLowerCase(),
            profilename: "profile_".concat(brandName.toLowerCase(), "_General")
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_7___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    var ref2;
    return (ref2 = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.docs) !== null && ref2 !== void 0 ? ref2 : [];
});
const fetchPdpRequiredItems = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("pdp/fetchPdpRequiredItems", async (query)=>{
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.pdpCatalogProjectionEndPoint, "?where=key in (").concat(query, ")"));
        var _results;
        return (_results = response.data.results) !== null && _results !== void 0 ? _results : [];
    } catch (err) {
        return err;
    }
});
const getPdpTooltip = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("pdp/getPdpTooltip", async (payload)=>{
    const { brandName  } = payload;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_2__.getPdpTooltipEndPoint, {
        params: {
            collection: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()
        }
    });
    return response === null || response === void 0 ? void 0 : response.data;
});
const pdpSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "pdp",
    initialState,
    reducers: {
        setPDP (state, action) {
            state.pdp = {
                ...state.pdp,
                ...action.payload
            };
        },
        getDiscontinuedProductValue (state, action) {
            state.isDiscontinued = action.payload;
        },
        setProductInfo (state, action) {
            state.productInfo = action.payload;
        },
        setTeaserContent (state, action) {
            state.teaserContent = action.payload;
        },
        setIsTeaserLoaded (state, action) {
            state.isTeaserLoaded = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_3__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.pdp
            };
        }).addCase(searchPdp.pending, (state, action)=>{
            state.status = "pending";
        }).addCase(searchPdp.fulfilled, (state, action)=>{
            const { productData ={} , sku ="" , recommendedAccessories =[] , colors =[] , slug ="" , customerFacingSKU =""  } = action.payload;
            state.status = "succeeded";
            state.pdp = {
                sku,
                slug: slug,
                recommendedAccessories,
                productBrand: productData["ProductBrandNameDisplay_t"],
                data: productData,
                variants: colors,
                customerFacingSKU: customerFacingSKU ? customerFacingSKU.replace("K-", "") : ""
            };
        }).addCase(searchPdp.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setPDP , getDiscontinuedProductValue , setProductInfo , setTeaserContent , setIsTeaserLoaded  } = pdpSlice.actions;
const selectPdpState = (state)=>state.pdp;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (pdpSlice.reducer);


/***/ }),

/***/ 49682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bp": function() { return /* binding */ profileBrandTopSearches; },
/* harmony export */   "R$": function() { return /* binding */ profileBrandSearch; },
/* harmony export */   "Tx": function() { return /* binding */ productListSlice; },
/* harmony export */   "Xp": function() { return /* binding */ getProducts; },
/* harmony export */   "dM": function() { return /* binding */ clearSuggestion; },
/* harmony export */   "gS": function() { return /* binding */ setPlpData; },
/* harmony export */   "rv": function() { return /* binding */ selectProductListState; },
/* harmony export */   "zw": function() { return /* binding */ profileBrandTypeahead; }
/* harmony export */ });
/* unused harmony exports profileServicePartsSearch, setProfileServicePartsSearch, setProfileBrandTypeahead, setProfileBrandSearch, updatePlpData, updatePlpDataStatus */
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55111);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34326);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29843);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28858);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19514);









const initialState = {
    profile_service_parts_Search: {},
    profile_brand_Typeahead: {},
    profile_brand_Search: {},
    profile_brand_Top_Searches: {},
    plp: {
        status: "loading-yes",
        error: "",
        initialLoad: true,
        suggestions: [],
        suggestionExactMatch: false
    }
};
const profileBrandTypeahead = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("profileBrandTypeahead", async (query)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPlpEndPoint, "?rows=10&fl=sku_s,productName_s,variantList.sku_ss&collections=").concat(query[1], "&profilename=profile_").concat(query[1], "_Typeahead&q=").concat(query[0], "&start=0"));
    return response.data;
});
const profileServicePartsSearch = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("profileServicePartsSearch", async (query)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPlpEndPoint, "?rows=").concat(query[2], "&fl=").concat(query[1], "&collections=service_parts&profilename=profile_service_parts_Search&q=").concat(query[0]));
    return response.data;
});
const profileBrandSearch = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("profileBrandSearch", async (query)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPlpEndPoint, "?rows=").concat(query[3], "&fl=").concat(query[2], "&lw.tagger.debug=true&collections=").concat(query[1], "&profilename=profile_").concat(query[1], "_Search&q=").concat(query[0]) + (query[4] ? "&fq=".concat(query[4]) : ""));
    return response.data;
});
const profileBrandTopSearches = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("profileBrandTopSearches", async (brand)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchProfilePlpEndPoint, "?q=*.*&profilename=profile_").concat(brand, "_Top_Searches&collections=").concat(brand));
    return response.data;
});
const getProducts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("plp/getProducts", async (payload)=>{
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.getUserPersona)();
    const { profileName: updatedProfileName , update , query , isFaq , isSuggestion , isSearch =false , ...params } = payload;
    let brandName = "kohler-india";
    (0,_constants_config__WEBPACK_IMPORTED_MODULE_6__/* .getConfig */ .i)().then((config)=>{
        brandName = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(config, "general.siteName");
    });
    const profilename = isSearch ? "profile_".concat(brandName.toLowerCase(), "_").concat(updatedProfileName) : "profile_".concat(brandName.toLowerCase(), "_PLP_").concat(updatedProfileName);
    const url = isFaq ? _constants_index__WEBPACK_IMPORTED_MODULE_2__.HELP_FAQ_END_POINT : _constants_index__WEBPACK_IMPORTED_MODULE_2__.PLP_END_POINT_CLIENT;
    const responseList = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get(url, {
        params: {
            ...query,
            ...params,
            persona,
            profilename,
            collections: "kohler-india",
            q: isSearch ? params.q : "*:*"
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_8___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    const data = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_4__/* .formatListingData */ .nx)(responseList.data);
    return {
        data,
        update,
        isSuggestion
    };
});
const productListSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "productList",
    initialState,
    reducers: {
        setProfileServicePartsSearch (state, action) {
            state.profile_service_parts_Search = action.payload;
        },
        setProfileBrandTypeahead (state, action) {
            state.profile_brand_Typeahead = action.payload;
        },
        setProfileBrandSearch (state, action) {
            state.profile_brand_Search = action.payload;
        },
        setPlpData (state, action) {
            state.plp = action === null || action === void 0 ? void 0 : action.payload;
            console.log(action, "-------action");
            state.plp["status"] = "succeeded";
        },
        updatePlpData (state, action) {
            console.log(action, "-------action");
            state.plp = {
                ...state.plp,
                data: [
                    ...state.plp.data,
                    ...action.payload
                ]
            };
        },
        updatePlpDataStatus (state, action) {
            console.log(action, "-------action");
            state.plp.status = action.payload;
        },
        clearSuggestion (state) {
            state.plp.suggestions = [];
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_5__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }).addCase(profileBrandSearch.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(profileBrandSearch.fulfilled, (state, action)=>{
            state.profile_brand_Search = {
                ...action.payload,
                status: "succeeded"
            };
        }).addCase(profileBrandSearch.rejected, (state, action)=>{
            state.profile_brand_Search.status = "failed";
            state.profile_brand_Search.error = action.error.message;
        }).addCase(profileServicePartsSearch.pending, (state, action)=>{
            state.profile_service_parts_Search.status = "loading";
        }).addCase(profileServicePartsSearch.fulfilled, (state, action)=>{
            if (action.payload && action.payload !== "") {
                state.profile_service_parts_Search = {
                    ...action.payload,
                    status: "succeeded"
                };
            }
        }).addCase(profileServicePartsSearch.rejected, (state, action)=>{
            state.profile_service_parts_Search.status = "failed";
            state.profile_service_parts_Search.error = action.error.message;
        }).addCase(profileBrandTopSearches.pending, (state, action)=>{
            state.profile_brand_Top_Searches.status = "loading";
        }).addCase(profileBrandTopSearches.fulfilled, (state, action)=>{
            if (action.payload && action.payload !== "") {
                state.profile_brand_Top_Searches = {
                    ...action.payload,
                    status: "succeeded"
                };
            }
        }).addCase(profileBrandTopSearches.rejected, (state, action)=>{
            state.profile_brand_Top_Searches.status = "failed";
            state.profile_brand_Top_Searches.error = action.error.message;
        }).addCase(profileBrandTypeahead.pending, (state, action)=>{
            state.profile_brand_Typeahead.status = "loading";
        }).addCase(profileBrandTypeahead.fulfilled, (state, action)=>{
            state.profile_brand_Typeahead = {
                ...action.payload,
                status: "succeeded"
            };
        }).addCase(profileBrandTypeahead.rejected, (state, action)=>{
            state.profile_brand_Typeahead.status = "failed";
            state.profile_brand_Top_Searches.error = action.error.message;
        }).addCase(getProducts.pending, (state, action)=>{
            if (!state.plp.initialLoad) {
                state.plp.status = "loading";
            }
        }).addCase(getProducts.fulfilled, (state, action)=>{
            const { data , update , isSuggestion =""  } = action === null || action === void 0 ? void 0 : action.payload;
            if (isSuggestion) {
                state.plp = {
                    ...state.plp,
                    suggestions: data,
                    suggestionExactMatch: isSuggestion
                };
            } else if (update) {
                state.plp = {
                    ...state.plp,
                    data: state.plp.data.concat(data.data)
                };
            } else {
                state.plp = data;
            }
            state.plp.initialLoad = false;
            state.plp.status = "succeeded";
        }).addCase(getProducts.rejected, (state, action)=>{
            state.plp.status = "failed";
            state.plp.error = action.error.message;
        });
    }
});
const { setProfileServicePartsSearch , setProfileBrandTypeahead , setProfileBrandSearch , setPlpData , updatePlpData , updatePlpDataStatus , clearSuggestion  } = productListSlice.actions;
const selectProductListState = (state)=>state.productList;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (productListSlice.reducer);


/***/ }),

/***/ 45094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ store; },
  "YS": function() { return /* binding */ wrapper; }
});

// UNUSED EXPORTS: makeStore

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(77236);
// EXTERNAL MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(28858);
// EXTERNAL MODULE: ./node_modules/redux-persist/lib/storage/createWebStorage.js
var createWebStorage = __webpack_require__(23488);
;// CONCATENATED MODULE: ./src/store/syncStorage.js

const createNoopStorage = ()=>{
    return {
        getItem (_key) {
            return Promise.resolve(null);
        },
        setItem (_key, value) {
            return Promise.resolve(value);
        },
        removeItem (_key) {
            return Promise.resolve();
        }
    };
};
const storage =  true ? (0,createWebStorage/* default */.Z)("local") : 0;
/* harmony default export */ var syncStorage = (storage);

// EXTERNAL MODULE: ./node_modules/redux-persist/es/index.js + 11 modules
var es = __webpack_require__(97568);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./src/store/features/locationSlice.js
var locationSlice = __webpack_require__(13644);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/checkoutSlice.js
var checkoutSlice = __webpack_require__(60475);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
// EXTERNAL MODULE: ./store/features/orderSlice.js
var orderSlice = __webpack_require__(76977);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(5702);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./node_modules/redux-persist-transform-filter/dist/index.js
var dist = __webpack_require__(38551);
// EXTERNAL MODULE: ./node_modules/redux-persist/lib/stateReconciler/autoMergeLevel2.js
var autoMergeLevel2 = __webpack_require__(1190);
// EXTERNAL MODULE: ./src/store/features/searchSlice.js
var searchSlice = __webpack_require__(54127);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./src/store/features/myProductSlice.js
var myProductSlice = __webpack_require__(2570);
// EXTERNAL MODULE: ./store/features/membershipSlice.js
var membershipSlice = __webpack_require__(9862);
;// CONCATENATED MODULE: ./store/index.js



















const combinedReducer = (0,redux/* combineReducers */.UY)({
    [authSlice/* authSlice.name */.Gb.name]: authSlice/* authSlice.reducer */.Gb.reducer,
    [cartSlice/* cartSlice.name */.Ao.name]: cartSlice/* cartSlice.reducer */.Ao.reducer,
    [locationSlice/* locationSlice.name */.vM.name]: locationSlice/* locationSlice.reducer */.vM.reducer,
    [genericSlice/* genericSlice.name */.JN.name]: genericSlice/* genericSlice.reducer */.JN.reducer,
    [checkoutSlice/* checkoutSlice.name */.vu.name]: checkoutSlice/* checkoutSlice.reducer */.vu.reducer,
    [productListSlice/* productListSlice.name */.Tx.name]: productListSlice/* productListSlice.reducer */.Tx.reducer,
    [orderSlice/* orderSlice.name */.zM.name]: orderSlice/* orderSlice.reducer */.zM.reducer,
    [favoritesSlice/* favoritesSlice.name */.MY.name]: favoritesSlice/* favoritesSlice.reducer */.MY.reducer,
    [compareSlice/* compareSlice.name */.qD.name]: compareSlice/* compareSlice.reducer */.qD.reducer,
    [searchSlice/* searchSlice.name */.iv.name]: searchSlice/* searchSlice.reducer */.iv.reducer,
    [pdpSlice/* pdpSlice.name */.ou.name]: pdpSlice/* pdpSlice.reducer */.ou.reducer,
    [myProductSlice/* myProductSlice.name */.dj.name]: myProductSlice/* myProductSlice.reducer */.dj.reducer,
    [membershipSlice/* memberSlice.name */.k.name]: membershipSlice/* memberSlice.reducer */.k.reducer
});
let store;
const makeStore = ()=>{
    const isServer = "object" === "undefined";
    if (isServer) {
        // If it's on server side, create a store
        return (0,redux_toolkit_esm/* configureStore */.xC)({
            reducer: combinedReducer,
            middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
                    serializableCheck: {
                        ignoredActions: [
                            es.FLUSH,
                            es.REHYDRATE,
                            es.PAUSE,
                            es.PERSIST,
                            es.PURGE,
                            es.REGISTER
                        ]
                    }
                })
        });
    } else {
        // If it's on client side, create a store which will persist
        const authSubsetFilter = (0,dist/* default */.ZP)("auth", [
            "anonymousId",
            "access_token",
            "refresh_token",
            "expires_in",
            "revalidate_in",
            "hashedEmail",
            "customerProspect"
        ]);
        const persistConfig = {
            key: "root",
            whitelist: [
                "auth",
                "location",
                "compare"
            ],
            transforms: [
                authSubsetFilter
            ],
            storage: syncStorage,
            stateReconciler: autoMergeLevel2/* default */.Z
        };
        const persistedReducer = (0,es.persistReducer)(persistConfig, combinedReducer);
        store = (0,redux_toolkit_esm/* configureStore */.xC)({
            reducer: persistedReducer,
            middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
                    serializableCheck: {
                        ignoredActions: [
                            es.FLUSH,
                            es.REHYDRATE,
                            es.PAUSE,
                            es.PERSIST,
                            es.PURGE,
                            es.REGISTER
                        ]
                    }
                })
        });
        store.__persistor = (0,es.persistStore)(store);
        return store;
    }
};

const wrapper = (0,es6/* createWrapper */.KV)(makeStore);


/***/ }),

/***/ 51666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getSessionIdObjWithEpoc; }
/* harmony export */ });
const getSessionIdObjWithEpoc = ()=>{
    var ref;
    const cookies = (ref = document.cookie.split(";")) !== null && ref !== void 0 ? ref : [];
    var ref1;
    let sessionCookie = (ref1 = cookies.find((myCookie)=>myCookie.includes("session#"))) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    sessionCookie = (ref2 = sessionCookie.split("|").find((item)=>item.includes("session"))) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    const sessionCookies = (ref3 = sessionCookie.split("#")) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    const sessionId = (ref4 = sessionCookies[1]) !== null && ref4 !== void 0 ? ref4 : "";
    return sessionId ? "".concat(sessionId, "-").concat(Date.now()) : "";
};


/***/ }),

/***/ 33273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xw": function() { return /* binding */ cart_getAriaLabel; },
  "c0": function() { return /* binding */ cart_getCartCount; },
  "Uo": function() { return /* binding */ cart_getCartIdParams; },
  "dZ": function() { return /* binding */ cart_getCartLandingPagePath; },
  "cS": function() { return /* binding */ cart_getCustomerCartId; },
  "X3": function() { return /* binding */ getETACached; },
  "PW": function() { return /* binding */ cart_getQuantityCount; },
  "K5": function() { return /* binding */ cart_getStock; },
  "fd": function() { return /* binding */ getStockCached; },
  "w$": function() { return /* reexport */ removeCustomerCartId; },
  "NS": function() { return /* binding */ cart_setCartLandingPagePath; },
  "VN": function() { return /* reexport */ setCustomerCartId; }
});

// UNUSED EXPORTS: deleteFromCart, getCartPagePath

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./store/index.js + 1 modules
var store_0 = __webpack_require__(45094);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
;// CONCATENATED MODULE: ./src/utils/cart.js







const getStock = async (sku)=>{
    let stock = 0;
    const response = await apim.get("".concat(getStockEndPoint, "/?sku=").concat(sku));
    if (response && response.data && response.data.results && response.data.results[0]) {
        var _availableQuantity;
        stock = (_availableQuantity = response.data.results[0].availableQuantity) !== null && _availableQuantity !== void 0 ? _availableQuantity : 0;
    }
    return stock;
};
const getQuantityCount = (data)=>{
    if (!(data && data.length)) return 0;
    const totalCount = data && data.filter((item)=>{
        var ref, ref1;
        return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
    }).reduce((accumulator, item)=>{
        return accumulator + item.quantity;
    }, 0);
    return totalCount;
};
const getCartCount = ()=>{
    var ref;
    var ref1;
    const { cartCount  } = (ref1 = (ref = store === null || store === void 0 ? void 0 : store.getState()) === null || ref === void 0 ? void 0 : ref.cart) !== null && ref1 !== void 0 ? ref1 : 0;
    return cartCount;
};
const getAriaLabel = (t, cartCount)=>{
    const ariaLabel = cartCount > 1 ? t("kf.minicart.aria.label.cartItems", {
        count: cartCount
    }) : t("kf.minicart.aria.label.cartItem", {
        count: cartCount
    });
    return ariaLabel;
};
const setCartLandingPagePath = async ()=>{
    const config = await getConfig();
    const cartLandingUrl = await getShortenedUrl(_get(config, "general.cartLandingPagePath", "/"));
    store.dispatch(setCartUrl(cartLandingUrl));
};
const getCartLandingPagePath = async ()=>{
    const config = await getConfig();
    const cartLandingUrl = await getShortenedUrl(_get(config, "general.cartLandingPagePath", "/"));
    return cartLandingUrl;
};
const getCartPagePath = ()=>{
    let path = "/";
    path = getCartLandingPagePath().then((res)=>{
        return res;
    });
    return path;
};
const getCustomerCartId = ()=>{
    return localStorage.getItem("customerCartId");
};
const setCustomerCartId = (item)=>{
    localStorage.setItem("customerCartId", item);
};
const removeCustomerCartId = ()=>{
    localStorage.removeItem("customerCartId");
};
const getCartIdParams = (isSubmit)=>{
    const { auth: { user: { koc: isIscUser  } = {}  } = {} , cart: { cart: { id =""  } = {}  } = {}  } = store.getState();
    const customerCartId = getCustomerCartId();
    const cartId = isIscUser && customerCartId ? "&cartId=".concat(customerCartId) : "";
    const cartIdQuery = isIscUser && customerCartId ? "?cartId=".concat(customerCartId) : isSubmit ? "?cartId=".concat(id) : "";
    const activeCartId = isIscUser && customerCartId ? customerCartId : id;
    return {
        cartId,
        cartIdQuery,
        activeCartId
    };
};
const deleteFromCart = async (cb)=>{
    await store.dispatch(deleteCart()).unwrap().then((res)=>{
        if (res) {
            cb && cb("success", null, res ? res : {});
            store.dispatch(setCart({
                lineItems: []
            }));
            store.dispatch(setNoshipping([]));
            store.dispatch(setCartCount(0));
            store.dispatch(setShipping([]));
            const cartPayload = {
                currency: "USD",
                taxMode: "ExternalAmount"
            };
            store.dispatch(createCart(cartPayload));
        }
    }).catch(()=>{
        cb && cb("failure", "failed to empty your cart.");
    });
};


;// CONCATENATED MODULE: ./utils/cart.js








const cart_getStock = async (sku)=>{
    let stock = 0;
    try {
        const { data: { results =[]  } = {}  } = await api/* apim.get */.TH.get("".concat(constants.getStockEndPoint, "/?sku=").concat(sku));
        stock = results.reduce((acc, cur)=>acc + cur.availableQuantity, 0);
    } catch (err) {
        console.error(err);
    }
    return stock;
};
const getStockCached = async (sku)=>{
    const cacheDuration = 2 * 60 * 1000;
    const now = Date.now();
    if (!window.stockCache) {
        window.stockCache = {};
    }
    if (window.stockCache[sku] && now - window.stockCache[sku].timestamp < cacheDuration) {
        return window.stockCache[sku].stock;
    }
    let stock = 0;
    try {
        const { data: { results =[]  } = {}  } = await api/* apim.get */.TH.get("".concat(constants.getStockEndPoint, "/?sku=").concat(sku));
        stock = results.reduce((acc, cur)=>acc + cur.availableQuantity, 0);
        window.stockCache[sku] = {
            stock,
            timestamp: now
        };
    } catch (err) {
        console.error(err);
    }
    return stock;
};
const cart_getQuantityCount = (data)=>{
    if (!(data && data.length)) {
        return 0;
    }
    const totalCount = data && data.filter((item)=>{
        var ref, ref1, ref2, ref3;
        const category = (ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find((attr)=>attr.name === "ProductLocalCategory");
        return !((ref2 = item.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.isBundleChildItem) || (category === null || category === void 0 ? void 0 : category.value) === "Install Services";
    }).reduce((accumulator, item)=>{
        return accumulator + item.quantity;
    }, 0);
    return totalCount;
};
const cart_getCartCount = ()=>{
    var ref;
    var ref1;
    const { cartCount  } = (ref1 = (ref = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : ref.cart) !== null && ref1 !== void 0 ? ref1 : 0;
    return cartCount;
};
const cart_getAriaLabel = (t, cartCount)=>{
    const ariaLabel = cartCount > 1 ? t("kf.minicart.aria.label.cartItems", {
        count: cartCount
    }) : t("kf.minicart.aria.label.cartItem", {
        count: cartCount
    });
    return ariaLabel;
};
const cart_setCartLandingPagePath = async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const cartLandingUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.cartLandingPagePath", "/"));
    store_0/* store.dispatch */.h.dispatch((0,cartSlice/* setCartUrl */.xA)(cartLandingUrl));
};
const cart_getCartLandingPagePath = async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const cartLandingUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.cartLandingPagePath", "/"));
    return cartLandingUrl;
};
const cart_getCartPagePath = ()=>{
    let path = "/";
    path = cart_getCartLandingPagePath().then((res)=>{
        return res;
    });
    return path;
};
const cart_getCustomerCartId = ()=>{
    return localStorage.getItem("customerCartId");
};
const cart_getCartIdParams = (isSubmit)=>{
    const { auth: { user: { persona =[]  } = {}  } = {} , cart: { cart: { id =""  } = {}  } = {}  } = store_0/* store.getState */.h.getState();
    const isIscUser = persona === null || persona === void 0 ? void 0 : persona.includes("IN_Kohler_ISC");
    const customerCartId = cart_getCustomerCartId();
    const cartId = isIscUser && customerCartId ? "&cartId=".concat(customerCartId) : "";
    const cartIdQuery = isIscUser && customerCartId ? "?cartId=".concat(customerCartId) : isSubmit ? "?cartId=".concat(id) : "";
    return {
        cartId,
        cartIdQuery
    };
};
const cart_deleteFromCart = async (cb)=>{
    await store.dispatch(deleteCart()).unwrap().then((res)=>{
        if (res) {
            cb && cb("success", null, res ? res : {});
            store.dispatch(setCart({
                lineItems: []
            }));
            store.dispatch(setNoshipping([]));
            store.dispatch(setCartCount(0));
            store.dispatch(setShipping([]));
            const cartPayload = {
                currency: "INR"
            };
            store.dispatch(createCart(cartPayload));
        }
    }).catch(()=>{
        cb && cb("failure", "failed to empty your cart.");
    });
};
const getETACached = async function() {
    let isBundle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], isMustOrder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    try {
        const now = new Date().getTime();
        const cacheDuration = 2 * 60 * 1000;
        const SKU = isBundle ? payload.parentSKU : payload.sku;
        if (!window.etaCache) {
            window.etaCache = {};
        }
        const isCacheValid = !isMustOrder && window.etaCache[SKU] && window.etaCache[SKU].pincode === payload.pincode && payload.qty <= window.etaCache[SKU].availableQty && now - window.etaCache[SKU].lastCacheTime <= cacheDuration && window.etaCache[SKU].lastQty < payload.qty;
        if (!isCacheValid) {
            var ref;
            window.etaCache = {};
            const { data: res = {}  } = await api/* apim.post */.TH.post("/catalog/stock-availability/eta" + (isBundle ? "?type=bundle" : isMustOrder ? "?type=must-order" : ""), payload);
            const cacheData = (etaResponse)=>{
                const { result: { data: { warehouse =[] , items =[] , sku =""  } = {}  } = {}  } = etaResponse;
                let availableQty = 0;
                if (isBundle) {
                    availableQty = items.reduce((minQty, item, index)=>{
                        var ref;
                        const itemQty = ((ref = item.warehouse) === null || ref === void 0 ? void 0 : ref.reduce((total, warehouse)=>total + warehouse.availableQty, 0)) || 0;
                        return index === 0 ? itemQty : Math.min(minQty, itemQty);
                    }, 0);
                } else {
                    availableQty = (warehouse === null || warehouse === void 0 ? void 0 : warehouse.reduce((total, wh)=>total + wh.availableQty, 0)) || 0;
                }
                if (etaResponse.status !== "fail") {
                    var ref, ref1;
                    window.etaCache[isBundle ? SKU : sku] = {
                        data: JSON.parse(JSON.stringify(etaResponse)),
                        pincode: payload.pincode,
                        availableQty,
                        lastCacheTime: now,
                        lastQty: payload.qty,
                        warehouse: isMustOrder ? JSON.parse(JSON.stringify((ref = etaResponse.result) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.warehouse)) : []
                    };
                }
            };
            isMustOrder ? (ref = res.result) === null || ref === void 0 ? void 0 : ref.data.forEach((item)=>cacheData(item)) : cacheData(res);
            return res;
        }
        if (window.etaCache[SKU]) {
            window.etaCache[SKU].lastQty = payload.qty;
        }
        return JSON.parse(JSON.stringify(window.etaCache[SKU].data));
    } catch (ex) {
        console.log("Fetching ETA failed", ex);
        return ex.response;
    }
};




/***/ }),

/***/ 11310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": function() { return /* binding */ inventoryStatus; },
/* harmony export */   "Bp": function() { return /* binding */ submitDealershipUrl; },
/* harmony export */   "Fi": function() { return /* binding */ getStateWithCitiesServer; },
/* harmony export */   "Jf": function() { return /* binding */ findAStoreUrl; },
/* harmony export */   "MT": function() { return /* binding */ customerSupportUrl; },
/* harmony export */   "Oy": function() { return /* binding */ productSections; },
/* harmony export */   "S$": function() { return /* binding */ promoAllowedCitites; },
/* harmony export */   "Wc": function() { return /* binding */ submitFeedbackUrl; },
/* harmony export */   "_F": function() { return /* binding */ INSTALL_SERVICES; },
/* harmony export */   "e7": function() { return /* binding */ months; },
/* harmony export */   "h0": function() { return /* binding */ stateWithCities; },
/* harmony export */   "id": function() { return /* binding */ createAccountUrl; },
/* harmony export */   "m8": function() { return /* binding */ getDetailsClient; },
/* harmony export */   "tR": function() { return /* binding */ activateUserFactorUrl; },
/* harmony export */   "uF": function() { return /* binding */ submitLeadGenerationUrl; }
/* harmony export */ });
/* unused harmony exports FIND_BY_PINCODE, pinCodeUrl, getDetailsServer, getStoresServer, getLocationFromIPURL, sendOTPUrl */
const findAStoreUrl = "/maps/stores";
const pinCodeUrl = "/maps/location/zipcode";
const customerSupportUrl = "/support/contact-us";
const getDetailsServer = "/common/get-city-state-with-pincode";
const getDetailsClient = "/maps/get-city-state-with-pincode";
const getStoresServer = "/common/stores";
const getStateWithCitiesServer = "/common/stores/states-with-cities";
const submitFeedbackUrl = "/support/feedback/submit";
const createAccountUrl = "/customer/signup";
const getLocationFromIPURL = "/maps/location/ip";
const submitDealershipUrl = "/support/lead/create?type=enquiry";
const submitLeadGenerationUrl = "/support/lead/create";
const sendOTPUrl = "/customer/signup";
const activateUserFactorUrl = "/customer/factor/activate";
const INSTALL_SERVICES = "Install Services";
const FIND_BY_PINCODE = "/maps/get-city-state-with-pincode?pincode=";
const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const inventoryStatus = {
    IN_STOCK: "inStock",
    NON_DELIVERABLE: "nonDeliverable",
    OUT_OF_STOCK: "outOfStock",
    PARTIAL_NON_DELIVERABLE: "partialNonDeliverable",
    PARTIAL_OUT_OF_STOCK: "partialOutOfStock",
    PARTIAL_NON_DELIVERABLE_AND_OUT_OF_STOCK: "partialNonDeliverableAndOutOfStock",
    INSTALLATION_NOT_AVAILABLE: "installationNotAvailable"
};
const productSections = {
    MUST_ORDER: "pdp:itemsrequired",
    RECOMMENDATIONS: "cart:recommendation"
};
const stateWithCities = [
    {
        state: "Maharashtra",
        city: "Pune"
    },
    {
        state: "Maharashtra",
        city: "Mumbai"
    },
    {
        state: "Maharashtra",
        city: "Thane"
    }
];
const promoAllowedCitites = [
    {
        state: "Karnataka",
        city: "Bangalore"
    }
];



/***/ }),

/***/ 42605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ getCookieValue; },
/* harmony export */   "HR": function() { return /* binding */ getStatesAndCitiesFromServer; },
/* harmony export */   "Kh": function() { return /* binding */ reverseGeo; },
/* harmony export */   "Uk": function() { return /* binding */ getDealerNames; },
/* harmony export */   "k_": function() { return /* binding */ getDetailsFromZipCode; },
/* harmony export */   "yh": function() { return /* binding */ getStoresList; }
/* harmony export */ });
/* unused harmony exports getStateAndCities, getDetailsFromPincode, getStoresFromDetails, getLocationFromIP */
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55111);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11310);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34326);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73350);





const getStateAndCities = async ()=>{
    var ref;
    let accessToken = null;
    accessToken = (ref = getAccessToken()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await apim.get("".concat(apiBaseUrl).concat(findAStoreUrl, "/states-with-cities"));
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getStoresList = async (storeState, storeCity)=>{
    var ref;
    let accessToken = null;
    accessToken = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.apiBaseUrl).concat(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .findAStoreUrl */ .Jf, "?brand=india&state=").concat(storeState, "&city=").concat(storeCity, "&page=1&limit=100"));
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getDetailsFromZipCode = async (zipcode)=>{
    var ref;
    let accessToken = null;
    accessToken = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.apiBaseUrl).concat(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .getDetailsClient */ .m8, "?pincode=").concat(zipcode));
            resolve(content);
        } catch (error) {
            var ref;
            resolve((ref = error.response) === null || ref === void 0 ? void 0 : ref.status);
        }
    });
};
const getDetailsFromPincode = async (zipcode)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            aemAxiosInstance.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "".concat(apimSubscriptionKey);
            const { data: content  } = await aemAxiosInstance({
                url: "".concat(apiBaseUrl).concat(getDetailsClient, "?pincode=").concat(zipcode)
            });
            resolve(content);
        } catch (error) {
            resolve(error.response.status);
        }
    });
};
const getStoresFromDetails = async (storeState, storeCity)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            aemAxiosInstance.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "".concat(apimSubscriptionKey);
            const { data: content  } = await aemAxiosInstance({
                url: "".concat(apiBaseUrl).concat(getStoresServer, "?brand=india&state=").concat(storeState, "&city=").concat(storeCity, "&page=1&limit=100")
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getStatesAndCitiesFromServer = async ()=>{
    return new Promise(async (resolve, reject)=>{
        try {
            _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .aemAxiosInstance.defaults.headers.common["Ocp-Apim-Subscription-Key"] */ .Gb.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.apimSubscriptionKey);
            const { data: content  } = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_3__/* .aemAxiosInstance */ .Gb)({
                url: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.apiBaseUrl).concat(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .getStateWithCitiesServer */ .Fi)
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getLocationFromIP = async (ip)=>{
    var ref;
    let accessToken = null;
    accessToken = (ref = getAccessToken()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await apim.get("".concat(apiBaseUrl).concat(getLocationFromIPURL, "/").concat(ip));
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getDealerNames = async function() {
    let limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    let accessToken = null;
    accessToken = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.apiBaseUrl).concat(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .findAStoreUrl */ .Jf, "?brand=india&limit=").concat(limit));
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getCookieValue = (name)=>{
    var ref;
    return ((ref = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
};
const reverseGeo = async (lat, long)=>{
    try {
        var ref, ref1, ref2, ref3;
        const location = {
            lat: null,
            long: null
        };
        if (!lat) {
            const userCookie = getCookieValue("userLocation");
            const userLocation = userCookie === null || userCookie === void 0 ? void 0 : userCookie.split("+");
            if (userLocation.length) {
                location.lat = userLocation[4];
                location.long = userLocation[5];
            }
        }
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get("/maps/geocoding/reverse", {
            params: {
                $format: "json",
                brand: "india",
                lat: lat !== null && lat !== void 0 ? lat : location.lat,
                long: long !== null && long !== void 0 ? long : location.long
            }
        });
        return ((ref2 = (ref1 = (ref = res.data) === null || ref === void 0 ? void 0 : ref.resourceSets[0]) === null || ref1 === void 0 ? void 0 : ref1.resources[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.postalCode) || false;
    } catch (ex) {
        console.log("Failed to fetch pincode using lat long", ex);
    }
};


/***/ }),

/***/ 34326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "addADALink": function() { return /* reexport */ addADALink; },
  "addMediaToFavorites": function() { return /* reexport */ addMediaToFavorites; },
  "addPageLoadAnalyticsEvent": function() { return /* binding */ helper_addPageLoadAnalyticsEvent; },
  "addToRecentSearch": function() { return /* reexport */ addToRecentSearch; },
  "addToRecentlyViewed": function() { return /* reexport */ addToRecentlyViewed; },
  "appendPresetToUrl": function() { return /* binding */ helper_appendPresetToUrl; },
  "arrayMove": function() { return /* binding */ helper_arrayMove; },
  "buildUrlForAemApim": function() { return /* binding */ buildUrlForAemApim; },
  "caesarDecrypt": function() { return /* reexport */ helper_caesarDecrypt; },
  "caesarEncrypt": function() { return /* reexport */ caesarEncrypt; },
  "calculateCartData": function() { return /* binding */ helper_calculateCartData; },
  "capitalizeFirstName": function() { return /* reexport */ capitalizeFirstName; },
  "checkAlphabetOnly": function() { return /* reexport */ checkAlphabetOnly; },
  "checkAlphanumeric": function() { return /* reexport */ checkAlphanumeric; },
  "checkCartStock": function() { return /* reexport */ checkCartStock; },
  "checkIfUserExists": function() { return /* reexport */ checkIfUserExists; },
  "checkIsFavorite": function() { return /* reexport */ checkIsFavorite; },
  "checkStock": function() { return /* reexport */ checkStock; },
  "cleanText": function() { return /* reexport */ cleanText; },
  "clearAnonymousToken": function() { return /* binding */ helper_clearAnonymousToken; },
  "clearAuthToken": function() { return /* binding */ helper_clearAuthToken; },
  "closeModalAnalytics": function() { return /* reexport */ closeModalAnalytics; },
  "closePreview": function() { return /* reexport */ closePreview; },
  "convertStringToBoolean": function() { return /* reexport */ convertStringToBoolean; },
  "convertToIndianPhoneNumber": function() { return /* binding */ convertToIndianPhoneNumber; },
  "createHashFromString": function() { return /* binding */ createHashFromString; },
  "createIdFromString": function() { return /* reexport */ createIdFromString; },
  "createPersonaCookie": function() { return /* reexport */ createPersonaCookie; },
  "customSanitizeInnerHtml": function() { return /* reexport */ customSanitizeInnerHtml; },
  "debounce": function() { return /* reexport */ debounce; },
  "decodeHtmlCharacters": function() { return /* reexport */ decodeHtmlCharacters; },
  "destructureAddress": function() { return /* reexport */ destructureAddress; },
  "downloadArticle": function() { return /* reexport */ downloadArticle; },
  "extractLinksFromDOM": function() { return /* binding */ helper_extractLinksFromDOM; },
  "extractMetasFromDOM": function() { return /* binding */ helper_extractMetasFromDOM; },
  "extractScriptsFromDOM": function() { return /* reexport */ extractScriptsFromDOM; },
  "extractStylesFromDOM": function() { return /* reexport */ extractStylesFromDOM; },
  "filterBackEndJson": function() { return /* reexport */ filterBackEndJson; },
  "formatDate": function() { return /* reexport */ formatDate; },
  "formatFacetName": function() { return /* binding */ helper_formatFacetName; },
  "formatMultiSelectFacets": function() { return /* reexport */ formatMultiSelectFacets; },
  "formatOfflineRegisterPropsData": function() { return /* reexport */ formatOfflineRegisterPropsData; },
  "formatOnlineRegisterPropsData": function() { return /* reexport */ formatOnlineRegisterPropsData; },
  "formatPhoneNumber": function() { return /* reexport */ formatPhoneNumber; },
  "formatPriceRange": function() { return /* binding */ helper_formatPriceRange; },
  "gePDPUrlPageDetails": function() { return /* binding */ helper_gePDPUrlPageDetails; },
  "generateCanonicalUrl": function() { return /* reexport */ generateCanonicalUrl; },
  "getAEMPreviewModeCookie": function() { return /* reexport */ getAEMPreviewModeCookie; },
  "getAccessToken": function() { return /* binding */ helper_getAccessToken; },
  "getAllFilterQueries": function() { return /* binding */ helper_getAllFilterQueries; },
  "getAnalyticLinkUrl": function() { return /* binding */ getAnalyticLinkUrl; },
  "getAnalyticsFileName": function() { return /* reexport */ getAnalyticsFileName; },
  "getAnalyticsScript": function() { return /* reexport */ getAnalyticsScript; },
  "getAnalyticsUrl": function() { return /* reexport */ getAnalyticsUrl; },
  "getAnonymousId": function() { return /* reexport */ getAnonymousId; },
  "getAppliedSortPressKit": function() { return /* reexport */ getAppliedSortPressKit; },
  "getAttributeValue": function() { return /* reexport */ getAttributeValue; },
  "getBadgeValue": function() { return /* reexport */ getBadgeValue; },
  "getBundleProductName": function() { return /* binding */ getBundleProductName; },
  "getCacheKey": function() { return /* binding */ getCacheKey; },
  "getCartItemType": function() { return /* reexport */ getCartItemType; },
  "getCartItemsAnalyticsData": function() { return /* reexport */ getCartItemsAnalyticsData; },
  "getCityList": function() { return /* reexport */ getCityList; },
  "getClienIP": function() { return /* binding */ helper_getClienIP; },
  "getCompareData": function() { return /* reexport */ getCompareData; },
  "getCountryCode": function() { return /* reexport */ getCountryCode; },
  "getCurrency": function() { return /* binding */ helper_getCurrency; },
  "getCurrentSkuCouponDiscounts": function() { return /* reexport */ getCurrentSkuCouponDiscounts; },
  "getDataLayerObj": function() { return /* reexport */ getDataLayerObj; },
  "getDefaultProfileAddress": function() { return /* reexport */ getDefaultProfileAddress; },
  "getEtaDataIndividual": function() { return /* binding */ getEtaDataIndividual; },
  "getFacetsFromUrl": function() { return /* binding */ helper_getFacetsFromUrl; },
  "getFavouraties": function() { return /* reexport */ getFavouraties; },
  "getInternalLinkTypeForFindStore": function() { return /* reexport */ getInternalLinkTypeForFindStore; },
  "getLWData": function() { return /* binding */ getLWData; },
  "getLocationByCookies": function() { return /* binding */ helper_getLocationByCookies; },
  "getModelSuggestionSkuListFromData": function() { return /* reexport */ getModelSuggestionSkuListFromData; },
  "getMyLocation": function() { return /* reexport */ getMyLocation; },
  "getMyLocationByUserIP": function() { return /* reexport */ getMyLocationByUserIP; },
  "getOffsetTop": function() { return /* reexport */ getOffsetTop; },
  "getPDPUrl": function() { return /* binding */ helper_getPDPUrl; },
  "getPDPUrlForProductTile": function() { return /* binding */ helper_getPDPUrlForProductTile; },
  "getPDPUrlWithConfig": function() { return /* binding */ helper_getPDPUrlWithConfig; },
  "getPageInfo": function() { return /* reexport */ getPageInfo; },
  "getPageLevelScriptsAndStyles": function() { return /* reexport */ getPageLevelScriptsAndStyles; },
  "getParamFromUrl": function() { return /* reexport */ getParamFromUrl; },
  "getParamsFromUrl": function() { return /* reexport */ getParamsFromUrl; },
  "getPasswordRegExp": function() { return /* reexport */ getPasswordRegExp; },
  "getPathFromUrl": function() { return /* reexport */ getPathFromUrl; },
  "getPaymentFailureMessage": function() { return /* binding */ getPaymentFailureMessage; },
  "getPdpUrlParams": function() { return /* reexport */ getPdpUrlParams; },
  "getPresetThumbnailUrl": function() { return /* reexport */ getPresetThumbnailUrl; },
  "getPresetUrl": function() { return /* reexport */ getPresetUrl; },
  "getPriceSortQuery": function() { return /* binding */ helper_getPriceSortQuery; },
  "getProcessedProductInfoBasedOnLineItems": function() { return /* reexport */ getProcessedProductInfoBasedOnLineItems; },
  "getProductDetails": function() { return /* binding */ getProductDetails; },
  "getPureText": function() { return /* reexport */ getPureText; },
  "getRandom": function() { return /* reexport */ getRandom; },
  "getScriptsAndStyles": function() { return /* binding */ helper_getScriptsAndStyles; },
  "getSelectedSort": function() { return /* binding */ helper_getSelectedSort; },
  "getShippingDiscountPromoCodes": function() { return /* reexport */ getShippingDiscountPromoCodes; },
  "getShortenedUrl": function() { return /* reexport */ getShortenedUrl; },
  "getShortenedUrlwithGeneral": function() { return /* binding */ helper_getShortenedUrlwithGeneral; },
  "getSiteWideModal": function() { return /* reexport */ getSiteWideModal; },
  "getSortFromUrl": function() { return /* reexport */ getSortFromUrl; },
  "getSortItemBasedOnURL": function() { return /* binding */ helper_getSortItemBasedOnURL; },
  "getStateCode": function() { return /* reexport */ getStateCode; },
  "getStateCodeValue": function() { return /* binding */ getStateCodeValue; },
  "getSwatchCount": function() { return /* reexport */ getSwatchCount; },
  "getUpSellAuthData": function() { return /* reexport */ getUpSellAuthData; },
  "getUser": function() { return /* reexport */ getUser; },
  "getUserAnalyticsObject": function() { return /* binding */ helper_getUserAnalyticsObject; },
  "getUserIP": function() { return /* reexport */ getUserIP; },
  "getUserPersona": function() { return /* binding */ helper_getUserPersona; },
  "handleEnter": function() { return /* reexport */ handleEnter; },
  "handleModelNumberSuggestion": function() { return /* reexport */ handleModelNumberSuggestion; },
  "handleZipDownload": function() { return /* reexport */ handleZipDownload; },
  "handleZipcodeSet": function() { return /* reexport */ handleZipcodeSet; },
  "hasComponentType": function() { return /* reexport */ hasComponentType; },
  "hasNumber": function() { return /* reexport */ hasNumber; },
  "hourDifference": function() { return /* reexport */ hourDifference; },
  "isAuth": function() { return /* reexport */ isAuth; },
  "isAuthenticated": function() { return /* reexport */ isAuthenticated; },
  "isColorFacet": function() { return /* reexport */ isColorFacet; },
  "isElementExcluded": function() { return /* reexport */ isElementExcluded; },
  "isEmbeddedElement": function() { return /* reexport */ isEmbeddedElement; },
  "isEmbeddedStyles": function() { return /* reexport */ isEmbeddedStyles; },
  "isGuestTokenValid": function() { return /* reexport */ isGuestTokenValid; },
  "isPartsPage": function() { return /* reexport */ isPartsPage; },
  "isPriceZero": function() { return /* binding */ helper_isPriceZero; },
  "isPromoAllowed": function() { return /* binding */ isPromoAllowed; },
  "isProtectedUrl": function() { return /* reexport */ isProtectedUrl; },
  "isShowAnalyticsEventLoaded": function() { return /* reexport */ isShowAnalyticsEventLoaded; },
  "isUrlIncludeHttp": function() { return /* reexport */ isUrlIncludeHttp; },
  "isValidName": function() { return /* binding */ isValidName; },
  "isValidPincode": function() { return /* binding */ isValidPincode; },
  "jsonStringEscape": function() { return /* reexport */ jsonStringEscape; },
  "mapStateToCountryHandler": function() { return /* binding */ helper_mapStateToCountryHandler; },
  "navigationType": function() { return /* reexport */ navigationType; },
  "nbspSanitizeInnerHtml": function() { return /* reexport */ nbspSanitizeInnerHtml; },
  "organizeData": function() { return /* reexport */ organizeData; },
  "pdpTypeFormat": function() { return /* binding */ helper_pdpTypeFormat; },
  "performRedirect": function() { return /* reexport */ performRedirect; },
  "phoneFormat": function() { return /* binding */ phoneFormat; },
  "preventBodyScroll": function() { return /* reexport */ preventBodyScroll; },
  "preventBodyScrollTab": function() { return /* reexport */ preventBodyScrollTab; },
  "pushAnalyticsObjToDataLayer": function() { return /* reexport */ pushAnalyticsObjToDataLayer; },
  "randomWholeNumber": function() { return /* binding */ randomWholeNumber; },
  "recalculateCartRoomInfo": function() { return /* reexport */ recalculateCartRoomInfo; },
  "redirect": function() { return /* binding */ redirect; },
  "removeAndCleanLink": function() { return /* binding */ helper_removeAndCleanLink; },
  "removeAndCleanLinkConcat": function() { return /* binding */ removeAndCleanLinkConcat; },
  "removeFavorites": function() { return /* reexport */ removeFavorites; },
  "removePathandHtml": function() { return /* reexport */ removePathandHtml; },
  "removeSearchQueryParams": function() { return /* reexport */ removeSearchQueryParams; },
  "replaceAndFunction": function() { return /* reexport */ replaceAndFunction; },
  "replaceSearchUrl": function() { return /* reexport */ replaceSearchUrl; },
  "resetFilterUrl": function() { return /* reexport */ resetFilterUrl; },
  "resetUrl": function() { return /* reexport */ resetUrl; },
  "retainSearchQueryParams": function() { return /* reexport */ retainSearchQueryParams; },
  "revalidateTime": function() { return /* reexport */ revalidateTime; },
  "sanitizeAndDecodeHtml": function() { return /* reexport */ sanitizeAndDecodeHtml; },
  "sanitizeDOMString": function() { return /* reexport */ helper_sanitizeDOMString; },
  "sanitizeInnerHtml": function() { return /* binding */ helper_sanitizeInnerHtml; },
  "sanitizeObject": function() { return /* reexport */ sanitizeObject; },
  "sanitizeProductName": function() { return /* reexport */ sanitizeProductName; },
  "sanitizeText": function() { return /* reexport */ sanitizeText; },
  "sanitizeTextArticle": function() { return /* reexport */ sanitizeTextArticle; },
  "sanitizeTextForAnalytics": function() { return /* binding */ helper_sanitizeTextForAnalytics; },
  "sanitizeUrl": function() { return /* reexport */ sanitizeUrl; },
  "scrollToElement": function() { return /* reexport */ scrollToElement; },
  "setBannerConfirmationText": function() { return /* binding */ setBannerConfirmationText; },
  "setFocus": function() { return /* reexport */ setFocus; },
  "setLoaderText": function() { return /* binding */ setLoaderText; },
  "setWindowProps": function() { return /* reexport */ setWindowProps; },
  "shaEncrypt": function() { return /* reexport */ shaEncrypt; },
  "showNewBadge": function() { return /* reexport */ showNewBadge; },
  "smoothScroll": function() { return /* reexport */ smoothScroll; },
  "sortParameterURL": function() { return /* reexport */ sortParameterURL; },
  "stateCodeToName": function() { return /* binding */ stateCodeToName; },
  "storeFilterData": function() { return /* reexport */ storeFilterData; },
  "toggeleBodyScroll": function() { return /* reexport */ toggeleBodyScroll; },
  "truncateString": function() { return /* binding */ truncateString; },
  "updateAnalyticPageUrl": function() { return /* reexport */ updateAnalyticPageUrl; },
  "updateHeader": function() { return /* reexport */ updateHeader; },
  "updateObject": function() { return /* binding */ helper_updateObject; },
  "validateField": function() { return /* reexport */ validateField; },
  "validatePassword": function() { return /* reexport */ validatePassword; },
  "validatePhone": function() { return /* reexport */ validatePhone; }
});

// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./node_modules/js-file-download/file-download.js
var file_download = __webpack_require__(35823);
var file_download_default = /*#__PURE__*/__webpack_require__.n(file_download);
// EXTERNAL MODULE: ./node_modules/content-disposition/index.js
var content_disposition = __webpack_require__(67389);
var content_disposition_default = /*#__PURE__*/__webpack_require__.n(content_disposition);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./store/index.js + 1 modules
var store_0 = __webpack_require__(45094);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(65885);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./js/helperV2.js + 1 modules
var helperV2 = __webpack_require__(83699);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./src/constants/regex.js
var regex = __webpack_require__(71990);
// EXTERNAL MODULE: ./src/utils/index.js
var src_utils = __webpack_require__(33185);
;// CONCATENATED MODULE: ./src/public/redirect/redirectmap.json
var redirectmap_namespaceObject = JSON.parse('{"301":{"/toiletpartsbook":"https://kohler.dirxion.com/toiletserviceparts/Toilet-Service-Parts/1/","/en/locations/michigan":"/en/locations","/en/locations/massachusetts/natick":"/en/locations/massachusetts/natick/kohler-signature-store-by-supply-new-england","/en/locations/texas":"/en/locations","/en/locations/texas/dallas":"/en/locations/texas/dallas/kohler-signature-store-by-facets-of-dallas","/en/locations/maryland/bethesda":"/en/locations/maryland/bethesda/kohler-signature-store-by-grof-usa","/en/for-professionals":"/en/for-professionals/tools-and-resources","/en/locations/british-columbia/vancouver":"/en/locations/british-columbia/vancouver/kohler-signature-store-by-emco-corporation","/en/products/cross-category/one-bathroom-two-budget":"/en/inspiration/one-bathroom-two-budgets","/en/locations/connecticut/westport":"/en/locations/connecticut/westport/kohler-signature-store-by-plimpton-and-hills","/en/locations/massachusetts":"/en/locations","/en/locations/kansas":"/en/locations","/en/locations/connecticut":"/en/locations","/en/products/water-filtration":"/en/products/water-filtration/shop-water-filtration","/en/locations/new-york/manhasset":"/en/locations/new-york/manhasset/kohler-signature-store-by-general-plumbing-supply","/en/locations/arizona":"/en/locations","/en/locations/california/torrance":"/en/locations/california/torrance/kohler-signature-store-by-design-services","/en/locations/pennsylvania/king-of-prussia":"/en/locations/pennsylvania/king-of-prussia/kohler-signature-store-by-hajoca-supply","/en/locations/california/irvine":"/en/locations/california/irvine/kohler-signature-store-by-hajoca","/en/locations/california/culver-city":"/en/locations/california/culver-city/kohler-signature-store","/en/locations/maryland":"/en/locations","/en/locations/new-jersey":"/en/locations","/en/locations/washington":"/en/locations","/en/locations/florida/south-miami":"/en/locations/florida/south-miami/kohler-signature-store-by-wool-supply","/en/my-account":"/en/my-account/account-settings","/en/locations/illinois":"/en/locations","/en/locations/new-york":"/en/locations","/en/locations/missouri":"/en/locations","/en/locations/oregon/portland":"/en/locations/oregon/portland/kohler-signature-store-by-keller-supply","/en/locations/british-columbia":"/en/locations","/en/locations/virginia":"/en/locations","/en/locations/pennsylvania":"/en/locations","/en/products/samples":"/en","/en/products/cross-category/statement-and-anthem":"/en/inspiration/ultimate-shower-experience-anthem-statement","/en/locations/wisconsin/milwaukee":"/en/locations/wisconsin/milwaukee/kohler-signature-store-by-first-supply","/en/locations/washington/seattle":"/en/locations/washington/seattle/kohler-signature-store-by-keller-supply","/en/locations/kansas/overland-park":"/en/locations/kansas/overland-park/kohler-signature-store-by-first-supply","/qrktank1":"https://www.us.kohler.com/webassets/kpna/catalog/pdf/en/1175975-5.pdf","/en/locations/michigan/detroit":"/en/locations/michigan/detroit/kohler-signature-store-by-first-supply","/en/locations/wisconsin":"/en/locations","/en/locations/indiana/indianapolis":"/en/locations/indiana/indianapolis/kohler-signature-store-by-crescent-supply","/en/products/bathroom-accessories":"/en/products/bathroom-accessories/shop-bathroom-accessories","/en/locations/california/west-hollywood":"/en/locations/california/west-hollywood/kohler-experience-center-by-expressions-home-gallery","/en/products/cross-category/jennifer-gizzi":"/en/inspiration/jennifer-gizzi-interview-making-pretty-spaces","/en/locations/connecticut/greenwich":"/en/locations/connecticut/greenwich/kohler-signature-store-by-plimpton-and-hills","/en/locations/colorado":"/en/locations","/en/locations/minnesota/edina":"/en/locations/minnesota/edina/kohler-signature-store-by-first-supply","/en/products/cleaners":"/en/support/how-to-use-kohler-cleaning-products","/en/locations/new-jersey/paramus":"/en/locations/new-jersey/paramus/kohler-signature-store-by-general-plumbing-supply","/en/locations/missouri/saint-louis":"/en/locations/missouri/saint-louis/kohler-signature-store-by-crescent-supply","/en/locations/georgia/alpharetta":"/en/locations/georgia/alpharetta/kohler-signature-store-by-pdi","/en/locations/massachusetts/boston":"/en/locations/massachusetts/boston/kohler-signature-store-by-supply-new-england","/redirects-testing":"/content/kohler/us/en/products/lighting/shop-chandelier-lighting.html","/en/products/cross-category/anthony-carrino":"/en/inspiration/anthony-carrino-designs-breathe-new-life-into-historical-firehouse","/en/locations/colorado/denver":"/en/locations/colorado/denver/kohler-signature-store-by-facets-of-cherry-creek","/en/support/find-a-service-part/shop-parts":"/en/support/find-a-service-part","/en/locations/indiana":"/en/locations","/en/locations/massachusetts/burlington":"/en/locations/massachusetts/burlington/kohler-signature-store-by-supply-new-england","/en/locations/georgia/atlanta":"/en/locations/georgia/atlanta/kohler-signature-store-by-pdi","/en/locations/texas/austin":"/en/locations/texas/austin/kohler-signature-store-by-facets-of-austin","/en/products/cross-category/epd":"/en/for-professionals/environmental-product-declaration","/en/locations/new-jersey/jersey-shore":"/en/locations/new-jersey/jersey-shore/kohler-signature-store-by-general-plumbing-supply","/en/locations/minnesota":"/en/locations","/en/locations/arizona/scottsdale":"/en/locations/arizona/scottsdale/kohler-signature-store-by-hughes-supply","/en/locations/ontario/toronto":"/en/locations/ontario/toronto/kohler-signature-store-by-emco","/en/locations/virginia/sterling":"/en/locations/virginia/sterling/kohler-signature-store-by-grof","/en/locations/california":"/en/locations","/en/locations/florida":"/en/locations","/en/help":"/en/support","/en/locations/illinois/chicago":"/en/locations/illinois/chicago/kohler-signature-store-by-studio41","/en/locations/oregon":"/en/locations","/en/locations/maryland/baltimore":"/en/locations/missouri/saint-louis/kohler-signature-store-by-crescent-supply","/en/locations/georgia":"/en/locations","/en/products/kitchen-accessories":"/en/products/kitchen-accessories/shop-kitchen-accessories","/en/locations/new-york/new-york-city":"/en/locations/new-york/new-york-city/kohler-experience-center-by-best-plumbing-supply","/en/locations/ontario":"/en/locations"},"shortendPagePath":"/content/kohler/us","Vanity":{"/content/kohler/test123":"/test456","/testkohler":"/content/kohler/us/en.html","/vanitykohler":"/content/kohler/us/en/inspiration/design-trends.html"},"file_last_updated_on":"Fri, 15 Sep 2023 05:45:28 GMT"}');
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(5702);
;// CONCATENATED MODULE: ./src/utils/helper.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);























const isServer = "object" === "undefined";
const getMyLocation = ()=>{
    return new Promise((resolve, reject)=>{
        (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
            navigator.geolocation.getCurrentPosition(async (position)=>{
                try {
                    const res = await getCurrentLocationLatLng(position);
                    var _city, _zipcode;
                    resolve({
                        city: (_city = res.city) !== null && _city !== void 0 ? _city : "",
                        zipcode: (_zipcode = res.zipcode) !== null && _zipcode !== void 0 ? _zipcode : ""
                    });
                } catch (e) {
                    const errorCause = {
                        title: get_default()(CONFIG, "general.geoLocationErrorTitle", "").trim(),
                        message: get_default()(CONFIG, "general.geoLocationErrorMessage", "").trim(),
                        ctaLink: get_default()(CONFIG, "general.geoLocationErrorCtaLink", "").trim(),
                        ctaLabel: get_default()(CONFIG, "general.geoLocationErrorCtaLabel", "").trim()
                    };
                    reject(new Error("Location Error", {
                        cause: errorCause
                    }));
                }
            }, (e)=>{
                const errorCause = {
                    title: get_default()(CONFIG, "general.geoLocationErrorTitle", "").trim(),
                    message: get_default()(CONFIG, "general.geoLocationErrorMessage", "").trim(),
                    ctaLink: get_default()(CONFIG, "general.geoLocationErrorCtaLink", "").trim(),
                    ctaLabel: get_default()(CONFIG, "general.geoLocationErrorCtaLabel", "").trim()
                };
                reject(new Error("Location Error", {
                    cause: errorCause
                }));
            });
        });
    });
};
const helper_getMyCity = async (reverseGeo, lat, long)=>{
    const { general  } = await (0,constants_config/* getConfig */.i)();
    var _siteName;
    const siteName = (_siteName = general.siteName) !== null && _siteName !== void 0 ? _siteName : "";
    try {
        const res = await api/* apim.get */.TH.get(reverseGeo, {
            params: {
                $format: "json",
                brand: siteName.toLowerCase(),
                lat: lat,
                long: long
            }
        });
        const response = res.data.resourceSets[0].resources[0].address;
        return {
            city: get_default()(response, "adminDistrict2", ""),
            zipcode: get_default()(response, "postalCode", "")
        };
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Fetching City failed", err);
    }
};
const helper_getApiServletPath = async ()=>{
    const CONFIG = await (0,constants_config/* getConfig */.i)();
    const res = CONFIG.apiEndpoints;
    return {
        findStores: get_default()(res, "findStores", ""),
        reverseGeo: get_default()(res, "reverseGeo", ""),
        findStoresBingKey: get_default()(res, "findStoresBingKey", "")
    };
};
const getCurrentLocationLatLng = async (position)=>{
    const getReverseGeo = await helper_getApiServletPath();
    var _reverseGeo;
    const reverseGeoLink = (_reverseGeo = getReverseGeo.reverseGeo) !== null && _reverseGeo !== void 0 ? _reverseGeo : "";
    let getCityData = {};
    try {
        const lat = localStorage.getItem("latitude");
        const lng = localStorage.getItem("longitude");
        const cityData = localStorage.getItem("cityData");
        const locationTimeout = localStorage.getItem("locationTimeout");
        if (parseFloat(lat) === position.coords.latitude && parseFloat(lng) === position.coords.longitude && cityData && locationTimeout && moment_default()().isBefore(moment_default()(locationTimeout))) {
            getCityData = JSON.parse(cityData);
        } else {
            getCityData = await helper_getMyCity(reverseGeoLink, position.coords.latitude, position.coords.longitude);
            const localStorageData = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                cityData: JSON.stringify(getCityData),
                locationTimeout: moment_default()().add("30", "minutes").toISOString(true)
            };
            helper_setLocalStorageData(localStorageData);
        }
    } catch (err) {
        helper_clearLocalStorageData("latitude", "longitude", "cityData", "locationTimeout");
    }
    return {
        city: get_default()(getCityData, "city", ""),
        zipcode: get_default()(getCityData, "zipcode", "")
    };
};
const helper_clearLocalStorageData = function() {
    for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++){
        keys[_key] = arguments[_key];
    }
    keys.forEach((key)=>{
        localStorage.removeItem(key);
    });
};
const helper_setLocalStorageData = (localStorageData)=>{
    for (const [key, value] of Object.entries(localStorageData)){
        localStorage.setItem(key, value);
    }
};
const getMyLocationByUserIP = async ()=>{
    const response = await getUserIP();
    var _city, _zipcode;
    return {
        city: (_city = response.city) !== null && _city !== void 0 ? _city : "",
        zipcode: (_zipcode = response.zipcode) !== null && _zipcode !== void 0 ? _zipcode : ""
    };
};
const getUserIP = async ()=>{
    var ref, ref1, ref2, ref3;
    const res = await (0,utils_location/* getLocationUsingIP */.XD)();
    var ref4, ref5;
    return {
        city: (ref4 = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.C) !== null && ref4 !== void 0 ? ref4 : "",
        zipcode: (ref5 = res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.Z) !== null && ref5 !== void 0 ? ref5 : ""
    };
};
const getLocationByCookies = async ()=>{
    var ref;
    const userLocation = ((ref = document.cookie.match("(^|;)\\s*userLocation\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
    let getCityData = {};
    if (userLocation !== "") {
        try {
            const splitLocation = userLocation.split("+");
            const lat = localStorage.getItem("cookiesLatitude");
            const lng = localStorage.getItem("cookiesLongitude");
            const cityData = localStorage.getItem("cookiesCityData");
            const locationTimeout = localStorage.getItem("cookiesLocationTimeout");
            if (parseFloat(lat) === splitLocation[4] && parseFloat(lng) === splitLocation[5] && cityData && locationTimeout && moment().isBefore(moment(locationTimeout))) {
                getCityData = JSON.parse(cityData);
            } else {
                const getReverseGeo = await helper_getApiServletPath();
                var _reverseGeo;
                const reverseGeoLink = (_reverseGeo = getReverseGeo.reverseGeo) !== null && _reverseGeo !== void 0 ? _reverseGeo : "";
                getCityData = await helper_getMyCity(reverseGeoLink, splitLocation[4], splitLocation[5]);
                const localStorageData = {
                    cookiesLatitude: splitLocation[4],
                    cookiesLongitude: splitLocation[5],
                    cookiesCityData: JSON.stringify(getCityData),
                    cookiesLocationTimeout: moment().add("30", "minutes").toISOString(true)
                };
                helper_setLocalStorageData(localStorageData);
            }
        } catch (err) {
            helper_clearLocalStorageData("cookiesLatitude", "cookiesLongitude", "cookiesCityData", "cookiesLocationTimeout");
        }
    }
    return {
        city: _get(getCityData, "city", ""),
        zipcode: _get(getCityData, "zipcode", "")
    };
};
const sanitizeInnerHtml = function(property) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0,html_react_parser/* default */.ZP)("".concat(browser_default().sanitize(property, {
        ADD_ATTR: [
            "target"
        ]
    })), options);
};
const customSanitizeInnerHtml = (property)=>(0,html_react_parser/* default */.ZP)("".concat(browser_default().sanitize(property, {
        ADD_ATTR: [
            "target",
            "frameborder",
            "scrolling",
            "allowfullscreen",
            "height",
            "src",
            "width"
        ],
        ALLOWED_TAGS: [
            "iframe",
            "p"
        ]
    })));
const formatPhoneNumber = (phoneNumberString)=>{
    const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return null;
};
const validatePassword = async (password, userData)=>{
    const regexObj = await getPasswordRegExp();
    const regex = new RegExp(regexObj.regex);
    const data = userData.filter((el)=>el.length > 0);
    if (password.length < 10) return false;
    if (!regex.test(password)) return false;
    if (data.some((vl)=>password.toLowerCase().includes(vl.toLowerCase()))) {
        if (!password.match(/(?=.*[A-Z])/)) {
            return false;
        }
    }
    return true;
};
const validateField = async (field, value)=>{
    const { regexPattern  } = await (0,constants_config/* getConfig */.i)();
    const pattern = get_default()(regexPattern, "map.".concat(field), "");
    const regex = new RegExp(pattern);
    return !!regex.test(value);
};
const addToRecentSearch = (keyword)=>{
    if (keyword && keyword.length > 2) {
        var ref;
        let history1 = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
        history1 = history1.filter((item)=>item.keyWord.toLowerCase() !== keyword.toLowerCase());
        history1.unshift({
            keyWord: keyword,
            id: Date.now()
        });
        window.localStorage.setItem("keyWordList", JSON.stringify(history1));
    }
};
const navigationType = ()=>{
    let result;
    let p;
    if (window.performance.getEntriesByType("navigation")) {
        p = window.performance.getEntriesByType("navigation")[0].type;
        if (p === "navigate") result = 0;
        if (p === "reload") result = 1;
        if (p === "back_forward") result = 2;
        if (p === "prerender") result = 3;
    }
    return result;
};
const getParamFromUrl = function(param) {
    let urlLocation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const url = new URL(urlLocation || location.href);
    var ref;
    const appliedSort = (ref = url.searchParams.get(param)) !== null && ref !== void 0 ? ref : "";
    return appliedSort.includes("%2B") ? appliedSort.replaceAll("%2B", "+") : appliedSort.replaceAll(" ", "+");
};
const smoothScroll = (element)=>element.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest"
    });
const getClienIP = (request)=>{
    let ip = "";
    if (!request) return ip;
    if (request.headers["IpAddress"]) {
        ip = request.headers["IpAddress"].split(",")[0];
    } else if (request.headers["true-ip"]) {
        ip = request.headers["true-ip"].split(",")[0];
    } else if (request.headers["x-forwarded-for"]) {
        ip = request.headers["x-forwarded-for"].split(",")[0];
    } else if (request.headers["x-real-ip"]) {
        ip = request.connection.remoteAddress;
    } else {
        ip = request.connection.remoteAddress || "";
    }
    return ip;
};
const isProtectedUrl = async (url)=>{
    const CONFIG = await (0,constants_config/* getConfig */.i)();
    const { commerce: { sessionAuth: { securePagePathList  }  }  } = CONFIG;
    const curUrl = url !== null && url !== void 0 ? url : window.location.pathname;
    return securePagePathList.includes(curUrl);
};
const updateHeader = function(token) {
    let isAuth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const authHeader = "Bearer ".concat(token);
    api/* apim.defaults.headers.common.Authorization */.TH.defaults.headers.common.Authorization = authHeader;
// if (isAuth) {
//   clearTimeout(refreshTimer)
//   setTimeout(() => {
//     addPageLoadAnalyticsEvent()
//   }, 2000)
//   return
// }
// addPageLoadAnalyticsEvent()
// renewAnonymousTokenBeforeExpiry(token.access_token)
};
// eslint-disable-next-line require-jsdoc
function debounce(func) {
    let timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    var _this = this;
    let timer;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clearTimeout(timer);
        timer = setTimeout(()=>{
            // eslint-disable-next-line no-invalid-this
            func.apply(_this, args);
        }, timeout);
    };
}
const shaEncrypt = async (message)=>{
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);
    // hash the message
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    // convert bytes to hex string
    const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, "0")).join("");
    // return a promise
    return hashHex;
};
const caesarEncrypt = (salt, text)=>{
    const textToChars = (text)=>text.split("").map((c)=>c.charCodeAt(0));
    const byteHex = (n)=>("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = (code)=>textToChars(salt).reduce((a, b)=>a ^ b, code);
    return text.split("").map(textToChars).map(applySaltToChar).map(byteHex).join("");
};
const helper_caesarDecrypt = (salt, encoded)=>{
    const textToChars = (text)=>text.split("").map((c)=>c.charCodeAt(0));
    const applySaltToChar = (code)=>textToChars(salt).reduce((a, b)=>a ^ b, code);
    return encoded.match(/.{1,2}/g).map((hex)=>parseInt(hex, 16)).map(applySaltToChar).map((charCode)=>String.fromCharCode(charCode)).join("");
};
const getPasswordRegExp = async ()=>{
    const { regex  } = await (0,constants_config/* getConfig */.i)();
    var _regex, _conditionsList;
    return {
        regex: (_regex = regex.regex) !== null && _regex !== void 0 ? _regex : "",
        passwordMessage: (_conditionsList = regex.conditionsList) !== null && _conditionsList !== void 0 ? _conditionsList : []
    };
};
const getUserAnalyticsObject = function() {
    let isFromRegisterUser = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref, ref1, ref2, ref3, ref4, ref5;
    const hashedEmail = localStorage.getItem("hashedEmail") || ((ref = store === null || store === void 0 ? void 0 : store.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.hashedEmail) || "";
    const customerProspect = localStorage.getItem("customerProspect") || ((ref2 = store === null || store === void 0 ? void 0 : store.getState()) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.auth) === null || ref3 === void 0 ? void 0 : ref3.customerProspect);
    let isCustomerOrProspect = "n/a";
    if (hashedEmail && customerProspect) {
        try {
            const decryptedJSON = JSON.parse(helper_caesarDecrypt(hashedEmail, customerProspect));
            if (decryptedJSON.pastOrders.length) {
                isCustomerOrProspect = "customer";
            } else {
                isCustomerOrProspect = "prospect";
            }
        } catch (es) {
            // eslint-disable-next-line no-console
            console.log("decrypt error: ", es);
        }
    }
    // this user object should be updated when user log in or out.
    const user = {
        gId: "n/a",
        abTestName: "n/a",
        adBlocker: false,
        authStatus: "anonymous",
        commerceToolsID: "n/a",
        customerProspect: isCustomerOrProspect,
        envName: "development",
        knownStatus: "unknown",
        profileRole: "guest",
        returningStatus: "new visitor",
        emailId: hashedEmail || "n/a"
    };
    // fetch okta tokens for both logged in and anonymous users
    const oktaToken = localStorage.getItem("okta-token-storage");
    const anonymousOktaToken = localStorage.getItem("okta-anonymous-access-token") || ((ref4 = store === null || store === void 0 ? void 0 : store.getState()) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.auth) === null || ref5 === void 0 ? void 0 : ref5.access_token);
    if (oktaToken && oktaToken !== "{}") {
        var ref6;
        // user is logged in
        const oktaObject = JSON.parse(oktaToken);
        const claim = (oktaObject === null || oktaObject === void 0 ? void 0 : (ref6 = oktaObject.accessToken) === null || ref6 === void 0 ? void 0 : ref6.claims) || {};
        // user.uId = claim.uid || "n/a";
        claim.businessType === "Consumer" ? user.profileRole = "consumer" : user.profileRole = "professional";
        user.commerceToolsID = claim.commercetoolsID || "n/a";
        if (!isFromRegisterUser) {
            user.returningStatus = "returning customer";
        }
        user.authStatus = "logged in";
        user.knownStatus = "known";
    } else if (anonymousOktaToken) {
        // anonymous user
        let oktaObject1;
        try {
            oktaObject1 = JSON.parse(atob(anonymousOktaToken.split(".")[1])) || {};
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Anonymous Okta Token can not be decoded......");
        }
        if (oktaObject1) {
            user.gId = oktaObject1.gId || "n/a";
        }
    }
    return user;
};
const isElementExcluded = (e, classNames)=>{
    const path = e.path || e.composedPath && e.composedPath();
    return path.some((element)=>{
        return classNames.some((className)=>{
            var ref;
            return element === null || element === void 0 ? void 0 : (ref = element.className) === null || ref === void 0 ? void 0 : ref.includes(className);
        });
    });
};
const clearAuthToken = ()=>{
    localStorage.removeItem("hashedEmail");
    localStorage.removeItem("customerProspect");
    localStorage.removeItem("okta-cache-storage");
    localStorage.removeItem("okta-anonymous-access-token");
    localStorage.removeItem("anonymousId");
    const cookies = new Cookie();
    cookies.remove("commerce_gid", {
        path: "/",
        domain: ".kohler.com"
    });
};
const clearAnonymousToken = ()=>{
    localStorage.removeItem("anonymousId");
    localStorage.removeItem("okta-anonymous-access-token");
    localStorage.removeItem("okta-anonymous-refresh-token");
    localStorage.removeItem("token-revalidate-expiry");
    const cookies = new Cookie();
    cookies.remove("commerce_gid", {
        path: "/",
        domain: ".kohler.com"
    });
};
const SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi;
/** A pattern that matches safe data URLs. It only matches image, video, and audio types. */ const DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;
const _sanitizeUrl = (url)=>{
    url = String(url);
    if (url === "null" || url.length === 0 || url === "about:blank") return "about:blank";
    if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN)) return url;
    return "unsafe:".concat(url);
};
const sanitizeUrl = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "about:blank";
    return _sanitizeUrl(String(url).trim());
};
const revalidateTime = ()=>moment_default()().add(30, "m").format();
const getPDPUrl = async (category, slug)=>{
    const { plpServletPath , general  } = await getConfig();
    const pdpUrl = gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const getPDPUrlForProductTile = async (data)=>{
    var _ProductLocalCategory_s;
    const category = data.Product_Category ? data.Product_Category : (_ProductLocalCategory_s = data.ProductLocalCategory_s) !== null && _ProductLocalCategory_s !== void 0 ? _ProductLocalCategory_s : "";
    const slug = data.slug_s;
    const { plpServletPath , general  } = await getConfig();
    const pdpUrl = gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const getPDPUrlWithConfig = (category, slug, plpServletPath, general)=>{
    const pdpUrl = gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const gePDPUrlPageDetails = (plpServletPath, general, category, slug)=>{
    const path = plpServletPath === null || plpServletPath === void 0 ? void 0 : plpServletPath.find((i)=>i.categories.includes(category));
    var _shortendPagePath;
    const shortUrl = (_shortendPagePath = general.shortendPagePath) !== null && _shortendPagePath !== void 0 ? _shortendPagePath : "";
    if (category === "Design Services") {
        return getShortenedUrlwithGeneral(general.designServiceLandingPath, general);
    }
    if (category === "Install Services") {
        return getShortenedUrlwithGeneral(general.installServiceLandingPath, general);
    }
    if (!category || category === "Service Parts") {
        var ref;
        return "".concat((ref = general.servicePartsLandingPath) === null || ref === void 0 ? void 0 : ref.replace(shortUrl, ""), "/").concat(slug);
    }
    if (path) {
        var ref1;
        return "".concat((ref1 = path.url) === null || ref1 === void 0 ? void 0 : ref1.replace(shortUrl, ""), "/").concat(slug);
    }
    return "".concat(getShortenedUrlwithGeneral(general.plpPagePath, general), "/").concat(category === null || category === void 0 ? void 0 : category.replace(/\s&\s|\s/g, "-").toLowerCase(), "/").concat(slug, ".html");
};
const pdpTypeFormat = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { businessUnitName ="" , ProductIsRetail ="" , discontinuedProductb ="" , ProductRequiredAccessoriesGroupsList =[] , superSku =""  } = data;
    let pdpType = "";
    if (businessUnitName === "Service Parts") {
        pdpType = "regular part";
    } else if (ProductIsRetail) {
        pdpType = "retail exclusive";
    } else if (discontinuedProductb) {
        pdpType = "discontinued";
    } else if (ProductRequiredAccessoriesGroupsList.length) {
        pdpType = "regular w/required Items";
    } else if (superSku) {
        pdpType = "super sku";
    } else {
        pdpType = "regular finished Goods";
    }
    return pdpType;
};
const sanitizeTextForAnalytics = function() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const testData = text !== null && text !== void 0 ? text : "";
    return String(testData).replace(regex/* SANITIZE_TEXT_REGEX */.If, "").toLowerCase().trim();
};
const getSwatchCount = function() {
    let isPlp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (!isPlp && window.outerWidth < 1330) {
        return 3;
    } else if (isPlp && window.outerWidth < 812) {
        return 5;
    }
    return isPlp ? 7 : 5;
};
const isColorFacet = (f)=>{
    const facet = f.replace(/^\*{2}/, "");
    return !!(facet === "ColorFinish_s" || facet === "SKUColorFinishName_ss");
};
const getCurrentSkuCouponDiscounts = (param)=>{
    let { sku , cart , locale  } = param;
    var ref, ref1;
    // find if cart-discount is applied to this product
    const discountID = [];
    const discountedAmount = [];
    const productCouponCode = [];
    const comparedList = [];
    const codesList = [];
    const globalDiscountNames = [];
    let productCoupondiscount = 0;
    let globalDiscountValues = 0;
    cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.forEach((lineItem)=>{
        const discountSku = get_default()(lineItem, "variant.sku", null);
        // finding discount details in lineItems
        if (discountSku === sku) {
            get_default()(lineItem, "discountedPrice.includedDiscounts", []).forEach((includedDiscount)=>{
                var ref, ref1;
                if ((includedDiscount === null || includedDiscount === void 0 ? void 0 : (ref = includedDiscount.discount) === null || ref === void 0 ? void 0 : ref.typeId) === "cart-discount" && ((ref1 = includedDiscount.discount.obj) === null || ref1 === void 0 ? void 0 : ref1.id)) {
                    discountID.push(includedDiscount.discount.obj.id);
                    discountedAmount.push(Number((includedDiscount.discountedAmount.centAmount / 100).toFixed(2)));
                    codesList.push(includedDiscount.discount.obj.name[locale]);
                }
            });
        }
    });
    if (discountID.length && (cart === null || cart === void 0 ? void 0 : (ref1 = cart.discountCodes) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        // we got discount id from lineItems, now get discount code from discountCodes
        cart === null || cart === void 0 ? void 0 : cart.discountCodes.forEach((discountCode)=>{
            var ref, ref1;
            if (discountCode === null || discountCode === void 0 ? void 0 : (ref = discountCode.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.code) {
                var ref2;
                (ref2 = discountCode.discountCode.obj.cartDiscounts) === null || ref2 === void 0 ? void 0 : ref2.forEach((cartDiscount)=>{
                    const matchingIndex = discountID.indexOf(cartDiscount.id);
                    if (matchingIndex !== -1 && cartDiscount.typeId === "cart-discount") {
                        // copy discount code of this discountCode object
                        productCouponCode.push(discountCode.discountCode.obj.code);
                        productCoupondiscount += discountedAmount[matchingIndex];
                        comparedList.push(cartDiscount.id);
                    }
                });
            }
        });
    }
    discountID.filter((a)=>!comparedList.includes(a)).forEach((a)=>{
        const matchedIndex = discountID.indexOf(a);
        if (matchedIndex >= 0) {
            globalDiscountNames.push(codesList[matchedIndex]);
            globalDiscountValues += discountedAmount[matchedIndex];
        }
    });
    productCoupondiscount = Number(productCoupondiscount.toFixed(2));
    return {
        productCouponCode,
        productCoupondiscount,
        globalDiscountNames,
        globalDiscountValues
    };
};
const destructureAddress = (addr, siteName)=>{
    const data = {
        address: "",
        city: "",
        state: "",
        zipcode: ""
    };
    var ref;
    data.address = (ref = addr.split(",")[0]) !== null && ref !== void 0 ? ref : "";
    if (siteName === "kohler-canada") {
        var ref1, ref2, ref3;
        var ref4;
        const address = (ref4 = addr.split(",")) !== null && ref4 !== void 0 ? ref4 : "";
        var ref5;
        data.city = (ref5 = (ref1 = address[1]) === null || ref1 === void 0 ? void 0 : ref1.trim()) !== null && ref5 !== void 0 ? ref5 : "";
        var ref6;
        data.state = (ref6 = (ref2 = address[2]) === null || ref2 === void 0 ? void 0 : ref2.trim()) !== null && ref6 !== void 0 ? ref6 : "";
        var ref7;
        data.zipcode = (ref7 = (ref3 = address[3]) === null || ref3 === void 0 ? void 0 : ref3.trim()) !== null && ref7 !== void 0 ? ref7 : "";
    } else {
        var ref8;
        const addrLine2 = (ref8 = addr.split(",")[1]) !== null && ref8 !== void 0 ? ref8 : "";
        const splitAddress = addrLine2.split(" ");
        var ref9;
        const len = (ref9 = splitAddress === null || splitAddress === void 0 ? void 0 : splitAddress.length) !== null && ref9 !== void 0 ? ref9 : 0;
        let addrLine1 = "";
        splitAddress.forEach((item, i)=>{
            if (i < len - 2) addrLine1 = addrLine1 + item + " ";
        });
        if (addrLine2) {
            var ref10;
            data.city = (ref10 = addrLine1 === null || addrLine1 === void 0 ? void 0 : addrLine1.trim()) !== null && ref10 !== void 0 ? ref10 : "";
            var ref11;
            data.state = (ref11 = addrLine2.split(" ")[len - 2]) !== null && ref11 !== void 0 ? ref11 : "";
            var ref12;
            data.zipcode = (ref12 = addrLine2.split(" ")[len - 1]) !== null && ref12 !== void 0 ? ref12 : "";
        }
    }
    return data;
};
const getStateCode = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.code === countryVal)) {
        country = data.find((obj)=>obj.code === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.name === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.code === stateVal)) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.name === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _code;
    return (_code = state.code) !== null && _code !== void 0 ? _code : "";
};
const getCountryCode = (countryVal, data)=>{
    if (data.find((obj)=>obj.code === countryVal)) return countryVal;
    var ref;
    const country = (ref = data.find((obj)=>obj.name === countryVal)) !== null && ref !== void 0 ? ref : {};
    var _code;
    return (_code = country.code) !== null && _code !== void 0 ? _code : "";
};
const extractScriptsFromDOM = (doc, cb)=>{
    const scripts = doc.getElementsByTagName("script");
    for (const script of scripts){
        const scriptItem = {};
        const src = script.getAttribute("src") || "";
        const type = script.getAttribute("type") || "";
        const integrity = script.getAttribute("integrity") || "";
        const charset = script.getAttribute("charset") || "";
        const dataDomainScript = script.getAttribute("data-domain-script") || "";
        if (src) scriptItem.src = src;
        if (charset) scriptItem.charset = charset;
        if (dataDomainScript) scriptItem.dataDomainScript = dataDomainScript;
        if (type) scriptItem.type = type;
        if (integrity) scriptItem.integrity = integrity;
        if (script.innerHTML) scriptItem.innerHTML = script.innerHTML;
        if ("https://www.kohler.com/corporate/include-consent-banner.js" !== src) {
            cb(scriptItem);
        }
    }
};
const extractStylesFromDOM = (doc, cb)=>{
    const styles = doc.getElementsByTagName("style");
    for (const style of styles){
        if (style.innerHTML) cb(style.innerHTML);
    }
};
const extractLinksFromDOM = (doc, cb)=>{
    const links = doc.getElementsByTagName("link");
    for (const link of links){
        cb(link);
    }
};
const extractMetasFromDOM = (doc, cb)=>{
    const metas = doc.getElementsByTagName("meta");
    for (const meta of metas){
        cb(meta);
    }
};
const showNewBadge = (shipmentDate)=>{
    if (shipmentDate) {
        const today = new Date();
        today.setMonth(today.getMonth() - 6);
        if (Date.parse(shipmentDate) > Date.parse(today)) {
            return true;
        }
    }
    return false;
};
const getCompareData = ()=>{
    const { compare  } = store_0/* store.getState */.h.getState();
    return compare;
};
const isAuth = ()=>{
    const { isAuth  } = store_0/* store.getState */.h.getState();
    return isAuth;
};
const getUser = ()=>{
    const { user  } = store_0/* store.getState */.h.getState();
    return user;
};
const getFavouraties = ()=>{
    if (!isServer) {
        const { favorites  } = store_0/* store.getState */.h.getState();
        return favorites === null || favorites === void 0 ? void 0 : favorites.favorites;
    }
    return [];
};
const getDataLayerObj = (datalayerObj)=>{
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setDataLayerObj */.sZ)(datalayerObj));
};
const getScriptsAndStyles = (jsonData)=>{
    const scriptsList = [];
    const stylesList = [];
    const dataRecursion = (jsonData)=>{
        jsonData[":itemsOrder"] && jsonData[":itemsOrder"].map((key, index)=>{
            var ref;
            const jsonItem = jsonData[":items"][key];
            if ((ref = jsonItem[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.EMBED)) {
                const doc = new DOMParser().parseFromString(jsonItem === null || jsonItem === void 0 ? void 0 : jsonItem.script, "text/html");
                extractScriptsFromDOM(doc, (item)=>scriptsList.push(item));
                extractStylesFromDOM(doc, (item)=>stylesList.push(item));
            } else {
                return dataRecursion(jsonItem);
            }
        });
    };
    dataRecursion(jsonData);
    store === null || store === void 0 ? void 0 : store.dispatch(setGlobalScripts(scriptsList));
    store === null || store === void 0 ? void 0 : store.dispatch(setGlobalStyles(stylesList));
    return scriptsList;
};
const hasComponentType = (data, type, cb)=>{
    data[":itemsOrder"] && data[":itemsOrder"].map((key)=>{
        const item = data[":items"][key];
        if (item[":type"].includes(type)) {
            cb && cb();
        } else {
            return hasComponentType(item, type, cb);
        }
    });
};
const isShowAnalyticsEventLoaded = ()=>{
    // this function is used to check if cmp:show event is already loaded or not to avoid duplicate show events
    if (window.adobeDataLayer) {
        let isLoaded = false;
        window.adobeDataLayer.forEach((event)=>{
            if ((event === null || event === void 0 ? void 0 : event.event) === "cmp:show") {
                isLoaded = true;
            }
        });
        return isLoaded;
    }
    return false;
};
const handleForOrderconfirmationCall = ()=>{
    var ref, ref1, ref2;
    if ((window === null || window === void 0 ? void 0 : (ref = window.pageObj) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.primaryCategory) === "order confirmation" && !(window === null || window === void 0 ? void 0 : (ref2 = window.pageObj) === null || ref2 === void 0 ? void 0 : ref2.transaction)) {
        return false;
    }
    return true;
};
let pageLoadAnalyticsTimer;
const addPageLoadAnalyticsEvent = ()=>{
    if (window.adobeDataLayer && window.isShowAnalyticsEvent === true && window.pageObj && !isShowAnalyticsEventLoaded() && window.datalayerTopLoaded && handleForOrderconfirmationCall()) {
        // we need to execute cmp:show event here as it is a first time page
        const page = window.pageObj;
        const { category: { pageType =""  } = {}  } = page;
        if (pageLoadAnalyticsTimer) {
            clearTimeout(pageLoadAnalyticsTimer);
            pageLoadAnalyticsTimer = undefined;
        }
        if (!pageType) {
            pageLoadAnalyticsTimer = setTimeout(()=>addPageLoadAnalyticsEvent(), 500);
            return;
        }
        if (pageType === "pdp" || pageType === "search-results" || pageType === "search") {
            return;
        }
        page.user = localStorage ? getUserAnalyticsObject() : {};
        const otherItems = {};
        if (page.component) {
            otherItems.component = page.component;
        // delete page.component
        }
        if (page.eventInfo) {
            otherItems.eventInfo = page.eventInfo;
        // delete page.eventInfo
        }
        if (page.productInfo) {
            otherItems.productInfo = page.productInfo;
        // delete page.productInfo
        }
        window.adobeDataLayer.push({
            event: "cmp:show",
            page: page,
            ...otherItems
        });
        window.isShowAnalyticsEvent = false;
        delete window.isShowAnalyticsEvent;
    }
};
const handleZipcodeSet = (zipCode, status, message)=>{
    const eventInfo = {
        eventAction: "cart:landing page:order summary:update zip code",
        eventName: "cart:landing page:order summary:update zip code",
        eventMsg: message || "n/a",
        eventStatus: status,
        internalLinkName: "update",
        eventType: "navigation",
        internalLinkPosition: "cart",
        internalLinkType: "cart:" + zipCode,
        internalLinkZoneName: "cart:landing page:order summary",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    if (page.cart) {
        page.cart.zipcode = zipCode;
    }
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getAccessToken = ()=>{
    const { auth: { isAuth , access_token: accessToken = ""  } = {}  } = store_0/* store.getState */.h.getState();
    let token = "";
    if (!isAuth && "object" !== "undefined") {
        token = localStorage.getItem("okta-anonymous-access-token");
    }
    if (!token) token = accessToken;
    if (token) {
        const tokenSplit = token.split(".")[1] || null;
        if (tokenSplit) {
            const { gId , exp  } = JSON.parse(Buffer.from(tokenSplit, "base64"));
            return {
                token,
                gId,
                exp
            };
        } else {
            return {};
        }
    }
    return {
        token
    };
};
const getAnonymousId = ()=>{
    var ref, ref1;
    let anonymousId = "";
    if (true) {
        anonymousId = localStorage.getItem("anonymousId");
    }
    if (!anonymousId) anonymousId = (ref = store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.anonymousId;
    return anonymousId;
};
const isAuthenticated = async (ref, activeTab, isKPN)=>{
    var ref1;
    const { isAuth  } = (ref1 = store_0/* store.getState */.h.getState()) === null || ref1 === void 0 ? void 0 : ref1.auth;
    const { general  } = await (0,constants_config/* getConfig */.i)();
    if (isAuth) {
        if (typeof ref === "function") {
            ref();
            return;
        }
        if (isKPN) {
            const persona = getUserPersona();
            var _homepageUrl;
            if (persona !== "TVS") return window.location.replace(getShortenedUrlwithGeneral((_homepageUrl = general.homepageUrl) !== null && _homepageUrl !== void 0 ? _homepageUrl : "/", general));
        }
        window.location.href = ref;
    } else {
        window.loginCallback = ref;
        store_0/* store.dispatch */.h.dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: !activeTab ? 0 : activeTab
        }));
    }
};
const isGuestTokenValid = ()=>{
    var ref;
    const { isAuth  } = (ref = store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : ref.auth;
    const { exp =""  } = getAccessToken();
    if (!exp) return false;
    if (!isAuth) return moment_default()().isBefore(moment_default().unix(exp).subtract(120, "s"));
    return true;
};
const hourDifference = (date1, date2)=>{
    let diff = (new Date(date2).getTime() - new Date(date1).getTime()) / 1000;
    diff /= 60 * 60;
    return Math.abs(Math.round(diff));
};
const getUserPersona = ()=>{
    if (!isServer) {
        if (process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true") return "ANY";
        const { auth: { isAuth , user: { persona =[]  } = {}  } = {}  } = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState();
        if (isAuth) {
            var ref;
            const personaName = (ref = persona.find((e)=>e.includes(":"))) !== null && ref !== void 0 ? ref : "";
            var ref1;
            return (ref1 = personaName.split(":")[1]) !== null && ref1 !== void 0 ? ref1 : "GST";
        }
    }
    if (process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true") return "ANY";
    return "GST";
};
const createPersonaCookie = ()=>{
    const cookie = new es6/* default */.Z();
    cookie.set("userPersona", getUserPersona(), {
        path: "/"
    });
};
const getAEMPreviewModeCookie = ()=>{
    const cookie = new es6/* default */.Z();
    if (cookie.get("aem-author-preview-mode") && cookie.get("__token__")) {
        return true;
    } else {
        return false;
    }
};
const closePreview = ()=>{
    const cookie = new es6/* default */.Z();
    sessionStorage.removeItem("aem-author-preview-mode");
    cookie.remove("aem-author-preview-mode", {
        path: "/"
    });
    cookie.remove("__token__", {
        path: "/"
    });
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
};
const handleEnter = (e)=>{
    if (e.keyCode === 13) {
        if (e.target.onclick && e.target.tagName !== "BUTTON") {
            e.stopPropagation();
            document.activeElement.click();
        }
    }
};
const setWindowProps = (obj, val)=>{
    if (val) window[obj] = val;
};
const arrayMove = (arr, fromIndex, toIndex)=>{
    const newArr = [
        ...arr
    ];
    const element = newArr.splice(fromIndex, 1)[0];
    newArr.splice(toIndex, 0, element);
    return newArr;
};
const getCurrency = async ()=>{
    const config = await getConfig();
    const { internationalization: { currencyCode ="USD"  } = {}  } = config;
    return currencyCode;
};
const getAnalyticsScript = (analyticsScript)=>{
    if (analyticsScript) {
        store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setAnalyticsScript */.DE)(analyticsScript));
    } else {
        store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setAnalyticsScript */.DE)(""));
    }
};
const getPageLevelScriptsAndStyles = (scriptsAndStyles)=>{
    const scriptsList = [];
    const stylesList = [];
    const metaList = [];
    const linkList = [];
    let bazaarVoice = null;
    const dataRecursion = (scriptsAndStyles)=>{
        const doc = new DOMParser().parseFromString(scriptsAndStyles, "text/html");
        extractScriptsFromDOM(doc, (item)=>{
            var ref;
            const isBv = item === null || item === void 0 ? void 0 : (ref = item.src) === null || ref === void 0 ? void 0 : ref.includes(constants.BAZAAR_VOICE);
            if (isBv) {
                bazaarVoice = item;
            } else {
                scriptsList.push(item);
            }
        });
        extractStylesFromDOM(doc, (item)=>stylesList.push(item));
        extractMetasFromDOM(doc, (item)=>metaList.push(item));
        extractLinksFromDOM(doc, (item)=>linkList.push(item));
    };
    dataRecursion(scriptsAndStyles);
    const pageLevelDetails = {};
    pageLevelDetails["pageScripts"] = scriptsList;
    pageLevelDetails["stylesList"] = stylesList;
    pageLevelDetails["metaList"] = metaList;
    pageLevelDetails["linkList"] = linkList;
    return {
        pageLevelDetails,
        bazaarVoice
    };
};
const checkStock = (backOrder, category)=>{
    return !(!category || backOrder === true || backOrder === "Yes" || category === "Install Services" || category === "Design Services");
};
const checkCartStock = function() {
    let cart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { lineItems =[]  } = cart;
    let valid = true;
    lineItems.filter((item)=>{
        var ref, ref1;
        return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
    }).map((item)=>{
        var ref;
        var ref1;
        const attributes = (ref1 = (ref = item.variant) === null || ref === void 0 ? void 0 : ref.attributes) !== null && ref1 !== void 0 ? ref1 : [];
        const cartItem = {
            quantity: get_default()(item, "quantity", 0),
            backOrder: get_default()(item, "custom.fields.isBackOrderable", false),
            category: get_default()(attributes.find((attr)=>attr.name === "ProductLocalCategory"), "value", "")
        };
        if (valid && checkStock(cartItem.backOrder, cartItem.category)) {
            const channels = Object.values(get_default()(item, "variant.availability.channels", {}));
            if (channels.length > 0) {
                const availableQty = get_default()(channels[0], "availableQuantity", 0);
                if (availableQty < cartItem.quantity) {
                    valid = false;
                }
            }
        }
    });
    return valid;
};
const getCartItemsAnalyticsData = async (cartItems)=>{
    // first parameter should be cartItems
    const { general  } = await (0,constants_config/* getConfig */.i)();
    const data = {
        item: []
    };
    cartItems.forEach((item)=>{
        var ref, ref1;
        const siteWideCoupanCode = [];
        const productCouponCode = [];
        const discountPercents = [];
        let productCoupondiscount = 0;
        let siteWideDiscount = 0;
        if ((ref = item.discountsList) === null || ref === void 0 ? void 0 : ref.length) {
            item.discountsList.forEach((discountItem)=>{
                if (discountItem.type === "sitewide") {
                    var ref;
                    // always apply sitewide discount first then remaining can be applied
                    siteWideDiscount += Number(item.unitPrice) * (discountItem.percent / 100);
                    siteWideCoupanCode.push((ref = discountItem.code) === null || ref === void 0 ? void 0 : ref.toLowerCase());
                } else {
                    // there can be multiple product coupon codes
                    discountPercents.push(discountItem.percent);
                    productCouponCode.push(discountItem.code);
                }
            });
            if (discountPercents.length) {
                let priceAfterDiscount = Number(item.unitPrice) - siteWideDiscount;
                let temporaryCouponPrice;
                for (const disc of discountPercents){
                    temporaryCouponPrice = Number((priceAfterDiscount * (disc / 100)).toFixed(2));
                    priceAfterDiscount = priceAfterDiscount - temporaryCouponPrice;
                    productCoupondiscount += temporaryCouponPrice;
                }
                productCoupondiscount = Number(productCoupondiscount.toFixed(2));
            }
        }
        const otherItem = {};
        if (item.productUpdated === true || item.productUpdated === false) {
            otherItem.productUpdated = item.productUpdated;
        }
        const globalDiscount = siteWideDiscount ? siteWideDiscount : 0;
        const globalPromotionPrice = Number(item.unitPrice) - globalDiscount;
        const itemType = getCartItemType(item.category, item.businessUnitName);
        data.item.push({
            productInfo: {
                productBrand: general === null || general === void 0 ? void 0 : (ref1 = general.siteName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(),
                productID: item.customerFacingSKU || item.sku,
                description: sanitizeTextForAnalytics(item.desc),
                productCategory: sanitizeTextForAnalytics(item.category),
                productName: sanitizeTextForAnalytics(item.name || item.desc || item.category),
                productColor: sanitizeTextForAnalytics(item.color),
                productRoom: sanitizeTextForAnalytics(item.productRoom || (itemType === "service" ? itemType : "non-catalog")),
                productSaleable: true,
                productStatus: !checkStock(item.backOrder, item.category) || item.availableQty >= item.quantity || itemType === "service" ? "in stock" : "out of stock",
                productPartnerBuyNow: false,
                productBasePrice: Number(item.unitPrice),
                productCouponCode: productCouponCode.join("|") || "n/a",
                productCoupondiscount: productCoupondiscount || 0,
                productSuperSku: item.superSku ? true : false,
                productSalePrice: item.discountPrice ? Number(item.discountPrice) : Number(item.unitPrice),
                globalPromotionPrice: Number(globalPromotionPrice.toFixed(2)),
                defaultImageName: item.image,
                priceState: item.discountPercent > 0 ? "percentOff|" + item.discountPercent : item.discountAmount > 0 ? "priceOff|" + item.discountAmount : "regular price",
                productCollectionsName: sanitizeTextForAnalytics(item.productCollectionsName || item.category),
                productFindingMethod: "n/a",
                productTileName: sanitizeTextForAnalytics(item.name || item.desc),
                quantity: item.quantity,
                globalOffer: siteWideCoupanCode.join("|") || "n/a",
                globalDiscount: Number(globalDiscount.toFixed(2)),
                itemType,
                isSubscription: false,
                isRecommended: false,
                frequency: "n/a",
                isSendNow: "n/a",
                ratings: "n/a",
                numberOfReviews: "n/a",
                pdpType: "regular finished goods & service parts",
                ...otherItem
            },
            quantity: item.quantity
        });
    });
    return data;
};
const getAssociatedServices = (attr)=>{
    var ref;
    const productServices = (ref = attr.find((item)=>item.name === "ProductServices")) !== null && ref !== void 0 ? ref : {};
    const { value =[]  } = productServices;
    return [
        ...value
    ];
};
const calculateCartData = async (params, isCart)=>{
    var ref;
    const { i18n ={} , noShippingItems: noShippingItemsProps = [] , shippingItemstoCheckout =[] , quantityUpdatedFlag  } = params;
    const cartObject = params.cart;
    const shippingItemsProps = shippingItemstoCheckout;
    const CONFIG = await getConfig();
    const locale = _get(CONFIG, "internationalization.locale", "");
    const brandName = (ref = _get(CONFIG, "general.siteName", "")) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    const currency = _get(CONFIG, "internationalization.currencyCode", "usd");
    const currencySign = _get(CONFIG, "internationalization.currencySign", "$");
    let voucherDiscount = 0;
    let subtotal = 0;
    let subtotalWithDiscount = 0;
    let totalPromotions = 0;
    let estimatedShipping = 0;
    let estimatedTax = 0;
    let estimatedTotal = 0;
    let promoCodes = [];
    let oldPromoCodes = [];
    let oldDiscountCodes = [];
    const cartItems = [];
    const specFiles = [];
    const outOfStockItems = [];
    const noShippingItems = [];
    let shippingDiscountsList = 0;
    const shippingDiscountsNameList = [];
    const voucherCode = [];
    const { shippingTotal: { centAmount: shippingTotal  } = {} , customLineItems =[] , billingAddress ={}  } = cartObject;
    oldPromoCodes = cartObject === null || cartObject === void 0 ? void 0 : cartObject.promoCode;
    oldDiscountCodes = cartObject === null || cartObject === void 0 ? void 0 : cartObject.discountCodes;
    if ((cartObject === null || cartObject === void 0 ? void 0 : cartObject.lineItems) && (cartObject === null || cartObject === void 0 ? void 0 : cartObject.lineItems.length) > 0) {
        var ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        // Get discount code details
        if (((ref1 = cartObject.promoCode) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            var _discountCodes;
            const discountCodes = (_discountCodes = cartObject.discountCodes) !== null && _discountCodes !== void 0 ? _discountCodes : [];
            cartObject.promoCode.forEach((item)=>{
                let discountName;
                if (item.code) {
                    var ref, ref1, ref2;
                    if (((ref = cartObject.discountCodes) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                        const matchedDiscountCode = cartObject.discountCodes.find((dc)=>{
                            var ref, ref1;
                            return ((ref = dc.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.code) === item.code;
                        });
                        if (matchedDiscountCode === null || matchedDiscountCode === void 0 ? void 0 : matchedDiscountCode.discountCode.obj.name[locale]) {
                            discountName = matchedDiscountCode === null || matchedDiscountCode === void 0 ? void 0 : matchedDiscountCode.discountCode.obj.name[locale];
                        }
                    }
                    var ref3;
                    promoCodes.push({
                        code: item.code,
                        discount: (Number(_get(item, "discountedAmount.centAmount", 0)) / 100).toFixed(2),
                        id: (ref3 = (ref1 = discountCodes.find((code)=>code.discountCode.obj.code === item.code)) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discountCode) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref3 !== void 0 ? ref3 : "",
                        type: item.type
                    });
                } else if (item.type === "product") {
                    if (promoCodes.find((p)=>p.type === "product")) {
                        const code = promoCodes.find((p)=>p.type === "product");
                        code.discount = (Number(code.discount) + Number(_get(item, "discountedAmount.centAmount", 0)) / 100).toFixed(2);
                    } else {
                        promoCodes.unshift({
                            code: i18n === null || i18n === void 0 ? void 0 : i18n.productDiscounts,
                            code: "Product Discounts",
                            discount: (Number(_get(item, "discountedAmount.centAmount", 0)) / 100).toFixed(2),
                            id: "",
                            type: "product",
                            name: discountName
                        });
                    }
                } else {
                    if (promoCodes.find((p)=>p.code === (item.name || discountName))) {
                        const code1 = promoCodes.find((p)=>p.code === (item.name || discountName));
                        code1.discount = (Number(code1.discount) + Number(_get(item, "discountedAmount.centAmount", 0)) / 100).toFixed(2);
                    } else {
                        var ref4;
                        ((ref4 = item.discountedAmount) === null || ref4 === void 0 ? void 0 : ref4.centAmount) > 0 && promoCodes.unshift({
                            code: item.name || discountName,
                            discount: (Number(_get(item, "discountedAmount.centAmount", 0)) / 100).toFixed(2),
                            id: "",
                            type: "no-code"
                        });
                    }
                }
            });
        }
        // Get shipping promotions
        if (((ref2 = cartObject.customLineItems) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
            promoCodes = promoCodes.concat(await getShippingDiscountPromoCodes(cartObject));
        }
        var _lineItems;
        let lineItems = (_lineItems = cartObject.lineItems) !== null && _lineItems !== void 0 ? _lineItems : [];
        if (isCart) {
            var ref8;
            var ref9;
            lineItems = (ref9 = (ref8 = cartObject.lineItems) === null || ref8 === void 0 ? void 0 : ref8.filter((item)=>{
                var ref, ref1;
                return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
            })) !== null && ref9 !== void 0 ? ref9 : [];
        }
        lineItems.forEach((item, i)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
            // Get line item price
            let discountPrice = 0;
            if ((ref = item.price) === null || ref === void 0 ? void 0 : ref.discounted) {
                discountPrice = (Number(_get(item.price.discounted, "value.centAmount", 0)) / 100).toFixed(2);
            }
            if (item.discountedPrice) {
                discountPrice = (Number(_get(item.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
            }
            const discountedPricePerQuantity = (Number(_get((ref2 = item === null || item === void 0 ? void 0 : (ref1 = item.discountedPrice) === null || ref1 === void 0 ? void 0 : ref1.includedDiscounts[0]) === null || ref2 === void 0 ? void 0 : ref2.discountedAmount, "centAmount", 0)) / 100).toFixed(2);
            let discountedPriceProductLevel = 0;
            if (!_isEmpty(item === null || item === void 0 ? void 0 : (ref3 = item.price) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.discounted) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.discount) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.obj) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.value) === null || ref7 === void 0 ? void 0 : ref7.money)) {
                var ref17, ref18, ref19, ref20, ref21;
                discountedPriceProductLevel = (Number(_get(item === null || item === void 0 ? void 0 : (ref17 = item.price) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.discounted) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.discount) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.obj) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.value) === null || ref21 === void 0 ? void 0 : ref21.money[0], "centAmount", 0)) / 100).toFixed(2);
            }
            var ref22;
            // Get line item details
            const attributes = (ref22 = (ref8 = item.variant) === null || ref8 === void 0 ? void 0 : ref8.attributes) !== null && ref22 !== void 0 ? ref22 : [];
            const productSection = _get(attributes.find((attr)=>attr.name === "ProductSection"), "value", null);
            let productRoom;
            if (productSection && productSection[0] && productSection[0][locale]) {
                productRoom = productSection[0][locale];
            }
            const getSize = _get(attributes.find((attr)=>attr.name === "ProductSize"), "value", "");
            let size;
            if (getSize && getSize[0] && getSize[0][locale]) {
                size = getSize[0][locale];
            }
            const getShape = _get(attributes.find((attr)=>attr.name === "ProductShape"), "value", "");
            let shape;
            if (getShape && getShape[0] && getShape[0][locale]) {
                shape = getShape[0][locale];
            }
            cartItems[i] = {
                id: _get(item, "id", ""),
                sku: _get(item, "variant.sku", ""),
                customerFacingSKU: getAttributeValue(attributes, "CustomerFacingSKU"),
                productRoom: productRoom,
                slug: _get(item, "productSlug[".concat(locale, "]"), ""),
                quantity: _get(item, "quantity", 0),
                image: _get(item, "variant.images[0].url", ""),
                category: getAttributeValue(attributes, "ProductLocalCategory"),
                brand: getAttributeValue(attributes, "CustomerFacingBrand"),
                associatedServices: getAssociatedServices(attributes),
                currencySign,
                name: _get(attributes.find((attr)=>attr.name === "RegionBrandName"), "value", _get(item, "name[".concat(locale, "]"), "")),
                desc: _get(attributes.find((attr)=>attr.name === "ProductDescriptionProductShort"), "value[".concat(locale, "]"), _get(attributes.find((attr)=>attr.name === "ProductDescriptionProduct"), "value", "")),
                color: _get(attributes.find((attr)=>attr.name === "SKUColorFinishName"), "value[".concat(locale, "]"), ""),
                size: size,
                shape: shape,
                unitPrice: (Number(_get(item, "price.value.centAmount", 0)) / 100).toFixed(2),
                totalPrice: (Number(_get(item, "totalPrice.centAmount", 0)) / 100).toFixed(2),
                discountUnitPrice: (Number(_get(item, "price.discounted.value.centAmount", 0)) / 100).toFixed(2),
                discountPrice: discountPrice,
                discountedPricePerQuantity: discountedPricePerQuantity,
                discountedPriceProductLevel: discountedPriceProductLevel,
                isComboSku: attributes.find((attr)=>attr.name === "ComboSKU") ? true : false,
                backOrder: _get(item, "custom.fields.isBackOrderable", false),
                businessUnitName: _get(attributes.find((attr)=>attr.name === "SPProductBusinessUnit"), "value", ""),
                additionalData: (item === null || item === void 0 ? void 0 : (ref9 = item.custom) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fields) === null || ref10 === void 0 ? void 0 : ref10.roomInfo) ? _get(item, "custom.fields", "") : "",
                discountsList: [],
                productCollectionsName: getAttributeValue(attributes, "ProductBrandNameDisplay") || getAttributeValue(attributes, "ProductBrandNameDisplay_t"),
                addedAt: _get(item, "addedAt", "")
            };
            if (quantityUpdatedFlag) {
                var ref23;
                if (quantityUpdatedFlag === ((ref23 = cartItems[i].customerFacingSKU) === null || ref23 === void 0 ? void 0 : ref23.toLowerCase())) {
                    cartItems[i].productUpdated = true;
                } else {
                    cartItems[i].productUpdated = false;
                }
            }
            cartItems[i].superSku = cartItems[i].isComboSku;
            // Get line item discounts
            if ((ref11 = item.price) === null || ref11 === void 0 ? void 0 : ref11.discounted) {
                var ref24, ref25, ref26, ref27;
                const isAbs = ((ref24 = item.price) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.discounted) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.discount) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.obj) === null || ref27 === void 0 ? void 0 : ref27.value.type) === "absolute";
                const isRel = !isAbs;
                if (isAbs) {
                    cartItems[i].discountAmount = Number(_get(item.price.discounted, "discount.obj.value.money[0].centAmount", 0) / 100);
                } else {
                    var ref28, ref29;
                    cartItems[i].discountPercent = Number(_get(item.price.discounted, "discount.obj.value.permyriad", 0) / 100);
                    if ((ref28 = item.price.discounted.discount) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.obj) === null || ref29 === void 0 ? void 0 : ref29.name[locale]) {
                        // sitewide discount
                        cartItems[i].discountsList.push({
                            type: "sitewide",
                            isAbs,
                            isRel,
                            percent: isRel ? cartItems[i].discountPercent : 0,
                            absolute: cartItems[i].discountAmount || 0,
                            code: item.price.discounted.discount.obj.name[locale]
                        });
                    }
                }
            }
            if ((ref12 = item.discountedPrice) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.includedDiscounts) === null || ref13 === void 0 ? void 0 : ref13.length) {
                item.discountedPrice.includedDiscounts.forEach((includedDiscountItem)=>{
                    var ref, ref1, ref2, ref3;
                    const isAbs = ((ref = includedDiscountItem.discount) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.value.type) === "absolute";
                    const isRel = ((ref2 = includedDiscountItem.discount) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.obj) === null || ref3 === void 0 ? void 0 : ref3.value.type) === "relative";
                    if (isAbs) {
                        cartItems[i].discountAmount = Number(_get(includedDiscountItem, "discount.obj.value.money[0].centAmount", 0) / 100);
                    } else if (isRel) {
                        cartItems[i].discountPercent = Number(_get(includedDiscountItem, "discount.obj.value.permyriad", 0) / 100);
                    }
                    if (isAbs || isRel) {
                        var ref4, ref5;
                        const otherDiscount = _get(includedDiscountItem, "discount.obj.name[".concat(locale, "]"), null);
                        const lineItemDiscountName = (ref4 = cartObject.promoCode) === null || ref4 === void 0 ? void 0 : ref4.find((p)=>p.type === "order" && p.name === otherDiscount);
                        if (otherDiscount && lineItemDiscountName) {
                            // capture discounts like buy 1 get 1 free. could be like installation service free on design service
                            const matchedOrderDiscount = promoCodes.find((p)=>p.type === "no-code" && p.code === otherDiscount);
                            if (matchedOrderDiscount) {
                                // sitewide discount
                                cartItems[i].discountsList.push({
                                    type: "sitewide",
                                    percent: isRel ? cartItems[i].discountPercent : 0,
                                    absolute: cartItems[i].discountAmount || 0,
                                    isAbs,
                                    isRel,
                                    code: matchedOrderDiscount.code
                                });
                            }
                        }
                        // find code from discountCode
                        if ((ref5 = cartObject.discountCodes) === null || ref5 === void 0 ? void 0 : ref5.length) {
                            cartObject.discountCodes.forEach((discountCode)=>{
                                const cartDiscounts = _get(discountCode, "discountCode.obj.cartDiscounts", []);
                                if (cartDiscounts === null || cartDiscounts === void 0 ? void 0 : cartDiscounts.length) {
                                    cartDiscounts.forEach((discountItem)=>{
                                        if (discountItem.id === includedDiscountItem.discount.obj.id) {
                                            // All coupon discounts
                                            cartItems[i].discountsList.push({
                                                type: "cart",
                                                isAbs,
                                                isRel,
                                                percent: cartItems[i].discountPercent || 0,
                                                absolute: cartItems[i].discountAmount || 0,
                                                code: discountCode.discountCode.obj.code
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            }
            const channels = Object.values(_get(item, "variant.availability.channels", {}));
            cartItems[i].availableQty = _get(channels[0], "availableQuantity", 0);
            if (!((ref14 = item.custom) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.fields) === null || ref15 === void 0 ? void 0 : ref15.bundleParentId)) {
                // Check if item is out of stock
                if (checkStock(cartItems[i].backOrder, cartItems[i].category)) {
                    if (cartItems[i].availableQty < cartItems[i].quantity) {
                        cartItems[i].outOfStock = true;
                        outOfStockItems.push(cartItems[i]);
                    }
                }
            }
            // get lead time if item is back ordered
            if (cartItems[i].backOrder === true) {
                cartItems[i].leadTime = _get(attributes.find((attr)=>attr.name === "RegionLeadTime"), "value", 0);
            }
            // Check if all items are avilable for shipping
            const comboSku = _get(attributes.find((attr)=>attr.name === "ComboSKU"), "value");
            const childSku = [];
            comboSku === null || comboSku === void 0 ? void 0 : comboSku.forEach((e)=>{
                const sku = e.find((attr)=>attr.name === "sku");
                childSku.push(sku.value);
            });
            if (noShippingItemsProps === null || noShippingItemsProps === void 0 ? void 0 : noShippingItemsProps.find((e)=>{
                return childSku === null || childSku === void 0 ? void 0 : childSku.includes(e);
            })) {
                cartItems[i].noShipping = true;
                noShippingItems.push(cartItems[i]);
            }
            if (noShippingItemsProps === null || noShippingItemsProps === void 0 ? void 0 : noShippingItemsProps.includes((ref16 = item.variant) === null || ref16 === void 0 ? void 0 : ref16.sku)) {
                cartItems[i].noShipping = true;
                noShippingItems.push(cartItems[i]);
            } else if (shippingItemsProps) {
                const shipmentItem = shippingItemsProps === null || shippingItemsProps === void 0 ? void 0 : shippingItemsProps.find((shippingItem)=>shippingItem.lineItemId === item.id);
                if (shipmentItem && shipmentItem.warningMessage) {
                    if (shipmentItem.parentLineItemId) {
                        const parentIndex = cartItems.findIndex((c)=>c.id === shipmentItem.parentLineItemId);
                        if (parentIndex >= 0 && !cartItems[parentIndex].noShipping) {
                            cartItems[parentIndex].noShipping = true;
                            noShippingItems.push(cartItems[parentIndex]);
                        }
                    } else {
                        cartItems[i].noShipping = true;
                        noShippingItems.push(cartItems[i]);
                    }
                }
            }
            // Get spec files for all line items
            const productResources = _get(attributes.find((attr)=>attr.name === "ProductResource"), "value", []);
            if (productResources.length > 0) {
                var ref30;
                const resource = (ref30 = productResources.find((arr)=>arr[1].value === "SpecPDFFileName")) !== null && ref30 !== void 0 ? ref30 : [];
                var ref31;
                const resourceUrl = (ref31 = resource.find((obj)=>obj.name === "ResourceFullWebURL")) !== null && ref31 !== void 0 ? ref31 : {};
                var _value;
                const specFileUrl = (_value = resourceUrl.value) !== null && _value !== void 0 ? _value : "";
                if (specFileUrl) specFiles.push(specFileUrl);
            }
        });
        var ref10;
        // Get order summary price amounts
        subtotal = Number(((ref10 = (ref3 = cartObject.subtotalWithoutDiscount) === null || ref3 === void 0 ? void 0 : ref3.centAmount) !== null && ref10 !== void 0 ? ref10 : 0) / 100).toFixed(2);
        var ref11;
        subtotalWithDiscount = Number(((ref11 = (ref4 = cartObject.subtotalWithPromotion) === null || ref4 === void 0 ? void 0 : ref4.centAmount) !== null && ref11 !== void 0 ? ref11 : 0) / 100).toFixed(2);
        var ref12;
        totalPromotions = Number(((ref12 = (ref5 = cartObject.totalPromo) === null || ref5 === void 0 ? void 0 : ref5.centAmount) !== null && ref12 !== void 0 ? ref12 : 0) / 100).toFixed(2);
        var ref13;
        estimatedTax = Number(((ref13 = (ref6 = cartObject.totalTax) === null || ref6 === void 0 ? void 0 : ref6.centAmount) !== null && ref13 !== void 0 ? ref13 : 0) / 100).toFixed(2);
        estimatedShipping = Number((shippingTotal !== null && shippingTotal !== void 0 ? shippingTotal : 0) / 100).toFixed(2);
        var ref14;
        estimatedTotal = Number(((ref14 = (ref7 = cartObject.estimatedTotal) === null || ref7 === void 0 ? void 0 : ref7.centAmount) !== null && ref14 !== void 0 ? ref14 : 0) / 100).toFixed(2);
        // checking shipping related discounts and adding it to price object
        promoCodes.forEach((promo)=>{
            if (promo.type === "shipping" || promo.type === "no-code") {
                shippingDiscountsList += Number(promo.discount);
                shippingDiscountsNameList.push(promo.code);
            }
        });
        // Add shipping promotions to total promotions
        promoCodes.filter((item)=>item.type === "shipping").forEach((item)=>{
            estimatedShipping = Number(estimatedShipping) + Number(item.discount);
        // totalPromotions = Number(totalPromotions) + Number(item.discount)
        });
    }
    promoCodes.forEach((itm)=>{
        voucherCode.push(itm.code);
        voucherDiscount += Number(itm.discount);
    });
    const analyticsCartItems = await getCartItemsAnalyticsData(cartItems);
    const cart = {
        cartID: cartObject === null || cartObject === void 0 ? void 0 : cartObject.id,
        price: {
            basePrice: subtotal || 0,
            voucherCode: voucherCode.length ? voucherCode.join("|") : "n/a",
            voucherDiscount: voucherDiscount ? Number(voucherDiscount.toFixed(2)) : 0,
            globalOffer: shippingDiscountsNameList ? shippingDiscountsNameList.join("|") || "n/a" : "n/a",
            globalDiscount: shippingDiscountsList ? Number(shippingDiscountsList.toFixed(2)) : 0,
            currency: currency.toLowerCase(),
            taxRate: estimatedTax || "n/a",
            shipping: estimatedShipping ? Number(estimatedShipping) : "n/a",
            priceWithTax: estimatedTotal || 0,
            cartTotal: subtotal || 0,
            couponCode: "n/a",
            couponDiscount: 0,
            orderCouponCode: "n/a",
            orderCouponDiscount: 0,
            shippingMethod: "ground"
        },
        ...analyticsCartItems
    };
    cartItems.forEach((e)=>{
        var ref;
        const matchedItem = analyticsCartItems === null || analyticsCartItems === void 0 ? void 0 : (ref = analyticsCartItems.item) === null || ref === void 0 ? void 0 : ref.find((i)=>i.productInfo.productID === e.customerFacingSKU);
        if (matchedItem) {
            e.customProductInfo = helper_sanitizeDOMString(JSON.stringify(matchedItem));
        }
    });
    cartItems.sort((prev, curr)=>{
        return new Date(curr.addedAt) - new Date(prev.addedAt);
    });
    sanitizeObject(cartItems);
    sanitizeObject(cart);
    const getFreightDiscountTotal = function() {
        let codes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        let total = 0;
        codes.forEach((e)=>{
            if (FREIGHT_SHIPPING_TYPES.includes(e.name)) {
                total += Number(e.discount);
            }
        });
        return total;
    };
    const freightDiscountTotal = getFreightDiscountTotal(promoCodes);
    const shippingAllTotal = getShippingAllTotal(customLineItems, locale);
    return {
        oldPromoCodes,
        oldDiscountCodes,
        cartItems,
        subtotal,
        subtotalWithDiscount,
        totalPromotions,
        estimatedTax,
        estimatedShipping,
        estimatedTotal,
        shippingTotal: shippingTotal / 100,
        promoCodes,
        specFiles,
        outOfStockItems,
        noShippingItems,
        shippingDiscountsNameList,
        shippingDiscountsList,
        cart,
        freightDiscountTotal,
        shippingAllTotal,
        brandName,
        billingAddress
    };
};
const getShippingDiscountPromoCodes = async (cartObject)=>{
    var ref;
    const locale = await (0,constants_config/* getConfig */.i)().then((config)=>get_default()(config, "internationalization.locale", ""));
    const promoCodes = [];
    if (cartObject === null || cartObject === void 0 ? void 0 : (ref = cartObject.customLineItems) === null || ref === void 0 ? void 0 : ref.length) {
        cartObject.customLineItems.map((item)=>{
            var ref;
            if ((ref = item.discountedPrice) === null || ref === void 0 ? void 0 : ref.includedDiscounts) {
                item.discountedPrice.includedDiscounts.map((disc)=>{
                    var ref, ref1, ref2;
                    var ref3;
                    const discountObj = (ref3 = (ref = disc.discount) === null || ref === void 0 ? void 0 : ref.obj) !== null && ref3 !== void 0 ? ref3 : {};
                    var ref4;
                    const discountName = (ref4 = discountObj === null || discountObj === void 0 ? void 0 : (ref1 = discountObj.name) === null || ref1 === void 0 ? void 0 : ref1[locale]) !== null && ref4 !== void 0 ? ref4 : "";
                    var ref5;
                    const name = (ref5 = item === null || item === void 0 ? void 0 : (ref2 = item.name) === null || ref2 === void 0 ? void 0 : ref2[locale]) !== null && ref5 !== void 0 ? ref5 : "";
                    // get shipping promotions with codes
                    if (discountObj.requiresDiscountCode) {
                        var ref6, ref7;
                        var ref8;
                        const dicountIdObj = (ref8 = (ref6 = cartObject.discountCodes) === null || ref6 === void 0 ? void 0 : ref6.find((disc)=>{
                            var ref, ref1, ref2;
                            return ((ref2 = (ref = disc.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.cartDiscounts[0]) === null || ref2 === void 0 ? void 0 : ref2.id) === (discountObj === null || discountObj === void 0 ? void 0 : discountObj.id);
                        })) !== null && ref8 !== void 0 ? ref8 : {};
                        var ref9;
                        const discountId = (ref9 = (ref7 = dicountIdObj.discountCode) === null || ref7 === void 0 ? void 0 : ref7.id) !== null && ref9 !== void 0 ? ref9 : "";
                        if (!promoCodes.find((code)=>code.id === discountId)) {
                            promoCodes.push({
                                code: discountName,
                                discount: (Number(get_default()(disc, "discountedAmount.centAmount", 0)) / 100).toFixed(2),
                                id: discountId,
                                type: "shipping",
                                name
                            });
                        } else {
                            const index = promoCodes.findIndex((code)=>code.id === discountId);
                            promoCodes[index].discount = (Number(promoCodes[index].discount) + Number(get_default()(disc, "discountedAmount.centAmount", 0)) / 100).toFixed(2);
                        }
                    } else {
                        if (!promoCodes.find((p)=>p.code === discountName)) {
                            promoCodes.push({
                                code: discountName,
                                discount: (Number(get_default()(disc, "discountedAmount.centAmount", 0)) / 100).toFixed(2),
                                id: "",
                                type: "shipping",
                                name
                            });
                        } else {
                            const index1 = promoCodes.findIndex((p)=>p.code === discountName);
                            promoCodes[index1].discount = (Number(promoCodes[index1].discount) + Number(get_default()(disc, "discountedAmount.centAmount", 0)) / 100).toFixed(2);
                        }
                    }
                });
            }
        });
    }
    return promoCodes;
};
const getCartItemType = function() {
    let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", businessUnitName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (!category && !businessUnitName) {
        return "n/a";
    }
    category = category.toLowerCase();
    businessUnitName = businessUnitName.toLowerCase();
    if (category === "install services" || category === "design services" || category === "services") {
        return "service";
    }
    if (category === "samples") {
        return "sample";
    }
    if (category === "parts" || category === "service parts" || businessUnitName.indexOf("serviceparts") !== -1 || businessUnitName === "service parts") {
        return "part";
    }
    return "product";
};
const helper_sanitizeDOMString = (property)=>typeof property === "string" ? browser_default().sanitize(property) : property;
const decodeHtmlCharacters = (str)=>{
    return str.replace(/&amp;/g, "&").replace(/&#8217;/g, "'").replace(/&nbsp;/g, " ");
};
const sanitizeAndDecodeHtml = (str)=>{
    const decodeVal = decodeHtmlCharacters(str);
    return sanitizeInnerHtml(decodeVal);
};
const updateObject = (objRef, objKey)=>{
    const copyObject = {
        ...objRef
    };
    copyObject[objKey] = helper_sanitizeDOMString(copyObject[objKey]);
    return copyObject;
};
const sanitizeObject = (obj)=>{
    if (typeof obj === "object" && obj !== null) {
        Object.keys(obj).forEach((objKey)=>{
            if (typeof obj[objKey] === "string") {
                return updateObject(obj, objKey);
            }
            return sanitizeObject(obj[objKey]);
        });
    }
    return obj;
};
const handleZipDownload = async (files, filename, success, err)=>{
    for(let i = 0; i < files.length; i++){
        if (!files[i].includes("http")) {
            files.splice(i, i + 1);
            i--;
        }
    }
    try {
        const payload = {
            files: files
        };
        if (filename) {
            payload.downloadFileName = filename;
        } else {
            const crypto1 = window.crypto || window.msCrypto;
            const array = new Uint32Array(1);
            const rand = crypto1.getRandomValues(array)[0];
            const { general  } = await (0,constants_config/* getConfig */.i)();
            var ref;
            const brandName = (ref = general === null || general === void 0 ? void 0 : general.siteName) !== null && ref !== void 0 ? ref : "";
            const randomId = Math.floor(rand * 10000000).toString(16);
            payload.downloadFileName = "".concat(brandName, "-").concat(randomId);
        }
        const { payload: res  } = await (store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* zipDownload */.t8)(payload)));
        if (res) {
            let downloadFileName = filename + ".zip";
            if (!filename) {
                const disposition = content_disposition_default().parse(res.headers["content-disposition"]);
                downloadFileName = disposition.parameters.filename;
            }
            file_download_default()(res.data, downloadFileName);
            if (success) success();
        }
    } catch (ex) {
        // temp
        // log.error(ex)
        if (err) err();
    }
};
const isEmbeddedElement = (script)=>{
    if (script) {
        const doc = new DOMParser().parseFromString(script, "text/html");
        if (doc.body.innerHTML) {
            return true;
        }
    }
    return false;
};
const isEmbeddedStyles = (script)=>{
    const stylesList = [];
    if (script) {
        const doc = new DOMParser().parseFromString(script, "text/html");
        extractStylesFromDOM(doc, (item)=>stylesList.push(item));
    }
    const resultVal = {
        styles: stylesList
    };
    return resultVal;
};
const getSiteWideModal = (e, url)=>{
    if (url.indexOf("http") === 0) {
        e.preventDefault();
        window.handleShowModal(url);
    }
};
const getAttributeValue = (attributes, name)=>get_default()(attributes.find((attr)=>attr.name === name), "value", "");
const createIdFromString = (text)=>{
    const testData = text !== null && text !== void 0 ? text : "";
    testData.replace(regex/* SANITIZE_TEXT_REGEX */.If, "").toLowerCase().replace(/ /g, "-").trim();
    return testData;
};
const capitalizeFirstName = (firstname)=>{
    firstname = (firstname === null || firstname === void 0 ? void 0 : firstname.charAt(0).toUpperCase()) + (firstname === null || firstname === void 0 ? void 0 : firstname.slice(1));
    return firstname;
};
const setFocus = (id)=>{
    var ref;
    (ref = document.getElementById(id)) === null || ref === void 0 ? void 0 : ref.focus();
};
const preventBodyScroll = (status)=>{
    if (status) {
        document.body.classList.add("scroll-lock", "modal-open");
        document.getElementsByTagName("html")[0].classList.add("scroll-lock", "modal-open");
    } else {
        document.body.classList.remove("scroll-lock", "modal-open");
        document.getElementsByTagName("html")[0].classList.remove("scroll-lock", "modal-open");
    }
};
const preventBodyScrollTab = (status)=>{
    if (status) {
        document.body.classList.add("gbh-of-scroll");
    } else {
        document.body.classList.remove("gbh-of-scroll");
    }
};
const sanitizeText = (text)=>{
    return text === null || text === void 0 ? void 0 : text.replace(/<\/?[^>]+(>|$)/g, "");
};
// Sort
const getSortFromUrl = ()=>{
    const url = new URL(location.href);
    var ref;
    const appliedSort = (ref = url.searchParams.get("sort")) !== null && ref !== void 0 ? ref : "";
    return appliedSort.includes("%2B") ? appliedSort.replaceAll("%2B", "+") : appliedSort.replaceAll(" ", "+");
};
const getSelectedSort = (text, query)=>{
    switch(query){
        case "bestSeller_l+asc":
            return {
                name: text.bestSellers,
                query: "bestSeller_l+asc"
            };
        case "price+desc":
            return {
                name: text.priceDesc,
                query: "price+desc"
            };
        case "price+asc":
            return {
                name: text.priceAsc,
                query: "price+asc"
            };
        case "CollapseSort_s+asc":
        case "NonCollapseSort_s+asc":
            return {
                name: text.atoz,
                query
            };
        case "CollapseSort_s+desc":
        case "NonCollapseSort_s+desc":
            return {
                name: text.ztoa,
                query
            };
        case "productName_s+asc":
            return {
                name: text.atoz,
                query
            };
        case "productName_s+desc":
            return {
                name: text.ztoa,
                query
            };
        case "title_s+asc":
            return {
                name: text.atoz,
                query
            };
        case "title_s+desc":
            return {
                name: text.ztoa,
                query
            };
        case "new":
            return {
                name: text.newToOld,
                query
            };
        case "old":
            return {
                name: text.oldToNew,
                query
            };
        // Temp Fix AToZ & ZToA
        case "atoz":
            return {
                name: text.AToZ,
                query
            };
        case "ztoa":
            return {
                name: text.ZToA,
                query
            };
    }
    return {
        name: text.featured,
        query: ""
    };
};
const replaceSearchUrl = (searchTerm, param)=>{
    const url = new URL(window.location.href);
    let searchUrl = url.search;
    const searchArray = searchUrl.split("&");
    const index = searchUrl.split("&").findIndex((param)=>param.includes(searchTerm));
    if (param === "" || param === undefined) {
        searchArray.splice(index, 1);
        const urlIndex = searchArray.findIndex((searchParam)=>searchParam.includes("?"));
        searchUrl = searchArray.length !== 0 ? urlIndex === -1 ? "?".concat(searchArray.join("&")) : searchArray.join("&") : searchArray.join("&");
    } else if (index !== -1) {
        searchArray.splice(index, 1, "".concat(searchTerm, "=").concat(param));
        if (!index) {
            searchArray[index] = "?".concat(searchArray[index]);
        }
        searchUrl = searchArray.join("&");
    } else {
        searchUrl = searchUrl ? searchUrl + "&".concat(searchTerm, "=").concat(param) : "?".concat(searchTerm, "=").concat(param);
    }
    history.replaceState(window.location.pathname, document.title, url.pathname + searchUrl);
};
const getPriceSortQuery = ()=>{
    const persona = getUserPersona();
    return "priceList.".concat(persona, ".finalPrice_d");
};
const getSortItemBasedOnURL = (text, defaultItem)=>{
    const urlParams = window.location.search;
    let queryVal = "";
    if (urlParams) {
        const urlQuery = urlParams.replace("?", "").split("&");
        urlQuery.forEach((query, i)=>{
            const isBack = query.split("=")[0] === "back";
            if (isBack) {
                sessionStorage.plpScrollSku = query.split("=")[1];
            }
            queryVal += isBack ? "" : "".concat(i > 0 ? "&" : "").concat(query);
        });
        window.history.replaceState(window.location.pathname, document.title, queryVal.length > 0 ? "?".concat(queryVal.toString()) : window.location.pathname);
    }
    const query = getSortFromUrl();
    const selectedSortItem = query ? getSelectedSort(text, query) : defaultItem || null;
    return selectedSortItem;
};
// *****
const filterBackEndJson = (json)=>{
    const newJson = {};
    for(const k in json){
        if (k !== "allowedComponents") {
            if (typeof json[k] === "object" && !Array.isArray(json[k]) && json[k] !== null) {
                newJson[k] = filterBackEndJson(json[k]);
            } else {
                newJson[k] = json[k];
            }
        }
    }
    return newJson;
};
// Filter
const formatFacetName = (name, filter, facetLabels)=>{
    var ref, ref1;
    let val = facetLabels && facetLabels[name === null || name === void 0 ? void 0 : name.replace(/^\*{2}/, "")] ? facetLabels[name === null || name === void 0 ? void 0 : name.replace(/^\*{2}/, "")] : (ref1 = (ref = name === null || name === void 0 ? void 0 : name.replace(/\./g, "/")) === null || ref === void 0 ? void 0 : ref.replace(/_/g, " ")) === null || ref1 === void 0 ? void 0 : ref1.replace(/^\*{2}/, "");
    if (filter) val += " - ".concat(filter);
    return val;
};
const formatPriceRange = function(filter) {
    let isAnnsacksPlp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1;
    const values = filter.match(/\d+/g);
    return isAnnsacksPlp ? "$".concat((ref = Number(values[0])) === null || ref === void 0 ? void 0 : ref.toLocaleString(), " - $").concat((ref1 = Number(values[1])) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString()) : "$".concat(values[0], " - $").concat(values[1]);
};
const resetFilterUrl = ()=>{
    let searches = location.search.split("&");
    searches = searches.filter((item)=>constants.queryParamsToPersist.filter((param)=>item.includes(param)).length);
    const url = searches.join("&");
    window.history.replaceState({}, document.title, window.location.pathname + (url.includes("?") ? url : url && "?".concat(url)));
};
const getFacetsFromUrl = function() {
    let marketParamValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const currFilters = [];
    const urlParams = window.location.search;
    const aMarkettingParameters = marketParamValues === null || marketParamValues === void 0 ? void 0 : marketParamValues.marketParamValues;
    if (urlParams) {
        urlParams.replace("?", "").split("&").forEach((filter)=>{
            if (filter.split("=")[0] !== "title" && filter.split("=")[0] !== "id" && filter.split("=")[0] !== "keyword" && filter.split("=")[0] !== "compare" && filter.split("=")[0] !== "back" && filter.split("=")[0] !== "sort" && filter.split("=")[0] !== "activeTab" && filter.split("=")[0] !== "tab" && filter.split("=")[0] !== "skuSearch" && filter.split("=")[0] !== "service" && !(aMarkettingParameters === null || aMarkettingParameters === void 0 ? void 0 : aMarkettingParameters.includes(filter.split("=")[0]))) {
                const facet = decodeURIComponent(filter.split("=")[0]);
                if (facet === "wcmmode") return;
                const decode = decodeURIComponent(filter);
                let values = decode && decode.split("=")[1].split(",");
                values = values.map((val)=>val.replace(/[+]/g, " "));
                let display = decode && decode.split("=")[1].split(",");
                display = display.map((val)=>val.replace(/[+]/g, " "));
                const filterName = decode.split("=")[0];
                display = display.map((d)=>d.replace(/\\/g, ""));
                // format price range filter
                if (filterName === "Price_Range") {
                    display = display.map((range)=>formatPriceRange(range));
                }
                // Check if the filter attribute already exists
                let checkFacet = false;
                currFilters.forEach((item)=>{
                    checkFacet = Object.values(item).includes(facet);
                });
                // Add a new filter or add values to existing filter
                if (!checkFacet) {
                    currFilters.push({
                        facet: facet,
                        value: values,
                        display: display
                    });
                } else {
                    currFilters.forEach((fc)=>{
                        if (facet === fc.facet) {
                            fc.value.push(values);
                            fc.display.push(display);
                        }
                    });
                }
            }
        });
    }
    return currFilters.filter((currFilter)=>currFilter.facet !== "sort");
};
const getParamsFromUrl = async ()=>{
    const urlParams = window.location.search;
    const decode = decodeURIComponent(urlParams);
    const value = decode && decode.split("=")[1].split(",");
    return value;
};
const retainSearchQueryParams = (type)=>{
    const search = window.location.search;
    let srpTabDetails = {};
    if (!search.includes("tab=")) {
        srpTabDetails = {
            [type]: search
        };
    } else {
        if (search.includes("tab=".concat(type))) {
            srpTabDetails = {
                [type]: search
            };
        }
    }
    if (sessionStorage.getItem("SRPTabDetails")) {
        srpTabDetails = JSON.parse(sessionStorage.getItem("SRPTabDetails"));
        srpTabDetails[type] = window.location.search;
    }
    sessionStorage.setItem("SRPTabDetails", JSON.stringify(srpTabDetails));
};
const removeSearchQueryParams = ()=>{
    sessionStorage.removeItem("SRPTabDetails");
};
const checkIfUserExists = (email)=>api/* apim.post */.TH.post("/customer/lookup", {
        email
    });
const getShortenedUrl = async (uUrl)=>{
    const { general  } = await (0,constants_config/* getConfig */.i)();
    if (general) {
        const { shortendPagePath  } = general;
        const shortUrl = shortendPagePath !== null && shortendPagePath !== void 0 ? shortendPagePath : "";
        const htmlRegExp = new RegExp(".html", "g");
        const htmlRemovedUrl = "".concat(uUrl === null || uUrl === void 0 ? void 0 : uUrl.replace(htmlRegExp, ""));
        const shortUrlRegEx = new RegExp(shortUrl, "g");
        return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
    }
    return "";
};
const getShortenedUrlwithGeneral = (uUrl, general)=>{
    if (general) {
        const { shortendPagePath  } = general;
        const shortUrl = shortendPagePath !== null && shortendPagePath !== void 0 ? shortendPagePath : "";
        const htmlRegExp = new RegExp(".html", "g");
        const htmlRemovedUrl = "".concat(uUrl === null || uUrl === void 0 ? void 0 : uUrl.replace(htmlRegExp, ""));
        const shortUrlRegEx = new RegExp(shortUrl, "g");
        return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
    }
    return "";
};
const getFacetField = (facetFields, facetQuery)=>{
    return Array.isArray(facetFields) ? facetFields.find((f)=>f === facetQuery) : facetFields === facetQuery;
};
const getAllFilterQueries = function(componentProps) {
    let fusion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, marketParamValues = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    let currFilters = [];
    const urlFilters = getFacetsFromUrl(marketParamValues);
    var ref;
    const facetFields = (ref = fusion["facet.field"]) !== null && ref !== void 0 ? ref : [];
    var ref1;
    const facetLabels = (ref1 = fusion === null || fusion === void 0 ? void 0 : fusion.facet_labels) !== null && ref1 !== void 0 ? ref1 : {};
    if (urlFilters.length > 0) {
        urlFilters.forEach((f)=>{
            let facetQuery = f.facet === "Price_Range" ? "Price_Range" : Object.keys(facetLabels).find((key)=>facetLabels[key] === f.facet.replace(/_/g, " "));
            const isValidFacet = getFacetField(facetFields, facetQuery);
            if (isValidFacet) facetQuery = "**".concat(facetQuery);
            if (facetQuery) {
                f.facet = facetQuery;
            }
        });
    }
    // Set pre-selected filters
    if ((urlFilters === null || urlFilters === void 0 ? void 0 : urlFilters.length) === 0 && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributeName) !== "" && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue) !== "") {
        let facetQuery = componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributeName;
        const isValidFacet = getFacetField(facetFields, facetQuery);
        if (isValidFacet) {
            facetQuery = "**".concat(facetQuery);
        }
        currFilters.push({
            facet: facetQuery,
            value: [
                componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue.replace(/"/g, '\\"')
            ],
            display: [
                componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue
            ]
        });
    }
    currFilters = [
        ...currFilters,
        ...urlFilters
    ];
    return currFilters;
};
const convertStringToBoolean = (str)=>{
    if (typeof str === "string") {
        if (str.toLowerCase() === "true") {
            return true;
        } else if (str.toLowerCase() === "false") {
            return false;
        } else {
            return false;
        }
    } else if (typeof str === "boolean") {
        return str;
    } else {
        return false;
    }
};
const resetUrl = ()=>{
    const url = new URL(window.location.href);
    const searchUrl = url.search;
    const searchArray = searchUrl.split("&");
    const searchedUrl = searchArray.length ? searchArray[0] : "";
    history.replaceState(window.location.pathname, document.title, url.pathname + searchedUrl);
};
const formatMultiSelectFacets = (data)=>{
    var ref;
    var ref1;
    const facets = Object.entries((ref1 = (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_fields) !== null && ref1 !== void 0 ? ref1 : {}).map((fields)=>({
            [fields[0]]: fields[1]
        }));
    let facetField = data === null || data === void 0 ? void 0 : data.fusion["facet.field"];
    if (facetField) {
        if (typeof facetField === "string") facetField = [
            facetField
        ];
        facetField.forEach((item)=>{
            facets.forEach((filter, index)=>{
                if (filter[item]) {
                    const obj = {
                        ["**".concat(item)]: filter[item]
                    };
                    facets.splice(index, 1, obj);
                }
            });
        });
    }
    const result = Object.assign({}, ...facets);
    return result;
};
const addADALink = (ele, params)=>{
    const a = ele === null || ele === void 0 ? void 0 : ele.getElementsByTagName("a");
    if (a && a.length) {
        for(let i = 0; i < a.length; i++){
            const anchor = a[i];
            if (!anchor.hasAttribute("aria-label")) {
                const innerHtml = anchor.innerHTML;
                anchor.setAttribute("aria-label", anchor.getAttribute("target") === "_blank" ? params.translate("kf.pdp.label.aria.dangerouslyLinkADABlankPage", {
                    innerHtml
                }) : params.translate("kf.pdp.label.aria.dangerouslyLinkADA", {
                    innerHtml
                }));
            }
        }
    }
};
const removeAndCleanLink = (link)=>{
    return link ? link === null || link === void 0 ? void 0 : link.split("/content/kohler-india/in").join("").replace(".html", "") : link;
};
const mapStateToCountryHandler = function() {
    let countryData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], stateData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const data = [];
    countryData.forEach((country)=>{
        data.push({
            code: country.value,
            name: country.text,
            states: []
        });
    });
    stateData.forEach((state)=>{
        var ref, ref1, ref2;
        const countryCode = (ref = state.value) === null || ref === void 0 ? void 0 : ref.split(":")[1];
        (ref1 = data.find((country)=>country.code === countryCode)) === null || ref1 === void 0 ? void 0 : ref1.states.push({
            code: (ref2 = state.value) === null || ref2 === void 0 ? void 0 : ref2.split(":")[0],
            name: state.text
        });
    });
    return data;
};
const addToRecentlyViewed = (id)=>{
    const { general  } = (0,constants_config/* getConfig */.i)();
    var ref;
    const max = (ref = general === null || general === void 0 ? void 0 : general.recentlyViewedMax) !== null && ref !== void 0 ? ref : 10;
    let items = localStorage.getItem("recently-viewed") ? JSON.parse(localStorage.getItem("recently-viewed")) : [];
    if (id) {
        items = items.filter((i)=>i !== id);
        items.unshift(id);
        const newItems = items.slice(0, max);
        localStorage.setItem("recently-viewed", JSON.stringify(newItems));
    }
};
const getModelSuggestionSkuListFromData = (data)=>{
    const skuList = [];
    data.map((variants)=>{
        var ref;
        const labelList = (ref = variants === null || variants === void 0 ? void 0 : variants.customerFacingSKUList_ss) !== null && ref !== void 0 ? ref : get_default()(variants, "variantList.sku_ss");
        if (Array.isArray(labelList)) {
            labelList.forEach((sku)=>skuList.push(sku));
        } else if (labelList) {
            skuList.push(labelList);
        }
    });
    return skuList;
};
const handleModelNumberSuggestion = (resp)=>{
    const { response: { numFound , docs  }  } = resp;
    if (numFound < 1) {
        return {
            suggestions: [],
            invalidModelNumber: numFound === 0 ? true : false
        };
    } else {
        var ref;
        const skuList = (ref = getModelSuggestionSkuListFromData(docs)) !== null && ref !== void 0 ? ref : [];
        return {
            suggestions: skuList
        };
    }
};
const closeModalAnalytics = (productInfo)=>{
    setTimeout(()=>{
        const modalCloseButtons = document.getElementsByClassName("bv-mbox-close");
        if (!window.modalCloseEventLoaded && (modalCloseButtons === null || modalCloseButtons === void 0 ? void 0 : modalCloseButtons.length)) {
            // this means review contents are loaded
            const modalCloseButton = modalCloseButtons[0];
            const clickEvent = function() {
                const { adobeDataLayer: { getState  } = {}  } = window;
                const page = getState && getState("page") || {};
                const eventInfo = {
                    eventAction: "pdp:modal:write a review:close",
                    eventName: "pdp:modal:write a review:close",
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "close",
                    internalLinkPosition: "pdp",
                    internalLinkType: "pdp:close",
                    internalLinkZoneName: "pdp:modal:write a review",
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                };
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo,
                    page,
                    productInfo: productInfo ? JSON.parse(productInfo).productInfo : null
                });
                modalCloseButton.removeEventListener("click", clickEvent);
                delete window.checker;
                delete window.modalCloseEventLoaded;
            };
            modalCloseButton.addEventListener("click", clickEvent);
            window.modalCloseEventLoaded = true;
        } else if (!window.modalCloseEventLoaded && (!window.checker || window.checker < 10)) {
            var _checker;
            window.checker = ((_checker = window.checker) !== null && _checker !== void 0 ? _checker : 0) + 1;
            closeModalAnalytics(productInfo);
        }
    }, 2000);
};
const sanitizeTextArticle = (text)=>{
    return text.replace(/<\/?[^>]+(>|$)/g, "").replace(/(\r\n|\n|\r)/gm, "");
};
const cleanText = function() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return text.replace(/<\/?[^>]+(>|$)/g, "");
};
const appendPresetToUrl = function(assetAccountName, swatchUrl, assetId, width) {
    let presetConfigs = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, isReel = arguments.length > 5 ? arguments[5] : void 0;
    const { Desktop , MobileLandscape ="" , MobilePortrait ="" , LandscapeCategory  } = presetConfigs;
    let preset = "";
    if (width <= 768) {
        if (width <= 425) {
            if (MobilePortrait) {
                preset = MobilePortrait;
            }
        } else {
            if (MobileLandscape) {
                preset = MobileLandscape;
            }
        }
    } else {
        preset = isReel ? Desktop : MobileLandscape;
    }
    return "".concat(swatchUrl).concat(LandscapeCategory, "?$product_src=is{").concat(assetAccountName, "/").concat(assetId, "}&").concat(preset);
};
const getPresetThumbnailUrl = (assetAccountName, swatchUrl, assetId, presetConfigs)=>{
    const { Thumbnail , LandscapeCategory  } = presetConfigs;
    return "".concat(swatchUrl).concat(LandscapeCategory, "?$product_src=is{").concat(assetAccountName, "/").concat(assetId, "}&").concat(Thumbnail);
};
const checkIsFavorite = (items)=>{
    const page = window.location.origin + window.location.pathname;
    const checkLink = (item)=>{
        let link = {};
        try {
            var ref, ref1;
            link = new URL((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
        }
        return link.origin + link.pathname === page ? true : false;
    };
    const isFavorite = (el)=>{
        var ref, ref1, ref2;
        // check if asset url is added to favorites
        if (((ref = el.dataset) === null || ref === void 0 ? void 0 : ref.asset) && items.find((item)=>{
            var ref, ref1;
            return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === el.dataset.url;
        })) {
            return items.find((item)=>{
                var ref, ref1;
                return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === el.dataset.url;
            }).id;
        }
        if (((ref1 = el.dataset) === null || ref1 === void 0 ? void 0 : ref1.asset) && items.find((item)=>{
            var ref, ref1;
            return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === window.location.origin + el.dataset.url;
        })) {
            return items.find((item)=>{
                var ref, ref1;
                return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === window.location.origin + el.dataset.url;
            }).id;
        }
        // check if current page url is added to favorites
        if (!((ref2 = el.dataset) === null || ref2 === void 0 ? void 0 : ref2.asset) && items.find((item)=>checkLink(item))) {
            return items.find((item)=>checkLink(item)).id;
        }
        return false;
    };
    const favElements = [
        ...document.getElementsByClassName("fav-trigger"),
        ...document.getElementsByClassName("fav-video-trigger")
    ];
    favElements.forEach((elem)=>{
        const id = isFavorite(elem);
        if (id) {
            elem.classList.add("favorite-filled");
            elem.dataset.id = id;
        }
    });
};
const sanitizeProductName = (name)=>name.replace(/®|™/g, "");
/**
 *
 * @param {Boolean} isEnable
 */ const toggeleBodyScroll = (isEnable)=>{
    if (isEnable) {
        document.body.classList.add("remove-scroll");
    } else {
        document.body.classList.remove("remove-scroll");
    }
};
const formatOfflineRegisterPropsData = (root)=>{
    const result = {};
    if (root && root[":items"]) {
        const handleItems = (items)=>{
            for (const [key, value] of Object.entries(items)){
                if (key === "register_offline_pro") {
                    Object.assign(result, value);
                } else if (value && value[":items"]) {
                    handleItems(value[":items"]);
                }
            }
        };
        handleItems(root[":items"]);
    }
    return result;
};
const formatOnlineRegisterPropsData = (root)=>{
    const result = {};
    if (root && root[":items"]) {
        const handleItems = (items)=>{
            for (const [key, value] of Object.entries(items)){
                if (key === "register_online_prod") {
                    Object.assign(result, value);
                } else if (value && value[":items"]) {
                    handleItems(value[":items"]);
                }
            }
        };
        handleItems(root[":items"]);
    }
    return result;
};
const nbspSanitizeInnerHtml = (property)=>{
    const sanitizedHtml = browser_default().sanitize(property).replace(/&nbsp;/g, " ");
    const parsedHtml = (0,html_react_parser/* default */.ZP)(sanitizedHtml);
    return parsedHtml;
};
const getDefaultProfileAddress = (profile)=>{
    const { firstName ="" , lastName ="" , defaultShippingAddressId ="" , addresses =[]  } = profile;
    const prefilledCustomerDetails = {
        firstName: {
            value: firstName
        },
        lastName: {
            value: lastName
        }
    };
    if (addresses.length) {
        const defaultAddress = addresses.find((item)=>item.id === defaultShippingAddressId);
        if (!isEmpty_default()(defaultAddress)) {
            const { city , postalCode , state , streetName  } = defaultAddress;
            prefilledCustomerDetails["city"] = {
                value: city
            };
            prefilledCustomerDetails["address"] = {
                value: streetName
            };
            prefilledCustomerDetails["zipCode"] = {
                value: postalCode
            };
            prefilledCustomerDetails["state"] = {
                value: state
            };
        }
    }
    return prefilledCustomerDetails;
};
const getPathFromUrl = (url)=>{
    return url.split(/[?#]/)[0];
};
const validatePhone = function() {
    let phone = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    phone = phone.replace("(", "");
    phone = phone.replace(")", "");
    phone = phone.replace(" ", "");
    phone = phone.replace("-", "");
    if (/^\d+$/.test(phone) && phone.length > 9) return true;
    return false;
};
const getCityList = (url, brand, searchTerm)=>{
    return api/* apim.get */.TH.get(url, {
        params: {
            $format: "json",
            brand,
            $select: "Locality",
            $filter: "StartsWith(Locality,'".concat(searchTerm, "') eq true")
        }
    });
};
const storeFilterData = (filterData)=>{
    const storeFinalData = {};
    delete filterData["jcr:primaryType"];
    const filterKeys = Object.keys(filterData);
    filterKeys.forEach((element)=>{
        delete filterData[element]["jcr:primaryType"];
        const categoryKeys = filterData[element]["categoryName"];
        const categoryList = filterData[element]["list"];
        delete categoryList["jcr:primaryType"];
        const categoryListValues = Object === null || Object === void 0 ? void 0 : Object.values(filterData[element]["list"]);
        const filteredCategoryValues = Object === null || Object === void 0 ? void 0 : Object.values(categoryListValues);
        const finalFacets = filteredCategoryValues.map((x)=>({
                label: x.displayName,
                query: x.bingName
            }));
        storeFinalData[categoryKeys] = finalFacets;
    });
    return storeFinalData;
};
const checkAlphanumeric = (value)=>{
    const pattern = /^[A-Za-z0-9 ]+$/;
    if (pattern.test(value)) {
        return true;
    }
    return false;
};
const checkAlphabetOnly = (value)=>{
    return regex/* ALPHABET_WITH_SPACE_REGEX.test */.si.test(value);
};
const getRandom = ()=>{
    if (!isServer) {
        const crypto1 = window.crypto || window.msCrypto;
        const array = new Uint32Array(1);
        return crypto1.getRandomValues(array)[0];
    } else {
        return parseInt(new Date().getTime());
    }
};
const getAnalyticsUrl = (url)=>(url.indexOf("http") === -1 ? window.location.origin : "") + url;
const getPageInfo = ()=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    return getState && getState("page") || {};
};
const formatDate = async (date)=>{
    const { internationalization: { locale: currentLocale  }  } = await (0,constants_config/* getConfig */.i)();
    const d = new Date(date);
    const options = {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
    return d.toLocaleDateString(currentLocale, options);
};
const downloadArticle = async function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, successCallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ()=>{}, downloadSuccess = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", downloadFailure = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const { target: { classList: targetClassList = {}  } = {}  } = e;
    try {
        targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.add(constants.DOWNLOAD_SPINNER);
        const { status , data , headers  } = await api/* apim.get */.TH.get("catalog/pdf-file-download?page=".concat(url), {
            responseType: "blob"
        });
        if (status === 200) {
            let filenameVal;
            if (headers["content-disposition"]) {
                const { parameters: { filename =""  } = {}  } = content_disposition_default().parse(headers["content-disposition"]);
                filenameVal = filename;
            } else {
                filenameVal = "zip";
            }
            file_download_default()(data, filenameVal);
            typeof successCallback === "function" && successCallback();
            store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
                message: downloadSuccess,
                isVisible: true
            }));
            targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.remove(constants.DOWNLOAD_SPINNER);
        } else {
            store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
                message: downloadFailure,
                isVisible: true
            }));
            targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.remove(constants.DOWNLOAD_SPINNER);
        }
    } catch (ex) {
        targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.remove(constants.DOWNLOAD_SPINNER);
        store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
            message: downloadFailure,
            isVisible: true
        }));
    }
};
const getAppliedSortPressKit = (i18n, query)=>{
    switch(query){
        case "navTitle_s+asc":
            return i18n.sortByAsc;
        case "navTitle_s+desc":
            return i18n.sortByDesc;
        case "pressReleaseDate_dt+desc":
            return i18n.sortByNewest;
        case "pressReleaseDate_dt+asc":
            return i18n.sortByOldest;
    }
    return null;
};
// Function will scroll to a particular element
const scrollToElement = (element)=>{
    element.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
    });
};
// function to get offsetTop
const getOffsetTop = (element)=>{
    let offsetTop = 0;
    while(element){
        offsetTop += element.offsetTop;
        element = element.offsetParent;
    }
    return offsetTop;
};
// Function to check part page or not
const isPartsPage = (url)=>{
    const urls = url === null || url === void 0 ? void 0 : url.split("?");
    let isPart = false;
    if ((urls === null || urls === void 0 ? void 0 : urls.length) && urls[1]) {
        isPart = url === null || url === void 0 ? void 0 : url.includes("type=part");
    } else {
        isPart = url === null || url === void 0 ? void 0 : url.includes("/support/");
    }
    return isPart;
};
const getPdpUrlParams = ()=>{
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const skuNumber = searchParams.get("skuNumber");
    const skuId = searchParams.get("skuId");
    if (skuNumber || skuId) {
        skuNumber ? searchParams.set("skuNumber", skuNumber) : searchParams.set("skuId", skuId);
        const query = "?" + searchParams.toString();
        return query;
    }
    return null;
};
const getUpSellDataByRecursion = (data)=>{
    var ref;
    let upSellContainerData = {};
    if ((ref = data[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.length) {
        let isContainerMatched = false;
        let item = {};
        for(let i = 0; i < data[":itemsOrder"].length; i++){
            var ref1;
            const key = data[":itemsOrder"][i];
            item = data[":items"][key];
            if ((0,src_utils/* isUpSellContainer */._4)(item)) {
                upSellContainerData = item;
                isContainerMatched = true;
                break;
            }
            if ((item === null || item === void 0 ? void 0 : item.hasOwnProperty(":itemsOrder")) && ((ref1 = item[":itemsOrder"]) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                for(let j = 0; j < item[":itemsOrder"].length; j++){
                    const innerKey = item[":itemsOrder"][j];
                    if (item[":items"][innerKey].hasOwnProperty(":itemsOrder")) {
                        item = item[":items"][innerKey];
                        if ((0,src_utils/* isUpSellContainer */._4)(item)) {
                            upSellContainerData = item;
                            isContainerMatched = true;
                            break;
                        }
                    }
                }
                if (isContainerMatched) break;
            }
        }
        if (!isContainerMatched) return getUpSellDataByRecursion(item);
        return upSellContainerData;
    }
    return upSellContainerData;
};
const getUpSellAuthData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isRequireToLookupFullData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1, ref2, ref3, ref4, ref5;
    let upSellAuthData = {};
    if (isEmpty_default()(data)) return {};
    let upSellContainerData = data;
    if (isRequireToLookupFullData) {
        upSellContainerData = getUpSellDataByRecursion(data);
    }
    const { searchLabelUpSell , zipUpdateLabelUpSell , zipChangeLabelUpSell , zipLabelUpSell , userTitleUpSell  } = upSellContainerData;
    const headerAuthData = {
        searchLabelUpSell,
        zipUpdateLabelUpSell,
        zipChangeLabelUpSell,
        zipLabelUpSell,
        userTitleUpSell
    };
    var ref6;
    const productCard = (ref6 = (ref = upSellContainerData[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref["container"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[":items"]) === null || ref2 === void 0 ? void 0 : ref2["productcard_v4"]) !== null && ref6 !== void 0 ? ref6 : {};
    var ref7;
    const serviceData = (ref7 = (ref3 = upSellContainerData[":items"]) === null || ref3 === void 0 ? void 0 : ref3["up_sell_services"]) !== null && ref7 !== void 0 ? ref7 : {};
    const itemsTabs = (ref4 = upSellContainerData[":items"]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4["up_sell_tabs"]) === null || ref5 === void 0 ? void 0 : ref5[":items"];
    const tabs = [];
    const tabsData = {};
    if (!isEmpty_default()(itemsTabs)) {
        for(const tabKey in itemsTabs){
            if (Object.prototype.hasOwnProperty.call(itemsTabs, tabKey)) {
                const panelTitle = itemsTabs[tabKey]["cq:panelTitle"].toLowerCase();
                tabs.push(panelTitle);
                tabsData[panelTitle] = itemsTabs[tabKey][":items"]["up_sell_services"];
            }
        }
    }
    const upSellServiceData = tabsData.length ? tabsData["services"] : serviceData;
    upSellAuthData = {
        headerAuthData,
        tabs,
        tabsData,
        productCard,
        upSellServiceData
    };
    return upSellAuthData;
};
const isUrlIncludeHttp = (url)=>{
    if (url) {
        return url.indexOf("http") !== -1;
    } else {
        return false;
    }
};
const getInternalLinkTypeForFindStore = function(store, city, state, name) {
    let isLocationPage = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    const storeName = sanitizeTextForAnalytics(store);
    const cityName = sanitizeTextForAnalytics(city);
    const stateName = sanitizeTextForAnalytics(state);
    const micrositeName = sanitizeTextForAnalytics(name);
    if (isLocationPage) return "".concat(storeName, ":").concat(cityName, ":").concat(stateName);
    return "".concat(micrositeName, ":").concat(cityName, ":").concat(stateName);
};
const getProcessedProductInfoBasedOnLineItems = async (lineItems)=>{
    var ref;
    const config = await (0,constants_config/* getConfig */.i)();
    const locale = get_default()(config, "internationalization.locale", "");
    const brandName = (ref = get_default()(config, "general.siteName", "")) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    const currency = get_default()(config, "internationalization.currencyCode", "usd");
    const currencySign = get_default()(config, "internationalization.currencySign", "$");
    const productItems = lineItems.map((item)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        var ref6;
        let discountPrice = (ref6 = item === null || item === void 0 ? void 0 : item.discountPrice) !== null && ref6 !== void 0 ? ref6 : 0;
        if ((ref = item.price) === null || ref === void 0 ? void 0 : ref.discounted) {
            discountPrice = (Number(get_default()(item.price.discounted, "value.centAmount", 0)) / 100).toFixed(2);
        }
        if (item.discountedPrice) {
            discountPrice = (Number(get_default()(item.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
        }
        const discountedPricePerQuantity = (Number(get_default()((ref2 = item === null || item === void 0 ? void 0 : (ref1 = item.discountedPrice) === null || ref1 === void 0 ? void 0 : ref1.includedDiscounts[0]) === null || ref2 === void 0 ? void 0 : ref2.discountedAmount, "centAmount", 0)) / 100).toFixed(2);
        var ref7;
        const attributes = (ref7 = (ref3 = item.variant) === null || ref3 === void 0 ? void 0 : ref3.attributes) !== null && ref7 !== void 0 ? ref7 : [];
        const productSection = get_default()(attributes.find((attr)=>attr.name === "ProductSection"), "value", null);
        let productRoom = "";
        if (productSection && productSection[0] && productSection[0][locale]) {
            productRoom = productSection[0][locale];
        }
        return {
            id: get_default()(item, "id", ""),
            sku: get_default()(item, "variant.sku", ""),
            customerFacingSKU: getAttributeValue(attributes, "CustomerFacingSKU"),
            productRoom: productRoom,
            slug: get_default()(item, "productSlug[".concat(locale, "]"), ""),
            quantity: get_default()(item, "quantity", 0),
            image: get_default()(item, "variant.images[0].url", ""),
            category: getAttributeValue(attributes, "ProductLocalCategory"),
            brand: getAttributeValue(attributes, "CustomerFacingBrand"),
            associatedServices: getAssociatedServices(attributes),
            currencySign,
            name: get_default()(attributes.find((attr)=>attr.name === "RegionBrandName"), "value", get_default()(item, "name[".concat(locale, "]"), "")),
            desc: get_default()(attributes.find((attr)=>attr.name === "ProductDescriptionProductShort"), "value[".concat(locale, "]"), get_default()(attributes.find((attr)=>attr.name === "ProductDescriptionProduct"), "value", "")),
            color: get_default()(attributes.find((attr)=>attr.name === "SKUColorFinishName"), "value[".concat(locale, "]"), ""),
            unitPrice: typeof item.unitPrice === "string" ? item.unitPrice : (Number(get_default()(item, "price.value.centAmount", 0)) / 100).toFixed(2),
            totalPrice: typeof item.totalPrice === "string" ? item.totalPrice : (Number(get_default()(item, "totalPrice.centAmount", 0)) / 100).toFixed(2),
            discountPrice: discountPrice,
            discountedPricePerQuantity: discountedPricePerQuantity,
            isComboSku: attributes.find((attr)=>attr.name === "ComboSKU") ? true : false,
            backOrder: get_default()(item, "custom.fields.isBackOrderable", false),
            businessUnitName: get_default()(attributes.find((attr)=>attr.name === "SPProductBusinessUnit"), "value", ""),
            additionalData: brandName === "annsacks" && (item === null || item === void 0 ? void 0 : (ref4 = item.custom) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : ref5.roomInfo) ? get_default()(item, "custom.fields", "") : "",
            discountsList: [],
            productCollectionsName: getAttributeValue(attributes, "ProductBrandNameDisplay") || getAttributeValue(attributes, "ProductBrandNameDisplay_t"),
            addedAt: get_default()(item, "addedAt", "")
        };
    });
    return {
        productItems,
        brandName,
        currency
    };
};
const jsonStringEscape = (jsonString)=>{
    return jsonString.replace(/\n|\t|\r|\&|\'/g, (m)=>{
        switch(m){
            case "\n":
            case "\r":
            case "	":
            case "\b":
            case "\f":
                return "";
            case "&":
                return "&amp;";
            case "'":
                return "&#8217;";
            default:
                return;
        }
    });
};
const replaceAndFunction = (str)=>{
    return str === null || str === void 0 ? void 0 : str.replace("&", "%26");
};
const getBadgeValue = (key, arry)=>{
    const badgeInfo = arry.find((item)=>item.map.Key === key);
    const { map: { Key ="" , Values: { myArrayList: badgeValue = []  } = {}  } = {}  } = badgeInfo;
    var ref;
    return {
        key: Key,
        value: (ref = badgeValue[0]) !== null && ref !== void 0 ? ref : ""
    };
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, event = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cmp:click", modifiedPageObj = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, customDataLayer = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    let page = getState && getState("page") || {};
    if (!isEmpty_default()(modifiedPageObj)) {
        page = modifiedPageObj;
    }
    const datalayerObj = {
        event,
        eventInfo,
        page
    };
    if (!isEmpty_default()(customDataLayer)) {
        for(const key in customDataLayer){
            if (Object.hasOwn(customDataLayer, key)) {
                datalayerObj[key] = customDataLayer[key];
            }
        }
    }
    window.adobeDataLayer.push(datalayerObj);
};
const hasNumber = (str)=>{
    return /\d/.test(str);
};
const generateCanonicalUrl = (url, locale, host)=>{
    if (url) {
        if ((url === null || url === void 0 ? void 0 : url.includes(".json")) && "object" !== "undefined") {
            return window.location.href;
        }
        var ref;
        const canonicalUrl = (ref = url.split("?")[0]) !== null && ref !== void 0 ? ref : url;
        return "".concat(host).concat(canonicalUrl);
    }
    return "";
};
const updateAnalyticPageUrl = (data, url)=>{
    if (data) {
        const parsedData = JSON.parse(data);
        parsedData.pageInfo.pageUrl = url;
        const analyticsData = JSON.stringify(parsedData);
        return analyticsData;
    }
    return "";
};
const sortParameterURL = ()=>{
    const url = new URL(window.location.href);
    var ref;
    const appliedSort = (ref = url.searchParams.get("sort")) !== null && ref !== void 0 ? ref : "";
    return appliedSort === null || appliedSort === void 0 ? void 0 : appliedSort.split(" ").join("+");
};
// Below util helper (removePathandHtml) is created especially when shortened URL is needed from getserversideprops function.
const removePathandHtml = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (url) {
        const { shortendPagePath =""  } = redirectmap_namespaceObject !== null && redirectmap_namespaceObject !== void 0 ? redirectmap_namespaceObject : {};
        const htmlRemovedUrl = url === null || url === void 0 ? void 0 : url.replace(".html", "");
        const pathRemovedUrl = htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortendPagePath, "");
        return pathRemovedUrl;
    }
    return null;
};
const performRedirect = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    let redirectUrl;
    let redirectType;
    const urlWithLocale = "/".concat(locale).concat(url);
    Object.keys(redirectmap_namespaceObject).forEach((key)=>{
        if (redirectmap_namespaceObject[key][url]) {
            redirectUrl = redirectmap_namespaceObject[key][url];
            redirectType = key;
        } else if (redirectmap_namespaceObject[key][urlWithLocale]) {
            redirectUrl = redirectmap_namespaceObject[key][urlWithLocale];
            redirectType = key;
        }
    });
    if (redirectUrl) {
        redirectUrl = removePathandHtml(redirectUrl);
        return {
            redirectUrl,
            url,
            redirectType
        };
    }
    return null;
};
const getPureText = (str)=>{
    return str.replace(regex/* PURE_TEXT_REGEX */.AP, "");
};
const isPriceZero = (price)=>price === "0.00" || price === 0;
const toastMsg = (msg)=>store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
        message: msg,
        isVisible: true
    }));
const addMediaToFavorites = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", successMsg = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", errMsg = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", internalLinkType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", sharedZoneName = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", videoName = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", videoId = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "";
    isAuthenticated(()=>store_0/* store.dispatch */.h.dispatch((0,favoritesSlice/* addMedia */.rA)({
            type,
            name,
            url,
            errMsg,
            internalLinkType,
            sharedZoneName,
            videoName,
            videoId,
            successCallback: ()=>toastMsg(successMsg)
        })));
};
const removeFavorites = (ids, favEle, removemsg)=>{
    isAuthenticated(()=>store_0/* store.dispatch */.h.dispatch((0,favoritesSlice/* removeItems */.Er)(ids)).unwrap().then(()=>{
            favEle.current.removeAttribute("data-id");
            favEle.current.classList.remove("favorite-filled");
            toastMsg(removemsg);
        }));
};
const organizeData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], placeHolder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", type = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", idVal = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    return data.map((item, i)=>{
        let obj = {
            title: name.length ? name[i] : "".concat(placeHolder, " ").concat(data.length > 1 ? i + 1 : "")
        };
        if (idVal) {
            obj.id = idVal + "-" + i;
        }
        if (type === "PART") {
            obj = {
                ...obj,
                id: item
            };
        } else {
            obj = {
                ...obj,
                type,
                url: item
            };
        }
        return obj;
    });
};
const getAnalyticsFileName = (file)=>{
    const { actualName ="" , title ="" , type =""  } = file;
    const fileName = actualName || sanitizeTextForAnalytics("".concat(title === null || title === void 0 ? void 0 : title.trim(), ".").concat(type));
    return fileName;
};
const getPresetUrl = function() {
    let width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, swatchUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", image = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", presetConfigs = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, scene7AccountName = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const { Desktop ="" , MobileLandscape ="" , MobilePortrait ="" , PotraitCategory =""  } = presetConfigs;
    const assetId = image.split("/").pop();
    const scene7Url = swatchUrl === null || swatchUrl === void 0 ? void 0 : swatchUrl.replace("PAWEB/", "");
    let preset = Desktop;
    if (width >= 1024) {
        preset = Desktop;
    } else if (width < 1024 && width >= 768) {
        preset = MobileLandscape;
    } else if (width < 768) {
        preset = MobilePortrait;
    }
    return "".concat(scene7Url).concat(scene7AccountName, "/").concat(PotraitCategory, "?$product_src=is{").concat(scene7AccountName, "/").concat(assetId, "}&").concat(preset);
};
const recalculateCartRoomInfo = function(lineItemId, product) {
    let setqtyLoading = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,cartSlice/* getCart */.dv)()).unwrap().then((rsp)=>{
        const actions = [];
        if (product === null || product === void 0 ? void 0 : product.roomInfo) {
            actions.push({
                action: "setLineItemCustomField",
                lineItemId: lineItemId,
                name: "roomInfo",
                value: [
                    '{"productType":"' + (product === null || product === void 0 ? void 0 : product.productType) + '","totalNeeded":"' + (product === null || product === void 0 ? void 0 : product.totalNeeded) + '","totalUserNeeded":"' + (product === null || product === void 0 ? void 0 : product.totalUserNeeded) + '","totalSFUserNeeded":"' + (product === null || product === void 0 ? void 0 : product.totalSFUserNeeded) + '","totalArea":"' + (product === null || product === void 0 ? void 0 : product.totalArea) + '","soldByBox":"' + (product === null || product === void 0 ? void 0 : product.soldByBox) + '","soldByUom":"' + (product === null || product === void 0 ? void 0 : product.soldByUom) + '"}'
                ]
            }, {
                action: "setLineItemCustomField",
                lineItemId: lineItemId,
                name: "customQuantity",
                value: (product === null || product === void 0 ? void 0 : product.soldByBox) ? Number((product === null || product === void 0 ? void 0 : product.customQuantity) * (product === null || product === void 0 ? void 0 : product.soldByBox)) : product === null || product === void 0 ? void 0 : product.customQuantity
            }, {
                action: "setLineItemCustomField",
                lineItemId: lineItemId,
                name: "totalUOM",
                value: "".concat(product === null || product === void 0 ? void 0 : product.totalArea)
            }, {
                action: "setLineItemCustomField",
                lineItemId: lineItemId,
                name: "overage",
                value: product === null || product === void 0 ? void 0 : product.overage
            }, {
                action: "changeLineItemQuantity",
                lineItemId: lineItemId,
                quantity: product === null || product === void 0 ? void 0 : product.customQuantity
            });
        } else {
            actions.push({
                action: "setLineItemCustomField",
                lineItemId: lineItemId,
                name: "customQuantity",
                value: product === null || product === void 0 ? void 0 : product.quantity
            }, {
                action: "changeLineItemQuantity",
                lineItemId: lineItemId,
                quantity: product === null || product === void 0 ? void 0 : product.quantity
            });
        }
        try {
            api/* apim.post */.TH.post("/cart/items?cartId=".concat(rsp.id, "&expand=calculation"), {
                version: rsp.version,
                actions: actions
            }).then((response)=>{
                store_0/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(response.data));
                store_0/* store.dispatch */.h.dispatch((0,cartSlice/* setCartCount */.oJ)((0,helperV2/* getQuantityCount */.PW)(response.data.lineItems)));
                setqtyLoading === null || setqtyLoading === void 0 ? void 0 : setqtyLoading(false);
            }).catch((err)=>{
                // eslint-disable-next-line no-console
                console.log(err);
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
        }
    });
};


// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./components/cart/utils.js
var cart_utils = __webpack_require__(65875);
// EXTERNAL MODULE: ./utils/constants.js
var utils_constants = __webpack_require__(11310);
// EXTERNAL MODULE: ./utils/findStore.js
var findStore = __webpack_require__(42605);
;// CONCATENATED MODULE: ./utils/helper.js
/* provided dependency */ var helper_Buffer = __webpack_require__(48764)["Buffer"];













const helper_isServer = "object" === "undefined";
const helper_extractMetasFromDOM = (doc, cb)=>{
    const metas = doc.getElementsByTagName("meta");
    for (const meta of metas){
        cb(meta);
    }
};
const convertToIndianPhoneNumber = (text)=>{
    try {
        if (text) {
            let value = text;
            // let x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            let numericOnly = value.replace(/\D/g, "");
            numericOnly = numericOnly.substring(0, 10);
            if (/^[0-9]/.test(numericOnly)) {
                return numericOnly;
            }
        // return !x[2]
        //   ? "(" + x[1]
        //   : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
        // return x;
        } else {
            return;
        }
    } catch (error) {
        log.error(error);
    }
};
const isValidPincode = (pincode)=>{
    if (!pincode) {
        return false;
    }
    return /^[0-9]{6,6}$/.test(pincode);
};
const isValidName = (name)=>{
    return /^[a-zA-Z0-9_ ]*[a-zA-Z0-9_]$/.test(name);
};
const helper_extractLinksFromDOM = (doc, cb)=>{
    const links = doc.getElementsByTagName("link");
    for (const link of links){
        cb(link);
    }
};
const helper_getAttributeValue = (attributes, name)=>get_default()(attributes.find((attr)=>attr.name === name), "value", "");
const helper_getLocationByCookies = async ()=>{
    var ref;
    const userLocation = ((ref = document.cookie.match("(^|;)\\s*userLocation\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
    let getCityData = {};
    if (userLocation !== "") {
        try {
            const splitLocation = userLocation.split("+");
            const lat = localStorage.getItem("cookiesLatitude");
            const lng = localStorage.getItem("cookiesLongitude");
            const cityData = localStorage.getItem("cookiesCityData");
            const locationTimeout = localStorage.getItem("cookiesLocationTimeout");
            if (parseFloat(lat) === splitLocation[4] && parseFloat(lng) === splitLocation[5] && cityData && locationTimeout && moment().isBefore(moment(locationTimeout))) {
                getCityData = JSON.parse(cityData);
            } else {
                const getReverseGeo = getApiServletPath();
                var _reverseGeo;
                const reverseGeoLink = (_reverseGeo = getReverseGeo.reverseGeo) !== null && _reverseGeo !== void 0 ? _reverseGeo : "";
                getCityData = await getMyCity(reverseGeoLink, splitLocation[4], splitLocation[5]);
                const localStorageData = {
                    cookiesLatitude: splitLocation[4],
                    cookiesLongitude: splitLocation[5],
                    cookiesCityData: JSON.stringify(getCityData),
                    cookiesLocationTimeout: moment().add("30", "minutes").toISOString(true)
                };
                setLocalStorageData(localStorageData);
            }
        } catch (err) {
            clearLocalStorageData("cookiesLatitude", "cookiesLongitude", "cookiesCityData", "cookiesLocationTimeout");
        }
    }
    return {
        city: get_default()(getCityData, "city", ""),
        zipcode: get_default()(getCityData, "zipcode", "")
    };
};
const helper_sanitizeInnerHtml = function(property) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0,html_react_parser/* default */.ZP)("".concat(DOMPurify.sanitize(property, {
        ADD_ATTR: [
            "target"
        ]
    })), options);
};
const helper_getClienIP = (request)=>{
    let ip = "";
    if (!request) return ip;
    if (request.headers["true-ip"]) {
        ip = request.headers["true-ip"].split(",")[0];
    } else if (request.headers["x-forwarded-for"]) {
        ip = request.headers["x-forwarded-for"].split(",")[0];
    } else if (request.headers["x-real-ip"]) {
        ip = request.connection.remoteAddress;
    } else {
        ip = request.connection.remoteAddress || "";
    }
    return ip;
};
const helper_getUserAnalyticsObject = function() {
    let isFromRegisterUser = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref, ref1, ref2, ref3, ref4, ref5;
    const hashedEmail = localStorage.getItem("hashedEmail") || ((ref = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.hashedEmail) || "";
    const customerProspect = localStorage.getItem("customerProspect") || ((ref2 = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.auth) === null || ref3 === void 0 ? void 0 : ref3.customerProspect);
    let isCustomerOrProspect = "n/a";
    if (hashedEmail && customerProspect) {
        try {
            const decryptedJSON = JSON.parse(caesarDecrypt(hashedEmail, customerProspect));
            if (decryptedJSON.pastOrders.length) {
                isCustomerOrProspect = "customer";
            } else {
                isCustomerOrProspect = "prospect";
            }
        } catch (es) {
            // eslint-disable-next-line no-console
            console.log("decrypt error: ", es);
        }
    }
    // this user object should be updated when user log in or out.
    const user = {
        gId: "n/a",
        abTestName: "n/a",
        adBlocker: false,
        authStatus: "anonymous",
        commerceToolsID: "n/a",
        customerProspect: isCustomerOrProspect,
        envName: "development",
        knownStatus: "unknown",
        profileRole: "guest",
        returningStatus: "new visitor",
        emailId: hashedEmail || "n/a"
    };
    // fetch okta tokens for both logged in and anonymous users
    const oktaToken = localStorage.getItem("okta-token-storage");
    const anonymousOktaToken = localStorage.getItem("okta-anonymous-access-token") || ((ref4 = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.auth) === null || ref5 === void 0 ? void 0 : ref5.access_token);
    if (oktaToken && oktaToken !== "{}") {
        var ref6;
        // user is logged in
        const oktaObject = JSON.parse(oktaToken);
        const claim = (oktaObject === null || oktaObject === void 0 ? void 0 : (ref6 = oktaObject.accessToken) === null || ref6 === void 0 ? void 0 : ref6.claims) || {};
        // user.uId = claim.uid || "n/a";
        if (!claim.businessType) {
            user.profileRole = "consumer";
        } else {
            user.profileRole = claim.businessType.toLowerCase();
        }
        user.commerceToolsID = claim.commercetoolsID || "n/a";
        if (!isFromRegisterUser) {
            user.returningStatus = "returning customer";
        }
        user.authStatus = "logged in";
        user.knownStatus = "known";
    } else if (anonymousOktaToken) {
        // anonymous user
        let oktaObject1;
        try {
            oktaObject1 = JSON.parse(atob(anonymousOktaToken.split(".")[1])) || {};
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Anonymous Okta Token can not be decoded......");
        }
        if (oktaObject1) {
            user.gId = oktaObject1.gId || "n/a";
        }
    }
    return user;
};
const helper_clearAuthToken = ()=>{
    localStorage.removeItem("hashedEmail");
    localStorage.removeItem("customerProspect");
    localStorage.removeItem("okta-token-storage");
    localStorage.removeItem("okta-cache-storage");
    localStorage.removeItem("okta-anonymous-access-token");
    localStorage.removeItem("anonymousId");
};
const helper_clearAnonymousToken = ()=>{
    localStorage.removeItem("anonymousId");
    localStorage.removeItem("okta-anonymous-access-token");
    localStorage.removeItem("okta-anonymous-refresh-token");
    localStorage.removeItem("token-revalidate-expiry");
};
const helper_getAccessToken = ()=>{
    var ref, ref1;
    let token = "";
    if (true) {
        token = localStorage.getItem("okta-anonymous-access-token");
    }
    if (!token) token = (ref = store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.access_token;
    if (token) {
        const tokenSplit = token.split(".")[1] || null;
        if (tokenSplit) {
            const { gId , exp  } = JSON.parse(helper_Buffer.from(tokenSplit, "base64"));
            return {
                token,
                gId,
                exp
            };
        } else {
            return {};
        }
    }
    return {
        token
    };
};
const helper_arrayMove = (arr, fromIndex, toIndex)=>{
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    return arr;
};
const helper_getCurrency = async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { currencyCode ="INR"  } = {}  } = config;
    return currencyCode;
};
const getLWData = async (body)=>{
    let cart = body;
    const updatedLineItems = await (0,product/* getLineItemAttrs */.lP)(cart === null || cart === void 0 ? void 0 : cart.lineItems);
    return {
        ...cart,
        lineItems: updatedLineItems
    };
};
const helper_calculateCartData = async (params, isCart)=>{
    var ref;
    const { i18n ={} , noShippingItems: noShippingItemsProps = [] , shippingItemstoCheckout =[] , quantityUpdatedFlag  } = params;
    let cartObject = params.cart;
    const shippingItemsProps = shippingItemstoCheckout;
    const CONFIG = await (0,constants_config/* getConfig */.i)();
    const locale = get_default()(CONFIG, "internationalization.locale", "");
    const brandName = (ref = get_default()(CONFIG, "general.siteName", "")) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    const currency = get_default()(CONFIG, "internationalization.currencyCode", "");
    let voucherDiscount = 0;
    let MRPsubtotal = 0;
    let subtotal = 0;
    let subtotalWithDiscount = 0;
    let totalPromotions = 0;
    let productPromotions = 0;
    let couponPromotions = 0;
    let estimatedShipping = 0;
    let estimatedTax = 0;
    let estimatedTotal = 0;
    let promoCodes = [];
    let oldPromoCodes = [];
    let oldDiscountCodes = [];
    const cartItems = [];
    const specFiles = [];
    const outOfStockItems = [];
    const noShippingItems = [];
    let shippingDiscountsList = 0;
    const shippingDiscountsNameList = [];
    const voucherCode = [];
    const { shippingTotal: { centAmount: shippingTotal  } = {}  } = cartObject;
    oldPromoCodes = (cartObject === null || cartObject === void 0 ? void 0 : cartObject.promoCode) || [];
    oldDiscountCodes = (cartObject === null || cartObject === void 0 ? void 0 : cartObject.discountCodes) || [];
    if ((cartObject === null || cartObject === void 0 ? void 0 : cartObject.lineItems) && (cartObject === null || cartObject === void 0 ? void 0 : cartObject.lineItems.length) > 0) {
        var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        // Get discount code details
        if (((ref1 = cartObject.promoCode) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            var _discountCodes;
            const discountCodes = (_discountCodes = cartObject.discountCodes) !== null && _discountCodes !== void 0 ? _discountCodes : [];
            cartObject.promoCode.forEach((item)=>{
                let discountName;
                if (item.code) {
                    var ref, ref1, ref2;
                    if (((ref = cartObject.discountCodes) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                        const matchedDiscountCode = cartObject.discountCodes.find((dc)=>{
                            var ref, ref1;
                            return ((ref = dc.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.code) === item.code;
                        });
                        if (matchedDiscountCode === null || matchedDiscountCode === void 0 ? void 0 : matchedDiscountCode.discountCode.obj.name[locale]) {
                            discountName = matchedDiscountCode === null || matchedDiscountCode === void 0 ? void 0 : matchedDiscountCode.discountCode.obj.name[locale];
                        }
                    }
                    var ref3, _description;
                    promoCodes.push({
                        code: item.code,
                        discount: (Number(get_default()(item, "discountedAmount.centAmount", 0)) / 100).toFixed(2),
                        id: (ref3 = (ref1 = discountCodes.find((code)=>code.discountCode.obj.code === item.code)) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discountCode) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref3 !== void 0 ? ref3 : "",
                        type: item.type,
                        description: (_description = item.description) !== null && _description !== void 0 ? _description : ""
                    });
                } else if (item.type === "product") {
                    if (promoCodes.find((p)=>p.type === "product")) {
                        const code = promoCodes.find((p)=>p.type === "product");
                        code.discount = (Number(code.discount) + Number(get_default()(item, "discountedAmount.centAmount", 0)) / 100).toFixed(2);
                    } else {
                        var _description1;
                        promoCodes.unshift({
                            code: i18n === null || i18n === void 0 ? void 0 : i18n.productDiscounts,
                            code: "Product Discounts",
                            discount: (Number(get_default()(item, "discountedAmount.centAmount", 0)) / 100).toFixed(2),
                            id: "",
                            type: "product",
                            name: discountName,
                            description: (_description1 = item.description) !== null && _description1 !== void 0 ? _description1 : ""
                        });
                    }
                } else {
                    if (promoCodes.find((p)=>p.code === (item.name || discountName))) {
                        const code1 = promoCodes.find((p)=>p.code === (item.name || discountName));
                        code1.discount = (Number(code1.discount) + Number(get_default()(item, "discountedAmount.centAmount", 0)) / 100).toFixed(2);
                    } else {
                        var ref4;
                        var _description2;
                        ((ref4 = item.discountedAmount) === null || ref4 === void 0 ? void 0 : ref4.centAmount) > 0 && promoCodes.unshift({
                            code: item.name || discountName,
                            discount: (Number(get_default()(item, "discountedAmount.centAmount", 0)) / 100).toFixed(2),
                            id: "",
                            type: "no-code",
                            description: (_description2 = item.description) !== null && _description2 !== void 0 ? _description2 : ""
                        });
                    }
                }
            });
        }
        var _lineItems;
        // Get shipping promotions
        // if (cartObject.customLineItems?.length > 0) {
        //   promoCodes = promoCodes.concat(
        //     await getShippingDiscountPromoCodes(cartObject)
        //   )
        // }
        //cartObject = cartObject?.lineItems ? await getLWData(cartObject) : []
        let lineItems = (_lineItems = cartObject.lineItems) !== null && _lineItems !== void 0 ? _lineItems : [];
        if (((ref2 = cartObject.customLineItems) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
            const cusItemWithSku = cartObject.customLineItems.map((item)=>{
                const modifiedCusItems = {
                    ...item
                };
                modifiedCusItems.sku = get_default()(item, "custom.fields.bundleSku", "");
                return modifiedCusItems;
            });
            lineItems = await (0,product/* getLineItemAttrs */.lP)([
                ...cusItemWithSku,
                ...lineItems
            ]);
        } else {
            lineItems = await (0,product/* getLineItemAttrs */.lP)(lineItems);
        }
        // if (isCart) {
        //   lineItems =
        //     cartObject.lineItems?.filter(
        //       item => !item.custom?.fields?.bundleParentId
        //     ) ?? []
        // }
        lineItems === null || lineItems === void 0 ? void 0 : lineItems.forEach((item, i)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
            //check if bundle parent
            const isBundleParent = get_default()(item, "custom.fields.isBundleParent", false);
            const isBundleChild = get_default()(item, "custom.fields.isBundleChildItem", false);
            const MRPPrice = item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.prices) === null || ref1 === void 0 ? void 0 : ref1.find((price)=>!price.customerGroup);
            if (!isBundleParent && !isBundleChild) {
                var ref13;
                MRPsubtotal = MRPsubtotal + (MRPPrice === null || MRPPrice === void 0 ? void 0 : (ref13 = MRPPrice.value) === null || ref13 === void 0 ? void 0 : ref13.centAmount) * item.quantity;
            }
            if (isBundleParent) {
                var ref14, ref15;
                MRPsubtotal = MRPsubtotal + (item === null || item === void 0 ? void 0 : (ref14 = item.custom) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.fields) === null || ref15 === void 0 ? void 0 : ref15.bundleAnyPrice) * item.quantity;
            }
            let productCategory = get_default()(item, "lwData.Product_Category");
            if (isBundleChild && productCategory === utils_constants/* INSTALL_SERVICES */._F) {
                var ref16;
                MRPsubtotal = MRPsubtotal + (MRPPrice === null || MRPPrice === void 0 ? void 0 : (ref16 = MRPPrice.value) === null || ref16 === void 0 ? void 0 : ref16.centAmount) * item.quantity;
            }
            // Get line item price
            let discountPrice = 0;
            if ((ref2 = item.price) === null || ref2 === void 0 ? void 0 : ref2.discounted) {
                discountPrice = (Number(get_default()(item.price.discounted, "value.centAmount", 0)) / 100).toFixed(2);
            }
            // if (item.discountedPrice) {
            //   discountPrice = (
            //     Number(_get(item.discountedPrice, "value.centAmount", 0)) / 100
            //   ).toFixed(2)
            // }
            if (isBundleParent) {
                discountPrice = (Number(get_default()(item, "custom.fields.bundleDiscountedPrice", 0)) / 100).toFixed(2);
            }
            // MRP Changes might need later
            if (isBundleChild) {
                discountPrice = (Number(get_default()(item.price, "value.centAmount", 0)) / 100).toFixed(2);
            }
            var _productKey;
            // Get line item details
            const masterVariantKey = (_productKey = item.productKey) !== null && _productKey !== void 0 ? _productKey : "";
            var ref17;
            const attributes = (ref17 = (ref3 = item.variant) === null || ref3 === void 0 ? void 0 : ref3.attributes) !== null && ref17 !== void 0 ? ref17 : [];
            const productSection = get_default()(attributes.find((attr)=>attr.name === "ProductSection"), "value", null);
            let productRoom;
            if (productSection && productSection[0] && productSection[0][locale]) {
                productRoom = productSection[0][locale];
            }
            const lwAttr = (0,product/* getProductAttr */.Dv)(isBundleParent ? get_default()(item, "custom.fields.bundleSku", "") : get_default()(item, "variant.sku", ""), item.lwData);
            const variantPrices = get_default()(item, "variant.prices", []);
            let notContains = (ref4 = variantPrices.filter((i)=>!i.hasOwnProperty("customerGroup"))[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.centAmount;
            let anyTotalPrice = 0;
            if (productCategory !== utils_constants/* INSTALL_SERVICES */._F) {
                anyTotalPrice = (Number(notContains) / 100).toFixed(2);
            }
            cartItems[i] = {
                id: get_default()(item, "id", ""),
                sku: isBundleParent ? get_default()(item, "custom.fields.bundleSku", "") : get_default()(item, "variant.sku", ""),
                custom: get_default()(item, "custom", ""),
                customerFacingSKU: helper_getAttributeValue(attributes, "CustomerFacingSKU"),
                productRoom: productRoom,
                slug: isBundleParent ? get_default()(item, "slug", "") : get_default()(item, "productSlug[".concat(locale, "]"), ""),
                quantity: get_default()(item, "quantity", 0),
                image: lwAttr.image,
                category: isBundleParent ? get_default()(item, "custom.fields.productLocalCategory", "") : helper_getAttributeValue(attributes, "ProductLocalCategory"),
                brand: helper_getAttributeValue(attributes, "CustomerFacingBrand") || lwAttr.brandName,
                masterVariantKey,
                name: get_default()(attributes.find((attr)=>attr.name === "ProductBrandName"), "value", get_default()(item, "name[".concat(locale, "]"), "")),
                desc: get_default()(attributes.find((attr)=>attr.name === "ProductDescriptionProductShort"), "value", get_default()(attributes.find((attr)=>attr.name === "ProductDescriptionProduct"), "value", "")),
                color: lwAttr.finishName,
                bundleMRPPrice: isBundleParent ? get_default()(item, "custom.fields.bundleAnyPrice", 0) : 0,
                unitPrice: (Number(isBundleParent ? get_default()(item, "custom.fields.bundleSalePrice", 0) : get_default()(item, "price.value.centAmount", 0)) / 100).toFixed(2),
                totalPrice: (Number(isBundleParent ? get_default()(item, "custom.fields.bundleDiscountedPrice", get_default()(item, "custom.fields.bundleSalePrice", 0)) * get_default()(item, "state[0].quantity", 1) : get_default()(item, "totalPrice.centAmount", 0)) / 100).toFixed(2),
                discountPrice: discountPrice,
                isComboSku: attributes.find((attr)=>attr.name === "ComboSKU") ? true : false,
                backOrder: get_default()(item, "custom.fields.isBackOrderable", false),
                businessUnitName: get_default()(attributes.find((attr)=>attr.name === "SPProductBusinessUnit"), "value", ""),
                additionalData: brandName === "annsacks" && (item === null || item === void 0 ? void 0 : (ref6 = item.custom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.roomInfo) ? get_default()(item, "custom.fields", "") : "",
                discountsList: [],
                productCollectionsName: helper_getAttributeValue(attributes, "ProductBrandNameDisplay") || helper_getAttributeValue(attributes, "ProductBrandNameDisplay_t"),
                addedAt: get_default()(item, "addedAt", ""),
                isBundleChildItem: get_default()(item, "custom.fields.isBundleChildItem", false),
                parentBundleSku: get_default()(item, "custom.fields.parentBundleSku", ""),
                isBundleParent,
                prices: item === null || item === void 0 ? void 0 : (ref8 = item.variant) === null || ref8 === void 0 ? void 0 : ref8.prices,
                totalBasePrice: anyTotalPrice
            };
            if (quantityUpdatedFlag) {
                var ref18;
                if (quantityUpdatedFlag === ((ref18 = cartItems[i].customerFacingSKU) === null || ref18 === void 0 ? void 0 : ref18.toLowerCase())) {
                    cartItems[i].productUpdated = true;
                } else {
                    cartItems[i].productUpdated = false;
                }
            }
            cartItems[i].superSku = cartItems[i].isComboSku;
            //Get bundle discounts
            if (isBundleParent || isBundleChild) {
                if (cartItems[i].discountPrice > 0) {
                    const { totalPrice , unitPrice , quantity  } = cartItems[i];
                    const totalUnitPrice = unitPrice * quantity;
                    const discountPercent = (totalUnitPrice - totalPrice) / totalUnitPrice * 100;
                    cartItems[i].discountPercent = discountPercent.toFixed(2);
                }
            }
            // Get line item discounts
            if ((ref9 = item.price) === null || ref9 === void 0 ? void 0 : ref9.discounted) {
                var ref19, ref20, ref21, ref22;
                const isAbs = ((ref19 = item.price) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.discounted) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.discount) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.obj) === null || ref22 === void 0 ? void 0 : ref22.value.type) === "absolute";
                const isRel = !isAbs;
                if (isAbs) {
                    cartItems[i].discountAmount = Number(get_default()(item.price.discounted, "discount.obj.value.money[0].centAmount", 0) / 100);
                } else {
                    var ref23, ref24;
                    cartItems[i].discountPercent = Number(get_default()(item.price.discounted, "discount.obj.value.permyriad", 0) / 100);
                    if ((ref23 = item.price.discounted.discount) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.obj) === null || ref24 === void 0 ? void 0 : ref24.name[locale]) {
                        // sitewide discount
                        cartItems[i].discountsList.push({
                            type: "sitewide",
                            isAbs,
                            isRel,
                            percent: isRel ? cartItems[i].discountPercent : 0,
                            absolute: cartItems[i].discountAmount || 0,
                            code: item.price.discounted.discount.obj.name[locale]
                        });
                    }
                }
            }
            if ((ref10 = item.discountedPrice) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.includedDiscounts) === null || ref11 === void 0 ? void 0 : ref11.length) {
                item.discountedPrice.includedDiscounts.forEach((includedDiscountItem)=>{
                    var ref, ref1, ref2, ref3;
                    const isAbs = ((ref = includedDiscountItem.discount) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.value.type) === "absolute";
                    const isRel = ((ref2 = includedDiscountItem.discount) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.obj) === null || ref3 === void 0 ? void 0 : ref3.value.type) === "relative";
                    if (isAbs) {
                        cartItems[i].discountAmount = Number(get_default()(includedDiscountItem, "discount.obj.value.money[0].centAmount", 0) / 100);
                    } else if (isRel) {
                        cartItems[i].discountPercent = Number(get_default()(includedDiscountItem, "discount.obj.value.permyriad", 0) / 100);
                    }
                    if (isAbs || isRel) {
                        var ref4, ref5;
                        const otherDiscount = get_default()(includedDiscountItem, "discount.obj.name[".concat(locale, "]"), null);
                        const lineItemDiscountName = (ref4 = cartObject.promoCode) === null || ref4 === void 0 ? void 0 : ref4.find((p)=>p.type === "order" && p.name === otherDiscount);
                        if (otherDiscount && lineItemDiscountName) {
                            // capture discounts like buy 1 get 1 free. could be like installation service free on design service
                            const matchedOrderDiscount = promoCodes.find((p)=>p.type === "no-code" && p.code === otherDiscount);
                            if (matchedOrderDiscount) {
                                // sitewide discount
                                cartItems[i].discountsList.push({
                                    type: "sitewide",
                                    percent: isRel ? cartItems[i].discountPercent : 0,
                                    absolute: cartItems[i].discountAmount || 0,
                                    isAbs,
                                    isRel,
                                    code: matchedOrderDiscount.code
                                });
                            }
                        }
                        // find code from discountCode
                        if ((ref5 = cartObject.discountCodes) === null || ref5 === void 0 ? void 0 : ref5.length) {
                            cartObject.discountCodes.forEach((discountCode)=>{
                                const cartDiscounts = get_default()(discountCode, "discountCode.obj.cartDiscounts", []);
                                if (cartDiscounts === null || cartDiscounts === void 0 ? void 0 : cartDiscounts.length) {
                                    cartDiscounts.forEach((discountItem)=>{
                                        if (discountItem.id === includedDiscountItem.discount.obj.id) {
                                            // All coupon discounts
                                            cartItems[i].discountsList.push({
                                                type: "cart",
                                                isAbs,
                                                isRel,
                                                percent: cartItems[i].discountPercent || 0,
                                                absolute: cartItems[i].discountAmount || 0,
                                                code: discountCode.discountCode.obj.code
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            }
            const channels = Object.values(get_default()(item, "variant.availability.channels", {}));
            cartItems[i].availableQty = channels.reduce((acc, cur)=>acc + cur.availableQuantity, 0);
            if (!isBundleParent) {
                // Check if item is out of stock
                if (checkStock(cartItems[i].backOrder, cartItems[i].category)) {
                    if (cartItems[i].availableQty < cartItems[i].quantity) {
                        cartItems[i].outOfStock = true;
                        outOfStockItems.push(cartItems[i]);
                    }
                }
            }
            // get lead time if item is back ordered
            if (cartItems[i].backOrder === true) {
                cartItems[i].leadTime = get_default()(attributes.find((attr)=>attr.name === "RegionLeadTime"), "value", 0);
            }
            // // get lead time if item is back ordered
            // if (cartObject?.newLineItems?.length) {
            //   const lineItemObj = cartObject?.newLineItems.filter(
            //     item => item.sku === cartItems[i].sku
            //   )
            //   cartItems[
            //     i
            //   ].leadTime = `${lineItemObj?.[0]?.eta?.minDay} - ${lineItemObj?.[0]?.eta?.maxDay}`
            // }
            // Check if all items are avilable for shipping
            if (noShippingItemsProps === null || noShippingItemsProps === void 0 ? void 0 : noShippingItemsProps.includes((ref12 = item.variant) === null || ref12 === void 0 ? void 0 : ref12.sku)) {
                cartItems[i].noShipping = true;
                noShippingItems.push(cartItems[i]);
            } else if (shippingItemsProps) {
                const shipmentItem = shippingItemsProps === null || shippingItemsProps === void 0 ? void 0 : shippingItemsProps.find((shippingItem)=>shippingItem.lineItemId === item.id);
                if (shipmentItem && shipmentItem.warningMessage) {
                    if (shipmentItem.parentLineItemId) {
                        const parentIndex = cartItems.findIndex((c)=>c.id === shipmentItem.parentLineItemId);
                        if (parentIndex >= 0 && !cartItems[parentIndex].noShipping) {
                            cartItems[parentIndex].noShipping = true;
                            noShippingItems.push(cartItems[parentIndex]);
                        }
                    } else {
                        cartItems[i].noShipping = true;
                        noShippingItems.push(cartItems[i]);
                    }
                }
            }
            // Get spec files for all line items
            const productResources = get_default()(attributes.find((attr)=>attr.name === "ProductResource"), "value", []);
            if (productResources.length > 0) {
                var ref25;
                const resource = (ref25 = productResources.find((arr)=>arr[1].value === "SpecPDFFileName")) !== null && ref25 !== void 0 ? ref25 : [];
                var ref26;
                const resourceUrl = (ref26 = resource.find((obj)=>obj.name === "ResourceFullWebURL")) !== null && ref26 !== void 0 ? ref26 : {};
                var _value;
                const specFileUrl = (_value = resourceUrl.value) !== null && _value !== void 0 ? _value : "";
                if (specFileUrl) specFiles.push(specFileUrl);
            }
        });
        var ref11;
        // Get order summary price amounts
        subtotal = Number(((ref11 = (ref3 = cartObject.subtotalWithoutDiscount) === null || ref3 === void 0 ? void 0 : ref3.centAmount) !== null && ref11 !== void 0 ? ref11 : 0) / 100).toFixed(2);
        var ref12;
        subtotalWithDiscount = Number(((ref12 = (ref4 = cartObject.subtotalWithPromotion) === null || ref4 === void 0 ? void 0 : ref4.centAmount) !== null && ref12 !== void 0 ? ref12 : 0) / 100).toFixed(2);
        var ref13;
        totalPromotions = Number(((ref13 = (ref5 = cartObject.totalPromo) === null || ref5 === void 0 ? void 0 : ref5.centAmount) !== null && ref13 !== void 0 ? ref13 : 0) / 100).toFixed(2);
        var ref14;
        const promoDiscounts = (ref14 = cartObject === null || cartObject === void 0 ? void 0 : (ref6 = cartObject.promoCode) === null || ref6 === void 0 ? void 0 : ref6.filter((promo)=>promo.type === "product")) !== null && ref14 !== void 0 ? ref14 : [];
        var ref15;
        const couponDiscounts = (ref15 = cartObject === null || cartObject === void 0 ? void 0 : (ref7 = cartObject.promoCode) === null || ref7 === void 0 ? void 0 : ref7.filter((promo)=>promo.type === "order")) !== null && ref15 !== void 0 ? ref15 : [];
        if (promoDiscounts === null || promoDiscounts === void 0 ? void 0 : promoDiscounts.length) {
            productPromotions = promoDiscounts.reduce((accumulator, currentValue)=>accumulator + currentValue.discountedAmount.centAmount, 0);
        }
        if (cartObject.customLineItems) {
            for (let lineItem of cartObject === null || cartObject === void 0 ? void 0 : cartObject.customLineItems){
                var ref16, ref17, ref18, ref19;
                const bundleDiscountedPrice = (lineItem === null || lineItem === void 0 ? void 0 : (ref16 = lineItem.custom) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.fields) === null || ref17 === void 0 ? void 0 : ref17.bundleSalePrice) - (lineItem === null || lineItem === void 0 ? void 0 : (ref18 = lineItem.custom) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.fields) === null || ref19 === void 0 ? void 0 : ref19.bundleDiscountedPrice);
                if (!isNaN(bundleDiscountedPrice)) {
                    productPromotions = productPromotions + bundleDiscountedPrice;
                }
            }
        }
        productPromotions = Number((productPromotions !== null && productPromotions !== void 0 ? productPromotions : 0) / 100).toFixed(2);
        if (couponDiscounts === null || couponDiscounts === void 0 ? void 0 : couponDiscounts.length) {
            couponPromotions = couponDiscounts.reduce((accumulator, currentValue)=>accumulator + currentValue.discountedAmount.centAmount, 0);
        }
        couponPromotions = Number((couponPromotions !== null && couponPromotions !== void 0 ? couponPromotions : 0) / 100).toFixed(2);
        var ref20;
        estimatedTax = Number((ref20 = cartObject === null || cartObject === void 0 ? void 0 : (ref8 = cartObject.custom) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : ref9.totalTaxAmountOfCart) !== null && ref20 !== void 0 ? ref20 : 0).toFixed(2);
        estimatedShipping = Number((shippingTotal !== null && shippingTotal !== void 0 ? shippingTotal : 0) / 100).toFixed(2);
        var ref21;
        estimatedTotal = Number(((ref21 = (ref10 = cartObject.estimatedTotal) === null || ref10 === void 0 ? void 0 : ref10.centAmount) !== null && ref21 !== void 0 ? ref21 : 0) / 100).toFixed(2);
        // checking shipping related discounts and adding it to price object
        promoCodes === null || promoCodes === void 0 ? void 0 : promoCodes.forEach((promo)=>{
            if (promo.type === "shipping" || promo.type === "no-code") {
                shippingDiscountsList += Number(promo.discount);
                shippingDiscountsNameList.push(promo.code);
            }
        });
        // Add shipping promotions to total promotions
        promoCodes.filter((item)=>item.type === "shipping").forEach((item)=>{
            estimatedShipping = Number(estimatedShipping) + Number(item.discount);
        // totalPromotions = Number(totalPromotions) + Number(item.discount)
        });
    }
    promoCodes === null || promoCodes === void 0 ? void 0 : promoCodes.forEach((itm)=>{
        voucherCode.push(itm.code);
        voucherDiscount += Number(itm.discount);
    });
    const analyticsCartItems = await helper_getCartItemsAnalyticsData(cartItems);
    const cart = {
        cartID: cartObject === null || cartObject === void 0 ? void 0 : cartObject.id,
        price: {
            basePrice: parseFloat(subtotal) || 0,
            voucherCode: voucherCode.length ? voucherCode.join("|") : "n/a",
            voucherDiscount: voucherDiscount ? Number(voucherDiscount.toFixed(2)) : 0,
            globalOffer: shippingDiscountsNameList ? shippingDiscountsNameList.join("|") || "n/a" : "n/a",
            globalDiscount: shippingDiscountsList ? Number(shippingDiscountsList.toFixed(2)) : 0,
            currency: currency.toLowerCase(),
            taxRate: parseFloat(estimatedTax) || 0,
            shipping: estimatedShipping ? Number(estimatedShipping) : "n/a",
            priceWithTax: parseFloat(estimatedTotal) || 0,
            cartTotal: parseFloat(subtotal) || 0,
            couponCode: "n/a",
            couponDiscount: 0,
            orderCouponCode: "n/a",
            orderCouponDiscount: 0,
            shippingMethod: "ground"
        },
        ...analyticsCartItems
    };
    // cartItems.forEach(e => {
    //   const matchedItem = analyticsCartItems?.item?.find(
    //     i => i.productInfo.productID === e.customerFacingSKU
    //   )
    //   if (matchedItem) {
    //     e.customProductInfo = sanitizeDOMString(JSON.stringify(matchedItem))
    //   }
    // })
    cartItems.sort((prev, curr)=>{
        return new Date(curr.addedAt) - new Date(prev.addedAt);
    });
    // sanitizeObject(cartItems)
    // sanitizeObject(cart)
    const getFreightDiscountTotal = function() {
        let codes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        let total = 0;
        codes.filter((e)=>{
            if (e.name === "Freight Shipping") {
                total += Number(e.discount);
            }
        });
        return total;
    };
    const freightDiscountTotal = getFreightDiscountTotal(promoCodes);
    //map child items to partent
    cartItems.forEach((product)=>{
        if (product.isBundleParent) {
            product.bundleItems = cartItems.filter((item)=>{
                var ref, ref1;
                return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.parentBundleSku) === product.sku;
            });
        }
    });
    MRPsubtotal = Number((MRPsubtotal !== null && MRPsubtotal !== void 0 ? MRPsubtotal : 0) / 100).toFixed(2);
    totalPromotions = Number(totalPromotions) + (Number(MRPsubtotal) - Number(subtotal));
    return {
        oldPromoCodes,
        oldDiscountCodes,
        cartItems,
        MRPsubtotal,
        subtotal,
        subtotalWithDiscount,
        totalPromotions,
        couponPromotions,
        productPromotions,
        estimatedTax,
        estimatedShipping,
        estimatedTotal,
        shippingTotal: shippingTotal / 100,
        promoCodes,
        specFiles,
        outOfStockItems,
        noShippingItems,
        shippingDiscountsNameList,
        shippingDiscountsList,
        cart,
        freightDiscountTotal
    };
};
const helper_getCartItemType = function() {
    let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", businessUnitName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (!category && !businessUnitName) {
        return "n/a";
    }
    category = category.toLowerCase();
    businessUnitName = businessUnitName.toLowerCase();
    if (category === "install services" || category === "design services" || category === "services") {
        return "service";
    }
    if (category === "samples") {
        return "sample";
    }
    if (category === "parts" || category === "service parts" || businessUnitName.indexOf("serviceparts") !== -1 || businessUnitName === "service parts") {
        return "part";
    }
    return "product";
};
const helper_sanitizeTextForAnalytics = function() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return text ? String(text).replace(regex/* SANITIZE_TEXT_REGEX */.If, "").toLowerCase().trim() : "n/a";
};
const helper_getCartItemsAnalyticsData = async (cartItems)=>{
    // first parameter should be cartItems
    const { general  } = await (0,constants_config/* getConfig */.i)();
    const data = {
        item: []
    };
    cartItems.forEach((item)=>{
        var ref, ref1;
        const siteWideCoupanCode = [];
        const productCouponCode = [];
        const discountPercents = [];
        let productCoupondiscount = 0;
        let siteWideDiscount = 0;
        let newDiscountPercentage = 0;
        if ((ref = item.discountsList) === null || ref === void 0 ? void 0 : ref.length) {
            item.discountsList.forEach((discountItem)=>{
                if (discountItem.type === "sitewide") {
                    var ref;
                    // always apply sitewide discount first then remaining can be applied
                    siteWideDiscount += Number(item.unitPrice) * (discountItem.percent / 100);
                    siteWideCoupanCode.push((ref = discountItem.code) === null || ref === void 0 ? void 0 : ref.toLowerCase());
                } else {
                    // there can be multiple product coupon codes
                    discountPercents.push(discountItem.percent);
                    productCouponCode.push(discountItem.code);
                }
            });
            if (discountPercents.length) {
                let priceAfterDiscount = Number(item.unitPrice) - siteWideDiscount;
                let temporaryCouponPrice;
                for (const disc of discountPercents){
                    temporaryCouponPrice = Number((priceAfterDiscount * (disc / 100)).toFixed(2));
                    priceAfterDiscount = priceAfterDiscount - temporaryCouponPrice;
                    productCoupondiscount += temporaryCouponPrice;
                }
                productCoupondiscount = Number(productCoupondiscount.toFixed(2));
            }
        } else if (Number(item.totalBasePrice) > Number(item.unitPrice)) {
            newDiscountPercentage = (Number(item.totalBasePrice) - Number(item.unitPrice)) / Number(item.totalBasePrice) * 100;
            newDiscountPercentage = Number(newDiscountPercentage.toFixed(2));
        }
        const otherItem = {};
        if (item.productUpdated === true || item.productUpdated === false) {
            otherItem.productUpdated = item.productUpdated;
        }
        const newDiscount = Number((item === null || item === void 0 ? void 0 : item.totalBasePrice) - item.unitPrice);
        const globalDiscount = siteWideDiscount ? siteWideDiscount : Number(item === null || item === void 0 ? void 0 : item.totalBasePrice) > 0 ? newDiscount : 0;
        const globalPromotionPrice = Number(item === null || item === void 0 ? void 0 : item.totalBasePrice) > 0 ? Number(item.unitPrice) : Number(item === null || item === void 0 ? void 0 : item.totalBasePrice);
        const itemType = helper_getCartItemType(item.category, item.businessUnitName);
        data.item.push({
            productInfo: {
                productBrand: general === null || general === void 0 ? void 0 : (ref1 = general.siteName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(),
                productID: item.customerFacingSKU || item.sku,
                description: helper_sanitizeTextForAnalytics(item.desc),
                productCategory: helper_sanitizeTextForAnalytics(item.category),
                productName: helper_sanitizeTextForAnalytics(item.name || item.desc || item.category),
                productColor: helper_sanitizeTextForAnalytics(item.color),
                productRoom: helper_sanitizeTextForAnalytics(item.productRoom || (itemType === "service" ? itemType : "non-catalog")),
                productSaleable: true,
                productStatus: !checkStock(item.backOrder, item.category) || item.availableQty >= item.quantity || itemType === "service" ? "in stock" : "out of stock",
                productPartnerBuyNow: false,
                productBasePrice: Number(item === null || item === void 0 ? void 0 : item.totalBasePrice) > 0 ? Number(item === null || item === void 0 ? void 0 : item.totalBasePrice) : Number(item.unitPrice),
                productCouponCode: productCouponCode.join("|") || "n/a",
                productCoupondiscount: productCoupondiscount || 0,
                productSuperSku: item.superSku ? true : false,
                productSalePrice: item.discountPrice ? Number(item.discountPrice) : Number(item.unitPrice),
                globalPromotionPrice: Number(globalPromotionPrice.toFixed(2)),
                defaultImageName: item.image || "n/a",
                priceState: item.discountPercent > 0 ? "percentOff|" + item.discountPercent : item.discountAmount > 0 ? "priceOff|" + item.discountAmount : newDiscountPercentage > 0 ? "percentOff|" + newDiscountPercentage : "regular price",
                productCollectionsName: helper_sanitizeTextForAnalytics(item.productCollectionsName || item.category),
                productFindingMethod: "n/a",
                productTileName: helper_sanitizeTextForAnalytics(item.name || item.desc),
                quantity: item.quantity,
                globalOffer: siteWideCoupanCode.join("|") || "n/a",
                globalDiscount: Number(globalDiscount.toFixed(2)),
                itemType,
                isSubscription: false,
                isRecommended: false,
                frequency: "n/a",
                isSendNow: "n/a",
                ratings: "n/a",
                numberOfReviews: "n/a",
                pdpType: "regular finished goods & service parts",
                ...otherItem
            },
            quantity: item.quantity
        });
    });
    return data;
};
const helper_updateObject = (objRef, objKey)=>{
    objRef[objKey] = sanitizeDOMString(objRef[objKey]);
    return objRef;
};
const helper_formatFacetName = (name, filter, facetLabels)=>{
    let val = facetLabels && facetLabels[name.replace(/^\*{2}/, "")] ? facetLabels[name.replace(/^\*{2}/, "")] : name.replace(/\./g, "/").replace(/_/g, " ").replace(/^\*{2}/, "");
    if (filter) val += " - ".concat(filter);
    return val;
};
const helper_getFacetsFromUrl = function() {
    let marketParamValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const currFilters = [];
    const urlParams = window.location.search;
    const aMarkettingParameters = marketParamValues === null || marketParamValues === void 0 ? void 0 : marketParamValues.marketParamValues;
    if (urlParams) {
        urlParams.replace("?", "").split("&").forEach((filter)=>{
            if (filter.split("=")[0] !== "title" && filter.split("=")[0] !== "id" && filter.split("=")[0] !== "keyword" && filter.split("=")[0] !== "compare" && filter.split("=")[0] !== "back" && filter.split("=")[0] !== "sort" && filter.split("=")[0] !== "activeTab" && filter.split("=")[0] !== "tab" && filter.split("=")[0] !== "skuSearch" && filter.split("=")[0] !== "service" && !(aMarkettingParameters === null || aMarkettingParameters === void 0 ? void 0 : aMarkettingParameters.includes(filter.split("=")[0]))) {
                const facet = decodeURIComponent(filter.split("=")[0]);
                if (facet === "wcmmode") return;
                const decode = decodeURIComponent(filter);
                let value = decode && decode.split("=")[1].split(",");
                value = value.map((val)=>val.replace(/[+]/g, " "));
                let display = decode && decode.split("=")[1].split(",");
                display = display.map((val)=>val.replace(/[+]/g, " "));
                const filterName = decode.split("=")[0];
                display = display.map((d)=>d.replace(/\\/g, ""));
                // format price range filter
                if (filterName === "Price_Range") {
                    display = display.map((range)=>helper_formatPriceRange(range));
                }
                // Check if the filter attribute already exists
                let checkFacet = false;
                currFilters.map((item)=>{
                    checkFacet = Object.values(item).includes(facet);
                });
                // Add a new filter or add values to existing filter
                if (!checkFacet) {
                    currFilters.push({
                        facet: facet,
                        value: value,
                        display: display
                    });
                } else {
                    currFilters.forEach((fc)=>{
                        if (facet === fc.facet) {
                            fc.value.push(value);
                            fc.display.push(display);
                        }
                    });
                }
            }
        });
    }
    return currFilters.filter((currFilter)=>currFilter.facet !== "sort");
};
const helper_getAllFilterQueries = function(componentProps) {
    let fusion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, marketParamValues = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    let currFilters = [];
    const urlFilters = helper_getFacetsFromUrl(marketParamValues);
    var ref;
    const facetFields = (ref = fusion["facet.field"]) !== null && ref !== void 0 ? ref : [];
    var ref1;
    const facetLabels = (ref1 = fusion === null || fusion === void 0 ? void 0 : fusion.facet_labels) !== null && ref1 !== void 0 ? ref1 : {};
    if (urlFilters.length > 0) {
        urlFilters.forEach((f)=>{
            let facetQuery = f.facet === "Price_Range" ? "Price_Range" : Object.keys(facetLabels).find((key)=>facetLabels[key] === f.facet.replace(/_/g, " "));
            if (typeof facetFields === "string") {
                if (facetFields === null || facetFields === void 0 ? void 0 : facetFields.includes((f)=>f === facetQuery)) {
                    facetQuery = "**".concat(facetQuery);
                }
            } else {
                if (facetFields === null || facetFields === void 0 ? void 0 : facetFields.find((f)=>f === facetQuery)) {
                    facetQuery = "**".concat(facetQuery);
                }
            }
            if (facetQuery) {
                f.facet = facetQuery;
            }
        });
    }
    //helper to push data
    function pushFilter(name, value) {
        if (facetFields === null || facetFields === void 0 ? void 0 : facetFields.includes((f)=>f === name)) {
            name = "**".concat(name);
        }
        const filterExists = currFilters.find((item)=>item.facet === name);
        if (filterExists) {
            var ref, ref1;
            (ref = filterExists.value) === null || ref === void 0 ? void 0 : ref.push(value.replace(/"/g, '\\"'));
            (ref1 = filterExists.display) === null || ref1 === void 0 ? void 0 : ref1.push(value);
        } else {
            currFilters.push({
                facet: name,
                value: [
                    value.replace(/"/g, '\\"')
                ],
                display: [
                    value
                ]
            });
        }
    }
    // Set pre-selected filters
    if ((urlFilters === null || urlFilters === void 0 ? void 0 : urlFilters.length) === 0 && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributeName) !== "" && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue) !== "") {
        let facetQuery = componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributeName;
        if (Array.isArray(facetQuery)) {
            facetQuery.forEach((query, i)=>{
                pushFilter(query, componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue[i]);
            });
        } else {
            pushFilter(facetQuery, componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue);
        }
    }
    currFilters = [
        ...currFilters,
        ...urlFilters
    ];
    console.log("filters", currFilters);
    return currFilters;
};
const helper_mapStateToCountryHandler = function() {
    let countryData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], stateData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const data = [];
    countryData.map((country)=>{
        data.push({
            code: country.value,
            name: country.text,
            states: []
        });
    });
    stateData.map((state)=>{
        var ref, ref1, ref2;
        const countryCode = (ref = state.value) === null || ref === void 0 ? void 0 : ref.split(":")[1];
        (ref1 = data.find((country)=>country.code === countryCode)) === null || ref1 === void 0 ? void 0 : ref1.states.push({
            code: (ref2 = state.value) === null || ref2 === void 0 ? void 0 : ref2.split(":")[0],
            name: state.text
        });
    });
    return data;
};
const randomWholeNumber = (min, max)=>Math.floor(Math.random() * (max - min + 1) + min);
const getProductDetails = function() {
    let cartArray = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isBundleParent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, productData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    let cartItem = null;
    if (isBundleParent) {
        cartItem = cartArray.customLineItems.find((item)=>{
            var ref, ref1;
            return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleSku) === sku;
        });
    } else {
        const cartItems = cartArray.lineItems.filter((item)=>{
            var ref, ref1;
            return item.variant.sku === sku && !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.isBundleChildItem);
        });
        if (cartItems && cartItems.length) {
            if (cartItems.length > 1 && (productData === null || productData === void 0 ? void 0 : productData.sku)) {
                cartItem = cartItems.find((item)=>{
                    var ref, ref1;
                    return (item === null || item === void 0 ? void 0 : (ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.associatedProduct) === productData.sku;
                });
            } else {
                cartItem = cartItems[0];
            }
        }
    }
    const isInstallService = isBundleParent ? (0,cart_utils/* isBundleWithInstallation */.u1)(sku, cartArray.lineItems) : cartItem === null || cartItem === void 0 ? void 0 : (ref = cartItem.custom) === null || ref === void 0 ? void 0 : ref.fields.hasOwnProperty("associatedService");
    let installProduct = null;
    if (isBundleParent && isInstallService) {
        var ref18;
        installProduct = (ref18 = productData.bundleItems) === null || ref18 === void 0 ? void 0 : ref18.find((item)=>item.category === "Install Services");
    }
    const installServiceName = isInstallService && (installProduct ? installProduct.sku : cartItem === null || cartItem === void 0 ? void 0 : (ref1 = cartItem.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.associatedService);
    const installServiceQty = isInstallService && (installProduct ? installProduct.quantity : cartItem === null || cartItem === void 0 ? void 0 : (ref3 = cartItem.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.associatedServiceQty);
    const installServiceData = isInstallService && (installProduct !== null && installProduct !== void 0 ? installProduct : cartArray === null || cartArray === void 0 ? void 0 : (ref5 = cartArray.lineItems) === null || ref5 === void 0 ? void 0 : ref5.find((item)=>{
        var ref, ref1, ref2;
        return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) === installServiceName && (item === null || item === void 0 ? void 0 : (ref1 = item.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.associatedProduct) === productData.sku;
    }));
    const totalInstallServiceQty = isInstallService && (installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.quantity);
    const warehouses = isInstallService && (cartItem === null || cartItem === void 0 ? void 0 : (ref6 = cartItem.custom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.warehouses);
    const curWarehouses = cartItem === null || cartItem === void 0 ? void 0 : (ref8 = cartItem.custom) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : ref9.warehouses;
    const isInstallItem = isBundleParent ? false : (cartItem === null || cartItem === void 0 ? void 0 : (ref10 = cartItem.variant) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : ref11.findIndex((attribute)=>attribute.name === "ProductLocalCategory" && attribute.value === "Install Services")) !== -1;
    var ref19;
    const cartQuantity = (ref19 = cartItem === null || cartItem === void 0 ? void 0 : cartItem.quantity) !== null && ref19 !== void 0 ? ref19 : 1;
    const lineItemId = cartItem === null || cartItem === void 0 ? void 0 : cartItem.id;
    var ref20;
    const isBackOrder = (ref20 = cartItem === null || cartItem === void 0 ? void 0 : (ref12 = cartItem.custom) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.fields) === null || ref13 === void 0 ? void 0 : ref13.isBackOrderable) !== null && ref20 !== void 0 ? ref20 : false;
    const brand = get_default()(cartItem === null || cartItem === void 0 ? void 0 : (ref14 = cartItem.variant) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.attributes) === null || ref15 === void 0 ? void 0 : ref15.find((attr)=>attr.name === "CustomerFacingBrand"), "value", "");
    const section = cartItem === null || cartItem === void 0 ? void 0 : (ref16 = cartItem.custom) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.fields) === null || ref17 === void 0 ? void 0 : ref17.section;
    return {
        totalInstallServiceQty,
        cartItem,
        isInstallService,
        installServiceName,
        installServiceQty,
        warehouses,
        isInstallItem,
        cartQuantity,
        lineItemId,
        isBackOrder,
        brand,
        curWarehouses,
        section
    };
};
const helper_extractScriptsFromDOM = (doc, cb)=>{
    const scripts = doc.getElementsByTagName("script");
    for (const script of scripts){
        const scriptItem = {};
        const src = script.getAttribute("src") || "";
        const type = script.getAttribute("type") || "";
        const integrity = script.getAttribute("integrity") || "";
        const charset = script.getAttribute("charset") || "";
        const dataDomainScript = script.getAttribute("data-domain-script") || "";
        if (src) scriptItem.src = src;
        if (charset) scriptItem.charset = charset;
        if (dataDomainScript) scriptItem.dataDomainScript = dataDomainScript;
        if (type) scriptItem.type = type;
        if (integrity) scriptItem.integrity = integrity;
        if (script.innerHTML) scriptItem.innerHTML = script.innerHTML;
        if ("https://www.kohler.com/corporate/include-consent-banner.js" !== src) {
            cb(scriptItem);
        }
    }
};
const helper_extractStylesFromDOM = (doc, cb)=>{
    const styles = doc.getElementsByTagName("style");
    for (const style of styles){
        if (style.innerHTML) cb(style.innerHTML);
    }
};
const helper_getScriptsAndStyles = (jsonData)=>{
    const scriptsList = [];
    const stylesList = [];
    const dataRecursion = (jsonData)=>{
        jsonData && (jsonData === null || jsonData === void 0 ? void 0 : jsonData[":itemsOrder"]) && (jsonData === null || jsonData === void 0 ? void 0 : jsonData[":itemsOrder"].map((key, index)=>{
            var ref;
            const jsonItem = jsonData[":items"][key];
            if ((ref = jsonItem[":type"]) === null || ref === void 0 ? void 0 : ref.includes(constants.COMPONENT_TYPES.EMBED)) {
                const doc = new DOMParser().parseFromString(jsonItem === null || jsonItem === void 0 ? void 0 : jsonItem.script, "text/html");
                helper_extractScriptsFromDOM(doc, (item)=>scriptsList.push(item));
                helper_extractStylesFromDOM(doc, (item)=>stylesList.push(item));
            } else {
                return dataRecursion(jsonItem);
            }
        }));
    };
    dataRecursion(jsonData);
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setGlobalScripts */.n8)(scriptsList));
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setGlobalStyles */.cw)(stylesList));
    return scriptsList;
};
const helper_removeAndCleanLink = (link)=>{
    return link ? link === null || link === void 0 ? void 0 : link.split("/content/kohler-india/in").join("").replace(".html", "") : link;
};
const removeAndCleanLinkConcat = (link)=>{
    return link ? link === null || link === void 0 ? void 0 : link.split("/content/kohler-india/in" + constants.baseUrl).join("").replace(".html", "") : link;
};
const getAnalyticLinkUrl = (link)=>{
    return link ? (link.indexOf("http") === -1 && "object" !== "undefined" ? window.location.origin : "") + link : "n/a";
};
const redirect = (url)=>{
    router_default().push(url);
};
const phoneFormat = (mobileNo)=>{
    return mobileNo.toString().replace(/(\d{2})(\d{3})(\d{3})(\d{4})/, "$1 $2 $3 $4");
};
const helper_formatPriceRange = function(filter) {
    let isAnnsacksPlp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1;
    const values = filter.match(/\d+/g);
    const { internationalization: { currencySign ="₹"  } = {}  } = (0,constants_config/* getConfig */.i)();
    return isAnnsacksPlp ? "".concat(currencySign).concat((ref = Number(values[0])) === null || ref === void 0 ? void 0 : ref.toLocaleString(), " - ").concat(currencySign).concat((ref1 = Number(values[1])) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString()) : "".concat(currencySign).concat(values[0], " - ").concat(currencySign).concat(values[1]);
};
const helper_getPDPUrl = async (category, slug)=>{
    const { plpServletPath , general  } = await (0,constants_config/* getConfig */.i)();
    const pdpUrl = helper_gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const getBundleProductName = (data, selSku)=>{
    let name = "";
    data["bundleNameSlugDetails_ss"].forEach((i)=>{
        if (i.split("|").includes(selSku)) {
            name = i.split("|")[1];
        }
    });
    return name;
};
const helper_getPDPUrlForProductTile = async (data, selSku)=>{
    var ref;
    var _ProductLocalCategory_s;
    const category = data.Product_Category ? data.Product_Category : (_ProductLocalCategory_s = data.ProductLocalCategory_s) !== null && _ProductLocalCategory_s !== void 0 ? _ProductLocalCategory_s : "";
    let newSlug = "";
    ((ref = data["bundleNameSlugDetails_ss"]) === null || ref === void 0 ? void 0 : ref.length) > 0 && data["bundleNameSlugDetails_ss"].forEach((i)=>{
        if (i.split("|").includes(selSku)) {
            newSlug = i.split("|")[2];
        }
    });
    const slug = newSlug ? newSlug : data.slug_s;
    const { plpServletPath , general  } = await (0,constants_config/* getConfig */.i)();
    const pdpUrl = helper_gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const helper_getPDPUrlWithConfig = (category, slug, plpServletPath, general)=>{
    const pdpUrl = helper_gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const helper_gePDPUrlPageDetails = async (plpServletPath, general, category, slug)=>{
    const path = plpServletPath === null || plpServletPath === void 0 ? void 0 : plpServletPath.find((i)=>i.categories.includes(category));
    var _shortendPagePath;
    const shortUrl = (_shortendPagePath = general.shortendPagePath) !== null && _shortendPagePath !== void 0 ? _shortendPagePath : "";
    if (category === "Design Services") {
        return helper_getShortenedUrlwithGeneral(general.designServiceLandingPath, general);
    }
    if (category === "Install Services") {
        return helper_getShortenedUrlwithGeneral(general.installServiceLandingPath, general);
    }
    if (path) {
        var ref;
        return "".concat((ref = path.url) === null || ref === void 0 ? void 0 : ref.replace(shortUrl, ""), "/").concat(slug);
    }
    return "".concat(helper_getShortenedUrlwithGeneral(general.plpPagePath, general), "/").concat(category === null || category === void 0 ? void 0 : category.replace(/\s&\s|\s/g, "-").toLowerCase(), "/").concat(slug);
};
const helper_getShortenedUrlwithGeneral = (uUrl, general)=>{
    if (general) {
        const { shortendPagePath  } = general;
        const shortUrl = shortendPagePath !== null && shortendPagePath !== void 0 ? shortendPagePath : "";
        const htmlRegExp = new RegExp(".html", "g");
        const htmlRemovedUrl = "".concat(uUrl === null || uUrl === void 0 ? void 0 : uUrl.replace(htmlRegExp, ""));
        const shortUrlRegEx = new RegExp(shortUrl, "g");
        return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
    }
    return "";
};
const buildUrlForAemApim = (url)=>{
    return "".concat(constants.apimAemURL).concat(url, "&brand=india");
};
const helper_isPriceZero = (price)=>price === "0.00" || price === 0;
// stateUtils.js
const stateCodeToName = (code)=>{
    const stateMap = {
        AP: "Andhra Pradesh",
        AR: "Arunachal Pradesh",
        AS: "Assam",
        BR: "Bihar",
        CT: "Chhattisgarh",
        GA: "Goa",
        GJ: "Gujarat",
        HR: "Haryana",
        HP: "Himachal Pradesh",
        JH: "Jharkhand",
        KA: "Karnataka",
        KL: "Kerala",
        MP: "Madhya Pradesh",
        MH: "Maharashtra",
        MN: "Manipur",
        ML: "Meghalaya",
        MZ: "Mizoram",
        NL: "Nagaland",
        OR: "Odisha",
        PB: "Punjab",
        RJ: "Rajasthan",
        SK: "Sikkim",
        TN: "Tamil Nadu",
        TG: "Telangana",
        TR: "Tripura",
        UT: "Uttarakhand",
        UP: "Uttar Pradesh",
        WB: "West Bengal",
        AN: "Andaman and Nicobar Islands",
        CH: "Chandigarh",
        DN: "Dadra and Nagar Haveli and Daman and Diu",
        DL: "Delhi",
        JK: "Jammu and Kashmir",
        LA: "Ladakh",
        LD: "Lakshadweep",
        PY: "Puducherry"
    };
    return stateMap[code] || "State Not Found";
};
const helper_getUserPersona = ()=>{
    if (!helper_isServer) {
        var ref;
        const { isAuth , user  } = (ref = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : ref.auth;
        if (isAuth) {
            var ref1, ref2;
            const persona = (user === null || user === void 0 ? void 0 : (ref1 = user.persona) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? (ref2 = user === null || user === void 0 ? void 0 : user.persona[0]) === null || ref2 === void 0 ? void 0 : ref2.split(":")[1] : "GST";
            return persona === "CTR" ? "GST" : persona;
        }
    }
    return "GST";
};
const helper_getPriceSortQuery = ()=>{
    const persona = helper_getUserPersona();
    return "priceList.".concat(persona, ".finalPrice_d");
};
const helper_appendPresetToUrl = function(assetAccountName, swatchUrl, assetId, width) {
    let presetConfigs = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, isReel = arguments.length > 5 ? arguments[5] : void 0, imageUrl = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "";
    const { Desktop , MobileLandscape ="" , MobilePortrait ="" , LandscapeCategory  } = presetConfigs;
    if (imageUrl && !imageUrl.includes("/PAWEB/")) {
        return imageUrl;
    }
    let preset = "";
    if (width <= 768) {
        if (width <= 425) {
            if (MobilePortrait) {
                preset = MobilePortrait;
            }
        } else {
            if (MobileLandscape) {
                preset = MobileLandscape;
            }
        }
    } else {
        preset = isReel ? Desktop : MobileLandscape;
    }
    return "".concat(swatchUrl).concat(LandscapeCategory, "?$product_src=is{").concat(assetAccountName, "/").concat(assetId, "}&").concat(preset);
};
const helper_getSortItemBasedOnURL = (text, defaultItem)=>{
    const urlParams = window.location.search;
    let queryVal = "";
    if (urlParams) {
        const urlQuery = urlParams.replace("?", "").split("&");
        urlQuery.forEach((query, i)=>{
            const isBack = query.split("=")[0] === "back";
            if (isBack) {
                sessionStorage.plpScrollSku = query.split("=")[1];
            }
            queryVal += isBack ? "" : "".concat(i > 0 ? "&" : "").concat(query);
        });
        window.history.replaceState(window.location.pathname, document.title, queryVal.length > 0 ? "?".concat(queryVal.toString()) : window.location.pathname);
    }
    const query = helper_getSortFromUrl();
    const selectedSortItem = query ? helper_getSelectedSort(text, query) : defaultItem || null;
    return selectedSortItem;
};
const helper_getSortFromUrl = ()=>{
    const url = new URL(location.href);
    var ref;
    const appliedSort = (ref = url.searchParams.get("sort")) !== null && ref !== void 0 ? ref : "";
    return appliedSort.includes("%2B") ? appliedSort.replaceAll("%2B", "+") : appliedSort.replaceAll(" ", "+");
};
const helper_getSelectedSort = (text, query)=>{
    switch(query){
        case "bestSeller_l+asc":
            return {
                name: text.bestSellers,
                query: "bestSeller_l+asc"
            };
        case "price+desc":
            return {
                name: text.priceDesc,
                query: "price+desc"
            };
        case "price+asc":
            return {
                name: text.priceAsc,
                query: "price+asc"
            };
        case "CollapseSort_s+asc":
        case "NonCollapseSort_s+asc":
        case "productName_s+asc":
        case "ProductBrandName_s+asc":
        case "title_s+asc":
            return {
                name: text.atoz,
                query
            };
        case "CollapseSort_s+desc":
        case "NonCollapseSort_s+desc":
        case "productName_s+desc":
        case "ProductBrandName_s+desc":
        case "title_s+desc":
            return {
                name: text.ztoa,
                query
            };
        case "new":
            return {
                name: text.newToOld,
                query
            };
        case "old":
            return {
                name: text.oldToNew,
                query
            };
        case "atoz":
            return {
                name: text.AToZ,
                query
            };
        case "ztoa":
            return {
                name: text.ZToA,
                query
            };
    }
    return {
        name: text.featured,
        query: ""
    };
};
const setBannerConfirmationText = function() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref, ref1;
    if (!id) return;
    const banner = document.getElementById(id);
    const bannerDesc = (ref = banner === null || banner === void 0 ? void 0 : banner.getElementsByClassName("cmp-teaser__description")) === null || ref === void 0 ? void 0 : ref[0];
    const bannerDescElem = (ref1 = bannerDesc === null || bannerDesc === void 0 ? void 0 : bannerDesc.getElementsByTagName("p")) === null || ref1 === void 0 ? void 0 : ref1[0];
    if (bannerDescElem) {
        bannerDescElem.innerText = text;
    }
};
const truncateString = (str, maxLength)=>{
    if (str.length > maxLength) {
        return str.substring(0, maxLength) + "...";
    } else {
        return str;
    }
};
const helper_pdpTypeFormat = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { businessUnitName ="" , ProductIsRetail ="" , discontinuedProductb ="" , ProductRequiredAccessoriesGroupsList =[] , superSku =""  } = data;
    let pdpType = "";
    if (businessUnitName === "Service Parts") {
        pdpType = "regular part";
    } else if (ProductIsRetail) {
        pdpType = "retail exclusive";
    } else if (discontinuedProductb) {
        pdpType = "discontinued";
    } else if (ProductRequiredAccessoriesGroupsList.length) {
        pdpType = "regular w/required items";
    } else if (superSku) {
        pdpType = "super sku";
    } else {
        pdpType = "regular finished goods";
    }
    return pdpType;
};
const getStateCodeValue = function() {
    let stateVal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", countryVal = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var ref, ref1;
    let country = {};
    const countryValueToCompare = countryVal.toLocaleLowerCase();
    const stateValueToCompare = stateVal.toLocaleLowerCase();
    var ref2;
    if (data.find((obj)=>{
        return ((ref2 = obj === null || obj === void 0 ? void 0 : obj.code) !== null && ref2 !== void 0 ? ref2 : "").toLocaleLowerCase() === countryValueToCompare;
    })) {
        var ref3;
        country = data.find((obj)=>{
            return ((ref3 = obj === null || obj === void 0 ? void 0 : obj.code) !== null && ref3 !== void 0 ? ref3 : "").toLocaleLowerCase() === countryValueToCompare;
        });
    } else {
        var ref4, ref5;
        country = (ref5 = data.find((obj)=>{
            return ((ref4 = obj === null || obj === void 0 ? void 0 : obj.name) !== null && ref4 !== void 0 ? ref4 : "").toLocaleLowerCase() === countryValueToCompare;
        })) !== null && ref5 !== void 0 ? ref5 : {};
    }
    var ref6;
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>{
        return ((ref6 = obj === null || obj === void 0 ? void 0 : obj.code) !== null && ref6 !== void 0 ? ref6 : "").toLocaleLowerCase() === stateValueToCompare;
    })) return stateVal;
    var ref7, ref8;
    const state = (ref8 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>{
        return ((ref7 = obj === null || obj === void 0 ? void 0 : obj.name) !== null && ref7 !== void 0 ? ref7 : "").toLocaleLowerCase() === stateValueToCompare;
    })) !== null && ref8 !== void 0 ? ref8 : {};
    var _code;
    return (_code = state.code) !== null && _code !== void 0 ? _code : "";
};
const helper_handleForOrderconfirmationCall = ()=>{
    var ref, ref1, ref2, ref3;
    if ([
        "checkout",
        "cart"
    ].includes(window === null || window === void 0 ? void 0 : (ref = window.pageObj) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.primaryCategory) || (window === null || window === void 0 ? void 0 : (ref2 = window.pageObj) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.category) === null || ref3 === void 0 ? void 0 : ref3.primaryCategory) === "order confirmation") {
        return false;
    }
    return true;
};
const helper_isShowAnalyticsEventLoaded = ()=>{
    // this function is used to check if cmp:show event is already loaded or not to avoid duplicate show events
    if (window.adobeDataLayer) {
        let isLoaded = false;
        window.adobeDataLayer.forEach((event)=>{
            if ((event === null || event === void 0 ? void 0 : event.event) === "cmp:show") {
                isLoaded = true;
            }
        });
        return isLoaded;
    }
    return false;
};
let helper_pageLoadAnalyticsTimer;
const helper_addPageLoadAnalyticsEvent = ()=>{
    if (window.adobeDataLayer && window.isShowAnalyticsEvent === true && window.pageObj && !helper_isShowAnalyticsEventLoaded() && window.datalayerTopLoaded && helper_handleForOrderconfirmationCall()) {
        // we need to execute cmp:show event here as it is a first time page
        const page = window.pageObj;
        const { category: { pageType =""  } = {}  } = page;
        if (helper_pageLoadAnalyticsTimer) {
            clearTimeout(helper_pageLoadAnalyticsTimer);
            helper_pageLoadAnalyticsTimer = undefined;
        }
        if (!pageType) {
            helper_pageLoadAnalyticsTimer = setTimeout(()=>helper_addPageLoadAnalyticsEvent(), 500);
            return;
        }
        if (pageType === "pdp" || pageType === "search-results" || pageType === "search") {
            return;
        }
        page.user = localStorage ? helper_getUserAnalyticsObject() : {};
        const otherItems = {};
        if (page.component) {
            otherItems.component = page.component;
        // delete page.component
        }
        if (page.eventInfo) {
            otherItems.eventInfo = page.eventInfo;
        // delete page.eventInfo
        }
        if (page.productInfo) {
            otherItems.productInfo = page.productInfo;
        // delete page.productInfo
        }
        window.adobeDataLayer.push({
            event: "cmp:show",
            page: page,
            ...otherItems
        });
        window.isShowAnalyticsEvent = false;
        delete window.isShowAnalyticsEvent;
    }
};
const getPaymentFailureMessage = (message, staticText)=>{
    let messageText = "";
    if (message["status_message"] === constants.cancellationReason) {
        messageText = "".concat(staticText.cancelledPayment);
    } else if (message["status_message"]) {
        messageText = "".concat(staticText.cancelledPaymentWithReason, ": '").concat(message["status_message"], "'");
    } else if (message["failure_message"]) {
        messageText = "".concat(staticText.paymentFailedMessage);
    }
    return messageText;
};
const getEtaDataIndividual = function() {
    let lineItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, newLineItems = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var ref, ref1, ref2, ref3;
    const updatedLineItems = lineItems.map((t1)=>({
            ...t1,
            ...newLineItems.find((t2)=>t2.lineItemId === t1.id)
        }));
    let individualEtaData = {
        maxDay: null,
        minDay: null,
        isError: true
    };
    if (data === null || data === void 0 ? void 0 : (ref = data.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.isBundleParent) {
        const filteredLineItems = updatedLineItems.filter((item)=>{
            var ref, ref1, ref2, ref3;
            const { variant: { attributes  }  } = item;
            const isInstallationService = attributes.findIndex((attribute)=>attribute.name === "ProductLocalCategory" && attribute.value === utils_constants/* INSTALL_SERVICES */._F);
            return (item === null || item === void 0 ? void 0 : (ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.parentBundleSku) === (data === null || data === void 0 ? void 0 : (ref2 = data.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.bundleSku) && isInstallationService < 0;
        });
        const etaData = filteredLineItems.map((item)=>item.eta);
        const maxDay = Math.max(...etaData.map((param)=>{
            let { maxDay  } = param;
            return maxDay;
        }));
        const minDay = Math.min(...etaData.map((param)=>{
            let { minDay  } = param;
            return minDay;
        }));
        if (Number.isSafeInteger(maxDay) && Number.isSafeInteger(minDay)) {
            individualEtaData = {
                maxDay,
                minDay,
                isError: false
            };
        }
    } else if (!(data === null || data === void 0 ? void 0 : (ref2 = data.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.isBundleChildItem)) {
        const filteredLineItems1 = updatedLineItems.filter((item)=>{
            return (item === null || item === void 0 ? void 0 : item.id) === (data === null || data === void 0 ? void 0 : data.id);
        });
        const etaData1 = filteredLineItems1.map((item)=>item.eta);
        const maxDay1 = Math.max(...etaData1.map((param)=>{
            let { maxDay  } = param;
            return maxDay;
        }));
        const minDay1 = Math.min(...etaData1.map((param)=>{
            let { minDay  } = param;
            return minDay;
        }));
        if (Number.isSafeInteger(maxDay1) && Number.isSafeInteger(minDay1)) {
            individualEtaData = {
                maxDay: maxDay1,
                minDay: minDay1,
                isError: false
            };
        }
    }
    return individualEtaData;
};
function createHashFromString(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0 // Convert to 32bit integer
        ;
    }
    return hash.toString(36) // Convert to base-36 string
    ;
}
function getCacheKey(axiosConfig) {
    const query = new URLSearchParams();
    for(const key in axiosConfig.params){
        query.append(key, axiosConfig.params[key]);
    }
    const hashedQuery = createHashFromString(query.toString());
    return "".concat(axiosConfig.method, ":").concat(axiosConfig.url, ":").concat(hashedQuery);
}
function setLoaderText(txt) {
    const event = new CustomEvent("set-loader-text", {
        detail: txt
    });
    document.dispatchEvent(event);
}
const isPromoAllowed = ()=>{
    var ref, ref1;
    if ((ref = store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.isAuth) {
        return true;
    }
    const locCookie = (0,findStore/* getCookieValue */.Do)("userLocation");
    if (locCookie) {
        const city = locCookie === null || locCookie === void 0 ? void 0 : locCookie.split("+")[3];
        return utils_constants/* promoAllowedCitites.findIndex */.S$.findIndex((item)=>{
            var ref;
            return ((ref = item.city) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === city.toLowerCase();
        });
    }
};



/***/ }),

/***/ 20558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AY": function() { return /* binding */ isBrandTransact; },
/* harmony export */   "A_": function() { return /* binding */ isDealerEnquiry; },
/* harmony export */   "Ac": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Ac; },
/* harmony export */   "Ar": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Ar; },
/* harmony export */   "BB": function() { return /* binding */ getPresetThumbnailUrl; },
/* harmony export */   "Be": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Be; },
/* harmony export */   "Bq": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Bq; },
/* harmony export */   "C2": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.C2; },
/* harmony export */   "C_": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.C_; },
/* harmony export */   "DN": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.DN; },
/* harmony export */   "Dx": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Dx; },
/* harmony export */   "EE": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.EE; },
/* harmony export */   "F0": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.F0; },
/* harmony export */   "GX": function() { return /* binding */ isPressLanding; },
/* harmony export */   "Gs": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Gs; },
/* harmony export */   "Hx": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Hx; },
/* harmony export */   "IE": function() { return /* binding */ isBlogPage; },
/* harmony export */   "K0": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.K0; },
/* harmony export */   "K5": function() { return /* binding */ isAemList; },
/* harmony export */   "L": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.L; },
/* harmony export */   "L8": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.L8; },
/* harmony export */   "M0": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.M0; },
/* harmony export */   "M2": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.M2; },
/* harmony export */   "MN": function() { return /* binding */ isBrowseAllStores; },
/* harmony export */   "MW": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.MW; },
/* harmony export */   "Mc": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Mc; },
/* harmony export */   "N": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.N; },
/* harmony export */   "Nm": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Nm; },
/* harmony export */   "Om": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Om; },
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "P2": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.P2; },
/* harmony export */   "Pe": function() { return /* binding */ isAemImage; },
/* harmony export */   "Qe": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Qe; },
/* harmony export */   "S": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.S; },
/* harmony export */   "U4": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.U4; },
/* harmony export */   "Uq": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Uq; },
/* harmony export */   "V6": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.V6; },
/* harmony export */   "Wv": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Wv; },
/* harmony export */   "Z3": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.Z3; },
/* harmony export */   "ZS": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.ZS; },
/* harmony export */   "_$": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__._$; },
/* harmony export */   "_4": function() { return /* binding */ isUpSellContainer; },
/* harmony export */   "bU": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.bU; },
/* harmony export */   "bd": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.bd; },
/* harmony export */   "bu": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.bu; },
/* harmony export */   "cD": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.cD; },
/* harmony export */   "ck": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.ck; },
/* harmony export */   "cl": function() { return /* binding */ isFooter; },
/* harmony export */   "e1": function() { return /* binding */ getOrderDetailsUrl; },
/* harmony export */   "e7": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.e7; },
/* harmony export */   "ek": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.ek; },
/* harmony export */   "eq": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.eq; },
/* harmony export */   "f5": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.f5; },
/* harmony export */   "fN": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.fN; },
/* harmony export */   "gb": function() { return /* binding */ isQuiz; },
/* harmony export */   "hn": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.hn; },
/* harmony export */   "iL": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.iL; },
/* harmony export */   "iP": function() { return /* binding */ isLeadGeneration; },
/* harmony export */   "ik": function() { return /* binding */ isFindAStore; },
/* harmony export */   "j$": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.j$; },
/* harmony export */   "jS": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.jS; },
/* harmony export */   "l1": function() { return /* binding */ isCartLanding; },
/* harmony export */   "lU": function() { return /* binding */ isCustomerSupport; },
/* harmony export */   "le": function() { return /* binding */ isNullOrUndefined; },
/* harmony export */   "mg": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.mg; },
/* harmony export */   "n": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.n; },
/* harmony export */   "np": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.np; },
/* harmony export */   "o4": function() { return /* binding */ getBrandSwitcher; },
/* harmony export */   "oC": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.oC; },
/* harmony export */   "oq": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.oq; },
/* harmony export */   "po": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.po; },
/* harmony export */   "pv": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.pv; },
/* harmony export */   "s3": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.s3; },
/* harmony export */   "sL": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.sL; },
/* harmony export */   "uR": function() { return /* binding */ getOrderDetailsUrlNonLoggedIn; },
/* harmony export */   "v$": function() { return /* binding */ getPresetUrl; },
/* harmony export */   "vI": function() { return /* binding */ isProductEnquiry; },
/* harmony export */   "wR": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.wR; },
/* harmony export */   "we": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.we; },
/* harmony export */   "xW": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.xW; },
/* harmony export */   "xv": function() { return /* binding */ isReturns; },
/* harmony export */   "yd": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.yd; },
/* harmony export */   "zK": function() { return /* reexport safe */ _src_utils__WEBPACK_IMPORTED_MODULE_2__.zK; }
/* harmony export */ });
/* unused harmony export getBillingAsShippingAddress */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55111);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19514);
/* harmony import */ var _src_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33185);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];


const isImage = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.IMAGEV3);
};
const isAemImage = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.IMAGE);
};
const isAemList = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.LIST);
};
const isCartLanding = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.CART_LANDING);
};
const isUpSellContainer = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.UPSELL_CONTAINER);
};
const isFindAStore = (item)=>{
    return item["templateName"] === _constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.FIND_A_STORE;
};
const isPressLanding = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.PRESS_LANDING);
};
const isDealerEnquiry = (item)=>{
    var ref;
    return (ref = item["dealershipTitle"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.DEALER_ENQUIRY);
};
const isProductEnquiry = (item)=>{
    var ref;
    return (ref = item["productEnquiryTitle"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.PRODUCT_ENQUIRY);
};
const isLeadGeneration = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.LEAD_GENERATION);
};
const isBlogPage = (item)=>{
    var ref, ref1;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.BLOG_PAGE)) && !((ref1 = item[":type"]) === null || ref1 === void 0 ? void 0 : ref1.includes("blogtabpage"));
};
const isReturns = (item)=>{
    var ref, ref1;
    return ((ref = item["title"]) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.RETURNS.toLowerCase())) || ((ref1 = item["title"]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase().includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.RETURN_CONFIRMATION.toLowerCase()));
};
const isBrowseAllStores = (item)=>{
    var ref, ref1;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.BROWSE_ALL_STORES)) || ((ref1 = item[":type"]) === null || ref1 === void 0 ? void 0 : ref1.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.STORE_FILTER));
};
const isCustomerSupport = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES === null || _constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.CUSTOMER_SUPPORT);
};
const getPresetUrl = function() {
    let width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, rowCols = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, swatchUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", assetId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", presetConfigs = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    const { Desktop , MobilePortrait , MobilePortrait1 , MobilePortrait2 , MobileLandscape , MobileLandscape1 , MobileLandscape2 , PotraitCategory  } = presetConfigs;
    let preset = "";
    if (width <= 768) {
        if (width <= 425) {
            if (rowCols) {
                if (rowCols === 1) preset = MobilePortrait1;
                else preset = MobilePortrait2;
            } else if (MobilePortrait) {
                preset = MobilePortrait;
            } else preset = MobilePortrait2;
        } else {
            if (rowCols) {
                if (rowCols === 1) preset = MobileLandscape1;
                else preset = MobileLandscape2;
            } else if (MobileLandscape) {
                preset = MobileLandscape;
            } else preset = MobileLandscape1;
        }
    } else preset = Desktop;
    return "".concat(swatchUrl).concat(PotraitCategory, "?$product_src=is{PAWEB/").concat(assetId, "}&").concat(preset);
};
const isFooter = (data)=>{
    const types = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.MAIN_FOOTER)) || types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.ADDITIONAL_FOOTER)) || types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.NEWSLETTER_SIGNIN)) || (types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.TEASER)) ? undefined : types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.PRODUCT_DETAILS_ACCORDION)));
};
const getBillingAsShippingAddress = (shipping, billing)=>{
    const { billingStreetName ="" , billingAptNo ="" , billingCity ="" , billingStateCode ="" , billingZipcode =""  } = billing;
    const { shippingStreetName ="" , shippingAptNo ="" , shippingCity ="" , shippingStateCode ="" , shippingZipcode =""  } = shipping;
    return billingStreetName.toLowerCase() === shippingStreetName.toLowerCase() && billingAptNo.toLowerCase() === shippingAptNo.toLowerCase() && billingCity.toLowerCase() === shippingCity.toLowerCase() && billingStateCode.toLowerCase() === shippingStateCode.toLowerCase() && billingZipcode.toLowerCase() === shippingZipcode.toLowerCase();
};
const isNullOrUndefined = (value)=>{
    return value === null || value === undefined;
};
const getPresetThumbnailUrl = (swatchUrl, assetId, presetConfigs, assetAccountName, imageUrl)=>{
    if (imageUrl && !imageUrl.includes("/PAWEB/")) {
        return imageUrl;
    }
    const { Thumbnail , LandscapeCategory  } = presetConfigs;
    return "".concat(swatchUrl).concat(LandscapeCategory, "?$product_src=is{").concat(assetAccountName, "/").concat(assetId, "}&").concat(Thumbnail);
};
const getBrandSwitcher = function() {
    let headerData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const headPropsItems = headerData[":items"];
    const headerPropsRoot = headPropsItems === null || headPropsItems === void 0 ? void 0 : headPropsItems.root;
    const headerRootItems = headerPropsRoot === null || headerPropsRoot === void 0 ? void 0 : headerPropsRoot[":items"];
    const hedaerPropsContainer = headerRootItems === null || headerRootItems === void 0 ? void 0 : headerRootItems.container;
    const headerContainerItems = hedaerPropsContainer === null || hedaerPropsContainer === void 0 ? void 0 : hedaerPropsContainer[":items"];
    const headerUtilityWidgets = headerContainerItems === null || headerContainerItems === void 0 ? void 0 : headerContainerItems.brand_switcher;
    var ref;
    return (ref = headerUtilityWidgets === null || headerUtilityWidgets === void 0 ? void 0 : headerUtilityWidgets.items) !== null && ref !== void 0 ? ref : "";
};
const isBrandTransact = ()=>{
    const hostname =  true ? window.location.hostname : 0;
    const envhost = _constants__WEBPACK_IMPORTED_MODULE_0__.brandTransactSwitcher === null || _constants__WEBPACK_IMPORTED_MODULE_0__.brandTransactSwitcher === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_0__.brandTransactSwitcher.toUpperCase();
    if ((hostname === null || hostname === void 0 ? void 0 : hostname.toUpperCase()) == envhost) return true;
    else return false;
};
const getOrderDetailsUrl = async (email, orderNumber, source)=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .i)();
    const { general: { orderDetailsPath =""  } = {}  } = config;
    return "".concat(orderDetailsPath, "?orderNumber=").concat(orderNumber, "&q=").concat(Buffer.from(email).toString("base64")).concat(source ? "&orderSource=" + source : "");
};
const isQuiz = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.COMPONENT_TYPES.QUIZ);
};
const getOrderDetailsUrlNonLoggedIn = async (orderNumber)=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .i)();
    const { general: { orderDetailsPath =""  } = {}  } = config;
    return "".concat(orderDetailsPath, "?orderNumber=").concat(orderNumber, "&status=true");
};




/***/ }),

/***/ 97433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$8": function() { return /* binding */ validateZip; },
/* harmony export */   "OP": function() { return /* binding */ validateField; },
/* harmony export */   "Pp": function() { return /* binding */ getShortenedUrl; },
/* harmony export */   "XD": function() { return /* binding */ getLocationUsingIP; },
/* harmony export */   "e": function() { return /* binding */ getStoreDataById; }
/* harmony export */ });
/* unused harmony exports getLocationUsingZipcode, getStoreDataByDistance, getUtilityStoreDetails */
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55111);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73350);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);






// import { store } from "@/store"
// Get location using the public ip address of the client
const getLocationUsingIP = async ()=>{
    try {
        const ip = window === null || window === void 0 ? void 0 : window.sessionStorage["true-ip"];
        const ipRegex = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/;
        if (ip && ip !== "" && ipRegex.test(ip)) {
            // {"23.100.225.115"}
            const res = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_2__.locationIpEndPoint).concat(ip));
            return res;
        } else {
            return {};
        }
    } catch (err) {
        console.error("Failed to get location using IP address", err);
    }
};
// Get location using the zip code
const getLocationUsingZipcode = async (zip)=>{
    try {
        if (zip && zip !== "") {
            const res = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_2__.locationZipEndPoint).concat(zip));
            return res;
        } else {
            return {};
        }
    } catch (err) {
        console.error("Failed to get location using zipcode", err);
    }
};
const validateField = async (field, value)=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const { regexPattern  } = config;
    const pattern = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(regexPattern, "map.".concat(field), "");
    const regex = new RegExp(pattern);
    const isValid = regex.test(value) ? true : false;
    return isValid;
};
const validateZip = async (zip)=>{
    var ref, ref1, ref2, ref3, ref4;
    const res = await getLocationUsingZipcode(zip);
    if ((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.resourceSets) && ((ref3 = (ref2 = res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.resourceSets[0]) === null || ref2 === void 0 ? void 0 : ref2.resources[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.address) === null || ref4 === void 0 ? void 0 : ref4.postalCode) === zip) return true;
    return false;
};
const getShortenedUrl = async (uUrl)=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const { general  } = config;
    var ref;
    const shortUrl = (ref = general === null || general === void 0 ? void 0 : general.shortendPagePath) !== null && ref !== void 0 ? ref : "";
    const htmlRegExp = new RegExp(".html", "g");
    const htmlRemovedUrl = "".concat(uUrl === null || uUrl === void 0 ? void 0 : uUrl.replace(htmlRegExp, ""));
    const shortUrlRegEx = new RegExp(shortUrl, "g");
    return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
};
const getStoreDataById = (param)=>{
    let { myStoreId , findStores , siteName  } = param;
    return new Promise((resolve, reject)=>{
        const selectQuery = "EntityID,BPnumber,LocationName,AddressLine,AddressLine2,StateLong,AdminDistrict,PostalCode,Latitude,__Distance,Longitude,Phone,OpenUntil,Locality";
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(findStores)) {
            _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get(findStores, {
                params: {
                    $format: "json",
                    brand: siteName.toLowerCase(),
                    $select: selectQuery,
                    $filter: "EntityID Eq ('".concat(myStoreId, "')")
                }
            }).then((response)=>{
                if (response && response.data) {
                    var ref;
                    resolve((ref = response.data.d.results[0]) !== null && ref !== void 0 ? ref : {});
                } else {
                    reject(new Error("Find a nearest store: Error occured while fetching data from Get URL Property"));
                // log.error(
                //   "Find a nearest store: Error occured while fetching data from Get URL Property"
                // )
                }
            }).catch((err)=>{
                console.log({
                    err
                });
                reject(new Error("Find a nearest store: Error occured while fetching data from Get URL Property"));
            });
        // .catch(err => log.error(err))
        } else {
        // log.error("Find a nearest store: Get API config not found")
        }
    });
};
const getStoreDataByDistance = (param)=>{
    let { utilityDistance =STORE_MIN_DISTANCE , findStores , userCity , siteName  } = param;
    return new Promise((resolve, reject)=>{
        // const locationStore = store.getState()?.location || ""
        // console.log({ locationStore })
        const selectQuery = "EntityID,BPnumber,LocationName,AddressLine,AddressLine2,StateLong,AdminDistrict,PostalCode,Latitude,__Distance,Longitude,Phone,OpenUntil,Locality";
        if (!_isEmpty(findStores)) {
            apim.get(findStores, {
                params: {
                    $format: "json",
                    brand: siteName.toLowerCase(),
                    spatialFilter: "nearby('".concat(userCity, "',").concat(utilityDistance, ")"),
                    $select: selectQuery,
                    $filter: "LocationType Eq ('KOHLER Store')"
                }
            }).then((response)=>{
                if (response && response.data) {
                    if (!_isEmpty(response.data.d.results[0])) {
                        const utilityData = response.data.d.results[0];
                        resolve(utilityData);
                    } else if (utilityDistance === 64) {
                        getStoreDataByDistance({
                            utilityDistance: STORE_MAX_DISTANCE,
                            findStores,
                            userCity
                        });
                    }
                } else {
                    reject(new Error("Find a nearest store: Error occured while fetching data from Get URL Property"));
                // log.error(
                //   "Find a nearest store: Error occured while fetching data from Get URL Property"
                // )
                }
            }).catch((err)=>{
                console.log({
                    err
                });
            // log.error(err)
            });
        } else {
        // log.error("Find a nearest store: Get API config not found")
        }
    });
};
const getUtilityStoreDetails = async (param)=>{
    let { utilityStoreDetailsUrl  } = param;
    try {
        const response = await aemAxiosInstance({
            url: STORE_DETAILS_API_ENDPOINT,
            params: {
                path: utilityStoreDetailsUrl
            }
        });
        if (response && response.data) {
            return response.data;
        // this.setState({
        //   utilityStoreDetails: response.data ?? {},
        // })
        } else {
        // log.error(
        //   "Store Details: Error occured while fetching data from Get URL Property"
        // )
        }
    } catch (error) {
    // log.error(error)
    }
};



/***/ }),

/***/ 61150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ cartPrerender; },
/* harmony export */   "Q": function() { return /* binding */ initPrerender; }
/* harmony export */ });
const setPrerender = (rules, id)=>{
    const scriptEl = document.createElement("script");
    scriptEl.type = "speculationrules";
    if (id) {
        scriptEl.setAttribute("data-id", id);
    }
    scriptEl.textContent = JSON.stringify(rules);
    document.body.append(scriptEl);
};
const removePrerender = (id)=>{
    document.querySelectorAll('script[data-id="'.concat(id, '"]')).forEach((el)=>el.remove());
};
const cartPrerender = ()=>{
    const urls = [];
    const tagId = "cart";
    if (!(window.location.pathname === "/cart" || window.location.pathname === "/checkout" || window.location.pathname === "/cart/shared-cart")) {
        urls.push("/cart");
    }
    const cartRule = {
        prerender: [
            {
                urls
            }
        ]
    };
    removePrerender(tagId);
    setTimeout(()=>setPrerender(cartRule, tagId), 500);
};
const initPrerender = ()=>{
    const commonRules = {
        prerender: [
            {
                where: {
                    href_matches: "/p/*/*"
                },
                eagerness: "moderate"
            }
        ]
    };
    setPrerender(commonRules, "common");
    cartPrerender();
};


/***/ }),

/***/ 29843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cb": function() { return /* binding */ getPlpParams; },
/* harmony export */   "Dv": function() { return /* binding */ getProductAttr; },
/* harmony export */   "HK": function() { return /* binding */ getListFromServer; },
/* harmony export */   "In": function() { return /* binding */ formatBundleItems; },
/* harmony export */   "MQ": function() { return /* binding */ getProductDetailsFromServer; },
/* harmony export */   "U9": function() { return /* binding */ getRowsInitialValue; },
/* harmony export */   "YB": function() { return /* binding */ getProductBySku; },
/* harmony export */   "Zj": function() { return /* binding */ removeFromCompareProduct; },
/* harmony export */   "dX": function() { return /* binding */ addToCompareProduct; },
/* harmony export */   "lP": function() { return /* binding */ getLineItemAttrs; },
/* harmony export */   "nx": function() { return /* binding */ formatListingData; }
/* harmony export */ });
/* unused harmony exports getListFromClient, getSearchItems */
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85518);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55111);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34326);
/* harmony import */ var _components_sharedCart_shareCartHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4364);
/* harmony import */ var _store_features_compareSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39915);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45094);








const isServer = "object" === "undefined";
const getListFromServer = async function(profileName, persona) {
    let brand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "kohler-india";
    return new Promise(async (resolve, reject)=>{
        try {
            _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance.defaults.headers.common["Ocp-Apim-Subscription-Key"] */ .Gb.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "".concat(_constants__WEBPACK_IMPORTED_MODULE_2__.apimSubscriptionKey);
            const { data: content  } = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
                url: "".concat(_constants__WEBPACK_IMPORTED_MODULE_2__.authorBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_2__.PLP_END_POINT_SUBSCRIPTION_KEY, "?profilename=profile_").concat(brand, "_PLP_").concat(profileName, "&persona=").concat(persona, "&collections=").concat(brand, "&rows=3")
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getListFromClient = async (profileName, persona, accessToken)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            aemAxiosInstance.defaults.headers.common["Authorization"] = "Bearer ".concat(accessToken);
            const { data: content  } = await aemAxiosInstance({
                url: "".concat(authorBaseUrl).concat(PLP_END_POINT, "?profilename=").concat(profileName, "&persona=").concat(persona)
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getPlpParams = (obj, targetKey)=>{
    let result = null;
    for(const key in obj){
        if (obj.hasOwnProperty(key)) {
            if (key === targetKey) {
                return obj[key];
            }
            if (typeof obj[key] === "object" && obj[key] !== null) {
                result = getPlpParams(obj[key], targetKey);
                if (result !== null) {
                    return result;
                }
            }
        }
    }
    return result;
};
const getSearchItems = async function(searchKey, accessToken) {
    let displayName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "SEARCH";
    return new Promise(async (resolve, reject)=>{
        try {
            aemAxiosInstance.defaults.headers.common["Authorization"] = "Bearer ".concat(accessToken);
            const { data: content  } = await aemAxiosInstance({
                url: "".concat(authorBaseUrl).concat(PLP_END_POINT, "?displayname=").concat(displayName, "&q=").concat(searchKey)
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const formatListingData = async (data, stripResponse)=>{
    return new Promise((resolve, reject)=>{
        try {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.getUserPersona)();
            var ref7;
            const payload = {
                facets: (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_fields,
                facetLabels: (ref7 = (ref1 = data.fusion) === null || ref1 === void 0 ? void 0 : ref1.facet_labels) !== null && ref7 !== void 0 ? ref7 : [],
                grouped: ((ref2 = data.fusion) === null || ref2 === void 0 ? void 0 : ref2.isCollapsePLP) === "true" || ((ref3 = data.fusion) === null || ref3 === void 0 ? void 0 : ref3.isCollapsePLP) === true,
                fusion: data.fusion
            };
            const priceRange = payload.grouped ? (ref4 = data.facet_counts) === null || ref4 === void 0 ? void 0 : ref4.facet_ranges["discountedPriceStartingAt.".concat(persona, "_d")] : (ref5 = data.facet_counts) === null || ref5 === void 0 ? void 0 : ref5.facet_ranges["priceList.".concat(persona, ".finalPrice_d")];
            if (priceRange) {
                const gap = priceRange.gap;
                // eslint-disable-next-line camelcase
                payload.facets.Price_Range = priceRange.counts.map((item)=>typeof item === "string" ? "[".concat(parseInt(item), " TO ").concat(parseInt(item) + gap, "]") : item);
            }
            // mark multiselect
            payload.facets = formatMultiSelectFacets(data);
            var ref8;
            // set color swatches
            payload.colors = (ref8 = (ref6 = data.fusion) === null || ref6 === void 0 ? void 0 : ref6.color_swatch_labels) !== null && ref8 !== void 0 ? ref8 : {};
            if (data.response) {
                var ref9, ref10;
                if (stripResponse && data.response.docs.length > 3) {
                    payload.data = data.response.docs.slice(0, 3);
                } else {
                    payload.data = data.response.docs;
                }
                payload.total = data.response.numFound;
                payload.start = data.response.start;
                if (((ref9 = data.fusion) === null || ref9 === void 0 ? void 0 : ref9.isCollapsePLP) === "true" || ((ref10 = data.fusion) === null || ref10 === void 0 ? void 0 : ref10.isCollapsePLP) === true) {
                    payload.grouped = true;
                }
            } else {
                payload.data = data.grouped[Object.keys(data.grouped)[0]].groups.map((doc)=>doc.doclist.docs[0]);
                payload.total = data.grouped[Object.keys(data.grouped)[0]].groups.length;
                payload.start = 0;
                payload.grouped = true;
            }
            resolve(payload);
        // update
        //   ? dispatch({ type: GET_MORE_PRODUCTS, payload: data.response.docs })
        //   : dispatch({ type: GET_PRODUCTS, payload })
        // dispatch({ type: STOP_LOADING, payload: "plp" })
        } catch (error) {
            reject(error);
        }
    });
};
const formatMultiSelectFacets = (data)=>{
    var ref;
    var ref1;
    const facets = Object.entries((ref1 = (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_fields) !== null && ref1 !== void 0 ? ref1 : {}).map((fields)=>({
            [fields[0]]: fields[1]
        }));
    let facetField = data === null || data === void 0 ? void 0 : data.fusion["facet.field"];
    if (facetField) {
        if (typeof facetField === "string") facetField = [
            facetField
        ];
        facetField.forEach((item)=>{
            facets.forEach((filter, index)=>{
                if (filter[item]) {
                    const obj = {
                        ["**".concat(item)]: filter[item]
                    };
                    facets.splice(index, 1, obj);
                }
            });
        });
    }
    const result = Object.assign({}, ...facets);
    return result;
};
const getRowsInitialValue = ()=>{
    let rowsInitialValue = 30;
    if (!isServer) {
        rowsInitialValue = react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isMobile */ .tq ? 30 : sessionStorage.rows && JSON.parse(sessionStorage.rows)[window.location.pathname] ? JSON.parse(sessionStorage.rows)[window.location.pathname] : 30;
    }
    return rowsInitialValue;
};
const addToCompareProduct = (sku, isBackOrder, imgUrl, category)=>{
    _store__WEBPACK_IMPORTED_MODULE_6__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_5__/* .updateCompareStatus */ .Er)(true));
    (0,_components_sharedCart_shareCartHelper__WEBPACK_IMPORTED_MODULE_4__/* .getProductDetailsBySku */ .ze)([
        sku
    ], category).then(async (resp)=>{
        resp.forEach((vsku)=>{
            _store__WEBPACK_IMPORTED_MODULE_6__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_5__/* .addCompareProducts */ .rI)({
                sku: vsku,
                backorder: isBackOrder,
                compareSku: sku,
                imgUrl
            }));
        });
    }).catch((error)=>{
        _store__WEBPACK_IMPORTED_MODULE_6__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_5__/* .updateCompareStatus */ .Er)(false));
    });
};
const removeFromCompareProduct = (sku)=>{
    _store__WEBPACK_IMPORTED_MODULE_6__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_5__/* .clearProduct */ .JY)(sku));
};
const getProductDetailsFromServer = async (profileName, collections, slug)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance.defaults.headers.common["Ocp-Apim-Subscription-Key"] */ .Gb.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "".concat(_constants__WEBPACK_IMPORTED_MODULE_2__.apimSubscriptionKey);
            const { data: { response: { docs =[]  } = {}  } = {}  } = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
                url: "".concat(_constants__WEBPACK_IMPORTED_MODULE_2__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_2__.PDP_END_POINT_SUBSCRIPTION_KEY, "?profilename=").concat(profileName, "&collections=").concat(collections, "&slug=").concat(slug)
            });
            if (docs[0]) {
                const data = docs[0];
                const prodName = data["ProductBrandNameDisplay_s"] ? data["ProductBrandNameDisplay_s"] : data["productName_s"];
                const prodDesc = data["ProductDescriptionProductShort_s"] ? data["ProductDescriptionProductShort_s"] : "";
                const prodSku = data["CustomerFacingSKU_s"];
                const prodCategory = data["ProductLocalCategory_s"];
                data.metaTitle_s = "Buy ".concat(prodName, " ").concat(prodDesc, " ").concat(prodSku, " Online at Kohler India");
                data.metaDescription_s = "Shop ".concat(prodName, " ").concat(prodCategory, " ").concat(prodSku, ". Discover our wide selection of high-quality Bathroom and Kitchen accessories available at Kohler India");
            }
            var ref;
            resolve((ref = docs[0]) !== null && ref !== void 0 ? ref : {});
        } catch (error) {
            reject(error);
        }
    });
};
const getLineItemAttrs = async (lineItems)=>{
    let query = "";
    lineItems === null || lineItems === void 0 ? void 0 : lineItems.forEach((item, i)=>{
        if (item) {
            var ref;
            let sku = (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) || (item === null || item === void 0 ? void 0 : item.sku) || "";
            if (!sku) {
                var ref1;
                sku = (item === null || item === void 0 ? void 0 : item.sku) || (item === null || item === void 0 ? void 0 : (ref1 = item.variant) === null || ref1 === void 0 ? void 0 : ref1.sku);
            }
            query += '"'.concat(sku, '"');
            if (i + 1 !== lineItems.length) query += ", ";
        }
    });
    try {
        if (query) {
            const { data  } = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("/search/plp", {
                params: {
                    fl: "sku_s,ctId_s,Color.SKU.Details_ss,productName_s,ProductBrandNameDisplay_s,productImage.labelWithUrl_ss,slug_s,Product_Category, RegionSupplyChain_ss",
                    q: "*:*",
                    profilename: "profile_kohler-india_General",
                    collections: "kohler-india",
                    fq: "sku_s:(".concat(query, ")"),
                    rows: 50,
                    noCollapse: true
                }
            });
            const { response: { docs =[]  }  } = data;
            const updatedLineItems = lineItems.map((item)=>{
                return {
                    ...item,
                    lwData: docs.find((product)=>{
                        var ref;
                        return product["sku_s"] === ((item === null || item === void 0 ? void 0 : item.sku) || (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku));
                    }) || []
                };
            });
            return updatedLineItems;
        }
    } catch (err) {
        console.error("Failed to fetch product details", err);
    }
    return [];
};
const getProductAttr = function() {
    let sku = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", lwData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const attr = {};
    const colorAttr = lwData["Color.SKU.Details_ss"];
    const imgAttr = lwData["productImage.labelWithUrl_ss"];
    const brandAttr = lwData["ProductBrandNameDisplay_s"];
    if (colorAttr) {
        const res = colorAttr.find((d)=>d.includes(sku));
        if (res) {
            const a = res.split("|");
            attr.finishName = a[0];
            attr.fileName = a[1];
            attr.customerFacingSku = a[5];
        }
    }
    if (imgAttr) {
        const res1 = imgAttr.find((d)=>d.includes(sku));
        if (res1) {
            const a1 = res1.split("|");
            attr.image = a1[5];
        }
    }
    if (brandAttr) {
        attr.brandName = brandAttr;
    }
    return attr;
};
const getProductBySku = async (sku)=>{
    try {
        var ref;
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get('/catalog/product/projection?where=masterVariant(sku%3D"'.concat(sku, '")'));
        if (res && res.data && ((ref = res.data.results) === null || ref === void 0 ? void 0 : ref.length)) return res.data.results[0];
    } catch (err) {
        console.error("Failed to fetch product details", err);
    }
};
const getPriceByPersona = (data, sku)=>{
    var ref;
    let prices = [];
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__.getUserPersona)();
    if (data.masterVariant.sku === sku) {
        prices = data.masterVariant.prices;
    } else if (data.variants.length) {
        const product = data.variants.find((item)=>item.sku === sku);
        prices = product === null || product === void 0 ? void 0 : product.prices;
    }
    const price = prices.find((p)=>{
        var ref, ref1;
        return ((ref = p.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) === persona;
    });
    return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.centAmount) / 100 || 0;
};
const getMRPprice = (data, sku)=>{
    var ref;
    let prices = [];
    if (data.masterVariant.sku === sku) {
        prices = data.masterVariant.prices;
    } else if (data.variants.length) {
        const product = data.variants.find((item)=>item.sku === sku);
        prices = product === null || product === void 0 ? void 0 : product.prices;
    }
    const mrpprice = prices.find((p)=>!p.customerGroup);
    return ((ref = mrpprice.value) === null || ref === void 0 ? void 0 : ref.centAmount) / 100 || 0;
};
const formatBundleItems = async function() {
    let bundle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], list = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    try {
        const skus = bundle.map((item)=>item["sku_s"]);
        const ctData = await (0,_components_sharedCart_shareCartHelper__WEBPACK_IMPORTED_MODULE_4__/* .getProductsBySku */ .uX)(skus);
        const data = [];
        bundle.forEach((item)=>{
            let sku = item["sku_s"];
            let ctId = item["ctId_s"];
            let slug = item["slug_s"];
            let category = item["ProductLocalCategory_s"];
            let color = item["ColorFinish_s"];
            let img = "";
            let productName = item["ProductDescriptionProductShort_s"];
            let qty = list.find((item)=>item.startsWith(sku)).split("|")[1];
            const ctAttributes = ctData.find((item)=>item.id === ctId);
            let price = getPriceByPersona(ctAttributes, sku) * Number(qty || 1);
            let mrpprice = getMRPprice(ctAttributes, sku) * Number(qty || 1);
            const imgAttr = item["productImages.labelWithUrl_ss"];
            if (imgAttr) {
                const res = imgAttr.find((d)=>d.includes(sku));
                if (res) {
                    const a = res.split("|");
                    img = a[5];
                }
            }
            const additionalInfo = {
                country: item["SKUCountryofOrigin_s"],
                packageContent: item["ProductPackageContents_s"],
                length: item["ProductOverallLengthCm_d"],
                width: item["ProductOverallWidthCm_d"],
                height: item["ProductOverallHeightCm_d"]
            };
            if (item["RegionSupplyChain_ss"] && item["RegionSupplyChain_ss"].length) {
                additionalInfo.regionSupplyChain = item["RegionSupplyChain_ss"][0];
            }
            data.push({
                img,
                productName,
                color,
                sku,
                qty,
                price,
                mrpprice,
                slug,
                category,
                additionalInfo
            });
        });
        return data;
    } catch (ex) {
        console.log(ex);
    }
};



/***/ }),

/***/ 3783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$D": function() { return /* binding */ setRemoveCartPayload; },
/* harmony export */   "Wj": function() { return /* binding */ changeBundleQty; },
/* harmony export */   "h2": function() { return /* binding */ removeFromCart; }
/* harmony export */ });
const removeFromCart = (item)=>{
    /**
   * It removeFrom cart for pay load
   */ const { id , quantity , isBundleParent , sku  } = item;
    const payload = {};
    if (isBundleParent) {
        payload.action = "removeBundleItem";
        payload.customLineItemId = id;
        payload.sku = sku;
    } else {
        payload.action = "removeLineItem";
        payload.lineItemId = id;
        payload.quantity = quantity;
    }
    const actions = [
        payload
    ];
    return actions;
};
const setRemoveCartPayload = function() {
    let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    /**
   * It removeFrom cart for payload
   */ const actions = [];
    items.forEach((item)=>{
        actions.push({
            action: item.isComboSku ? "removebundle" : "removeLineItem",
            lineItemId: item.id,
            quantity: item.quantity
        });
    });
    return actions;
};
const changeBundleQty = function(id, sku, quantity, warehouses) {
    let includeInstallation = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, isInCart = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true;
    const actions = [
        {
            action: isInCart ? "changeBundleItemQuantity" : "addBundleItem",
            customLineItemId: id,
            sku,
            quantity,
            custom: {
                type: {
                    key: "cartLineItemAdditionalInfo",
                    typeId: "type"
                },
                fields: {
                    warehouses
                }
            }
        }
    ];
    return actions;
};


/***/ }),

/***/ 20889:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageLoaderWrapper":"PageLoader_pageLoaderWrapper__0QMuD","kf-page-loader-spin":"PageLoader_kf-page-loader-spin__cHGmF"};

/***/ }),

/***/ 95828:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 20127:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 28380:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 44366:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6689:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81076:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1864:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={114:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t="";n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(114);module.exports=t})();

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37645)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(80880)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
   false
    ? 0
    : __webpack_require__(63573)


/***/ }),

/***/ 70631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(24654);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 80341:
/***/ (function(module) {

"use strict";


class CancelError extends Error {
	constructor(reason) {
		super(reason || 'Promise was canceled');
		this.name = 'CancelError';
	}

	get isCanceled() {
		return true;
	}
}

class PCancelable {
	static fn(userFn) {
		return (...arguments_) => {
			return new PCancelable((resolve, reject, onCancel) => {
				arguments_.push(onCancel);
				// eslint-disable-next-line promise/prefer-await-to-then
				userFn(...arguments_).then(resolve, reject);
			});
		};
	}

	constructor(executor) {
		this._cancelHandlers = [];
		this._isPending = true;
		this._isCanceled = false;
		this._rejectOnCancel = true;

		this._promise = new Promise((resolve, reject) => {
			this._reject = reject;

			const onResolve = value => {
				if (!this._isCanceled || !onCancel.shouldReject) {
					this._isPending = false;
					resolve(value);
				}
			};

			const onReject = error => {
				this._isPending = false;
				reject(error);
			};

			const onCancel = handler => {
				if (!this._isPending) {
					throw new Error('The `onCancel` handler was attached after the promise settled.');
				}

				this._cancelHandlers.push(handler);
			};

			Object.defineProperties(onCancel, {
				shouldReject: {
					get: () => this._rejectOnCancel,
					set: boolean => {
						this._rejectOnCancel = boolean;
					}
				}
			});

			return executor(onResolve, onReject, onCancel);
		});
	}

	then(onFulfilled, onRejected) {
		// eslint-disable-next-line promise/prefer-await-to-then
		return this._promise.then(onFulfilled, onRejected);
	}

	catch(onRejected) {
		return this._promise.catch(onRejected);
	}

	finally(onFinally) {
		return this._promise.finally(onFinally);
	}

	cancel(reason) {
		if (!this._isPending || this._isCanceled) {
			return;
		}

		this._isCanceled = true;

		if (this._cancelHandlers.length > 0) {
			try {
				for (const handler of this._cancelHandlers) {
					handler();
				}
			} catch (error) {
				this._reject(error);
				return;
			}
		}

		if (this._rejectOnCancel) {
			this._reject(new CancelError(reason));
		}
	}

	get isCanceled() {
		return this._isCanceled;
	}
}

Object.setPrototypeOf(PCancelable.prototype, Promise.prototype);

module.exports = PCancelable;
module.exports.CancelError = CancelError;


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 55798:
/***/ (function(module) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 80129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(58261);
var parse = __webpack_require__(55235);
var formats = __webpack_require__(55798);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 55235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(12769);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            val = utils.maybeMap(
                parseArrayValue(
                    part.slice(pos + 1),
                    options,
                    isArray(obj[key]) ? obj[key].length : 0
                ),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : utils.combine([], leaf);
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 58261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(12769);
var formats = __webpack_require__(55798);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 12769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(55798);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 85518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(67294);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(23451);

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

__webpack_unused_export__ = AndroidView;
__webpack_unused_export__ = BrowserTypes;
__webpack_unused_export__ = BrowserView;
__webpack_unused_export__ = ConsoleView;
__webpack_unused_export__ = CustomView;
__webpack_unused_export__ = IEView;
__webpack_unused_export__ = IOSView;
__webpack_unused_export__ = MobileOnlyView;
__webpack_unused_export__ = MobileView;
__webpack_unused_export__ = OsTypes;
__webpack_unused_export__ = SmartTVView;
__webpack_unused_export__ = TabletView;
__webpack_unused_export__ = WearableView;
__webpack_unused_export__ = WinPhoneView;
__webpack_unused_export__ = browserName;
__webpack_unused_export__ = browserVersion;
__webpack_unused_export__ = deviceDetect;
__webpack_unused_export__ = deviceType;
__webpack_unused_export__ = engineName;
__webpack_unused_export__ = engineVersion;
__webpack_unused_export__ = fullBrowserVersion;
__webpack_unused_export__ = getSelectorsByUserAgent;
__webpack_unused_export__ = getUA;
__webpack_unused_export__ = isAndroid;
__webpack_unused_export__ = isBrowser;
__webpack_unused_export__ = isChrome;
__webpack_unused_export__ = isChromium;
__webpack_unused_export__ = isConsole;
__webpack_unused_export__ = isDesktop;
__webpack_unused_export__ = isEdge;
__webpack_unused_export__ = isEdgeChromium;
__webpack_unused_export__ = isElectron;
__webpack_unused_export__ = isEmbedded;
__webpack_unused_export__ = isFirefox;
__webpack_unused_export__ = isIE;
exports.gn = isIOS;
__webpack_unused_export__ = isIOS13;
__webpack_unused_export__ = isIPad13;
__webpack_unused_export__ = isIPhone13;
__webpack_unused_export__ = isIPod13;
__webpack_unused_export__ = isLegacyEdge;
__webpack_unused_export__ = isMIUI;
__webpack_unused_export__ = isMacOs;
exports.tq = isMobile;
__webpack_unused_export__ = isMobileOnly;
__webpack_unused_export__ = isMobileSafari;
__webpack_unused_export__ = isOpera;
exports.G6 = isSafari;
__webpack_unused_export__ = isSamsungBrowser;
__webpack_unused_export__ = isSmartTV;
exports.Em = isTablet;
__webpack_unused_export__ = isWearable;
__webpack_unused_export__ = isWinPhone;
__webpack_unused_export__ = isWindows;
__webpack_unused_export__ = isYandex;
__webpack_unused_export__ = mobileModel;
__webpack_unused_export__ = mobileVendor;
__webpack_unused_export__ = osName;
__webpack_unused_export__ = osVersion;
__webpack_unused_export__ = parseUserAgent;
__webpack_unused_export__ = setUserAgent;
__webpack_unused_export__ = useDeviceData;
__webpack_unused_export__ = useDeviceSelectors;
__webpack_unused_export__ = useMobileOrientation;
exports.Qe = withOrientationChange;


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(69921);
} else {}


/***/ }),

/***/ 83:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.

var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.

var BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.

var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.

var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.

var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.

var POSITIVE_NUMERIC = 6;
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}

function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.


var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
// elements (not just inputs). Now that ReactDOMInput assigns to the
// defaultValue property -- do we need this?
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.

[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      attributeName = _ref2[1];

  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).

['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.

['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML boolean attributes.

['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
// on the client side because the browsers are inconsistent. Instead we call focus().
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.

['checked', // Note: `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`. We have special logic for handling this.
'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.

['capture', 'download' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be positive numbers.

['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be numbers.

['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;

var capitalize = function capitalize(token) {
  return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.


['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // String SVG attributes with the xlink namespace.

['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
  false);
}); // String SVG attributes with the xml namespace.

['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
  false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.

['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.

var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
false);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  true, // sanitizeURL
  true);
});

var _require = __webpack_require__(78229),
    CAMELCASE = _require.CAMELCASE,
    SAME = _require.SAME,
    possibleStandardNamesOptimized = _require.possibleStandardNames;

var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see {@link https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25}
 *
 * @param {string}
 * @return {boolean}
 */

var isCustomAttribute = RegExp.prototype.test.bind( // eslint-disable-next-line no-misleading-character-class
new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
var possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce(function (accumulator, standardName) {
  var propName = possibleStandardNamesOptimized[standardName];

  if (propName === SAME) {
    accumulator[standardName] = standardName;
  } else if (propName === CAMELCASE) {
    accumulator[standardName.toLowerCase()] = standardName;
  } else {
    accumulator[standardName] = propName;
  }

  return accumulator;
}, {});

exports.BOOLEAN = BOOLEAN;
exports.BOOLEANISH_STRING = BOOLEANISH_STRING;
exports.NUMERIC = NUMERIC;
exports.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
exports.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
exports.RESERVED = RESERVED;
exports.STRING = STRING;
exports.getPropertyInfo = getPropertyInfo;
exports.isCustomAttribute = isCustomAttribute;
exports.possibleStandardNames = possibleStandardNames;


/***/ }),

/***/ 78229:
/***/ (function(__unused_webpack_module, exports) {

// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var SAME = 0;
exports.SAME = SAME;

// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var CAMELCASE = 1;
exports.CAMELCASE = CAMELCASE;

exports.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  'accept-charset': 'acceptCharset',
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: 'className',
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: 'htmlFor',
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  'http-equiv': 'httpEquiv',
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  'accent-height': 'accentHeight',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  'alignment-baseline': 'alignmentBaseline',
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  'arabic-form': 'arabicForm',
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  'baseline-shift': 'baselineShift',
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  'cap-height': 'capHeight',
  clip: 0,
  clipPath: 1,
  'clip-path': 'clipPath',
  clipPathUnits: 1,
  clipRule: 1,
  'clip-rule': 'clipRule',
  color: 0,
  colorInterpolation: 1,
  'color-interpolation': 'colorInterpolation',
  colorInterpolationFilters: 1,
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorProfile: 1,
  'color-profile': 'colorProfile',
  colorRendering: 1,
  'color-rendering': 'colorRendering',
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  'dominant-baseline': 'dominantBaseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  'enable-background': 'enableBackground',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  'fill-opacity': 'fillOpacity',
  fillRule: 1,
  'fill-rule': 'fillRule',
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  'flood-opacity': 'floodOpacity',
  floodColor: 1,
  'flood-color': 'floodColor',
  focusable: 0,
  fontFamily: 1,
  'font-family': 'fontFamily',
  fontSize: 1,
  'font-size': 'fontSize',
  fontSizeAdjust: 1,
  'font-size-adjust': 'fontSizeAdjust',
  fontStretch: 1,
  'font-stretch': 'fontStretch',
  fontStyle: 1,
  'font-style': 'fontStyle',
  fontVariant: 1,
  'font-variant': 'fontVariant',
  fontWeight: 1,
  'font-weight': 'fontWeight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  'glyph-name': 'glyphName',
  glyphOrientationHorizontal: 1,
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphOrientationVertical: 1,
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  'horiz-adv-x': 'horizAdvX',
  horizOriginX: 1,
  'horiz-origin-x': 'horizOriginX',
  ideographic: 0,
  imageRendering: 1,
  'image-rendering': 'imageRendering',
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  'letter-spacing': 'letterSpacing',
  lightingColor: 1,
  'lighting-color': 'lightingColor',
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  'marker-end': 'markerEnd',
  markerHeight: 1,
  markerMid: 1,
  'marker-mid': 'markerMid',
  markerStart: 1,
  'marker-start': 'markerStart',
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  'overline-position': 'overlinePosition',
  overlineThickness: 1,
  'overline-thickness': 'overlineThickness',
  paintOrder: 1,
  'paint-order': 'paintOrder',
  panose1: 0,
  'panose-1': 'panose1',
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  'pointer-events': 'pointerEvents',
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  'rendering-intent': 'renderingIntent',
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  'shape-rendering': 'shapeRendering',
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  'stop-color': 'stopColor',
  stopOpacity: 1,
  'stop-opacity': 'stopOpacity',
  strikethroughPosition: 1,
  'strikethrough-position': 'strikethroughPosition',
  strikethroughThickness: 1,
  'strikethrough-thickness': 'strikethroughThickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  'stroke-dasharray': 'strokeDasharray',
  strokeDashoffset: 1,
  'stroke-dashoffset': 'strokeDashoffset',
  strokeLinecap: 1,
  'stroke-linecap': 'strokeLinecap',
  strokeLinejoin: 1,
  'stroke-linejoin': 'strokeLinejoin',
  strokeMiterlimit: 1,
  'stroke-miterlimit': 'strokeMiterlimit',
  strokeWidth: 1,
  'stroke-width': 'strokeWidth',
  strokeOpacity: 1,
  'stroke-opacity': 'strokeOpacity',
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  'text-anchor': 'textAnchor',
  textDecoration: 1,
  'text-decoration': 'textDecoration',
  textLength: 1,
  textRendering: 1,
  'text-rendering': 'textRendering',
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  'underline-position': 'underlinePosition',
  underlineThickness: 1,
  'underline-thickness': 'underlineThickness',
  unicode: 0,
  unicodeBidi: 1,
  'unicode-bidi': 'unicodeBidi',
  unicodeRange: 1,
  'unicode-range': 'unicodeRange',
  unitsPerEm: 1,
  'units-per-em': 'unitsPerEm',
  unselectable: 0,
  vAlphabetic: 1,
  'v-alphabetic': 'vAlphabetic',
  values: 0,
  vectorEffect: 1,
  'vector-effect': 'vectorEffect',
  version: 0,
  vertAdvY: 1,
  'vert-adv-y': 'vertAdvY',
  vertOriginX: 1,
  'vert-origin-x': 'vertOriginX',
  vertOriginY: 1,
  'vert-origin-y': 'vertOriginY',
  vHanging: 1,
  'v-hanging': 'vHanging',
  vIdeographic: 1,
  'v-ideographic': 'vIdeographic',
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  'v-mathematical': 'vMathematical',
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  'word-spacing': 'wordSpacing',
  writingMode: 1,
  'writing-mode': 'writingMode',
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  'x-height': 'xHeight',
  xlinkActuate: 1,
  'xlink:actuate': 'xlinkActuate',
  xlinkArcrole: 1,
  'xlink:arcrole': 'xlinkArcrole',
  xlinkHref: 1,
  'xlink:href': 'xlinkHref',
  xlinkRole: 1,
  'xlink:role': 'xlinkRole',
  xlinkShow: 1,
  'xlink:show': 'xlinkShow',
  xlinkTitle: 1,
  'xlink:title': 'xlinkTitle',
  xlinkType: 1,
  'xlink:type': 'xlinkType',
  xmlBase: 1,
  'xml:base': 'xmlBase',
  xmlLang: 1,
  'xml:lang': 'xmlLang',
  xmlns: 0,
  'xml:space': 'xmlSpace',
  xmlnsXlink: 1,
  'xmlns:xlink': 'xmlnsXlink',
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};


/***/ }),

/***/ 9473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; },
  "oR": function() { return /* reexport */ useStore_useStore; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connect, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual

// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(17540);
// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(36786);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js

;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

let batch = defaultNoopBatch; // Allow injecting another batching function later

const setBatch = newBatch => batch = newBatch; // Supply a getter just to skip dealing with ESM bindings

const getBatch = () => batch;
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

const ContextKey = Symbol.for(`react-redux-context`);
const gT = typeof globalThis !== "undefined" ? globalThis :
/* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
{};

function getContext() {
  var _gT$ContextKey;

  if (!react.createContext) return {};
  const contextMap = (_gT$ContextKey = gT[ContextKey]) != null ? _gT$ContextKey : gT[ContextKey] = new Map();
  let realContext = contextMap.get(react.createContext);

  if (!realContext) {
    realContext = react.createContext(null);

    if (false) {}

    contextMap.set(react.createContext, realContext);
  }

  return realContext;
}

const Context_ReactReduxContext = /*#__PURE__*/getContext();
/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (Context_ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js



/**
 * Hook factory, which creates a `useReduxContext` hook bound to a given context. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useReduxContext` hook bound to the specified context.
 */
function createReduxContextHook(context = Context_ReactReduxContext) {
  return function useReduxContext() {
    const contextValue = (0,react.useContext)(context);

    if (false) {}

    return contextValue;
  };
}
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

const useReduxContext_useReduxContext = /*#__PURE__*/createReduxContextHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useSyncExternalStore.js
const useSyncExternalStore_notInitialized = () => {
  throw new Error('uSES not initialized!');
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js




let useSyncExternalStoreWithSelector = useSyncExternalStore_notInitialized;
const initializeUseSelector = fn => {
  useSyncExternalStoreWithSelector = fn;
};

const refEquality = (a, b) => a === b;
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context = Context_ReactReduxContext) {
  const useReduxContext = context === Context_ReactReduxContext ? useReduxContext_useReduxContext : createReduxContextHook(context);
  return function useSelector(selector, equalityFnOrOptions = {}) {
    const {
      equalityFn = refEquality,
      stabilityCheck = undefined,
      noopCheck = undefined
    } = typeof equalityFnOrOptions === 'function' ? {
      equalityFn: equalityFnOrOptions
    } : equalityFnOrOptions;

    if (false) {}

    const {
      store,
      subscription,
      getServerState,
      stabilityCheck: globalStabilityCheck,
      noopCheck: globalNoopCheck
    } = useReduxContext();
    const firstRun = (0,react.useRef)(true);
    const wrappedSelector = (0,react.useCallback)({
      [selector.name](state) {
        const selected = selector(state);

        if (false) {}

        return selected;
      }

    }[selector.name], [selector, globalStabilityCheck, stabilityCheck]);
    const selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

const useSelector = /*#__PURE__*/createSelectorHook();
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  const batch = getBatch();
  let first = null;
  let last = null;
  return {
    clear() {
      first = null;
      last = null;
    },

    notify() {
      batch(() => {
        let listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },

    get() {
      let listeners = [];
      let listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },

    subscribe(callback) {
      let isSubscribed = true;
      let listener = last = {
        callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }

  };
}

const nullListeners = {
  notify() {},

  get: () => []
};
function Subscription_createSubscription(store, parentSub) {
  let unsubscribe;
  let listeners = nullListeners; // Reasons to keep the subscription active

  let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)

  let selfSubscribed = false;

  function addNestedSub(listener) {
    trySubscribe();
    const cleanupListener = listeners.subscribe(listener); // cleanup nested sub

    let removed = false;
    return () => {
      if (!removed) {
        removed = true;
        cleanupListener();
        tryUnsubscribe();
      }
    };
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return selfSubscribed;
  }

  function trySubscribe() {
    subscriptionsAmount++;

    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    subscriptionsAmount--;

    if (unsubscribe && subscriptionsAmount === 0) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  function trySubscribeSelf() {
    if (!selfSubscribed) {
      selfSubscribed = true;
      trySubscribe();
    }
  }

  function tryUnsubscribeSelf() {
    if (selfSubscribed) {
      selfSubscribed = false;
      tryUnsubscribe();
    }
  }

  const subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe: trySubscribeSelf,
    tryUnsubscribe: tryUnsubscribeSelf,
    getListeners: () => listeners
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed
// Matches logic in React's `shared/ExecutionEnvironment` file

const canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = canUseDOM ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connect.js


const _excluded = (/* unused pure expression or super */ null && (["reactReduxForwardedRef"]));

/* eslint-disable valid-jsdoc, @typescript-eslint/no-unused-vars */













let useSyncExternalStore = (/* unused pure expression or super */ null && (notInitialized));
const initializeConnect = fn => {
  useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these

const EMPTY_ARRAY = (/* unused pure expression or super */ null && ([null, 0]));
const NO_SUBSCRIPTION_ARRAY = (/* unused pure expression or super */ null && ([null, null])); // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message

const stringifyComponent = Comp => {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(() => effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage


function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, // actualChildProps: unknown,
childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.


function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, // forceComponentUpdateDispatch: React.Dispatch<any>,
additionalSubscribeListener) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return () => {}; // Capture values for checking if and when this component unmounts

  let didUnsubscribe = false;
  let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  const checkForUpdates = () => {
    if (didUnsubscribe || !isMounted.current) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    } // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it


    const latestStoreState = store.getState();
    let newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
      // Trigger the React `useSyncExternalStore` subscriber

      additionalSubscribeListener();
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  const unsubscribeWrapper = () => {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer


const initStateUpdates = () => EMPTY_ARRAY;

function strictEqual(a, b) {
  return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */


let hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */

function connect(mapStateToProps, mapDispatchToProps, mergeProps, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure,
  areStatesEqual = strictEqual,
  areOwnPropsEqual = shallowEqual,
  areStatePropsEqual = shallowEqual,
  areMergedPropsEqual = shallowEqual,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef = false,
  // the context consumer to use
  context = ReactReduxContext
} = {}) {
  if (false) {}

  const Context = context;
  const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
  const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
  const initMergeProps = mergePropsFactory(mergeProps);
  const shouldHandleStateChanges = Boolean(mapStateToProps);

  const wrapWithConnect = WrappedComponent => {
    if (false) {}

    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const displayName = `Connect(${wrappedComponentName})`;
    const selectorFactoryOptions = {
      shouldHandleStateChanges,
      displayName,
      wrappedComponentName,
      WrappedComponent,
      // @ts-ignore
      initMapStateToProps,
      // @ts-ignore
      initMapDispatchToProps,
      initMergeProps,
      areStatesEqual,
      areStatePropsEqual,
      areOwnPropsEqual,
      areMergedPropsEqual
    };

    function ConnectFunction(props) {
      const [propsContext, reactReduxForwardedRef, wrapperProps] = React.useMemo(() => {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        const {
          reactReduxForwardedRef
        } = props,
              wrapperProps = _objectWithoutPropertiesLoose(props, _excluded);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]);
      const ContextToUse = React.useMemo(() => {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && // @ts-ignore
        isContextConsumer( /*#__PURE__*/React.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      const contextValue = React.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      const store = didStoreComeFromProps ? props.store : contextValue.store;
      const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
      const childPropsSelector = React.useMemo(() => {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return defaultSelectorFactory(store.dispatch, selectorFactoryOptions);
      }, [store]);
      const [subscription, notifyNestedSubs] = React.useMemo(() => {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        const subscription = createSubscription(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]); // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.

      const overriddenContextValue = React.useMemo(() => {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends({}, contextValue, {
          subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // Set up refs to coordinate values between the subscription effect and the render logic

      const lastChildProps = React.useRef();
      const lastWrapperProps = React.useRef(wrapperProps);
      const childPropsFromStoreUpdate = React.useRef();
      const renderIsScheduled = React.useRef(false);
      const isProcessingDispatch = React.useRef(false);
      const isMounted = React.useRef(false);
      const latestSubscriptionCallbackError = React.useRef();
      useIsomorphicLayoutEffect(() => {
        isMounted.current = true;
        return () => {
          isMounted.current = false;
        };
      }, []);
      const actualChildPropsSelector = React.useMemo(() => {
        const selector = () => {
          // Tricky logic here:
          // - This render may have been triggered by a Redux store update that produced new child props
          // - However, we may have gotten new wrapper props after that
          // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
          // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
          // So, we'll use the child props from store update only if the wrapper props are the same as last time.
          if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
            return childPropsFromStoreUpdate.current;
          } // TODO We're reading the store directly in render() here. Bad idea?
          // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
          // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
          // to determine what the child props should be.


          return childPropsSelector(store.getState(), wrapperProps);
        };

        return selector;
      }, [store, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      const subscribeForReact = React.useMemo(() => {
        const subscribe = reactListener => {
          if (!subscription) {
            return () => {};
          }

          return subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
          childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
        };

        return subscribe;
      }, [subscription]);
      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs]);
      let actualChildProps;

      try {
        actualChildProps = useSyncExternalStore( // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
        subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
        // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
        actualChildPropsSelector, getServerState ? () => childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
      } catch (err) {
        if (latestSubscriptionCallbackError.current) {
          ;
          err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
        }

        throw err;
      }

      useIsomorphicLayoutEffect(() => {
        latestSubscriptionCallbackError.current = undefined;
        childPropsFromStoreUpdate.current = undefined;
        lastChildProps.current = actualChildProps;
      }); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      const renderedWrappedComponent = React.useMemo(() => {
        return (
          /*#__PURE__*/
          // @ts-ignore
          React.createElement(WrappedComponent, _extends({}, actualChildProps, {
            ref: reactReduxForwardedRef
          }))
        );
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      const renderedChild = React.useMemo(() => {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/React.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    }

    const _Connect = React.memo(ConnectFunction);

    // Add a hacky cast to get the right output type
    const Connect = _Connect;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      const _forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        // @ts-ignore
        return /*#__PURE__*/React.createElement(Connect, _extends({}, props, {
          reactReduxForwardedRef: ref
        }));
      });

      const forwarded = _forwarded;
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistStatics(forwarded, WrappedComponent);
    }

    return hoistStatics(Connect, WrappedComponent);
  };

  return wrapWithConnect;
}

/* harmony default export */ var components_connect = ((/* unused pure expression or super */ null && (connect)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js





function Provider({
  store,
  context,
  children,
  serverState,
  stabilityCheck = 'once',
  noopCheck = 'once'
}) {
  const contextValue = react.useMemo(() => {
    const subscription = Subscription_createSubscription(store);
    return {
      store,
      subscription,
      getServerState: serverState ? () => serverState : undefined,
      stabilityCheck,
      noopCheck
    };
  }, [store, serverState, stabilityCheck, noopCheck]);
  const previousState = react.useMemo(() => store.getState(), [store]);
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(() => {
    const {
      subscription
    } = contextValue;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return () => {
      subscription.tryUnsubscribe();
      subscription.onStateChange = undefined;
    };
  }, [contextValue, previousState]);
  const Context = context || Context_ReactReduxContext; // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype

  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

/* harmony default export */ var components_Provider = (Provider);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js


/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context = Context_ReactReduxContext) {
  const useReduxContext = // @ts-ignore
  context === Context_ReactReduxContext ? useReduxContext_useReduxContext : // @ts-ignore
  createReduxContextHook(context);
  return function useStore() {
    const {
      store
    } = useReduxContext(); // @ts-ignore

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

const useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context = Context_ReactReduxContext) {
  const useStore = // @ts-ignore
  context === Context_ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    const store = useStore(); // @ts-ignore

    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

const useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/exports.js









;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.






initializeUseSelector(with_selector.useSyncExternalStoreWithSelector);
initializeConnect(shim.useSyncExternalStore); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);



/***/ }),

/***/ 44937:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(
    function () {
      inst.value = value;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
    },
    [subscribe, value, getSnapshot]
  );
  useEffect(
    function () {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      return subscribe(function () {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      });
    },
    [subscribe]
  );
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim =
  "undefined" === typeof window ||
  "undefined" === typeof window.document ||
  "undefined" === typeof window.document.createElement
    ? useSyncExternalStore$1
    : useSyncExternalStore$2;
exports.useSyncExternalStore =
  void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;


/***/ }),

/***/ 78069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294),
  shim = __webpack_require__(17540);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useSyncExternalStore = shim.useSyncExternalStore,
  useRef = React.useRef,
  useEffect = React.useEffect,
  useMemo = React.useMemo,
  useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function (
  subscribe,
  getSnapshot,
  getServerSnapshot,
  selector,
  isEqual
) {
  var instRef = useRef(null);
  if (null === instRef.current) {
    var inst = { hasValue: !1, value: null };
    instRef.current = inst;
  } else inst = instRef.current;
  instRef = useMemo(
    function () {
      function memoizedSelector(nextSnapshot) {
        if (!hasMemo) {
          hasMemo = !0;
          memoizedSnapshot = nextSnapshot;
          nextSnapshot = selector(nextSnapshot);
          if (void 0 !== isEqual && inst.hasValue) {
            var currentSelection = inst.value;
            if (isEqual(currentSelection, nextSnapshot))
              return (memoizedSelection = currentSelection);
          }
          return (memoizedSelection = nextSnapshot);
        }
        currentSelection = memoizedSelection;
        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
        var nextSelection = selector(nextSnapshot);
        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
          return (memoizedSnapshot = nextSnapshot), currentSelection;
        memoizedSnapshot = nextSnapshot;
        return (memoizedSelection = nextSelection);
      }
      var hasMemo = !1,
        memoizedSnapshot,
        memoizedSelection,
        maybeGetServerSnapshot =
          void 0 === getServerSnapshot ? null : getServerSnapshot;
      return [
        function () {
          return memoizedSelector(getSnapshot());
        },
        null === maybeGetServerSnapshot
          ? void 0
          : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            }
      ];
    },
    [getSnapshot, getServerSnapshot, selector, isEqual]
  );
  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
  useEffect(
    function () {
      inst.hasValue = !0;
      inst.value = value;
    },
    [value]
  );
  useDebugValue(value);
  return value;
};


/***/ }),

/***/ 17540:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(44937);
} else {}


/***/ }),

/***/ 36786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(78069);
} else {}


/***/ }),

/***/ 38551:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__webpack_unused_export__ = createFilter;
__webpack_unused_export__ = createWhitelistFilter;
__webpack_unused_export__ = createBlacklistFilter;
__webpack_unused_export__ = persistFilter;

var _reduxPersist = __webpack_require__(97568);

var _lodash = __webpack_require__(29208);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(31468);

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = __webpack_require__(96633);

var _lodash6 = _interopRequireDefault(_lodash5);

var _lodash7 = __webpack_require__(16040);

var _lodash8 = _interopRequireDefault(_lodash7);

var _lodash9 = __webpack_require__(99245);

var _lodash10 = _interopRequireDefault(_lodash9);

var _lodash11 = __webpack_require__(60790);

var _lodash12 = _interopRequireDefault(_lodash11);

var _lodash13 = __webpack_require__(83465);

var _lodash14 = _interopRequireDefault(_lodash13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createFilter(reducerName, inboundPaths, outboundPaths) {
	var transformType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'whitelist';

	return (0, _reduxPersist.createTransform)(
	// inbound
	function (inboundState, key) {
		return inboundPaths ? persistFilter(inboundState, inboundPaths, transformType) : inboundState;
	},

	// outbound
	function (outboundState, key) {
		return outboundPaths ? persistFilter(outboundState, outboundPaths, transformType) : outboundState;
	}, { 'whitelist': [reducerName] });
};

function createWhitelistFilter(reducerName, inboundPaths, outboundPaths) {
	return createFilter(reducerName, inboundPaths, outboundPaths, 'whitelist');
}

function createBlacklistFilter(reducerName, inboundPaths, outboundPaths) {
	return createFilter(reducerName, inboundPaths, outboundPaths, 'blacklist');
}

function filterObject(_ref, state) {
	var path = _ref.path,
	    _ref$filterFunction = _ref.filterFunction,
	    filterFunction = _ref$filterFunction === undefined ? function () {
		return true;
	} : _ref$filterFunction;

	var value = (0, _lodash2.default)(state, path, state);

	if (value instanceof Array) {
		return value.filter(filterFunction);
	}

	return (0, _lodash8.default)(value, filterFunction);
}

function persistFilter(state) {
	var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	var transformType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'whitelist';

	var subset = {};

	// support only one key
	if (typeof paths === 'string') {
		paths = [paths];
	}

	if (transformType === 'whitelist') {
		paths.forEach(function (path) {
			if ((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && !(path instanceof Array)) {
				var value = filterObject(path, state);

				if (!(0, _lodash10.default)(value)) {
					(0, _lodash4.default)(subset, path.path, value);
				}
			} else {
				var _value = (0, _lodash2.default)(state, path);

				if (typeof _value !== 'undefined') {
					(0, _lodash4.default)(subset, path, _value);
				}
			}
		});
	} else if (transformType === 'blacklist') {
		subset = (0, _lodash14.default)(state);
		paths.forEach(function (path) {
			if ((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && !(path instanceof Array)) {
				var value = filterObject(path, state);

				if (!(0, _lodash10.default)(value)) {
					if (value instanceof Array) {
						(0, _lodash4.default)(subset, path.path, (0, _lodash2.default)(subset, path.path, subset).filter(function (x) {
							return false;
						}));
					} else {
						(0, _lodash12.default)(value, function (value, key) {
							(0, _lodash6.default)(subset, path.path + '[' + key + ']');
						});
					}
				} else {
					subset = value;
				}
			} else {
				var _value2 = (0, _lodash2.default)(state, path);

				if (typeof _value2 !== 'undefined') {
					(0, _lodash6.default)(subset, path);
				}
			}
		});
	} else {
		subset = state;
	}

	return subset;
}

exports.ZP = createFilter;


/***/ }),

/***/ 97568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DEFAULT_VERSION": function() { return /* reexport */ DEFAULT_VERSION; },
  "FLUSH": function() { return /* reexport */ FLUSH; },
  "KEY_PREFIX": function() { return /* reexport */ KEY_PREFIX; },
  "PAUSE": function() { return /* reexport */ PAUSE; },
  "PERSIST": function() { return /* reexport */ PERSIST; },
  "PURGE": function() { return /* reexport */ PURGE; },
  "REGISTER": function() { return /* reexport */ REGISTER; },
  "REHYDRATE": function() { return /* reexport */ REHYDRATE; },
  "createMigrate": function() { return /* reexport */ createMigrate; },
  "createPersistoid": function() { return /* reexport */ createPersistoid; },
  "createTransform": function() { return /* reexport */ createTransform; },
  "getStoredState": function() { return /* reexport */ getStoredState_getStoredState; },
  "persistCombineReducers": function() { return /* reexport */ persistCombineReducers; },
  "persistReducer": function() { return /* reexport */ persistReducer; },
  "persistStore": function() { return /* reexport */ persistStore; },
  "purgeStoredState": function() { return /* reexport */ purgeStoredState; }
});

;// CONCATENATED MODULE: ./node_modules/redux-persist/es/constants.js
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/stateReconciler/autoMergeLevel1.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/
function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && _typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      } // otherwise hard set the new value


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/createPersistoid.js

// @TODO remove once flow < 0.63 support is no longer required.
function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var serialize;

  if (config.serialize === false) {
    serialize = function serialize(x) {
      return x;
    };
  } else if (typeof config.serialize === 'function') {
    serialize = config.serialize;
  } else {
    serialize = defaultSerialize;
  }

  var writeFailHandler = config.writeFailHandler || null; // initialize stateful values

  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop

      if (lastState[key] === state[key]) return; // value unchanged? noop

      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop

      keysToProcess.push(key); // add key to queue
    }); //if any key is missing in the new state which was present in the lastState,
    //add it for processing too

    Object.keys(lastState).forEach(function (key) {
      if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) {
        keysToProcess.push(key);
      }
    }); // start the time iterator if not running (read: throttle)

    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);

    if (endState !== undefined) {
      try {
        stagedState[key] = serialize(endState);
      } catch (err) {
        console.error('redux-persist/createPersistoid: error serializing state', err);
      }
    } else {
      //if the endState is undefined, no need to persist the existing serialized content
      delete stagedState[key];
    }

    if (keysToProcess.length === 0) {
      writeStagedState();
    }
  }

  function writeStagedState() {
    // cleanup any removed keys just before write.
    Object.keys(stagedState).forEach(function (key) {
      if (lastState[key] === undefined) {
        delete stagedState[key];
      }
    });
    writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (writeFailHandler) writeFailHandler(err);

    if (err && "production" !== 'production') {}
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }

    return writePromise || Promise.resolve();
  }; // return `persistoid`


  return {
    update: update,
    flush: flush
  };
} // @NOTE in the future this may be exposed via config

function defaultSerialize(data) {
  return JSON.stringify(data);
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/getStoredState.js

function getStoredState_getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var debug = config.debug;
  var deserialize;

  if (config.deserialize === false) {
    deserialize = function deserialize(x) {
      return x;
    };
  } else if (typeof config.deserialize === 'function') {
    deserialize = config.deserialize;
  } else {
    deserialize = defaultDeserialize;
  }

  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) {}
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/purgeStoredState.js

function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {}
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistReducer.js
function persistReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function persistReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { persistReducer_ownKeys(source, true).forEach(function (key) { persistReducer_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { persistReducer_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function persistReducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/

function persistReducer(config, baseReducer) {
  if (false) {}

  var version = config.version !== undefined ? config.version : DEFAULT_VERSION;
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? autoMergeLevel1 : config.stateReconciler;
  var getStoredState = config.getStoredState || getStoredState_getStoredState;
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;

  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ["_persist"]); // $FlowIgnore need to update State type


    var restState = rest;

    if (action.type === PERSIST) {
      var _sealed = false;

      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) {} // only rehydrate if we are not already sealed

        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };

      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
      }, timeout); // @NOTE PERSIST resumes if paused.

      _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set

      if (!_persistoid) _persistoid = createPersistoid(config); // @NOTE PERSIST can be called multiple times, noop after the first

      if (_persist) {
        // We still need to call the base reducer because there might be nested
        // uses of persistReducer which need to be aware of the PERSIST action
        return persistReducer_objectSpread({}, baseReducer(restState, action), {
          _persist: _persist
        });
      }

      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
      action.register(config.key);
      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };

        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) {}

          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: {
          version: version,
          rehydrated: false
        }
      });
    } else if (action.type === PURGE) {
      _purge = true;
      action.result(purgeStoredState(config));
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === FLUSH) {
      action.result(_persistoid && _persistoid.flush());
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === PAUSE) {
      _paused = true;
    } else if (action.type === REHYDRATE) {
      // noop on restState if purging
      if (_purge) return persistReducer_objectSpread({}, restState, {
        _persist: persistReducer_objectSpread({}, _persist, {
          rehydrated: true
        }) // @NOTE if key does not match, will continue to default else below

      });

      if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined

        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = persistReducer_objectSpread({}, reconciledRest, {
          _persist: persistReducer_objectSpread({}, _persist, {
            rehydrated: true
          })
        });

        return conditionalUpdate(_newState);
      }
    } // if we have not already handled PERSIST, straight passthrough


    if (!_persist) return baseReducer(state, action); // run base reducer:
    // is state modified ? return original : return updated

    var newState = baseReducer(restState, action);
    if (newState === restState) return state;
    return conditionalUpdate(persistReducer_objectSpread({}, newState, {
      _persist: _persist
    }));
  };
}
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/stateReconciler/autoMergeLevel2.js
function autoMergeLevel2_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { autoMergeLevel2_typeof = function _typeof(obj) { return typeof obj; }; } else { autoMergeLevel2_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return autoMergeLevel2_typeof(obj); }

function autoMergeLevel2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function autoMergeLevel2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { autoMergeLevel2_ownKeys(source, true).forEach(function (key) { autoMergeLevel2_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { autoMergeLevel2_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function autoMergeLevel2_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/
function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = autoMergeLevel2_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && autoMergeLevel2_typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      }

      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = autoMergeLevel2_objectSpread({}, newState[key], {}, inboundState[key]);
        return;
      } // otherwise hard set


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && autoMergeLevel2_typeof(o) === 'object';
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistCombineReducers.js



// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? autoMergeLevel2 : config.stateReconciler;
  return persistReducer(config, (0,redux/* combineReducers */.UY)(reducers));
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistStore.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function persistStore_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function persistStore_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { persistStore_ownKeys(source, true).forEach(function (key) { persistStore_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { persistStore_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function persistStore_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case REGISTER:
      return persistStore_objectSpread({}, state, {
        registry: [].concat(_toConsumableArray(state.registry), [action.key])
      });

    case REHYDRATE:
      var firstIndex = state.registry.indexOf(action.key);

      var registry = _toConsumableArray(state.registry);

      registry.splice(firstIndex, 1);
      return persistStore_objectSpread({}, state, {
        registry: registry,
        bootstrapped: registry.length === 0
      });

    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) { var bannedKeys, optionsToTest; }

  var boostrappedCb = cb || false;

  var _pStore = (0,redux/* createStore */.MT)(persistorReducer, initialState, options && options.enhancer ? options.enhancer : undefined);

  var register = function register(key) {
    _pStore.dispatch({
      type: REGISTER,
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: REHYDRATE,
      payload: payload,
      err: err,
      key: key // dispatch to `store` to rehydrate and `persistor` to track result

    };
    store.dispatch(rehydrateAction);

    _pStore.dispatch(rehydrateAction);

    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = persistStore_objectSpread({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: PURGE,
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: FLUSH,
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: PAUSE
      });
    },
    persist: function persist() {
      store.dispatch({
        type: PERSIST,
        register: register,
        rehydrate: rehydrate
      });
    }
  });

  if (!(options && options.manualPersist)) {
    persistor.persist();
  }

  return persistor;
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/createMigrate.js

function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) {}
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : DEFAULT_VERSION;

    if (inboundVersion === currentVersion) {
      if (false) {}
      return Promise.resolve(state);
    }

    if (inboundVersion > currentVersion) {
      if (false) {}
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });
    if (false) {}

    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) {}
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/createTransform.js
function createTransform( // @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound, // @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
    },
    out: function out(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/index.js










/***/ }),

/***/ 1190:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports.Z = autoMergeLevel2;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/
function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && _typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      }

      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = _objectSpread({}, newState[key], {}, inboundState[key]);
        return;
      } // otherwise hard set


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && _typeof(o) === 'object';
}

/***/ }),

/***/ 23488:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports.Z = createWebStorage;

var _getStorage = _interopRequireDefault(__webpack_require__(77290));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),

/***/ 77290:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;
exports["default"] = getStorage;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === "undefined" ? "undefined" : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = "redux-persist ".concat(storageType, " test");
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) {}
    return false;
  }

  return true;
}

function getStorage(type) {
  var storageType = "".concat(type, "Storage");
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {}

    return noopStorage;
  }
}

/***/ }),

/***/ 45217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "md": function() { return /* binding */ applyMiddleware; },
  "UY": function() { return /* binding */ combineReducers; },
  "qC": function() { return /* binding */ compose; },
  "MT": function() { return /* binding */ createStore; }
});

// UNUSED EXPORTS: __DO_NOT_USE__ActionTypes, bindActionCreators, legacy_createStore

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}




/***/ }),

/***/ 89509:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48764)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 35747:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 23595:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),

/***/ 69034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);
var getSideChannelMap = __webpack_require__(23595);

var $TypeError = __webpack_require__(14453);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),

/***/ 37478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(14453);
var inspect = __webpack_require__(70631);
var getSideChannelList = __webpack_require__(35747);
var getSideChannelMap = __webpack_require__(23595);
var getSideChannelWeakMap = __webpack_require__(69034);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 41476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var style_to_object_1 = __importDefault(__webpack_require__(57848));
var utilities_1 = __webpack_require__(26678);
function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') {
        return output;
    }
    (0, style_to_object_1["default"])(style, function (property, value) {
        if (property && value) {
            output[(0, utilities_1.camelCase)(property, options)] = value;
        }
    });
    return output;
}
exports["default"] = StyleToJS;


/***/ }),

/***/ 26678:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.__esModule = true;
exports.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var skipCamelCase = function (property) {
    return !property ||
        NO_HYPHEN_REGEX.test(property) ||
        CUSTOM_PROPERTY_REGEX.test(property);
};
var capitalize = function (match, character) {
    return character.toUpperCase();
};
var trimHyphen = function (match, prefix) { return "".concat(prefix, "-"); };
var camelCase = function (property, options) {
    if (options === void 0) { options = {}; }
    if (skipCamelCase(property)) {
        return property;
    }
    property = property.toLowerCase();
    if (options.reactCompat) {
        property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
    }
    else {
        property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }
    return property.replace(HYPHEN_REGEX, capitalize);
};
exports.camelCase = camelCase;


/***/ }),

/***/ 57848:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18139);

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

module.exports = StyleToObject;
module.exports["default"] = StyleToObject; // ESM support


/***/ }),

/***/ 74279:
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),

/***/ 23451:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v1.0.40
   Copyright © 2012-2024 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="1.0.40",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=500;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS",SUFFIX_BROWSER=" Browser";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return map.hasOwnProperty("*")?map["*"]:str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" GX"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"Baidu"]],[/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i],[VERSION,[NAME,"Maxthon"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,/(heytap|ovi|115)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/quark(?:pc)?\/([-\w\.]+)/i],[VERSION,[NAME,"Quark"]],[/\bddg\/([\w\.]+)/i],[VERSION,[NAME,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[VERSION,[NAME,"Smart Lenovo "+BROWSER]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI"+SUFFIX_BROWSER]],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihoobrowser\/?([\w\.]*)/i],[VERSION,[NAME,"360"]],[/\b(qq)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1Browser"],VERSION],[/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1"+SUFFIX_BROWSER],VERSION],[/samsungbrowser\/([\w\.]+)/i],[VERSION,[NAME,SAMSUNG+" Internet"]],[/metasr[\/ ]?([\d\.]+)/i],[VERSION,[NAME,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[NAME,"Sogou Mobile"],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i],[NAME,VERSION],[/(lbbrowser|rekonq)/i,/\[(linkedin)app\]/i],[NAME],[/ome\/([\w\.]+) \w* ?(iron) saf/i,/ome\/([\w\.]+).+qihu (360)[es]e/i],[VERSION,NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/(wolvic|librewolf)\/([\w\.]+)/i],[NAME,VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i],[NAME,[VERSION,/_/g,"."]],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]((?!sm-[lr])[-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/(?:honor)([-\w ]+)[;\)]/i],[MODEL,[VENDOR,"Honor"],[TYPE,MOBILE]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/\b(opd2\d{3}a?) bui/i],[MODEL,[VENDOR,"OPPO"],[TYPE,TABLET]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i],[MODEL,[VENDOR,"TCL"],[TYPE,TABLET]],[/(itel) ((\w+))/i],[[VENDOR,lowerize],MODEL,[TYPE,strMapper,{tablet:["p10001l","w7001"],"*":"mobile"}]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[MODEL,[VENDOR,"Ulefone"],[TYPE,MOBILE]],[/; (energy ?\w+)(?: bui|\))/i,/; energizer ([\w ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Energizer"],[TYPE,MOBILE]],[/; cat (b35);/i,/; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i],[MODEL,[VENDOR,"Cat"],[TYPE,MOBILE]],[/((?:new )?andromax[\w- ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Smartfren"],[TYPE,MOBILE]],[/droid.+; (a(?:015|06[35]|142p?))/i],[MODEL,[VENDOR,"Nothing"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,/; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(imo) (tab \w+)/i,/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w+)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mitv-\w{5}) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,WEARABLE]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/(pico) (4|neo3(?: link|pro)?)/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/; (quest( \d| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/(arkweb)\/([\w\.]+)/i],[NAME,VERSION],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[VERSION,strMapper,windowsVersionMap],[NAME,"Windows"]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave"}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS)}return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if("object"!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__.amdO){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),

/***/ 65885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es6; }
});

// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie/* parse */.Q(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie/* parse */.Q(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);


/***/ }),

/***/ 71739:
/***/ (function(module) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 7638:
/***/ (function(module, exports, __webpack_require__) {

var fetchApi = typeof fetch === 'function' ? fetch : undefined
if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.fetch) {
  fetchApi = __webpack_require__.g.fetch
} else if (typeof window !== 'undefined' && window.fetch) {
  fetchApi = window.fetch
}

if ( true && typeof window === 'undefined') {
  var f = fetchApi || __webpack_require__(54098)
  if (f.default) f = f.default
  exports["default"] = f
  module.exports = exports.default
}


/***/ }),

/***/ 78122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _utils = __webpack_require__(58144);
var _request = _interopRequireDefault(__webpack_require__(93183));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getDefaults = function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    parse: function parse(data) {
      return JSON.parse(data);
    },
    stringify: JSON.stringify,
    parsePayload: function parsePayload(namespace, key, fallbackValue) {
      return _defineProperty({}, key, fallbackValue || '');
    },
    parseLoadPayload: function parseLoadPayload(languages, namespaces) {
      return undefined;
    },
    request: _request.default,
    reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: false,
    withCredentials: false,
    overrideMimeType: false,
    requestOptions: {
      mode: 'cors',
      credentials: 'same-origin',
      cache: 'default'
    }
  };
};
var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Backend);
    this.services = services;
    this.options = options;
    this.allOptions = allOptions;
    this.type = 'backend';
    this.init(services, options, allOptions);
  }
  return _createClass(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = _objectSpread(_objectSpread(_objectSpread({}, getDefaults()), this.options || {}), options);
      this.allOptions = allOptions;
      if (this.services && this.options.reloadInterval) {
        var timer = setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
        if (_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
      }
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      this._readAny(languages, languages, namespaces, namespaces, callback);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      this._readAny([language], language, [namespace], namespace, callback);
    }
  }, {
    key: "_readAny",
    value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
      var _this2 = this;
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }
      loadPath = (0, _utils.makePromise)(loadPath);
      loadPath.then(function (resolvedLoadPath) {
        if (!resolvedLoadPath) return callback(null, {});
        var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
          lng: languages.join('+'),
          ns: namespaces.join('+')
        });
        _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
      });
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback, languages, namespaces) {
      var _this3 = this;
      var lng = typeof languages === 'string' ? [languages] : languages;
      var ns = typeof namespaces === 'string' ? [namespaces] : namespaces;
      var payload = this.options.parseLoadPayload(lng, ns);
      this.options.request(this.options, url, payload, function (err, res) {
        if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
        if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
        if (!res && err && err.message) {
          var errorMessage = err.message.toLowerCase();
          var isNetworkError = ['failed', 'fetch', 'network', 'load'].find(function (term) {
            return errorMessage.indexOf(term) > -1;
          });
          if (isNetworkError) {
            return callback('failed loading ' + url + ': ' + err.message, true);
          }
        }
        if (err) return callback(err, false);
        var ret, parseErr;
        try {
          if (typeof res.data === 'string') {
            ret = _this3.options.parse(res.data, languages, namespaces);
          } else {
            ret = res.data;
          }
        } catch (e) {
          parseErr = 'failed parsing ' + url + ' to json';
        }
        if (parseErr) return callback(parseErr, false);
        callback(null, ret);
      });
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue, callback) {
      var _this4 = this;
      if (!this.options.addPath) return;
      if (typeof languages === 'string') languages = [languages];
      var payload = this.options.parsePayload(namespace, key, fallbackValue);
      var finished = 0;
      var dataArray = [];
      var resArray = [];
      languages.forEach(function (lng) {
        var addPath = _this4.options.addPath;
        if (typeof _this4.options.addPath === 'function') {
          addPath = _this4.options.addPath(lng, namespace);
        }
        var url = _this4.services.interpolator.interpolate(addPath, {
          lng: lng,
          ns: namespace
        });
        _this4.options.request(_this4.options, url, payload, function (data, res) {
          finished += 1;
          dataArray.push(data);
          resArray.push(res);
          if (finished === languages.length) {
            if (typeof callback === 'function') callback(dataArray, resArray);
          }
        });
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this5 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this5.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
}();
Backend.type = 'backend';
var _default = exports["default"] = Backend;
module.exports = exports.default;

/***/ }),

/***/ 93183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _utils = __webpack_require__(58144);
var fetchNode = _interopRequireWildcard(__webpack_require__(7638));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.fetch) {
  fetchApi = __webpack_require__.g.fetch;
} else if (typeof window !== 'undefined' && window.fetch) {
  fetchApi = window.fetch;
}
var XmlHttpRequestApi;
if ((0, _utils.hasXMLHttpRequest)()) {
  if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.XMLHttpRequest) {
    XmlHttpRequestApi = __webpack_require__.g.XMLHttpRequest;
  } else if (typeof window !== 'undefined' && window.XMLHttpRequest) {
    XmlHttpRequestApi = window.XMLHttpRequest;
  }
}
var ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
  if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.ActiveXObject) {
    ActiveXObjectApi = __webpack_require__.g.ActiveXObject;
  } else if (typeof window !== 'undefined' && window.ActiveXObject) {
    ActiveXObjectApi = window.ActiveXObject;
  }
}
if (!fetchApi && fetchNode && !XmlHttpRequestApi && !ActiveXObjectApi) fetchApi = fetchNode.default || fetchNode;
if (typeof fetchApi !== 'function') fetchApi = undefined;
var addQueryString = function addQueryString(url, params) {
  if (params && _typeof(params) === 'object') {
    var queryString = '';
    for (var paramName in params) {
      queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
    }
    if (!queryString) return url;
    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }
  return url;
};
var fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
  var resolver = function resolver(response) {
    if (!response.ok) return callback(response.statusText || 'Error', {
      status: response.status
    });
    response.text().then(function (data) {
      callback(null, {
        status: response.status,
        data: data
      });
    }).catch(callback);
  };
  if (altFetch) {
    var altResponse = altFetch(url, fetchOptions);
    if (altResponse instanceof Promise) {
      altResponse.then(resolver).catch(callback);
      return;
    }
  }
  if (typeof fetch === 'function') {
    fetch(url, fetchOptions).then(resolver).catch(callback);
  } else {
    fetchApi(url, fetchOptions).then(resolver).catch(callback);
  }
};
var omitFetchOptions = false;
var requestWithFetch = function requestWithFetch(options, url, payload, callback) {
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  var headers = _objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
  if (typeof window === 'undefined' && typeof __webpack_require__.g !== 'undefined' && typeof __webpack_require__.g.process !== 'undefined' && __webpack_require__.g.process.versions && __webpack_require__.g.process.versions.node) {
    headers['User-Agent'] = "i18next-http-backend (node/".concat(__webpack_require__.g.process.version, "; ").concat(__webpack_require__.g.process.platform, " ").concat(__webpack_require__.g.process.arch, ")");
  }
  if (payload) headers['Content-Type'] = 'application/json';
  var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
  var fetchOptions = _objectSpread({
    method: payload ? 'POST' : 'GET',
    body: payload ? options.stringify(payload) : undefined,
    headers: headers
  }, omitFetchOptions ? {} : reqOptions);
  var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
  try {
    fetchIt(url, fetchOptions, callback, altFetch);
  } catch (e) {
    if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) {
      return callback(e);
    }
    try {
      Object.keys(reqOptions).forEach(function (opt) {
        delete fetchOptions[opt];
      });
      fetchIt(url, fetchOptions, callback, altFetch);
      omitFetchOptions = true;
    } catch (err) {
      callback(err);
    }
  }
};
var requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
  if (payload && _typeof(payload) === 'object') {
    payload = addQueryString('', payload).slice(1);
  }
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  try {
    var x;
    if (XmlHttpRequestApi) {
      x = new XmlHttpRequestApi();
    } else {
      x = new ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
    }
    x.open(payload ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (payload) {
      x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType('application/json');
    }
    var h = options.customHeaders;
    h = typeof h === 'function' ? h() : h;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
        status: x.status,
        data: x.responseText
      });
    };
    x.send(payload);
  } catch (e) {
    console && console.log(e);
  }
};
var request = function request(options, url, payload, callback) {
  if (typeof payload === 'function') {
    callback = payload;
    payload = undefined;
  }
  callback = callback || function () {};
  if (fetchApi && url.indexOf('file:') !== 0) {
    return requestWithFetch(options, url, payload, callback);
  }
  if ((0, _utils.hasXMLHttpRequest)() || typeof ActiveXObject === 'function') {
    return requestWithXmlHttpRequest(options, url, payload, callback);
  }
  callback(new Error('No fetch and no xhr implementation found!'));
};
var _default = exports["default"] = request;
module.exports = exports.default;

/***/ }),

/***/ 58144:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaults = defaults;
exports.hasXMLHttpRequest = hasXMLHttpRequest;
exports.makePromise = makePromise;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function hasXMLHttpRequest() {
  return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : _typeof(XMLHttpRequest)) === 'object';
}
function isPromise(maybePromise) {
  return !!maybePromise && typeof maybePromise.then === 'function';
}
function makePromise(maybePromise) {
  if (isPromise(maybePromise)) {
    return maybePromise;
  }
  return Promise.resolve(maybePromise);
}

/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 83878:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}


/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 61120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),

/***/ 32531:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}


/***/ }),

/***/ 59199:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}


/***/ }),

/***/ 25267:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 91:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 82963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t);
}


/***/ }),

/***/ 97685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || (0,nonIterableRest/* default */.Z)();
}


/***/ }),

/***/ 84506:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83878);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59199);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40181);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25267);




function _toArray(r) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(r) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(r) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 83997:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ toPropertyKey; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ }),

/***/ 30156:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "snk": function() { return /* binding */ OktaAuth; }
});

// UNUSED EXPORTS: ACCESS_TOKEN_STORAGE_KEY, AuthApiError, AuthPollStopError, AuthSdkError, AuthStateManager, AuthenticatorKey, BaseStorageManager, CACHE_STORAGE_NAME, DEFAULT_CACHE_DURATION, DEFAULT_CODE_CHALLENGE_METHOD, DEFAULT_MAX_CLOCK_SKEW, DEFAULT_POLLING_DELAY, EVENT_ADDED, EVENT_ERROR, EVENT_EXPIRED, EVENT_REMOVED, EVENT_RENEWED, EVENT_SET_STORAGE, EmailRole, IDX_API_VERSION, IDX_RESPONSE_STORAGE_NAME, ID_TOKEN_STORAGE_KEY, INITIAL_AUTH_STATE, IOS_MAX_RETRY_COUNT, IdxFeature, IdxStatus, MAX_VERIFIER_LENGTH, MIN_VERIFIER_LENGTH, OAuthError, ORIGINAL_URI_STORAGE_NAME, OktaUserAgent, PKCE_STORAGE_NAME, PasswordStatus, PromiseQueue, REFERRER_PATH_STORAGE_KEY, REFRESH_TOKEN_STORAGE_KEY, SHARED_TRANSACTION_STORAGE_NAME, STATE_TOKEN_KEY_NAME, SavedObject, ServiceManager, Status, TOKEN_STORAGE_NAME, TRANSACTION_STORAGE_NAME, TokenKind, TokenManager, WWWAuthError, addEmail, addIDPPopupLisenter, addListener, addPhone, addPostMessageListener, assertPKCESupport, authenticate, bind, buildAuthorizeParams, canProceed, cancel, clearTransactionMeta, clone, closeSession, convertTokenParamsToOAuthParams, createAuthnTransactionAPI, createBaseOptionsConstructor, createCoreOptionsConstructor, createCoreStorageManager, createEndpoints, createEnrollAuthenticatorMeta, createHttpOptionsConstructor, createIdxAPI, createIdxOptionsConstructor, createIdxStorageManager, createIdxTransactionManager, createMinimalOktaAuthIdx, createOAuthMeta, createOAuthOptionsConstructor, createOAuthStorageManager, createOktaAuthBase, createOktaAuthCore, createOktaAuthIdx, createOktaAuthMyAccount, createOktaAuthOAuth, createSessionApi, createStorageOptionsConstructor, createTokenAPI, createTransactionManager, createTransactionMeta, crypto, decodeToken, default, delay, deleteEmail, deletePassword, deletePhone, deprecate, deprecateWrap, enrollPassword, exchangeCodeForTokens, extend, find, genRandomString, generateNonce, generateState, get, getConsole, getDefaultEnrollAuthenticatorParams, getDefaultTokenParams, getEmail, getEmailChallenge, getEmails, getHashOrSearch, getKey, getLink, getNativeConsole, getOAuthBaseUrl, getOAuthDomain, getOAuthUrls, getPassword, getPhone, getPhones, getProfile, getProfileSchema, getSavedTransactionMeta, getSession, getToken, getTransactionMeta, getUserInfo, getWellKnown, getWithIDPPopup, getWithPopup, getWithRedirect, getWithoutPrompt, handleEmailVerifyCallback, handleInteractionCodeRedirect, handleOAuthResponse, hasAuthorizationCode, hasErrorInUrl, hasInteractionCode, hasResponseType, hasSavedInteractionHandle, hasTokensInHash, httpRequest, interact, introspect, isAbsoluteUrl, isAccessToken, isAuthApiError, isAuthenticator, isAuthorizationCodeError, isCodeFlow, isCustomAuthTransactionMeta, isEmailVerifyCallback, isEmailVerifyCallbackError, isFunction, isIDToken, isIdxTransactionMeta, isInteractionRequired, isInteractionRequiredError, isLoginRedirect, isNumber, isOAuthError, isOAuthTransactionMeta, isObject, isPKCETransactionMeta, isPromise, isRedirectUri, isRefreshToken, isRefreshTokenError, isRefreshTokenInvalidError, isSameRefreshToken, isString, isToken, isTransactionMeta, isTransactionMetaValid, isTransactionMetaValidForFlow, isTransactionMetaValidForOptions, isWWWAuthError, isoToUTCString, loadFrame, loadPopup, logServerSideMemoryStorageWarning, mixinAuthn, mixinCore, mixinHttp, mixinIdx, mixinMyAccount, mixinOAuth, mixinSession, mixinStorage, oidcIntrospect, omit, parseEmailVerifyCallback, parseFromUrl, pkce, poll, post, postRefreshToken, postToTokenEndpoint, prepareEnrollAuthenticatorParams, preparePKCE, prepareTokenParams, proceed, recoverPassword, refreshSession, register, removeListener, removeNils, removeTrailingSlash, renewToken, renewTokens, renewTokensWithRefresh, revokeToken, saveTransactionMeta, sendEmailChallenge, sendPhoneChallenge, sessionExists, setCookieAndRedirect, setRequestHeader, split2, startTransaction, toAbsoluteUrl, toQueryString, toRelativeUrl, unlockAccount, updatePassword, updateProfile, urlParamsToObject, validateClaims, validateCodeChallengeMethod, validateToken, verifyEmailChallenge, verifyPhoneChallenge, verifyToken, warn

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/constants.js
var constants_namespaceObject = {};
__webpack_require__.r(constants_namespaceObject);
__webpack_require__.d(constants_namespaceObject, {
  "ACCESS_TOKEN_STORAGE_KEY": function() { return ACCESS_TOKEN_STORAGE_KEY; },
  "CACHE_STORAGE_NAME": function() { return CACHE_STORAGE_NAME; },
  "DEFAULT_CACHE_DURATION": function() { return DEFAULT_CACHE_DURATION; },
  "DEFAULT_CODE_CHALLENGE_METHOD": function() { return DEFAULT_CODE_CHALLENGE_METHOD; },
  "DEFAULT_MAX_CLOCK_SKEW": function() { return DEFAULT_MAX_CLOCK_SKEW; },
  "DEFAULT_POLLING_DELAY": function() { return DEFAULT_POLLING_DELAY; },
  "IDX_API_VERSION": function() { return IDX_API_VERSION; },
  "IDX_RESPONSE_STORAGE_NAME": function() { return IDX_RESPONSE_STORAGE_NAME; },
  "ID_TOKEN_STORAGE_KEY": function() { return ID_TOKEN_STORAGE_KEY; },
  "IOS_MAX_RETRY_COUNT": function() { return IOS_MAX_RETRY_COUNT; },
  "MAX_VERIFIER_LENGTH": function() { return MAX_VERIFIER_LENGTH; },
  "MIN_VERIFIER_LENGTH": function() { return MIN_VERIFIER_LENGTH; },
  "ORIGINAL_URI_STORAGE_NAME": function() { return ORIGINAL_URI_STORAGE_NAME; },
  "PKCE_STORAGE_NAME": function() { return PKCE_STORAGE_NAME; },
  "REFERRER_PATH_STORAGE_KEY": function() { return REFERRER_PATH_STORAGE_KEY; },
  "REFRESH_TOKEN_STORAGE_KEY": function() { return REFRESH_TOKEN_STORAGE_KEY; },
  "SHARED_TRANSACTION_STORAGE_NAME": function() { return SHARED_TRANSACTION_STORAGE_NAME; },
  "STATE_TOKEN_KEY_NAME": function() { return STATE_TOKEN_KEY_NAME; },
  "TOKEN_STORAGE_NAME": function() { return TOKEN_STORAGE_NAME; },
  "TRANSACTION_STORAGE_NAME": function() { return TRANSACTION_STORAGE_NAME; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/features.js
var features_namespaceObject = {};
__webpack_require__.r(features_namespaceObject);
__webpack_require__.d(features_namespaceObject, {
  "getUserAgent": function() { return getUserAgent; },
  "hasTextEncoder": function() { return hasTextEncoder; },
  "isBrowser": function() { return isBrowser; },
  "isDPoPSupported": function() { return isDPoPSupported; },
  "isFingerprintSupported": function() { return isFingerprintSupported; },
  "isHTTPS": function() { return isHTTPS; },
  "isIE11OrLess": function() { return isIE11OrLess; },
  "isIOS": function() { return isIOS; },
  "isLocalhost": function() { return isLocalhost; },
  "isPKCESupported": function() { return isPKCESupported; },
  "isPopupPostMessageSupported": function() { return isPopupPostMessageSupported; },
  "isTokenVerifySupported": function() { return isTokenVerifySupported; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/index.js
var remediators_namespaceObject = {};
__webpack_require__.r(remediators_namespaceObject);
__webpack_require__.d(remediators_namespaceObject, {
  "AuthenticatorEnrollmentData": function() { return AuthenticatorEnrollmentData; },
  "AuthenticatorVerificationData": function() { return AuthenticatorVerificationData; },
  "ChallengeAuthenticator": function() { return ChallengeAuthenticator; },
  "ChallengePoll": function() { return ChallengePoll; },
  "EnrollAuthenticator": function() { return EnrollAuthenticator; },
  "EnrollPoll": function() { return EnrollPoll; },
  "EnrollProfile": function() { return EnrollProfile; },
  "EnrollmentChannelData": function() { return EnrollmentChannelData; },
  "GenericRemediator": function() { return GenericRemediator; },
  "Identify": function() { return Identify; },
  "ReEnrollAuthenticator": function() { return ReEnrollAuthenticator; },
  "ReEnrollAuthenticatorWarning": function() { return ReEnrollAuthenticatorWarning; },
  "RedirectIdp": function() { return RedirectIdp; },
  "Remediator": function() { return Remediator; },
  "ResetAuthenticator": function() { return ResetAuthenticator; },
  "SelectAuthenticatorAuthenticate": function() { return SelectAuthenticatorAuthenticate; },
  "SelectAuthenticatorEnroll": function() { return SelectAuthenticatorEnroll; },
  "SelectAuthenticatorUnlockAccount": function() { return SelectAuthenticatorUnlockAccount; },
  "SelectEnrollProfile": function() { return SelectEnrollProfile; },
  "SelectEnrollmentChannel": function() { return SelectEnrollmentChannel; },
  "Skip": function() { return Skip; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/index.js
var crypto_namespaceObject = {};
__webpack_require__.r(crypto_namespaceObject);
__webpack_require__.d(crypto_namespaceObject, {
  "atob": function() { return a; },
  "base64ToBase64Url": function() { return base64ToBase64Url; },
  "base64UrlDecode": function() { return base64UrlDecode; },
  "base64UrlToBase64": function() { return base64UrlToBase64; },
  "base64UrlToBuffer": function() { return base64UrlToBuffer; },
  "base64UrlToString": function() { return base64UrlToString; },
  "btoa": function() { return b; },
  "bufferToBase64Url": function() { return bufferToBase64Url; },
  "getOidcHash": function() { return getOidcHash; },
  "stringToBase64Url": function() { return stringToBase64Url; },
  "stringToBuffer": function() { return stringToBuffer; },
  "verifyToken": function() { return verifyToken; },
  "webcrypto": function() { return c; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/idx/webauthn.js
var webauthn_namespaceObject = {};
__webpack_require__.r(webauthn_namespaceObject);
__webpack_require__.d(webauthn_namespaceObject, {
  "buildCredentialCreationOptions": function() { return buildCredentialCreationOptions; },
  "buildCredentialRequestOptions": function() { return buildCredentialRequestOptions; },
  "getAssertion": function() { return getAssertion; },
  "getAttestation": function() { return getAttestation; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/api.js
var myaccount_api_namespaceObject = {};
__webpack_require__.r(myaccount_api_namespaceObject);
__webpack_require__.d(myaccount_api_namespaceObject, {
  "addEmail": function() { return addEmail; },
  "addPhone": function() { return addPhone; },
  "deleteEmail": function() { return deleteEmail; },
  "deletePassword": function() { return deletePassword; },
  "deletePhone": function() { return deletePhone; },
  "enrollPassword": function() { return enrollPassword; },
  "getEmail": function() { return getEmail; },
  "getEmailChallenge": function() { return getEmailChallenge; },
  "getEmails": function() { return getEmails; },
  "getPassword": function() { return getPassword; },
  "getPhone": function() { return getPhone; },
  "getPhones": function() { return getPhones; },
  "getProfile": function() { return getProfile; },
  "getProfileSchema": function() { return getProfileSchema; },
  "sendEmailChallenge": function() { return sendEmailChallenge; },
  "sendPhoneChallenge": function() { return sendPhoneChallenge; },
  "updatePassword": function() { return updatePassword; },
  "updateProfile": function() { return updateProfile; },
  "verifyEmailChallenge": function() { return verifyEmailChallenge; },
  "verifyPhoneChallenge": function() { return verifyPhoneChallenge; }
});

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/types/api.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

var IdxStatus;
(function (IdxStatus) {
    IdxStatus["SUCCESS"] = "SUCCESS";
    IdxStatus["PENDING"] = "PENDING";
    IdxStatus["FAILURE"] = "FAILURE";
    IdxStatus["TERMINAL"] = "TERMINAL";
    IdxStatus["CANCELED"] = "CANCELED";
})(IdxStatus || (IdxStatus = {}));
var AuthenticatorKey;
(function (AuthenticatorKey) {
    AuthenticatorKey["OKTA_PASSWORD"] = "okta_password";
    AuthenticatorKey["OKTA_EMAIL"] = "okta_email";
    AuthenticatorKey["PHONE_NUMBER"] = "phone_number";
    AuthenticatorKey["GOOGLE_AUTHENTICATOR"] = "google_otp";
    AuthenticatorKey["SECURITY_QUESTION"] = "security_question";
    AuthenticatorKey["OKTA_VERIFY"] = "okta_verify";
    AuthenticatorKey["WEBAUTHN"] = "webauthn";
})(AuthenticatorKey || (AuthenticatorKey = {}));
var IdxFeature;
(function (IdxFeature) {
    IdxFeature["PASSWORD_RECOVERY"] = "recover-password";
    IdxFeature["REGISTRATION"] = "enroll-profile";
    IdxFeature["SOCIAL_IDP"] = "redirect-idp";
    IdxFeature["ACCOUNT_UNLOCK"] = "unlock-account";
})(IdxFeature || (IdxFeature = {}));
function isAuthenticator(obj) {
    return obj && (obj.key || obj.id);
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/console.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function getNativeConsole() {
    if (typeof window !== 'undefined') {
        return window.console;
    }
    else if (typeof console !== 'undefined') {
        return console;
    }
    else {
        return undefined;
    }
}
function getConsole() {
    var nativeConsole = getNativeConsole();
    if (nativeConsole && nativeConsole.log) {
        return nativeConsole;
    }
    return {
        log: function () { },
        warn: function () { },
        group: function () { },
        groupEnd: function () { }
    };
}
function warn(text) {
    getConsole().warn('[okta-auth-sdk] WARN: ' + text);
}
function deprecate(text) {
    getConsole().warn('[okta-auth-sdk] DEPRECATION: ' + text);
}
function deprecateWrap(text, fn) {
    return function () {
        deprecate(text);
        return fn.apply(null, arguments);
    };
}


//# sourceMappingURL=console.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/object.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function bind(fn, ctx) {
    var additionalArgs = Array.prototype.slice.call(arguments, 2);
    return function () {
        var args = Array.prototype.slice.call(arguments);
        args = additionalArgs.concat(args);
        return fn.apply(ctx, args);
    };
}
function extend() {
    var obj1 = arguments[0];
    var objArray = [].slice.call(arguments, 1);
    objArray.forEach(function (obj) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop) && obj[prop] !== undefined) {
                obj1[prop] = obj[prop];
            }
        }
    });
    return obj1;
}
function removeNils(obj) {
    var cleaned = {};
    for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            var value = obj[prop];
            if (value !== null && value !== undefined) {
                cleaned[prop] = value;
            }
        }
    }
    return cleaned;
}
function clone(obj) {
    if (obj) {
        var str = JSON.stringify(obj);
        if (str) {
            return JSON.parse(str);
        }
    }
    return obj;
}
function omit(obj, ...props) {
    var newobj = {};
    for (var p in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, p) && props.indexOf(p) == -1) {
            newobj[p] = obj[p];
        }
    }
    return clone(newobj);
}
function find(collection, searchParams) {
    var c = collection.length;
    while (c--) {
        var item = collection[c];
        var found = true;
        for (var prop in searchParams) {
            if (!Object.prototype.hasOwnProperty.call(searchParams, prop)) {
                continue;
            }
            if (item[prop] !== searchParams[prop]) {
                found = false;
                break;
            }
        }
        if (found) {
            return item;
        }
    }
}
function getLink(obj, linkName, altName) {
    if (!obj || !obj._links) {
        return;
    }
    var link = clone(obj._links[linkName]);
    if (link && link.name && altName) {
        if (link.name === altName) {
            return link;
        }
    }
    else {
        return link;
    }
}


//# sourceMappingURL=object.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/CustomError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

class CustomError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}


//# sourceMappingURL=CustomError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/types.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
}
function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
function isNumber(obj) {
    return Object.prototype.toString.call(obj) === '[object Number]';
}
function isFunction(fn) {
    return !!fn && {}.toString.call(fn) === '[object Function]';
}
function isPromise(obj) {
    return obj && obj.finally && (typeof obj.finally === 'function');
}


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/WWWAuthError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class WWWAuthError extends CustomError {
    constructor(scheme, parameters, resp) {
        var _a;
        super((_a = parameters.error) !== null && _a !== void 0 ? _a : WWWAuthError.UNKNOWN_ERROR);
        this.name = 'WWWAuthError';
        this.resp = null;
        this.scheme = scheme;
        this.parameters = parameters;
        if (resp) {
            this.resp = resp;
        }
    }
    get error() { return this.parameters.error; }
    get errorCode() { return this.error; }
    get error_description() { return this.parameters.error_description; }
    get errorDescription() { return this.error_description; }
    get errorSummary() { return this.errorDescription; }
    get realm() { return this.parameters.realm; }
    static parseHeader(header) {
        var _a;
        if (!header) {
            return null;
        }
        const regex = /(?:,|, )?([a-zA-Z0-9!#$%&'*+\-.^_`|~]+)=(?:"([a-zA-Z0-9!#$%&'*+\-.,^_`|~ /:]+)"|([a-zA-Z0-9!#$%&'*+\-.^_`|~/:]+))/g;
        const firstSpace = header.indexOf(' ');
        const scheme = header.slice(0, firstSpace);
        const remaining = header.slice(firstSpace + 1);
        const params = {};
        let match;
        while ((match = regex.exec(remaining)) !== null) {
            params[match[1]] = ((_a = match[2]) !== null && _a !== void 0 ? _a : match[3]);
        }
        return new WWWAuthError(scheme, params);
    }
    static getWWWAuthenticateHeader(headers = {}) {
        var _a;
        if (isFunction(headers === null || headers === void 0 ? void 0 : headers.get)) {
            return headers.get('WWW-Authenticate');
        }
        return (_a = headers['www-authenticate']) !== null && _a !== void 0 ? _a : headers['WWW-Authenticate'];
    }
}
WWWAuthError.UNKNOWN_ERROR = 'UNKNOWN_WWW_AUTH_ERROR';


//# sourceMappingURL=WWWAuthError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/misc.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isoToUTCString(str) {
    var parts = str.match(/\d+/g), isoTime = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]), isoDate = new Date(isoTime);
    return isoDate.toUTCString();
}
function genRandomString(length) {
    var randomCharset = 'abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var random = '';
    for (var c = 0, cl = randomCharset.length; c < length; ++c) {
        random += randomCharset[Math.floor(Math.random() * cl)];
    }
    return random;
}
function delay(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}
function split2(str, delim) {
    const parts = str.split(delim);
    return [
        parts[0],
        parts.splice(1, parts.length).join(delim),
    ];
}


//# sourceMappingURL=misc.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/url.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isAbsoluteUrl(url) {
    return /^[a-z][a-z0-9+.-]*:/i.test(url);
}
function toAbsoluteUrl(url = '', baseUrl) {
    if (isAbsoluteUrl(url)) {
        return url;
    }
    baseUrl = removeTrailingSlash(baseUrl);
    return url[0] === '/' ? `${baseUrl}${url}` : `${baseUrl}/${url}`;
}
function toRelativeUrl(url = '', baseUrl) {
    if (isAbsoluteUrl(url)) {
        url = url.substring(baseUrl.length);
    }
    return url[0] === '/' ? url : `/${url}`;
}
function toQueryString(obj) {
    var str = [];
    if (obj !== null) {
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key) &&
                obj[key] !== undefined &&
                obj[key] !== null) {
                str.push(key + '=' + encodeURIComponent(obj[key]));
            }
        }
    }
    if (str.length) {
        return '?' + str.join('&');
    }
    else {
        return '';
    }
}
function removeTrailingSlash(path) {
    if (!path) {
        return;
    }
    var trimmed = path.replace(/^\s+|\s+$/gm, '');
    trimmed = trimmed.replace(/\/+$/, '');
    return trimmed;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/AuthSdkError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class AuthSdkError extends CustomError {
    constructor(msg, xhr) {
        super(msg);
        this.name = 'AuthSdkError';
        this.errorCode = 'INTERNAL';
        this.errorSummary = msg;
        this.errorLink = 'INTERNAL';
        this.errorId = 'INTERNAL';
        this.errorCauses = [];
        if (xhr) {
            this.xhr = xhr;
        }
    }
}


//# sourceMappingURL=AuthSdkError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/oauth.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function generateState() {
    return genRandomString(64);
}
function generateNonce() {
    return genRandomString(64);
}
function getIssuer(sdk, options = {}) {
    const issuer = removeTrailingSlash(options.issuer) || sdk.options.issuer;
    return issuer;
}
function getOAuthBaseUrl(sdk, options = {}) {
    const issuer = getIssuer(sdk, options);
    const baseUrl = issuer.indexOf('/oauth2') > 0 ? issuer : issuer + '/oauth2';
    return baseUrl;
}
function getOAuthDomain(sdk, options = {}) {
    const issuer = getIssuer(sdk, options);
    const domain = issuer.split('/oauth2')[0];
    return domain;
}
function getOAuthUrls(sdk, options) {
    if (arguments.length > 2) {
        throw new AuthSdkError('As of version 3.0, "getOAuthUrls" takes only a single set of options');
    }
    options = options || {};
    var authorizeUrl = removeTrailingSlash(options.authorizeUrl) || sdk.options.authorizeUrl;
    var issuer = getIssuer(sdk, options);
    var userinfoUrl = removeTrailingSlash(options.userinfoUrl) || sdk.options.userinfoUrl;
    var tokenUrl = removeTrailingSlash(options.tokenUrl) || sdk.options.tokenUrl;
    var logoutUrl = removeTrailingSlash(options.logoutUrl) || sdk.options.logoutUrl;
    var revokeUrl = removeTrailingSlash(options.revokeUrl) || sdk.options.revokeUrl;
    var baseUrl = getOAuthBaseUrl(sdk, options);
    authorizeUrl = authorizeUrl || baseUrl + '/v1/authorize';
    userinfoUrl = userinfoUrl || baseUrl + '/v1/userinfo';
    tokenUrl = tokenUrl || baseUrl + '/v1/token';
    revokeUrl = revokeUrl || baseUrl + '/v1/revoke';
    logoutUrl = logoutUrl || baseUrl + '/v1/logout';
    return {
        issuer: issuer,
        authorizeUrl: authorizeUrl,
        userinfoUrl: userinfoUrl,
        tokenUrl: tokenUrl,
        revokeUrl: revokeUrl,
        logoutUrl: logoutUrl
    };
}


//# sourceMappingURL=oauth.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/oauthMeta.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function createOAuthMeta(sdk, tokenParams) {
    const issuer = sdk.options.issuer;
    const urls = getOAuthUrls(sdk, tokenParams);
    const oauthMeta = {
        issuer,
        urls,
        clientId: tokenParams.clientId,
        redirectUri: tokenParams.redirectUri,
        responseType: tokenParams.responseType,
        responseMode: tokenParams.responseMode,
        scopes: tokenParams.scopes,
        state: tokenParams.state,
        nonce: tokenParams.nonce,
        ignoreSignature: tokenParams.ignoreSignature,
        acrValues: tokenParams.acrValues,
        extraParams: tokenParams.extraParams
    };
    if (tokenParams.pkce === false) {
        return oauthMeta;
    }
    const pkceMeta = Object.assign(Object.assign({}, oauthMeta), { codeVerifier: tokenParams.codeVerifier, codeChallengeMethod: tokenParams.codeChallengeMethod, codeChallenge: tokenParams.codeChallenge });
    return pkceMeta;
}


//# sourceMappingURL=oauthMeta.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/constants.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const STATE_TOKEN_KEY_NAME = 'oktaStateToken';
const DEFAULT_POLLING_DELAY = 500;
const IOS_MAX_RETRY_COUNT = 3;
const DEFAULT_MAX_CLOCK_SKEW = 300;
const DEFAULT_CACHE_DURATION = 86400;
const TOKEN_STORAGE_NAME = 'okta-token-storage';
const CACHE_STORAGE_NAME = 'okta-cache-storage';
const PKCE_STORAGE_NAME = 'okta-pkce-storage';
const TRANSACTION_STORAGE_NAME = 'okta-transaction-storage';
const SHARED_TRANSACTION_STORAGE_NAME = 'okta-shared-transaction-storage';
const ORIGINAL_URI_STORAGE_NAME = 'okta-original-uri-storage';
const IDX_RESPONSE_STORAGE_NAME = 'okta-idx-response-storage';
const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';
const ID_TOKEN_STORAGE_KEY = 'idToken';
const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';
const REFERRER_PATH_STORAGE_KEY = 'referrerPath';
const MIN_VERIFIER_LENGTH = 43;
const MAX_VERIFIER_LENGTH = 128;
const DEFAULT_CODE_CHALLENGE_METHOD = 'S256';
const IDX_API_VERSION = '1.0.0';


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/AuthApiError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class AuthApiError extends CustomError {
    constructor(err, xhr, meta) {
        const message = err.errorSummary;
        super(message);
        this.name = 'AuthApiError';
        this.errorSummary = err.errorSummary;
        this.errorCode = err.errorCode;
        this.errorLink = err.errorLink;
        this.errorId = err.errorId;
        this.errorCauses = err.errorCauses;
        if (xhr) {
            this.xhr = xhr;
        }
        if (meta) {
            this.meta = meta;
        }
    }
}


//# sourceMappingURL=AuthApiError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/OAuthError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OAuthError extends CustomError {
    constructor(errorCode, summary, resp) {
        super(summary);
        this.resp = null;
        this.name = 'OAuthError';
        this.errorCode = errorCode;
        this.errorSummary = summary;
        this.error = errorCode;
        this.error_description = summary;
        if (resp) {
            this.resp = resp;
        }
    }
}


//# sourceMappingURL=OAuthError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const a = function (str) { return atob(str); };
const b = function (str) { return btoa(str); };
const c = typeof crypto === 'undefined' ? null : crypto;


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/features.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




const isWindowsPhone = /windows phone|iemobile|wpdesktop/i;
function isBrowser() {
    return typeof document !== 'undefined' && typeof window !== 'undefined';
}
function isIE11OrLess() {
    if (!isBrowser()) {
        return false;
    }
    const documentMode = document.documentMode;
    return !!documentMode && documentMode <= 11;
}
function getUserAgent() {
    return navigator.userAgent;
}
function isFingerprintSupported() {
    const agent = getUserAgent();
    return agent && !isWindowsPhone.test(agent);
}
function isPopupPostMessageSupported() {
    if (!isBrowser()) {
        return false;
    }
    const documentMode = document.documentMode;
    var isIE8or9 = documentMode && documentMode < 10;
    if (typeof window.postMessage !== 'undefined' && !isIE8or9) {
        return true;
    }
    return false;
}
function isWebCryptoSubtleSupported() {
    return typeof c !== 'undefined'
        && c !== null
        && typeof c.subtle !== 'undefined'
        && typeof Uint8Array !== 'undefined';
}
function isTokenVerifySupported() {
    return isWebCryptoSubtleSupported();
}
function hasTextEncoder() {
    return typeof TextEncoder !== 'undefined';
}
function isPKCESupported() {
    return isTokenVerifySupported() && hasTextEncoder();
}
function isHTTPS() {
    if (!isBrowser()) {
        return false;
    }
    return window.location.protocol === 'https:';
}
function isLocalhost() {
    return isBrowser() && window.location.hostname === 'localhost';
}
function isDPoPSupported() {
    return !isIE11OrLess() &&
        typeof window.indexedDB !== 'undefined' &&
        hasTextEncoder() &&
        isWebCryptoSubtleSupported();
}
function isIOS() {
    return isBrowser() && typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' &&
        (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
}


//# sourceMappingURL=features.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/http/request.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










let dateDocumentBecameVisible = 0;
let trackDateDocumentBecameVisible;
if (isBrowser()) {
    dateDocumentBecameVisible = Date.now();
    trackDateDocumentBecameVisible = () => {
        if (!document.hidden) {
            dateDocumentBecameVisible = Date.now();
        }
    };
    document.addEventListener('visibilitychange', trackDateDocumentBecameVisible);
}
const formatError = (sdk, error) => {
    var _a;
    if (error instanceof Error) {
        return new AuthApiError({
            errorSummary: error.message,
        });
    }
    let resp = error;
    let err;
    let serverErr = {};
    if (resp.responseText && isString(resp.responseText)) {
        try {
            serverErr = JSON.parse(resp.responseText);
        }
        catch (e) {
            serverErr = {
                errorSummary: 'Unknown error'
            };
        }
    }
    if (resp.status >= 500) {
        serverErr.errorSummary = 'Unknown error';
    }
    if (sdk.options.transformErrorXHR) {
        resp = sdk.options.transformErrorXHR(clone(resp));
    }
    const wwwAuthHeader = (_a = WWWAuthError.getWWWAuthenticateHeader(resp === null || resp === void 0 ? void 0 : resp.headers)) !== null && _a !== void 0 ? _a : '';
    if (serverErr.error && serverErr.error_description) {
        err = new OAuthError(serverErr.error, serverErr.error_description, resp);
    }
    else {
        err = new AuthApiError(serverErr, resp, { wwwAuthHeader });
    }
    if (wwwAuthHeader && (resp === null || resp === void 0 ? void 0 : resp.status) >= 400 && (resp === null || resp === void 0 ? void 0 : resp.status) < 500) {
        const wwwAuthErr = WWWAuthError.parseHeader(wwwAuthHeader);
        if (resp.status === 403 && (wwwAuthErr === null || wwwAuthErr === void 0 ? void 0 : wwwAuthErr.error) === 'insufficient_authentication_context') {
            const { max_age, acr_values } = wwwAuthErr.parameters;
            err = new AuthApiError({
                errorSummary: wwwAuthErr.error,
                errorCauses: [{ errorSummary: wwwAuthErr.errorDescription }]
            }, resp, Object.assign({
                max_age: +max_age }, (acr_values && { acr_values })));
        }
        else if ((wwwAuthErr === null || wwwAuthErr === void 0 ? void 0 : wwwAuthErr.scheme) === 'DPoP') {
            err = wwwAuthErr;
        }
    }
    return err;
};
function httpRequest(sdk, options) {
    var _a;
    options = options || {};
    if (sdk.options.httpRequestInterceptors) {
        for (const interceptor of sdk.options.httpRequestInterceptors) {
            interceptor(options);
        }
    }
    var url = options.url, method = options.method, args = options.args, saveAuthnState = options.saveAuthnState, accessToken = options.accessToken, withCredentials = options.withCredentials === true,
    storageUtil = sdk.options.storageUtil, storage = storageUtil.storage, httpCache = sdk.storageManager.getHttpCache(sdk.options.cookies), pollingIntent = options.pollingIntent, pollDelay = (_a = sdk.options.pollDelay) !== null && _a !== void 0 ? _a : 0;
    if (options.cacheResponse) {
        var cacheContents = httpCache.getStorage();
        var cachedResponse = cacheContents[url];
        if (cachedResponse && Date.now() / 1000 < cachedResponse.expiresAt) {
            return Promise.resolve(cachedResponse.response);
        }
    }
    var oktaUserAgentHeader = sdk._oktaUserAgent.getHttpHeader();
    var headers = Object.assign({ 'Accept': 'application/json', 'Content-Type': 'application/json' }, oktaUserAgentHeader);
    Object.assign(headers, sdk.options.headers, options.headers);
    headers = removeNils(headers);
    if (accessToken && isString(accessToken)) {
        headers['Authorization'] = 'Bearer ' + accessToken;
    }
    var ajaxOptions = {
        headers,
        data: args || undefined,
        withCredentials
    };
    var err, res, promise;
    if (pollingIntent && isBrowser() && pollDelay > 0) {
        let waitForVisibleAndAwakenDocument;
        let waitForAwakenDocument;
        let recursiveFetch;
        let retryCount = 0;
        waitForAwakenDocument = () => {
            const timeSinceDocumentIsVisible = Date.now() - dateDocumentBecameVisible;
            if (timeSinceDocumentIsVisible < pollDelay) {
                return new Promise((resolve) => setTimeout(() => {
                    if (!document.hidden) {
                        resolve();
                    }
                    else {
                        resolve(waitForVisibleAndAwakenDocument());
                    }
                }, pollDelay - timeSinceDocumentIsVisible));
            }
            else {
                return Promise.resolve();
            }
        };
        waitForVisibleAndAwakenDocument = () => {
            if (document.hidden) {
                let pageVisibilityHandler;
                return new Promise((resolve) => {
                    pageVisibilityHandler = () => {
                        if (!document.hidden) {
                            document.removeEventListener('visibilitychange', pageVisibilityHandler);
                            resolve(waitForAwakenDocument());
                        }
                    };
                    document.addEventListener('visibilitychange', pageVisibilityHandler);
                });
            }
            else {
                return waitForAwakenDocument();
            }
        };
        const retryableFetch = () => {
            return sdk.options.httpRequestClient(method, url, ajaxOptions).catch((err) => {
                const isNetworkError = (err === null || err === void 0 ? void 0 : err.message) === 'Load failed';
                if (isNetworkError && retryCount < IOS_MAX_RETRY_COUNT) {
                    retryCount++;
                    return recursiveFetch();
                }
                throw err;
            });
        };
        recursiveFetch = () => {
            return waitForVisibleAndAwakenDocument().then(retryableFetch);
        };
        promise = recursiveFetch();
    }
    else {
        promise = sdk.options.httpRequestClient(method, url, ajaxOptions);
    }
    return promise
        .then(function (resp) {
        res = resp.responseText;
        if (res && isString(res)) {
            res = JSON.parse(res);
            if (res && typeof res === 'object' && !res.headers) {
                if (Array.isArray(res)) {
                    res.forEach(item => {
                        item.headers = resp.headers;
                    });
                }
                else {
                    res.headers = resp.headers;
                }
            }
        }
        if (saveAuthnState) {
            if (!res.stateToken) {
                storage.delete(STATE_TOKEN_KEY_NAME);
            }
        }
        if (res && res.stateToken && res.expiresAt) {
            storage.set(STATE_TOKEN_KEY_NAME, res.stateToken, res.expiresAt, sdk.options.cookies);
        }
        if (res && options.cacheResponse) {
            httpCache.updateStorage(url, {
                expiresAt: Math.floor(Date.now() / 1000) + DEFAULT_CACHE_DURATION,
                response: res
            });
        }
        return res;
    })
        .catch(function (resp) {
        err = formatError(sdk, resp);
        if (err.errorCode === 'E0000011') {
            storage.delete(STATE_TOKEN_KEY_NAME);
        }
        throw err;
    });
}
function get(sdk, url, options) {
    url = isAbsoluteUrl(url) ? url : sdk.getIssuerOrigin() + url;
    var getOptions = {
        url: url,
        method: 'GET'
    };
    Object.assign(getOptions, options);
    return httpRequest(sdk, getOptions);
}
function post(sdk, url, args, options) {
    url = isAbsoluteUrl(url) ? url : sdk.getIssuerOrigin() + url;
    var postOptions = {
        url: url,
        method: 'POST',
        args: args,
        saveAuthnState: true
    };
    Object.assign(postOptions, options);
    return httpRequest(sdk, postOptions);
}


//# sourceMappingURL=request.js.map

// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(74279);
;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */



// EXTERNAL MODULE: ./node_modules/@okta/okta-auth-js/node_modules/cross-fetch/dist/browser-ponyfill.js
var browser_ponyfill = __webpack_require__(44642);
;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/types/Token.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

var TokenKind;
(function (TokenKind) {
    TokenKind["ACCESS"] = "accessToken";
    TokenKind["ID"] = "idToken";
    TokenKind["REFRESH"] = "refreshToken";
})(TokenKind || (TokenKind = {}));
function isToken(obj) {
    if (obj &&
        (obj.accessToken || obj.idToken || obj.refreshToken) &&
        Array.isArray(obj.scopes)) {
        return true;
    }
    return false;
}
function isAccessToken(obj) {
    return obj && obj.accessToken;
}
function isIDToken(obj) {
    return obj && obj.idToken;
}
function isRefreshToken(obj) {
    return obj && obj.refreshToken;
}


//# sourceMappingURL=Token.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/_virtual/_tslib.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};


//# sourceMappingURL=_tslib.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/transactionMeta.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












async function transactionMeta_createTransactionMeta(authClient, options = {}) {
    const tokenParams = await authClient.token.prepareTokenParams(options);
    const pkceMeta = createOAuthMeta(authClient, tokenParams);
    let { flow = 'default', withCredentials = true, activationToken = undefined, recoveryToken = undefined, maxAge = undefined, acrValues = undefined, } = Object.assign(Object.assign({}, authClient.options), options);
    const meta = Object.assign(Object.assign({}, pkceMeta), { flow,
        withCredentials,
        activationToken,
        recoveryToken,
        maxAge,
        acrValues });
    return meta;
}
function hasSavedInteractionHandle(authClient, options) {
    const savedMeta = transactionMeta_getSavedTransactionMeta(authClient, options);
    if (savedMeta === null || savedMeta === void 0 ? void 0 : savedMeta.interactionHandle) {
        return true;
    }
    return false;
}
function transactionMeta_getSavedTransactionMeta(authClient, options) {
    options = removeNils(options);
    options = Object.assign(Object.assign({}, authClient.options), options);
    let savedMeta;
    try {
        savedMeta = authClient.transactionManager.load(options);
    }
    catch (e) {
    }
    if (!savedMeta) {
        return;
    }
    if (transactionMeta_isTransactionMetaValid(savedMeta, options)) {
        return savedMeta;
    }
    warn('Saved transaction meta does not match the current configuration. ' +
        'This may indicate that two apps are sharing a storage key.');
}
async function transactionMeta_getTransactionMeta(authClient, options) {
    options = removeNils(options);
    options = Object.assign(Object.assign({}, authClient.options), options);
    const validExistingMeta = transactionMeta_getSavedTransactionMeta(authClient, options);
    if (validExistingMeta) {
        return validExistingMeta;
    }
    return transactionMeta_createTransactionMeta(authClient, options);
}
function transactionMeta_saveTransactionMeta(authClient, meta) {
    authClient.transactionManager.save(meta, { muteWarning: true });
}
function transactionMeta_clearTransactionMeta(authClient) {
    authClient.transactionManager.clear();
}
function transactionMeta_isTransactionMetaValid(meta, options = {}) {
    const keys = [
        'issuer',
        'clientId',
        'redirectUri',
        'state',
        'codeChallenge',
        'codeChallengeMethod',
        'activationToken',
        'recoveryToken'
    ];
    if (isTransactionMetaValidForOptions(meta, options, keys) === false) {
        return false;
    }
    const { flow } = options;
    if (isTransactionMetaValidForFlow(meta, flow) === false) {
        return false;
    }
    return true;
}
function isTransactionMetaValidForFlow(meta, flow) {
    const shouldValidateFlow = flow && flow !== 'default' && flow !== 'proceed';
    if (shouldValidateFlow) {
        if (flow !== meta.flow) {
            return false;
        }
    }
    return true;
}
function isTransactionMetaValidForOptions(meta, options, keys) {
    const mismatch = keys.some(key => {
        const value = options[key];
        if (value && value !== meta[key]) {
            return true;
        }
    });
    return !mismatch;
}


//# sourceMappingURL=transactionMeta.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/interact.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












function getResponse(meta) {
    return {
        meta,
        interactionHandle: meta.interactionHandle,
        state: meta.state
    };
}
async function interact(authClient, options = {}) {
    options = removeNils(options);
    let meta = transactionMeta_getSavedTransactionMeta(authClient, options);
    if (meta === null || meta === void 0 ? void 0 : meta.interactionHandle) {
        return getResponse(meta);
    }
    meta = await transactionMeta_createTransactionMeta(authClient, Object.assign(Object.assign({}, meta), options));
    const baseUrl = getOAuthBaseUrl(authClient);
    let { clientId, redirectUri, state, scopes, withCredentials, codeChallenge, codeChallengeMethod, activationToken, recoveryToken, maxAge, acrValues, nonce } = meta;
    const clientSecret = options.clientSecret || authClient.options.clientSecret;
    withCredentials = withCredentials !== null && withCredentials !== void 0 ? withCredentials : true;
    const url = `${baseUrl}/v1/interact`;
    const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ client_id: clientId, scope: scopes.join(' '), redirect_uri: redirectUri, code_challenge: codeChallenge, code_challenge_method: codeChallengeMethod, state }, (activationToken && { activation_token: activationToken })), (recoveryToken && { recovery_token: recoveryToken })), (clientSecret && { client_secret: clientSecret })), (maxAge && { max_age: maxAge })), (acrValues && { acr_values: acrValues })), (nonce && { nonce }));
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
    };
    const resp = await httpRequest(authClient, {
        method: 'POST',
        url,
        headers,
        withCredentials,
        args: params
    });
    const interactionHandle = resp.interaction_handle;
    const newMeta = Object.assign(Object.assign({}, meta), { interactionHandle,
        withCredentials,
        state,
        scopes,
        recoveryToken,
        activationToken });
    transactionMeta_saveTransactionMeta(authClient, newMeta);
    return getResponse(newMeta);
}


//# sourceMappingURL=interact.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/actionParser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const isFieldMutable = function isFieldMutable(field) {
    return (field.mutable !== false);
};
const divideSingleActionParamsByMutability = function divideSingleActionParamsByMutability(action) {
    var _a, _b;
    const defaultParamsForAction = {};
    const neededParamsForAction = [];
    const immutableParamsForAction = {};
    if (!action.value) {
        neededParamsForAction.push(action);
        return { defaultParamsForAction, neededParamsForAction, immutableParamsForAction };
    }
    for (let field of action.value) {
        if (isFieldMutable(field)) {
            neededParamsForAction.push(field);
            if ((_a = field.value) !== null && _a !== void 0 ? _a : false) {
                defaultParamsForAction[field.name] = field.value;
            }
        }
        else {
            immutableParamsForAction[field.name] = (_b = field.value) !== null && _b !== void 0 ? _b : '';
        }
    }
    return { defaultParamsForAction, neededParamsForAction, immutableParamsForAction };
};
const divideActionParamsByMutability = function divideActionParamsByMutability(actionList) {
    actionList = Array.isArray(actionList) ? actionList : [actionList];
    const neededParams = [];
    const defaultParams = {};
    const immutableParams = {};
    for (let action of actionList) {
        const { defaultParamsForAction, neededParamsForAction, immutableParamsForAction } = divideSingleActionParamsByMutability(action);
        neededParams.push(neededParamsForAction);
        defaultParams[action.name] = defaultParamsForAction;
        immutableParams[action.name] = immutableParamsForAction;
    }
    return { defaultParams, neededParams, immutableParams };
};


//# sourceMappingURL=actionParser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/generateIdxAction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









const generateDirectFetch = function generateDirectFetch(authClient, { actionDefinition, defaultParamsForAction = {}, immutableParamsForAction = {}, toPersist = {} }) {
    const target = actionDefinition.href;
    return async function (params = {}) {
        var _a, _b;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': actionDefinition.accepts || 'application/ion+json',
        };
        const body = JSON.stringify(Object.assign(Object.assign(Object.assign({}, defaultParamsForAction), params), immutableParamsForAction));
        try {
            const options = {
                url: target,
                method: actionDefinition.method,
                headers,
                args: body,
                withCredentials: (_a = toPersist === null || toPersist === void 0 ? void 0 : toPersist.withCredentials) !== null && _a !== void 0 ? _a : true
            };
            const isPolling = actionDefinition.name === 'poll' || ((_b = actionDefinition.name) === null || _b === void 0 ? void 0 : _b.endsWith('-poll'));
            if (isPolling) {
                options.pollingIntent = true;
            }
            const response = await httpRequest(authClient, options);
            return authClient.idx.makeIdxResponse(Object.assign({}, response), toPersist, true);
        }
        catch (err) {
            if (!(err instanceof AuthApiError) || !(err === null || err === void 0 ? void 0 : err.xhr)) {
                throw err;
            }
            const response = err.xhr;
            const payload = response.responseJSON || JSON.parse(response.responseText);
            const wwwAuthHeader = response.headers['WWW-Authenticate'] || response.headers['www-authenticate'];
            const idxResponse = authClient.idx.makeIdxResponse(Object.assign({}, payload), toPersist, false);
            if (response.status === 401 && wwwAuthHeader === 'Oktadevicejwt realm="Okta Device"') {
                idxResponse.stepUp = true;
            }
            return idxResponse;
        }
    };
};
const generateIdxAction = function generateIdxAction(authClient, actionDefinition, toPersist) {
    const generator = generateDirectFetch;
    const { defaultParams, neededParams, immutableParams } = divideActionParamsByMutability(actionDefinition);
    const action = generator(authClient, {
        actionDefinition,
        defaultParamsForAction: defaultParams[actionDefinition.name],
        immutableParamsForAction: immutableParams[actionDefinition.name],
        toPersist
    });
    action.neededParams = neededParams;
    return action;
};


//# sourceMappingURL=generateIdxAction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/remediationParser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const generateRemediationFunctions = function generateRemediationFunctions(authClient, remediationValue, toPersist = {}) {
    return remediationValue.reduce((obj, remediation) => (Object.assign(Object.assign({}, obj), { [remediation.name]: generateIdxAction(authClient, remediation, toPersist) })), {});
};


//# sourceMappingURL=remediationParser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/jsonpath.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const jsonpathRegex = /\$?(?<step>\w+)|(?:\[(?<index>\d+)\])/g;
function jsonpath({ path, json }) {
    var _a, _b, _c;
    const steps = [];
    let match;
    while ((match = jsonpathRegex.exec(path)) !== null) {
        const step = (_b = (_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.step) !== null && _b !== void 0 ? _b : (_c = match === null || match === void 0 ? void 0 : match.groups) === null || _c === void 0 ? void 0 : _c.index;
        if (step) {
            steps.push(step);
        }
    }
    if (steps.length < 1) {
        return undefined;
    }
    const lastStep = steps.pop();
    let curr = json;
    for (const step of steps) {
        if (Object.prototype.hasOwnProperty.call(curr, step)) {
            if (typeof curr[step] !== 'object') {
                return undefined;
            }
            curr = curr[step];
        }
    }
    return curr[lastStep];
}


//# sourceMappingURL=jsonpath.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/idxResponseParser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








const SKIP_FIELDS = {
    'remediation': true,
    'context': true,
};
const parseNonRemediations = function parseNonRemediations(authClient, idxResponse, toPersist = {}) {
    const actions = {};
    const context = {};
    Object.keys(idxResponse)
        .filter(field => !SKIP_FIELDS[field])
        .forEach(field => {
        const fieldIsObject = typeof idxResponse[field] === 'object' && !!idxResponse[field];
        if (!fieldIsObject) {
            context[field] = idxResponse[field];
            return;
        }
        if (idxResponse[field].rel) {
            actions[idxResponse[field].name] = generateIdxAction(authClient, idxResponse[field], toPersist);
            return;
        }
        const _a = idxResponse[field], { value: fieldValue, type } = _a, info = __rest(_a, ["value", "type"]);
        context[field] = Object.assign({ type }, info);
        if (type !== 'object') {
            context[field].value = fieldValue;
            return;
        }
        context[field].value = {};
        Object.entries(fieldValue)
            .forEach(([subField, value]) => {
            if (value.rel) {
                actions[`${field}-${subField.name || subField}`] = generateIdxAction(authClient, value, toPersist);
            }
            else {
                context[field].value[subField] = value;
            }
        });
    });
    return { context, actions };
};
const expandRelatesTo = (idxResponse, value) => {
    Object.keys(value).forEach(k => {
        if (k === 'relatesTo') {
            const query = Array.isArray(value[k]) ? value[k][0] : value[k];
            if (typeof query === 'string') {
                const result = jsonpath({ path: query, json: idxResponse });
                if (result) {
                    value[k] = result;
                    return;
                }
                else {
                    throw new AuthSdkError(`Cannot resolve relatesTo: ${query}`);
                }
            }
        }
        if (Array.isArray(value[k])) {
            value[k].forEach(innerValue => expandRelatesTo(idxResponse, innerValue));
        }
    });
};
const convertRemediationAction = (authClient, remediation, toPersist) => {
    if (remediation.rel) {
        const remediationActions = generateRemediationFunctions(authClient, [remediation], toPersist);
        const actionFn = remediationActions[remediation.name];
        return Object.assign(Object.assign({}, remediation), { action: actionFn });
    }
    return remediation;
};
const parseIdxResponse = function parseIdxResponse(authClient, idxResponse, toPersist = {}) {
    var _a;
    const remediationData = ((_a = idxResponse.remediation) === null || _a === void 0 ? void 0 : _a.value) || [];
    remediationData.forEach(remediation => {
        var _a;
        if (remediation.name === 'launch-authenticator' &&
            ((_a = remediation === null || remediation === void 0 ? void 0 : remediation.relatesTo) === null || _a === void 0 ? void 0 : _a[0]) === 'authenticatorChallenge' &&
            !(idxResponse === null || idxResponse === void 0 ? void 0 : idxResponse.authenticatorChallenge)) {
            delete remediation.relatesTo;
            return;
        }
        return expandRelatesTo(idxResponse, remediation);
    });
    const remediations = remediationData.map(remediation => convertRemediationAction(authClient, remediation, toPersist));
    const { context, actions } = parseNonRemediations(authClient, idxResponse, toPersist);
    return {
        remediations,
        context,
        actions,
    };
};


//# sourceMappingURL=idxResponseParser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/makeIdxState.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function makeIdxState_makeIdxState(authClient, idxResponse, toPersist, requestDidSucceed) {
    var _a, _b, _c;
    const rawIdxResponse = idxResponse;
    const { remediations, context, actions } = parseIdxResponse(authClient, idxResponse, toPersist);
    const neededToProceed = [...remediations];
    const proceed = async function (remediationChoice, paramsFromUser = {}) {
        const remediationChoiceObject = remediations.find((remediation) => remediation.name === remediationChoice);
        if (!remediationChoiceObject) {
            return Promise.reject(`Unknown remediation choice: [${remediationChoice}]`);
        }
        const actionFn = remediationChoiceObject.action;
        if (typeof actionFn !== 'function') {
            return Promise.reject(`Current remediation cannot make form submit action: [${remediationChoice}]`);
        }
        return remediationChoiceObject.action(paramsFromUser);
    };
    const findCode = item => item.name === 'interaction_code';
    const interactionCode = (_c = (_b = (_a = rawIdxResponse.successWithInteractionCode) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.find(findCode)) === null || _c === void 0 ? void 0 : _c.value;
    return {
        proceed,
        neededToProceed,
        actions,
        context,
        rawIdxState: rawIdxResponse,
        interactionCode,
        toPersist,
        requestDidSucceed,
    };
}


//# sourceMappingURL=makeIdxState.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/parsers.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



var v1 = {
    makeIdxState: makeIdxState_makeIdxState,
};


//# sourceMappingURL=parsers.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




const parsersForVersion = function parsersForVersion(version) {
    switch (version) {
        case '1.0.0':
            return v1;
        case undefined:
        case null:
            throw new Error('Api version is required');
        default:
            throw new Error(`Unknown api version: ${version}.  Use an exact semver version.`);
    }
};
function validateVersionConfig(version) {
    if (!version) {
        throw new Error('version is required');
    }
    const cleanVersion = (version !== null && version !== void 0 ? version : '').replace(/[^0-9a-zA-Z._-]/, '');
    if (cleanVersion !== version || !version) {
        throw new Error('invalid version supplied - version is required and uses semver syntax');
    }
    parsersForVersion(version);
}
function idxState_makeIdxState(authClient, rawIdxResponse, toPersist, requestDidSucceed) {
    var _a;
    const version = (_a = rawIdxResponse === null || rawIdxResponse === void 0 ? void 0 : rawIdxResponse.version) !== null && _a !== void 0 ? _a : IDX_API_VERSION;
    validateVersionConfig(version);
    const { makeIdxState } = parsersForVersion(version);
    return makeIdxState(authClient, rawIdxResponse, toPersist, requestDidSucceed);
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/types/idx-js.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isRawIdxResponse(obj) {
    return obj && obj.version;
}


//# sourceMappingURL=idx-js.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function errors_isAuthApiError(obj) {
    return (obj instanceof AuthApiError);
}
function isOAuthError(obj) {
    return (obj instanceof OAuthError);
}
function isWWWAuthError(obj) {
    return (obj instanceof WWWAuthError);
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/introspect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */













async function introspect(authClient, options = {}) {
    var _a;
    let rawIdxResponse;
    let requestDidSucceed;
    const savedIdxResponse = authClient.transactionManager.loadIdxResponse(options);
    if (savedIdxResponse) {
        rawIdxResponse = savedIdxResponse.rawIdxResponse;
        requestDidSucceed = savedIdxResponse.requestDidSucceed;
    }
    if (!rawIdxResponse) {
        const version = options.version || IDX_API_VERSION;
        const domain = getOAuthDomain(authClient);
        const { interactionHandle, stateHandle } = options;
        const withCredentials = (_a = options.withCredentials) !== null && _a !== void 0 ? _a : true;
        try {
            requestDidSucceed = true;
            validateVersionConfig(version);
            const url = `${domain}/idp/idx/introspect`;
            const body = stateHandle ? { stateToken: stateHandle } : { interactionHandle };
            const headers = {
                'Content-Type': `application/ion+json; okta-version=${version}`,
                Accept: `application/ion+json; okta-version=${version}`,
            };
            rawIdxResponse = await httpRequest(authClient, {
                method: 'POST',
                url,
                headers,
                withCredentials,
                args: body
            });
        }
        catch (err) {
            if (errors_isAuthApiError(err) && err.xhr && isRawIdxResponse(err.xhr.responseJSON)) {
                rawIdxResponse = err.xhr.responseJSON;
                requestDidSucceed = false;
            }
            else {
                throw err;
            }
        }
    }
    const { withCredentials } = options;
    return idxState_makeIdxState(authClient, rawIdxResponse, { withCredentials }, requestDidSucceed);
}


//# sourceMappingURL=introspect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function getAllValues(idxRemediation) {
    var _a;
    return (_a = idxRemediation.value) === null || _a === void 0 ? void 0 : _a.map(r => r.name);
}
function getRequiredValues(idxRemediation) {
    var _a;
    return (_a = idxRemediation.value) === null || _a === void 0 ? void 0 : _a.reduce((required, cur) => {
        if (cur.required) {
            required.push(cur.name);
        }
        return required;
    }, []);
}
function titleCase(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
}
function getAuthenticatorFromRemediation(remediation) {
    return remediation.value.find(({ name }) => name === 'authenticator');
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function formatAuthenticator(incoming) {
    let authenticator;
    if (isAuthenticator(incoming)) {
        authenticator = incoming;
    }
    else if (typeof incoming === 'string') {
        authenticator = {
            key: incoming
        };
    }
    else {
        throw new Error('Invalid format for authenticator');
    }
    return authenticator;
}
function compareAuthenticators(auth1, auth2) {
    if (!auth1 || !auth2) {
        return false;
    }
    if (auth1.id && auth2.id) {
        return (auth1.id === auth2.id);
    }
    if (auth1.key && auth2.key) {
        return (auth1.key === auth2.key);
    }
    return false;
}
function findMatchedOption(authenticators, options) {
    let option;
    for (let authenticator of authenticators) {
        option = options
            .find(({ relatesTo }) => relatesTo.key && relatesTo.key === authenticator.key);
        if (option) {
            break;
        }
    }
    return option;
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/Remediator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class Remediator {
    constructor(remediation, values = {}, options = {}) {
        this.values = Object.assign({}, values);
        this.options = Object.assign({}, options);
        this.formatAuthenticators();
        this.remediation = remediation;
    }
    formatAuthenticators() {
        this.values.authenticators = (this.values.authenticators || []);
        this.values.authenticators = this.values.authenticators.map(authenticator => {
            return formatAuthenticator(authenticator);
        });
        if (this.values.authenticator) {
            const authenticator = formatAuthenticator(this.values.authenticator);
            const hasAuthenticatorInList = this.values.authenticators.some(existing => {
                return compareAuthenticators(authenticator, existing);
            });
            if (!hasAuthenticatorInList) {
                this.values.authenticators.push(authenticator);
            }
        }
        this.values.authenticatorsData = this.values.authenticators.reduce((acc, authenticator) => {
            if (typeof authenticator === 'object' && Object.keys(authenticator).length > 1) {
                acc.push(authenticator);
            }
            return acc;
        }, this.values.authenticatorsData || []);
    }
    getName() {
        return this.remediation.name;
    }
    canRemediate(context) {
        const required = getRequiredValues(this.remediation);
        const needed = required.find((key) => !this.hasData(key));
        if (needed) {
            return false;
        }
        return true;
    }
    getData(key) {
        if (!key) {
            let allValues = getAllValues(this.remediation);
            let res = allValues.reduce((data, key) => {
                data[key] = this.getData(key);
                return data;
            }, {});
            return res;
        }
        if (typeof this[`map${titleCase(key)}`] === 'function') {
            const val = this[`map${titleCase(key)}`](this.remediation.value.find(({ name }) => name === key));
            if (val) {
                return val;
            }
        }
        if (this.map && this.map[key]) {
            const entry = this.map[key];
            for (let i = 0; i < entry.length; i++) {
                let val = this.values[entry[i]];
                if (val) {
                    return val;
                }
            }
        }
        return this.values[key];
    }
    hasData(key
    ) {
        return !!this.getData(key);
    }
    getNextStep(_authClient, _context) {
        const name = this.getName();
        const inputs = this.getInputs();
        const authenticator = this.getAuthenticator();
        const type = authenticator === null || authenticator === void 0 ? void 0 : authenticator.type;
        return Object.assign(Object.assign({ name,
            inputs }, (type && { type })), (authenticator && { authenticator }));
    }
    getInputs() {
        const inputs = [];
        const inputsFromRemediation = this.remediation.value || [];
        inputsFromRemediation.forEach(inputFromRemediation => {
            let input;
            let { name, type, visible, messages } = inputFromRemediation;
            if (visible === false) {
                return;
            }
            if (typeof this[`getInput${titleCase(name)}`] === 'function') {
                input = this[`getInput${titleCase(name)}`](inputFromRemediation);
            }
            else if (type !== 'object') {
                let alias;
                const aliases = (this.map ? this.map[name] : null) || [];
                if (aliases.length === 1) {
                    alias = aliases[0];
                }
                else {
                    alias = aliases.find(name => Object.keys(this.values).includes(name));
                }
                if (alias) {
                    input = Object.assign(Object.assign({}, inputFromRemediation), { name: alias });
                }
            }
            if (!input) {
                input = inputFromRemediation;
            }
            if (Array.isArray(input)) {
                input.forEach(i => inputs.push(i));
            }
            else {
                if (messages) {
                    input.messages = messages;
                }
                inputs.push(input);
            }
        });
        return inputs;
    }
    static getMessages(remediation) {
        var _a, _b;
        if (!remediation.value) {
            return;
        }
        return (_b = (_a = remediation.value[0]) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.value.reduce((messages, field) => {
            if (field.messages) {
                messages = [...messages, ...field.messages.value];
            }
            return messages;
        }, []);
    }
    getValuesAfterProceed() {
        const inputsFromRemediation = this.remediation.value || [];
        const inputsFromRemediator = this.getInputs();
        const inputs = [
            ...inputsFromRemediation,
            ...inputsFromRemediator
        ];
        for (const input of inputs) {
            delete this.values[input.name];
        }
        return this.values;
    }
    getAuthenticator() {
        var _a, _b;
        const relatesTo = (_a = this.remediation.relatesTo) === null || _a === void 0 ? void 0 : _a.value;
        if (!relatesTo) {
            return;
        }
        const authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
        if (!authenticatorFromRemediation) {
            return relatesTo;
        }
        const id = authenticatorFromRemediation.form.value
            .find(({ name }) => name === 'id').value;
        const enrollmentId = (_b = authenticatorFromRemediation.form.value
            .find(({ name }) => name === 'enrollmentId')) === null || _b === void 0 ? void 0 : _b.value;
        return Object.assign(Object.assign({}, relatesTo), { id,
            enrollmentId });
    }
}


//# sourceMappingURL=Remediator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/GenericRemediator/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function unwrapFormValue(remediation) {
    if (Array.isArray(remediation)) {
        return remediation
            .map(item => {
            if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
                return item;
            }
            return unwrapFormValue(item);
        });
    }
    const res = {};
    for (const [key, value] of Object.entries(remediation)) {
        if (value === null || typeof value === 'undefined') {
            continue;
        }
        if (typeof value === 'object') {
            const formKeys = Object.keys(value);
            if (['value', 'form'].includes(key)
                && formKeys.length === 1
                && ['value', 'form'].includes(formKeys[0])) {
                const unwrappedForm = unwrapFormValue(value);
                Object.entries(unwrappedForm).forEach(([key, value]) => {
                    res[key] = value;
                });
            }
            else {
                res[key] = unwrapFormValue(value);
            }
        }
        else {
            res[key] = value;
        }
    }
    return res;
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/GenericRemediator/GenericRemediator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class GenericRemediator extends Remediator {
    canRemediate() {
        if (typeof this.remediation.action !== 'function') {
            return false;
        }
        if (this.remediation.name === 'poll' || this.remediation.name.endsWith('-poll')) {
            return true;
        }
        if (this.options.step) {
            return true;
        }
        return false;
    }
    getData() {
        const data = this.getInputs().reduce((acc, { name }) => {
            acc[name] = this.values[name];
            return acc;
        }, {});
        return data;
    }
    getNextStep(authClient, _context) {
        const name = this.getName();
        const inputs = this.getInputs();
        const _a = this.remediation, {
        href, method, rel, accepts, produces,
        value,
        action } = _a, rest = __rest(_a, ["href", "method", "rel", "accepts", "produces", "value", "action"]);
        if (action) {
            return Object.assign(Object.assign(Object.assign({}, rest), (!!inputs.length && { inputs })), { action: async (params) => {
                    return authClient.idx.proceed(Object.assign({ step: name }, params));
                } });
        }
        return Object.assign({}, this.remediation);
    }
    getInputs() {
        return (this.remediation.value || [])
            .filter(({ name }) => name !== 'stateHandle')
            .map(unwrapFormValue)
            .map(input => {
            input.type = input.type || 'string';
            return input;
        });
    }
}


//# sourceMappingURL=GenericRemediator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







const ctx = {
    remediators: {},
    getFlowSpecification: function (_oktaAuth, _flow = 'default') {
        return {
            remediators: {}
        };
    }
};
function setRemediatorsCtx(newCtx) {
    Object.assign(ctx, newCtx);
}
function getFlowSpecification(oktaAuth, flow = 'default') {
    return ctx.getFlowSpecification(oktaAuth, flow);
}
function isTerminalResponse(idxResponse) {
    const { neededToProceed, interactionCode } = idxResponse;
    return !neededToProceed.length && !interactionCode;
}
function canSkipFn(idxResponse) {
    return idxResponse.neededToProceed.some(({ name }) => name === 'skip');
}
function canResendFn(idxResponse) {
    return Object.keys(idxResponse.actions).some(actionName => actionName.includes('resend'));
}
function getMessagesFromIdxRemediationValue(value) {
    if (!value || !Array.isArray(value)) {
        return;
    }
    return value.reduce((messages, value) => {
        if (value.messages) {
            messages = [...messages, ...value.messages.value];
        }
        if (value.form) {
            const messagesFromForm = getMessagesFromIdxRemediationValue(value.form.value) || [];
            messages = [...messages, ...messagesFromForm];
        }
        if (value.options) {
            let optionValues = [];
            value.options.forEach(option => {
                if (!option.value || typeof option.value === 'string') {
                    return;
                }
                optionValues = [...optionValues, option.value];
            });
            const messagesFromOptions = getMessagesFromIdxRemediationValue(optionValues) || [];
            messages = [...messages, ...messagesFromOptions];
        }
        return messages;
    }, []);
}
function getMessagesFromResponse(idxResponse, options) {
    var _a;
    let messages = [];
    const { rawIdxState, neededToProceed } = idxResponse;
    const globalMessages = (_a = rawIdxState.messages) === null || _a === void 0 ? void 0 : _a.value.map(message => message);
    if (globalMessages) {
        messages = [...messages, ...globalMessages];
    }
    if (!options.useGenericRemediator) {
        for (let remediation of neededToProceed) {
            const fieldMessages = getMessagesFromIdxRemediationValue(remediation.value);
            if (fieldMessages) {
                messages = [...messages, ...fieldMessages];
            }
        }
    }
    const seen = {};
    messages = messages.reduce((filtered, message) => {
        var _a;
        const key = (_a = message.i18n) === null || _a === void 0 ? void 0 : _a.key;
        if (key && seen[key] && message.message === seen[key].message) {
            return filtered;
        }
        seen[key] = message;
        filtered = [...filtered, message];
        return filtered;
    }, []);
    return messages;
}
function getEnabledFeatures(idxResponse) {
    const res = [];
    const { actions, neededToProceed } = idxResponse;
    if (actions['currentAuthenticator-recover']) {
        res.push(IdxFeature.PASSWORD_RECOVERY);
    }
    if (neededToProceed.some(({ name }) => name === 'select-enroll-profile')) {
        res.push(IdxFeature.REGISTRATION);
    }
    if (neededToProceed.some(({ name }) => name === 'redirect-idp')) {
        res.push(IdxFeature.SOCIAL_IDP);
    }
    if (neededToProceed.some(({ name }) => name === 'unlock-account')) {
        res.push(IdxFeature.ACCOUNT_UNLOCK);
    }
    return res;
}
function getAvailableSteps(authClient, idxResponse, useGenericRemediator) {
    var _a;
    const res = [];
    const remediatorMap = Object.values(ctx.remediators)
        .reduce((map, remediatorClass) => {
        if (remediatorClass.remediationName) {
            map[remediatorClass.remediationName] = remediatorClass;
        }
        return map;
    }, {});
    for (let remediation of idxResponse.neededToProceed) {
        const T = getRemediatorClass(remediation, { useGenericRemediator, remediators: remediatorMap });
        if (T) {
            const remediator = new T(remediation);
            res.push(remediator.getNextStep(authClient, idxResponse.context));
        }
    }
    for (const [name] of Object.entries((idxResponse.actions || {}))) {
        let stepObj = {
            name,
            action: async (params) => {
                return authClient.idx.proceed({
                    actions: [{ name, params }]
                });
            }
        };
        if (name.startsWith('currentAuthenticator')) {
            const [part1, part2] = split2(name, '-');
            const actionObj = idxResponse.rawIdxState[part1].value[part2];
            const rest = __rest(actionObj, ["href", "method", "rel", "accepts", "produces"]);
            const value = (_a = actionObj.value) === null || _a === void 0 ? void 0 : _a.filter(item => item.name !== 'stateHandle');
            stepObj = Object.assign(Object.assign(Object.assign({}, rest), (value && { value })), stepObj);
        }
        res.push(stepObj);
    }
    return res;
}
function filterValuesForRemediation(idxResponse, remediationName, values) {
    const remediations = idxResponse.neededToProceed || [];
    const remediation = remediations.find(r => r.name === remediationName);
    if (!remediation) {
        warn(`filterValuesForRemediation: "${remediationName}" did not match any remediations`);
        return values;
    }
    const valuesForRemediation = remediation.value.reduce((res, entry) => {
        const { name, value } = entry;
        if (name === 'stateHandle') {
            res[name] = value;
        }
        else {
            res[name] = values[name];
        }
        return res;
    }, {});
    return valuesForRemediation;
}
function getRemediatorClass(remediation, options) {
    const { useGenericRemediator, remediators } = options;
    if (!remediation) {
        return undefined;
    }
    if (useGenericRemediator) {
        return GenericRemediator;
    }
    return remediators[remediation.name];
}
function getRemediator(idxResponse, values, options) {
    const remediators = options.remediators;
    const useGenericRemediator = options.useGenericRemediator;
    const { neededToProceed: idxRemediations, context } = idxResponse;
    let remediator;
    if (options.step) {
        const remediation = idxRemediations.find(({ name }) => name === options.step);
        if (remediation) {
            const T = getRemediatorClass(remediation, options);
            return T ? new T(remediation, values, options) : undefined;
        }
        else {
            warn(`step "${options.step}" did not match any remediations`);
            return;
        }
    }
    const remediatorCandidates = [];
    if (useGenericRemediator) {
        remediatorCandidates.push(new GenericRemediator(idxRemediations[0], values, options));
    }
    else {
        for (let remediation of idxRemediations) {
            const isRemeditionInFlow = Object.keys(remediators).includes(remediation.name);
            if (!isRemeditionInFlow) {
                continue;
            }
            const T = getRemediatorClass(remediation, options);
            remediator = new T(remediation, values, options);
            if (remediator.canRemediate(context)) {
                return remediator;
            }
            remediatorCandidates.push(remediator);
        }
    }
    return remediatorCandidates[0];
}
function getNextStep(authClient, remediator, idxResponse) {
    const nextStep = remediator.getNextStep(authClient, idxResponse.context);
    const canSkip = canSkipFn(idxResponse);
    const canResend = canResendFn(idxResponse);
    return Object.assign(Object.assign(Object.assign({}, nextStep), (canSkip && { canSkip })), (canResend && { canResend }));
}
function handleFailedResponse(authClient, idxResponse, options = {}) {
    const terminal = isTerminalResponse(idxResponse);
    const messages = getMessagesFromResponse(idxResponse, options);
    if (terminal) {
        return { idxResponse, terminal, messages };
    }
    else {
        const remediator = getRemediator(idxResponse, {}, options);
        const nextStep = remediator && getNextStep(authClient, remediator, idxResponse);
        return Object.assign({ idxResponse,
            messages }, (nextStep && { nextStep }));
    }
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediate.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function getActionFromValues(values, idxResponse) {
    return Object.keys(idxResponse.actions).find(action => !!values.resend && action.includes('-resend'));
}
function removeActionFromValues(values) {
    return Object.assign(Object.assign({}, values), { resend: undefined });
}
function removeActionFromOptions(options, actionName) {
    let actions = options.actions || [];
    actions = actions.filter(entry => {
        if (typeof entry === 'string') {
            return entry !== actionName;
        }
        return entry.name !== actionName;
    });
    return Object.assign(Object.assign({}, options), { actions });
}
async function remediate(authClient, idxResponse, values, options) {
    let { neededToProceed, interactionCode } = idxResponse;
    const { flow } = options;
    if (interactionCode) {
        return { idxResponse };
    }
    const remediator = getRemediator(idxResponse, values, options);
    const actionFromValues = getActionFromValues(values, idxResponse);
    const actionFromOptions = options.actions || [];
    const actions = [
        ...actionFromOptions,
        ...(actionFromValues && [actionFromValues] || []),
    ];
    if (actions) {
        for (let action of actions) {
            let params = {};
            if (typeof action !== 'string') {
                params = action.params || {};
                action = action.name;
            }
            let valuesWithoutExecutedAction = removeActionFromValues(values);
            let optionsWithoutExecutedAction = removeActionFromOptions(options, action);
            if (typeof idxResponse.actions[action] === 'function') {
                idxResponse = await idxResponse.actions[action](params);
                if (idxResponse.requestDidSucceed === false) {
                    return handleFailedResponse(authClient, idxResponse, options);
                }
                if (action === 'cancel') {
                    return { idxResponse, canceled: true };
                }
                return remediate(authClient, idxResponse, valuesWithoutExecutedAction, optionsWithoutExecutedAction);
            }
            const remediationAction = neededToProceed.find(({ name }) => name === action);
            if (remediationAction) {
                idxResponse = await idxResponse.proceed(action, params);
                if (idxResponse.requestDidSucceed === false) {
                    return handleFailedResponse(authClient, idxResponse, options);
                }
                return remediate(authClient, idxResponse, values, optionsWithoutExecutedAction);
            }
        }
    }
    const terminal = isTerminalResponse(idxResponse);
    if (terminal) {
        return { idxResponse, terminal };
    }
    if (!remediator) {
        if (options.step) {
            values = filterValuesForRemediation(idxResponse, options.step, values);
            idxResponse = await idxResponse.proceed(options.step, values);
            if (idxResponse.requestDidSucceed === false) {
                return handleFailedResponse(authClient, idxResponse, options);
            }
            return { idxResponse };
        }
        if (flow === 'default') {
            return { idxResponse };
        }
        throw new AuthSdkError(`
      No remediation can match current flow, check policy settings in your org.
      Remediations: [${neededToProceed.reduce((acc, curr) => acc ? acc + ' ,' + curr.name : curr.name, '')}]
    `);
    }
    if (!remediator.canRemediate()) {
        const nextStep = getNextStep(authClient, remediator, idxResponse);
        return {
            idxResponse,
            nextStep,
        };
    }
    const name = remediator.getName();
    const data = remediator.getData();
    idxResponse = await idxResponse.proceed(name, data);
    if (idxResponse.requestDidSucceed === false) {
        return handleFailedResponse(authClient, idxResponse, options);
    }
    values = remediator.getValuesAfterProceed();
    options = Object.assign(Object.assign({}, options), { step: undefined });
    if (options.useGenericRemediator && !idxResponse.interactionCode && !isTerminalResponse(idxResponse)) {
        const gr = getRemediator(idxResponse, values, options);
        const nextStep = getNextStep(authClient, gr, idxResponse);
        return {
            idxResponse,
            nextStep,
        };
    }
    return remediate(authClient, idxResponse, values, options);
}


//# sourceMappingURL=remediate.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/run.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function initializeValues(options) {
    const knownOptions = [
        'flow',
        'remediators',
        'actions',
        'withCredentials',
        'step',
        'useGenericRemediator',
        'exchangeCodeForTokens',
    ];
    const values = Object.assign({}, options);
    knownOptions.forEach(option => {
        delete values[option];
    });
    return values;
}
function initializeData(authClient, data) {
    var _a, _b, _c, _d;
    let { options } = data;
    options = Object.assign(Object.assign({}, authClient.options.idx), options);
    let { flow, withCredentials, remediators, actions, } = options;
    const status = IdxStatus.PENDING;
    flow = flow || ((_b = (_a = authClient.idx).getFlow) === null || _b === void 0 ? void 0 : _b.call(_a)) || 'default';
    if (flow) {
        (_d = (_c = authClient.idx).setFlow) === null || _d === void 0 ? void 0 : _d.call(_c, flow);
        const flowSpec = getFlowSpecification(authClient, flow);
        withCredentials = (typeof withCredentials !== 'undefined') ? withCredentials : flowSpec.withCredentials;
        remediators = remediators || flowSpec.remediators;
        actions = actions || flowSpec.actions;
    }
    return Object.assign(Object.assign({}, data), { options: Object.assign(Object.assign({}, options), { flow,
            withCredentials,
            remediators,
            actions }), status });
}
async function getDataFromIntrospect(authClient, data) {
    const { options } = data;
    const { stateHandle, withCredentials, version, state, scopes, recoveryToken, activationToken, maxAge, acrValues, nonce, useGenericRemediator, } = options;
    let idxResponse;
    let meta = transactionMeta_getSavedTransactionMeta(authClient, { state, recoveryToken, activationToken });
    if (stateHandle) {
        idxResponse = await introspect(authClient, { withCredentials, version, stateHandle, useGenericRemediator });
    }
    else {
        let interactionHandle = meta === null || meta === void 0 ? void 0 : meta.interactionHandle;
        if (!interactionHandle) {
            authClient.transactionManager.clear();
            const interactResponse = await interact(authClient, {
                withCredentials,
                state,
                scopes,
                activationToken,
                recoveryToken,
                maxAge,
                acrValues,
                nonce,
            });
            interactionHandle = interactResponse.interactionHandle;
            meta = interactResponse.meta;
        }
        idxResponse = await introspect(authClient, { withCredentials, version, interactionHandle, useGenericRemediator });
    }
    return Object.assign(Object.assign({}, data), { idxResponse, meta });
}
async function getDataFromRemediate(authClient, data) {
    let { idxResponse, options, values } = data;
    const { autoRemediate, remediators, actions, flow, step, useGenericRemediator, } = options;
    const shouldRemediate = (autoRemediate !== false && (remediators || actions || step));
    if (!shouldRemediate) {
        return data;
    }
    values = Object.assign(Object.assign({}, values), { stateHandle: idxResponse.rawIdxState.stateHandle });
    const { idxResponse: idxResponseFromRemediation, nextStep, canceled, } = await remediate(authClient, idxResponse, values, {
        remediators,
        actions,
        flow,
        step,
        useGenericRemediator,
    });
    idxResponse = idxResponseFromRemediation;
    return Object.assign(Object.assign({}, data), { idxResponse, nextStep, canceled });
}
async function getTokens(authClient, data) {
    let { meta, idxResponse } = data;
    const { interactionCode } = idxResponse;
    const { clientId, codeVerifier, ignoreSignature, redirectUri, urls, scopes, } = meta;
    const tokenResponse = await authClient.token.exchangeCodeForTokens({
        interactionCode,
        clientId,
        codeVerifier,
        ignoreSignature,
        redirectUri,
        scopes
    }, urls);
    return tokenResponse.tokens;
}
async function finalizeData(authClient, data) {
    let { options, idxResponse, canceled, status, } = data;
    const { exchangeCodeForTokens } = options;
    let shouldSaveResponse = false;
    let shouldClearTransaction = false;
    let clearSharedStorage = true;
    let interactionCode;
    let tokens;
    let enabledFeatures;
    let availableSteps;
    let messages;
    let terminal;
    if (idxResponse) {
        shouldSaveResponse = !!(idxResponse.requestDidSucceed || idxResponse.stepUp);
        enabledFeatures = getEnabledFeatures(idxResponse);
        availableSteps = getAvailableSteps(authClient, idxResponse, options.useGenericRemediator);
        messages = getMessagesFromResponse(idxResponse, options);
        terminal = isTerminalResponse(idxResponse);
    }
    if (terminal) {
        status = IdxStatus.TERMINAL;
        const hasActions = Object.keys(idxResponse.actions).length > 0;
        const hasErrors = !!messages.find(msg => msg.class === 'ERROR');
        const isTerminalSuccess = !hasActions && !hasErrors && idxResponse.requestDidSucceed === true;
        if (isTerminalSuccess) {
            shouldClearTransaction = true;
        }
        else {
            shouldSaveResponse = !!hasActions;
        }
        clearSharedStorage = false;
    }
    else if (canceled) {
        status = IdxStatus.CANCELED;
        shouldClearTransaction = true;
    }
    else if (idxResponse === null || idxResponse === void 0 ? void 0 : idxResponse.interactionCode) {
        interactionCode = idxResponse.interactionCode;
        if (exchangeCodeForTokens === false) {
            status = IdxStatus.SUCCESS;
            shouldClearTransaction = false;
        }
        else {
            tokens = await getTokens(authClient, data);
            status = IdxStatus.SUCCESS;
            shouldClearTransaction = true;
        }
    }
    return Object.assign(Object.assign({}, data), { status,
        interactionCode,
        tokens,
        shouldSaveResponse,
        shouldClearTransaction,
        clearSharedStorage,
        enabledFeatures,
        availableSteps,
        messages,
        terminal });
}
async function run(authClient, options = {}) {
    var _a;
    let data = {
        options,
        values: initializeValues(options)
    };
    data = initializeData(authClient, data);
    data = await getDataFromIntrospect(authClient, data);
    data = await getDataFromRemediate(authClient, data);
    data = await finalizeData(authClient, data);
    const { idxResponse, meta, shouldSaveResponse, shouldClearTransaction, clearSharedStorage, status, enabledFeatures, availableSteps, tokens, nextStep, messages, error, interactionCode } = data;
    if (shouldClearTransaction) {
        authClient.transactionManager.clear({ clearSharedStorage });
    }
    else {
        transactionMeta_saveTransactionMeta(authClient, Object.assign({}, meta));
        if (shouldSaveResponse) {
            const { rawIdxState: rawIdxResponse, requestDidSucceed } = idxResponse;
            authClient.transactionManager.saveIdxResponse({
                rawIdxResponse,
                requestDidSucceed,
                stateHandle: (_a = idxResponse.context) === null || _a === void 0 ? void 0 : _a.stateHandle,
                interactionHandle: meta === null || meta === void 0 ? void 0 : meta.interactionHandle
            });
        }
    }
    const { actions, context, neededToProceed, proceed, rawIdxState, requestDidSucceed, stepUp } = idxResponse || {};
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ status: status }, (meta && { meta })), (enabledFeatures && { enabledFeatures })), (availableSteps && { availableSteps })), (tokens && { tokens })), (nextStep && { nextStep })), (messages && messages.length && { messages })), (error && { error })), (stepUp && { stepUp })), { interactionCode,
        actions: actions, context: context, neededToProceed: neededToProceed, proceed: proceed, rawIdxState: rawIdxState, requestDidSucceed });
}


//# sourceMappingURL=run.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticate.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




async function authenticate(authClient, options = {}) {
    if (options.password && !options.authenticator) {
        options.authenticator = AuthenticatorKey.OKTA_PASSWORD;
    }
    return run(authClient, Object.assign(Object.assign({}, options), { flow: 'authenticate' }));
}


//# sourceMappingURL=authenticate.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/Authenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

class Authenticator {
    constructor(authenticator) {
        this.meta = authenticator;
    }
}


//# sourceMappingURL=Authenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/VerificationCodeAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class VerificationCodeAuthenticator extends Authenticator {
    canVerify(values) {
        return !!(values.credentials || values.verificationCode || values.otp);
    }
    mapCredentials(values) {
        const { credentials, verificationCode, otp } = values;
        if (!credentials && !verificationCode && !otp) {
            return;
        }
        return credentials || { passcode: verificationCode || otp };
    }
    getInputs(idxRemediationValue) {
        var _a;
        return Object.assign(Object.assign({}, (_a = idxRemediationValue.form) === null || _a === void 0 ? void 0 : _a.value[0]), { name: 'verificationCode', type: 'string', required: idxRemediationValue.required });
    }
}


//# sourceMappingURL=VerificationCodeAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/OktaVerifyTotp.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OktaVerifyTotp extends VerificationCodeAuthenticator {
    mapCredentials(values) {
        const { verificationCode } = values;
        if (!verificationCode) {
            return;
        }
        return { totp: verificationCode };
    }
}


//# sourceMappingURL=OktaVerifyTotp.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/OktaPassword.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OktaPassword extends Authenticator {
    canVerify(values) {
        return !!(values.credentials || values.password || values.passcode);
    }
    mapCredentials(values) {
        const { credentials, password, passcode, revokeSessions } = values;
        if (!credentials && !password && !passcode) {
            return;
        }
        return credentials || {
            passcode: passcode || password,
            revokeSessions,
        };
    }
    getInputs(idxRemediationValue) {
        var _a, _b;
        const inputs = [Object.assign(Object.assign({}, (_a = idxRemediationValue.form) === null || _a === void 0 ? void 0 : _a.value[0]), { name: 'password', type: 'string', required: idxRemediationValue.required })];
        const revokeSessions = (_b = idxRemediationValue.form) === null || _b === void 0 ? void 0 : _b.value.find(input => input.name === 'revokeSessions');
        if (revokeSessions) {
            inputs.push({
                name: 'revokeSessions',
                type: 'boolean',
                label: 'Sign me out of all other devices',
                required: false,
            });
        }
        return inputs;
    }
}


//# sourceMappingURL=OktaPassword.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/SecurityQuestionEnrollment.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SecurityQuestionEnrollment extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        if (credentials && credentials.questionKey && credentials.answer) {
            return true;
        }
        const { questionKey, question, answer } = values;
        return !!(questionKey && answer) || !!(question && answer);
    }
    mapCredentials(values) {
        const { questionKey, question, answer } = values;
        if (!answer || (!questionKey && !question)) {
            return;
        }
        return {
            questionKey: question ? 'custom' : questionKey,
            question,
            answer
        };
    }
    getInputs() {
        return [
            { name: 'questionKey', type: 'string', required: true },
            { name: 'question', type: 'string', label: 'Create a security question' },
            { name: 'answer', type: 'string', label: 'Answer', required: true },
        ];
    }
}


//# sourceMappingURL=SecurityQuestionEnrollment.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/SecurityQuestionVerification.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SecurityQuestionVerification extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        if (credentials && credentials.answer) {
            return true;
        }
        const { answer } = values;
        return !!answer;
    }
    mapCredentials(values) {
        const { answer } = values;
        if (!answer) {
            return;
        }
        return {
            questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
            answer
        };
    }
    getInputs() {
        return [
            { name: 'answer', type: 'string', label: 'Answer', required: true }
        ];
    }
}


//# sourceMappingURL=SecurityQuestionVerification.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/WebauthnEnrollment.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class WebauthnEnrollment extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        const obj = credentials || values;
        const { clientData, attestation } = obj;
        return !!(clientData && attestation);
    }
    mapCredentials(values) {
        const { credentials, clientData, attestation } = values;
        if (!credentials && !clientData && !attestation) {
            return;
        }
        return credentials || ({
            clientData,
            attestation
        });
    }
    getInputs() {
        return [
            { name: 'clientData', type: 'string', required: true, visible: false, label: 'Client Data' },
            { name: 'attestation', type: 'string', required: true, visible: false, label: 'Attestation' },
        ];
    }
}


//# sourceMappingURL=WebauthnEnrollment.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/WebauthnVerification.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class WebauthnVerification extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        const obj = credentials || values;
        const { clientData, authenticatorData, signatureData } = obj;
        return !!(clientData && authenticatorData && signatureData);
    }
    mapCredentials(values) {
        const { credentials, authenticatorData, clientData, signatureData } = values;
        if (!credentials && !authenticatorData && !clientData && !signatureData) {
            return;
        }
        return credentials || ({
            authenticatorData,
            clientData,
            signatureData
        });
    }
    getInputs() {
        return [
            { name: 'authenticatorData', type: 'string', label: 'Authenticator Data', required: true, visible: false },
            { name: 'clientData', type: 'string', label: 'Client Data', required: true, visible: false },
            { name: 'signatureData', type: 'string', label: 'Signature Data', required: true, visible: false },
        ];
    }
}


//# sourceMappingURL=WebauthnVerification.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/getAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function getAuthenticator(remediation) {
    var _a, _b;
    const relatesTo = remediation.relatesTo;
    const value = (relatesTo === null || relatesTo === void 0 ? void 0 : relatesTo.value) || {};
    switch (value.key) {
        case AuthenticatorKey.OKTA_PASSWORD:
            return new OktaPassword(value);
        case AuthenticatorKey.SECURITY_QUESTION:
            if ((_a = value.contextualData) === null || _a === void 0 ? void 0 : _a.enrolledQuestion) {
                return new SecurityQuestionVerification(value);
            }
            else {
                return new SecurityQuestionEnrollment(value);
            }
        case AuthenticatorKey.OKTA_VERIFY:
            return new OktaVerifyTotp(value);
        case AuthenticatorKey.WEBAUTHN:
            if ((_b = value.contextualData) === null || _b === void 0 ? void 0 : _b.challengeData) {
                return new WebauthnVerification(value);
            }
            else {
                return new WebauthnEnrollment(value);
            }
        default:
            return new VerificationCodeAuthenticator(value);
    }
}


//# sourceMappingURL=getAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/VerifyAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class VerifyAuthenticator extends Remediator {
    constructor(remediation, values = {}) {
        super(remediation, values);
        this.authenticator = getAuthenticator(remediation);
    }
    getNextStep(authClient, context) {
        var _a;
        const nextStep = super.getNextStep(authClient, context);
        const authenticatorEnrollments = (_a = context === null || context === void 0 ? void 0 : context.authenticatorEnrollments) === null || _a === void 0 ? void 0 : _a.value;
        return Object.assign(Object.assign({}, nextStep), { authenticatorEnrollments });
    }
    canRemediate() {
        return this.authenticator.canVerify(this.values);
    }
    mapCredentials() {
        return this.authenticator.mapCredentials(this.values);
    }
    getInputCredentials(input) {
        return this.authenticator.getInputs(input);
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== 'credentials');
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}


//# sourceMappingURL=VerifyAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class EnrollAuthenticator extends VerifyAuthenticator {
}
EnrollAuthenticator.remediationName = 'enroll-authenticator';


//# sourceMappingURL=EnrollAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollPoll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class EnrollPoll extends Remediator {
    canRemediate() {
        return !!this.values.startPolling || this.options.step === 'enroll-poll';
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        let authenticator = this.getAuthenticator();
        if (!authenticator && (context === null || context === void 0 ? void 0 : context.currentAuthenticator)) {
            authenticator = context.currentAuthenticator.value;
        }
        return Object.assign(Object.assign({}, common), { authenticator, poll: {
                required: true,
                refresh: this.remediation.refresh
            } });
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== 'startPolling');
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
EnrollPoll.remediationName = 'enroll-poll';


//# sourceMappingURL=EnrollPoll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectEnrollmentChannel.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SelectEnrollmentChannel extends Remediator {
    canRemediate() {
        if (this.values.channel) {
            return true;
        }
        if (this.values.authenticator) {
            const { id, channel } = this.values.authenticator;
            if (!!id && !!channel) {
                return true;
            }
        }
        return false;
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        const authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign({}, common), { authenticator });
    }
    getData() {
        var _a;
        const remediationValue = this.remediation.value[0].value;
        return {
            authenticator: {
                id: remediationValue.form.value[0].value,
                channel: ((_a = this.values.authenticator) === null || _a === void 0 ? void 0 : _a.channel) || this.values.channel,
            },
            stateHandle: this.values.stateHandle,
        };
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        delete this.values.authenticators;
        const filterKey = this.values.channel ? 'channel' : 'authenticator';
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== filterKey);
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
SelectEnrollmentChannel.remediationName = 'select-enrollment-channel';


//# sourceMappingURL=SelectEnrollmentChannel.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollmentChannelData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class EnrollmentChannelData extends Remediator {
    getInputEmail() {
        return [
            { name: 'email', type: 'string', required: true, label: 'Email' },
        ];
    }
    getInputPhoneNumber() {
        return [
            { name: 'phoneNumber', type: 'string', required: true, label: 'Phone Number' },
        ];
    }
    canRemediate() {
        return Boolean(this.values.email || this.values.phoneNumber);
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        const authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign({}, common), { authenticator });
    }
    getData() {
        return {
            stateHandle: this.values.stateHandle,
            email: this.values.email,
            phoneNumber: this.values.phoneNumber
        };
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter(valueKey => !['email', 'phoneNumber'].includes(valueKey));
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
EnrollmentChannelData.remediationName = 'enrollment-channel-data';


//# sourceMappingURL=EnrollmentChannelData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ChallengeAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ChallengeAuthenticator extends VerifyAuthenticator {
}
ChallengeAuthenticator.remediationName = 'challenge-authenticator';


//# sourceMappingURL=ChallengeAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ChallengePoll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ChallengePoll extends EnrollPoll {
    canRemediate() {
        return !!this.values.startPolling || this.options.step === 'challenge-poll';
    }
}
ChallengePoll.remediationName = 'challenge-poll';


//# sourceMappingURL=ChallengePoll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ResetAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ResetAuthenticator extends VerifyAuthenticator {
}
ResetAuthenticator.remediationName = 'reset-authenticator';


//# sourceMappingURL=ResetAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollProfile.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class EnrollProfile extends Remediator {
    constructor(remediation, values = {}, options = {}) {
        super(remediation, values, options);
        this.authenticator = null;
        const credentials = this.getCredentialsFromRemediation();
        if (credentials) {
            this.authenticator = this.authenticator = new OktaPassword({});
        }
    }
    canRemediate() {
        if (this.authenticator && !this.authenticator.canVerify(this.values)) {
            return false;
        }
        const userProfileFromValues = this.getData().userProfile;
        if (!userProfileFromValues) {
            return false;
        }
        const userProfileFromRemediation = this.remediation.value.find(({ name }) => name === 'userProfile');
        return userProfileFromRemediation.form.value.reduce((canRemediate, curr) => {
            if (curr.required) {
                canRemediate = canRemediate && !!userProfileFromValues[curr.name];
            }
            return canRemediate;
        }, true);
    }
    getCredentialsFromRemediation() {
        return this.remediation.value.find(({ name }) => name === 'credentials');
    }
    mapUserProfile({ form: { value: profileAttributes } }) {
        const attributeNames = profileAttributes.map(({ name }) => name);
        const data = attributeNames.reduce((attributeValues, attributeName) => (this.values[attributeName] ? Object.assign(Object.assign({}, attributeValues), { [attributeName]: this.values[attributeName] }) : attributeValues), {});
        if (Object.keys(data).length === 0) {
            return;
        }
        return data;
    }
    mapCredentials() {
        const val = this.authenticator && this.authenticator.mapCredentials(this.values);
        if (!val) {
            return;
        }
        return val;
    }
    getInputUserProfile(input) {
        return [...input.form.value];
    }
    getInputCredentials(input) {
        return [...input.form.value];
    }
    getErrorMessages(errorRemediation) {
        return errorRemediation.value[0].form.value.reduce((errors, field) => {
            if (field.messages) {
                errors.push(field.messages.value[0].message);
            }
            return errors;
        }, []);
    }
}
EnrollProfile.remediationName = 'enroll-profile';


//# sourceMappingURL=EnrollProfile.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Identify.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class Identify extends Remediator {
    constructor() {
        super(...arguments);
        this.map = {
            'identifier': ['username']
        };
    }
    canRemediate() {
        const { identifier } = this.getData();
        return !!identifier;
    }
    mapCredentials() {
        const { credentials, password } = this.values;
        if (!credentials && !password) {
            return;
        }
        return credentials || { passcode: password };
    }
    getInputCredentials(input) {
        return Object.assign(Object.assign({}, input.form.value[0]), { name: 'password', required: input.required });
    }
}
Identify.remediationName = 'identify';


//# sourceMappingURL=Identify.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ReEnrollAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ReEnrollAuthenticator extends Remediator {
    mapCredentials() {
        const { newPassword } = this.values;
        if (!newPassword) {
            return;
        }
        return {
            passcode: newPassword,
        };
    }
    getInputCredentials(input) {
        const challengeType = this.getAuthenticator().type;
        const name = challengeType === 'password' ? 'newPassword' : 'verificationCode';
        return Object.assign(Object.assign({}, input.form.value[0]), { name });
    }
}
ReEnrollAuthenticator.remediationName = 'reenroll-authenticator';


//# sourceMappingURL=ReEnrollAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ReEnrollAuthenticatorWarning.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ReEnrollAuthenticatorWarning extends ReEnrollAuthenticator {
}
ReEnrollAuthenticatorWarning.remediationName = 'reenroll-authenticator-warning';


//# sourceMappingURL=ReEnrollAuthenticatorWarning.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/RedirectIdp.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class RedirectIdp extends Remediator {
    canRemediate() {
        return false;
    }
    getNextStep() {
        const { name, type, idp, href } = this.remediation;
        return {
            name,
            type,
            idp,
            href
        };
    }
}
RedirectIdp.remediationName = 'redirect-idp';


//# sourceMappingURL=RedirectIdp.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/SelectAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






class SelectAuthenticator extends Remediator {
    findMatchedOption(authenticators, options) {
        let option;
        for (let authenticator of authenticators) {
            option = options
                .find(({ relatesTo }) => relatesTo.key && relatesTo.key === authenticator.key);
            if (option) {
                break;
            }
        }
        return option;
    }
    canRemediate(context) {
        var _a, _b;
        const { authenticators, authenticator } = this.values;
        const authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
        const { options } = authenticatorFromRemediation;
        if (!authenticators || !authenticators.length) {
            return false;
        }
        if (isAuthenticator(authenticator) && authenticator.id) {
            return true;
        }
        const matchedOption = this.findMatchedOption(authenticators, options);
        if (matchedOption) {
            const isCurrentAuthenticator = (context === null || context === void 0 ? void 0 : context.currentAuthenticator)
                && (context === null || context === void 0 ? void 0 : context.currentAuthenticator.value.id) === ((_a = matchedOption.relatesTo) === null || _a === void 0 ? void 0 : _a.id);
            const isCurrentAuthenticatorEnrollment = (context === null || context === void 0 ? void 0 : context.currentAuthenticatorEnrollment)
                && (context === null || context === void 0 ? void 0 : context.currentAuthenticatorEnrollment.value.id) === ((_b = matchedOption.relatesTo) === null || _b === void 0 ? void 0 : _b.id);
            return !isCurrentAuthenticator && !isCurrentAuthenticatorEnrollment;
        }
        return false;
    }
    mapAuthenticator(remediationValue) {
        const { authenticators, authenticator } = this.values;
        if (isAuthenticator(authenticator) && authenticator.id) {
            this.selectedAuthenticator = authenticator;
            return authenticator;
        }
        const { options } = remediationValue;
        const selectedOption = findMatchedOption(authenticators, options);
        this.selectedAuthenticator = selectedOption.relatesTo;
        this.selectedOption = selectedOption;
        return {
            id: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value.form.value.find(({ name }) => name === 'id').value
        };
    }
    getInputAuthenticator(remediation) {
        const options = remediation.options.map(({ label, relatesTo }) => {
            return {
                label,
                value: relatesTo.key
            };
        });
        return { name: 'authenticator', type: 'string', options };
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        const authenticators = this.values.authenticators
            .filter(authenticator => {
            return compareAuthenticators(authenticator, this.selectedAuthenticator) !== true;
        });
        return Object.assign(Object.assign({}, this.values), { authenticators });
    }
}


//# sourceMappingURL=SelectAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectAuthenticatorAuthenticate.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class SelectAuthenticatorAuthenticate extends SelectAuthenticator {
    constructor(remediation, values = {}, options = {}) {
        var _a;
        super(remediation, values, options);
        const isRecoveryFlow = this.options.flow === 'recoverPassword';
        const hasPasswordInOptions = (_a = getAuthenticatorFromRemediation(remediation)
            .options) === null || _a === void 0 ? void 0 : _a.some(({ relatesTo }) => (relatesTo === null || relatesTo === void 0 ? void 0 : relatesTo.key) === AuthenticatorKey.OKTA_PASSWORD);
        if (hasPasswordInOptions && (isRecoveryFlow || this.values.password)) {
            this.values.authenticators = [
                ...this.values.authenticators || [],
                { key: AuthenticatorKey.OKTA_PASSWORD }
            ];
        }
    }
}
SelectAuthenticatorAuthenticate.remediationName = 'select-authenticator-authenticate';


//# sourceMappingURL=SelectAuthenticatorAuthenticate.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectAuthenticatorEnroll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SelectAuthenticatorEnroll extends SelectAuthenticator {
}
SelectAuthenticatorEnroll.remediationName = 'select-authenticator-enroll';


//# sourceMappingURL=SelectAuthenticatorEnroll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectAuthenticatorUnlockAccount.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SelectAuthenticatorUnlockAccount extends SelectAuthenticator {
    constructor() {
        super(...arguments);
        this.map = {
            identifier: ['username']
        };
    }
    canRemediate() {
        const identifier = this.getData('identifier');
        return !!identifier && super.canRemediate();
    }
    mapAuthenticator(remediationValue) {
        var _a, _b, _c;
        const authenticatorMap = super.mapAuthenticator(remediationValue);
        const methodTypeOption = (_a = this.selectedOption) === null || _a === void 0 ? void 0 : _a.value.form.value.find(({ name }) => name === 'methodType');
        const methodTypeValue = this.values.methodType ||
            (methodTypeOption === null || methodTypeOption === void 0 ? void 0 : methodTypeOption.value) || ((_c = (_b = methodTypeOption === null || methodTypeOption === void 0 ? void 0 : methodTypeOption.options) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value);
        if (methodTypeValue) {
            return Object.assign(Object.assign({}, authenticatorMap), { methodType: methodTypeValue });
        }
        return authenticatorMap;
    }
    getInputUsername() {
        return { name: 'username', type: 'string' };
    }
}
SelectAuthenticatorUnlockAccount.remediationName = 'select-authenticator-unlock-account';


//# sourceMappingURL=SelectAuthenticatorUnlockAccount.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectEnrollProfile.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SelectEnrollProfile extends Remediator {
    canRemediate() {
        return true;
    }
}
SelectEnrollProfile.remediationName = 'select-enroll-profile';


//# sourceMappingURL=SelectEnrollProfile.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/AuthenticatorData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class AuthenticatorData extends Remediator {
    constructor(remediation, values = {}) {
        super(remediation, values);
        this.authenticator = this.getAuthenticator();
        this.formatAuthenticatorData();
    }
    formatAuthenticatorData() {
        const authenticatorData = this.getAuthenticatorData();
        if (authenticatorData) {
            this.values.authenticatorsData = this.values.authenticatorsData.map(data => {
                if (compareAuthenticators(this.authenticator, data)) {
                    return this.mapAuthenticatorDataFromValues(data);
                }
                return data;
            });
        }
        else {
            const data = this.mapAuthenticatorDataFromValues();
            if (data) {
                this.values.authenticatorsData.push(data);
            }
        }
    }
    getAuthenticatorData() {
        return this.values.authenticatorsData
            .find((data) => compareAuthenticators(this.authenticator, data));
    }
    canRemediate() {
        return this.values.authenticatorsData
            .some(data => compareAuthenticators(this.authenticator, data));
    }
    mapAuthenticatorDataFromValues(authenticatorData) {
        let { methodType, authenticator } = this.values;
        if (!methodType && isAuthenticator(authenticator)) {
            methodType = authenticator === null || authenticator === void 0 ? void 0 : authenticator.methodType;
        }
        const { id, enrollmentId } = this.authenticator;
        const data = Object.assign(Object.assign({ id,
            enrollmentId }, (authenticatorData && authenticatorData)), (methodType && { methodType }));
        return data.methodType ? data : null;
    }
    getAuthenticatorFromRemediation() {
        const authenticator = this.remediation.value
            .find(({ name }) => name === 'authenticator');
        return authenticator;
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        const authenticatorsData = this.values.authenticatorsData
            .filter(data => compareAuthenticators(this.authenticator, data) !== true);
        return Object.assign(Object.assign({}, this.values), { authenticatorsData });
    }
}


//# sourceMappingURL=AuthenticatorData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/AuthenticatorVerificationData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class AuthenticatorVerificationData extends AuthenticatorData {
    mapAuthenticator() {
        return this.getAuthenticatorData();
    }
    getInputAuthenticator() {
        const authenticator = this.getAuthenticatorFromRemediation();
        const methodType = authenticator.form.value.find(({ name }) => name === 'methodType');
        if (methodType && methodType.options) {
            return {
                name: 'methodType',
                type: 'string',
                required: true,
                options: methodType.options
            };
        }
        const inputs = [...authenticator.form.value];
        return inputs;
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== 'authenticator');
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
AuthenticatorVerificationData.remediationName = 'authenticator-verification-data';


//# sourceMappingURL=AuthenticatorVerificationData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/AuthenticatorEnrollmentData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class AuthenticatorEnrollmentData extends AuthenticatorData {
    mapAuthenticator() {
        const authenticatorData = this.getAuthenticatorData();
        const authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
        return {
            id: authenticatorFromRemediation.form.value
                .find(({ name }) => name === 'id').value,
            methodType: authenticatorData.methodType,
            phoneNumber: authenticatorData.phoneNumber,
        };
    }
    getInputAuthenticator(remediation) {
        return [
            { name: 'methodType', type: 'string' },
            { name: 'phoneNumber', label: 'Phone Number', type: 'string' }
        ].map(item => {
            const value = remediation.form.value.find(val => val.name === item.name);
            return Object.assign(Object.assign({}, value), item);
        });
    }
    mapAuthenticatorDataFromValues(data) {
        data = super.mapAuthenticatorDataFromValues(data);
        const { phoneNumber } = this.values;
        if (!data && !phoneNumber) {
            return;
        }
        return Object.assign(Object.assign({}, (data && data)), (phoneNumber && { phoneNumber }));
    }
}
AuthenticatorEnrollmentData.remediationName = 'authenticator-enrollment-data';


//# sourceMappingURL=AuthenticatorEnrollmentData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Skip.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class Skip extends Remediator {
    canRemediate() {
        return !!this.values.skip || this.options.step === 'skip';
    }
}
Skip.remediationName = 'skip';


//# sourceMappingURL=Skip.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/AuthenticationFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */
























const AuthenticationFlow = {
    'identify': Identify,
    'select-authenticator-authenticate': SelectAuthenticatorAuthenticate,
    'select-authenticator-enroll': SelectAuthenticatorEnroll,
    'authenticator-enrollment-data': AuthenticatorEnrollmentData,
    'authenticator-verification-data': AuthenticatorVerificationData,
    'enroll-authenticator': EnrollAuthenticator,
    'challenge-authenticator': ChallengeAuthenticator,
    'challenge-poll': ChallengePoll,
    'reenroll-authenticator': ReEnrollAuthenticator,
    'reenroll-authenticator-warning': ReEnrollAuthenticatorWarning,
    'enroll-poll': EnrollPoll,
    'select-enrollment-channel': SelectEnrollmentChannel,
    'enrollment-channel-data': EnrollmentChannelData,
    'redirect-idp': RedirectIdp,
    'skip': Skip,
};


//# sourceMappingURL=AuthenticationFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/PasswordRecoveryFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */
























const PasswordRecoveryFlow = {
    'identify': Identify,
    'identify-recovery': Identify,
    'select-authenticator-authenticate': SelectAuthenticatorAuthenticate,
    'select-authenticator-enroll': SelectAuthenticatorEnroll,
    'challenge-authenticator': ChallengeAuthenticator,
    'authenticator-verification-data': AuthenticatorVerificationData,
    'authenticator-enrollment-data': AuthenticatorEnrollmentData,
    'reset-authenticator': ResetAuthenticator,
    'reenroll-authenticator': ReEnrollAuthenticator,
    'reenroll-authenticator-warning': ReEnrollAuthenticatorWarning,
    'enroll-poll': EnrollPoll,
};


//# sourceMappingURL=PasswordRecoveryFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/RegistrationFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */
























const RegistrationFlow = {
    'select-enroll-profile': SelectEnrollProfile,
    'enroll-profile': EnrollProfile,
    'authenticator-enrollment-data': AuthenticatorEnrollmentData,
    'select-authenticator-enroll': SelectAuthenticatorEnroll,
    'enroll-poll': EnrollPoll,
    'select-enrollment-channel': SelectEnrollmentChannel,
    'enrollment-channel-data': EnrollmentChannelData,
    'enroll-authenticator': EnrollAuthenticator,
    'skip': Skip,
};


//# sourceMappingURL=RegistrationFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/AccountUnlockFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */
























const AccountUnlockFlow = {
    'identify': Identify,
    'select-authenticator-unlock-account': SelectAuthenticatorUnlockAccount,
    'select-authenticator-authenticate': SelectAuthenticatorAuthenticate,
    'challenge-authenticator': ChallengeAuthenticator,
    'challenge-poll': ChallengePoll,
    'authenticator-verification-data': AuthenticatorVerificationData,
    'reenroll-authenticator-warning': ReEnrollAuthenticatorWarning,
};


//# sourceMappingURL=AccountUnlockFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/FlowSpecification.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function FlowSpecification_getFlowSpecification(oktaAuth, flow = 'default') {
    let remediators, actions, withCredentials = true;
    switch (flow) {
        case 'register':
        case 'signup':
        case 'enrollProfile':
            remediators = RegistrationFlow;
            withCredentials = false;
            break;
        case 'recoverPassword':
        case 'resetPassword':
            remediators = PasswordRecoveryFlow;
            actions = [
                'currentAuthenticator-recover',
                'currentAuthenticatorEnrollment-recover'
            ];
            withCredentials = false;
            break;
        case 'unlockAccount':
            remediators = AccountUnlockFlow;
            withCredentials = false;
            actions = [
                'unlock-account'
            ];
            break;
        case 'authenticate':
        case 'login':
        case 'signin':
            remediators = AuthenticationFlow;
            break;
        default:
            remediators = AuthenticationFlow;
            break;
    }
    return { flow, remediators, actions, withCredentials };
}


//# sourceMappingURL=FlowSpecification.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/cancel.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */


























async function cancel(authClient, options) {
    const meta = authClient.transactionManager.load();
    const flowSpec = FlowSpecification_getFlowSpecification(authClient, meta.flow);
    return run(authClient, Object.assign(Object.assign(Object.assign({}, options), flowSpec), { actions: ['cancel'] }));
}


//# sourceMappingURL=cancel.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/urlParams.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function urlParamsToObject(hashOrSearch) {
    var plus2space = /\+/g;
    var paramSplit = /([^&=]+)=?([^&]*)/g;
    var fragment = hashOrSearch || '';
    if (fragment.charAt(0) === '#' && fragment.charAt(1) === '/') {
        fragment = fragment.substring(2);
    }
    if (fragment.charAt(0) === '#' || fragment.charAt(0) === '?') {
        fragment = fragment.substring(1);
    }
    var obj = {};
    var param;
    while (true) {
        param = paramSplit.exec(fragment);
        if (!param) {
            break;
        }
        var key = param[1];
        var value = param[2];
        if (key === 'id_token' || key === 'access_token' || key === 'code') {
            obj[key] = value;
        }
        else {
            obj[key] = decodeURIComponent(value.replace(plus2space, ' '));
        }
    }
    return obj;
}


//# sourceMappingURL=urlParams.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/emailVerify.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class EmailVerifyCallbackError extends CustomError {
    constructor(state, otp) {
        super(`Enter the OTP code in the originating client: ${otp}`);
        this.name = 'EmailVerifyCallbackError';
        this.state = state;
        this.otp = otp;
    }
}
function isEmailVerifyCallbackError(error) {
    return (error.name === 'EmailVerifyCallbackError');
}
function isEmailVerifyCallback(urlPath) {
    return /(otp=)/i.test(urlPath) && /(state=)/i.test(urlPath);
}
function parseEmailVerifyCallback(urlPath) {
    return urlParamsToObject(urlPath);
}
async function handleEmailVerifyCallback(authClient, search) {
    if (isEmailVerifyCallback(search)) {
        const { state, otp } = parseEmailVerifyCallback(search);
        if (authClient.idx.canProceed({ state })) {
            return await authClient.idx.proceed({ state, otp });
        }
        else {
            throw new EmailVerifyCallbackError(state, otp);
        }
    }
}


//# sourceMappingURL=emailVerify.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/proceed.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function proceed_canProceed(authClient, options = {}) {
    const meta = transactionMeta_getSavedTransactionMeta(authClient, options);
    return !!(meta || options.stateHandle);
}
async function proceed_proceed(authClient, options = {}) {
    if (!proceed_canProceed(authClient, options)) {
        throw new AuthSdkError('Unable to proceed: saved transaction could not be loaded');
    }
    let { flow, state } = options;
    if (!flow) {
        const meta = transactionMeta_getSavedTransactionMeta(authClient, { state });
        flow = meta === null || meta === void 0 ? void 0 : meta.flow;
    }
    return run(authClient, Object.assign(Object.assign({}, options), { flow }));
}


//# sourceMappingURL=proceed.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/poll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





async function poll(authClient, options = {}) {
    var _a;
    const { withCredentials, exchangeCodeForTokens } = options;
    let transaction = await proceed_proceed(authClient, {
        startPolling: true,
        withCredentials,
        exchangeCodeForTokens
    });
    const meta = transactionMeta_getSavedTransactionMeta(authClient);
    let availablePollingRemeditaions = (_a = meta === null || meta === void 0 ? void 0 : meta.remediations) === null || _a === void 0 ? void 0 : _a.find(remediation => remediation.includes('poll'));
    if (!(availablePollingRemeditaions === null || availablePollingRemeditaions === void 0 ? void 0 : availablePollingRemeditaions.length)) {
        warn('No polling remediations available at the current IDX flow stage');
    }
    if (Number.isInteger(options.refresh)) {
        return new Promise(function (resolve, reject) {
            setTimeout(async function () {
                var _a, _b;
                try {
                    const refresh = (_b = (_a = transaction.nextStep) === null || _a === void 0 ? void 0 : _a.poll) === null || _b === void 0 ? void 0 : _b.refresh;
                    if (refresh) {
                        resolve(poll(authClient, {
                            refresh
                        }));
                    }
                    else {
                        resolve(transaction);
                    }
                }
                catch (err) {
                    reject(err);
                }
            }, options.refresh);
        });
    }
    return transaction;
}


//# sourceMappingURL=poll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/startTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



async function startTransaction_startTransaction(authClient, options = {}) {
    authClient.transactionManager.clear();
    return run(authClient, Object.assign({ exchangeCodeForTokens: false }, options));
}


//# sourceMappingURL=startTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/register.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








async function register(authClient, options = {}) {
    if (!hasSavedInteractionHandle(authClient)) {
        const { enabledFeatures } = await startTransaction_startTransaction(authClient, Object.assign(Object.assign({}, options), { flow: 'register', autoRemediate: false }));
        if (!options.activationToken && enabledFeatures && !enabledFeatures.includes(IdxFeature.REGISTRATION)) {
            throw new AuthSdkError('Registration is not supported based on your current org configuration.');
        }
    }
    return run(authClient, Object.assign(Object.assign({}, options), { flow: 'register' }));
}


//# sourceMappingURL=register.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/recoverPassword.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */


























async function recoverPassword(authClient, options = {}) {
    const flowSpec = FlowSpecification_getFlowSpecification(authClient, 'recoverPassword');
    return run(authClient, Object.assign(Object.assign({}, options), flowSpec));
}


//# sourceMappingURL=recoverPassword.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/handleInteractionCodeRedirect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





async function handleInteractionCodeRedirect(authClient, url) {
    const meta = authClient.transactionManager.load();
    if (!meta) {
        throw new AuthSdkError('No transaction data was found in storage');
    }
    const { codeVerifier, state: savedState } = meta;
    const { searchParams
     } = new URL(url);
    const state = searchParams.get('state');
    const interactionCode = searchParams.get('interaction_code');
    const error = searchParams.get('error');
    if (error) {
        throw new OAuthError(error, searchParams.get('error_description'));
    }
    if (state !== savedState) {
        throw new AuthSdkError('State in redirect uri does not match with transaction state');
    }
    if (!interactionCode) {
        throw new AuthSdkError('Unable to parse interaction_code from the url');
    }
    const { tokens } = await authClient.token.exchangeCodeForTokens({ interactionCode, codeVerifier });
    authClient.tokenManager.setTokens(tokens);
}


//# sourceMappingURL=handleInteractionCodeRedirect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/unlockAccount.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








async function unlockAccount(authClient, options = {}) {
    options.flow = 'unlockAccount';
    if (!hasSavedInteractionHandle(authClient)) {
        const { enabledFeatures } = await startTransaction_startTransaction(authClient, Object.assign(Object.assign({}, options), { autoRemediate: false }));
        if (enabledFeatures && !enabledFeatures.includes(IdxFeature.ACCOUNT_UNLOCK)) {
            throw new AuthSdkError('Self Service Account Unlock is not supported based on your current org configuration.');
        }
    }
    return run(authClient, Object.assign({}, options));
}


//# sourceMappingURL=unlockAccount.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/errors.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function isInteractionRequiredError(error) {
    if (error.name !== 'OAuthError') {
        return false;
    }
    const oauthError = error;
    return (oauthError.errorCode === 'interaction_required');
}
function isAuthorizationCodeError(sdk, error) {
    if (error.name !== 'AuthApiError') {
        return false;
    }
    const authApiError = error;
    const errorResponse = authApiError.xhr;
    const responseJSON = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.responseJSON;
    return sdk.options.pkce && ((responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.error) === 'invalid_grant');
}
function isRefreshTokenInvalidError(error) {
    return isOAuthError(error) &&
        error.errorCode === 'invalid_grant' &&
        error.errorSummary === 'The refresh token is invalid or expired.';
}


//# sourceMappingURL=errors.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/loginRedirect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function hasTokensInHash(hash) {
    return /((id|access)_token=)/i.test(hash);
}
function hasAuthorizationCode(hashOrSearch) {
    return /(code=)/i.test(hashOrSearch);
}
function hasInteractionCode(hashOrSearch) {
    return /(interaction_code=)/i.test(hashOrSearch);
}
function hasErrorInUrl(hashOrSearch) {
    return /(error=)/i.test(hashOrSearch) || /(error_description)/i.test(hashOrSearch);
}
function isRedirectUri(uri, sdk) {
    var authParams = sdk.options;
    if (!uri || !authParams.redirectUri) {
        return false;
    }
    return uri.indexOf(authParams.redirectUri) === 0;
}
function isCodeFlow(options) {
    return options.pkce || options.responseType === 'code' || options.responseMode === 'query';
}
function loginRedirect_hasResponseType(responseType, options) {
    let hasResponseType = false;
    if (Array.isArray(options.responseType) && options.responseType.length) {
        hasResponseType = options.responseType.indexOf(responseType) >= 0;
    }
    else {
        hasResponseType = options.responseType === responseType;
    }
    return hasResponseType;
}
function getHashOrSearch(options) {
    var codeFlow = isCodeFlow(options);
    var useQuery = codeFlow && options.responseMode !== 'fragment';
    return useQuery ? window.location.search : window.location.hash;
}
function loginRedirect_isLoginRedirect(sdk) {
    if (!isRedirectUri(window.location.href, sdk)) {
        return false;
    }
    var codeFlow = isCodeFlow(sdk.options);
    var hashOrSearch = getHashOrSearch(sdk.options);
    if (hasErrorInUrl(hashOrSearch)) {
        return true;
    }
    if (codeFlow) {
        var hasCode = hasAuthorizationCode(hashOrSearch) || hasInteractionCode(hashOrSearch);
        return hasCode;
    }
    return hasTokensInHash(window.location.hash);
}
function isInteractionRequired(sdk, hashOrSearch) {
    if (!hashOrSearch) {
        if (!loginRedirect_isLoginRedirect(sdk)) {
            return false;
        }
        hashOrSearch = getHashOrSearch(sdk.options);
    }
    return /(error=interaction_required)/i.test(hashOrSearch);
}


//# sourceMappingURL=loginRedirect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






















//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/factory/api.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




























function createIdxAPI(sdk) {
    setRemediatorsCtx({
        remediators: remediators_namespaceObject,
        getFlowSpecification: FlowSpecification_getFlowSpecification,
    });
    const boundStartTransaction = startTransaction_startTransaction.bind(null, sdk);
    const idx = {
        interact: interact.bind(null, sdk),
        introspect: introspect.bind(null, sdk),
        makeIdxResponse: idxState_makeIdxState.bind(null, sdk),
        authenticate: authenticate.bind(null, sdk),
        register: register.bind(null, sdk),
        start: boundStartTransaction,
        startTransaction: boundStartTransaction,
        poll: poll.bind(null, sdk),
        proceed: proceed_proceed.bind(null, sdk),
        cancel: cancel.bind(null, sdk),
        recoverPassword: recoverPassword.bind(null, sdk),
        handleInteractionCodeRedirect: handleInteractionCodeRedirect.bind(null, sdk),
        isInteractionRequired: isInteractionRequired.bind(null, sdk),
        isInteractionRequiredError: isInteractionRequiredError,
        handleEmailVerifyCallback: handleEmailVerifyCallback.bind(null, sdk),
        isEmailVerifyCallback: isEmailVerifyCallback,
        parseEmailVerifyCallback: parseEmailVerifyCallback,
        isEmailVerifyCallbackError: isEmailVerifyCallbackError,
        getSavedTransactionMeta: transactionMeta_getSavedTransactionMeta.bind(null, sdk),
        createTransactionMeta: transactionMeta_createTransactionMeta.bind(null, sdk),
        getTransactionMeta: transactionMeta_getTransactionMeta.bind(null, sdk),
        saveTransactionMeta: transactionMeta_saveTransactionMeta.bind(null, sdk),
        clearTransactionMeta: transactionMeta_clearTransactionMeta.bind(null, sdk),
        isTransactionMetaValid: transactionMeta_isTransactionMetaValid,
        setFlow: (flow) => {
            sdk.options.flow = flow;
        },
        getFlow: () => {
            return sdk.options.flow;
        },
        canProceed: proceed_canProceed.bind(null, sdk),
        unlockAccount: unlockAccount.bind(null, sdk),
    };
    return idx;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/base/factory.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function factory_createOktaAuthBase(OptionsConstructor) {
    class OktaAuthBase {
        constructor(...args) {
            const options = new OptionsConstructor(args.length ? args[0] || {} : {});
            this.options = removeNils(options);
            this.emitter = new tiny_emitter();
            this.features = features_namespaceObject;
        }
    }
    OktaAuthBase.features = features_namespaceObject;
    OktaAuthBase.constants = constants_namespaceObject;
    OktaAuthBase.features = OktaAuthBase.prototype.features = features_namespaceObject;
    Object.assign(OktaAuthBase, {
        constants: constants_namespaceObject
    });
    return OktaAuthBase;
}


//# sourceMappingURL=factory.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/storage/mixin.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function mixin_mixinStorage(Base, StorageManager) {
    return class OktaAuthStorage extends Base {
        constructor(...args) {
            super(...args);
            const { storageManager, cookies, storageUtil } = this.options;
            this.storageManager = new StorageManager(storageManager, cookies, storageUtil);
        }
        clearStorage() {
        }
    };
}


//# sourceMappingURL=mixin.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/http/OktaUserAgent.js
/* provided dependency */ var process = __webpack_require__(83454);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OktaUserAgent {
    constructor() {
        this.environments = [`okta-auth-js/${"7.12.1"}`];
        this.maybeAddNodeEnvironment();
    }
    addEnvironment(env) {
        this.environments.push(env);
    }
    getHttpHeader() {
        return { 'X-Okta-User-Agent-Extended': this.environments.join(' ') };
    }
    getVersion() {
        return "7.12.1";
    }
    maybeAddNodeEnvironment() {
        if (isBrowser() || !process || !process.versions) {
            return;
        }
        const { node: version } = process.versions;
        this.environments.push(`nodejs/${version}`);
    }
}


//# sourceMappingURL=OktaUserAgent.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/http/headers.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function setRequestHeader(authClient, headerName, headerValue) {
    authClient.options.headers = authClient.options.headers || {};
    authClient.options.headers[headerName] = headerValue;
}


//# sourceMappingURL=headers.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/http/mixin.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function mixin_mixinHttp(Base) {
    return class OktaAuthHttp extends Base {
        constructor(...args) {
            super(...args);
            this._oktaUserAgent = new OktaUserAgent();
            this.http = {
                setRequestHeader: setRequestHeader.bind(null, this)
            };
        }
        setHeaders(headers) {
            this.options.headers = Object.assign({}, this.options.headers, headers);
        }
        getIssuerOrigin() {
            return this.options.issuer.split('/oauth2/')[0];
        }
        webfinger(opts) {
            var url = '/.well-known/webfinger' + toQueryString(opts);
            var options = {
                headers: {
                    'Accept': 'application/jrd+json'
                }
            };
            return get(this, url, options);
        }
    };
}


//# sourceMappingURL=mixin.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/base64.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function stringToBase64Url(str) {
    var b64 = b(str);
    return base64ToBase64Url(b64);
}
function base64ToBase64Url(b64) {
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function base64UrlToBase64(b64u) {
    return b64u.replace(/-/g, '+').replace(/_/g, '/');
}
function base64UrlToString(b64u) {
    var b64 = base64UrlToBase64(b64u);
    switch (b64.length % 4) {
        case 0:
            break;
        case 2:
            b64 += '==';
            break;
        case 3:
            b64 += '=';
            break;
        default:
            throw new AuthSdkError('Not a valid Base64Url');
    }
    var utf8 = a(b64);
    try {
        return decodeURIComponent(escape(utf8));
    }
    catch (e) {
        return utf8;
    }
}
function stringToBuffer(str) {
    var buffer = new Uint8Array(str.length);
    for (var i = 0; i < str.length; i++) {
        buffer[i] = str.charCodeAt(i);
    }
    return buffer;
}
function base64UrlDecode(str) {
    return a(base64UrlToBase64(str));
}
function base64UrlToBuffer(b64u) {
    return Uint8Array.from(base64UrlDecode(b64u), (c) => c.charCodeAt(0));
}
function bufferToBase64Url(bin) {
    return b(new Uint8Array(bin).reduce((s, byte) => s + String.fromCharCode(byte), ''));
}


//# sourceMappingURL=base64.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/oidcHash.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function getOidcHash(str) {
    var buffer = new TextEncoder().encode(str);
    return c.subtle.digest('SHA-256', buffer).then(function (arrayBuffer) {
        var intBuffer = new Uint8Array(arrayBuffer);
        var firstHalf = intBuffer.slice(0, 16);
        var hash = String.fromCharCode.apply(null, firstHalf);
        var b64u = stringToBase64Url(hash);
        return b64u;
    });
}


//# sourceMappingURL=oidcHash.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/verifyToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function verifyToken(idToken, key) {
    key = clone(key);
    var format = 'jwk';
    var algo = {
        name: 'RSASSA-PKCS1-v1_5',
        hash: { name: 'SHA-256' }
    };
    var extractable = true;
    var usages = ['verify'];
    delete key.use;
    return c.subtle.importKey(format, key, algo, extractable, usages)
        .then(function (cryptoKey) {
        var jwt = idToken.split('.');
        var payload = stringToBuffer(jwt[0] + '.' + jwt[1]);
        var b64Signature = base64UrlDecode(jwt[2]);
        var signature = stringToBuffer(b64Signature);
        return c.subtle.verify(algo, cryptoKey, signature, payload);
    });
}


//# sourceMappingURL=verifyToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/PromiseQueue.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class PromiseQueue {
    constructor(options = { quiet: false }) {
        this.queue = [];
        this.running = false;
        this.options = options;
    }
    push(method, thisObject, ...args) {
        return new Promise((resolve, reject) => {
            if (this.queue.length > 0) {
                if (this.options.quiet !== false) {
                    warn('Async method is being called but another async method is already running. ' +
                        'The new method will be delayed until the previous method completes.');
                }
            }
            this.queue.push({
                method,
                thisObject,
                args,
                resolve,
                reject
            });
            this.run();
        });
    }
    run() {
        if (this.running) {
            return;
        }
        if (this.queue.length === 0) {
            return;
        }
        this.running = true;
        var queueItem = this.queue.shift();
        var res = queueItem.method.apply(queueItem.thisObject, queueItem.args);
        if (isPromise(res)) {
            res.then(queueItem.resolve, queueItem.reject).finally(() => {
                this.running = false;
                this.run();
            });
        }
        else {
            queueItem.resolve(res);
            this.running = false;
            this.run();
        }
    }
}


//# sourceMappingURL=PromiseQueue.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/pkce.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function getRandomString(length) {
    var a = new Uint8Array(Math.ceil(length / 2));
    c.getRandomValues(a);
    var str = Array.from(a, dec2hex).join('');
    return str.slice(0, length);
}
function generateVerifier(prefix) {
    var verifier = prefix || '';
    if (verifier.length < MIN_VERIFIER_LENGTH) {
        verifier = verifier + getRandomString(MIN_VERIFIER_LENGTH - verifier.length);
    }
    return encodeURIComponent(verifier).slice(0, MAX_VERIFIER_LENGTH);
}
function computeChallenge(str) {
    var buffer = new TextEncoder().encode(str);
    return c.subtle.digest('SHA-256', buffer).then(function (arrayBuffer) {
        var hash = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
        var b64u = stringToBase64Url(hash);
        return b64u;
    });
}
var PKCE = {
    DEFAULT_CODE_CHALLENGE_METHOD: DEFAULT_CODE_CHALLENGE_METHOD,
    generateVerifier,
    computeChallenge
};


//# sourceMappingURL=pkce.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/decodeToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function decodeToken_decodeToken(token) {
    var jwt = token.split('.');
    var decodedToken;
    try {
        decodedToken = {
            header: JSON.parse(base64UrlToString(jwt[0])),
            payload: JSON.parse(base64UrlToString(jwt[1])),
            signature: jwt[2]
        };
    }
    catch (e) {
        throw new AuthSdkError('Malformed token');
    }
    return decodedToken;
}


//# sourceMappingURL=decodeToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/defaultTokenParams.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function getDefaultTokenParams(sdk) {
    const { pkce, clientId, redirectUri, responseType, responseMode, scopes, acrValues, maxAge, state, ignoreSignature, dpop } = sdk.options;
    const defaultRedirectUri = isBrowser() ? window.location.href : undefined;
    return removeNils({
        pkce,
        clientId,
        redirectUri: redirectUri || defaultRedirectUri,
        responseType: responseType || ['token', 'id_token'],
        responseMode,
        state: state || generateState(),
        nonce: generateNonce(),
        scopes: scopes || ['openid', 'email'],
        acrValues,
        maxAge,
        ignoreSignature,
        dpop,
    });
}


//# sourceMappingURL=defaultTokenParams.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/dpop.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






const INDEXEDDB_NAME = 'OktaAuthJs';
const DB_KEY = 'DPoPKeys';
function isDPoPNonceError(obj) {
    return ((isOAuthError(obj) || isWWWAuthError(obj)) &&
        obj.errorCode === 'use_dpop_nonce');
}
async function createJwt(header, claims, signingKey) {
    const head = stringToBase64Url(JSON.stringify(header));
    const body = stringToBase64Url(JSON.stringify(claims));
    const signature = await c.subtle.sign({ name: signingKey.algorithm.name }, signingKey, stringToBuffer(`${head}.${body}`));
    return `${head}.${body}.${base64ToBase64Url(bufferToBase64Url(signature))}`;
}
function cryptoRandomValue(byteLen = 32) {
    return [...c.getRandomValues(new Uint8Array(byteLen))].map(v => v.toString(16)).join('');
}
async function generateKeyPair() {
    const algorithm = {
        name: 'RSASSA-PKCS1-v1_5',
        hash: 'SHA-256',
        modulusLength: 2048,
        publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
    };
    return c.subtle.generateKey(algorithm, false, ['sign', 'verify']);
}
async function hashAccessToken(accessToken) {
    const buffer = new TextEncoder().encode(accessToken);
    const hash = await c.subtle.digest('SHA-256', buffer);
    return b(String.fromCharCode.apply(null, new Uint8Array(hash)))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function keyStore() {
    return new Promise((resolve, reject) => {
        try {
            const indexedDB = window.indexedDB;
            const req = indexedDB.open(INDEXEDDB_NAME, 1);
            req.onerror = function () {
                reject(req.error);
            };
            req.onupgradeneeded = function () {
                const db = req.result;
                db.createObjectStore(DB_KEY);
            };
            req.onsuccess = function () {
                const db = req.result;
                const tx = db.transaction(DB_KEY, 'readwrite');
                tx.onerror = function () {
                    reject(tx.error);
                };
                const store = tx.objectStore(DB_KEY);
                resolve(store);
                tx.oncomplete = function () {
                    db.close();
                };
            };
        }
        catch (err) {
            reject(err);
        }
    });
}
async function invokeStoreMethod(method, ...args) {
    const store = await keyStore();
    return new Promise((resolve, reject) => {
        const req = store[method](...args);
        req.onsuccess = function () {
            resolve(req);
        };
        req.onerror = function () {
            reject(req.error);
        };
    });
}
async function storeKeyPair(pairId, keyPair) {
    await invokeStoreMethod('add', keyPair, pairId);
    return keyPair;
}
async function findKeyPair(pairId) {
    if (pairId) {
        const req = await invokeStoreMethod('get', pairId);
        if (req.result) {
            return req.result;
        }
    }
    throw new AuthSdkError(`Unable to locate dpop key pair required for refresh${pairId ? ` (${pairId})` : ''}`);
}
async function clearDPoPKeyPair(pairId) {
    await invokeStoreMethod('delete', pairId);
}
async function clearAllDPoPKeyPairs() {
    await invokeStoreMethod('clear');
}
async function createDPoPKeyPair() {
    const keyPairId = cryptoRandomValue(4);
    const keyPair = await generateKeyPair();
    await storeKeyPair(keyPairId, keyPair);
    return { keyPair, keyPairId };
}
async function clearDPoPKeyPairAfterRevoke(revokedToken, tokens) {
    var _a;
    let shouldClear = false;
    const { accessToken, refreshToken } = tokens;
    if (revokedToken === 'access' && accessToken && accessToken.tokenType === 'DPoP' && !refreshToken) {
        shouldClear = true;
    }
    if (revokedToken === 'refresh' && refreshToken && !accessToken) {
        shouldClear = true;
    }
    const pairId = (_a = accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId) !== null && _a !== void 0 ? _a : refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.dpopPairId;
    if (shouldClear && pairId) {
        await clearDPoPKeyPair(pairId);
    }
}
async function generateDPoPProof({ keyPair, url, method, nonce, accessToken }) {
    const { kty, crv, e, n, x, y } = await c.subtle.exportKey('jwk', keyPair.publicKey);
    const header = {
        alg: 'RS256',
        typ: 'dpop+jwt',
        jwk: { kty, crv, e, n, x, y }
    };
    const claims = {
        htm: method,
        htu: url,
        iat: Math.floor(Date.now() / 1000),
        jti: cryptoRandomValue(),
    };
    if (nonce) {
        claims.nonce = nonce;
    }
    if (accessToken) {
        claims.ath = await hashAccessToken(accessToken);
    }
    return createJwt(header, claims, keyPair.privateKey);
}
async function generateDPoPForTokenRequest({ keyPair, url, method, nonce }) {
    const params = { keyPair, url, method };
    if (nonce) {
        params.nonce = nonce;
    }
    return generateDPoPProof(params);
}


//# sourceMappingURL=dpop.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/endpoints/token.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












function validateOptions(options) {
    if (!options.clientId) {
        throw new AuthSdkError('A clientId must be specified in the OktaAuth constructor to get a token');
    }
    if (!options.redirectUri) {
        throw new AuthSdkError('The redirectUri passed to /authorize must also be passed to /token');
    }
    if (!options.authorizationCode && !options.interactionCode) {
        throw new AuthSdkError('An authorization code (returned from /authorize) must be passed to /token');
    }
    if (!options.codeVerifier) {
        throw new AuthSdkError('The "codeVerifier" (generated and saved by your app) must be passed to /token');
    }
}
function getPostData(sdk, options) {
    var params = removeNils({
        'client_id': options.clientId,
        'redirect_uri': options.redirectUri,
        'grant_type': options.interactionCode ? 'interaction_code' : 'authorization_code',
        'code_verifier': options.codeVerifier
    });
    if (options.interactionCode) {
        params['interaction_code'] = options.interactionCode;
    }
    else if (options.authorizationCode) {
        params.code = options.authorizationCode;
    }
    const { clientSecret } = sdk.options;
    if (clientSecret) {
        params['client_secret'] = clientSecret;
    }
    return toQueryString(params).slice(1);
}
async function makeTokenRequest(sdk, { url, data, nonce, dpopKeyPair }) {
    var _a, _b;
    const method = 'POST';
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
    };
    if (sdk.options.dpop) {
        if (!dpopKeyPair) {
            throw new AuthSdkError('DPoP is configured but no key pair was provided');
        }
        const proof = await generateDPoPForTokenRequest({ url, method, nonce, keyPair: dpopKeyPair });
        headers.DPoP = proof;
    }
    try {
        const resp = await httpRequest(sdk, {
            url,
            method,
            args: data,
            headers
        });
        return resp;
    }
    catch (err) {
        if (isDPoPNonceError(err) && !nonce) {
            const dpopNonce = (_a = err.resp) === null || _a === void 0 ? void 0 : _a.headers['dpop-nonce'];
            if (!dpopNonce) {
                throw new AuthApiError({ errorSummary: 'No `dpop-nonce` header found when required' }, (_b = err.resp) !== null && _b !== void 0 ? _b : undefined
                );
            }
            return makeTokenRequest(sdk, { url, data, dpopKeyPair, nonce: dpopNonce });
        }
        throw err;
    }
}
async function postToTokenEndpoint(sdk, options, urls) {
    validateOptions(options);
    var data = getPostData(sdk, options);
    const params = {
        url: urls.tokenUrl,
        data,
        dpopKeyPair: options === null || options === void 0 ? void 0 : options.dpopKeyPair
    };
    return makeTokenRequest(sdk, params);
}
async function postRefreshToken(sdk, options, refreshToken) {
    const data = Object.entries({
        client_id: options.clientId,
        grant_type: 'refresh_token',
        scope: refreshToken.scopes.join(' '),
        refresh_token: refreshToken.refreshToken,
    }).map(function ([name, value]) {
        return name + '=' + encodeURIComponent(value);
    }).join('&');
    let url = refreshToken.tokenUrl;
    if (options.extraParams && Object.keys(options.extraParams).length >= 1) {
        url += toQueryString(options.extraParams);
    }
    const params = {
        url,
        data,
        dpopKeyPair: options === null || options === void 0 ? void 0 : options.dpopKeyPair
    };
    return makeTokenRequest(sdk, params);
}


//# sourceMappingURL=token.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/endpoints/well-known.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









function getWellKnown(sdk, issuer) {
    var authServerUri = (issuer || sdk.options.issuer);
    return get(sdk, authServerUri + '/.well-known/openid-configuration', {
        cacheResponse: true
    });
}
function getKey(sdk, issuer, kid) {
    var httpCache = sdk.storageManager.getHttpCache(sdk.options.cookies);
    return getWellKnown(sdk, issuer)
        .then(function (wellKnown) {
        var jwksUri = wellKnown['jwks_uri'];
        var cacheContents = httpCache.getStorage();
        var cachedResponse = cacheContents[jwksUri];
        if (cachedResponse && Date.now() / 1000 < cachedResponse.expiresAt) {
            var cachedKey = find(cachedResponse.response.keys, {
                kid: kid
            });
            if (cachedKey) {
                return cachedKey;
            }
        }
        httpCache.clearStorage(jwksUri);
        return get(sdk, jwksUri, {
            cacheResponse: true
        })
            .then(function (res) {
            var key = find(res.keys, {
                kid: kid
            });
            if (key) {
                return key;
            }
            throw new AuthSdkError('The key id, ' + kid + ', was not found in the server\'s keys');
        });
    });
}


//# sourceMappingURL=well-known.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/validateClaims.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function validateClaims(sdk, claims, validationParams) {
    const aud = validationParams.clientId;
    const iss = validationParams.issuer;
    const nonce = validationParams.nonce;
    const acr = validationParams.acrValues;
    if (!claims || !iss || !aud) {
        throw new AuthSdkError('The jwt, iss, and aud arguments are all required');
    }
    if (nonce && claims.nonce !== nonce) {
        throw new AuthSdkError('OAuth flow response nonce doesn\'t match request nonce');
    }
    const now = Math.floor(Date.now() / 1000);
    if (claims.iss !== iss) {
        throw new AuthSdkError('The issuer [' + claims.iss + '] ' +
            'does not match [' + iss + ']');
    }
    if ((Array.isArray(claims.aud) && claims.aud.indexOf(aud) < 0) ||
        (!Array.isArray(claims.aud) && claims.aud !== aud)) {
        throw new AuthSdkError('The audience [' + claims.aud + '] ' +
            'does not match [' + aud + ']');
    }
    if (acr && claims.acr !== acr) {
        throw new AuthSdkError('The acr [' + claims.acr + '] ' +
            'does not match acr_values [' + acr + ']');
    }
    if (claims.iat > claims.exp) {
        throw new AuthSdkError('The JWT expired before it was issued');
    }
    if (!sdk.options.ignoreLifetime) {
        if ((now - sdk.options.maxClockSkew) > claims.exp) {
            throw new AuthSdkError('The JWT expired and is no longer valid');
        }
        if (claims.iat > (now + sdk.options.maxClockSkew)) {
            throw new AuthSdkError('The JWT was issued in the future');
        }
    }
}


//# sourceMappingURL=validateClaims.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/verifyToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










async function verifyToken_verifyToken(sdk, token, validationParams) {
    if (!token || !token.idToken) {
        throw new AuthSdkError('Only idTokens may be verified');
    }
    const jwt = decodeToken_decodeToken(token.idToken);
    const configuredIssuer = (validationParams === null || validationParams === void 0 ? void 0 : validationParams.issuer) || sdk.options.issuer;
    const { issuer } = await getWellKnown(sdk, configuredIssuer);
    const validationOptions = Object.assign({
        clientId: sdk.options.clientId,
        ignoreSignature: sdk.options.ignoreSignature
    }, validationParams, {
        issuer
    });
    validateClaims(sdk, jwt.payload, validationOptions);
    if (validationOptions.ignoreSignature == true || !sdk.features.isTokenVerifySupported()) {
        return token;
    }
    const key = await getKey(sdk, token.issuer, jwt.header.kid);
    const valid = await verifyToken(token.idToken, key);
    if (!valid) {
        throw new AuthSdkError('The token signature is not valid');
    }
    if (validationParams && validationParams.accessToken && token.claims.at_hash) {
        const hash = await getOidcHash(validationParams.accessToken);
        if (hash !== token.claims.at_hash) {
            throw new AuthSdkError('Token hash verification failed');
        }
    }
    return token;
}


//# sourceMappingURL=verifyToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/handleOAuthResponse.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */














function validateResponse(res, oauthParams) {
    if (res['error'] && res['error_description']) {
        throw new OAuthError(res['error'], res['error_description']);
    }
    if (res.state !== oauthParams.state) {
        throw new AuthSdkError('OAuth flow response state doesn\'t match request state');
    }
}
async function handleOAuthResponse(sdk, tokenParams, res, urls) {
    var _a, _b;
    const pkce = sdk.options.pkce !== false;
    if (pkce && (res.code || res.interaction_code)) {
        return sdk.token.exchangeCodeForTokens(Object.assign({}, tokenParams, {
            authorizationCode: res.code,
            interactionCode: res.interaction_code
        }), urls);
    }
    tokenParams = tokenParams || getDefaultTokenParams(sdk);
    urls = urls || getOAuthUrls(sdk, tokenParams);
    let responseType = tokenParams.responseType || [];
    if (!Array.isArray(responseType) && responseType !== 'none') {
        responseType = [responseType];
    }
    let scopes;
    if (res.scope) {
        scopes = res.scope.split(' ');
    }
    else {
        scopes = clone(tokenParams.scopes);
    }
    const clientId = tokenParams.clientId || sdk.options.clientId;
    validateResponse(res, tokenParams);
    if (tokenParams.dpop) {
        const { allowBearerTokens } = (_b = (_a = sdk.options) === null || _a === void 0 ? void 0 : _a.dpopOptions) !== null && _b !== void 0 ? _b : { allowBearerTokens: false };
        if (!allowBearerTokens && res.token_type !== 'DPoP') {
            throw new AuthSdkError('Unable to parse OAuth flow response: DPoP was configured but "token_type" was not DPoP');
        }
    }
    const tokenDict = {};
    const expiresIn = res.expires_in;
    const tokenType = res.token_type;
    const accessToken = res.access_token;
    const idToken = res.id_token;
    const refreshToken = res.refresh_token;
    const now = Math.floor(Date.now() / 1000);
    if (accessToken) {
        const accessJwt = sdk.token.decode(accessToken);
        tokenDict.accessToken = {
            accessToken: accessToken,
            claims: accessJwt.payload,
            expiresAt: Number(expiresIn) + now,
            tokenType: tokenType,
            scopes: scopes,
            authorizeUrl: urls.authorizeUrl,
            userinfoUrl: urls.userinfoUrl
        };
        if (tokenParams.dpopPairId) {
            tokenDict.accessToken.dpopPairId = tokenParams.dpopPairId;
        }
        if (tokenParams.extraParams) {
            tokenDict.accessToken.extraParams = tokenParams.extraParams;
        }
    }
    if (refreshToken) {
        tokenDict.refreshToken = {
            refreshToken: refreshToken,
            expiresAt: Number(expiresIn) + now,
            scopes: scopes,
            tokenUrl: urls.tokenUrl,
            authorizeUrl: urls.authorizeUrl,
            issuer: urls.issuer,
        };
        if (tokenParams.dpopPairId) {
            tokenDict.refreshToken.dpopPairId = tokenParams.dpopPairId;
        }
        if (tokenParams.extraParams) {
            tokenDict.refreshToken.extraParams = tokenParams.extraParams;
        }
    }
    if (idToken) {
        const idJwt = sdk.token.decode(idToken);
        const idTokenObj = {
            idToken: idToken,
            claims: idJwt.payload,
            expiresAt: idJwt.payload.exp - idJwt.payload.iat + now,
            scopes: scopes,
            authorizeUrl: urls.authorizeUrl,
            issuer: urls.issuer,
            clientId: clientId
        };
        if (tokenParams.extraParams) {
            idTokenObj.extraParams = tokenParams.extraParams;
        }
        const validationParams = {
            clientId: clientId,
            issuer: urls.issuer,
            nonce: tokenParams.nonce,
            accessToken: accessToken,
            acrValues: tokenParams.acrValues
        };
        if (tokenParams.ignoreSignature !== undefined) {
            validationParams.ignoreSignature = tokenParams.ignoreSignature;
        }
        await verifyToken_verifyToken(sdk, idTokenObj, validationParams);
        tokenDict.idToken = idTokenObj;
    }
    if (responseType.indexOf('token') !== -1 && !tokenDict.accessToken) {
        throw new AuthSdkError('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
    }
    if (responseType.indexOf('id_token') !== -1 && !tokenDict.idToken) {
        throw new AuthSdkError('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
    }
    return {
        tokens: tokenDict,
        state: res.state,
        code: res.code,
        responseType
    };
}


//# sourceMappingURL=handleOAuthResponse.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/exchangeCodeForTokens.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */














async function exchangeCodeForTokens_exchangeCodeForTokens(sdk, tokenParams, urls) {
    urls = urls || getOAuthUrls(sdk, tokenParams);
    tokenParams = Object.assign({}, getDefaultTokenParams(sdk), clone(tokenParams));
    const { authorizationCode, interactionCode, codeVerifier, clientId, redirectUri, scopes, ignoreSignature, state, acrValues, dpop, dpopPairId, extraParams } = tokenParams;
    const getTokenOptions = {
        clientId,
        redirectUri,
        authorizationCode,
        interactionCode,
        codeVerifier,
        dpop,
    };
    const responseType = ['token'];
    if (scopes.indexOf('openid') !== -1) {
        responseType.push('id_token');
    }
    const handleResponseOptions = {
        clientId,
        redirectUri,
        scopes,
        responseType,
        ignoreSignature,
        acrValues,
        extraParams
    };
    try {
        if (dpop) {
            if (dpopPairId) {
                const keyPair = await findKeyPair(dpopPairId);
                getTokenOptions.dpopKeyPair = keyPair;
                handleResponseOptions.dpop = dpop;
                handleResponseOptions.dpopPairId = dpopPairId;
            }
            else {
                const { keyPair, keyPairId } = await createDPoPKeyPair();
                getTokenOptions.dpopKeyPair = keyPair;
                handleResponseOptions.dpop = dpop;
                handleResponseOptions.dpopPairId = keyPairId;
            }
        }
        const oauthResponse = await postToTokenEndpoint(sdk, getTokenOptions, urls);
        const tokenResponse = await handleOAuthResponse(sdk, handleResponseOptions, oauthResponse, urls);
        tokenResponse.code = authorizationCode;
        tokenResponse.state = state;
        return tokenResponse;
    }
    finally {
        sdk.transactionManager.clear();
    }
}


//# sourceMappingURL=exchangeCodeForTokens.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getUserInfo.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */











async function getUserInfo(sdk, accessTokenObject, idTokenObject) {
    if (!accessTokenObject) {
        accessTokenObject = (await sdk.tokenManager.getTokens()).accessToken;
    }
    if (!idTokenObject) {
        idTokenObject = (await sdk.tokenManager.getTokens()).idToken;
    }
    if (!accessTokenObject || !isAccessToken(accessTokenObject)) {
        return Promise.reject(new AuthSdkError('getUserInfo requires an access token object'));
    }
    if (!idTokenObject || !isIDToken(idTokenObject)) {
        return Promise.reject(new AuthSdkError('getUserInfo requires an ID token object'));
    }
    const options = {
        url: accessTokenObject.userinfoUrl,
        method: 'GET',
        accessToken: accessTokenObject.accessToken
    };
    if (sdk.options.dpop) {
        const headers = await sdk.getDPoPAuthorizationHeaders(Object.assign(Object.assign({}, options), { accessToken: accessTokenObject }));
        options.headers = headers;
        delete options.accessToken;
    }
    return httpRequest(sdk, options)
        .then(userInfo => {
        if (userInfo.sub === idTokenObject.claims.sub) {
            return userInfo;
        }
        return Promise.reject(new AuthSdkError('getUserInfo request was rejected due to token mismatch'));
    })
        .catch(function (err) {
        var _a;
        if (err instanceof WWWAuthError && !sdk.options.dpop) {
            const { error, errorDescription } = err;
            throw new OAuthError(error, errorDescription);
        }
        if (!sdk.options.dpop) {
            let e = err;
            if (err instanceof AuthApiError && ((_a = err === null || err === void 0 ? void 0 : err.meta) === null || _a === void 0 ? void 0 : _a.wwwAuthHeader)) {
                e = WWWAuthError.parseHeader(err.meta.wwwAuthHeader);
            }
            if (e instanceof WWWAuthError) {
                const { error, errorDescription } = e;
                throw new OAuthError(error, errorDescription);
            }
        }
        throw err;
    });
}


//# sourceMappingURL=getUserInfo.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




const DEFAULT_TIMEOUT = 120000;
function addListener(eventTarget, name, fn) {
    if (eventTarget.addEventListener) {
        eventTarget.addEventListener(name, fn);
    }
    else {
        eventTarget.attachEvent('on' + name, fn);
    }
}
function removeListener(eventTarget, name, fn) {
    if (eventTarget.removeEventListener) {
        eventTarget.removeEventListener(name, fn);
    }
    else {
        eventTarget.detachEvent('on' + name, fn);
    }
}
function loadFrame(src) {
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = src;
    return document.body.appendChild(iframe);
}
function loadPopup(src, options) {
    var title = options.popupTitle || 'External Identity Provider User Authentication';
    var appearance = 'toolbar=no, scrollbars=yes, resizable=yes, ' +
        'top=100, left=500, width=600, height=600';
    return window.open(src, title, appearance);
}
function addPostMessageListener(sdk, timeout, state) {
    var responseHandler;
    var timeoutId;
    var msgReceivedOrTimeout = new Promise(function (resolve, reject) {
        responseHandler = function responseHandler(e) {
            if (!e.data || e.data.state !== state) {
                return;
            }
            if (e.origin !== sdk.getIssuerOrigin()) {
                return reject(new AuthSdkError('The request does not match client configuration'));
            }
            resolve(e.data);
        };
        addListener(window, 'message', responseHandler);
        timeoutId = setTimeout(function () {
            reject(new AuthSdkError('OAuth flow timed out'));
        }, timeout || DEFAULT_TIMEOUT);
    });
    return msgReceivedOrTimeout
        .finally(function () {
        clearTimeout(timeoutId);
        removeListener(window, 'message', responseHandler);
    });
}
function addIDPPopupLisenter(sdk, timeout, channel, state) {
    let timeoutId;
    const promise = new Promise((resolve, reject) => {
        channel.onmessage = (event) => {
            if (!event.isTrusted || !event.data) {
                return;
            }
            if (typeof event.data === 'object' && state === event.data.state) {
                return resolve(Object.assign({}, event.data));
            }
            reject(new AuthSdkError('Unable to complete auth code exchange'));
        };
        timeoutId = setTimeout(function () {
            reject(new AuthSdkError('OAuth flow timed out'));
        }, timeout || DEFAULT_TIMEOUT);
    });
    return promise
        .finally(() => {
        clearTimeout(timeoutId);
        channel.close();
    });
}


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/prepareTokenParams.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function assertPKCESupport(sdk) {
    if (!sdk.features.isPKCESupported()) {
        var errorMessage = 'PKCE requires a modern browser with encryption support running in a secure context.';
        if (!sdk.features.isHTTPS()) {
            errorMessage += '\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol.';
        }
        if (!sdk.features.hasTextEncoder()) {
            errorMessage += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.';
        }
        throw new AuthSdkError(errorMessage);
    }
}
async function validateCodeChallengeMethod(sdk, codeChallengeMethod) {
    codeChallengeMethod = codeChallengeMethod || sdk.options.codeChallengeMethod || DEFAULT_CODE_CHALLENGE_METHOD;
    const wellKnownResponse = await getWellKnown(sdk);
    var methods = wellKnownResponse['code_challenge_methods_supported'] || [];
    if (methods.indexOf(codeChallengeMethod) === -1) {
        throw new AuthSdkError('Invalid code_challenge_method');
    }
    return codeChallengeMethod;
}
async function preparePKCE(sdk, tokenParams) {
    let { codeVerifier, codeChallenge, codeChallengeMethod } = tokenParams;
    codeChallenge = codeChallenge || sdk.options.codeChallenge;
    if (!codeChallenge) {
        assertPKCESupport(sdk);
        codeVerifier = codeVerifier || PKCE.generateVerifier();
        codeChallenge = await PKCE.computeChallenge(codeVerifier);
    }
    codeChallengeMethod = await validateCodeChallengeMethod(sdk, codeChallengeMethod);
    tokenParams = Object.assign(Object.assign({}, tokenParams), { responseType: 'code',
        codeVerifier,
        codeChallenge,
        codeChallengeMethod });
    return tokenParams;
}
async function prepareTokenParams_prepareTokenParams(sdk, tokenParams = {}) {
    const defaults = getDefaultTokenParams(sdk);
    tokenParams = Object.assign(Object.assign({}, defaults), tokenParams);
    if (tokenParams.dpop && !sdk.features.isDPoPSupported()) {
        throw new AuthSdkError('DPoP has been configured, but is not supported by browser');
    }
    if (tokenParams.pkce === false) {
        return tokenParams;
    }
    return preparePKCE(sdk, tokenParams);
}


//# sourceMappingURL=prepareTokenParams.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/endpoints/authorize.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







function convertTokenParamsToOAuthParams(tokenParams) {
    if (!tokenParams.clientId) {
        throw new AuthSdkError('A clientId must be specified in the OktaAuth constructor to get a token');
    }
    if (isString(tokenParams.responseType) && tokenParams.responseType.indexOf(' ') !== -1) {
        throw new AuthSdkError('Multiple OAuth responseTypes must be defined as an array');
    }
    var oauthParams = {
        'client_id': tokenParams.clientId,
        'code_challenge': tokenParams.codeChallenge,
        'code_challenge_method': tokenParams.codeChallengeMethod,
        'display': tokenParams.display,
        'idp': tokenParams.idp,
        'idp_scope': tokenParams.idpScope,
        'login_hint': tokenParams.loginHint,
        'max_age': tokenParams.maxAge,
        'nonce': tokenParams.nonce,
        'prompt': tokenParams.prompt,
        'redirect_uri': tokenParams.redirectUri,
        'response_mode': tokenParams.responseMode,
        'response_type': tokenParams.responseType,
        'sessionToken': tokenParams.sessionToken,
        'state': tokenParams.state,
        'acr_values': tokenParams.acrValues,
        'enroll_amr_values': tokenParams.enrollAmrValues,
    };
    oauthParams = removeNils(oauthParams);
    ['idp_scope', 'response_type', 'enroll_amr_values'].forEach(function (mayBeArray) {
        if (Array.isArray(oauthParams[mayBeArray])) {
            oauthParams[mayBeArray] = oauthParams[mayBeArray].join(' ');
        }
    });
    if (tokenParams.responseType.indexOf('id_token') !== -1 &&
        tokenParams.scopes.indexOf('openid') === -1) {
        throw new AuthSdkError('openid scope must be specified in the scopes argument when requesting an id_token');
    }
    else if (tokenParams.scopes) {
        oauthParams.scope = tokenParams.scopes.join(' ');
    }
    return oauthParams;
}
function buildAuthorizeParams(tokenParams) {
    var oauthQueryParams = convertTokenParamsToOAuthParams(tokenParams);
    return toQueryString(Object.assign(Object.assign({}, oauthQueryParams), (tokenParams.extraParams && Object.assign({}, tokenParams.extraParams))));
}


//# sourceMappingURL=authorize.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function getToken(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError('As of version 3.0, "getToken" takes only a single set of options'));
    }
    options = options || {};
    const popupWindow = options.popupWindow;
    options.popupWindow = undefined;
    return prepareTokenParams_prepareTokenParams(sdk, options)
        .then(function (tokenParams) {
        var sessionTokenOverrides = {
            prompt: 'none',
            responseMode: 'okta_post_message',
            display: null
        };
        var idpOverrides = {
            display: 'popup'
        };
        if (options.sessionToken) {
            Object.assign(tokenParams, sessionTokenOverrides);
        }
        else if (options.idp) {
            Object.assign(tokenParams, idpOverrides);
        }
        var requestUrl, endpoint, urls;
        urls = getOAuthUrls(sdk, tokenParams);
        endpoint = options.codeVerifier ? urls.tokenUrl : urls.authorizeUrl;
        requestUrl = endpoint + buildAuthorizeParams(tokenParams);
        var flowType = 'IMPLICIT';
        if (tokenParams.sessionToken || tokenParams.display === null) {
            flowType = 'IFRAME';
        }
        else if (tokenParams.display === 'popup') {
            flowType = options.idpPopup ? 'IDP_POPUP' : 'POPUP';
        }
        else {
            flowType = 'IMPLICIT';
        }
        switch (flowType) {
            case 'IFRAME':
                var iframePromise = addPostMessageListener(sdk, options.timeout, tokenParams.state);
                var iframeEl = loadFrame(requestUrl);
                return iframePromise
                    .then(function (res) {
                    return handleOAuthResponse(sdk, tokenParams, res, urls);
                })
                    .finally(function () {
                    var _a;
                    if (document.body.contains(iframeEl)) {
                        (_a = iframeEl.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(iframeEl);
                    }
                });
            case 'POPUP':
                var oauthPromise;
                if (tokenParams.responseMode === 'okta_post_message') {
                    if (!sdk.features.isPopupPostMessageSupported()) {
                        throw new AuthSdkError('This browser doesn\'t have full postMessage support');
                    }
                    oauthPromise = addPostMessageListener(sdk, options.timeout, tokenParams.state);
                }
                if (popupWindow) {
                    popupWindow.location.assign(requestUrl);
                }
                var popupPromise = new Promise(function (resolve, reject) {
                    var closePoller = setInterval(function () {
                        if (!popupWindow || popupWindow.closed) {
                            clearInterval(closePoller);
                            reject(new AuthSdkError('Unable to parse OAuth flow response'));
                        }
                    }, 100);
                    oauthPromise
                        .then(function (res) {
                        clearInterval(closePoller);
                        resolve(res);
                    })
                        .catch(function (err) {
                        clearInterval(closePoller);
                        reject(err);
                    });
                });
                return popupPromise
                    .then(function (res) {
                    return handleOAuthResponse(sdk, tokenParams, res, urls);
                })
                    .finally(function () {
                    if (popupWindow && !popupWindow.closed) {
                        popupWindow.close();
                    }
                });
            case 'IDP_POPUP':
                var idpPromise = addIDPPopupLisenter(sdk, options.timeout, options.channel, tokenParams.state);
                if (popupWindow) {
                    popupWindow.location.assign(requestUrl);
                }
                else {
                    throw new AuthSdkError('Unable to open popup window');
                }
                return idpPromise
                    .then(function (res) {
                    return handleOAuthResponse(sdk, tokenParams, res, urls);
                });
            default:
                throw new AuthSdkError('The full page redirect flow is not supported');
        }
    });
}


//# sourceMappingURL=getToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getWithoutPrompt.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function getWithoutPrompt(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError('As of version 3.0, "getWithoutPrompt" takes only a single set of options'));
    }
    options = clone(options) || {};
    Object.assign(options, {
        prompt: 'none',
        responseMode: 'okta_post_message',
        display: null
    });
    return getToken(sdk, options);
}


//# sourceMappingURL=getWithoutPrompt.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getWithPopup.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */













function getWithPopup(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError('As of version 3.0, "getWithPopup" takes only a single set of options'));
    }
    const popupWindow = loadPopup('/', options);
    options = clone(options) || {};
    Object.assign(options, {
        display: 'popup',
        responseMode: 'okta_post_message',
        popupWindow
    });
    return getToken(sdk, options);
}
function getWithIDPPopup(sdk, options) {
    try {
        if (!BroadcastChannel) {
            throw new AuthSdkError('Modern browser with `BroadcastChannel` support is required to use this method');
        }
        if (!options.redirectUri) {
            throw new AuthSdkError('`redirectUri` is a required param for `getWithIDPPopup`');
        }
        if (!options.state) {
            options.state = generateState();
        }
        const popupWindow = loadPopup('/', options);
        const channel = new BroadcastChannel(`popup-callback:${options.state}`);
        options = clone(options) || {};
        Object.assign(options, {
            display: 'popup',
            responseMode: 'query',
            popupWindow,
            idpPopup: true,
            channel,
        });
        let cancelPromise;
        const promise = new Promise((resolve, reject) => {
            cancelPromise = reject;
            return getToken(sdk, options)
                .then((res) => resolve(res))
                .catch(err => reject(err));
        });
        const cancel = () => {
            channel.close();
            cancelPromise(new AuthSdkError('Popup flow canceled'));
        };
        return {
            promise,
            cancel
        };
    }
    catch (err) {
        return {
            promise: Promise.reject(err),
            cancel: () => { }
        };
    }
}


//# sourceMappingURL=getWithPopup.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getWithRedirect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









async function getWithRedirect(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError('As of version 3.0, "getWithRedirect" takes only a single set of options'));
    }
    options = clone(options) || {};
    const tokenParams = await prepareTokenParams_prepareTokenParams(sdk, options);
    const meta = createOAuthMeta(sdk, tokenParams);
    const requestUrl = meta.urls.authorizeUrl + buildAuthorizeParams(tokenParams);
    sdk.transactionManager.save(meta);
    if (sdk.options.setLocation) {
        sdk.options.setLocation(requestUrl);
    }
    else {
        window.location.assign(requestUrl);
    }
}


//# sourceMappingURL=getWithRedirect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/parseFromUrl.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */













function removeHash(sdk) {
    var nativeHistory = sdk.token.parseFromUrl._getHistory();
    var nativeDoc = sdk.token.parseFromUrl._getDocument();
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    if (nativeHistory && nativeHistory.replaceState) {
        nativeHistory.replaceState(null, nativeDoc.title, nativeLoc.pathname + nativeLoc.search);
    }
    else {
        nativeLoc.hash = '';
    }
}
function removeSearch(sdk) {
    var nativeHistory = sdk.token.parseFromUrl._getHistory();
    var nativeDoc = sdk.token.parseFromUrl._getDocument();
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    if (nativeHistory && nativeHistory.replaceState) {
        nativeHistory.replaceState(null, nativeDoc.title, nativeLoc.pathname + nativeLoc.hash);
    }
    else {
        nativeLoc.search = '';
    }
}
function getResponseMode(sdk) {
    var defaultResponseMode = sdk.options.pkce ? 'query' : 'fragment';
    var responseMode = sdk.options.responseMode || defaultResponseMode;
    return responseMode;
}
function parseOAuthResponseFromUrl(sdk, options) {
    options = options || {};
    if (isString(options)) {
        options = { url: options };
    }
    else {
        options = options;
    }
    var url = options.url;
    var responseMode = options.responseMode || getResponseMode(sdk);
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    var paramStr;
    if (responseMode === 'query') {
        paramStr = url ? url.substring(url.indexOf('?')) : nativeLoc.search;
    }
    else {
        paramStr = url ? url.substring(url.indexOf('#')) : nativeLoc.hash;
    }
    if (!paramStr) {
        throw new AuthSdkError('Unable to parse a token from the url');
    }
    return urlParamsToObject(paramStr);
}
function cleanOAuthResponseFromUrl(sdk, options) {
    const responseMode = options.responseMode || getResponseMode(sdk);
    responseMode === 'query' ? removeSearch(sdk) : removeHash(sdk);
}
async function parseFromUrl(sdk, options) {
    options = options || {};
    if (isString(options)) {
        options = { url: options };
    }
    else {
        options = options;
    }
    const res = parseOAuthResponseFromUrl(sdk, options);
    const state = res.state;
    const oauthParams = sdk.transactionManager.load({
        state
    });
    if (!oauthParams) {
        if (sdk.options.pkce) {
            throw new AuthSdkError('Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.', undefined);
        }
        throw new AuthSdkError('Unable to retrieve OAuth redirect params from storage');
    }
    const urls = oauthParams.urls;
    delete oauthParams.urls;
    if (!options.url) {
        cleanOAuthResponseFromUrl(sdk, options);
    }
    return handleOAuthResponse(sdk, oauthParams, res, urls)
        .catch(err => {
        if (!isInteractionRequiredError(err)) {
            sdk.transactionManager.clear({
                state
            });
        }
        throw err;
    })
        .then(res => {
        sdk.transactionManager.clear({
            state
        });
        return res;
    });
}


//# sourceMappingURL=parseFromUrl.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/refreshToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function isSameRefreshToken(a, b) {
    return (a.refreshToken === b.refreshToken);
}
function isRefreshTokenError(err) {
    if (!isAuthApiError(err)) {
        return false;
    }
    if (!err.xhr || !err.xhr.responseJSON) {
        return false;
    }
    const { responseJSON } = err.xhr;
    if (responseJSON.error === 'invalid_grant') {
        return true;
    }
    return false;
}


//# sourceMappingURL=refreshToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/renewTokensWithRefresh.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










async function renewTokensWithRefresh(sdk, tokenParams, refreshTokenObject) {
    const { clientId, dpop } = sdk.options;
    if (!clientId) {
        throw new AuthSdkError('A clientId must be specified in the OktaAuth constructor to renew tokens');
    }
    try {
        const renewTokenParams = Object.assign({}, tokenParams, { clientId });
        if (refreshTokenObject.extraParams) {
            renewTokenParams.extraParams = refreshTokenObject.extraParams;
        }
        const endpointParams = Object.assign({}, renewTokenParams);
        if (dpop) {
            const keyPair = await findKeyPair(refreshTokenObject === null || refreshTokenObject === void 0 ? void 0 : refreshTokenObject.dpopPairId);
            endpointParams.dpopKeyPair = keyPair;
            renewTokenParams.dpop = dpop;
            renewTokenParams.dpopPairId = refreshTokenObject.dpopPairId;
        }
        const tokenResponse = await postRefreshToken(sdk, endpointParams, refreshTokenObject);
        const urls = getOAuthUrls(sdk, tokenParams);
        const { tokens } = await handleOAuthResponse(sdk, renewTokenParams, tokenResponse, urls);
        const { refreshToken } = tokens;
        if (refreshToken && !isSameRefreshToken(refreshToken, refreshTokenObject)) {
            sdk.tokenManager.updateRefreshToken(refreshToken);
        }
        return tokens;
    }
    catch (err) {
        if (isRefreshTokenInvalidError(err)) {
            sdk.tokenManager.removeRefreshToken();
        }
        throw err;
    }
}


//# sourceMappingURL=renewTokensWithRefresh.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/renewToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







function throwInvalidTokenError() {
    throw new AuthSdkError('Renew must be passed a token with an array of scopes and an accessToken or idToken');
}
function getSingleToken(originalToken, tokens) {
    if (isIDToken(originalToken)) {
        return tokens.idToken;
    }
    if (isAccessToken(originalToken)) {
        return tokens.accessToken;
    }
    throwInvalidTokenError();
}
async function renewToken(sdk, token) {
    if (!isIDToken(token) && !isAccessToken(token)) {
        throwInvalidTokenError();
    }
    let tokens = sdk.tokenManager.getTokensSync();
    if (tokens.refreshToken) {
        tokens = await renewTokensWithRefresh(sdk, {
            scopes: token.scopes,
        }, tokens.refreshToken);
        return getSingleToken(token, tokens);
    }
    var responseType;
    if (sdk.options.pkce) {
        responseType = 'code';
    }
    else if (isAccessToken(token)) {
        responseType = 'token';
    }
    else {
        responseType = 'id_token';
    }
    const { scopes, authorizeUrl, userinfoUrl, issuer, dpopPairId, extraParams } = token;
    return getWithoutPrompt(sdk, {
        responseType,
        scopes,
        authorizeUrl,
        userinfoUrl,
        issuer,
        dpopPairId,
        extraParams
    })
        .then(function (res) {
        return getSingleToken(token, res.tokens);
    });
}


//# sourceMappingURL=renewToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/renewTokens.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












async function renewTokens(sdk, options) {
    var _a;
    const tokens = (_a = options === null || options === void 0 ? void 0 : options.tokens) !== null && _a !== void 0 ? _a : sdk.tokenManager.getTokensSync();
    if (tokens.refreshToken) {
        return renewTokensWithRefresh(sdk, options || {}, tokens.refreshToken);
    }
    if (!tokens.accessToken && !tokens.idToken) {
        throw new AuthSdkError('renewTokens() was called but there is no existing token');
    }
    const accessToken = tokens.accessToken || {};
    const idToken = tokens.idToken || {};
    const scopes = accessToken.scopes || idToken.scopes;
    if (!scopes) {
        throw new AuthSdkError('renewTokens: invalid tokens: could not read scopes');
    }
    const authorizeUrl = accessToken.authorizeUrl || idToken.authorizeUrl;
    if (!authorizeUrl) {
        throw new AuthSdkError('renewTokens: invalid tokens: could not read authorizeUrl');
    }
    const userinfoUrl = accessToken.userinfoUrl || sdk.options.userinfoUrl;
    const issuer = idToken.issuer || sdk.options.issuer;
    const dpopPairId = accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId;
    const extraParams = (accessToken === null || accessToken === void 0 ? void 0 : accessToken.extraParams) || (idToken === null || idToken === void 0 ? void 0 : idToken.extraParams);
    options = Object.assign({
        scopes,
        authorizeUrl,
        userinfoUrl,
        issuer,
        dpopPairId,
        extraParams
    }, options);
    if (sdk.options.pkce) {
        options.responseType = 'code';
    }
    else {
        const { responseType } = getDefaultTokenParams(sdk);
        options.responseType = responseType;
    }
    return getWithoutPrompt(sdk, options)
        .then(res => res.tokens);
}


//# sourceMappingURL=renewTokens.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/revokeToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */











async function revokeToken(sdk, token) {
    let accessToken = '';
    let refreshToken = '';
    if (token) {
        accessToken = token.accessToken;
        refreshToken = token.refreshToken;
    }
    if (!accessToken && !refreshToken) {
        throw new AuthSdkError('A valid access or refresh token object is required');
    }
    var clientId = sdk.options.clientId;
    var clientSecret = sdk.options.clientSecret;
    if (!clientId) {
        throw new AuthSdkError('A clientId must be specified in the OktaAuth constructor to revoke a token');
    }
    var revokeUrl = getOAuthUrls(sdk).revokeUrl;
    var args = toQueryString({
        token_type_hint: refreshToken ? 'refresh_token' : 'access_token',
        token: refreshToken || accessToken,
    }).slice(1);
    var creds = clientSecret ? b(`${clientId}:${clientSecret}`) : b(clientId);
    return post(sdk, revokeUrl, args, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic ' + creds
        }
    });
}


//# sourceMappingURL=revokeToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/introspect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












const hintMap = {
    accessToken: 'access_token',
    idToken: 'id_token',
    refreshToken: 'refresh_token'
};
async function oidcIntrospect(sdk, kind, token) {
    var _a;
    let issuer;
    let clientId = sdk.options.clientId;
    let clientSecret = sdk.options.clientSecret;
    if (!token) {
        token = sdk.tokenManager.getTokens()[kind];
    }
    if (!token) {
        throw new AuthSdkError(`unable to find ${kind} in storage or fn params`);
    }
    if (kind !== TokenKind.ACCESS) {
        issuer = token === null || token === void 0 ? void 0 : token.issuer;
    }
    else {
        issuer = (_a = token === null || token === void 0 ? void 0 : token.claims) === null || _a === void 0 ? void 0 : _a.iss;
    }
    issuer = issuer || sdk.options.issuer;
    if (!clientId) {
        throw new AuthSdkError('A clientId must be specified in the OktaAuth constructor to introspect a token');
    }
    if (!issuer) {
        throw new AuthSdkError('Unable to find issuer');
    }
    const { introspection_endpoint: introspectUrl } = await getWellKnown(sdk, issuer);
    const authHeader = clientSecret ? b(`${clientId}:${clientSecret}`) : b(clientId);
    const args = toQueryString({
        token_type_hint: hintMap[kind],
        token: token[kind]
    }).slice(1);
    return post(sdk, introspectUrl, args, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic ' + authHeader
        }
    });
}


//# sourceMappingURL=introspect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/enrollAuthenticatorMeta.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function createEnrollAuthenticatorMeta(sdk, params) {
    const issuer = sdk.options.issuer;
    const urls = getOAuthUrls(sdk, params);
    const oauthMeta = {
        issuer,
        urls,
        clientId: params.clientId,
        redirectUri: params.redirectUri,
        responseType: params.responseType,
        responseMode: params.responseMode,
        state: params.state,
        acrValues: params.acrValues,
        enrollAmrValues: params.enrollAmrValues,
    };
    return oauthMeta;
}


//# sourceMappingURL=enrollAuthenticatorMeta.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/defaultEnrollAuthenticatorParams.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function getDefaultEnrollAuthenticatorParams(sdk) {
    const { clientId, redirectUri, responseMode, state, } = sdk.options;
    const defaultRedirectUri = isBrowser() ? window.location.href : undefined;
    return removeNils({
        clientId,
        redirectUri: redirectUri || defaultRedirectUri,
        responseMode,
        state: state || generateState(),
        responseType: 'none',
        prompt: 'enroll_authenticator',
    });
}


//# sourceMappingURL=defaultEnrollAuthenticatorParams.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/prepareEnrollAuthenticatorParams.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function prepareParams(params) {
    params = Object.assign(Object.assign({}, params), {
        responseType: 'none', prompt: 'enroll_authenticator', maxAge: 0 });
    if (!params.enrollAmrValues) {
        throw new AuthSdkError('enroll_amr_values must be specified');
    }
    if (!params.acrValues) {
        throw new AuthSdkError('acr_values must be specified');
    }
    delete params.scopes;
    delete params.nonce;
    return params;
}
function prepareEnrollAuthenticatorParams(sdk, options) {
    return prepareParams(Object.assign(Object.assign({}, getDefaultEnrollAuthenticatorParams(sdk)), options));
}


//# sourceMappingURL=prepareEnrollAuthenticatorParams.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/enrollAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












function enrollAuthenticator(sdk, options) {
    options = clone(options) || {};
    const params = prepareEnrollAuthenticatorParams(sdk, options);
    const meta = createEnrollAuthenticatorMeta(sdk, params);
    const requestUrl = meta.urls.authorizeUrl + buildAuthorizeParams(params);
    sdk.transactionManager.save(meta);
    if (sdk.options.setLocation) {
        sdk.options.setLocation(requestUrl);
    }
    else {
        window.location.assign(requestUrl);
    }
}


//# sourceMappingURL=enrollAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/factory/api.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





















function createTokenAPI(sdk, queue) {
    const useQueue = (method) => {
        return PromiseQueue.prototype.push.bind(queue, method, null);
    };
    const getWithRedirectFn = useQueue(getWithRedirect.bind(null, sdk));
    const parseFromUrlFn = useQueue(parseFromUrl.bind(null, sdk));
    const parseFromUrlApi = Object.assign(parseFromUrlFn, {
        _getHistory: function () {
            return window.history;
        },
        _getLocation: function () {
            return window.location;
        },
        _getDocument: function () {
            return window.document;
        }
    });
    const token = {
        prepareTokenParams: prepareTokenParams_prepareTokenParams.bind(null, sdk),
        exchangeCodeForTokens: exchangeCodeForTokens_exchangeCodeForTokens.bind(null, sdk),
        getWithoutPrompt: getWithoutPrompt.bind(null, sdk),
        getWithPopup: getWithPopup.bind(null, sdk),
        getWithIDPPopup: getWithIDPPopup.bind(null, sdk),
        getWithRedirect: getWithRedirectFn,
        parseFromUrl: parseFromUrlApi,
        decode: decodeToken_decodeToken,
        revoke: revokeToken.bind(null, sdk),
        renew: renewToken.bind(null, sdk),
        renewTokensWithRefresh: renewTokensWithRefresh.bind(null, sdk),
        renewTokens: renewTokens.bind(null, sdk),
        getUserInfo: (accessTokenObject, idTokenObject) => {
            return getUserInfo(sdk, accessTokenObject, idTokenObject);
        },
        verify: verifyToken_verifyToken.bind(null, sdk),
        isLoginRedirect: loginRedirect_isLoginRedirect.bind(null, sdk),
        introspect: oidcIntrospect.bind(null, sdk),
    };
    const toWrap = [
        'getWithoutPrompt',
        'getWithPopup',
        'revoke',
        'renew',
        'renewTokensWithRefresh',
        'renewTokens'
    ];
    toWrap.forEach(key => {
        token[key] = useQueue(token[key]);
    });
    return token;
}
function createEndpoints(sdk) {
    return {
        authorize: {
            enrollAuthenticator: enrollAuthenticator.bind(null, sdk),
        }
    };
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/validateToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function validateToken(token, type) {
    if (!isIDToken(token) && !isAccessToken(token) && !isRefreshToken(token)) {
        throw new AuthSdkError('Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property');
    }
    if (type === 'accessToken' && !isAccessToken(token)) {
        throw new AuthSdkError('invalid accessToken');
    }
    if (type === 'idToken' && !isIDToken(token)) {
        throw new AuthSdkError('invalid idToken');
    }
    if (type === 'refreshToken' && !isRefreshToken(token)) {
        throw new AuthSdkError('invalid refreshToken');
    }
}


//# sourceMappingURL=validateToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/clock.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

class SdkClock {
    constructor(localOffset) {
        this.localOffset = parseInt(localOffset || 0);
    }
    static create( ) {
        var localOffset = 0;
        return new SdkClock(localOffset);
    }
    now() {
        var now = (Date.now() + this.localOffset) / 1000;
        return now;
    }
}


//# sourceMappingURL=clock.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/types/TokenManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const EVENT_EXPIRED = 'expired';
const EVENT_RENEWED = 'renewed';
const EVENT_ADDED = 'added';
const EVENT_REMOVED = 'removed';
const EVENT_ERROR = 'error';
const EVENT_SET_STORAGE = 'set_storage';


//# sourceMappingURL=TokenManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/TokenManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */















const DEFAULT_OPTIONS = {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
    clearPendingRemoveTokens: true,
    storage: undefined,
    expireEarlySeconds: 30,
    storageKey: TOKEN_STORAGE_NAME
};
function defaultState() {
    return {
        expireTimeouts: {},
        renewPromise: null
    };
}
class TokenManager {
    constructor(sdk, options = {}) {
        this.sdk = sdk;
        this.emitter = sdk.emitter;
        if (!this.emitter) {
            throw new AuthSdkError('Emitter should be initialized before TokenManager');
        }
        options = Object.assign({}, DEFAULT_OPTIONS, removeNils(options));
        if (!isLocalhost()) {
            options.expireEarlySeconds = DEFAULT_OPTIONS.expireEarlySeconds;
        }
        this.options = options;
        const storageOptions = removeNils({
            storageKey: options.storageKey,
            secure: options.secure,
        });
        if (typeof options.storage === 'object') {
            storageOptions.storageProvider = options.storage;
        }
        else if (options.storage) {
            storageOptions.storageType = options.storage;
        }
        this.storage = sdk.storageManager.getTokenStorage(Object.assign(Object.assign({}, storageOptions), { useSeparateCookies: true }));
        this.clock = SdkClock.create( );
        this.state = defaultState();
    }
    on(event, handler, context) {
        if (context) {
            this.emitter.on(event, handler, context);
        }
        else {
            this.emitter.on(event, handler);
        }
    }
    off(event, handler) {
        if (handler) {
            this.emitter.off(event, handler);
        }
        else {
            this.emitter.off(event);
        }
    }
    start() {
        if (this.options.clearPendingRemoveTokens) {
            this.clearPendingRemoveTokens();
        }
        this.setExpireEventTimeoutAll();
        this.state.started = true;
    }
    stop() {
        this.clearExpireEventTimeoutAll();
        this.state.started = false;
    }
    isStarted() {
        return !!this.state.started;
    }
    getOptions() {
        return clone(this.options);
    }
    getExpireTime(token) {
        const expireEarlySeconds = this.options.expireEarlySeconds || 0;
        var expireTime = token.expiresAt - expireEarlySeconds;
        return expireTime;
    }
    hasExpired(token) {
        var expireTime = this.getExpireTime(token);
        return expireTime <= this.clock.now();
    }
    emitExpired(key, token) {
        this.emitter.emit(EVENT_EXPIRED, key, token);
    }
    emitRenewed(key, freshToken, oldToken) {
        this.emitter.emit(EVENT_RENEWED, key, freshToken, oldToken);
    }
    emitAdded(key, token) {
        this.emitter.emit(EVENT_ADDED, key, token);
    }
    emitRemoved(key, token) {
        this.emitter.emit(EVENT_REMOVED, key, token);
    }
    emitError(error) {
        this.emitter.emit(EVENT_ERROR, error);
    }
    clearExpireEventTimeout(key) {
        clearTimeout(this.state.expireTimeouts[key]);
        delete this.state.expireTimeouts[key];
        this.state.renewPromise = null;
    }
    clearExpireEventTimeoutAll() {
        var expireTimeouts = this.state.expireTimeouts;
        for (var key in expireTimeouts) {
            if (!Object.prototype.hasOwnProperty.call(expireTimeouts, key)) {
                continue;
            }
            this.clearExpireEventTimeout(key);
        }
    }
    setExpireEventTimeout(key, token) {
        if (isRefreshToken(token)) {
            return;
        }
        var expireTime = this.getExpireTime(token);
        var expireEventWait = Math.max(expireTime - this.clock.now(), 0) * 1000;
        this.clearExpireEventTimeout(key);
        var expireEventTimeout = setTimeout(() => {
            this.emitExpired(key, token);
        }, expireEventWait);
        this.state.expireTimeouts[key] = expireEventTimeout;
    }
    setExpireEventTimeoutAll() {
        var tokenStorage = this.storage.getStorage();
        for (var key in tokenStorage) {
            if (!Object.prototype.hasOwnProperty.call(tokenStorage, key)) {
                continue;
            }
            var token = tokenStorage[key];
            this.setExpireEventTimeout(key, token);
        }
    }
    resetExpireEventTimeoutAll() {
        this.clearExpireEventTimeoutAll();
        this.setExpireEventTimeoutAll();
    }
    add(key, token) {
        var tokenStorage = this.storage.getStorage();
        validateToken(token);
        tokenStorage[key] = token;
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        this.emitAdded(key, token);
        this.setExpireEventTimeout(key, token);
    }
    getSync(key) {
        var tokenStorage = this.storage.getStorage();
        return tokenStorage[key];
    }
    async get(key) {
        return this.getSync(key);
    }
    getTokensSync() {
        const tokens = {};
        const tokenStorage = this.storage.getStorage();
        Object.keys(tokenStorage).forEach(key => {
            const token = tokenStorage[key];
            if (isAccessToken(token)) {
                tokens.accessToken = token;
            }
            else if (isIDToken(token)) {
                tokens.idToken = token;
            }
            else if (isRefreshToken(token)) {
                tokens.refreshToken = token;
            }
        });
        return tokens;
    }
    async getTokens() {
        return this.getTokensSync();
    }
    getStorageKeyByType(type) {
        const tokenStorage = this.storage.getStorage();
        const key = Object.keys(tokenStorage).filter(key => {
            const token = tokenStorage[key];
            return (isAccessToken(token) && type === 'accessToken')
                || (isIDToken(token) && type === 'idToken')
                || (isRefreshToken(token) && type === 'refreshToken');
        })[0];
        return key;
    }
    getTokenType(token) {
        if (isAccessToken(token)) {
            return 'accessToken';
        }
        if (isIDToken(token)) {
            return 'idToken';
        }
        if (isRefreshToken(token)) {
            return 'refreshToken';
        }
        throw new AuthSdkError('Unknown token type');
    }
    emitSetStorageEvent() {
        if (isIE11OrLess()) {
            const storage = this.storage.getStorage();
            this.emitter.emit(EVENT_SET_STORAGE, storage);
        }
    }
    getStorage() {
        return this.storage;
    }
    setTokens(tokens,
    accessTokenCb, idTokenCb, refreshTokenCb) {
        const handleTokenCallback = (key, token) => {
            const type = this.getTokenType(token);
            if (type === 'accessToken') {
                accessTokenCb && accessTokenCb(key, token);
            }
            else if (type === 'idToken') {
                idTokenCb && idTokenCb(key, token);
            }
            else if (type === 'refreshToken') {
                refreshTokenCb && refreshTokenCb(key, token);
            }
        };
        const handleAdded = (key, token) => {
            this.emitAdded(key, token);
            this.setExpireEventTimeout(key, token);
            handleTokenCallback(key, token);
        };
        const handleRenewed = (key, token, oldToken) => {
            this.emitRenewed(key, token, oldToken);
            this.clearExpireEventTimeout(key);
            this.setExpireEventTimeout(key, token);
            handleTokenCallback(key, token);
        };
        const handleRemoved = (key, token) => {
            this.clearExpireEventTimeout(key);
            this.emitRemoved(key, token);
            handleTokenCallback(key, token);
        };
        const types = ['idToken', 'accessToken', 'refreshToken'];
        const existingTokens = this.getTokensSync();
        types.forEach((type) => {
            const token = tokens[type];
            if (token) {
                validateToken(token, type);
            }
        });
        const storage = types.reduce((storage, type) => {
            const token = tokens[type];
            if (token) {
                const storageKey = this.getStorageKeyByType(type) || type;
                storage[storageKey] = token;
            }
            return storage;
        }, {});
        this.storage.setStorage(storage);
        this.emitSetStorageEvent();
        types.forEach(type => {
            const newToken = tokens[type];
            const existingToken = existingTokens[type];
            const storageKey = this.getStorageKeyByType(type) || type;
            if (newToken && existingToken) {
                handleRemoved(storageKey, existingToken);
                handleAdded(storageKey, newToken);
                handleRenewed(storageKey, newToken, existingToken);
            }
            else if (newToken) {
                handleAdded(storageKey, newToken);
            }
            else if (existingToken) {
                handleRemoved(storageKey, existingToken);
            }
        });
    }
    remove(key) {
        this.clearExpireEventTimeout(key);
        var tokenStorage = this.storage.getStorage();
        var removedToken = tokenStorage[key];
        delete tokenStorage[key];
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        this.emitRemoved(key, removedToken);
    }
    async renewToken(token) {
        var _a;
        return (_a = this.sdk.token) === null || _a === void 0 ? void 0 : _a.renew(token);
    }
    validateToken(token) {
        return validateToken(token);
    }
    renew(key) {
        if (this.state.renewPromise) {
            return this.state.renewPromise;
        }
        try {
            var token = this.getSync(key);
            let shouldRenew = token !== undefined;
            if (!token && key === 'accessToken') {
                const refreshKey = this.getStorageKeyByType('refreshToken');
                const refreshToken = this.getSync(refreshKey);
                shouldRenew = refreshToken !== undefined;
            }
            if (!shouldRenew) {
                throw new AuthSdkError('The tokenManager has no token for the key: ' + key);
            }
        }
        catch (err) {
            this.emitError(err);
            return Promise.reject(err);
        }
        this.clearExpireEventTimeout(key);
        const renewPromise = this.state.renewPromise = this.sdk.token.renewTokens()
            .then(tokens => {
            this.setTokens(tokens);
            if (!token && key === 'accessToken') {
                const accessToken = tokens['accessToken'];
                this.emitRenewed(key, accessToken, null);
                return accessToken;
            }
            const tokenType = this.getTokenType(token);
            return tokens[tokenType];
        })
            .catch(err => {
            this.remove(key);
            err.tokenKey = key;
            this.emitError(err);
            throw err;
        })
            .finally(() => {
            this.state.renewPromise = null;
        });
        return renewPromise;
    }
    clear() {
        const tokens = this.getTokensSync();
        this.clearExpireEventTimeoutAll();
        this.storage.clearStorage();
        this.emitSetStorageEvent();
        Object.keys(tokens).forEach(key => {
            this.emitRemoved(key, tokens[key]);
        });
    }
    clearPendingRemoveTokens() {
        const tokenStorage = this.storage.getStorage();
        const removedTokens = {};
        Object.keys(tokenStorage).forEach(key => {
            if (tokenStorage[key].pendingRemove) {
                removedTokens[key] = tokenStorage[key];
                delete tokenStorage[key];
            }
        });
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        Object.keys(removedTokens).forEach(key => {
            this.clearExpireEventTimeout(key);
            this.emitRemoved(key, removedTokens[key]);
        });
    }
    updateRefreshToken(token) {
        const key = this.getStorageKeyByType('refreshToken') || REFRESH_TOKEN_STORAGE_KEY;
        var tokenStorage = this.storage.getStorage();
        validateToken(token);
        tokenStorage[key] = token;
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
    }
    removeRefreshToken() {
        const key = this.getStorageKeyByType('refreshToken') || REFRESH_TOKEN_STORAGE_KEY;
        this.remove(key);
    }
    addPendingRemoveFlags() {
        const tokens = this.getTokensSync();
        Object.keys(tokens).forEach(key => {
            tokens[key].pendingRemove = true;
        });
        this.setTokens(tokens);
    }
}


//# sourceMappingURL=TokenManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/browser/browserStorage.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






var storageUtil = {
    browserHasLocalStorage: function () {
        try {
            var storage = this.getLocalStorage();
            return this.testStorage(storage);
        }
        catch (e) {
            return false;
        }
    },
    browserHasSessionStorage: function () {
        try {
            var storage = this.getSessionStorage();
            return this.testStorage(storage);
        }
        catch (e) {
            return false;
        }
    },
    testStorageType: function (storageType) {
        var supported = false;
        switch (storageType) {
            case 'sessionStorage':
                supported = this.browserHasSessionStorage();
                break;
            case 'localStorage':
                supported = this.browserHasLocalStorage();
                break;
            case 'cookie':
            case 'memory':
                supported = true;
                break;
            default:
                supported = false;
                break;
        }
        return supported;
    },
    getStorageByType: function (storageType, options) {
        let storageProvider;
        switch (storageType) {
            case 'sessionStorage':
                storageProvider = this.getSessionStorage();
                break;
            case 'localStorage':
                storageProvider = this.getLocalStorage();
                break;
            case 'cookie':
                storageProvider = this.getCookieStorage(options);
                break;
            case 'memory':
                storageProvider = this.getInMemoryStorage();
                break;
            default:
                throw new AuthSdkError(`Unrecognized storage option: ${storageType}`);
        }
        return storageProvider;
    },
    findStorageType: function (types) {
        let curType;
        let nextType;
        types = types.slice();
        curType = types.shift();
        nextType = types.length ? types[0] : null;
        if (!nextType) {
            return curType;
        }
        if (this.testStorageType(curType)) {
            return curType;
        }
        warn(`This browser doesn't support ${curType}. Switching to ${nextType}.`);
        return this.findStorageType(types);
    },
    getLocalStorage: function () {
        if (isIE11OrLess() && !window.onstorage) {
            window.onstorage = function () { };
        }
        return localStorage;
    },
    getSessionStorage: function () {
        return sessionStorage;
    },
    getCookieStorage: function (options) {
        const secure = options.secure;
        const sameSite = options.sameSite;
        const sessionCookie = options.sessionCookie;
        if (typeof secure === 'undefined' || typeof sameSite === 'undefined') {
            throw new AuthSdkError('getCookieStorage: "secure" and "sameSite" options must be provided');
        }
        const storage = {
            getItem: this.storage.get,
            setItem: (key, value, expiresAt = '2200-01-01T00:00:00.000Z') => {
                expiresAt = (sessionCookie ? null : expiresAt);
                this.storage.set(key, value, expiresAt, {
                    secure: secure,
                    sameSite: sameSite,
                });
            },
            removeItem: (key) => {
                this.storage.delete(key);
            },
        };
        if (!options.useSeparateCookies) {
            return storage;
        }
        return {
            getItem: function (key) {
                var data = storage.getItem();
                var value = {};
                Object.keys(data).forEach(k => {
                    if (k.indexOf(key) === 0) {
                        value[k.replace(`${key}_`, '')] = JSON.parse(data[k]);
                    }
                });
                return JSON.stringify(value);
            },
            setItem: function (key, value) {
                var existingValues = JSON.parse(this.getItem(key));
                value = JSON.parse(value);
                Object.keys(value).forEach(k => {
                    var storageKey = key + '_' + k;
                    var valueToStore = JSON.stringify(value[k]);
                    storage.setItem(storageKey, valueToStore);
                    delete existingValues[k];
                });
                Object.keys(existingValues).forEach(k => {
                    storage.removeItem(key + '_' + k);
                });
            },
            removeItem: function (key) {
                var existingValues = JSON.parse(this.getItem(key));
                Object.keys(existingValues).forEach(k => {
                    storage.removeItem(key + '_' + k);
                });
            },
        };
    },
    inMemoryStore: {},
    getInMemoryStorage: function () {
        return {
            getItem: (key) => {
                return this.inMemoryStore[key];
            },
            setItem: (key, value) => {
                this.inMemoryStore[key] = value;
            },
        };
    },
    testStorage: function (storage) {
        var key = 'okta-test-storage';
        try {
            storage.setItem(key, key);
            storage.removeItem(key);
            return true;
        }
        catch (e) {
            return false;
        }
    },
    storage: {
        set: function (name, value, expiresAt, options) {
            const { sameSite, secure } = options;
            if (typeof secure === 'undefined' || typeof sameSite === 'undefined') {
                throw new AuthSdkError('storage.set: "secure" and "sameSite" options must be provided');
            }
            var cookieOptions = {
                path: options.path || '/',
                secure,
                sameSite
            };
            if (!!(Date.parse(expiresAt))) {
                cookieOptions.expires = new Date(expiresAt);
            }
            api.set(name, value, cookieOptions);
            return this.get(name);
        },
        get: function (name) {
            if (!arguments.length) {
                return api.get();
            }
            return api.get(name);
        },
        delete: function (name) {
            return api.remove(name, { path: '/' });
        }
    }
};


//# sourceMappingURL=browserStorage.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/mixin/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function provideOriginalUri(BaseClass) {
    return class WithOriginalUri extends BaseClass {
        setOriginalUri(originalUri, state) {
            const sessionStorage = storageUtil.getSessionStorage();
            sessionStorage.setItem(REFERRER_PATH_STORAGE_KEY, originalUri);
            state = state || this.options.state;
            if (state) {
                const sharedStorage = this.storageManager.getOriginalUriStorage();
                sharedStorage.setItem(state, originalUri);
            }
        }
        getOriginalUri(state) {
            state = state || this.options.state;
            if (state) {
                const sharedStorage = this.storageManager.getOriginalUriStorage();
                const originalUri = sharedStorage.getItem(state);
                if (originalUri) {
                    return originalUri;
                }
            }
            const storage = storageUtil.getSessionStorage();
            return storage ? storage.getItem(REFERRER_PATH_STORAGE_KEY) || undefined : undefined;
        }
        removeOriginalUri(state) {
            const storage = storageUtil.getSessionStorage();
            storage.removeItem(REFERRER_PATH_STORAGE_KEY);
            state = state || this.options.state;
            if (state) {
                const sharedStorage = this.storageManager.getOriginalUriStorage();
                sharedStorage.removeItem && sharedStorage.removeItem(state);
            }
        }
    };
}


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/mixin/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




















function mixin_mixinOAuth(Base, TransactionManagerConstructor) {
    var _a;
    const WithOriginalUri = provideOriginalUri(Base);
    return _a = class OktaAuthOAuth extends WithOriginalUri {
            constructor(...args) {
                super(...args);
                this.transactionManager = new TransactionManagerConstructor(Object.assign({
                    storageManager: this.storageManager,
                }, this.options.transactionManager));
                this.pkce = {
                    DEFAULT_CODE_CHALLENGE_METHOD: PKCE.DEFAULT_CODE_CHALLENGE_METHOD,
                    generateVerifier: PKCE.generateVerifier,
                    computeChallenge: PKCE.computeChallenge
                };
                this._pending = { handleLogin: false };
                this._tokenQueue = new PromiseQueue();
                this.token = createTokenAPI(this, this._tokenQueue);
                this.tokenManager = new TokenManager(this, this.options.tokenManager);
                this.endpoints = createEndpoints(this);
            }
            clearStorage() {
                super.clearStorage();
                this.tokenManager.clear();
            }
            async isAuthenticated(options = {}) {
                const { autoRenew, autoRemove } = this.tokenManager.getOptions();
                const shouldRenew = options.onExpiredToken ? options.onExpiredToken === 'renew' : autoRenew;
                const shouldRemove = options.onExpiredToken ? options.onExpiredToken === 'remove' : autoRemove;
                let { accessToken } = this.tokenManager.getTokensSync();
                if (accessToken && this.tokenManager.hasExpired(accessToken)) {
                    accessToken = undefined;
                    if (shouldRenew) {
                        try {
                            accessToken = await this.tokenManager.renew('accessToken');
                        }
                        catch (_a) {
                        }
                    }
                    else if (shouldRemove) {
                        this.tokenManager.remove('accessToken');
                    }
                }
                let { idToken } = this.tokenManager.getTokensSync();
                if (idToken && this.tokenManager.hasExpired(idToken)) {
                    idToken = undefined;
                    if (shouldRenew) {
                        try {
                            idToken = await this.tokenManager.renew('idToken');
                        }
                        catch (_b) {
                        }
                    }
                    else if (shouldRemove) {
                        this.tokenManager.remove('idToken');
                    }
                }
                return !!(accessToken && idToken);
            }
            async signInWithRedirect(opts = {}) {
                const { originalUri } = opts, additionalParams = __rest(opts, ["originalUri"]);
                if (this._pending.handleLogin) {
                    return;
                }
                this._pending.handleLogin = true;
                try {
                    if (originalUri) {
                        this.setOriginalUri(originalUri);
                    }
                    const params = Object.assign({
                        scopes: this.options.scopes || ['openid', 'email', 'profile']
                    }, additionalParams);
                    await this.token.getWithRedirect(params);
                }
                finally {
                    this._pending.handleLogin = false;
                }
            }
            async getUser() {
                const { idToken, accessToken } = this.tokenManager.getTokensSync();
                return this.token.getUserInfo(accessToken, idToken);
            }
            getIdToken() {
                const { idToken } = this.tokenManager.getTokensSync();
                return idToken ? idToken.idToken : undefined;
            }
            getAccessToken() {
                const { accessToken } = this.tokenManager.getTokensSync();
                return accessToken ? accessToken.accessToken : undefined;
            }
            getRefreshToken() {
                const { refreshToken } = this.tokenManager.getTokensSync();
                return refreshToken ? refreshToken.refreshToken : undefined;
            }
            async getOrRenewAccessToken() {
                var _a;
                const { accessToken } = this.tokenManager.getTokensSync();
                if (accessToken && !this.tokenManager.hasExpired(accessToken)) {
                    return accessToken.accessToken;
                }
                try {
                    const key = this.tokenManager.getStorageKeyByType('accessToken');
                    const token = await this.tokenManager.renew(key !== null && key !== void 0 ? key : 'accessToken');
                    return (_a = token === null || token === void 0 ? void 0 : token.accessToken) !== null && _a !== void 0 ? _a : null;
                }
                catch (err) {
                    this.emitter.emit('error', err);
                    return null;
                }
            }
            async storeTokensFromRedirect() {
                const { tokens, responseType } = await this.token.parseFromUrl();
                if (responseType !== 'none') {
                    this.tokenManager.setTokens(tokens);
                }
            }
            isLoginRedirect() {
                return loginRedirect_isLoginRedirect(this);
            }
            isPKCE() {
                return !!this.options.pkce;
            }
            hasResponseType(responseType) {
                return loginRedirect_hasResponseType(responseType, this.options);
            }
            isAuthorizationCodeFlow() {
                return this.hasResponseType('code');
            }
            async invokeApiMethod(options) {
                if (!options.accessToken) {
                    const accessToken = (await this.tokenManager.getTokens()).accessToken;
                    options.accessToken = accessToken === null || accessToken === void 0 ? void 0 : accessToken.accessToken;
                }
                return httpRequest(this, options);
            }
            async revokeAccessToken(accessToken) {
                if (!accessToken) {
                    const tokens = await this.tokenManager.getTokens();
                    accessToken = tokens.accessToken;
                    const accessTokenKey = this.tokenManager.getStorageKeyByType('accessToken');
                    this.tokenManager.remove(accessTokenKey);
                    if (this.options.dpop) {
                        await clearDPoPKeyPairAfterRevoke('access', tokens);
                    }
                }
                if (!accessToken) {
                    return Promise.resolve(null);
                }
                return this.token.revoke(accessToken);
            }
            async revokeRefreshToken(refreshToken) {
                if (!refreshToken) {
                    const tokens = await this.tokenManager.getTokens();
                    refreshToken = tokens.refreshToken;
                    const refreshTokenKey = this.tokenManager.getStorageKeyByType('refreshToken');
                    this.tokenManager.remove(refreshTokenKey);
                    if (this.options.dpop) {
                        await clearDPoPKeyPairAfterRevoke('refresh', tokens);
                    }
                }
                if (!refreshToken) {
                    return Promise.resolve(null);
                }
                return this.token.revoke(refreshToken);
            }
            getSignOutRedirectUrl(options = {}) {
                let { idToken, postLogoutRedirectUri, state, } = options;
                if (!idToken) {
                    idToken = this.tokenManager.getTokensSync().idToken;
                }
                if (!idToken) {
                    return '';
                }
                if (postLogoutRedirectUri === undefined) {
                    postLogoutRedirectUri = this.options.postLogoutRedirectUri;
                }
                const logoutUrl = getOAuthUrls(this).logoutUrl;
                const idTokenHint = idToken.idToken;
                let logoutUri = logoutUrl + '?id_token_hint=' + encodeURIComponent(idTokenHint);
                if (postLogoutRedirectUri) {
                    logoutUri += '&post_logout_redirect_uri=' + encodeURIComponent(postLogoutRedirectUri);
                }
                if (state) {
                    logoutUri += '&state=' + encodeURIComponent(state);
                }
                return logoutUri;
            }
            async signOut(options) {
                var _a;
                options = Object.assign({}, options);
                const defaultUri = window.location.origin;
                const currentUri = window.location.href;
                const postLogoutRedirectUri = options.postLogoutRedirectUri === null ? null :
                    (options.postLogoutRedirectUri
                        || this.options.postLogoutRedirectUri
                        || defaultUri);
                const state = options === null || options === void 0 ? void 0 : options.state;
                let accessToken = options.accessToken;
                let refreshToken = options.refreshToken;
                const revokeAccessToken = options.revokeAccessToken !== false;
                const revokeRefreshToken = options.revokeRefreshToken !== false;
                if (revokeRefreshToken && typeof refreshToken === 'undefined') {
                    refreshToken = this.tokenManager.getTokensSync().refreshToken;
                }
                if (revokeAccessToken && typeof accessToken === 'undefined') {
                    accessToken = this.tokenManager.getTokensSync().accessToken;
                }
                if (!options.idToken) {
                    options.idToken = this.tokenManager.getTokensSync().idToken;
                }
                if (revokeRefreshToken && refreshToken) {
                    await this.revokeRefreshToken(refreshToken);
                }
                if (revokeAccessToken && accessToken) {
                    await this.revokeAccessToken(accessToken);
                }
                const dpopPairId = (_a = accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId) !== null && _a !== void 0 ? _a : refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.dpopPairId;
                if (this.options.dpop && dpopPairId) {
                    await clearDPoPKeyPair(dpopPairId);
                }
                const logoutUri = this.getSignOutRedirectUrl(Object.assign(Object.assign({}, options), { postLogoutRedirectUri }));
                if (!logoutUri) {
                    const sessionClosed = await this.closeSession();
                    const redirectUri = new URL(postLogoutRedirectUri || defaultUri);
                    if (state) {
                        redirectUri.searchParams.append('state', state);
                    }
                    if (postLogoutRedirectUri === currentUri) {
                        window.location.href = redirectUri.href;
                    }
                    else {
                        window.location.assign(redirectUri.href);
                    }
                    return sessionClosed;
                }
                else {
                    if (options.clearTokensBeforeRedirect) {
                        this.tokenManager.clear();
                    }
                    else {
                        this.tokenManager.addPendingRemoveFlags();
                    }
                    window.location.assign(logoutUri);
                    return true;
                }
            }
            async getDPoPAuthorizationHeaders(params) {
                if (!this.options.dpop) {
                    throw new AuthSdkError('DPoP is not configured for this client instance');
                }
                let { accessToken } = params;
                if (!accessToken) {
                    accessToken = (this.tokenManager.getTokensSync()).accessToken;
                }
                if (!accessToken) {
                    throw new AuthSdkError('AccessToken is required to generate a DPoP Proof');
                }
                const keyPair = await findKeyPair(accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId);
                const proof = await generateDPoPProof(Object.assign(Object.assign({}, params), { keyPair, accessToken: accessToken.accessToken }));
                return {
                    Authorization: `DPoP ${accessToken.accessToken}`,
                    Dpop: proof
                };
            }
            async clearDPoPStorage(clearAll = false) {
                var _a, _b;
                if (clearAll) {
                    return clearAllDPoPKeyPairs();
                }
                const tokens = await this.tokenManager.getTokens();
                const keyPair = ((_a = tokens.accessToken) === null || _a === void 0 ? void 0 : _a.dpopPairId) || ((_b = tokens.refreshToken) === null || _b === void 0 ? void 0 : _b.dpopPairId);
                if (keyPair) {
                    await clearDPoPKeyPair(keyPair);
                }
            }
            parseUseDPoPNonceError(headers) {
                var _a;
                const wwwAuth = WWWAuthError.getWWWAuthenticateHeader(headers);
                const wwwErr = WWWAuthError.parseHeader(wwwAuth !== null && wwwAuth !== void 0 ? wwwAuth : '');
                if (isDPoPNonceError(wwwErr)) {
                    let nonce = null;
                    if (isFunction(headers === null || headers === void 0 ? void 0 : headers.get)) {
                        nonce = headers.get('DPoP-Nonce');
                    }
                    nonce = (_a = nonce !== null && nonce !== void 0 ? nonce : headers['dpop-nonce']) !== null && _a !== void 0 ? _a : headers['DPoP-Nonce'];
                    return nonce;
                }
                return null;
            }
        },
        _a.crypto = crypto_namespaceObject,
        _a;
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/p-cancelable/index.js
var p_cancelable = __webpack_require__(80341);
;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/core/AuthStateManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */














const INITIAL_AUTH_STATE = null;
const DEFAULT_PENDING = {
    updateAuthStatePromise: null,
    canceledTimes: 0
};
const EVENT_AUTH_STATE_CHANGE = 'authStateChange';
const MAX_PROMISE_CANCEL_TIMES = 10;
const isSameAuthState = (prevState, state) => {
    if (!prevState) {
        return false;
    }
    return prevState.isAuthenticated === state.isAuthenticated
        && JSON.stringify(prevState.idToken) === JSON.stringify(state.idToken)
        && JSON.stringify(prevState.accessToken) === JSON.stringify(state.accessToken)
        && prevState.error === state.error;
};
class AuthStateManager {
    constructor(sdk) {
        if (!sdk.emitter) {
            throw new AuthSdkError('Emitter should be initialized before AuthStateManager');
        }
        this._sdk = sdk;
        this._pending = Object.assign({}, DEFAULT_PENDING);
        this._authState = INITIAL_AUTH_STATE;
        this._logOptions = {};
        this._prevAuthState = null;
        this._transformQueue = new PromiseQueue({
            quiet: true
        });
        sdk.tokenManager.on(EVENT_ADDED, (key, token) => {
            this._setLogOptions({ event: EVENT_ADDED, key, token });
            this.updateAuthState();
        });
        sdk.tokenManager.on(EVENT_REMOVED, (key, token) => {
            this._setLogOptions({ event: EVENT_REMOVED, key, token });
            this.updateAuthState();
        });
    }
    _setLogOptions(options) {
        this._logOptions = options;
    }
    getAuthState() {
        return this._authState;
    }
    getPreviousAuthState() {
        return this._prevAuthState;
    }
    async updateAuthState() {
        const { transformAuthState, devMode } = this._sdk.options;
        const log = (status) => {
            const { event, key, token } = this._logOptions;
            getConsole().group(`OKTA-AUTH-JS:updateAuthState: Event:${event} Status:${status}`);
            getConsole().log(key, token);
            getConsole().log('Current authState', this._authState);
            getConsole().groupEnd();
            this._logOptions = {};
        };
        const emitAuthStateChange = (authState) => {
            if (isSameAuthState(this._authState, authState)) {
                devMode && log('unchanged');
                return;
            }
            this._prevAuthState = this._authState;
            this._authState = authState;
            this._sdk.emitter.emit(EVENT_AUTH_STATE_CHANGE, Object.assign({}, authState));
            devMode && log('emitted');
        };
        const finalPromise = (origPromise) => {
            return this._pending.updateAuthStatePromise.then(() => {
                const curPromise = this._pending.updateAuthStatePromise;
                if (curPromise && curPromise !== origPromise) {
                    return finalPromise(curPromise);
                }
                return this.getAuthState();
            });
        };
        if (this._pending.updateAuthStatePromise) {
            if (this._pending.canceledTimes >= MAX_PROMISE_CANCEL_TIMES) {
                devMode && log('terminated');
                return finalPromise(this._pending.updateAuthStatePromise);
            }
            else {
                this._pending.updateAuthStatePromise.cancel();
            }
        }
        const cancelablePromise = new p_cancelable((resolve, _, onCancel) => {
            onCancel.shouldReject = false;
            onCancel(() => {
                this._pending.updateAuthStatePromise = null;
                this._pending.canceledTimes = this._pending.canceledTimes + 1;
                devMode && log('canceled');
            });
            const emitAndResolve = (authState) => {
                if (cancelablePromise.isCanceled) {
                    resolve();
                    return;
                }
                emitAuthStateChange(authState);
                resolve();
                this._pending = Object.assign({}, DEFAULT_PENDING);
            };
            this._sdk.isAuthenticated()
                .then(() => {
                if (cancelablePromise.isCanceled) {
                    resolve();
                    return;
                }
                const { accessToken, idToken, refreshToken } = this._sdk.tokenManager.getTokensSync();
                const authState = {
                    accessToken,
                    idToken,
                    refreshToken,
                    isAuthenticated: !!(accessToken && idToken)
                };
                const promise = transformAuthState
                    ? this._transformQueue.push(transformAuthState, null, this._sdk, authState)
                    : Promise.resolve(authState);
                promise
                    .then(authState => emitAndResolve(authState))
                    .catch(error => emitAndResolve({
                    accessToken,
                    idToken,
                    refreshToken,
                    isAuthenticated: false,
                    error
                }));
            });
        });
        this._pending.updateAuthStatePromise = cancelablePromise;
        return finalPromise(cancelablePromise);
    }
    subscribe(handler) {
        this._sdk.emitter.on(EVENT_AUTH_STATE_CHANGE, handler);
    }
    unsubscribe(handler) {
        this._sdk.emitter.off(EVENT_AUTH_STATE_CHANGE, handler);
    }
}


//# sourceMappingURL=AuthStateManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/services/AutoRenewService.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







class AutoRenewService {
    constructor(tokenManager, options = {}) {
        this.started = false;
        this.tokenManager = tokenManager;
        this.options = options;
        this.renewTimeQueue = [];
        this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this);
    }
    shouldThrottleRenew() {
        let res = false;
        this.renewTimeQueue.push(Date.now());
        if (this.renewTimeQueue.length >= 10) {
            const firstTime = this.renewTimeQueue.shift();
            const lastTime = this.renewTimeQueue[this.renewTimeQueue.length - 1];
            res = (lastTime - firstTime) < 30 * 1000;
        }
        return res;
    }
    requiresLeadership() {
        return !!this.options.syncStorage && isBrowser();
    }
    processExpiredTokens() {
        const tokenStorage = this.tokenManager.getStorage();
        const tokens = tokenStorage.getStorage();
        Object.keys(tokens).forEach(key => {
            const token = tokens[key];
            if (!isRefreshToken(token) && this.tokenManager.hasExpired(token)) {
                this.onTokenExpiredHandler(key);
            }
        });
    }
    onTokenExpiredHandler(key) {
        if (this.options.autoRenew) {
            if (this.shouldThrottleRenew()) {
                const error = new AuthSdkError('Too many token renew requests');
                this.tokenManager.emitError(error);
            }
            else {
                this.tokenManager.renew(key).catch(() => { });
            }
        }
        else if (this.options.autoRemove) {
            this.tokenManager.remove(key);
        }
    }
    canStart() {
        return (!!this.options.autoRenew || !!this.options.autoRemove) && !this.started;
    }
    async start() {
        if (this.canStart()) {
            this.tokenManager.on(EVENT_EXPIRED, this.onTokenExpiredHandler);
            if (this.tokenManager.isStarted()) {
                this.processExpiredTokens();
            }
            this.started = true;
        }
    }
    async stop() {
        if (this.started) {
            this.tokenManager.off(EVENT_EXPIRED, this.onTokenExpiredHandler);
            this.renewTimeQueue = [];
            this.started = false;
        }
    }
    isStarted() {
        return this.started;
    }
}


//# sourceMappingURL=AutoRenewService.js.map

;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/util.js
/**
 * returns true if the given object is a promise
 */
function util_isPromise(obj) {
  return obj && typeof obj.then === 'function';
}
var util_PROMISE_RESOLVED_FALSE = Promise.resolve(false);
var PROMISE_RESOLVED_TRUE = Promise.resolve(true);
var PROMISE_RESOLVED_VOID = Promise.resolve();
function sleep(time, resolveWith) {
  if (!time) time = 0;
  return new Promise(function (res) {
    return setTimeout(function () {
      return res(resolveWith);
    }, time);
  });
}
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * https://stackoverflow.com/a/8084248
 */
function randomToken() {
  return Math.random().toString(36).substring(2);
}
var lastMs = 0;

/**
 * Returns the current unix time in micro-seconds,
 * WARNING: This is a pseudo-function
 * Performance.now is not reliable in webworkers, so we just make sure to never return the same time.
 * This is enough in browsers, and this function will not be used in nodejs.
 * The main reason for this hack is to ensure that BroadcastChannel behaves equal to production when it is used in fast-running unit tests.
 */
function microSeconds() {
  var ret = Date.now() * 1000; // milliseconds to microseconds
  if (ret <= lastMs) {
    ret = lastMs + 1;
  }
  lastMs = ret;
  return ret;
}

/**
 * Check if WebLock API is supported.
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Locks_API
 */
function supportsWebLockAPI() {
  if (typeof navigator !== 'undefined' && typeof navigator.locks !== 'undefined' && typeof navigator.locks.request === 'function') {
    return true;
  } else {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/native.js

var native_microSeconds = microSeconds;
var type = 'native';
function create(channelName) {
  var state = {
    time: microSeconds(),
    messagesCallback: null,
    bc: new BroadcastChannel(channelName),
    subFns: [] // subscriberFunctions
  };
  state.bc.onmessage = function (msgEvent) {
    if (state.messagesCallback) {
      state.messagesCallback(msgEvent.data);
    }
  };
  return state;
}
function native_close(channelState) {
  channelState.bc.close();
  channelState.subFns = [];
}
function postMessage(channelState, messageJson) {
  try {
    channelState.bc.postMessage(messageJson, false);
    return PROMISE_RESOLVED_VOID;
  } catch (err) {
    return Promise.reject(err);
  }
}
function onMessage(channelState, fn) {
  channelState.messagesCallback = fn;
}
function canBeUsed() {
  // Deno runtime
  // eslint-disable-next-line
  if (typeof globalThis !== 'undefined' && globalThis.Deno && globalThis.Deno.args) {
    return true;
  }

  // Browser runtime
  if ((typeof window !== 'undefined' || typeof self !== 'undefined') && typeof BroadcastChannel === 'function') {
    if (BroadcastChannel._pubkey) {
      throw new Error('BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill');
    }
    return true;
  } else {
    return false;
  }
}
function averageResponseTime() {
  return 150;
}
var NativeMethod = {
  create: create,
  close: native_close,
  onMessage: onMessage,
  postMessage: postMessage,
  canBeUsed: canBeUsed,
  type: type,
  averageResponseTime: averageResponseTime,
  microSeconds: native_microSeconds
};
;// CONCATENATED MODULE: ./node_modules/oblivious-set/dist/esm/src/index.js
/**
 * this is a set which automatically forgets
 * a given entry when a new entry is set and the ttl
 * of the old one is over
 */
class ObliviousSet {
    ttl;
    map = new Map();
    /**
     * Creating calls to setTimeout() is expensive,
     * so we only do that if there is not timeout already open.
     */
    _to = false;
    constructor(ttl) {
        this.ttl = ttl;
    }
    has(value) {
        return this.map.has(value);
    }
    add(value) {
        this.map.set(value, now());
        /**
         * When a new value is added,
         * start the cleanup at the next tick
         * to not block the cpu for more important stuff
         * that might happen.
         */
        if (!this._to) {
            this._to = true;
            setTimeout(() => {
                this._to = false;
                removeTooOldValues(this);
            }, 0);
        }
    }
    clear() {
        this.map.clear();
    }
}
/**
 * Removes all entries from the set
 * where the TTL has expired
 */
function removeTooOldValues(obliviousSet) {
    const olderThen = now() - obliviousSet.ttl;
    const iterator = obliviousSet.map[Symbol.iterator]();
    /**
     * Because we can assume the new values are added at the bottom,
     * we start from the top and stop as soon as we reach a non-too-old value.
     */
    while (true) {
        const next = iterator.next().value;
        if (!next) {
            return; // no more elements
        }
        const value = next[0];
        const time = next[1];
        if (time < olderThen) {
            obliviousSet.map.delete(value);
        }
        else {
            // We reached a value that is not old enough
            return;
        }
    }
}
function now() {
    return Date.now();
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/options.js
function options_fillOptionsWithDefaults() {
  var originalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = JSON.parse(JSON.stringify(originalOptions));

  // main
  if (typeof options.webWorkerSupport === 'undefined') options.webWorkerSupport = true;

  // indexed-db
  if (!options.idb) options.idb = {};
  //  after this time the messages get deleted
  if (!options.idb.ttl) options.idb.ttl = 1000 * 45;
  if (!options.idb.fallbackInterval) options.idb.fallbackInterval = 150;
  //  handles abrupt db onclose events.
  if (originalOptions.idb && typeof originalOptions.idb.onclose === 'function') options.idb.onclose = originalOptions.idb.onclose;

  // localstorage
  if (!options.localstorage) options.localstorage = {};
  if (!options.localstorage.removeTimeout) options.localstorage.removeTimeout = 1000 * 60;

  // custom methods
  if (originalOptions.methods) options.methods = originalOptions.methods;

  // node
  if (!options.node) options.node = {};
  if (!options.node.ttl) options.node.ttl = 1000 * 60 * 2; // 2 minutes;
  /**
   * On linux use 'ulimit -Hn' to get the limit of open files.
   * On ubuntu this was 4096 for me, so we use half of that as maxParallelWrites default.
   */
  if (!options.node.maxParallelWrites) options.node.maxParallelWrites = 2048;
  if (typeof options.node.useFastPath === 'undefined') options.node.useFastPath = true;
  return options;
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/indexed-db.js
/**
 * this method uses indexeddb to store the messages
 * There is currently no observerAPI for idb
 * @link https://github.com/w3c/IndexedDB/issues/51
 * 
 * When working on this, ensure to use these performance optimizations:
 * @link https://rxdb.info/slow-indexeddb.html
 */


var indexed_db_microSeconds = microSeconds;


var DB_PREFIX = 'pubkey.broadcast-channel-0-';
var OBJECT_STORE_ID = 'messages';

/**
 * Use relaxed durability for faster performance on all transactions.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */
var TRANSACTION_SETTINGS = {
  durability: 'relaxed'
};
var indexed_db_type = 'idb';
function getIdb() {
  if (typeof indexedDB !== 'undefined') return indexedDB;
  if (typeof window !== 'undefined') {
    if (typeof window.mozIndexedDB !== 'undefined') return window.mozIndexedDB;
    if (typeof window.webkitIndexedDB !== 'undefined') return window.webkitIndexedDB;
    if (typeof window.msIndexedDB !== 'undefined') return window.msIndexedDB;
  }
  return false;
}

/**
 * If possible, we should explicitly commit IndexedDB transactions
 * for better performance.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */
function commitIndexedDBTransaction(tx) {
  if (tx.commit) {
    tx.commit();
  }
}
function createDatabase(channelName) {
  var IndexedDB = getIdb();

  // create table
  var dbName = DB_PREFIX + channelName;

  /**
   * All IndexedDB databases are opened without version
   * because it is a bit faster, especially on firefox
   * @link http://nparashuram.com/IndexedDB/perf/#Open%20Database%20with%20version
   */
  var openRequest = IndexedDB.open(dbName);
  openRequest.onupgradeneeded = function (ev) {
    var db = ev.target.result;
    db.createObjectStore(OBJECT_STORE_ID, {
      keyPath: 'id',
      autoIncrement: true
    });
  };
  return new Promise(function (res, rej) {
    openRequest.onerror = function (ev) {
      return rej(ev);
    };
    openRequest.onsuccess = function () {
      res(openRequest.result);
    };
  });
}

/**
 * writes the new message to the database
 * so other readers can find it
 */
function writeMessage(db, readerUuid, messageJson) {
  var time = Date.now();
  var writeObject = {
    uuid: readerUuid,
    time: time,
    data: messageJson
  };
  var tx = db.transaction([OBJECT_STORE_ID], 'readwrite', TRANSACTION_SETTINGS);
  return new Promise(function (res, rej) {
    tx.oncomplete = function () {
      return res();
    };
    tx.onerror = function (ev) {
      return rej(ev);
    };
    var objectStore = tx.objectStore(OBJECT_STORE_ID);
    objectStore.add(writeObject);
    commitIndexedDBTransaction(tx);
  });
}
function getAllMessages(db) {
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  return new Promise(function (res) {
    objectStore.openCursor().onsuccess = function (ev) {
      var cursor = ev.target.result;
      if (cursor) {
        ret.push(cursor.value);
        //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
        cursor["continue"]();
      } else {
        commitIndexedDBTransaction(tx);
        res(ret);
      }
    };
  });
}
function getMessagesHigherThan(db, lastCursorId) {
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  var keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);

  /**
   * Optimization shortcut,
   * if getAll() can be used, do not use a cursor.
   * @link https://rxdb.info/slow-indexeddb.html
   */
  if (objectStore.getAll) {
    var getAllRequest = objectStore.getAll(keyRangeValue);
    return new Promise(function (res, rej) {
      getAllRequest.onerror = function (err) {
        return rej(err);
      };
      getAllRequest.onsuccess = function (e) {
        res(e.target.result);
      };
    });
  }
  function openCursor() {
    // Occasionally Safari will fail on IDBKeyRange.bound, this
    // catches that error, having it open the cursor to the first
    // item. When it gets data it will advance to the desired key.
    try {
      keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
      return objectStore.openCursor(keyRangeValue);
    } catch (e) {
      return objectStore.openCursor();
    }
  }
  return new Promise(function (res, rej) {
    var openCursorRequest = openCursor();
    openCursorRequest.onerror = function (err) {
      return rej(err);
    };
    openCursorRequest.onsuccess = function (ev) {
      var cursor = ev.target.result;
      if (cursor) {
        if (cursor.value.id < lastCursorId + 1) {
          cursor["continue"](lastCursorId + 1);
        } else {
          ret.push(cursor.value);
          cursor["continue"]();
        }
      } else {
        commitIndexedDBTransaction(tx);
        res(ret);
      }
    };
  });
}
function removeMessagesById(channelState, ids) {
  if (channelState.closed) {
    return Promise.resolve([]);
  }
  var tx = channelState.db.transaction(OBJECT_STORE_ID, 'readwrite', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  return Promise.all(ids.map(function (id) {
    var deleteRequest = objectStore["delete"](id);
    return new Promise(function (res) {
      deleteRequest.onsuccess = function () {
        return res();
      };
    });
  }));
}
function getOldMessages(db, ttl) {
  var olderThen = Date.now() - ttl;
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  return new Promise(function (res) {
    objectStore.openCursor().onsuccess = function (ev) {
      var cursor = ev.target.result;
      if (cursor) {
        var msgObk = cursor.value;
        if (msgObk.time < olderThen) {
          ret.push(msgObk);
          //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
          cursor["continue"]();
        } else {
          // no more old messages,
          commitIndexedDBTransaction(tx);
          res(ret);
        }
      } else {
        res(ret);
      }
    };
  });
}
function cleanOldMessages(channelState) {
  return getOldMessages(channelState.db, channelState.options.idb.ttl).then(function (tooOld) {
    return removeMessagesById(channelState, tooOld.map(function (msg) {
      return msg.id;
    }));
  });
}
function indexed_db_create(channelName, options) {
  options = options_fillOptionsWithDefaults(options);
  return createDatabase(channelName).then(function (db) {
    var state = {
      closed: false,
      lastCursorId: 0,
      channelName: channelName,
      options: options,
      uuid: randomToken(),
      /**
       * emittedMessagesIds
       * contains all messages that have been emitted before
       * @type {ObliviousSet}
       */
      eMIs: new ObliviousSet(options.idb.ttl * 2),
      // ensures we do not read messages in parallel
      writeBlockPromise: PROMISE_RESOLVED_VOID,
      messagesCallback: null,
      readQueuePromises: [],
      db: db
    };

    /**
     * Handle abrupt closes that do not originate from db.close().
     * This could happen, for example, if the underlying storage is
     * removed or if the user clears the database in the browser's
     * history preferences.
     */
    db.onclose = function () {
      state.closed = true;
      if (options.idb.onclose) options.idb.onclose();
    };

    /**
     * if service-workers are used,
     * we have no 'storage'-event if they post a message,
     * therefore we also have to set an interval
     */
    _readLoop(state);
    return state;
  });
}
function _readLoop(state) {
  if (state.closed) return;
  readNewMessages(state).then(function () {
    return sleep(state.options.idb.fallbackInterval);
  }).then(function () {
    return _readLoop(state);
  });
}
function _filterMessage(msgObj, state) {
  if (msgObj.uuid === state.uuid) return false; // send by own
  if (state.eMIs.has(msgObj.id)) return false; // already emitted
  if (msgObj.data.time < state.messagesCallbackTime) return false; // older then onMessageCallback
  return true;
}

/**
 * reads all new messages from the database and emits them
 */
function readNewMessages(state) {
  // channel already closed
  if (state.closed) return PROMISE_RESOLVED_VOID;

  // if no one is listening, we do not need to scan for new messages
  if (!state.messagesCallback) return PROMISE_RESOLVED_VOID;
  return getMessagesHigherThan(state.db, state.lastCursorId).then(function (newerMessages) {
    var useMessages = newerMessages
    /**
     * there is a bug in iOS where the msgObj can be undefined sometimes
     * so we filter them out
     * @link https://github.com/pubkey/broadcast-channel/issues/19
     */.filter(function (msgObj) {
      return !!msgObj;
    }).map(function (msgObj) {
      if (msgObj.id > state.lastCursorId) {
        state.lastCursorId = msgObj.id;
      }
      return msgObj;
    }).filter(function (msgObj) {
      return _filterMessage(msgObj, state);
    }).sort(function (msgObjA, msgObjB) {
      return msgObjA.time - msgObjB.time;
    }); // sort by time
    useMessages.forEach(function (msgObj) {
      if (state.messagesCallback) {
        state.eMIs.add(msgObj.id);
        state.messagesCallback(msgObj.data);
      }
    });
    return PROMISE_RESOLVED_VOID;
  });
}
function indexed_db_close(channelState) {
  channelState.closed = true;
  channelState.db.close();
}
function indexed_db_postMessage(channelState, messageJson) {
  channelState.writeBlockPromise = channelState.writeBlockPromise.then(function () {
    return writeMessage(channelState.db, channelState.uuid, messageJson);
  }).then(function () {
    if (randomInt(0, 10) === 0) {
      /* await (do not await) */
      cleanOldMessages(channelState);
    }
  });
  return channelState.writeBlockPromise;
}
function indexed_db_onMessage(channelState, fn, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn;
  readNewMessages(channelState);
}
function indexed_db_canBeUsed() {
  return !!getIdb();
}
function indexed_db_averageResponseTime(options) {
  return options.idb.fallbackInterval * 2;
}
var IndexedDBMethod = {
  create: indexed_db_create,
  close: indexed_db_close,
  onMessage: indexed_db_onMessage,
  postMessage: indexed_db_postMessage,
  canBeUsed: indexed_db_canBeUsed,
  type: indexed_db_type,
  averageResponseTime: indexed_db_averageResponseTime,
  microSeconds: indexed_db_microSeconds
};
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/localstorage.js
/**
 * A localStorage-only method which uses localstorage and its 'storage'-event
 * This does not work inside webworkers because they have no access to localstorage
 * This is basically implemented to support IE9 or your grandmother's toaster.
 * @link https://caniuse.com/#feat=namevalue-storage
 * @link https://caniuse.com/#feat=indexeddb
 */




var localstorage_microSeconds = microSeconds;
var KEY_PREFIX = 'pubkey.broadcastChannel-';
var localstorage_type = 'localstorage';

/**
 * copied from crosstab
 * @link https://github.com/tejacques/crosstab/blob/master/src/crosstab.js#L32
 */
function getLocalStorage() {
  var localStorage;
  if (typeof window === 'undefined') return null;
  try {
    localStorage = window.localStorage;
    localStorage = window['ie8-eventlistener/storage'] || window.localStorage;
  } catch (e) {
    // New versions of Firefox throw a Security exception
    // if cookies are disabled. See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1028153
  }
  return localStorage;
}
function storageKey(channelName) {
  return KEY_PREFIX + channelName;
}

/**
* writes the new message to the storage
* and fires the storage-event so other readers can find it
*/
function localstorage_postMessage(channelState, messageJson) {
  return new Promise(function (res) {
    sleep().then(function () {
      var key = storageKey(channelState.channelName);
      var writeObj = {
        token: randomToken(),
        time: Date.now(),
        data: messageJson,
        uuid: channelState.uuid
      };
      var value = JSON.stringify(writeObj);
      getLocalStorage().setItem(key, value);

      /**
       * StorageEvent does not fire the 'storage' event
       * in the window that changes the state of the local storage.
       * So we fire it manually
       */
      var ev = document.createEvent('Event');
      ev.initEvent('storage', true, true);
      ev.key = key;
      ev.newValue = value;
      window.dispatchEvent(ev);
      res();
    });
  });
}
function addStorageEventListener(channelName, fn) {
  var key = storageKey(channelName);
  var listener = function listener(ev) {
    if (ev.key === key) {
      fn(JSON.parse(ev.newValue));
    }
  };
  window.addEventListener('storage', listener);
  return listener;
}
function removeStorageEventListener(listener) {
  window.removeEventListener('storage', listener);
}
function localstorage_create(channelName, options) {
  options = options_fillOptionsWithDefaults(options);
  if (!localstorage_canBeUsed()) {
    throw new Error('BroadcastChannel: localstorage cannot be used');
  }
  var uuid = randomToken();

  /**
   * eMIs
   * contains all messages that have been emitted before
   * @type {ObliviousSet}
   */
  var eMIs = new ObliviousSet(options.localstorage.removeTimeout);
  var state = {
    channelName: channelName,
    uuid: uuid,
    eMIs: eMIs // emittedMessagesIds
  };
  state.listener = addStorageEventListener(channelName, function (msgObj) {
    if (!state.messagesCallback) return; // no listener
    if (msgObj.uuid === uuid) return; // own message
    if (!msgObj.token || eMIs.has(msgObj.token)) return; // already emitted
    if (msgObj.data.time && msgObj.data.time < state.messagesCallbackTime) return; // too old

    eMIs.add(msgObj.token);
    state.messagesCallback(msgObj.data);
  });
  return state;
}
function localstorage_close(channelState) {
  removeStorageEventListener(channelState.listener);
}
function localstorage_onMessage(channelState, fn, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn;
}
function localstorage_canBeUsed() {
  var ls = getLocalStorage();
  if (!ls) return false;
  try {
    var key = '__broadcastchannel_check';
    ls.setItem(key, 'works');
    ls.removeItem(key);
  } catch (e) {
    // Safari 10 in private mode will not allow write access to local
    // storage and fail with a QuotaExceededError. See
    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API#Private_Browsing_Incognito_modes
    return false;
  }
  return true;
}
function localstorage_averageResponseTime() {
  var defaultTime = 120;
  var userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    // safari is much slower so this time is higher
    return defaultTime * 2;
  }
  return defaultTime;
}
var LocalstorageMethod = {
  create: localstorage_create,
  close: localstorage_close,
  onMessage: localstorage_onMessage,
  postMessage: localstorage_postMessage,
  canBeUsed: localstorage_canBeUsed,
  type: localstorage_type,
  averageResponseTime: localstorage_averageResponseTime,
  microSeconds: localstorage_microSeconds
};
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/simulate.js

var simulate_microSeconds = microSeconds;
var simulate_type = 'simulate';
var SIMULATE_CHANNELS = new Set();
function simulate_create(channelName) {
  var state = {
    time: simulate_microSeconds(),
    name: channelName,
    messagesCallback: null
  };
  SIMULATE_CHANNELS.add(state);
  return state;
}
function simulate_close(channelState) {
  SIMULATE_CHANNELS["delete"](channelState);
}
var SIMULATE_DELAY_TIME = 5;
function simulate_postMessage(channelState, messageJson) {
  return new Promise(function (res) {
    return setTimeout(function () {
      var channelArray = Array.from(SIMULATE_CHANNELS);
      channelArray.forEach(function (channel) {
        if (channel.name === channelState.name &&
        // has same name
        channel !== channelState &&
        // not own channel
        !!channel.messagesCallback &&
        // has subscribers
        channel.time < messageJson.time // channel not created after postMessage() call
        ) {
          channel.messagesCallback(messageJson);
        }
      });
      res();
    }, SIMULATE_DELAY_TIME);
  });
}
function simulate_onMessage(channelState, fn) {
  channelState.messagesCallback = fn;
}
function simulate_canBeUsed() {
  return true;
}
function simulate_averageResponseTime() {
  return SIMULATE_DELAY_TIME;
}
var SimulateMethod = {
  create: simulate_create,
  close: simulate_close,
  onMessage: simulate_onMessage,
  postMessage: simulate_postMessage,
  canBeUsed: simulate_canBeUsed,
  type: simulate_type,
  averageResponseTime: simulate_averageResponseTime,
  microSeconds: simulate_microSeconds
};
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/method-chooser.js




// the line below will be removed from es5/browser builds

// order is important
var METHODS = [NativeMethod,
// fastest
IndexedDBMethod, LocalstorageMethod];
function method_chooser_chooseMethod(options) {
  var chooseMethods = [].concat(options.methods, METHODS).filter(Boolean);

  // the line below will be removed from es5/browser builds

  // directly chosen
  if (options.type) {
    if (options.type === 'simulate') {
      // only use simulate-method if directly chosen
      return SimulateMethod;
    }
    var ret = chooseMethods.find(function (m) {
      return m.type === options.type;
    });
    if (!ret) throw new Error('method-type ' + options.type + ' not found');else return ret;
  }

  /**
   * if no webworker support is needed,
   * remove idb from the list so that localstorage will be chosen
   */
  if (!options.webWorkerSupport) {
    chooseMethods = chooseMethods.filter(function (m) {
      return m.type !== 'idb';
    });
  }
  var useMethod = chooseMethods.find(function (method) {
    return method.canBeUsed();
  });
  if (!useMethod) {
    throw new Error("No usable method found in " + JSON.stringify(METHODS.map(function (m) {
      return m.type;
    })));
  } else {
    return useMethod;
  }
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/broadcast-channel.js




/**
 * Contains all open channels,
 * used in tests to ensure everything is closed.
 */
var OPEN_BROADCAST_CHANNELS = new Set();
var lastId = 0;
var broadcast_channel_BroadcastChannel = function BroadcastChannel(name, options) {
  // identifier of the channel to debug stuff
  this.id = lastId++;
  OPEN_BROADCAST_CHANNELS.add(this);
  this.name = name;
  if (ENFORCED_OPTIONS) {
    options = ENFORCED_OPTIONS;
  }
  this.options = options_fillOptionsWithDefaults(options);
  this.method = method_chooser_chooseMethod(this.options);

  // isListening
  this._iL = false;

  /**
   * _onMessageListener
   * setting onmessage twice,
   * will overwrite the first listener
   */
  this._onML = null;

  /**
   * _addEventListeners
   */
  this._addEL = {
    message: [],
    internal: []
  };

  /**
   * Unsent message promises
   * where the sending is still in progress
   * @type {Set<Promise>}
   */
  this._uMP = new Set();

  /**
   * _beforeClose
   * array of promises that will be awaited
   * before the channel is closed
   */
  this._befC = [];

  /**
   * _preparePromise
   */
  this._prepP = null;
  _prepareChannel(this);
};

// STATICS

/**
 * used to identify if someone overwrites
 * window.BroadcastChannel with this
 * See methods/native.js
 */
broadcast_channel_BroadcastChannel._pubkey = true;

/**
 * clears the tmp-folder if is node
 * @return {Promise<boolean>} true if has run, false if not node
 */
function clearNodeFolder(options) {
  options = fillOptionsWithDefaults(options);
  var method = chooseMethod(options);
  if (method.type === 'node') {
    return method.clearNodeFolder().then(function () {
      return true;
    });
  } else {
    return PROMISE_RESOLVED_FALSE;
  }
}

/**
 * if set, this method is enforced,
 * no mather what the options are
 */
var ENFORCED_OPTIONS;
function enforceOptions(options) {
  ENFORCED_OPTIONS = options;
}

// PROTOTYPE
broadcast_channel_BroadcastChannel.prototype = {
  postMessage: function postMessage(msg) {
    if (this.closed) {
      throw new Error('BroadcastChannel.postMessage(): ' + 'Cannot post message after channel has closed ' +
      /**
       * In the past when this error appeared, it was really hard to debug.
       * So now we log the msg together with the error so it at least
       * gives some clue about where in your application this happens.
       */
      JSON.stringify(msg));
    }
    return _post(this, 'message', msg);
  },
  postInternal: function postInternal(msg) {
    return _post(this, 'internal', msg);
  },
  set onmessage(fn) {
    var time = this.method.microSeconds();
    var listenObj = {
      time: time,
      fn: fn
    };
    _removeListenerObject(this, 'message', this._onML);
    if (fn && typeof fn === 'function') {
      this._onML = listenObj;
      _addListenerObject(this, 'message', listenObj);
    } else {
      this._onML = null;
    }
  },
  addEventListener: function addEventListener(type, fn) {
    var time = this.method.microSeconds();
    var listenObj = {
      time: time,
      fn: fn
    };
    _addListenerObject(this, type, listenObj);
  },
  removeEventListener: function removeEventListener(type, fn) {
    var obj = this._addEL[type].find(function (obj) {
      return obj.fn === fn;
    });
    _removeListenerObject(this, type, obj);
  },
  close: function close() {
    var _this = this;
    if (this.closed) {
      return;
    }
    OPEN_BROADCAST_CHANNELS["delete"](this);
    this.closed = true;
    var awaitPrepare = this._prepP ? this._prepP : PROMISE_RESOLVED_VOID;
    this._onML = null;
    this._addEL.message = [];
    return awaitPrepare
    // wait until all current sending are processed
    .then(function () {
      return Promise.all(Array.from(_this._uMP));
    })
    // run before-close hooks
    .then(function () {
      return Promise.all(_this._befC.map(function (fn) {
        return fn();
      }));
    })
    // close the channel
    .then(function () {
      return _this.method.close(_this._state);
    });
  },
  get type() {
    return this.method.type;
  },
  get isClosed() {
    return this.closed;
  }
};

/**
 * Post a message over the channel
 * @returns {Promise} that resolved when the message sending is done
 */
function _post(broadcastChannel, type, msg) {
  var time = broadcastChannel.method.microSeconds();
  var msgObj = {
    time: time,
    type: type,
    data: msg
  };
  var awaitPrepare = broadcastChannel._prepP ? broadcastChannel._prepP : PROMISE_RESOLVED_VOID;
  return awaitPrepare.then(function () {
    var sendPromise = broadcastChannel.method.postMessage(broadcastChannel._state, msgObj);

    // add/remove to unsent messages list
    broadcastChannel._uMP.add(sendPromise);
    sendPromise["catch"]().then(function () {
      return broadcastChannel._uMP["delete"](sendPromise);
    });
    return sendPromise;
  });
}
function _prepareChannel(channel) {
  var maybePromise = channel.method.create(channel.name, channel.options);
  if (util_isPromise(maybePromise)) {
    channel._prepP = maybePromise;
    maybePromise.then(function (s) {
      // used in tests to simulate slow runtime
      /*if (channel.options.prepareDelay) {
           await new Promise(res => setTimeout(res, this.options.prepareDelay));
      }*/
      channel._state = s;
    });
  } else {
    channel._state = maybePromise;
  }
}
function _hasMessageListeners(channel) {
  if (channel._addEL.message.length > 0) return true;
  if (channel._addEL.internal.length > 0) return true;
  return false;
}
function _addListenerObject(channel, type, obj) {
  channel._addEL[type].push(obj);
  _startListening(channel);
}
function _removeListenerObject(channel, type, obj) {
  channel._addEL[type] = channel._addEL[type].filter(function (o) {
    return o !== obj;
  });
  _stopListening(channel);
}
function _startListening(channel) {
  if (!channel._iL && _hasMessageListeners(channel)) {
    // someone is listening, start subscribing

    var listenerFn = function listenerFn(msgObj) {
      channel._addEL[msgObj.type].forEach(function (listenerObject) {
        if (msgObj.time >= listenerObject.time) {
          listenerObject.fn(msgObj.data);
        }
      });
    };
    var time = channel.method.microSeconds();
    if (channel._prepP) {
      channel._prepP.then(function () {
        channel._iL = true;
        channel.method.onMessage(channel._state, listenerFn, time);
      });
    } else {
      channel._iL = true;
      channel.method.onMessage(channel._state, listenerFn, time);
    }
  }
}
function _stopListening(channel) {
  if (channel._iL && !_hasMessageListeners(channel)) {
    // no one is listening, stop subscribing
    channel._iL = false;
    var time = channel.method.microSeconds();
    channel.method.onMessage(channel._state, null, time);
  }
}
;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/services/SyncStorageService.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








class SyncStorageService {
    constructor(tokenManager, options = {}) {
        this.started = false;
        this.enablePostMessage = true;
        this.tokenManager = tokenManager;
        this.options = options;
        this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this);
        this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this);
        this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this);
        this.onSetStorageHandler = this.onSetStorageHandler.bind(this);
        this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this);
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
    canStart() {
        return !!this.options.syncStorage && isBrowser() && !this.started;
    }
    async start() {
        if (!this.canStart()) {
            return;
        }
        const { syncChannelName } = this.options;
        try {
            this.channel = new broadcast_channel_BroadcastChannel(syncChannelName);
        }
        catch (err) {
            throw new AuthSdkError('SyncStorageService is not supported in current browser.');
        }
        this.tokenManager.on(EVENT_ADDED, this.onTokenAddedHandler);
        this.tokenManager.on(EVENT_REMOVED, this.onTokenRemovedHandler);
        this.tokenManager.on(EVENT_RENEWED, this.onTokenRenewedHandler);
        this.tokenManager.on(EVENT_SET_STORAGE, this.onSetStorageHandler);
        this.channel.addEventListener('message', this.onSyncMessageHandler);
        this.started = true;
    }
    async stop() {
        var _a, _b;
        if (this.started) {
            this.tokenManager.off(EVENT_ADDED, this.onTokenAddedHandler);
            this.tokenManager.off(EVENT_REMOVED, this.onTokenRemovedHandler);
            this.tokenManager.off(EVENT_RENEWED, this.onTokenRenewedHandler);
            this.tokenManager.off(EVENT_SET_STORAGE, this.onSetStorageHandler);
            (_a = this.channel) === null || _a === void 0 ? void 0 : _a.removeEventListener('message', this.onSyncMessageHandler);
            await ((_b = this.channel) === null || _b === void 0 ? void 0 : _b.close());
            this.channel = undefined;
            this.started = false;
        }
    }
    onTokenAddedHandler(key, token) {
        var _a;
        if (!this.enablePostMessage) {
            return;
        }
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_ADDED,
            key,
            token
        });
    }
    onTokenRemovedHandler(key, token) {
        var _a;
        if (!this.enablePostMessage) {
            return;
        }
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_REMOVED,
            key,
            token
        });
    }
    onTokenRenewedHandler(key, token, oldToken) {
        var _a;
        if (!this.enablePostMessage) {
            return;
        }
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_RENEWED,
            key,
            token,
            oldToken
        });
    }
    onSetStorageHandler(storage) {
        var _a;
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_SET_STORAGE,
            storage
        });
    }
    onSyncMessageHandler(msg) {
        this.enablePostMessage = false;
        switch (msg.type) {
            case EVENT_SET_STORAGE:
                this.tokenManager.getStorage().setStorage(msg.storage);
                break;
            case EVENT_ADDED:
                this.tokenManager.emitAdded(msg.key, msg.token);
                this.tokenManager.setExpireEventTimeout(msg.key, msg.token);
                break;
            case EVENT_REMOVED:
                this.tokenManager.clearExpireEventTimeout(msg.key);
                this.tokenManager.emitRemoved(msg.key, msg.token);
                break;
            case EVENT_RENEWED:
                this.tokenManager.emitRenewed(msg.key, msg.token, msg.oldToken);
                break;
        }
        this.enablePostMessage = true;
    }
}


//# sourceMappingURL=SyncStorageService.js.map

;// CONCATENATED MODULE: ./node_modules/unload/dist/es/browser.js
/* global WorkerGlobalScope */

function addBrowser(fn) {
  if (typeof WorkerGlobalScope === 'function' && self instanceof WorkerGlobalScope) {
    /**
     * Because killing a worker does directly stop the excution
     * of the code, our only chance is to overwrite the close function
     * which could work some times.
     * @link https://stackoverflow.com/q/72903255/3443137
     */
    var oldClose = self.close.bind(self);
    self.close = function () {
      fn();
      return oldClose();
    };
  } else {
    /**
     * if we are on react-native, there is no window.addEventListener
     * @link https://github.com/pubkey/unload/issues/6
     */
    if (typeof window.addEventListener !== 'function') {
      return;
    }

    /**
     * for normal browser-windows, we use the beforeunload-event
     */
    window.addEventListener('beforeunload', function () {
      fn();
    }, true);

    /**
     * for iframes, we have to use the unload-event
     * @link https://stackoverflow.com/q/47533670/3443137
     */
    window.addEventListener('unload', function () {
      fn();
    }, true);
  }

  /**
   * TODO add fallback for safari-mobile
   * @link https://stackoverflow.com/a/26193516/3443137
   */
}
;// CONCATENATED MODULE: ./node_modules/unload/dist/es/node.js
/* provided dependency */ var node_process = __webpack_require__(83454);
function addNode(fn) {
  node_process.on('exit', function () {
    return fn();
  });

  /**
   * on the following events,
   * the process will not end if there are
   * event-handlers attached,
   * therefore we have to call process.exit()
   */
  node_process.on('beforeExit', function () {
    return fn().then(function () {
      return node_process.exit();
    });
  });
  // catches ctrl+c event
  node_process.on('SIGINT', function () {
    return fn().then(function () {
      return node_process.exit();
    });
  });
  // catches uncaught exceptions
  node_process.on('uncaughtException', function (err) {
    return fn().then(function () {
      console.trace(err);
      node_process.exit(101);
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/unload/dist/es/index.js
/* provided dependency */ var es_process = __webpack_require__(83454);



/**
 * Use the code directly to prevent import problems
 * with the detect-node package.
 * @link https://github.com/iliakan/detect-node/blob/master/index.js
 */
var isNode = Object.prototype.toString.call(typeof es_process !== 'undefined' ? es_process : 0) === '[object process]';
var USE_METHOD = isNode ? addNode : addBrowser;
var LISTENERS = new Set();
var startedListening = false;
function startListening() {
  if (startedListening) {
    return;
  }
  startedListening = true;
  USE_METHOD(runAll);
}
function add(fn) {
  startListening();
  if (typeof fn !== 'function') {
    throw new Error('Listener is no function');
  }
  LISTENERS.add(fn);
  var addReturn = {
    remove: function remove() {
      return LISTENERS["delete"](fn);
    },
    run: function run() {
      LISTENERS["delete"](fn);
      return fn();
    }
  };
  return addReturn;
}
function runAll() {
  var promises = [];
  LISTENERS.forEach(function (fn) {
    promises.push(fn());
    LISTENERS["delete"](fn);
  });
  return Promise.all(promises);
}
function removeAll() {
  LISTENERS.clear();
}
function getSize() {
  return LISTENERS.size;
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/leader-election-util.js


/**
 * sends and internal message over the broadcast-channel
 */
function sendLeaderMessage(leaderElector, action) {
  var msgJson = {
    context: 'leader',
    action: action,
    token: leaderElector.token
  };
  return leaderElector.broadcastChannel.postInternal(msgJson);
}
function beLeader(leaderElector) {
  leaderElector.isLeader = true;
  leaderElector._hasLeader = true;
  var unloadFn = add(function () {
    return leaderElector.die();
  });
  leaderElector._unl.push(unloadFn);
  var isLeaderListener = function isLeaderListener(msg) {
    if (msg.context === 'leader' && msg.action === 'apply') {
      sendLeaderMessage(leaderElector, 'tell');
    }
    if (msg.context === 'leader' && msg.action === 'tell' && !leaderElector._dpLC) {
      /**
       * another instance is also leader!
       * This can happen on rare events
       * like when the CPU is at 100% for long time
       * or the tabs are open very long and the browser throttles them.
       * @link https://github.com/pubkey/broadcast-channel/issues/414
       * @link https://github.com/pubkey/broadcast-channel/issues/385
       */
      leaderElector._dpLC = true;
      leaderElector._dpL(); // message the lib user so the app can handle the problem
      sendLeaderMessage(leaderElector, 'tell'); // ensure other leader also knows the problem
    }
  };
  leaderElector.broadcastChannel.addEventListener('internal', isLeaderListener);
  leaderElector._lstns.push(isLeaderListener);
  return sendLeaderMessage(leaderElector, 'tell');
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/leader-election-web-lock.js



/**
 * A faster version of the leader elector that uses the WebLock API
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Locks_API
 */
var LeaderElectionWebLock = function LeaderElectionWebLock(broadcastChannel, options) {
  var _this = this;
  this.broadcastChannel = broadcastChannel;
  broadcastChannel._befC.push(function () {
    return _this.die();
  });
  this._options = options;
  this.isLeader = false;
  this.isDead = false;
  this.token = randomToken();
  this._lstns = [];
  this._unl = [];
  this._dpL = function () {}; // onduplicate listener
  this._dpLC = false; // true when onduplicate called

  this._wKMC = {}; // stuff for cleanup

  // lock name
  this.lN = 'pubkey-bc||' + broadcastChannel.method.type + '||' + broadcastChannel.name;
};
LeaderElectionWebLock.prototype = {
  hasLeader: function hasLeader() {
    var _this2 = this;
    return navigator.locks.query().then(function (locks) {
      var relevantLocks = locks.held ? locks.held.filter(function (lock) {
        return lock.name === _this2.lN;
      }) : [];
      if (relevantLocks && relevantLocks.length > 0) {
        return true;
      } else {
        return false;
      }
    });
  },
  awaitLeadership: function awaitLeadership() {
    var _this3 = this;
    if (!this._wLMP) {
      this._wKMC.c = new AbortController();
      var returnPromise = new Promise(function (res, rej) {
        _this3._wKMC.res = res;
        _this3._wKMC.rej = rej;
      });
      this._wLMP = new Promise(function (res) {
        navigator.locks.request(_this3.lN, {
          signal: _this3._wKMC.c.signal
        }, function () {
          // if the lock resolved, we can drop the abort controller
          _this3._wKMC.c = undefined;
          beLeader(_this3);
          res();
          return returnPromise;
        })["catch"](function () {});
      });
    }
    return this._wLMP;
  },
  set onduplicate(_fn) {
    // Do nothing because there are no duplicates in the WebLock version
  },
  die: function die() {
    var _this4 = this;
    this._lstns.forEach(function (listener) {
      return _this4.broadcastChannel.removeEventListener('internal', listener);
    });
    this._lstns = [];
    this._unl.forEach(function (uFn) {
      return uFn.remove();
    });
    this._unl = [];
    if (this.isLeader) {
      this.isLeader = false;
    }
    this.isDead = true;
    if (this._wKMC.res) {
      this._wKMC.res();
    }
    if (this._wKMC.c) {
      this._wKMC.c.abort('LeaderElectionWebLock.die() called');
    }
    return sendLeaderMessage(this, 'death');
  }
};
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/leader-election.js



var LeaderElection = function LeaderElection(broadcastChannel, options) {
  var _this = this;
  this.broadcastChannel = broadcastChannel;
  this._options = options;
  this.isLeader = false;
  this._hasLeader = false;
  this.isDead = false;
  this.token = randomToken();

  /**
   * Apply Queue,
   * used to ensure we do not run applyOnce()
   * in parallel.
   */
  this._aplQ = PROMISE_RESOLVED_VOID;
  // amount of unfinished applyOnce() calls
  this._aplQC = 0;

  // things to clean up
  this._unl = []; // _unloads
  this._lstns = []; // _listeners
  this._dpL = function () {}; // onduplicate listener
  this._dpLC = false; // true when onduplicate called

  /**
   * Even when the own instance is not applying,
   * we still listen to messages to ensure the hasLeader flag
   * is set correctly.
   */
  var hasLeaderListener = function hasLeaderListener(msg) {
    if (msg.context === 'leader') {
      if (msg.action === 'death') {
        _this._hasLeader = false;
      }
      if (msg.action === 'tell') {
        _this._hasLeader = true;
      }
    }
  };
  this.broadcastChannel.addEventListener('internal', hasLeaderListener);
  this._lstns.push(hasLeaderListener);
};
LeaderElection.prototype = {
  hasLeader: function hasLeader() {
    return Promise.resolve(this._hasLeader);
  },
  /**
   * Returns true if the instance is leader,
   * false if not.
   * @async
   */
  applyOnce: function applyOnce(
  // true if the applyOnce() call came from the fallbackInterval cycle
  isFromFallbackInterval) {
    var _this2 = this;
    if (this.isLeader) {
      return sleep(0, true);
    }
    if (this.isDead) {
      return sleep(0, false);
    }

    /**
     * Already applying more than once,
     * -> wait for the apply queue to be finished.
     */
    if (this._aplQC > 1) {
      return this._aplQ;
    }

    /**
     * Add a new apply-run
     */
    var applyRun = function applyRun() {
      /**
       * Optimization shortcuts.
       * Directly return if a previous run
       * has already elected a leader.
       */
      if (_this2.isLeader) {
        return PROMISE_RESOLVED_TRUE;
      }
      var stopCriteria = false;
      var stopCriteriaPromiseResolve;
      /**
       * Resolves when a stop criteria is reached.
       * Uses as a performance shortcut so we do not
       * have to await the responseTime when it is already clear
       * that the election failed.
       */
      var stopCriteriaPromise = new Promise(function (res) {
        stopCriteriaPromiseResolve = function stopCriteriaPromiseResolve() {
          stopCriteria = true;
          res();
        };
      });
      var handleMessage = function handleMessage(msg) {
        if (msg.context === 'leader' && msg.token != _this2.token) {
          if (msg.action === 'apply') {
            // other is applying
            if (msg.token > _this2.token) {
              /**
               * other has higher token
               * -> stop applying and let other become leader.
               */
              stopCriteriaPromiseResolve();
            }
          }
          if (msg.action === 'tell') {
            // other is already leader
            stopCriteriaPromiseResolve();
            _this2._hasLeader = true;
          }
        }
      };
      _this2.broadcastChannel.addEventListener('internal', handleMessage);

      /**
       * If the applyOnce() call came from the fallbackInterval,
       * we can assume that the election runs in the background and
       * not critical process is waiting for it.
       * When this is true, we give the other instances
       * more time to answer to messages in the election cycle.
       * This makes it less likely to elect duplicate leaders.
       * But also it takes longer which is not a problem because we anyway
       * run in the background.
       */
      var waitForAnswerTime = isFromFallbackInterval ? _this2._options.responseTime * 4 : _this2._options.responseTime;
      return sendLeaderMessage(_this2, 'apply') // send out that this one is applying
      .then(function () {
        return Promise.race([sleep(waitForAnswerTime), stopCriteriaPromise.then(function () {
          return Promise.reject(new Error());
        })]);
      })
      // send again in case another instance was just created
      .then(function () {
        return sendLeaderMessage(_this2, 'apply');
      })
      // let others time to respond
      .then(function () {
        return Promise.race([sleep(waitForAnswerTime), stopCriteriaPromise.then(function () {
          return Promise.reject(new Error());
        })]);
      })["catch"](function () {}).then(function () {
        _this2.broadcastChannel.removeEventListener('internal', handleMessage);
        if (!stopCriteria) {
          // no stop criteria -> own is leader
          return beLeader(_this2).then(function () {
            return true;
          });
        } else {
          // other is leader
          return false;
        }
      });
    };
    this._aplQC = this._aplQC + 1;
    this._aplQ = this._aplQ.then(function () {
      return applyRun();
    }).then(function () {
      _this2._aplQC = _this2._aplQC - 1;
    });
    return this._aplQ.then(function () {
      return _this2.isLeader;
    });
  },
  awaitLeadership: function awaitLeadership() {
    if (/* _awaitLeadershipPromise */
    !this._aLP) {
      this._aLP = _awaitLeadershipOnce(this);
    }
    return this._aLP;
  },
  set onduplicate(fn) {
    this._dpL = fn;
  },
  die: function die() {
    var _this3 = this;
    this._lstns.forEach(function (listener) {
      return _this3.broadcastChannel.removeEventListener('internal', listener);
    });
    this._lstns = [];
    this._unl.forEach(function (uFn) {
      return uFn.remove();
    });
    this._unl = [];
    if (this.isLeader) {
      this._hasLeader = false;
      this.isLeader = false;
    }
    this.isDead = true;
    return sendLeaderMessage(this, 'death');
  }
};

/**
 * @param leaderElector {LeaderElector}
 */
function _awaitLeadershipOnce(leaderElector) {
  if (leaderElector.isLeader) {
    return PROMISE_RESOLVED_VOID;
  }
  return new Promise(function (res) {
    var resolved = false;
    function finish() {
      if (resolved) {
        return;
      }
      resolved = true;
      leaderElector.broadcastChannel.removeEventListener('internal', whenDeathListener);
      res(true);
    }

    // try once now
    leaderElector.applyOnce().then(function () {
      if (leaderElector.isLeader) {
        finish();
      }
    });

    /**
     * Try on fallbackInterval
     * @recursive
     */
    var _tryOnFallBack = function tryOnFallBack() {
      return sleep(leaderElector._options.fallbackInterval).then(function () {
        if (leaderElector.isDead || resolved) {
          return;
        }
        if (leaderElector.isLeader) {
          finish();
        } else {
          return leaderElector.applyOnce(true).then(function () {
            if (leaderElector.isLeader) {
              finish();
            } else {
              _tryOnFallBack();
            }
          });
        }
      });
    };
    _tryOnFallBack();

    // try when other leader dies
    var whenDeathListener = function whenDeathListener(msg) {
      if (msg.context === 'leader' && msg.action === 'death') {
        leaderElector._hasLeader = false;
        leaderElector.applyOnce().then(function () {
          if (leaderElector.isLeader) {
            finish();
          }
        });
      }
    };
    leaderElector.broadcastChannel.addEventListener('internal', whenDeathListener);
    leaderElector._lstns.push(whenDeathListener);
  });
}
function leader_election_fillOptionsWithDefaults(options, channel) {
  if (!options) options = {};
  options = JSON.parse(JSON.stringify(options));
  if (!options.fallbackInterval) {
    options.fallbackInterval = 3000;
  }
  if (!options.responseTime) {
    options.responseTime = channel.method.averageResponseTime(channel.options);
  }
  return options;
}
function createLeaderElection(channel, options) {
  if (channel._leaderElector) {
    throw new Error('BroadcastChannel already has a leader-elector');
  }
  options = leader_election_fillOptionsWithDefaults(options, channel);
  var elector = supportsWebLockAPI() ? new LeaderElectionWebLock(channel, options) : new LeaderElection(channel, options);
  channel._befC.push(function () {
    return elector.die();
  });
  channel._leaderElector = elector;
  return elector;
}
;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/services/LeaderElectionService.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class LeaderElectionService {
    constructor(options = {}) {
        this.started = false;
        this.options = options;
        this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this);
        this.onLeader = this.onLeader.bind(this);
    }
    onLeaderDuplicate() {
    }
    async onLeader() {
        var _a, _b;
        await ((_b = (_a = this.options).onLeader) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    isLeader() {
        var _a;
        return !!((_a = this.elector) === null || _a === void 0 ? void 0 : _a.isLeader);
    }
    hasLeader() {
        var _a;
        return !!((_a = this.elector) === null || _a === void 0 ? void 0 : _a.hasLeader);
    }
    async start() {
        if (this.canStart()) {
            const { electionChannelName } = this.options;
            this.channel = new broadcast_channel_BroadcastChannel(electionChannelName);
            this.elector = createLeaderElection(this.channel);
            this.elector.onduplicate = this.onLeaderDuplicate;
            this.elector.awaitLeadership().then(this.onLeader);
            this.started = true;
        }
    }
    async stop() {
        if (this.started) {
            if (this.elector) {
                await this.elector.die();
                this.elector = undefined;
            }
            if (this.channel) {
                this.channel.postInternal = () => Promise.resolve();
                await this.channel.close();
                this.channel = undefined;
            }
            this.started = false;
        }
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
    canStart() {
        return isBrowser() && !this.started;
    }
}


//# sourceMappingURL=LeaderElectionService.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/services/RenewOnTabActivationService.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const getNow = () => Math.floor(Date.now() / 1000);
class RenewOnTabActivationService {
    constructor(tokenManager, options = {}) {
        this.started = false;
        this.lastHidden = -1;
        this.tokenManager = tokenManager;
        this.options = options;
        this.onPageVisbilityChange = this._onPageVisbilityChange.bind(this);
    }
    _onPageVisbilityChange() {
        if (document.hidden) {
            this.lastHidden = getNow();
        }
        else if (this.lastHidden > 0 && (getNow() - this.lastHidden >= this.options.tabInactivityDuration)) {
            const { accessToken, idToken } = this.tokenManager.getTokensSync();
            if (!!accessToken && this.tokenManager.hasExpired(accessToken)) {
                const key = this.tokenManager.getStorageKeyByType('accessToken');
                this.tokenManager.renew(key).catch(() => { });
            }
            else if (!!idToken && this.tokenManager.hasExpired(idToken)) {
                const key = this.tokenManager.getStorageKeyByType('idToken');
                this.tokenManager.renew(key).catch(() => { });
            }
        }
    }
    async start() {
        if (this.canStart() && !!document) {
            document.addEventListener('visibilitychange', this.onPageVisbilityChange);
            this.started = true;
        }
    }
    async stop() {
        if (document) {
            document.removeEventListener('visibilitychange', this.onPageVisbilityChange);
            this.started = false;
        }
    }
    canStart() {
        return isBrowser() &&
            !!this.options.autoRenew &&
            !!this.options.renewOnTabActivation &&
            !this.started;
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
}


//# sourceMappingURL=RenewOnTabActivationService.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/core/ServiceManager/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







const AUTO_RENEW = 'autoRenew';
const SYNC_STORAGE = 'syncStorage';
const LEADER_ELECTION = 'leaderElection';
const RENEW_ON_TAB_ACTIVATION = 'renewOnTabActivation';
class ServiceManager {
    constructor(sdk, options = {}) {
        this.sdk = sdk;
        this.onLeader = this.onLeader.bind(this);
        const { autoRenew, autoRemove, syncStorage } = sdk.tokenManager.getOptions();
        options.electionChannelName = options.electionChannelName || options.broadcastChannelName;
        this.options = Object.assign({}, ServiceManager.defaultOptions, { autoRenew, autoRemove, syncStorage }, {
            electionChannelName: `${sdk.options.clientId}-election`,
            syncChannelName: `${sdk.options.clientId}-sync`,
        }, removeNils(options));
        this.started = false;
        this.services = new Map();
        ServiceManager.knownServices.forEach(name => {
            const svc = this.createService(name);
            if (svc) {
                this.services.set(name, svc);
            }
        });
    }
    async onLeader() {
        if (this.started) {
            await this.startServices();
        }
    }
    isLeader() {
        var _a;
        return (_a = this.getService(LEADER_ELECTION)) === null || _a === void 0 ? void 0 : _a.isLeader();
    }
    isLeaderRequired() {
        return [...this.services.values()].some(srv => srv.canStart() && srv.requiresLeadership());
    }
    async start() {
        if (this.started) {
            return;
        }
        await this.startServices();
        this.started = true;
    }
    async stop() {
        await this.stopServices();
        this.started = false;
    }
    getService(name) {
        return this.services.get(name);
    }
    async startServices() {
        for (const [name, srv] of this.services.entries()) {
            if (this.canStartService(name, srv)) {
                await srv.start();
            }
        }
    }
    async stopServices() {
        for (const srv of this.services.values()) {
            await srv.stop();
        }
    }
    canStartService(name, srv) {
        let canStart = srv.canStart() && !srv.isStarted();
        if (name === LEADER_ELECTION) {
            canStart && (canStart = this.isLeaderRequired());
        }
        else if (srv.requiresLeadership()) {
            canStart && (canStart = this.isLeader());
        }
        return canStart;
    }
    createService(name) {
        const tokenManager = this.sdk.tokenManager;
        let service;
        switch (name) {
            case LEADER_ELECTION:
                service = new LeaderElectionService(Object.assign(Object.assign({}, this.options), { onLeader: this.onLeader }));
                break;
            case AUTO_RENEW:
                service = new AutoRenewService(tokenManager, Object.assign({}, this.options));
                break;
            case SYNC_STORAGE:
                service = new SyncStorageService(tokenManager, Object.assign({}, this.options));
                break;
            case RENEW_ON_TAB_ACTIVATION:
                service = new RenewOnTabActivationService(tokenManager, Object.assign({}, this.options));
                break;
            default:
                throw new Error(`Unknown service ${name}`);
        }
        return service;
    }
}
ServiceManager.knownServices = [AUTO_RENEW, SYNC_STORAGE, LEADER_ELECTION, RENEW_ON_TAB_ACTIVATION];
ServiceManager.defaultOptions = {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
    renewOnTabActivation: true,
    tabInactivityDuration: 1800,
};


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/core/mixin.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







function mixinCore(Base) {
    return class OktaAuthCore extends Base {
        constructor(...args) {
            super(...args);
            this.authStateManager = new AuthStateManager(this);
            this.serviceManager = new ServiceManager(this, this.options.services);
        }
        async start() {
            await this.serviceManager.start();
            this.tokenManager.start();
            if (!this.token.isLoginRedirect()) {
                await this.authStateManager.updateAuthState();
            }
        }
        async stop() {
            this.tokenManager.stop();
            await this.serviceManager.stop();
        }
        async handleRedirect(originalUri) {
            await this.handleLoginRedirect(undefined, originalUri);
        }
        async handleLoginRedirect(tokens, originalUri) {
            let state = this.options.state;
            if (tokens) {
                this.tokenManager.setTokens(tokens);
                originalUri = originalUri || this.getOriginalUri(this.options.state);
            }
            else if (this.isLoginRedirect()) {
                try {
                    const oAuthResponse = await parseOAuthResponseFromUrl(this, {});
                    state = oAuthResponse.state;
                    originalUri = originalUri || this.getOriginalUri(state);
                    await this.storeTokensFromRedirect();
                }
                catch (e) {
                    await this.authStateManager.updateAuthState();
                    throw e;
                }
            }
            else {
                return;
            }
            await this.authStateManager.updateAuthState();
            this.removeOriginalUri(state);
            const { restoreOriginalUri } = this.options;
            if (restoreOriginalUri) {
                await restoreOriginalUri(this, originalUri);
            }
            else if (originalUri) {
                window.location.replace(originalUri);
            }
        }
        handleIDPPopupRedirect(url = window.location.href) {
            const res = parseOAuthResponseFromUrl(this, { responseMode: 'query', url });
            if (res.state) {
                const channel = new BroadcastChannel(`popup-callback:${res.state}`);
                channel.postMessage(res);
                channel.close();
            }
            else {
                throw new AuthSdkError('Unable to parse auth code params');
            }
        }
    };
}


//# sourceMappingURL=mixin.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/session/api.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









function sessionExists(sdk) {
    return sdk.session.get()
        .then(function (res) {
        if (res.status === 'ACTIVE') {
            return true;
        }
        return false;
    })
        .catch(function () {
        return false;
    });
}
function getSession(sdk) {
    return get(sdk, '/api/v1/sessions/me', { withCredentials: true })
        .then(function (session) {
        var res = omit(session, '_links');
        res.refresh = function () {
            return post(sdk, getLink(session, 'refresh').href, {}, { withCredentials: true });
        };
        res.user = function () {
            return get(sdk, getLink(session, 'user').href, { withCredentials: true });
        };
        return res;
    })
        .catch(function () {
        return { status: 'INACTIVE' };
    });
}
function closeSession(sdk) {
    return httpRequest(sdk, {
        url: sdk.getIssuerOrigin() + '/api/v1/sessions/me',
        method: 'DELETE',
        withCredentials: true
    });
}
function refreshSession(sdk) {
    return post(sdk, '/api/v1/sessions/me/lifecycle/refresh', {}, { withCredentials: true });
}
function setCookieAndRedirect(sdk, sessionToken, redirectUrl) {
    redirectUrl = redirectUrl || window.location.href;
    window.location.assign(sdk.getIssuerOrigin() + '/login/sessionCookieRedirect' +
        toQueryString({
            checkAccountSetupComplete: true,
            token: sessionToken,
            redirectUrl: redirectUrl
        }));
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/session/factory.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function createSessionApi(sdk) {
    const session = {
        close: closeSession.bind(null, sdk),
        exists: sessionExists.bind(null, sdk),
        get: getSession.bind(null, sdk),
        refresh: refreshSession.bind(null, sdk),
        setCookieAndRedirect: setCookieAndRedirect.bind(null, sdk)
    };
    return session;
}


//# sourceMappingURL=factory.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/session/mixin.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function mixin_mixinSession(Base) {
    return class OktaAuthSession extends Base {
        constructor(...args) {
            super(...args);
            this.session = createSessionApi(this);
        }
        closeSession() {
            return this.session.close()
                .then(async () => {
                this.clearStorage();
                return true;
            })
                .catch(function (e) {
                if (e.name === 'AuthApiError' && e.errorCode === 'E0000007') {
                    return false;
                }
                throw e;
            });
        }
    };
}


//# sourceMappingURL=mixin.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/core/factory.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function factory_createOktaAuthCore(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Base = factory_createOktaAuthBase(OptionsConstructor);
    const WithStorage = mixin_mixinStorage(Base, StorageManagerConstructor);
    const WithHttp = mixin_mixinHttp(WithStorage);
    const WithSession = mixin_mixinSession(WithHttp);
    const WithOAuth = mixin_mixinOAuth(WithSession, TransactionManagerConstructor);
    const Core = mixinCore(WithOAuth);
    return Core;
}


//# sourceMappingURL=factory.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/browser/fingerprint.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












const isMessageFromCorrectSource = (iframe, event) => event.source === iframe.contentWindow;
function fingerprint_fingerprint(sdk, options) {
    var _a;
    if (!isFingerprintSupported()) {
        return Promise.reject(new AuthSdkError('Fingerprinting is not supported on this device'));
    }
    const container = (_a = options === null || options === void 0 ? void 0 : options.container) !== null && _a !== void 0 ? _a : document.body;
    let timeout;
    let iframe;
    let listener;
    const promise = new Promise(function (resolve, reject) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        listener = function listener(e) {
            var _a;
            if (!isMessageFromCorrectSource(iframe, e)) {
                return;
            }
            if (!e || !e.data || e.origin !== sdk.getIssuerOrigin()) {
                return;
            }
            let msg;
            try {
                msg = JSON.parse(e.data);
            }
            catch (err) {
                return;
            }
            if (!msg) {
                return;
            }
            if (msg.type === 'FingerprintAvailable') {
                return resolve(msg.fingerprint);
            }
            else if (msg.type === 'FingerprintServiceReady') {
                (_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({
                    type: 'GetFingerprint'
                }), e.origin);
            }
            else {
                return reject(new AuthSdkError('No data'));
            }
        };
        addListener(window, 'message', listener);
        iframe.src = sdk.getIssuerOrigin() + '/auth/services/devicefingerprint';
        container.appendChild(iframe);
        timeout = setTimeout(function () {
            reject(new AuthSdkError('Fingerprinting timed out'));
        }, (options === null || options === void 0 ? void 0 : options.timeout) || 15000);
    });
    return promise.finally(function () {
        var _a;
        clearTimeout(timeout);
        removeListener(window, 'message', listener);
        if (container.contains(iframe)) {
            (_a = iframe.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(iframe);
        }
    });
}


//# sourceMappingURL=fingerprint.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/webauthn.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const getEnrolledCredentials = (authenticatorEnrollments = []) => {
    const credentials = [];
    authenticatorEnrollments.forEach((enrollement) => {
        if (enrollement.key === 'webauthn') {
            credentials.push({
                type: 'public-key',
                id: base64UrlToBuffer(enrollement.credentialId),
            });
        }
    });
    return credentials;
};
const buildCredentialCreationOptions = (activationData, authenticatorEnrollments) => {
    return {
        publicKey: {
            rp: activationData.rp,
            user: {
                id: base64UrlToBuffer(activationData.user.id),
                name: activationData.user.name,
                displayName: activationData.user.displayName
            },
            challenge: base64UrlToBuffer(activationData.challenge),
            pubKeyCredParams: activationData.pubKeyCredParams,
            attestation: activationData.attestation,
            authenticatorSelection: activationData.authenticatorSelection,
            excludeCredentials: getEnrolledCredentials(authenticatorEnrollments),
        }
    };
};
const buildCredentialRequestOptions = (challengeData, authenticatorEnrollments) => {
    return {
        publicKey: {
            challenge: base64UrlToBuffer(challengeData.challenge),
            userVerification: challengeData.userVerification,
            allowCredentials: getEnrolledCredentials(authenticatorEnrollments),
        }
    };
};
const getAttestation = (credential) => {
    const response = credential.response;
    const id = credential.id;
    const clientData = bufferToBase64Url(response.clientDataJSON);
    const attestation = bufferToBase64Url(response.attestationObject);
    return {
        id,
        clientData,
        attestation
    };
};
const getAssertion = (credential) => {
    const response = credential.response;
    const id = credential.id;
    const clientData = bufferToBase64Url(response.clientDataJSON);
    const authenticatorData = bufferToBase64Url(response.authenticatorData);
    const signatureData = bufferToBase64Url(response.signature);
    return {
        id,
        clientData,
        authenticatorData,
        signatureData
    };
};


//# sourceMappingURL=webauthn.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/mixin.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function mixinIdx(Base) {
    var _a;
    return _a = class OktaAuthIdx extends Base {
            constructor(...args) {
                super(...args);
                this.idx = createIdxAPI(this);
                this.fingerprint = fingerprint_fingerprint.bind(null, this);
            }
        },
        _a.webauthn = webauthn_namespaceObject,
        _a;
}


//# sourceMappingURL=mixin.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/factory/OktaAuthIdx.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function createOktaAuthIdx(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Core = factory_createOktaAuthCore(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor);
    const WithIdx = mixinIdx(Core);
    return WithIdx;
}


//# sourceMappingURL=OktaAuthIdx.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/factory/minimalApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function minimalApi_createMinimalIdxAPI(minimalSdk) {
    const sdk = minimalSdk;
    const boundStartTransaction = startTransaction.bind(null, sdk);
    const idx = {
        makeIdxResponse: makeIdxState.bind(null, sdk),
        start: boundStartTransaction,
        startTransaction: boundStartTransaction,
        proceed: proceed.bind(null, sdk),
        canProceed: canProceed.bind(null, sdk),
        getSavedTransactionMeta: getSavedTransactionMeta.bind(null, sdk),
        createTransactionMeta: createTransactionMeta.bind(null, sdk),
        getTransactionMeta: getTransactionMeta.bind(null, sdk),
        saveTransactionMeta: saveTransactionMeta.bind(null, sdk),
        clearTransactionMeta: clearTransactionMeta.bind(null, sdk),
        isTransactionMetaValid,
    };
    return idx;
}


//# sourceMappingURL=minimalApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/mixinMinimal.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function mixinMinimal_mixinMinimalIdx(Base) {
    var _a;
    return _a = class OktaAuthIdx extends Base {
            constructor(...args) {
                super(...args);
                this.idx = createMinimalIdxAPI(this);
                this.fingerprint = fingerprint.bind(null, this);
            }
        },
        _a.webauthn = webauthn,
        _a;
}


//# sourceMappingURL=mixinMinimal.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/factory/baseApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







function baseApi_createBaseTokenAPI(sdk) {
    const token = {
        prepareTokenParams: prepareTokenParams.bind(null, sdk),
        exchangeCodeForTokens: exchangeCodeForTokens.bind(null, sdk),
        decode: decodeToken,
    };
    return token;
}


//# sourceMappingURL=baseApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/mixin/minimal.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function minimal_mixinMinimalOAuth(Base, TransactionManagerConstructor) {
    return class OktaAuthOAuth extends Base {
        constructor(...args) {
            super(...args);
            this.transactionManager = new TransactionManagerConstructor(Object.assign({
                storageManager: this.storageManager,
            }, this.options.transactionManager));
            this.token = createBaseTokenAPI(this);
        }
        isLoginRedirect() {
            return isLoginRedirect(this);
        }
        isPKCE() {
            return !!this.options.pkce;
        }
        hasResponseType(responseType) {
            return hasResponseType(responseType, this.options);
        }
        isAuthorizationCodeFlow() {
            return this.hasResponseType('code');
        }
    };
}


//# sourceMappingURL=minimal.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/factory/MinimalOktaAuthIdx.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function createMinimalOktaAuthIdx(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Base = createOktaAuthBase(OptionsConstructor);
    const WithStorage = mixinStorage(Base, StorageManagerConstructor);
    const WithHttp = mixinHttp(WithStorage);
    const WithSession = mixinSession(WithHttp);
    const WithOAuth = mixinMinimalOAuth(WithSession, TransactionManagerConstructor);
    const WithIdx = mixinMinimalIdx(WithOAuth);
    return WithIdx;
}


//# sourceMappingURL=MinimalOktaAuthIdx.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/base/options.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function createBaseOptionsConstructor() {
    return class BaseOptionsConstructor {
        constructor(args) {
            this.devMode = !!args.devMode;
        }
    };
}


//# sourceMappingURL=options.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/storage/options/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function getStorage() {
    const storageUtil$1 = Object.assign({}, storageUtil, {
        inMemoryStore: {}
    });
    return storageUtil$1;
}
const STORAGE_MANAGER_OPTIONS = {
    token: {
        storageTypes: [
            'localStorage',
            'sessionStorage',
            'cookie'
        ]
    },
    cache: {
        storageTypes: [
            'localStorage',
            'sessionStorage',
            'cookie'
        ]
    },
    transaction: {
        storageTypes: [
            'sessionStorage',
            'localStorage',
            'cookie'
        ]
    },
    'shared-transaction': {
        storageTypes: [
            'localStorage'
        ]
    },
    'original-uri': {
        storageTypes: [
            'localStorage'
        ]
    }
};
function getCookieSettings(args = {}, isHTTPS) {
    var cookieSettings = args.cookies || {};
    if (typeof cookieSettings.secure === 'undefined') {
        cookieSettings.secure = isHTTPS;
    }
    if (typeof cookieSettings.sameSite === 'undefined') {
        cookieSettings.sameSite = cookieSettings.secure ? 'none' : 'lax';
    }
    if (cookieSettings.secure && !isHTTPS) {
        warn('The current page is not being served with the HTTPS protocol.\n' +
            'For security reasons, we strongly recommend using HTTPS.\n' +
            'If you cannot use HTTPS, set "cookies.secure" option to false.');
        cookieSettings.secure = false;
    }
    if (cookieSettings.sameSite === 'none' && !cookieSettings.secure) {
        cookieSettings.sameSite = 'lax';
    }
    return cookieSettings;
}


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/storage/options/StorageOptionsConstructor.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function createStorageOptionsConstructor() {
    const BaseOptionsConstructor = createBaseOptionsConstructor();
    return class StorageOptionsConstructor extends BaseOptionsConstructor {
        constructor(args) {
            super(args);
            this.cookies = getCookieSettings(args, isHTTPS());
            this.storageUtil = args.storageUtil || getStorage();
            this.storageManager = Object.assign(Object.assign({}, STORAGE_MANAGER_OPTIONS), args.storageManager);
        }
    };
}


//# sourceMappingURL=StorageOptionsConstructor.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/fetch/fetchRequest.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const appJsonContentTypeRegex = /application\/\w*\+?json/;
function readData(response) {
    if (response.headers.get('Content-Type') &&
        response.headers.get('Content-Type').toLowerCase().indexOf('application/json') >= 0) {
        return response.json()
            .catch(e => {
            return {
                error: e,
                errorSummary: 'Could not parse server response'
            };
        });
    }
    else {
        return response.text();
    }
}
function formatResult(status, data, response) {
    const isObject = typeof data === 'object';
    const headers = {};
    for (const pair of response.headers.entries()) {
        headers[pair[0]] = pair[1];
    }
    const result = {
        responseText: isObject ? JSON.stringify(data) : data,
        status: status,
        headers
    };
    if (isObject) {
        result.responseType = 'json';
        result.responseJSON = data;
    }
    return result;
}
function fetchRequest(method, url, args) {
    var body = args.data;
    var headers = args.headers || {};
    var contentType = (headers['Content-Type'] || headers['content-type'] || '');
    if (body && typeof body !== 'string') {
        if (appJsonContentTypeRegex.test(contentType)) {
            body = JSON.stringify(body);
        }
        else if (contentType === 'application/x-www-form-urlencoded') {
            body = Object.entries(body)
                .map(([param, value]) => `${param}=${encodeURIComponent(value)}`)
                .join('&');
        }
    }
    var fetch = window.fetch || browser_ponyfill;
    var fetchPromise = fetch(url, {
        method: method,
        headers: args.headers,
        body: body,
        credentials: args.withCredentials ? 'include' : 'omit'
    });
    if (!fetchPromise.finally) {
        fetchPromise = Promise.resolve(fetchPromise);
    }
    return fetchPromise.then(function (response) {
        var error = !response.ok;
        var status = response.status;
        return readData(response)
            .then(data => {
            return formatResult(status, data, response);
        })
            .then(result => {
            var _a;
            if (error || ((_a = result.responseJSON) === null || _a === void 0 ? void 0 : _a.error)) {
                throw result;
            }
            return result;
        });
    });
}


//# sourceMappingURL=fetchRequest.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/http/options.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function createHttpOptionsConstructor() {
    const StorageOptionsConstructor = createStorageOptionsConstructor();
    return class HttpOptionsConstructor extends StorageOptionsConstructor {
        constructor(args) {
            super(args);
            this.issuer = args.issuer;
            this.transformErrorXHR = args.transformErrorXHR;
            this.headers = args.headers;
            this.httpRequestClient = args.httpRequestClient || fetchRequest;
            this.httpRequestInterceptors = args.httpRequestInterceptors;
            this.pollDelay = args.pollDelay;
        }
    };
}


//# sourceMappingURL=options.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/options/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const enableSharedStorage = true;


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/options/OAuthOptionsConstructor.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function assertValidConfig(args) {
    args = args || {};
    var scopes = args.scopes;
    if (scopes && !Array.isArray(scopes)) {
        throw new AuthSdkError('scopes must be a array of strings. ' +
            'Required usage: new OktaAuth({scopes: ["openid", "email"]})');
    }
    var issuer = args.issuer;
    if (!issuer) {
        throw new AuthSdkError('No issuer passed to constructor. ' +
            'Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
    }
    var isUrlRegex = new RegExp('^http?s?://.+');
    if (!isUrlRegex.test(issuer)) {
        throw new AuthSdkError('Issuer must be a valid URL. ' +
            'Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
    }
    if (issuer.indexOf('-admin.okta') !== -1) {
        throw new AuthSdkError('Issuer URL passed to constructor contains "-admin" in subdomain. ' +
            'Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
    }
}
function createOAuthOptionsConstructor() {
    const HttpOptionsConstructor = createHttpOptionsConstructor();
    return class OAuthOptionsConstructor extends HttpOptionsConstructor {
        constructor(options) {
            super(options);
            assertValidConfig(options);
            this.issuer = removeTrailingSlash(options.issuer);
            this.tokenUrl = removeTrailingSlash(options.tokenUrl);
            this.authorizeUrl = removeTrailingSlash(options.authorizeUrl);
            this.userinfoUrl = removeTrailingSlash(options.userinfoUrl);
            this.revokeUrl = removeTrailingSlash(options.revokeUrl);
            this.logoutUrl = removeTrailingSlash(options.logoutUrl);
            this.pkce = options.pkce === false ? false : true;
            this.clientId = options.clientId;
            this.redirectUri = options.redirectUri;
            if (isBrowser()) {
                this.redirectUri = toAbsoluteUrl(options.redirectUri, window.location.origin);
            }
            this.responseType = options.responseType;
            this.responseMode = options.responseMode;
            this.state = options.state;
            this.scopes = options.scopes;
            this.ignoreSignature = !!options.ignoreSignature;
            this.codeChallenge = options.codeChallenge;
            this.codeChallengeMethod = options.codeChallengeMethod;
            this.acrValues = options.acrValues;
            this.maxAge = options.maxAge;
            this.dpop = options.dpop === true;
            this.dpopOptions = Object.assign({ allowBearerTokens: false }, options.dpopOptions);
            this.tokenManager = options.tokenManager;
            this.postLogoutRedirectUri = options.postLogoutRedirectUri;
            this.restoreOriginalUri = options.restoreOriginalUri;
            this.transactionManager = Object.assign({ enableSharedStorage: enableSharedStorage }, options.transactionManager);
            this.clientSecret = options.clientSecret;
            this.setLocation = options.setLocation;
            this.ignoreLifetime = !!options.ignoreLifetime;
            if (!options.maxClockSkew && options.maxClockSkew !== 0) {
                this.maxClockSkew = DEFAULT_MAX_CLOCK_SKEW;
            }
            else {
                this.maxClockSkew = options.maxClockSkew;
            }
        }
    };
}


//# sourceMappingURL=OAuthOptionsConstructor.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/core/options.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function createCoreOptionsConstructor() {
    const OAuthOptionsConstructor = createOAuthOptionsConstructor();
    return class CoreOptionsConstructor extends OAuthOptionsConstructor {
        constructor(options) {
            super(options);
            this.services = options.services;
            this.transformAuthState = options.transformAuthState;
        }
    };
}


//# sourceMappingURL=options.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/options.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function createIdxOptionsConstructor() {
    const CoreOptionsConstructor = createCoreOptionsConstructor();
    return class IdxOptionsConstructor extends CoreOptionsConstructor {
        constructor(options) {
            super(options);
            this.flow = options.flow;
            this.activationToken = options.activationToken;
            this.recoveryToken = options.recoveryToken;
            this.idx = options.idx;
        }
    };
}


//# sourceMappingURL=options.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/storage/SavedObject.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SavedObject {
    constructor(storage, storageName) {
        if (!storage) {
            throw new AuthSdkError('"storage" is required');
        }
        if (typeof storageName !== 'string' || !storageName.length) {
            throw new AuthSdkError('"storageName" is required');
        }
        this.storageName = storageName;
        this.storageProvider = storage;
    }
    getItem(key) {
        return this.getStorage()[key];
    }
    setItem(key, value) {
        return this.updateStorage(key, value);
    }
    removeItem(key) {
        return this.clearStorage(key);
    }
    getStorage() {
        var storageString = this.storageProvider.getItem(this.storageName);
        storageString = storageString || '{}';
        try {
            return JSON.parse(storageString);
        }
        catch (e) {
            throw new AuthSdkError('Unable to parse storage string: ' + this.storageName);
        }
    }
    setStorage(obj) {
        try {
            var storageString = obj ? JSON.stringify(obj) : '{}';
            this.storageProvider.setItem(this.storageName, storageString);
        }
        catch (e) {
            throw new AuthSdkError('Unable to set storage: ' + this.storageName);
        }
    }
    clearStorage(key) {
        if (!key) {
            if (this.storageProvider.removeItem) {
                this.storageProvider.removeItem(this.storageName);
            }
            else {
                this.setStorage();
            }
            return;
        }
        var obj = this.getStorage();
        delete obj[key];
        this.setStorage(obj);
    }
    updateStorage(key, value) {
        var obj = this.getStorage();
        obj[key] = value;
        this.setStorage(obj);
    }
}


//# sourceMappingURL=SavedObject.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/storage/BaseStorageManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function logServerSideMemoryStorageWarning(options) {
    if (!isBrowser() && !options.storageProvider && !options.storageKey) {
        warn('Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.');
    }
}
class BaseStorageManager {
    constructor(storageManagerOptions, cookieOptions, storageUtil) {
        this.storageManagerOptions = storageManagerOptions;
        this.cookieOptions = cookieOptions;
        this.storageUtil = storageUtil;
    }
    getOptionsForSection(sectionName, overrideOptions) {
        return Object.assign({}, this.storageManagerOptions[sectionName], overrideOptions);
    }
    getStorage(options) {
        options = Object.assign({}, this.cookieOptions, options);
        if (options.storageProvider) {
            return options.storageProvider;
        }
        let { storageType, storageTypes } = options;
        if (storageType === 'sessionStorage') {
            options.sessionCookie = true;
        }
        if (storageType && storageTypes) {
            const idx = storageTypes.indexOf(storageType);
            if (idx >= 0) {
                storageTypes = storageTypes.slice(idx);
                storageType = undefined;
            }
        }
        if (!storageType) {
            storageType = this.storageUtil.findStorageType(storageTypes);
        }
        return this.storageUtil.getStorageByType(storageType, options);
    }
    getTokenStorage(options) {
        options = this.getOptionsForSection('token', options);
        logServerSideMemoryStorageWarning(options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || TOKEN_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getHttpCache(options) {
        options = this.getOptionsForSection('cache', options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || CACHE_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
}


//# sourceMappingURL=BaseStorageManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/storage.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function createOAuthStorageManager() {
    return class OAuthStorageManager extends BaseStorageManager {
        constructor(storageManagerOptions, cookieOptions, storageUtil) {
            super(storageManagerOptions, cookieOptions, storageUtil);
        }
        getTransactionStorage(options) {
            options = this.getOptionsForSection('transaction', options);
            logServerSideMemoryStorageWarning(options);
            const storage = this.getStorage(options);
            const storageKey = options.storageKey || TRANSACTION_STORAGE_NAME;
            return new SavedObject(storage, storageKey);
        }
        getSharedTansactionStorage(options) {
            options = this.getOptionsForSection('shared-transaction', options);
            logServerSideMemoryStorageWarning(options);
            const storage = this.getStorage(options);
            const storageKey = options.storageKey || SHARED_TRANSACTION_STORAGE_NAME;
            return new SavedObject(storage, storageKey);
        }
        getOriginalUriStorage(options) {
            options = this.getOptionsForSection('original-uri', options);
            logServerSideMemoryStorageWarning(options);
            const storage = this.getStorage(options);
            const storageKey = options.storageKey || ORIGINAL_URI_STORAGE_NAME;
            return new SavedObject(storage, storageKey);
        }
    };
}


//# sourceMappingURL=storage.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/core/storage.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function createCoreStorageManager() {
    return createOAuthStorageManager();
}


//# sourceMappingURL=storage.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/storage.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function createIdxStorageManager() {
    const CoreStorageManager = createCoreStorageManager();
    return class IdxStorageManager extends CoreStorageManager {
        constructor(storageManagerOptions, cookieOptions, storageUtil) {
            super(storageManagerOptions, cookieOptions, storageUtil);
        }
        getIdxResponseStorage(options) {
            let storage;
            if (isBrowser()) {
                try {
                    storage = this.storageUtil.getStorageByType('memory', options);
                }
                catch (e) {
                    warn('No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic');
                }
            }
            else {
                const transactionStorage = this.getTransactionStorage(options);
                if (transactionStorage) {
                    storage = {
                        getItem: (key) => {
                            const transaction = transactionStorage.getStorage();
                            if (transaction && transaction[key]) {
                                return transaction[key];
                            }
                            return null;
                        },
                        setItem: (key, val) => {
                            const transaction = transactionStorage.getStorage();
                            if (!transaction) {
                                throw new AuthSdkError('Transaction has been cleared, failed to save idxState');
                            }
                            transaction[key] = val;
                            transactionStorage.setStorage(transaction);
                        },
                        removeItem: (key) => {
                            const transaction = transactionStorage.getStorage();
                            if (!transaction) {
                                return;
                            }
                            delete transaction[key];
                            transactionStorage.setStorage(transaction);
                        }
                    };
                }
            }
            if (!storage) {
                return null;
            }
            return new SavedObject(storage, IDX_RESPONSE_STORAGE_NAME);
        }
    };
}


//# sourceMappingURL=storage.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/types/Transaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isObjectWithProperties(obj) {
    if (!obj || typeof obj !== 'object' || Object.values(obj).length === 0) {
        return false;
    }
    return true;
}
function isOAuthTransactionMeta(obj) {
    if (!isObjectWithProperties(obj)) {
        return false;
    }
    return !!obj.redirectUri || !!obj.responseType;
}
function isPKCETransactionMeta(obj) {
    if (!isOAuthTransactionMeta(obj)) {
        return false;
    }
    return !!obj.codeVerifier;
}
function isIdxTransactionMeta(obj) {
    if (!isPKCETransactionMeta(obj)) {
        return false;
    }
    return !!obj.interactionHandle;
}
function isCustomAuthTransactionMeta(obj) {
    if (!isObjectWithProperties(obj)) {
        return false;
    }
    const isAllStringValues = Object.values(obj).find((value) => (typeof value !== 'string')) === undefined;
    return isAllStringValues;
}
function isTransactionMeta(obj) {
    if (isOAuthTransactionMeta(obj) || isCustomAuthTransactionMeta(obj)) {
        return true;
    }
    return false;
}


//# sourceMappingURL=Transaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/sharedStorage.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




const MAX_ENTRY_LIFETIME = 30 * 60 * 1000;
function pruneSharedStorage(storageManager) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    Object.keys(entries).forEach(state => {
        const entry = entries[state];
        const age = Date.now() - entry.dateCreated;
        if (age > MAX_ENTRY_LIFETIME) {
            delete entries[state];
        }
    });
    sharedStorage.setStorage(entries);
}
function saveTransactionToSharedStorage(storageManager, state, meta) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    entries[state] = {
        dateCreated: Date.now(),
        transaction: meta
    };
    sharedStorage.setStorage(entries);
}
function loadTransactionFromSharedStorage(storageManager, state) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    const entry = entries[state];
    if (entry && entry.transaction && isTransactionMeta(entry.transaction)) {
        return entry.transaction;
    }
    return null;
}
function clearTransactionFromSharedStorage(storageManager, state) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    delete entries[state];
    sharedStorage.setStorage(entries);
}


//# sourceMappingURL=sharedStorage.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/TransactionManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function createTransactionManager() {
    return class TransactionManager {
        constructor(options) {
            this.storageManager = options.storageManager;
            this.enableSharedStorage = options.enableSharedStorage === false ? false : true;
            this.saveLastResponse = options.saveLastResponse === false ? false : true;
            this.options = options;
        }
        clear(options = {}) {
            const transactionStorage = this.storageManager.getTransactionStorage();
            const meta = transactionStorage.getStorage();
            transactionStorage.clearStorage();
            if (this.enableSharedStorage && options.clearSharedStorage !== false) {
                const state = options.state || (meta === null || meta === void 0 ? void 0 : meta.state);
                if (state) {
                    clearTransactionFromSharedStorage(this.storageManager, state);
                }
            }
        }
        save(meta, options = {}) {
            let storage = this.storageManager.getTransactionStorage();
            const obj = storage.getStorage();
            if (isTransactionMeta(obj) && !options.muteWarning) {
                warn('a saved auth transaction exists in storage. This may indicate another auth flow is already in progress.');
            }
            storage.setStorage(meta);
            if (this.enableSharedStorage && meta.state) {
                saveTransactionToSharedStorage(this.storageManager, meta.state, meta);
            }
        }
        exists(options = {}) {
            try {
                const meta = this.load(options);
                return !!meta;
            }
            catch (_a) {
                return false;
            }
        }
        load(options = {}) {
            let meta;
            if (this.enableSharedStorage && options.state) {
                pruneSharedStorage(this.storageManager);
                meta = loadTransactionFromSharedStorage(this.storageManager, options.state);
                if (isTransactionMeta(meta)) {
                    return meta;
                }
            }
            let storage = this.storageManager.getTransactionStorage();
            meta = storage.getStorage();
            if (isTransactionMeta(meta)) {
                return meta;
            }
            return null;
        }
    };
}


//# sourceMappingURL=TransactionManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/IdxTransactionManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function createIdxTransactionManager() {
    const TransactionManager = createTransactionManager();
    return class IdxTransactionManager extends TransactionManager {
        constructor(options) {
            super(options);
        }
        clear(options = {}) {
            super.clear(options);
            if (options.clearIdxResponse !== false) {
                this.clearIdxResponse();
            }
        }
        saveIdxResponse(data) {
            if (!this.saveLastResponse) {
                return;
            }
            const storage = this.storageManager.getIdxResponseStorage();
            if (!storage) {
                return;
            }
            storage.setStorage(data);
        }
        loadIdxResponse(options) {
            if (!this.saveLastResponse) {
                return null;
            }
            const storage = this.storageManager.getIdxResponseStorage();
            if (!storage) {
                return null;
            }
            const storedValue = storage.getStorage();
            if (!storedValue || !isRawIdxResponse(storedValue.rawIdxResponse)) {
                return null;
            }
            if (options) {
                const { stateHandle, interactionHandle } = options;
                if (!options.useGenericRemediator && stateHandle && storedValue.stateHandle !== stateHandle) {
                    return null;
                }
                if (interactionHandle && storedValue.interactionHandle !== interactionHandle) {
                    return null;
                }
            }
            return storedValue;
        }
        clearIdxResponse() {
            if (!this.saveLastResponse) {
                return;
            }
            const storage = this.storageManager.getIdxResponseStorage();
            storage === null || storage === void 0 ? void 0 : storage.clearStorage();
        }
    };
}


//# sourceMappingURL=IdxTransactionManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/Base.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class BaseTransaction {
    constructor(oktaAuth, options) {
        const { res } = options;
        const { headers } = res, rest = __rest(res, ["headers"]);
        if (headers) {
            this.headers = headers;
        }
        Object.keys(rest).forEach(key => {
            if (key === '_links') {
                return;
            }
            this[key] = rest[key];
        });
    }
}


//# sourceMappingURL=Base.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/request.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









async function sendRequest(oktaAuth, options, TransactionClass = BaseTransaction) {
    const { accessToken: accessTokenObj } = oktaAuth.tokenManager.getTokensSync();
    const atToken = options.accessToken || accessTokenObj;
    const issuer = oktaAuth.getIssuerOrigin();
    const { url, method, payload } = options;
    const requestUrl = url.startsWith(issuer) ? url : `${issuer}${url}`;
    if (!atToken) {
        throw new AuthSdkError('AccessToken is required to request MyAccount API endpoints.');
    }
    let accessToken = atToken;
    const httpOptions = Object.assign({ headers: { 'Accept': '*/*;okta-version=1.0.0' }, url: requestUrl, method }, (payload && { args: payload }));
    if (oktaAuth.options.dpop) {
        if (typeof accessToken === 'string') {
            throw new AuthSdkError('AccessToken object must be provided when using dpop');
        }
        const { Authorization, Dpop } = await oktaAuth.getDPoPAuthorizationHeaders({
            method,
            url: requestUrl,
            accessToken
        });
        httpOptions.headers.Authorization = Authorization;
        httpOptions.headers.Dpop = Dpop;
    }
    else {
        accessToken = typeof accessToken === 'string' ? accessToken : accessToken.accessToken;
        httpOptions.accessToken = accessToken;
    }
    const res = await httpRequest(oktaAuth, httpOptions);
    let ret;
    if (Array.isArray(res)) {
        ret = res.map(item => new TransactionClass(oktaAuth, {
            res: item,
            accessToken
        }));
    }
    else {
        ret = new TransactionClass(oktaAuth, {
            res,
            accessToken
        });
    }
    return ret;
}
function generateRequestFnFromLinks({ oktaAuth, accessToken, methodName, links, }, TransactionClass = BaseTransaction) {
    for (const method of ['GET', 'POST', 'PUT', 'DELETE']) {
        if (method.toLowerCase() === methodName) {
            const link = links.self;
            return (async (payload) => sendRequest(oktaAuth, {
                accessToken,
                url: link.href,
                method,
                payload,
            }, TransactionClass));
        }
    }
    const link = links[methodName];
    if (!link) {
        throw new AuthSdkError(`No link is found with methodName: ${methodName}`);
    }
    return (async (payload) => sendRequest(oktaAuth, {
        accessToken,
        url: link.href,
        method: link.hints.allow[0],
        payload,
    }, TransactionClass));
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/ProfileTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ProfileTransaction extends BaseTransaction {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { createdAt, modifiedAt, profile } = options.res;
        this.createdAt = createdAt;
        this.modifiedAt = modifiedAt;
        this.profile = profile;
    }
}


//# sourceMappingURL=ProfileTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/ProfileSchemaTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ProfileSchemaTransaction extends BaseTransaction {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        this.properties = options.res.properties;
    }
}


//# sourceMappingURL=ProfileSchemaTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/types.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

var EmailRole;
(function (EmailRole) {
    EmailRole["PRIMARY"] = "PRIMARY";
    EmailRole["SECONDARY"] = "SECONDARY";
})(EmailRole || (EmailRole = {}));
var Status;
(function (Status) {
    Status["VERIFIED"] = "VERIFIED";
    Status["UNVERIFIED"] = "UNVERIFIED";
})(Status || (Status = {}));
var PasswordStatus;
(function (PasswordStatus) {
    PasswordStatus["NOT_ENROLLED"] = "NOT_ENROLLED";
    PasswordStatus["ACTIVE"] = "ACTIVE";
})(PasswordStatus || (PasswordStatus = {}));


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/profileApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







const getProfile = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/profile',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
    }, ProfileTransaction);
    return transaction;
};
const updateProfile = async (oktaAuth, options) => {
    const { payload, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/profile',
        method: 'PUT',
        payload,
        accessToken,
    }, ProfileTransaction);
    return transaction;
};
const getProfileSchema = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/profile/schema',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
    }, ProfileSchemaTransaction);
    return transaction;
};


//# sourceMappingURL=profileApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/EmailStatusTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class EmailStatusTransaction extends BaseTransaction {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { res } = options;
        const { id, profile, expiresAt, status } = res;
        this.id = id;
        this.expiresAt = expiresAt;
        this.profile = profile;
        this.status = status;
    }
}


//# sourceMappingURL=EmailStatusTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/EmailChallengeTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class EmailChallengeTransaction extends BaseTransaction {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { accessToken, res } = options;
        const { id, expiresAt, profile, status, _links } = res;
        this.id = id;
        this.expiresAt = expiresAt;
        this.profile = profile;
        this.status = status;
        this.poll = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'poll',
                links: _links,
            }, EmailStatusTransaction);
            return await fn();
        };
        this.verify = async (payload) => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'verify',
                links: _links,
            }, EmailChallengeTransaction);
            return await fn(payload);
        };
    }
}


//# sourceMappingURL=EmailChallengeTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/EmailTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






class EmailTransaction extends BaseTransaction {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { accessToken, res } = options;
        const { id, profile, roles, status, _links } = res;
        this.id = id;
        this.profile = profile;
        this.roles = roles;
        this.status = status;
        this.get = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'get',
                links: _links,
            }, EmailTransaction);
            return await fn();
        };
        this.delete = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'delete',
                links: _links
            });
            return await fn();
        };
        this.challenge = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'challenge',
                links: _links,
            }, EmailChallengeTransaction);
            return await fn();
        };
        if (_links.poll) {
            this.poll = async () => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'poll',
                    links: _links,
                }, EmailStatusTransaction);
                return await fn();
            };
        }
        if (_links.verify) {
            this.verify = async (payload) => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'verify',
                    links: _links,
                });
                return await fn(payload);
            };
        }
    }
}


//# sourceMappingURL=EmailTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/emailApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







const getEmails = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/emails',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    }, EmailTransaction);
    return transaction;
};
const getEmail = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${id}`,
        method: 'GET',
        accessToken,
    }, EmailTransaction);
    return transaction;
};
const addEmail = async (oktaAuth, options) => {
    const { accessToken, payload } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/emails',
        method: 'POST',
        payload,
        accessToken,
    }, EmailTransaction);
    return transaction;
};
const deleteEmail = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${id}`,
        method: 'DELETE',
        accessToken
    });
    return transaction;
};
const sendEmailChallenge = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${id}/challenge`,
        method: 'POST',
        accessToken,
    }, EmailChallengeTransaction);
    return transaction;
};
const getEmailChallenge = async (oktaAuth, options) => {
    const { emailId, challengeId, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${emailId}/challenge/${challengeId}`,
        method: 'POST',
        accessToken,
    }, EmailChallengeTransaction);
    return transaction;
};
const verifyEmailChallenge = async (oktaAuth, options) => {
    const { emailId, challengeId, payload, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${emailId}/challenge/${challengeId}/verify`,
        method: 'POST',
        payload,
        accessToken
    });
    return transaction;
};


//# sourceMappingURL=emailApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/PhoneTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class PhoneTransaction extends BaseTransaction {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { res, accessToken } = options;
        const { id, profile, status, _links } = res;
        this.id = id;
        this.profile = profile;
        this.status = status;
        this.get = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'get',
                links: _links,
            }, PhoneTransaction);
            return await fn();
        };
        this.delete = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'delete',
                links: _links
            });
            return await fn();
        };
        this.challenge = async (payload) => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'challenge',
                links: _links
            });
            return await fn(payload);
        };
        if (_links.verify) {
            this.verify = async (payload) => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'verify',
                    links: _links
                });
                return await fn(payload);
            };
        }
    }
}


//# sourceMappingURL=PhoneTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/phoneApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






const getPhones = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/phones',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
    }, PhoneTransaction);
    return transaction;
};
const getPhone = async (oktaAuth, options) => {
    const { accessToken, id } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}`,
        method: 'GET',
        accessToken,
    }, PhoneTransaction);
    return transaction;
};
const addPhone = async (oktaAuth, options) => {
    const { accessToken, payload } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/phones',
        method: 'POST',
        payload,
        accessToken,
    }, PhoneTransaction);
    return transaction;
};
const deletePhone = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}`,
        method: 'DELETE',
        accessToken,
    });
    return transaction;
};
const sendPhoneChallenge = async (oktaAuth, options) => {
    const { accessToken, id, payload } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}/challenge`,
        method: 'POST',
        payload,
        accessToken
    });
    return transaction;
};
const verifyPhoneChallenge = async (oktaAuth, options) => {
    const { id, payload, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}/verify`,
        method: 'POST',
        payload,
        accessToken
    });
    return transaction;
};


//# sourceMappingURL=phoneApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/PasswordTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class PasswordTransaction extends BaseTransaction {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { res, accessToken } = options;
        const { id, status, created, lastUpdated, _links } = res;
        this.id = id;
        this.status = status;
        this.created = created;
        this.lastUpdated = lastUpdated;
        if (this.status == PasswordStatus.NOT_ENROLLED) {
            this.enroll = async (payload) => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'enroll',
                    links: _links,
                }, PasswordTransaction);
                return await fn(payload);
            };
        }
        else {
            this.get = async () => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'get',
                    links: _links,
                }, PasswordTransaction);
                return await fn();
            };
            this.update = async (payload) => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'put',
                    links: _links,
                }, PasswordTransaction);
                return await fn(payload);
            };
            this.delete = async () => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'delete',
                    links: _links
                });
                return await fn();
            };
        }
    }
}


//# sourceMappingURL=PasswordTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/passwordApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





const getPassword = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/password`,
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
    }, PasswordTransaction);
    return transaction;
};
const enrollPassword = async (oktaAuth, options) => {
    const { accessToken, payload } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/password',
        method: 'POST',
        payload,
        accessToken,
    }, PasswordTransaction);
    return transaction;
};
const updatePassword = async (oktaAuth, options) => {
    const { accessToken, payload } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/password',
        method: 'PUT',
        payload,
        accessToken,
    }, PasswordTransaction);
    return transaction;
};
const deletePassword = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/password`,
        method: 'DELETE',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
    });
    return transaction;
};


//# sourceMappingURL=passwordApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/api.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/mixin.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function mixin_mixinMyAccount(Base) {
    return class OktaAuthMyAccount extends Base {
        constructor(...args) {
            super(...args);
            this.myaccount = Object.entries(myaccount_api_namespaceObject)
                .filter(([name]) => name !== 'default')
                .reduce((acc, [name, fn]) => {
                acc[name] = fn.bind(null, this);
                return acc;
            }, {});
        }
    };
}


//# sourceMappingURL=mixin.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/factory.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function createOktaAuthMyAccount(StorageManagerConstructor, OptionsConstructor, TransactionManager) {
    const Core = createOktaAuthCore(StorageManagerConstructor, OptionsConstructor, TransactionManager);
    const WithMyAccount = mixinMyAccount(Core);
    return WithMyAccount;
}


//# sourceMappingURL=factory.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/authn/util/stateToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function addStateToken(res, options) {
    var builtArgs = {};
    Object.assign(builtArgs, options);
    if (!builtArgs.stateToken && res.stateToken) {
        builtArgs.stateToken = res.stateToken;
    }
    return builtArgs;
}
function getStateToken(res) {
    return addStateToken(res);
}


//# sourceMappingURL=stateToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/authn/api.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function transactionStatus(sdk, args) {
    args = addStateToken(sdk, args);
    return post(sdk, sdk.getIssuerOrigin() + '/api/v1/authn', args, { withCredentials: true });
}
function resumeTransaction(sdk, tx, args) {
    if (!args || !args.stateToken) {
        var stateToken = getSavedStateToken(sdk);
        if (stateToken) {
            args = {
                stateToken: stateToken
            };
        }
        else {
            return Promise.reject(new AuthSdkError('No transaction to resume'));
        }
    }
    return transactionStatus(sdk, args)
        .then(function (res) {
        return tx.createTransaction(res);
    });
}
function introspectAuthn(sdk, tx, args) {
    if (!args || !args.stateToken) {
        var stateToken = getSavedStateToken(sdk);
        if (stateToken) {
            args = {
                stateToken: stateToken
            };
        }
        else {
            return Promise.reject(new AuthSdkError('No transaction to evaluate'));
        }
    }
    return transactionStep(sdk, args)
        .then(function (res) {
        return tx.createTransaction(res);
    });
}
function transactionStep(sdk, args) {
    args = addStateToken(sdk, args);
    return post(sdk, sdk.getIssuerOrigin() + '/api/v1/authn/introspect', args, { withCredentials: true });
}
function transactionExists(sdk) {
    return !!getSavedStateToken(sdk);
}
function postToTransaction(sdk, tx, url, args, options) {
    options = Object.assign({ withCredentials: true }, options);
    return post(sdk, url, args, options)
        .then(function (res) {
        return tx.createTransaction(res);
    });
}
function getSavedStateToken(sdk) {
    const storage = sdk.options.storageUtil.storage;
    return storage.get(STATE_TOKEN_KEY_NAME);
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/authn/util/link2fn.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












function link2fn(sdk, tx, res, obj, link, ref) {
    if (Array.isArray(link)) {
        return function (name, opts) {
            if (!name) {
                throw new AuthSdkError('Must provide a link name');
            }
            var lk = find(link, { name: name });
            if (!lk) {
                throw new AuthSdkError('No link found for that name');
            }
            return link2fn(sdk, tx, res, obj, lk, ref)(opts);
        };
    }
    else if (link.hints &&
        link.hints.allow &&
        link.hints.allow.length === 1) {
        var method = link.hints.allow[0];
        switch (method) {
            case 'GET':
                return function () {
                    return get(sdk, link.href, { withCredentials: true });
                };
            case 'POST':
                return function (opts) {
                    if (ref && ref.isPolling) {
                        ref.isPolling = false;
                    }
                    var data = addStateToken(res, opts);
                    if (res.status === 'MFA_ENROLL' || res.status === 'FACTOR_ENROLL') {
                        Object.assign(data, {
                            factorType: obj.factorType,
                            provider: obj.provider
                        });
                    }
                    var params = {};
                    var autoPush = data.autoPush;
                    if (autoPush !== undefined) {
                        if (typeof autoPush === 'function') {
                            try {
                                params.autoPush = !!autoPush();
                            }
                            catch (e) {
                                return Promise.reject(new AuthSdkError('AutoPush resulted in an error.'));
                            }
                        }
                        else if (autoPush !== null) {
                            params.autoPush = !!autoPush;
                        }
                        data = omit(data, 'autoPush');
                    }
                    var rememberDevice = data.rememberDevice;
                    if (rememberDevice !== undefined) {
                        if (typeof rememberDevice === 'function') {
                            try {
                                params.rememberDevice = !!rememberDevice();
                            }
                            catch (e) {
                                return Promise.reject(new AuthSdkError('RememberDevice resulted in an error.'));
                            }
                        }
                        else if (rememberDevice !== null) {
                            params.rememberDevice = !!rememberDevice;
                        }
                        data = omit(data, 'rememberDevice');
                    }
                    else if (data.profile &&
                        data.profile.updatePhone !== undefined) {
                        if (data.profile.updatePhone) {
                            params.updatePhone = true;
                        }
                        data.profile = omit(data.profile, 'updatePhone');
                    }
                    var href = link.href + toQueryString(params);
                    return postToTransaction(sdk, tx, href, data);
                };
        }
    }
}


//# sourceMappingURL=link2fn.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/AuthPollStopError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class AuthPollStopError extends CustomError {
    constructor() {
        const message = 'The poll was stopped by the sdk';
        super(message);
    }
}


//# sourceMappingURL=AuthPollStopError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/authn/util/poll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */















function getPollFn(sdk, res, ref) {
    return function (options) {
        var delay$1;
        var rememberDevice;
        var autoPush;
        var transactionCallBack;
        if (isNumber(options)) {
            delay$1 = options;
        }
        else if (isObject(options)) {
            options = options;
            delay$1 = options.delay;
            rememberDevice = options.rememberDevice;
            autoPush = options.autoPush;
            transactionCallBack = options.transactionCallBack;
        }
        if (!delay$1 && delay$1 !== 0) {
            delay$1 = DEFAULT_POLLING_DELAY;
        }
        var pollLink = getLink(res, 'next', 'poll');
        function pollFn() {
            var opts = {};
            if (typeof autoPush === 'function') {
                try {
                    opts.autoPush = !!autoPush();
                }
                catch (e) {
                    return Promise.reject(new AuthSdkError('AutoPush resulted in an error.'));
                }
            }
            else if (autoPush !== undefined && autoPush !== null) {
                opts.autoPush = !!autoPush;
            }
            if (typeof rememberDevice === 'function') {
                try {
                    opts.rememberDevice = !!rememberDevice();
                }
                catch (e) {
                    return Promise.reject(new AuthSdkError('RememberDevice resulted in an error.'));
                }
            }
            else if (rememberDevice !== undefined && rememberDevice !== null) {
                opts.rememberDevice = !!rememberDevice;
            }
            var href = pollLink.href + toQueryString(opts);
            return post(sdk, href, getStateToken(res), {
                saveAuthnState: false,
                withCredentials: true,
                pollingIntent: true,
            });
        }
        ref.isPolling = true;
        var retryCount = 0;
        var recursivePoll = function () {
            if (!ref.isPolling) {
                return Promise.reject(new AuthPollStopError());
            }
            return pollFn()
                .then(function (pollRes) {
                retryCount = 0;
                if (pollRes.factorResult && pollRes.factorResult === 'WAITING') {
                    if (!ref.isPolling) {
                        throw new AuthPollStopError();
                    }
                    if (typeof transactionCallBack === 'function') {
                        transactionCallBack(pollRes);
                    }
                    return delay(delay$1).then(recursivePoll);
                }
                else {
                    ref.isPolling = false;
                    return sdk.tx.createTransaction(pollRes);
                }
            })
                .catch(function (err) {
                if (err.xhr &&
                    (err.xhr.status === 0 || err.xhr.status === 429) &&
                    retryCount <= 4) {
                    var delayLength = Math.pow(2, retryCount) * 1000;
                    retryCount++;
                    return delay(delayLength)
                        .then(recursivePoll);
                }
                throw err;
            });
        };
        return recursivePoll()
            .catch(function (err) {
            ref.isPolling = false;
            throw err;
        });
    };
}


//# sourceMappingURL=poll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/authn/util/links2fns.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function links2fns(sdk, tx, res, obj, ref) {
    var fns = {};
    for (var linkName in obj._links) {
        if (!Object.prototype.hasOwnProperty.call(obj._links, linkName)) {
            continue;
        }
        var link = obj._links[linkName];
        if (linkName === 'next') {
            linkName = link.name;
        }
        if (link.type) {
            fns[linkName] = link;
            continue;
        }
        switch (linkName) {
            case 'poll':
                fns.poll = getPollFn(sdk, res, ref);
                break;
            default:
                var fn = link2fn(sdk, tx, res, obj, link, ref);
                if (fn) {
                    fns[linkName] = fn;
                }
        }
    }
    return fns;
}


//# sourceMappingURL=links2fns.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/authn/util/flattenEmbedded.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function flattenEmbedded(sdk, tx, res, obj, ref) {
    obj = obj || res;
    obj = clone(obj);
    if (Array.isArray(obj)) {
        var objArr = [];
        for (var o = 0, ol = obj.length; o < ol; o++) {
            objArr.push(flattenEmbedded(sdk, tx, res, obj[o], ref));
        }
        return objArr;
    }
    var embedded = obj._embedded || {};
    for (var key in embedded) {
        if (!Object.prototype.hasOwnProperty.call(embedded, key)) {
            continue;
        }
        if (isObject(embedded[key]) || Array.isArray(embedded[key])) {
            embedded[key] = flattenEmbedded(sdk, tx, res, embedded[key], ref);
        }
    }
    var fns = links2fns(sdk, tx, res, obj, ref);
    Object.assign(embedded, fns);
    obj = omit(obj, '_embedded', '_links');
    Object.assign(obj, embedded);
    return obj;
}


//# sourceMappingURL=flattenEmbedded.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/authn/AuthnTransactionImpl.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class AuthnTransactionImpl {
    constructor(sdk, tx, res = null) {
        this.data = undefined;
        this.status = undefined;
        if (res) {
            this.data = res;
            Object.assign(this, flattenEmbedded(sdk, tx, res, res, {}));
            delete this.stateToken;
            if (res.status === 'RECOVERY_CHALLENGE' && !res._links) {
                this.cancel = function () {
                    return Promise.resolve(tx.createTransaction());
                };
            }
        }
    }
}


//# sourceMappingURL=AuthnTransactionImpl.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/authn/factory.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function createAuthnTransactionAPI(sdk) {
    const tx = {
        status: transactionStatus.bind(null, sdk),
        resume(args) {
            return resumeTransaction(sdk, tx, args);
        },
        exists: transactionExists.bind(null, sdk),
        introspect(args) {
            return introspectAuthn(sdk, tx, args);
        },
        createTransaction: (res) => {
            return new AuthnTransactionImpl(sdk, tx, res);
        },
        postToTransaction: (url, args, options) => {
            return postToTransaction(sdk, tx, url, args, options);
        }
    };
    return tx;
}


//# sourceMappingURL=factory.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/authn/mixin.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function mixinAuthn(Base) {
    return class OktaAuthTx extends Base {
        constructor(...args) {
            super(...args);
            this.authn = this.tx = createAuthnTransactionAPI(this);
            this.fingerprint = fingerprint_fingerprint.bind(null, this);
        }
        async signIn(opts) {
            opts = clone(opts || {});
            const _postToTransaction = (options) => {
                delete opts.sendFingerprint;
                return this.tx.postToTransaction('/api/v1/authn', opts, options);
            };
            if (!opts.sendFingerprint) {
                return _postToTransaction();
            }
            return this.fingerprint()
                .then(function (fingerprint) {
                return _postToTransaction({
                    headers: {
                        'X-Device-Fingerprint': fingerprint
                    }
                });
            });
        }
        async signInWithCredentials(opts) {
            return this.signIn(opts);
        }
        forgotPassword(opts) {
            return this.tx.postToTransaction('/api/v1/authn/recovery/password', opts);
        }
        unlockAccount(opts) {
            return this.tx.postToTransaction('/api/v1/authn/recovery/unlock', opts);
        }
        verifyRecoveryToken(opts) {
            return this.tx.postToTransaction('/api/v1/authn/recovery/token', opts);
        }
    };
}


//# sourceMappingURL=mixin.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/factory/OktaAuthOAuth.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







function createOktaAuthOAuth(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Base = createOktaAuthBase(OptionsConstructor);
    const WithStorage = mixinStorage(Base, StorageManagerConstructor);
    const WithHttp = mixinHttp(WithStorage);
    const WithSession = mixinSession(WithHttp);
    const WithOAuth = mixinOAuth(WithSession, TransactionManagerConstructor);
    return WithOAuth;
}


//# sourceMappingURL=OktaAuthOAuth.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/exports/exports/default.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




















































































































const OptionsConstructor = createIdxOptionsConstructor();
const StorageManager = createIdxStorageManager();
const TransactionManager = createIdxTransactionManager();
const WithIdx = createOktaAuthIdx(StorageManager, OptionsConstructor, TransactionManager);
const WithMyAccount = mixin_mixinMyAccount(WithIdx);
const WithAuthn = mixinAuthn(WithMyAccount);
class OktaAuth extends WithAuthn {
    constructor(options) {
        super(options);
    }
}


//# sourceMappingURL=default.js.map


/***/ }),

/***/ 25935:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports domToReact, htmlToDOM, attributesToProps, Comment, Element, ProcessingInstruction, Text */
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30488);


var domToReact = _index_js__WEBPACK_IMPORTED_MODULE_0__.domToReact;
var htmlToDOM = _index_js__WEBPACK_IMPORTED_MODULE_0__.htmlToDOM;
var attributesToProps = _index_js__WEBPACK_IMPORTED_MODULE_0__.attributesToProps;

// domhandler
var Comment = _index_js__WEBPACK_IMPORTED_MODULE_0__.Comment;
var Element = _index_js__WEBPACK_IMPORTED_MODULE_0__.Element;
var ProcessingInstruction = _index_js__WEBPACK_IMPORTED_MODULE_0__.ProcessingInstruction;
var Text = _index_js__WEBPACK_IMPORTED_MODULE_0__.Text;

/* harmony default export */ __webpack_exports__["ZP"] = (_index_js__WEBPACK_IMPORTED_MODULE_0__);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(23837), __webpack_exec__(80880); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);